
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Opgu", function(module, exports) {
/* ai-answer-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $a4TK8 = parcelRequire("a4TK8");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2cEww = parcelRequire("2cEww");


var $cbc8g = parcelRequire("cbc8g");


var $hnvzE = parcelRequire("hnvzE");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $e31DP = parcelRequire("e31DP");


var $epS7s = parcelRequire("epS7s");

var $7DA0P = parcelRequire("7DA0P");





var $7azCD = parcelRequire("7azCD");


var $7Zbm6 = parcelRequire("7Zbm6");


var $f7lNm = parcelRequire("f7lNm");




const $c97be5ff4a9e42e9$export$d905ae2a714518e8 = ({ answerString: answerString, smartAnswersRoute: smartAnswersRoute })=>{
    const parsed = JSON.parse(answerString);
    if ('user_metadata' in parsed && !!parsed.user_metadata) return {
        parsedResult: parsed.user_metadata,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WHO
    };
    else if ('user_metadata_only_cards' in parsed && !!parsed.user_metadata_only_cards) return {
        parsedResult: parsed.user_metadata_only_cards,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).PERSON
    };
    else if ('user_metadata_with_activity' in parsed && !!parsed.user_metadata_with_activity) return {
        parsedResult: parsed.user_metadata_with_activity,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WORK
    };
    else if ('team_metadata' in parsed && !!parsed.team_metadata) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM
    };
    else if (Array.isArray(parsed) && parsed.length > 0 && smartAnswersRoute === (0, $f7lNm.QueryIntent).AGENT) return {
        parsedResult: parsed,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).AGENT
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: parsed,
        parsedType: undefined
    };
};
const $c97be5ff4a9e42e9$var$mapRecentActivity = (activity)=>({
        title: activity.title,
        url: activity.url,
        containerName: activity.containerName,
        event: activity.event,
        timestamp: activity.timestamp,
        iconUrl: activity.iconUrl,
        contributors: activity.contributors.slice(0, $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW).map((contributor)=>({
                name: contributor.name,
                id: contributor.accountId
            })),
        othersCount: activity.othersCount
    });
const $c97be5ff4a9e42e9$var$mapTeam = (team)=>({
        name: team.displayName,
        avatarUrl: team.smallAvatarImageUrl,
        url: `/wiki/people/team/${team.id}`,
        memberCount: team.memberCount
    });
const $c97be5ff4a9e42e9$var$mapAdditionalMatch = (match)=>{
    return {
        name: match.name,
        avatar_url: match.avatar_url,
        profile_url: match.profile_url,
        job_title: match.title,
        email: match.email ?? ''
    };
};
// Collaborators, contributors and additional matches are expected to be at most 3
const $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW = 3;
const $c97be5ff4a9e42e9$export$b273f870e024eb5d = (answerString)=>{
    const parsed = JSON.parse(answerString);
    if ('enriched_activity_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_activity_output;
        return {
            parsedResult: [
                {
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    time: main_user_profile.time,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    recentActivity: main_user_profile.recent_activity.map($c97be5ff4a9e42e9$var$mapRecentActivity),
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    viewAllLink: main_user_profile.view_all_activity_url
                },
                ...additional_matches.slice(0, $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW).map((x)=>({
                        ...$c97be5ff4a9e42e9$var$mapAdditionalMatch(x),
                        recentActivity: [],
                        viewAllLink: ''
                    }))
            ],
            parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WORK
        };
    } else if ('enriched_profile_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_profile_output;
        return {
            parsedResult: [
                {
                    account_id: main_user_profile.user_base_data.account_id,
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    time: main_user_profile.time,
                    collaborators: main_user_profile.collaborators.slice(0, 6).map((user)=>({
                            name: user.name,
                            picture: user.avatar_url,
                            title: user.extended_profile?.job_title ?? null,
                            url: user.profile_url,
                            accountId: user.account_id,
                            department: user.extended_profile?.department ?? null,
                            email: user.email
                        })),
                    containers: main_user_profile.collaboration_spaces.map((container)=>({
                            name: container.name,
                            containerType: container.container_type,
                            url: container.url,
                            iconUrl: container.icon_url
                        })),
                    recentActivity: main_user_profile.recent_activity?.map($c97be5ff4a9e42e9$var$mapRecentActivity),
                    viewAllLink: main_user_profile.view_all_activity_url,
                    teams: main_user_profile.teams?.map($c97be5ff4a9e42e9$var$mapTeam)
                },
                ...additional_matches.slice(0, $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW).map($c97be5ff4a9e42e9$var$mapAdditionalMatch)
            ],
            parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WHO
        };
    } else if ('team_metadata' in parsed) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: {},
        parsedType: undefined
    };
};


const $f342a64f1825e9b1$export$ef87db6b11c89091 = ({ isReadingAids: isReadingAids, answerFormat: answerFormat, parsedType: parsedType })=>{
    if (isReadingAids) return 'definition';
    if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON && parsedType === (0, $7Zbm6.NLPSearchJSONResultFormat).WHO) return 'people';
    if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON && parsedType === (0, $7Zbm6.NLPSearchJSONResultFormat).WORK) return 'work';
    return 'SAIN';
};
const $f342a64f1825e9b1$export$3e9057828ebd5c7a = ({ answerFormat: answerFormat, answerString: answerString })=>{
    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).JSON) return undefined;
    return (0, $c97be5ff4a9e42e9$export$b273f870e024eb5d)(answerString).parsedType;
};
const $f342a64f1825e9b1$export$baca5c7d93c77000 = ({ userId: userId, cloudId: cloudId, source: source })=>{
    return (0, $42omo.useMemo)(()=>(0, $7azCD.sha256)(`${userId}-${cloudId}-${Date.now().toString()}-${source}`), [
        userId,
        cloudId,
        source
    ]);
};



var $4jIuc = parcelRequire("4jIuc");







const $fa6e2cc169bbcd5a$export$6dde22325042712e = (config)=>{
    const { isEnabled: isEnabled, isInViewport: isInViewport, tabHasFocus: tabHasFocus, thresholdMs: thresholdMs, onDwellStart: onDwellStart, onDwellThreshold: onDwellThreshold, onDwellEnd: onDwellEnd } = config;
    const [isThresholdReached, setIsThresholdReached] = (0, $42omo.useState)(false);
    const [dwellTimer, setDwellTimer] = (0, $42omo.useState)(null);
    const dwellStartTimeRef = (0, $42omo.useRef)();
    const isDwellActiveRef = (0, $42omo.useRef)(false);
    const isInterruptedRef = (0, $42omo.useRef)(false);
    const isThresholdReachedRef = (0, $42omo.useRef)(false);
    const isInViewportRef = (0, $42omo.useRef)(isInViewport);
    const tabHasFocusRef = (0, $42omo.useRef)(tabHasFocus);
    const onDwellEndRef = (0, $42omo.useRef)(onDwellEnd);
    // Keep refs in sync with current values
    isInViewportRef.current = isInViewport;
    tabHasFocusRef.current = tabHasFocus;
    onDwellEndRef.current = onDwellEnd;
    // Reset state when disabled
    (0, $42omo.useEffect)(()=>{
        if (!isEnabled) {
            setIsThresholdReached(false);
            isThresholdReachedRef.current = false;
            isDwellActiveRef.current = false;
            isInterruptedRef.current = false;
            dwellStartTimeRef.current = undefined;
            if (dwellTimer) {
                clearTimeout(dwellTimer);
                setDwellTimer(null);
            }
        }
    }, [
        isEnabled,
        dwellTimer
    ]);
    // Handle dwell start
    (0, $42omo.useEffect)(()=>{
        if (isEnabled && isInViewport && tabHasFocus) // Start dwell if not already active or if interrupted
        {
            if (!isDwellActiveRef.current || isInterruptedRef.current) {
                // Clear any existing timer
                if (dwellTimer) {
                    clearTimeout(dwellTimer);
                    setDwellTimer(null);
                }
                isDwellActiveRef.current = true;
                isInterruptedRef.current = false;
                dwellStartTimeRef.current = Date.now();
                // Fire dwell start event (always fire for QSR tracking)
                onDwellStart?.();
                // Set fresh threshold timer if threshold hasn't been reached yet
                if (!isThresholdReachedRef.current) {
                    const timer = setTimeout(()=>{
                        setDwellTimer(null);
                        // Only fire threshold event if still in viewport, has focus, and not already reached
                        if (isInViewportRef.current && tabHasFocusRef.current && !isThresholdReachedRef.current) {
                            const dwellTime = dwellStartTimeRef.current ? Date.now() - dwellStartTimeRef.current : 0;
                            isThresholdReachedRef.current = true;
                            setIsThresholdReached(true);
                            onDwellThreshold?.(dwellTime);
                        }
                    }, thresholdMs);
                    setDwellTimer(timer);
                }
            }
        }
    }, [
        isEnabled,
        isInViewport,
        tabHasFocus,
        thresholdMs,
        onDwellStart,
        onDwellThreshold,
        dwellTimer
    ]);
    // Handle dwell end (leaving viewport or losing tab focus)
    (0, $42omo.useEffect)(()=>{
        if (isEnabled && (!isInViewport || !tabHasFocus) && isDwellActiveRef.current) {
            isDwellActiveRef.current = false;
            isInterruptedRef.current = true;
            const dwellTime = dwellStartTimeRef.current ? Date.now() - dwellStartTimeRef.current : 0;
            // Clear timer when leaving viewport or losing focus
            if (dwellTimer) {
                clearTimeout(dwellTimer);
                setDwellTimer(null);
            }
            // Reset threshold state if dwell hasn't been reached yet to allow consecutive sessions
            if (!isThresholdReached) // Reset start time to prepare for next dwell session
            dwellStartTimeRef.current = undefined;
            // Fire dwell end event
            onDwellEnd?.(dwellTime);
        }
    }, [
        isEnabled,
        isInViewport,
        tabHasFocus,
        onDwellEnd,
        dwellTimer,
        isThresholdReached
    ]);
    // Handle page navigation and unmount
    (0, $42omo.useEffect)(()=>{
        const handleNavigation = ()=>{
            if (isDwellActiveRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEndRef.current?.(dwellTime);
                isDwellActiveRef.current = false; // Prevent duplicate firing
            }
        };
        const removeNavigationListener = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: handleNavigation
        });
        return ()=>{
            removeNavigationListener();
            if (isDwellActiveRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEndRef.current?.(dwellTime);
            }
        };
    }, []);
    // Cleanup on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (dwellTimer) clearTimeout(dwellTimer);
        };
    }, [
        dwellTimer
    ]);
};



var $eUEtI = parcelRequire("eUEtI");




const $3f9d8952278ae5ef$export$38439c13a4683ecf = (smartAnswersRoute)=>{
    switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).PERSON:
            return 'Person Card';
        case (0, $f7lNm.QueryIntent).TEAM:
            return 'Team Card';
        case (0, $f7lNm.QueryIntent).LOCATION:
            return 'Location Card';
        case (0, $f7lNm.QueryIntent).DATE:
            return 'Date Card';
        case (0, $f7lNm.QueryIntent).TOPIC:
            return 'Topic Card';
        case (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            return 'Jira Card';
        case (0, $f7lNm.QueryIntent).AGENT:
            return 'Agent Card';
        case (0, $f7lNm.QueryIntent).JIRA_ISSUE:
            return 'Jira Issue Card';
        case (0, $f7lNm.QueryIntent).ORG_CHART:
            return 'Org Chart Card';
        case (0, $f7lNm.QueryIntent).NAVIGATIONAL:
            return 'Navigational';
        case (0, $f7lNm.QueryIntent).NAV_CONTENT:
            return 'Nav Card';
        case (0, $f7lNm.QueryIntent).BOOKMARK:
            return 'Bookmark Knowledge Card';
        case (0, $f7lNm.QueryIntent).NONE:
            return 'None';
        case (0, $f7lNm.QueryIntent).DEFAULT:
            return 'Default';
        case (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return 'Plain Text';
    }
};



var $59vy4 = parcelRequire("59vy4");





var $aZJLt = parcelRequire("aZJLt");








var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $4Zqgi = parcelRequire("4Zqgi");

// Types for agent data structure
const $ebbfc84b440d28f8$export$da698a596bf7d462 = 'KnowledgeCardAgentSearchQuery';
const $ebbfc84b440d28f8$export$1bee71aceca6bc6 = `
query ${$ebbfc84b440d28f8$export$da698a596bf7d462}($cloudId: String!, $input: AgentStudioAgentQueryInput!, $limit: Int!) {
    agentStudio_getAgents(cloudId: $cloudId, input: $input, first: $limit) 
    @optIn(to: "AgentStudio")
    {
      edges {
        node {
          id
          identityAccountId
          name
          description
          creator {
            canonicalAccountId
            accountId
            accountStatus
            id
            name
          }
          creatorType
          externalConfigReference
          instructions
          conversationStarters
        }
      }
    }
  }`;


const $5047116fb00cd75d$var$getAgentSearchInput = (query)=>{
    // Extract agent name from query if it's in a specific format
    // For now, use the query as-is, but this could be enhanced to parse specific formats
    return query.trim();
};
const $5047116fb00cd75d$export$9cab63c7e0de7ad8 = ({ query: query, limit: limit, sourceProduct: sourceProduct, cloudId: cloudId, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const agentSearchInput = $5047116fb00cd75d$var$getAgentSearchInput(query);
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $ebbfc84b440d28f8$export$1bee71aceca6bc6),
        variables: {
            cloudId: cloudId,
            input: {
                name: agentSearchInput
            },
            limit: limit
        },
        operationName: (0, $ebbfc84b440d28f8$export$da698a596bf7d462),
        headers: {
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then((response)=>{
        if (response.errors) throw new Error(`GraphQL errors: ${JSON.stringify(response.errors)}`);
        const edges = response.data?.agentStudio_getAgents?.edges || [];
        const agents = edges.map((edge)=>{
            const agent = edge.node;
            return {
                ...agent,
                // Normalize agent ID by splitting on "/" and taking the last item
                id: agent.id.split('/').pop(),
                // Replace creator object with just the creator ID
                creator: agent.creator?.id,
                creator_type: agent.creatorType,
                identity_account_id: agent.identityAccountId
            };
        });
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(agents),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                ...(0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? {
                    extraAPIAnalyticsAttributes: {
                        requestId: response.extensions?.gateway?.request_id ?? null,
                        traceId: response.extensions?.gateway?.trace_id ?? null
                    }
                } : {}
            }
        };
    }).catch((error)=>{
        if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'fetchAgentCardData'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};






var $ay6Zz = parcelRequire("ay6Zz");














var $5iH4l = parcelRequire("5iH4l");

const $d81d4d91e9de5856$export$5d21e0d2847bfa41 = 'KnowledgeCardUserSearchQuery';
const $d81d4d91e9de5856$export$15ff3b6f089f4729 = `
query ${$d81d4d91e9de5856$export$5d21e0d2847bfa41}($userQuery: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchUser (
        userQuery: $userQuery
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search User"){
      ... on KnowledgeDiscoveryUsers {
        users {
            name
            id
            avatarUrl
            title
            zoneInfo
            location
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $d81d4d91e9de5856$export$4401a05b6c351189 = 'KnowledgeCardPrimaryUserDataQuery';
const $d81d4d91e9de5856$export$10a5d89b90ea01b3 = `
    query ${$d81d4d91e9de5856$export$4401a05b6c351189}(
        $accountId: String!
        $accountIdARI: ID!
        $tenantId: String!
        $requestingUserId: String!
        ) {
        user(accountId: $accountIdARI) {
            id
            picture
            name
            accountStatus
            ... on AtlassianAccountUser {
                email
                zoneinfo
                extendedProfile {
                    jobTitle
                    department
                    organization
                    location
                }
            }
        }
        smarts {
            recommendedUser(recommendationsQuery: {
            context: {
                userId: $accountId, tenantId: $tenantId
            },
            modelRequestParams: {
                caller: "search-ai",
                experience: "CgUserNearbyUser"
            },
            requestingUserId: $requestingUserId,
            maxNumberOfResults: 8
            }
            ) {
            id
            user {
                id
                picture
                name
                accountStatus
                ... on AtlassianAccountUser {
                email
                extendedProfile {
                    jobTitle
                    department
                }
                }
            }
            }
        }
    }
`;


const $95de468340d80197$export$b40bb50f32e7d452 = ({ personQuery: personQuery, tenantId: tenantId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${tenantId}` : '';
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $d81d4d91e9de5856$export$15ff3b6f089f4729),
        variables: {
            userQuery: personQuery,
            siteId: siteARI
        },
        operationName: (0, $d81d4d91e9de5856$export$5d21e0d2847bfa41),
        headers: {
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const users = data?.knowledgeDiscovery?.searchUser?.users || [];
        const message = data?.knowledgeDiscovery?.searchUser?.message;
        if (errors || message) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const mappedResults = users.map((user)=>({
                id: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl || '',
                title: user.title || '',
                zoneInfo: user.zoneInfo || '',
                location: user.location || ''
            }));
        const finalResult = {
            user_metadata_only_cards: mappedResults
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'fetchPersonKnowledgeCardDataWithPostFiltering'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};
const $95de468340d80197$export$3b2275a59c992e87 = async ({ personQuery: personQuery, tenantId: tenantId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${tenantId}` : '';
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $d81d4d91e9de5856$export$15ff3b6f089f4729),
        variables: {
            userQuery: personQuery,
            siteId: siteARI
        },
        operationName: (0, $d81d4d91e9de5856$export$5d21e0d2847bfa41),
        headers: {
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors, extensions: extensions })=>{
        const users = data?.knowledgeDiscovery?.searchUser?.users || [];
        const message = data?.knowledgeDiscovery?.searchUser?.message;
        if (errors || message) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const mappedResults = users.map((user)=>({
                id: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl || '',
                title: user.title || '',
                zoneInfo: user.zoneInfo || '',
                location: user.location || ''
            }));
        const finalResult = {
            user_metadata_only_cards: mappedResults
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                extraAPIAnalyticsAttributes: {
                    requestId: extensions?.gateway?.request_id ?? null,
                    traceId: extensions?.gateway?.trace_id ?? null
                }
            }
        };
    }).catch((error)=>{
        if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'fetchPersonKnowledgeCardDataWithPostFiltering'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};
const $95de468340d80197$export$3e632a26e137d79e = ({ accountId: accountId, tenantId: tenantId, requestingUserId: requestingUserId, activityClient: activityClient, locale: locale, workspaceId: workspaceId, product: product, traceHeaders: traceHeaders })=>{
    const aggPromise = (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $d81d4d91e9de5856$export$10a5d89b90ea01b3),
        variables: {
            accountId: accountId,
            accountIdARI: `ari:cloud:identity::user/${accountId}`,
            tenantId: tenantId,
            requestingUserId: requestingUserId
        },
        operationName: (0, $d81d4d91e9de5856$export$4401a05b6c351189),
        headers: {
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: product ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    });
    const activityPromise = activityClient.fetchActivities([
        100
    ], {
        limit: 50,
        actors: [
            `ari:cloud:identity::user/${accountId}`
        ]
    }, [
        'workedOn'
    ], false);
    const toUserProfile = (toAccountId)=>(0, $ay6Zz.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: toAccountId
            },
            cloudId: tenantId
        }).href;
    // Handle the primary user data first, then attempt to fetch activity data
    return Promise.allSettled([
        aggPromise,
        activityPromise
    ]).then((results)=>{
        const [aggResult, activityResult] = results;
        // Handle GraphQL call failure
        if (aggResult.status === 'rejected') throw new Error('Failed to fetch user data');
        const aggResponse = aggResult.value;
        // Create the base user data structure
        const primaryUserData = {
            account_id: accountId,
            name: aggResponse.data?.user.name || '',
            job_title: aggResponse.data?.user.extendedProfile?.jobTitle,
            profile_url: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? toUserProfile(accountId) : `/people/${accountId}`,
            avatar_url: aggResponse.data?.user.picture,
            email: aggResponse.data?.user.email,
            location: aggResponse.data?.user.extendedProfile?.location,
            department: aggResponse.data?.user.extendedProfile?.department,
            organization: aggResponse.data?.user.extendedProfile?.organization,
            time: aggResponse.data?.user.zoneinfo ? (0, $5iH4l.formatTimeKnowledgeCard)({
                locale: locale,
                zoneInfo: aggResponse.data.user.zoneinfo
            }) : undefined,
            collaborators: aggResponse.data?.smarts.recommendedUser.reduce((acc, node)=>{
                if ((0, $5iH4l.trimARI)(node.user.id) !== accountId) acc.push({
                    name: node.user.name,
                    picture: node.user.picture,
                    title: !!node.user.extendedProfile?.jobTitle ? node.user.extendedProfile.jobTitle : null,
                    url: !!node.user.id ? (0, $dh538.fg)('platform-adopt-teams-nav-config') ? toUserProfile((0, $5iH4l.trimARI)(node.user.id)) : `/people/${(0, $5iH4l.trimARI)(node.user.id)}` : null,
                    accountId: node.user.id,
                    department: !!node.user.extendedProfile?.department ? node.user.extendedProfile.department : null,
                    email: !!node.user.email ? node.user.email : null
                });
                return acc;
            }, []),
            viewAllLink: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? toUserProfile(accountId) : `/people/${accountId}`,
            recentActivity: []
        };
        // Add activity data if the call succeeded
        if (activityResult.status === 'fulfilled' && activityResult.value.workedOn && activityResult.value.workedOn.length > 0) primaryUserData.recentActivity = (0, $5iH4l.sanitizeAndMapRecentWorkActivity)(activityResult.value.workedOn);
        return primaryUserData;
    });
};























const $0283d979c1b89f27$export$330a89c6d5120b7c = 'KnowledgeCardTeamSearchQuery';
const $0283d979c1b89f27$export$f20269ab1c2af3aa = `
query ${$0283d979c1b89f27$export$330a89c6d5120b7c}($teamQuery: String!, $orgId: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchTeam (
        teamName: $teamQuery
        orgId: $orgId
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search Team"){
      ... on KnowledgeDiscoveryTeam {
        id
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $0283d979c1b89f27$export$1cc3d8f1a53775f = 'KnowledgeCardTeamDataQuery';
const $0283d979c1b89f27$export$b98556be52d17f2f = `
query ${$0283d979c1b89f27$export$1cc3d8f1a53775f}($teamId: ID!, $siteId: String!) {
    team {
      teamV2 (
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        id
        displayName
        smallAvatarImageUrl
        members {
          nodes {
            member {
              id
              accountId
              name
              picture
              ... on AtlassianAccountUser {
                email
                extendedProfile {
                  jobTitle
                  department
                }
              }
            }
            state
          }
        }
      }
    }
  }
`;


const $8cade13bd59126b4$var$NO_TEAM_MESSAGE = 'NO_TEAM';
const $8cade13bd59126b4$export$588cacdc66ef53ad = {
    team_metadata: {
        id: '',
        name: '',
        avatarUrl: null,
        url: null,
        memberCount: 0,
        members: [],
        recentActivity: []
    }
};
const $8cade13bd59126b4$export$1d3fe260188fa7d9 = ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, siteId: siteId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    let teamResult;
    let teamData;
    let activityResult;
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${siteId}` : '';
    const toTeam = (teamId)=>(0, $ay6Zz.navigateToTeamsApp)({
            type: 'TEAM',
            payload: {
                teamId: teamId
            },
            cloudId: siteId,
            orgId: orgId
        }).href;
    let actors = [];
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $0283d979c1b89f27$export$f20269ab1c2af3aa),
        variables: {
            teamQuery: teamQuery,
            orgId: orgId,
            siteId: siteARI
        },
        operationName: (0, $0283d979c1b89f27$export$330a89c6d5120b7c),
        headers: {
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: siteId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const id = data?.knowledgeDiscovery.searchTeam?.id;
        if (!errors && id) teamResult = id;
        else throw new Error($8cade13bd59126b4$var$NO_TEAM_MESSAGE);
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $0283d979c1b89f27$export$b98556be52d17f2f),
            variables: {
                teamId: teamResult,
                siteId: siteId
            },
            operationName: (0, $0283d979c1b89f27$export$1cc3d8f1a53775f),
            headers: {
                ...(0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: siteId,
                    product: sourceProduct ?? ''
                }),
                ...traceHeaders ?? undefined
            }
        });
    }).then(({ data: data, errors: errors })=>{
        if (!errors && data?.team.teamV2?.id) teamData = data;
        else throw new Error($8cade13bd59126b4$var$NO_TEAM_MESSAGE);
        actors = teamData.team.teamV2?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
        return activityClient.fetchActivities([
            100
        ], {
            limit: 100,
            actors: actors,
            rootContainerIds: [
                `ari:cloud:platform::site/${siteId}`
            ]
        }, [
            'workedOn'
        ], false);
    }).then((data)=>{
        if (data.workedOn && data.workedOn.length > 0) activityResult = data.workedOn;
        const filteredActivityResult = $8cade13bd59126b4$export$bd0b250fe24a4365(activityResult || [], actors);
        const finalResult = {
            team_metadata: {
                id: teamData?.team.teamV2?.id || '',
                name: teamData?.team.teamV2?.displayName || '',
                avatarUrl: teamData?.team.teamV2?.smallAvatarImageUrl || null,
                url: teamData?.team.teamV2?.id ? (0, $dh538.fg)('platform-adopt-teams-nav-config') ? toTeam(teamData?.team.teamV2?.id) : `/people/team/${(0, $5iH4l.trimARI)(teamData?.team.teamV2?.id)}` : null,
                memberCount: teamData?.team.teamV2?.members.nodes.length || 0,
                members: teamData?.team.teamV2?.members?.nodes ? $8cade13bd59126b4$var$sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
                recentActivity: filteredActivityResult ? (0, $5iH4l.sanitizeAndMapRecentWorkActivity)(filteredActivityResult) : []
            }
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if (error instanceof Object && 'message' in error && error.message === $8cade13bd59126b4$var$NO_TEAM_MESSAGE) return {
            nlpSearch: {
                nlpResult: JSON.stringify($8cade13bd59126b4$export$588cacdc66ef53ad),
                errorState: null,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        };
        if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'fetchTeamKnowledgeCardDataWithRanking'
        });
        return Promise.reject(error);
    });
};
const $8cade13bd59126b4$export$b9b0423f67d54dce = async ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, siteId: siteId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${siteId}` : '';
    const toTeam = (teamId)=>(0, $ay6Zz.navigateToTeamsApp)({
            type: 'TEAM',
            payload: {
                teamId: teamId
            },
            cloudId: siteId,
            orgId: orgId
        }).href;
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $0283d979c1b89f27$export$f20269ab1c2af3aa),
        variables: {
            teamQuery: teamQuery,
            orgId: orgId,
            siteId: siteARI
        },
        operationName: (0, $0283d979c1b89f27$export$330a89c6d5120b7c),
        headers: {
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: siteId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const id = data?.knowledgeDiscovery.searchTeam?.id;
        if (errors || !id) throw new Error($8cade13bd59126b4$var$NO_TEAM_MESSAGE);
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $0283d979c1b89f27$export$b98556be52d17f2f),
            variables: {
                teamId: id,
                siteId: siteId
            },
            operationName: (0, $0283d979c1b89f27$export$1cc3d8f1a53775f),
            headers: {
                ...(0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: siteId,
                    product: sourceProduct ?? ''
                }),
                ...traceHeaders ?? undefined
            }
        });
    }).then(async ({ data: data, errors: errors, extensions: extensions })=>{
        if (errors || !data?.team.teamV2?.id) throw new Error($8cade13bd59126b4$var$NO_TEAM_MESSAGE);
        const actors = data.team.teamV2?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
        const activityData = await activityClient.fetchActivities([
            100
        ], {
            limit: 100,
            actors: actors,
            rootContainerIds: [
                `ari:cloud:platform::site/${siteId}`
            ]
        }, [
            'workedOn'
        ], false);
        return {
            activityData: activityData,
            actors: actors,
            extensions: extensions,
            teamData: data
        };
    }).then(({ activityData: activityData, actors: actors, extensions: extensions, teamData: teamData })=>{
        let activityResult = [];
        if (activityData.workedOn && activityData.workedOn.length > 0) activityResult = activityData.workedOn;
        const filteredActivityResult = $8cade13bd59126b4$export$bd0b250fe24a4365(activityResult, actors);
        const finalResult = {
            team_metadata: {
                id: teamData?.team.teamV2?.id || '',
                name: teamData?.team.teamV2?.displayName || '',
                avatarUrl: teamData?.team.teamV2?.smallAvatarImageUrl || null,
                url: teamData?.team.teamV2?.id ? (0, $dh538.fg)('platform-adopt-teams-nav-config') ? toTeam(teamData?.team.teamV2?.id) : `/people/team/${(0, $5iH4l.trimARI)(teamData?.team.teamV2?.id)}` : null,
                memberCount: teamData?.team.teamV2?.members.nodes.length || 0,
                members: teamData?.team.teamV2?.members?.nodes ? $8cade13bd59126b4$var$sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
                recentActivity: filteredActivityResult ? (0, $5iH4l.sanitizeAndMapRecentWorkActivity)(filteredActivityResult) : []
            }
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                extraAPIAnalyticsAttributes: {
                    requestId: extensions?.gateway?.request_id ?? null,
                    traceId: extensions?.gateway?.trace_id ?? null
                }
            }
        };
    }).catch((error)=>{
        if (error instanceof Object && 'message' in error && error.message === $8cade13bd59126b4$var$NO_TEAM_MESSAGE) return {
            nlpSearch: {
                nlpResult: JSON.stringify($8cade13bd59126b4$export$588cacdc66ef53ad),
                errorState: null,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        };
        if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'fetchTeamKnowledgeCardDataWithRanking'
        });
        return Promise.reject(error);
    });
};
const $8cade13bd59126b4$var$sanitizeAndMapTeamMembers = (members)=>{
    return members.reduce(function(result, memberNode) {
        if (!!memberNode.member) return result.concat({
            name: memberNode.member.name || '',
            picture: memberNode.member.picture || null,
            title: memberNode.member.extendedProfile?.jobTitle || null,
            url: !!memberNode.member.id ? `/people/${(0, $5iH4l.trimARI)(memberNode.member.id)}` : null,
            accountId: !!memberNode.member.id ? (0, $5iH4l.trimARI)(memberNode.member.id) : null,
            department: memberNode.member.extendedProfile?.department || null,
            email: memberNode.member.email || null
        });
        return result;
    }, []);
};
const $8cade13bd59126b4$var$excludedEventTypes = [
    'commented',
    'updated'
];
const $8cade13bd59126b4$export$bd0b250fe24a4365 = (activityResult, members)=>{
    const teamMemberSet = new Set(members);
    return activityResult.reduce((filtered, activity)=>{
        const involvedTeamMembers = activity.contributors.filter((contributor)=>teamMemberSet.has(`ari:cloud:identity::user/${contributor.accountId}`));
        if (involvedTeamMembers.length >= 1 && !$8cade13bd59126b4$var$excludedEventTypes.includes(activity.eventType)) filtered.push({
            ...activity,
            contributors: involvedTeamMembers
        });
        return filtered;
    }, []);
};

















const $d24d8697bc189883$export$f928298386dd496b = 'KnowledgeDiscoveryPlatformTopicByIdQuery';
const $d24d8697bc189883$export$9c5339bca50e4652 = `
	query ${$d24d8697bc189883$export$f928298386dd496b}($cloudId: String!, $topicId: String!, $userCount: Int!) {
		knowledgeDiscovery {
			topic(cloudId: $cloudId, id: $topicId) {
				...on KnowledgeDiscoveryTopic {
					id
					name
					description
				}
				...on QueryError {
					message
				}
			}
			users: relatedEntities(
				cloudId: $cloudId
				entityId: $topicId
				entityType: TOPIC
				relatedEntityType: USER
				first: $userCount
			) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
				...on KnowledgeDiscoveryRelatedEntityConnection {
					nodes {
						...on KnowledgeDiscoveryUser {
							user {
								id
								name
								picture
								accountId
								accountStatus
								...on AtlassianAccountUser {
									extendedProfile {
										jobTitle
									}
								}
							}
						}
					}
				}
				...on QueryError {
					message
				}
			}
		}
	}
`;


const $906cce6160529aee$var$getTopicId = (topicIds)=>{
    const list = JSON.parse(topicIds);
    if (Array.isArray(list) && list.length) return list[0];
    return '';
};
const $906cce6160529aee$var$NO_TOPIC_FOUND_MESSAGE = 'No topic found for id:';
const $906cce6160529aee$export$d25837238feb3ab6 = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, sourceProduct: sourceProduct, traceHeaders: traceHeaders })=>{
    const userCount = 5;
    // transformedQuery from intent detection passed as query prop to SearchAIDialog from SearchPage
    // transformedQuery is a str e.g. "["f6aac8a1-7907-4fb0-88ca-d7a564b45db3"]" and need to extract id
    const topicId = $906cce6160529aee$var$getTopicId(query);
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $d24d8697bc189883$export$9c5339bca50e4652),
        variables: {
            cloudId: cloudId,
            topicId: topicId,
            userCount: userCount
        },
        operationName: (0, $d24d8697bc189883$export$f928298386dd496b),
        headers: {
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const message = data?.knowledgeDiscovery.topic.message;
        // if message includes no topic found, we move forward to rendering card
        // in no topic found state (right now is nothing similar to People/Team card)
        if (errors || message && !message.includes($906cce6160529aee$var$NO_TOPIC_FOUND_MESSAGE)) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const topicUserData = data?.knowledgeDiscovery || {};
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(topicUserData),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'fetchTopicCardData'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};





parcelRequire("42omo");


var $eRXI0 = parcelRequire("eRXI0");




/* JiraNlToJqlCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $bYRk6 = parcelRequire("bYRk6");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $7bZ3i = parcelRequire("7bZ3i");











var $eMz0l = parcelRequire("eMz0l");





var $4xTru = parcelRequire("4xTru");





var $cVtio = parcelRequire("cVtio");








var $01aV7 = parcelRequire("01aV7");


var $9lp28 = parcelRequire("9lp28");


var $kF5LJ = parcelRequire("kF5LJ");













const $6586aec03cab9a81$export$d77346a16f68afc1 = `
query IssueSearchStable($cloudId: ID!, $first: Int, $issueSearchInput: JiraIssueSearchInput!) {
  jira {
    issueSearchStable(
      cloudId: $cloudId
      first: $first
      issueSearchInput: $issueSearchInput
    ) {
      totalIssueSearchResultCount
      totalCount
      edges {
        node {
          key
          webUrl
          summary
          issueTypeField {
            issueType {
              name
              avatar {
                xsmall
                small
                medium
                large
              }
            }
          }
          status {
            name
            statusCategory {
              name
              colorName
              statusCategoryId
            }
          }
          assigneeField {
            user {
              picture
              name
              accountId
            }
          }
          priorityField {
            priority {
              name
              iconUrl
              color
            }
          }
        }
      }
    }
  }
}
`;


const $586e66ef37300257$var$MAIN_ISSUE_SEARCH_QUERY_OPERATION_NAME = 'IssueSearchStable';
const $586e66ef37300257$var$fetchIssueSearchQuery = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $9EFEY.fetchAggResponse)({
        variables: variables,
        graphQuery: (0, $6586aec03cab9a81$export$d77346a16f68afc1),
        operationName: $586e66ef37300257$var$MAIN_ISSUE_SEARCH_QUERY_OPERATION_NAME,
        headers: {
            'X-ExperimentalApi': 'JiraIssueSearch',
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        }
    }).then((response)=>{
        return {
            data: response.data,
            extensions: response.extensions
        };
    }).catch((error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'useIssueSearchQuery'
        });
        // rethrow error to be handled by the caller
        throw error;
    });
};
const $586e66ef37300257$export$11659072884978f5 = ({ cloudId: cloudId, jql: jql, workspaceId: workspaceId, product: product })=>{
    const [loading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(false);
    const [issues, setIssues] = (0, $42omo.useState)();
    const [totalIssuesCount, setTotalIssuesCount] = (0, $42omo.useState)();
    const [extensions, setExtensions] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const { data: data, extensions: extensions } = await $586e66ef37300257$var$fetchIssueSearchQuery({
                    variables: {
                        cloudId: cloudId,
                        first: 5,
                        issueSearchInput: {
                            jql: jql || ''
                        }
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                if (data?.errors?.length) {
                    setError(true);
                    throw new Error(data.errors[0].message || 'Unknown error');
                }
                setIssues(data?.jira?.issueSearchStable?.edges || []);
                setTotalIssuesCount(data?.jira?.issueSearchStable?.totalIssueSearchResultCount);
                setExtensions(extensions);
            } catch (e) {
                (0, $4Zqgi.logger).error({
                    error: e,
                    functionName: 'useIssueNavigatorQuery'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (Boolean(jql)) fetchData();
    }, [
        cloudId,
        jql,
        workspaceId,
        product
    ]);
    return {
        issues: issues,
        extensions: extensions,
        totalIssuesCount: totalIssuesCount,
        loading: loading,
        error: error
    };
};












var $dwp40 = parcelRequire("dwp40");


var $iip0W = parcelRequire("iip0W");

async function $063ef42884269cbf$export$180c897189be2f25({ variables: variables, operationName: operationName, aggUrl: url, headers: headers, cache: cache }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $dh538.fg)('kd_fe_enable_agg_cache')) return $063ef42884269cbf$var$fetchPersistedAggResponseWithCache({
        cache: cache,
        aggUrl: url,
        options: options
    });
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
async function $063ef42884269cbf$var$fetchPersistedAggResponseWithCache({ aggUrl: url, cache: cache, options: options }) {
    let cachedResponse = (0, $iip0W.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $iip0W.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $iip0W.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $dwp40.utils).requestService({
                url: url
            }, options);
            (0, $iip0W.InMemCache).setData({
                key: cache.key,
                response: response,
                ttl: cache.ttl
            });
            resolve(response);
        } catch (error) {
            reject(error);
        } finally{
            (0, $iip0W.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $iip0W.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}





const $ac8b486d2a893680$var$OPERATION_NAME = 'useNaturalLanguageToJqlQuery';
const $ac8b486d2a893680$var$fetchNaturalLanguageToJqlQuery = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $063ef42884269cbf$export$180c897189be2f25)({
        variables: variables,
        operationName: $ac8b486d2a893680$var$OPERATION_NAME,
        aggUrl: '/gateway/api/graphql/slow/pq/0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b',
        headers: {
            'X-ExperimentalApi': 'JiraIssueSearch',
            'x-atlassian-capability': 'NIN_NEW_ISSUE_NAVIGATOR--other',
            ...(0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        },
        cache: {
            key: `${$ac8b486d2a893680$var$OPERATION_NAME}.${variables.naturalLanguageInput}`,
            ttl: 300000
        }
    }).then((response)=>response.data);
};
const $ac8b486d2a893680$export$eca952b1040f8ff3 = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, product: product })=>{
    const [loading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(false);
    const [jql, setJql] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const data = await $ac8b486d2a893680$var$fetchNaturalLanguageToJqlQuery({
                    variables: {
                        cloudId: cloudId,
                        naturalLanguageInput: query,
                        iteration: 'ITERATION_2',
                        project: null
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                const generatedJQL = data?.jira?.naturalLanguageToJql?.generatedJQL || undefined;
                if (data?.jira?.naturalLanguageToJql?.generatedJQLError) {
                    setError(true);
                    throw new Error(data.jira.naturalLanguageToJql.generatedJQLError.message);
                }
                if (data?.errors?.length) {
                    setError(true);
                    throw new Error(data.errors[0].message || 'Unknown error');
                }
                // catch all
                if (!Boolean(generatedJQL)) {
                    setError(true);
                    throw new Error('No JQL generated');
                }
                setJql(generatedJQL);
            } catch (e) {
                (0, $4Zqgi.logger).error({
                    error: e,
                    functionName: 'useNaturalLanguageToJqlQuery'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (!!cloudId) fetchData();
    }, [
        cloudId,
        query,
        product,
        workspaceId
    ]);
    return {
        jql: jql,
        loading: loading,
        error: error
    };
};


/* ErrorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");







var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $jTYav = parcelRequire("jTYav");


var $cgtv4 = parcelRequire("cgtv4");

const $2b52297c8b87c076$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    headerWork: {
        id: "search_ai.jira_nl_to_jql_card.table_header.work",
        defaultMessage: "Work"
    },
    headerStatus: {
        id: "search_ai.jira_nl_to_jql_card.table_header.status",
        defaultMessage: "Status"
    },
    headerAssignee: {
        id: "search_ai.jira_nl_to_jql_card.table_header.assignee",
        defaultMessage: "Assignee"
    },
    headerPriority: {
        id: "search_ai.jira_nl_to_jql_card.table_header.priority",
        defaultMessage: "Priority"
    },
    cardTitle: {
        id: "search_ai.jira_nl_to_jql_card.card.title",
        defaultMessage: "Top Jira work items"
    },
    errorMessage: {
        id: "search_ai.jira_nl_to_jql_card.error",
        defaultMessage: "Rovo couldn't generate an answer for \"{title}\". Try rephrasing your query."
    },
    noResultsMessage: {
        id: "search_ai.jira_nl_to_jql_card.no_results",
        defaultMessage: "No results found"
    },
    unassigned: {
        id: "search_ai.jira_nl_to_jql_card.unassigned",
        defaultMessage: "Unassigned"
    },
    viewAll: {
        id: "search_ai.jira_nl_to_jql_card.viewall",
        defaultMessage: "{totalCount, plural, one {View {totalCount, number} work item} other {View all {totalCount, number} work items}}"
    },
    close: {
        id: "search_ai.jira_nl_to_jql_card.close",
        defaultMessage: "Close"
    }
});


const $4487e737d943b769$var$styles = {
    container: "_2rko12b0 _19itia51 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    onlineDebuggerButtonContainer: "_18u01wug _1bsb1ns9"
};
const $4487e737d943b769$export$a2c93507c97cd090 = ({ query: query })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const showOnlineDebuggerButton = (0, $dh538.fg)('kd_sain_online_debugger');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: isOpen ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            xcss: $4487e737d943b769$var$styles.container,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "bold",
                            children: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).errorMessage, {
                                title: query
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                            label: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).close),
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                showOnlineDebuggerButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4487e737d943b769$var$styles.onlineDebuggerButtonContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jTYav.OnlineDebuggerButton), {})
                })
            ]
        }) : null
    });
};


/* IssueTable.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");









/* IssueKeyNode.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $auNCB = parcelRequire("auNCB");


var $90Y9A = parcelRequire("90Y9A");










const $3cfb7b3d88f1c2fc$var$styles = {
    noWrap: "_o5721q9c"
};
const $3cfb7b3d88f1c2fc$export$227b36be34e771c5 = ({ issuekey: issuekey, url: url, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const onClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onJiraIssueKeyClicked)({
            ...analyticsAttributes,
            issuekey: issuekey
        }));
        if ((0, $dh538.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $4jIuc.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        analyticsAttributes,
        issuekey
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $90Y9A.StandaloneHoverCard), {
        url: url,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
            href: url,
            xcss: $3cfb7b3d88f1c2fc$var$styles.noWrap,
            onClick: onClick,
            children: issuekey
        })
    });
};


/* IssuePriorityNode.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $3gadb = parcelRequire("3gadb");

const $5e0232695efc990f$export$a62149baee0d175c = ({ IssuePriorityField: IssuePriorityField })=>{
    if (!IssuePriorityField?.priority) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        alignInline: "start",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: IssuePriorityField.priority.name,
            // don't need a screen reader announcement as the
            // tooltip content is the same as the items content
            isScreenReaderAnnouncementDisabled: true,
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                height: "16",
                width: "16",
                src: IssuePriorityField.priority.iconUrl,
                alt: IssuePriorityField.priority.name
            })
        })
    });
};


/* IssueStatusNode.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $5nBzc = parcelRequire("5nBzc");

const $b42861b68b74388f$export$47dfea36fbf85d70 = ({ status: status })=>{
    if (!status?.name || !status?.statusCategory.statusCategoryId) return null;
    let appearance = 'default';
    switch(status.statusCategory.statusCategoryId){
        case '2':
            appearance = 'default';
            break;
        case '4':
            appearance = 'inprogress';
            break;
        case '3':
            appearance = 'success';
            break;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: appearance,
        isBold: true,
        children: status.name.toUpperCase()
    });
};


/* IssueTextNode.tsx generated by @compiled/babel-plugin v0.36.1 */ 













const $fe058414711d0b98$var$styles = {
    container: "_1bsb1osq"
};
const $fe058414711d0b98$export$e899559221712ff = ({ text: text })=>{
    const textRef = (0, $42omo.useRef)(null);
    if (!text) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        children: "\xa0"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: text,
        // don't need a screen reader announcement as the
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true,
        canAppear: ()=>{
            const element = textRef.current;
            // Only showing the tooltip for this item when
            // the element has been clamped.
            return !!element && element.scrollHeight > element.clientHeight;
        },
        children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ...props,
                xcss: $fe058414711d0b98$var$styles.container,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    ref: textRef,
                    maxLines: 1,
                    children: text
                })
            })
    });
};


/* IssueTypeNode.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

const $3d5e390573b431e4$export$e34e3b13a9b68282 = ({ IssueTypeField: IssueTypeField })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        height: "16",
        width: "16",
        src: IssueTypeField.issueType.avatar.small,
        alt: IssueTypeField.issueType.name
    });
};


/* IssueUserNode.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $kpdGL = parcelRequire("kpdGL");

var $esRft = parcelRequire("esRft");











const $6a16c3e6ebb9a02f$var$styles = {
    avatar: "_18u0x0bf"
};
const $6a16c3e6ebb9a02f$export$ab6075737389532b = ({ user: user })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const User = !Boolean(user) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kpdGL.default), {
        avatar: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            appearance: "circle",
            size: "small",
            name: "unassigned"
        }),
        primaryText: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).unassigned)
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: user?.name,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpdGL.default), {
            avatar: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                appearance: "circle",
                src: user?.picture,
                size: "small",
                name: user?.name
            }),
            primaryText: user?.name
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($6a16c3e6ebb9a02f$var$styles.avatar),
        children: User
    });
};



const $d85d4973de359350$var$styles = {
    tableWrapper: "_2rko1mok _1dqonqa1 _1h6d1l7x _189ee4h9 _1reo1wug",
    table: "_1dqo15vq _1kqm1n9t",
    header: "_1dqoglyw",
    headerCell: "_11c8i4vh _1dqonqa1 _1h6d1l7x _189ee4h9 _syazazsu _bfhkhfxm _ca0qze3t _u5f3u2gc _n3tdze3t _19bvu2gc _4t3i1ylp _s7n4nkob",
    cell: "_1reo15vq _18m915vq _1dqonqa1 _1h6d1l7x _189ee4h9 _ca0qze3t _u5f3u2gc _n3tdze3t _19bvu2gc _1bsb1osq _4t3i1ylp"
};
const $d85d4973de359350$var$HeaderRow = ({ headerLabels: headerLabels })=>{
    return headerLabels.map((item, index)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)("th", {
            style: {
                width: item.width,
                // Override to avoid global first child padding
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...index === 0 && {
                    paddingLeft: "var(--ds-space-100, 8px)"
                }
            },
            className: (0, $gMc0m.default)([
                $d85d4973de359350$var$styles.headerCell
            ]),
            children: item.label
        }, `issue.header.${index}`);
    });
};
const $d85d4973de359350$var$BodyRows = ({ issues: issues, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>issues.map((issue, rowIndex)=>{
        const issueNode = issue.node;
        const issueTypeField = issueNode.issueTypeField;
        const issueStatus = issueNode.status;
        const issueAssignee = issueNode.assigneeField.user;
        const issuePriority = issueNode.priorityField;
        return /*#__PURE__*/ (0, $l998X.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("td" // Override to avoid global first child padding
                , {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: {
                        paddingLeft: "var(--ds-space-100, 8px)"
                    },
                    className: (0, $gMc0m.default)([
                        $d85d4973de359350$var$styles.cell
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        alignInline: "start",
                        space: "space.075",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $3d5e390573b431e4$export$e34e3b13a9b68282), {
                                IssueTypeField: issueTypeField
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $3cfb7b3d88f1c2fc$export$227b36be34e771c5), {
                                url: issueNode.webUrl,
                                issuekey: issueNode.key,
                                analyticsAttributes: analyticsAttributes,
                                fireEngagementEvent: fireEngagementEvent
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fe058414711d0b98$export$e899559221712ff), {
                                text: issueNode.summary
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("td", {
                    className: (0, $gMc0m.default)([
                        $d85d4973de359350$var$styles.cell
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b42861b68b74388f$export$47dfea36fbf85d70), {
                        status: issueStatus
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("td", {
                    className: (0, $gMc0m.default)([
                        $d85d4973de359350$var$styles.cell
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6a16c3e6ebb9a02f$export$ab6075737389532b), {
                        user: issueAssignee
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("td", {
                    className: (0, $gMc0m.default)([
                        $d85d4973de359350$var$styles.cell
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5e0232695efc990f$export$a62149baee0d175c), {
                        IssuePriorityField: issuePriority
                    })
                })
            ]
        }, `issue.row.${rowIndex}`);
    });
const $d85d4973de359350$export$548da6a0023fca70 = ({ issues: issues, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const headerLabels = [
        {
            label: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).headerWork),
            width: '60%'
        },
        {
            label: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).headerStatus),
            width: '15%'
        },
        {
            label: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).headerAssignee),
            width: '15%'
        },
        {
            label: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).headerPriority),
            width: '10%'
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d85d4973de359350$var$styles.tableWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("table", {
            "data-testid": "issue-table",
            className: (0, $gMc0m.default)([
                $d85d4973de359350$var$styles.table
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("thead", {
                    className: (0, $gMc0m.default)([
                        $d85d4973de359350$var$styles.header
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)($d85d4973de359350$var$HeaderRow, {
                            headerLabels: headerLabels
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
                    children: issues.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)($d85d4973de359350$var$BodyRows, {
                        issues: issues,
                        analyticsAttributes: analyticsAttributes,
                        fireEngagementEvent: fireEngagementEvent
                    }) : /*#__PURE__*/ (0, $l998X.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)("td", {
                            align: "center",
                            colSpan: headerLabels.length,
                            className: (0, $gMc0m.default)([
                                $d85d4973de359350$var$styles.cell
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                alignBlock: "center",
                                alignInline: "center",
                                children: formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).noResultsMessage)
                            })
                        })
                    })
                })
            ]
        })
    });
};






parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $7p4As = parcelRequire("7p4As");


var $lAFHW = parcelRequire("lAFHW");





const $acdfed4857679fee$export$28a2392dc2b2dd58 = (props)=>{
    const { totalIssuesCount: totalIssuesCount, url: url, callback: callback } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        href: url,
        appearance: "default",
        onClick: callback,
        testId: "view-all-button",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                    appearance: "brand",
                    shouldUseNewLogoDesign: true,
                    size: "xxsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $2b52297c8b87c076$export$defe85febe8b728c).viewAll,
                    values: {
                        totalCount: totalIssuesCount
                    }
                })
            ]
        })
    });
};


const $8bdd0346cf0b7eb0$var$styles = {
    container: "_2rko12b0 _19itia51",
    tableContainer: "_2rko1mok _kqswh2mm _18u0pxbi _2hwxpxbi _otyru2gc",
    sidePadding: "_19bvpxbi _u5f3pxbi",
    headerContainer: "_ca0qutpp _u5f3pxbi _n3tdu2gc",
    footer: "_18zrpxbi _85i5utpp",
    viewAllContainer: "_ca0q1b66 _n3td1b66 _y3gn1e5h"
};
const $8bdd0346cf0b7eb0$var$buildJiraLink = ({ issueUrl: issueUrl, jql: jql })=>{
    const hostname = new URL(issueUrl).hostname;
    const jiraLink = new URL(`https://${hostname}/issues/`);
    jiraLink.searchParams.append('jql', jql);
    return jiraLink.toString();
};
const $8bdd0346cf0b7eb0$export$ba6b7dafd54d334 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const renderStartTime = (0, $42omo.useRef)(performance.now());
    const analyticsFiredRef = (0, $42omo.useRef)(false);
    const { query: query, title: title, cloudId: cloudId, aiBrand: aiBrand, searchSessionId: searchSessionId, workspaceId: workspaceId, product: product, onFMPReached: onFMPReached } = props;
    const [issueUrl, setIssueUrl] = (0, $42omo.useState)(null);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { commonAttributes: commonAttributes, setData: setData } = (0, $eRXI0.useAIAnswerContext)();
    const { loading: jqlLoading, error: jqlError, jql: jql } = (0, $ac8b486d2a893680$export$eca952b1040f8ff3)({
        cloudId: cloudId,
        query: query,
        workspaceId: workspaceId,
        product: product
    });
    const { issues: issues, totalIssuesCount: totalIssuesCount, loading: issuesLoading, error: issuesError, extensions: issuesExtensions } = (0, $586e66ef37300257$export$11659072884978f5)({
        cloudId: cloudId,
        jql: jql,
        workspaceId: workspaceId,
        product: product
    });
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $01aV7.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            query: query,
            answerString: jql || '',
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY
        }), [
        searchSessionId,
        query,
        aiBrand,
        jql
    ]);
    const analyticsAttributesWithoutUGC = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $01aV7.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY
        }), [
        searchSessionId,
        query,
        aiBrand
    ]);
    const fireJiraNlToJqlCardLoaded = (0, $42omo.useCallback)(({ success: success, endState: endState })=>{
        const apiLoadedTime = performance.now();
        const totalDuration = apiLoadedTime - renderStartTime.current;
        fireAnalyticsEvent((0, $4xTru.onJiraNlToJqlCardLoaded)({
            ...analyticsAttributes,
            success: success,
            loadTime: totalDuration,
            endState: endState
        }));
    }, [
        fireAnalyticsEvent,
        analyticsAttributes
    ]);
    // using the first issue's webUrl to build a jira url for the view all 'x' items button
    (0, $42omo.useEffect)(()=>{
        if (!issuesLoading && !issuesError && issues?.length && issues[0]) try {
            const firstIssueUrl = issues[0].node.webUrl;
            setIssueUrl($8bdd0346cf0b7eb0$var$buildJiraLink({
                issueUrl: firstIssueUrl || '',
                jql: jql || ''
            }));
        } catch (error) {
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'JiraNlToJqlCard'
            });
        }
    }, [
        issuesLoading,
        issuesError,
        issues,
        jql
    ]);
    (0, $42omo.useEffect)(()=>{
        trackAIInteractionInit();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []); // Set debug data for online debugger when API response is available
    // Separate from analytics effect to avoid infinite loop with commonAttributes
    (0, $42omo.useEffect)(()=>{
        if (!issuesLoading && issuesExtensions?.gateway && (0, $dh538.fg)('kd_sain_online_debugger')) setData({
            errorState: null,
            format: null,
            uniqueSources: [],
            disclaimer: null,
            extraAPIAnalyticsAttributes: {
                traceId: issuesExtensions.gateway.trace_id ?? null,
                requestId: issuesExtensions.gateway.request_id ?? null
            }
        });
    }, [
        issuesLoading,
        issuesExtensions?.gateway,
        setData
    ]); // fire Analytics Events on final state changes
    (0, $42omo.useEffect)(()=>{
        if (analyticsFiredRef.current) return;
        if (!jqlLoading && !jqlError && !issuesLoading && !issuesError && issues?.length && issues[0]) {
            /*
       * * Success block
       */ analyticsFiredRef.current = true;
            onFMPReached();
            fireJiraNlToJqlCardLoaded({
                success: true,
                endState: 'answered'
            });
            if ((0, $dh538.fg)('kd_fix_nl2jql_mau_instrumentation')) fireSAINUsageEvent({
                commonAttributes: {
                    ...commonAttributes,
                    extraAttributes: {
                        ...commonAttributes?.extraAttributes,
                        requestId: issuesExtensions?.gateway?.request_id ?? null
                    }
                }
            });
            else fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
        } else if (!jqlLoading && jqlError) {
            /*
       * * JQL error block
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'jql-error'
            });
        } else if (!issuesLoading && issuesError) {
            /*
       * * Issues error block
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'issues-error'
            });
        } else if (!jqlLoading && !issuesLoading && issues?.length === 0) {
            /*
       * * No issues block,
       * * while this is not an error, we're still marking it as a failure cause the user sees an error card
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'no-issues'
            });
        }
    }, [
        jqlLoading,
        issuesLoading,
        issuesError,
        jqlError,
        issues,
        onFMPReached,
        fireJiraNlToJqlCardLoaded,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes,
        issuesExtensions?.gateway?.request_id
    ]);
    const fireEngagementEvent = (0, $42omo.useCallback)((sainAction)=>{
        fireSAINUsageEvent({
            metCriteria: sainAction,
            commonAttributes: {
                ...commonAttributes,
                extraAttributes: {
                    ...commonAttributes?.extraAttributes,
                    requestId: issuesExtensions?.gateway?.request_id ?? null
                }
            }
        });
    }, [
        fireSAINUsageEvent,
        commonAttributes,
        issuesExtensions?.gateway?.request_id
    ]);
    const onViewAllButtonClicked = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onJiraViewAllButtonClicked)({
            ...analyticsAttributes,
            totalIssuesCount: totalIssuesCount || 0
        }));
        if ((0, $dh538.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $4jIuc.SainAction).JIRA_NL_TO_JQL_VIEW_ALL);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        analyticsAttributes,
        totalIssuesCount
    ]);
    if (jqlLoading || issuesLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eMz0l.AnimatedWrapper), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kF5LJ.SmartAnswerCardBodyGenerating), {
            heightOverride: "jiraNlToJqlCard"
        })
    });
    if (jqlError || issuesError || issues?.length === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4487e737d943b769$export$a2c93507c97cd090), {
        query: query
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $8bdd0346cf0b7eb0$var$styles.container,
        testId: "jira-nl-to-jql-card-wrapper",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($8bdd0346cf0b7eb0$var$styles.headerContainer, $8bdd0346cf0b7eb0$var$styles.sidePadding),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                    size: "xsmall",
                    children: title || formatMessage((0, $2b52297c8b87c076$export$defe85febe8b728c).cardTitle)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $8bdd0346cf0b7eb0$var$styles.tableContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        attributes: {
                            location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD,
                            ...analyticsAttributesWithoutUGC
                        },
                        location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d85d4973de359350$export$548da6a0023fca70), {
                            issues: issues || [],
                            analyticsAttributes: analyticsAttributes,
                            fireEngagementEvent: fireEngagementEvent
                        })
                    })
                })
            }),
            totalIssuesCount && totalIssuesCount > 0 && issueUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($8bdd0346cf0b7eb0$var$styles.viewAllContainer, $8bdd0346cf0b7eb0$var$styles.sidePadding),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $acdfed4857679fee$export$28a2392dc2b2dd58), {
                    totalIssuesCount: totalIssuesCount,
                    url: issueUrl,
                    callback: onViewAllButtonClicked
                })
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $8bdd0346cf0b7eb0$var$styles.footer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                    showFeedbackButtons: true
                })
            })
        ]
    });
});



var $gt6aY = parcelRequire("gt6aY");

/* agent-knowledge-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $fid2I = parcelRequire("fid2I");


var $hezkK = parcelRequire("hezkK");










/* knowledge-carousel.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $lvsjl = parcelRequire("lvsjl");





var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");










const $d44aca612cf62bf3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    scrollLeft: {
        id: "search_ai.knowledge_carousel.scroll_left",
        defaultMessage: "Scroll left"
    },
    scrollRight: {
        id: "search_ai.knowledge_carousel.scroll_right",
        defaultMessage: "Scroll right"
    }
});
const $d44aca612cf62bf3$var$styles = {
    scrollContainerStyle: "_zulppxbi _4cvr1fhb _1e0c1txw _1reo1wug _1fjgglyw _o5721q9c"
};
const $d44aca612cf62bf3$var$isScrollable = (elem)=>elem ? elem.scrollWidth > elem.clientWidth : false;
const $d44aca612cf62bf3$var$isScrollAtLeftEdge = (elem)=>elem ? elem.scrollLeft <= 1 : false;
const $d44aca612cf62bf3$var$isScrollAtRightEdge = (elem)=>elem ? elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth <= 1 : false;
const $d44aca612cf62bf3$export$61c045a5252abd1d = ({ children: children, heading: heading, scrollOffset: scrollOffset })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const scrollContainerRef = (0, $42omo.useRef)(null);
    const [isContentScrollable, setIsContentScrollable] = (0, $42omo.useState)(false);
    const [shouldDisableLeftArrowButton, setShouldDisableLeftArrowButton] = (0, $42omo.useState)(true);
    const [shouldDisableRightArrowButton, setShouldDisableRightArrowButton] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        setIsContentScrollable($d44aca612cf62bf3$var$isScrollable(scrollContainerRef.current));
        setShouldDisableLeftArrowButton($d44aca612cf62bf3$var$isScrollAtLeftEdge(scrollContainerRef.current));
        setShouldDisableRightArrowButton($d44aca612cf62bf3$var$isScrollAtRightEdge(scrollContainerRef.current));
    }, []);
    const [onScroll] = (0, $lvsjl.default)(()=>{
        setShouldDisableLeftArrowButton($d44aca612cf62bf3$var$isScrollAtLeftEdge(scrollContainerRef.current));
        setShouldDisableRightArrowButton($d44aca612cf62bf3$var$isScrollAtRightEdge(scrollContainerRef.current));
    }, 10);
    const scrollLeft = ()=>{
        setShouldDisableRightArrowButton(false);
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: -scrollOffset,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        setShouldDisableLeftArrowButton(false);
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: scrollOffset,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.150",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                spread: "space-between",
                alignBlock: "center",
                children: [
                    typeof heading === 'string' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "large",
                        weight: "semibold",
                        children: heading
                    }) : heading,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        space: "space.050",
                        children: isContentScrollable ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    shape: "circle",
                                    appearance: "subtle",
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                                    isTooltipDisabled: true,
                                    label: formatMessage($d44aca612cf62bf3$export$defe85febe8b728c.scrollLeft),
                                    onClick: scrollLeft,
                                    spacing: "compact",
                                    isDisabled: shouldDisableLeftArrowButton
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    shape: "circle",
                                    appearance: "subtle",
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                                    isTooltipDisabled: true,
                                    label: formatMessage($d44aca612cf62bf3$export$defe85febe8b728c.scrollRight),
                                    onClick: scrollRight,
                                    spacing: "compact",
                                    isDisabled: shouldDisableRightArrowButton
                                })
                            ]
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: scrollContainerRef,
                onScroll: onScroll,
                xcss: $d44aca612cf62bf3$var$styles.scrollContainerStyle,
                children: children
            })
        ]
    });
};









var $hTKp4 = parcelRequire("hTKp4");










const $63654b9ac7fa44e6$var$document = (0, $hTKp4.getDocument)();
// Timeout constants for hover behavior, these come from the people and teams profilecard package
const $63654b9ac7fa44e6$var$HOVER_START_DELAY = 800; // Delay before starting hover on trigger
const $63654b9ac7fa44e6$var$HOVER_END_DELAY = 250; // Delay before ending hover when mouse leaves elements
const $63654b9ac7fa44e6$export$79db6a77ac4a8ace = ({ elementType: elementType, onHoverStart: onHoverStart, onHoverStop: onHoverStop, hoverCardSelector: hoverCardSelector, hoverStartDelay: hoverStartDelay = $63654b9ac7fa44e6$var$HOVER_START_DELAY, hoverEndDelay: hoverEndDelay = $63654b9ac7fa44e6$var$HOVER_END_DELAY })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [isHovering, setIsHovering] = (0, $42omo.useState)(false);
    const hoverStartTimeRef = (0, $42omo.useRef)(null);
    const isOnTriggerRef = (0, $42omo.useRef)(false);
    const isOnHoverCardRef = (0, $42omo.useRef)(false);
    /**
	 * Checks if the mouse is currently over the hover card element.
	 */ const isMouseOnHoverCard = (0, $42omo.useCallback)((event)=>{
        if (!$63654b9ac7fa44e6$var$document) return false;
        const hoverCardElement = $63654b9ac7fa44e6$var$document.querySelector(hoverCardSelector);
        if (!hoverCardElement) return false;
        return hoverCardElement.contains(event.target);
    }, [
        hoverCardSelector
    ]);
    /**
	 * Handles mouse movement to track position relative to hover card and manage hover state.
	 */ const handleMouseMove = (0, $42omo.useCallback)((event)=>{
        const isOnHoverCard = isMouseOnHoverCard(event);
        isOnHoverCardRef.current = isOnHoverCard;
        // If mouse leaves hover card, check if we should end hover after delay
        if (!isOnHoverCard) setTimeout(()=>{
            // End hover if mouse is not on either element after delay
            if (!isOnHoverCardRef.current && hoverStartTimeRef.current && !isOnTriggerRef.current) {
                const hoverTime = Date.now() - hoverStartTimeRef.current;
                hoverStartTimeRef.current = null;
                if (onHoverStop) onHoverStop(hoverTime);
                else fireAnalyticsEvent((0, $4xTru.onAIResultHoverStop)({
                    elementType: elementType,
                    hoverTime: hoverTime,
                    ...commonAttributes
                }));
                setIsHovering(false);
            }
        }, hoverEndDelay);
    }, [
        isMouseOnHoverCard,
        onHoverStop,
        fireAnalyticsEvent,
        commonAttributes,
        elementType,
        hoverEndDelay
    ]);
    /**
	 * Handles the start of a hover interaction on the trigger.
	 * Manages hover state and prevents duplicate hover interactions.
	 */ const handleHoverStart = (0, $42omo.useCallback)((event)=>{
        // Don't start hover if mouse is already on hover card
        const isOnHoverCard = isMouseOnHoverCard(event.nativeEvent);
        if (isOnHoverCard) return;
        // Check if hover card is currently open
        let anyHoverCardOpen;
        if ($63654b9ac7fa44e6$var$document) anyHoverCardOpen = $63654b9ac7fa44e6$var$document.querySelector(hoverCardSelector);
        // If hover card is open and we're already hovering, continue existing hover
        if (anyHoverCardOpen && isHovering) {
            isOnTriggerRef.current = true;
            return;
        }
        // Don't start new hover if hover card is already open
        if (anyHoverCardOpen) return;
        isOnTriggerRef.current = true;
        // Start hover after delay to prevent premature triggering
        setTimeout(()=>{
            // Only start hover if user is still on trigger after delay
            if (!isHovering && isOnTriggerRef.current) {
                const startTime = Date.now();
                hoverStartTimeRef.current = startTime;
                setIsHovering(true);
                if (onHoverStart) onHoverStart();
                else fireAnalyticsEvent((0, $4xTru.onAIResultHoverStart)({
                    elementType: elementType,
                    ...commonAttributes
                }));
            }
        }, hoverStartDelay);
    }, [
        elementType,
        onHoverStart,
        fireAnalyticsEvent,
        commonAttributes,
        isHovering,
        isMouseOnHoverCard,
        hoverCardSelector,
        hoverStartDelay
    ]);
    /**
	 * Handles the end of a hover interaction on the trigger.
	 * Updates trigger state to track mouse position.
	 */ const handleHoverLeave = (0, $42omo.useCallback)(()=>{
        isOnTriggerRef.current = false;
    }, []);
    // Set up global mouse move tracking
    (0, $42omo.useEffect)(()=>{
        if (!$63654b9ac7fa44e6$var$document) return;
        const removeMouseMoveListener = (0, $fFa3V.bind)($63654b9ac7fa44e6$var$document, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return ()=>{
            removeMouseMoveListener();
        };
    }, [
        handleMouseMove
    ]);
    return {
        isHovering: isHovering,
        handleHoverStart: handleHoverStart,
        handleHoverLeave: handleHoverLeave
    };
};






var $fJBWn = parcelRequire("fJBWn");

/* knowledge-card-loading.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $gj7hi = parcelRequire("gj7hi");









var $kpYGL = parcelRequire("kpYGL");








var $lqjTE = parcelRequire("lqjTE");











var $iew5c = parcelRequire("iew5c");

const $bb7252f08ce189c0$var$styles = {
    containerNewSAINLoading: "_u5f3pxbi _19bvpxbi _ca0qpxbi _n3tdpxbi _4t3ibn52",
    inline: "_19bvu2gc _u5f3u2gc _4t3i1ylp",
    agentCardHeightOverride: "_4t3igrxc"
};
const $bb7252f08ce189c0$var$messages = (0, $cgtv4.defineMessages)({
    knowledge_card_loading: {
        id: "search_ai.knowledge_card_loading",
        defaultMessage: "Searching across your connected apps"
    },
    knowledge_card_rovo_is_thinking: {
        id: "search_ai.knowledge_card_rovo_is_thinking",
        defaultMessage: "Rovo is thinking"
    }
});
function $bb7252f08ce189c0$export$a08238eb59773648({ queryIntent: queryIntent }) {
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onKnowledgeCardLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eMz0l.AnimatedWrapper), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: (0, $1Whri.cx)($bb7252f08ce189c0$var$styles.containerNewSAINLoading, queryIntent === (0, $f7lNm.QueryIntent).AGENT && $bb7252f08ce189c0$var$styles.agentCardHeightOverride),
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: 'space.100',
                    xcss: $bb7252f08ce189c0$var$styles.inline,
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($iew5c))),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    color: 'color.text.subtle',
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...$bb7252f08ce189c0$var$messages.knowledge_card_rovo_is_thinking
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $lqjTE.RovoGeneratingAnimation), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "100%",
                    height: "16px",
                    color: "var(--ds-skeleton-subtle, #17171708)"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "100%",
                    height: "16px",
                    color: "var(--ds-skeleton-subtle, #17171708)"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "90%",
                    height: "16px",
                    color: "var(--ds-skeleton-subtle, #17171708)"
                })
            ]
        })
    });
}


/* separator-line.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $65205934451f1233$var$styles = {
    lineRefresh: "_4t3it94y _1bsb1osq _bfhk7qp0"
};
const $65205934451f1233$export$4fb305a2fc986af3 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $65205934451f1233$var$styles.lineRefresh
    });



var $ckCUa = parcelRequire("ckCUa");


























var $7lL49 = parcelRequire("7lL49");




















var $cI0rA = parcelRequire("cI0rA");


var $io1wY = parcelRequire("io1wY");




const $febcadb8ebf037ac$var$youSingularWorkedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.today",
        defaultMessage: "You worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.yesterday",
        defaultMessage: "You worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.otherTime",
        defaultMessage: "You worked on this {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularCreatedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.today",
        defaultMessage: "You created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.yesterday",
        defaultMessage: "You created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.otherTime",
        defaultMessage: "You created this on {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularEditedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.today",
        defaultMessage: "You edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.yesterday",
        defaultMessage: "You edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.otherTime",
        defaultMessage: "You edited this on {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularCommentedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.today",
        defaultMessage: "You commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.yesterday",
        defaultMessage: "You commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.otherTime",
        defaultMessage: "You commented here on {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularUpdatedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.today",
        defaultMessage: "You updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.yesterday",
        defaultMessage: "You updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.otherTime",
        defaultMessage: "You updated this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularWorkedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.today",
        defaultMessage: "{name} worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.yesterday",
        defaultMessage: "{name} worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.otherTime",
        defaultMessage: "{name} worked on this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularCreatedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.today",
        defaultMessage: "{name} created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.yesterday",
        defaultMessage: "{name} created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.otherTime",
        defaultMessage: "{name} created this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularEditedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.today",
        defaultMessage: "{name} edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.yesterday",
        defaultMessage: "{name} edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.otherTime",
        defaultMessage: "{name} edited this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularCommentedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.today",
        defaultMessage: "{name} commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.yesterday",
        defaultMessage: "{name} commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.otherTime",
        defaultMessage: "{name} commented here on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularUpdatedMessages = (0, $cgtv4.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.today",
        defaultMessage: "{name} updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.yesterday",
        defaultMessage: "{name} updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.otherTime",
        defaultMessage: "{name} updated this on {time}"
    }
});
const $febcadb8ebf037ac$var$youPluralActivityMessages = (0, $cgtv4.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.double",
        defaultMessage: "You and {name1} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.triple",
        defaultMessage: "You, {name1}, and {name2} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.many",
        defaultMessage: "You, {name1}, and {count} others have all worked on this"
    }
});
const $febcadb8ebf037ac$var$otherPluralActivityMessages = (0, $cgtv4.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.double",
        defaultMessage: "{name1} and {name2} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.triple",
        defaultMessage: "{name1}, {name2}, and {name3} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.many",
        defaultMessage: "{name1}, {name2}, and {count} others have all worked on this"
    }
});
const $febcadb8ebf037ac$export$97eb62906ce0e051 = {
    worked: $febcadb8ebf037ac$var$youSingularWorkedMessages,
    created: $febcadb8ebf037ac$var$youSingularCreatedMessages,
    edited: $febcadb8ebf037ac$var$youSingularEditedMessages,
    commented: $febcadb8ebf037ac$var$youSingularCommentedMessages,
    updated: $febcadb8ebf037ac$var$youSingularUpdatedMessages
};
const $febcadb8ebf037ac$export$fca5bc54abc98673 = {
    worked: $febcadb8ebf037ac$var$otherSingularWorkedMessages,
    created: $febcadb8ebf037ac$var$otherSingularCreatedMessages,
    edited: $febcadb8ebf037ac$var$otherSingularEditedMessages,
    commented: $febcadb8ebf037ac$var$otherSingularCommentedMessages,
    updated: $febcadb8ebf037ac$var$otherSingularUpdatedMessages
};
const $febcadb8ebf037ac$export$b9d6808884fda53b = {
    you: $febcadb8ebf037ac$var$youPluralActivityMessages,
    other: $febcadb8ebf037ac$var$otherPluralActivityMessages
};


const $f0eed913fd2c0cbd$export$4d98da88c6a5014a = ({ currentUserId: currentUserId, event: event, contributors: contributors, othersCount: othersCount, timestamp: timestamp, formatMessage: formatMessage, formatDate: formatDate })=>{
    const involvesCurrentUser = contributors.some((contributor)=>contributor.id === currentUserId);
    // If the event is singular with a single contributor
    if (contributors.length === 1) {
        const formattedDate = formatDate(timestamp, {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
        let message;
        switch(event){
            case 'created':
                message = involvesCurrentUser ? (0, $febcadb8ebf037ac$export$97eb62906ce0e051).created : (0, $febcadb8ebf037ac$export$fca5bc54abc98673).created;
                break;
            case 'edited':
                message = involvesCurrentUser ? (0, $febcadb8ebf037ac$export$97eb62906ce0e051).edited : (0, $febcadb8ebf037ac$export$fca5bc54abc98673).edited;
                break;
            case 'commented':
                message = involvesCurrentUser ? (0, $febcadb8ebf037ac$export$97eb62906ce0e051).commented : (0, $febcadb8ebf037ac$export$fca5bc54abc98673).commented;
                break;
            case 'updated':
                message = involvesCurrentUser ? (0, $febcadb8ebf037ac$export$97eb62906ce0e051).updated : (0, $febcadb8ebf037ac$export$fca5bc54abc98673).updated;
                break;
            case 'worked':
            default:
                message = involvesCurrentUser ? (0, $febcadb8ebf037ac$export$97eb62906ce0e051).worked : (0, $febcadb8ebf037ac$export$fca5bc54abc98673).worked;
                break;
        }
        if ((0, $cI0rA.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.today) : formatMessage(message.today, {
            name: contributors[0].name
        });
        else if ((0, $io1wY.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.yesterday) : formatMessage(message.yesterday, {
            name: contributors[0].name
        });
        else return involvesCurrentUser ? formatMessage(message.otherTime, {
            time: formattedDate
        }) : formatMessage(message.yesterday, {
            name: contributors[0].name,
            time: formattedDate
        });
    } else if (involvesCurrentUser) {
        const contributorsWithoutCurrentUser = contributors.filter((contributor)=>contributor.id !== currentUserId);
        if (othersCount > 0) return formatMessage((0, $febcadb8ebf037ac$export$b9d6808884fda53b).you.many, {
            name1: contributorsWithoutCurrentUser[0].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $febcadb8ebf037ac$export$b9d6808884fda53b).you.double, {
            name1: contributorsWithoutCurrentUser[0].name
        }) : formatMessage((0, $febcadb8ebf037ac$export$b9d6808884fda53b).you.triple, {
            name1: contributorsWithoutCurrentUser[0].name,
            name2: contributorsWithoutCurrentUser[1].name
        });
    } else {
        if (othersCount > 0) return formatMessage((0, $febcadb8ebf037ac$export$b9d6808884fda53b).other.many, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $febcadb8ebf037ac$export$b9d6808884fda53b).other.double, {
            name1: contributors[0].name,
            name2: contributors[1].name
        }) : formatMessage((0, $febcadb8ebf037ac$export$b9d6808884fda53b).other.triple, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            name3: contributors[2].name
        });
    }
};






var $gUXWz = parcelRequire("gUXWz");





const $7b4f6a684ec95ddb$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("fcHIm")).then(({ HoverCard: HoverCard })=>({
            default: HoverCard
        })));
const $7b4f6a684ec95ddb$export$65943680306d629 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ item: activity, onClickCallback: onClickCallback, smartLinksAnalyticsContextData: smartLinksAnalyticsContextData })=>{
    const { userDetails: { id: searcherId } } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: smartLinksAnalyticsContextData,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($7b4f6a684ec95ddb$var$HoverCard, {
                    url: activity.url,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gUXWz.KnowledgeCardsRowRefresh), {
                        primaryText: activity.title,
                        secondaryText: `${activity.containerName} \u{2022} ${(0, $f0eed913fd2c0cbd$export$4d98da88c6a5014a)({
                            currentUserId: searcherId || '',
                            event: activity.event,
                            contributors: activity.contributors,
                            othersCount: activity.othersCount,
                            formatMessage: formatMessage,
                            formatDate: formatDate,
                            timestamp: new Date(activity.timestamp)
                        })}`,
                        pictureUrl: activity.iconUrl,
                        type: (0, $ckCUa.KnowledgeCardsRowType).WORK,
                        contentTypeName: activity.contentTypeName,
                        onClick: ()=>{
                            onClickCallback?.();
                            window.open(activity.url, '_self', 'noopener, noreferrer');
                        }
                    })
                }, `knowledge-card-activity-${activity.url}`)
            })
        })
    });
});


/* knowledge-card-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $ccHMk = parcelRequire("ccHMk");







var $2Nwuj = parcelRequire("2Nwuj");


























var $14qs9 = parcelRequire("14qs9");







const $96d38a1128ace4cb$var$CardBodyWrapper = {
    default: "_kqswh2mm _u5f3pxbi _19bvpxbi"
};
const $96d38a1128ace4cb$var$ColumnBottomPadding = {
    default: "_n3td1b66"
};
const $96d38a1128ace4cb$var$DynamicRowStyling = {
    column: "_1e0c1txw _2lx21bp4 _1p571b66 _gy1p1b66",
    grid: "_1e0c11p5 _yv0ewxkt _gy1ppxbi _1p571b66"
};
const $96d38a1128ace4cb$var$EXPANDED_MAX_ITEMS_SHOWN = 6;
const $96d38a1128ace4cb$var$MAX_ITEMS_SHOWN = 2;
const $96d38a1128ace4cb$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN = 4; // 2 rows * 2 items per row
const $96d38a1128ace4cb$var$SINGLE_COLUMN_EXPANDED_MAX_ITEMS_SHOWN = 12; // 6 rows * 2 items per row
const $96d38a1128ace4cb$export$ef08b123bd77f721 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ columnsConfig: columnsConfig, profileUrl: profileUrl, footerButtonText: footerButtonText, footerButtonAction: footerButtonAction, testId: testId })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setExpanded] = (0, $42omo.useState)(false); // Determine if we should show a single column layout (when only one column has data)
    const hasDataColumns = columnsConfig.filter((config)=>config.data.length > 0);
    const showSingleColumn = hasDataColumns.length === 1; // Calculate total items across all columns for expand logic
    const totalItems = columnsConfig.reduce((sum, config)=>sum + config.data.length, 0);
    const shouldShowExpandButton = showSingleColumn ? totalItems > $96d38a1128ace4cb$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN : totalItems > $96d38a1128ace4cb$var$MAX_ITEMS_SHOWN * columnsConfig.length;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $96d38a1128ace4cb$var$CardBodyWrapper.default,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.200",
                children: columnsConfig.map((columnConfig, columnIndex)=>{
                    if (columnConfig.data.length === 0) return null;
                    const maxItems = !isExpanded ? showSingleColumn ? $96d38a1128ace4cb$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN : $96d38a1128ace4cb$var$MAX_ITEMS_SHOWN : Math.min(columnConfig.data.length, showSingleColumn ? $96d38a1128ace4cb$var$SINGLE_COLUMN_EXPANDED_MAX_ITEMS_SHOWN : $96d38a1128ace4cb$var$EXPANDED_MAX_ITEMS_SHOWN);
                    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        grow: "fill",
                        space: "space.050",
                        xcss: $96d38a1128ace4cb$var$ColumnBottomPadding.default,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                paddingInlineStart: "space.200",
                                paddingInlineEnd: "space.200",
                                paddingBlockEnd: "space.075",
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    spread: "space-between",
                                    alignBlock: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "xsmall",
                                            as: "h3",
                                            children: columnConfig.header
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                            href: columnConfig.viewAllLinkHref,
                                            appearance: "subtle",
                                            onClick: (e)=>{
                                                columnConfig.viewAllLinkOnClick(e);
                                            },
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                color: "color.text.subtle",
                                                children: formatMessage((0, $7lL49.messages).knowledge_cards_view_all_link)
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
                                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: showSingleColumn ? $96d38a1128ace4cb$var$DynamicRowStyling.grid : $96d38a1128ace4cb$var$DynamicRowStyling.column,
                                            children: columnConfig.data.slice(0, maxItems).map((item, index)=>{
                                                // Calculate if this item is shown after card body expansion
                                                // For single column layout: items with index >= 4 are shown after expansion
                                                // For multi-column layout: items with index >= 2 are shown after expansion
                                                const shownAfterCardBodyExpanded = showSingleColumn ? index >= $96d38a1128ace4cb$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN && isExpanded : index >= $96d38a1128ace4cb$var$MAX_ITEMS_SHOWN && isExpanded;
                                                return /*#__PURE__*/ (0, $l998X.jsx)(columnConfig.component, {
                                                    item: item,
                                                    maxItems: maxItems,
                                                    onClickCallback: columnConfig?.onClickCallback ? ()=>columnConfig.onClickCallback(index, shownAfterCardBodyExpanded) : undefined,
                                                    smartLinksAnalyticsContextData: columnConfig.smartLinksAnalyticsContextLocation ? (0, $4xTru.getSmartLinksAnalyticsContextData)({
                                                        location: columnConfig.smartLinksAnalyticsContextLocation,
                                                        commonAttributes: commonAttributes
                                                    }) : undefined
                                                }, index);
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }, columnIndex);
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: shouldShowExpandButton ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    alignInline: "center",
                    space: "space.025",
                    children: isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                        href: profileUrl || '',
                        onClick: ()=>{
                            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                                ...commonAttributes,
                                location: 'footer-view-all'
                            }));
                            fireSAINUsageEvent({
                                metCriteria: footerButtonAction,
                                commonAttributes: commonAttributes
                            });
                        },
                        appearance: "subtle",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtlest",
                            weight: "medium",
                            children: footerButtonText
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        onClick: ()=>{
                            setExpanded((e)=>!e);
                            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                                ...commonAttributes,
                                location: 'show-more'
                            }));
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
                                commonAttributes: commonAttributes
                            });
                        },
                        appearance: "subtle",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtlest",
                            weight: "medium",
                            children: formatMessage((0, $7lL49.messages).ai_answer_expand_button_label)
                        })
                    })
                }) : null
            })
        ]
    });
});


















var $6aZ5T = parcelRequire("6aZ5T");


var $lhHcj = parcelRequire("lhHcj");

















const $28512a2c0bf4b799$export$40f705aca7f6b285 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ item: teamData, onClickCallback: onClickCallback })=>{
    const { commonAttributes: commonAttributes, userDetails: userDetails } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId, orgId: orgId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const team = teamData.team;
    const teamUrl = (0, $5iH4l.getTeamProfileUrl)(team.id.split('/').pop() || team.id, orgId);
    const handleTeamClick = (_e)=>{
        window.open(teamUrl, '_self', 'noopener, noreferrer');
    };
    const profileClient = (0, $42omo.useMemo)(()=>(0, $5iH4l.createProfileClient)(cloudId), [
        cloudId
    ]);
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $63654b9ac7fa44e6$export$79db6a77ac4a8ace)({
        elementType: 'team',
        hoverCardSelector: '[data-testid="team-profilecard"]'
    });
    if ((0, $dh538.fg)('ptc-enable-team-profilecard-package')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lhHcj.TeamProfileCardWithTrigger), {
        trigger: "hover",
        teamAri: team.id,
        cloudId: commonAttributes.cloudId,
        placement: "bottom-start",
        userId: userDetails.id,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            onMouseEnter: handleHoverStart,
            onMouseLeave: handleHoverLeave,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gUXWz.KnowledgeCardsRowRefresh), {
                primaryText: team.displayName,
                secondaryText: formatMessage((0, $7lL49.messages).knowledge_cards_team_member_count, {
                    count: teamData.memberCount
                }),
                pictureUrl: team.smallAvatarImageUrl,
                type: (0, $ckCUa.KnowledgeCardsRowType).AGENT,
                onClick: (e)=>{
                    onClickCallback?.();
                    handleTeamClick(e);
                }
            })
        })
    });
    if (!profileClient) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gUXWz.KnowledgeCardsRowRefresh), {
        primaryText: team.displayName,
        secondaryText: formatMessage((0, $7lL49.messages).knowledge_cards_team_member_count, {
            count: teamData.memberCount
        }),
        pictureUrl: team.smallAvatarImageUrl,
        type: (0, $ckCUa.KnowledgeCardsRowType).AGENT,
        onClick: (e)=>{
            onClickCallback?.();
            handleTeamClick(e);
        }
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6aZ5T.default), {
        trigger: "hover",
        teamId: team.id,
        cloudId: commonAttributes.cloudId,
        position: "bottom-start",
        viewProfileLink: teamUrl,
        resourceClient: profileClient,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            onMouseEnter: handleHoverStart,
            onMouseLeave: handleHoverLeave,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gUXWz.KnowledgeCardsRowRefresh), {
                primaryText: team.displayName,
                secondaryText: formatMessage((0, $7lL49.messages).knowledge_cards_team_member_count, {
                    count: teamData.memberCount
                }),
                pictureUrl: team.smallAvatarImageUrl,
                type: (0, $ckCUa.KnowledgeCardsRowType).AGENT,
                onClick: (e)=>{
                    onClickCallback?.();
                    handleTeamClick(e);
                }
            })
        })
    });
});


const $e58ef327a56d2ba7$export$e35364d8cf1f1804 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ currentUserId: _currentUserId, teamsData: teamsData, activityData: activityData, profileUrl: profileUrl, viewAllUrl: _viewAllUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleRecentWorkViewAllClick = (0, $42omo.useMemo)(()=>(_e)=>{
            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'recent-work-view-all'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED,
                commonAttributes: commonAttributes
            });
        }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    const handleAgentTeamsViewAllClick = (0, $42omo.useMemo)(()=>(_e)=>{
            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'agent-teams-view-all'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).TEAM_LIST_CLICKED,
                commonAttributes: commonAttributes
            });
        }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    // Determine which columns to render
    const hasRecentActivity = (0, $42omo.useMemo)(()=>activityData && Array.isArray(activityData) && activityData.length > 0, [
        activityData
    ]);
    const hasTeams = (0, $42omo.useMemo)(()=>teamsData?.teamSearch?.nodes && teamsData.teamSearch.nodes.length > 0, [
        teamsData?.teamSearch?.nodes
    ]);
    const columnsConfig = (0, $42omo.useMemo)(()=>[
            // Teams Column
            ...hasTeams && teamsData?.teamSearch?.nodes ? [
                {
                    viewAllLinkOnClick: handleAgentTeamsViewAllClick,
                    viewAllLinkHref: profileUrl,
                    data: teamsData.teamSearch.nodes,
                    component: (0, $28512a2c0bf4b799$export$40f705aca7f6b285),
                    header: formatMessage((0, $7lL49.messages).knowledge_cards_teams_subheader),
                    onClickCallback: (position, shownAfterCardBodyExpanded)=>{
                        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                            ...commonAttributes,
                            location: 'team-list-item',
                            position: position,
                            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
                        }));
                        fireSAINUsageEvent({
                            metCriteria: (0, $4jIuc.SainAction).TEAM_LIST_ITEM_CLICKED,
                            commonAttributes: commonAttributes
                        });
                    }
                }
            ] : [],
            // Recent Activity Column
            ...hasRecentActivity ? [
                {
                    viewAllLinkOnClick: handleRecentWorkViewAllClick,
                    viewAllLinkHref: profileUrl,
                    data: activityData,
                    component: (0, $7b4f6a684ec95ddb$export$65943680306d629),
                    header: formatMessage((0, $7lL49.messages).knowledge_cards_worked_on_subheader),
                    onClickCallback: (position, shownAfterCardBodyExpanded)=>{
                        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                            ...commonAttributes,
                            location: 'recent-work-item',
                            position: position,
                            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
                        }));
                        fireSAINUsageEvent({
                            metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED,
                            commonAttributes: commonAttributes
                        });
                    },
                    smartLinksAnalyticsContextLocation: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_AGENT_CARD
                }
            ] : []
        ], [
        hasTeams,
        teamsData?.teamSearch.nodes,
        handleAgentTeamsViewAllClick,
        profileUrl,
        formatMessage,
        hasRecentActivity,
        handleRecentWorkViewAllClick,
        activityData,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $96d38a1128ace4cb$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: profileUrl,
        footerButtonText: formatMessage((0, $7lL49.messages).knowledge_cards_view_agent),
        footerButtonAction: (0, $4jIuc.SainAction).VIEW_PROFILE_CLICKED,
        testId: "agent-card-body"
    });
});





parcelRequire("42omo");















var $i25hX = parcelRequire("i25hX");


var $iswAx = parcelRequire("iswAx");


var $ab1fW = parcelRequire("ab1fW");







/* knowledge-card-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













var $ldfch = parcelRequire("ldfch");
























const $cde523f011251e7a$var$HeaderWrapper = {
    default: "_19bvpxbi _u5f3pxbi"
};
const $cde523f011251e7a$var$PrimaryInfoWrapper = {
    default: "_1e0c1txw _1bsb1osq _4t3i1osq _2lx21bp4 _1bah1h6o"
};
const $cde523f011251e7a$var$HeaderActionsWrapper = {
    default: "_1o9zidpf _18u01wug"
};
const $cde523f011251e7a$export$c7c90b1402552129 = ({ name: name, email: email, profileUrl: profileUrl, profileLinkText: profileLinkText, media: media, orgText: orgText, additionalInfo: additionalInfo, onLinkClick: onLinkClick, headerActions: headerActions, testId: testId })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const emailTooltip = {
        position: 'bottom',
        content: formatMessage((0, $7lL49.messages).knowledge_cards_copy_email_address),
        hideTooltipOnClick: true
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        xcss: $cde523f011251e7a$var$HeaderWrapper.default,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                spread: "space-between",
                alignInline: "start",
                alignBlock: "center",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.200",
                    alignBlock: "center",
                    children: [
                        media,
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.100",
                            xcss: $cde523f011251e7a$var$PrimaryInfoWrapper.default,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "small",
                                    as: "h2",
                                    children: name
                                }),
                                orgText && orgText,
                                additionalInfo
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                xcss: $cde523f011251e7a$var$HeaderActionsWrapper.default,
                children: [
                    headerActions,
                    !!email && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldfch))), {
                                ...props,
                                color: "var(--ds-icon, #292A2E)"
                            }),
                        label: formatMessage((0, $7lL49.messages).ai_answer_who_questions_hover_email_icon),
                        onClick: ()=>{
                            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                                ...commonAttributes,
                                location: 'header-copy-email'
                            }));
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).COPY_CLICKED,
                                commonAttributes: commonAttributes
                            });
                            (0, $5iH4l.onEmailCopy)(email);
                        },
                        isTooltipDisabled: false,
                        tooltip: emailTooltip
                    }),
                    profileUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                        href: profileUrl,
                        onClick: (e)=>{
                            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                                ...commonAttributes,
                                location: 'header-view-profile'
                            }));
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).VIEW_PROFILE_CLICKED,
                                commonAttributes: commonAttributes
                            });
                            onLinkClick?.(e);
                        },
                        children: profileLinkText
                    })
                ]
            })
        ]
    });
};





const $874ff511a30bda15$export$162531e7c7ccb21f = ({ agent: agent })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId, orgId: orgId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const media = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
            agentId: agent.id,
            agentNamedId: agent.id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "xlarge"
        })
    });
    const additionalInfo = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtlest",
                maxLines: 2,
                children: agent.description
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    space: "space.025",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtlest",
                            children: formatMessage((0, $7lL49.messages).knowledge_cards_rovo_agent_by)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iswAx.AgentCreatedBy), {
                            agent: agent,
                            siteId: cloudId,
                            simplified: true
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cde523f011251e7a$export$c7c90b1402552129), {
        name: agent.name,
        profileUrl: (0, $5iH4l.getAgentProfileUrl)(agent, orgId),
        profileLinkText: formatMessage((0, $7lL49.messages).knowledge_cards_view_agent),
        media: media,
        additionalInfo: additionalInfo,
        testId: "agent-card-header",
        headerActions: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ab1fW.FollowUpButton), {
                followUpIndex: 0,
                followUpType: "agent",
                followUpText: "Chat to agent",
                experienceId: "sain",
                onClick: ()=>{
                    publish({
                        type: 'chat-new',
                        source: 'sain',
                        data: {
                            agentId: agent.id,
                            dialogues: [],
                            sourceId: commonAttributes.searchSessionId,
                            name: `Chat with ${agent.name}`
                        }
                    });
                }
            })
        })
    });
};

















const $23be2c3c8d7cac85$export$bfb683339256dc9e = 'KnowledgeCardAgentTeamsQuery';
const $23be2c3c8d7cac85$var$KNOWLEDGE_CARD_AGENT_TEAMS_QUERY = `
  query ${$23be2c3c8d7cac85$export$bfb683339256dc9e}(
    $first: Int,
    $after: String,
    $organizationId: ID!,
    $query: String = "",
    $memberIds: [ID] = [],
    $sortBy: [TeamSort],
    $siteId: String!,
    $showEmptyTeams: Boolean = false
  ) {
    team {
      teamSearch: teamSearchV2(
        first: $first
        after: $after
        organizationId: $organizationId
        filter: { query: $query, membership: { memberIds: $memberIds } }
        sortBy: $sortBy
        siteId: $siteId
        showEmptyTeams: $showEmptyTeams
      ) @optIn(to: ["Team-search-v2"]) {
        nodes {
          ...TeamNodeV2
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }

  fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			isVerified
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;
const $23be2c3c8d7cac85$export$76c925f889384cac = (agent)=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId, workspaceId: workspaceId, orgId: orgId } = commonAttributes;
    // Loading states
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [teamsLoading, setTeamsLoading] = (0, $42omo.useState)(false);
    const [activityLoading, setActivityLoading] = (0, $42omo.useState)(false);
    // Data states
    const [teamsData, setTeamsData] = (0, $42omo.useState)(null);
    const [activityData, setActivityData] = (0, $42omo.useState)(null);
    // Error states
    const [error, setError] = (0, $42omo.useState)(null);
    const [teamsError, setTeamsError] = (0, $42omo.useState)(null);
    const [activityError, setActivityError] = (0, $42omo.useState)(null);
    // Refetch counter to trigger refetches
    const [refetchCounter, setRefetchCounter] = (0, $42omo.useState)(0);
    // Fetch teams data
    const fetchTeamsData = (0, $42omo.useCallback)(async ()=>{
        if (!agent?.id || !cloudId) return;
        setTeamsLoading(true);
        setTeamsError(null);
        try {
            const response = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: $23be2c3c8d7cac85$var$KNOWLEDGE_CARD_AGENT_TEAMS_QUERY,
                variables: {
                    first: 12,
                    organizationId: `ari:cloud:platform::org/${orgId}`,
                    siteId: cloudId,
                    showEmptyTeams: true,
                    memberIds: [
                        agent.identity_account_id?.split('/').pop() || ''
                    ]
                },
                operationName: $23be2c3c8d7cac85$export$bfb683339256dc9e,
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: sourceProduct ?? ''
                })
            });
            const { data: data, errors: errors } = response;
            if (errors && errors.length > 0) throw new Error(errors.map((e)=>e.message).join(', '));
            if (data?.team) setTeamsData(data.team);
            else throw new Error('No teams data received');
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch teams data';
            setTeamsError(errorMessage);
            setError(errorMessage);
        } finally{
            setTeamsLoading(false);
        }
    }, [
        agent?.id,
        agent?.identity_account_id,
        cloudId,
        workspaceId,
        sourceProduct,
        orgId
    ]);
    const activityClient = (0, $e31DP.useActivityClient)('v3', 'people');
    // Fetch activity data
    const fetchActivityData = (0, $42omo.useCallback)(async ()=>{
        if (!agent?.identity_account_id) return;
        setActivityLoading(true);
        setActivityError(null);
        try {
            const activityData = await activityClient.fetchActivities([
                100
            ], {
                limit: 50,
                actors: [
                    agent.identity_account_id.startsWith('ari:cloud:identity::user/') ? agent.identity_account_id : `ari:cloud:identity::user/${agent.identity_account_id}`
                ]
            }, [
                'workedOn'
            ], false);
            setActivityData(activityData.workedOn);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch activity data';
            setActivityError(errorMessage);
            setError(errorMessage);
        } finally{
            setActivityLoading(false);
        }
    }, [
        agent?.identity_account_id,
        activityClient
    ]);
    // Combined loading state - true if either API is loading
    const combinedLoading = teamsLoading || activityLoading;
    // Refetch function
    const refetch = (0, $42omo.useCallback)(()=>{
        setRefetchCounter((prev)=>prev + 1);
    }, []);
    // Effect to fetch data when agent changes or refetch is triggered
    (0, $42omo.useEffect)(()=>{
        if (!agent?.id) {
            // Reset all states when no agent is provided
            setTeamsData(null);
            setActivityData(null);
            setTeamsError(null);
            setActivityError(null);
            setError(null);
            return;
        }
        // Reset error states when starting new fetch
        setError(null);
        // Fetch data conditionally based on available dependencies
        const fetchData = async ()=>{
            const promises = [];
            // Only fetch teams if we have the required data
            if (agent.identity_account_id && cloudId && orgId) promises.push(fetchTeamsData());
            // Only fetch activity if we have the required data
            if (agent.identity_account_id) promises.push(fetchActivityData());
            // Execute available fetches in parallel
            if (promises.length > 0) await Promise.all(promises);
        };
        fetchData();
    }, [
        agent?.id,
        agent?.identity_account_id,
        cloudId,
        orgId,
        fetchTeamsData,
        fetchActivityData,
        refetchCounter
    ]);
    // Update combined loading state
    (0, $42omo.useEffect)(()=>{
        setLoading(combinedLoading);
    }, [
        combinedLoading
    ]);
    return {
        loading: loading,
        teamsLoading: teamsLoading,
        activityLoading: activityLoading,
        teamsData: teamsData,
        activityData: activityData,
        error: error,
        teamsError: teamsError,
        activityError: activityError,
        refetch: refetch
    };
};


const $8176bf10f680ba0f$var$CardContainerStyles = {
    refresh: "_2rko12b0 _zulppxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _n3tdpxbi",
    disclaimer: "_19bvpxbi _u5f3pxbi"
};
const $8176bf10f680ba0f$var$AgentCardWrapperStyles = {
    wrapper: "_2rko1mok _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _i0dlmgvx _16jlidpf _1o9zidpf _1bsbmgvx _1ul91lit _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _kqswh2mm _o5724jg8 _9oik1r31 _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
const $8176bf10f680ba0f$var$AGENTS_SCROLL_OFFSET = 392;
const $8176bf10f680ba0f$var$messages = (0, $cgtv4.defineMessages)({
    multiple_agents_matches_header: {
        id: "search_ai.knowledge_cards.multiple_agents_matches_header",
        defaultMessage: "Agent matches"
    }
});
const $8176bf10f680ba0f$var$IndividualAgentKnowledgeCard = ({ agent: agent })=>{
    const { teamsData: teamsData, activityData: activityData, loading: loading } = (0, $23be2c3c8d7cac85$export$76c925f889384cac)(agent);
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { orgId: orgId } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)(); // Fire analytics event when individual agent knowledge card is shown
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (agent) fireAnalyticsEvent((0, $fJBWn.onIndividualAgentKnowledgeCardShown)({
            ...commonAttributes,
            agentId: agent.id
        }));
    }, [
        agent,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    if (!agent) return null;
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bb7252f08ce189c0$export$a08238eb59773648), {
        queryIntent: (0, $f7lNm.QueryIntent).AGENT
    });
    const showKnowledgeCardBody = teamsData?.teamSearch?.nodes && teamsData.teamSearch.nodes.length > 0 || activityData && Array.isArray(activityData) && activityData.length > 0;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $8176bf10f680ba0f$var$CardContainerStyles.refresh,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $874ff511a30bda15$export$162531e7c7ccb21f), {
                    agent: agent
                }),
                showKnowledgeCardBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $65205934451f1233$export$4fb305a2fc986af3), {}),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        showKnowledgeCardBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $e58ef327a56d2ba7$export$e35364d8cf1f1804), {
                            currentUserId: agent.identity_account_id || '',
                            teamsData: teamsData,
                            activityData: activityData,
                            profileUrl: (0, $5iH4l.getAgentProfileUrl)(agent, orgId)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $8176bf10f680ba0f$var$CardContainerStyles.disclaimer,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                                showFeedbackButtons: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $8176bf10f680ba0f$export$f3d65ac3e9ec58cd = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, loading: loading, userDetails: userDetails } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [selectedAgent, setSelectedAgent] = (0, $42omo.useState)();
    const { answerString: answerString } = commonAttributes; // Parses the answerString to extract agent results, returning an empty array if parsing fails or if the result is not an array.
    const agentResults = (0, $42omo.useMemo)(()=>{
        if (!answerString) return [];
        try {
            const parsed = JSON.parse(answerString);
            return Array.isArray(parsed) ? parsed : [];
        } catch  {
            return [];
        }
    }, [
        answerString
    ]); // Fire analytics event when carousel is shown (only when multiple agents exist)
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (agentResults && agentResults.length > 1) fireAnalyticsEvent((0, $fJBWn.onAgentKnowledgeCardCarouselShown)({
            ...commonAttributes,
            agentCount: agentResults.length
        }));
    }, [
        agentResults,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    const profileClient = (0, $42omo.useMemo)(()=>(0, $5iH4l.createProfileClient)(cloudId), [
        cloudId
    ]);
    const getHandleSelectAgent = (0, $42omo.useCallback)((index)=>()=>{
            const selectedAgentData = agentResults[index];
            setSelectedAgent(selectedAgentData); // Fire analytics event for carousel item click
            fireAnalyticsEvent((0, $fJBWn.onAgentKnowledgeCardCarouselItemClick)({
                ...commonAttributes,
                agentId: selectedAgentData.id,
                position: index
            }));
        }, [
        agentResults,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (agentResults.length === 1) setSelectedAgent(agentResults[0]);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agentResults
    ]);
    (0, $42omo.useEffect)(()=>{
        onFMPReached?.();
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardShown)({
            ...commonAttributes,
            cardType: (0, $ckCUa.KnowledgeCardsIntentType).AGENT
        })); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $63654b9ac7fa44e6$export$79db6a77ac4a8ace)({
        elementType: 'agent',
        hoverCardSelector: '[data-testid="agent-knowledge-card-trigger"]'
    });
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bb7252f08ce189c0$export$a08238eb59773648), {});
    if (agentResults.length === 0) return null;
    if (selectedAgent !== undefined || agentResults.length === 1) return /*#__PURE__*/ (0, $l998X.jsx)($8176bf10f680ba0f$var$IndividualAgentKnowledgeCard, {
        agent: selectedAgent
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.150",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d44aca612cf62bf3$export$61c045a5252abd1d), {
                heading: formatMessage($8176bf10f680ba0f$var$messages.multiple_agents_matches_header),
                scrollOffset: $8176bf10f680ba0f$var$AGENTS_SCROLL_OFFSET,
                children: agentResults.map((agent, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        onClick: getHandleSelectAgent(index),
                        testId: "agent-knowledge-card-wrapper",
                        xcss: $8176bf10f680ba0f$var$AgentCardWrapperStyles.wrapper,
                        onMouseEnter: handleHoverStart,
                        onMouseLeave: handleHoverLeave,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fid2I.AgentProfileCardTrigger), {
                            trigger: "hover",
                            agentId: agent.id,
                            resourceClient: profileClient,
                            cloudId: cloudId,
                            viewingUserId: userDetails.id,
                            testId: "agent-knowledge-card-trigger",
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                space: "space.150",
                                alignInline: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
                                        agentId: agent.id,
                                        agentNamedId: agent.id,
                                        agentIdentityAccountId: agent.identity_account_id,
                                        size: "xxlarge"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                        space: "space.100",
                                        alignInline: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                maxLines: 1,
                                                size: "medium",
                                                weight: "medium",
                                                align: "center",
                                                children: agent.name
                                            }),
                                            agent.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                maxLines: 1,
                                                size: "medium",
                                                color: "color.text.subtlest",
                                                align: "center",
                                                children: agent.description
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, agent.id))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                showFeedbackButtons: true
            })
        ]
    });
};



/* person-knowledge-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 























/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");







const $2e1f41273e93e29c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    scrollLeft: {
        id: "horizontal-scroll-container.scroll-left",
        defaultMessage: "Scroll left"
    },
    scrollRight: {
        id: "horizontal-scroll-container.scroll-right",
        defaultMessage: "Scroll right"
    }
});


const $9c7756fe8b395d80$var$atlaskitCssStyles = {
    containerStyles: "_1e0c1txw _kqswh2mm _4cvr1h6o",
    hoverButtonStyle: "_kqswstnw _1pby1nn1 _80omtlke _4t3i1osq _1e0c1txw _4cvr1h6o"
};
const $9c7756fe8b395d80$var$leftStyle = null;
const $9c7756fe8b395d80$var$rightStyle = null;
const $9c7756fe8b395d80$var$scrollContainerStyle = null;
const $9c7756fe8b395d80$var$OFFSET = 250;
const $9c7756fe8b395d80$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $9c7756fe8b395d80$var$isScrollAtRight = (elem)=>elem ? // https://stackoverflow.com/questions/3898130/check-if-a-user-has-scrolled-to-the-bottom-not-just-the-window-but-any-element
    Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $9c7756fe8b395d80$export$8e346a7c6ff89602 = ({ children: children })=>{
    const ref = (0, $42omo.useRef)(null);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [shouldHideLeft, setShouldHideLeft] = (0, $42omo.useState)(false);
    const [shouldHideRight, setShouldHideRight] = (0, $42omo.useState)(false);
    const [onScroll] = (0, $lvsjl.default)(()=>{
        setShouldHideLeft($9c7756fe8b395d80$var$isScrollAtLeft(ref.current));
        setShouldHideRight($9c7756fe8b395d80$var$isScrollAtRight(ref.current));
    }, 10);
    (0, $42omo.useEffect)(()=>{
        setShouldHideLeft($9c7756fe8b395d80$var$isScrollAtLeft(ref.current));
        setShouldHideRight($9c7756fe8b395d80$var$isScrollAtRight(ref.current));
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $9c7756fe8b395d80$var$atlaskitCssStyles.containerStyles,
        children: [
            !shouldHideLeft && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $9c7756fe8b395d80$var$atlaskitCssStyles.hoverButtonStyle,
                    "_11q75v77 _1ltvidpf _1qn1u2gc"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    shape: "circle",
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                            ...iconProps,
                            size: "small"
                        }),
                    isTooltipDisabled: true,
                    label: formatMessage((0, $2e1f41273e93e29c$export$defe85febe8b728c).scrollLeft),
                    onClick: ()=>{
                        ref.current?.scrollBy({
                            top: 0,
                            left: -$9c7756fe8b395d80$var$OFFSET,
                            behavior: 'smooth'
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: ref,
                onScroll: onScroll,
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1ul91ob8 _1e0c1txw _1reo1wug _18m915vq"
                ]),
                children: children
            }),
            !shouldHideRight && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $9c7756fe8b395d80$var$atlaskitCssStyles.hoverButtonStyle,
                    "_11q7165o _1xi2idpf _1bcru2gc"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    shape: "circle",
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                            ...iconProps,
                            size: "small"
                        }),
                    isTooltipDisabled: true,
                    label: formatMessage((0, $2e1f41273e93e29c$export$defe85febe8b728c).scrollRight),
                    onClick: ()=>{
                        ref.current?.scrollBy({
                            top: 0,
                            left: $9c7756fe8b395d80$var$OFFSET,
                            behavior: 'smooth'
                        });
                    }
                })
            })
        ]
    });
};



var $2YIh2 = parcelRequire("2YIh2");




















































































var $9uTsJ = parcelRequire("9uTsJ");















var $6aPlH = parcelRequire("6aPlH");




const $80904ce075c98085$export$87f3c1fc8ab2e681 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ item: user, onClickCallback: onClickCallback })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { toUser: toUser } = (0, $6aPlH.useTeamsAppLinks)({
        type: (0, $ckCUa.KnowledgeCardsIntentType).PERSON,
        currentUserId: user.accountId || '',
        cloudId: commonAttributes.cloudId
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const userUrl = `/people/${(0, $5iH4l.trimARI)(user.accountId || '')}`;
    const handleUserClick = (e)=>{
        if ((0, $dh538.fg)('platform-adopt-teams-nav-config')) toUser(user.accountId || '').onNavigate(e);
        else window.open(user.url || userUrl, '_self', 'noopener, noreferrer');
    };
    const profileClient = (0, $42omo.useMemo)(()=>(0, $5iH4l.createProfileClient)(commonAttributes.cloudId), [
        commonAttributes.cloudId
    ]);
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $63654b9ac7fa44e6$export$79db6a77ac4a8ace)({
        elementType: 'collaborator',
        hoverCardSelector: '[data-testid="profilecard"]'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9uTsJ.default), {
        userId: (0, $5iH4l.trimARI)(user.accountId || ''),
        resourceClient: profileClient,
        actions: [
            {
                label: formatMessage((0, $7lL49.messages).knowledge_cards_person_hover_profile_link),
                link: toUser(user.accountId || '').href,
                callback: (e)=>{
                    onClickCallback?.();
                    toUser(user.accountId || '').onNavigate(e);
                }
            }
        ],
        ariaLabel: user.name,
        position: "bottom-end",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            onMouseEnter: handleHoverStart,
            onMouseLeave: handleHoverLeave,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gUXWz.KnowledgeCardsRowRefresh), {
                primaryText: user.name,
                secondaryText: !!user.title || !!user.department ? [
                    user.title,
                    user.department
                ].filter((str)=>!!str).join(', ') : '',
                pictureUrl: user.picture || '',
                type: (0, $ckCUa.KnowledgeCardsRowType).PERSON,
                onClick: (e)=>{
                    onClickCallback?.();
                    handleUserClick(e);
                }
            })
        })
    });
});








const $6dbe17f3dfb7fa03$export$2460aa15a0a1d61e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ currentUserId: currentUserId, recommendedUsers: recommendedUsers, recentActivity: recentActivity, profileUrl: profileUrl, viewAllUrl: viewAllUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { viewAllLink: viewAllLink, viewAllOnNavigate: viewAllOnNavigate, worksWithHref: worksWithHref, worksWithOnNavigate: worksWithOnNavigate, profileHref: profileHref } = (0, $6aPlH.useTeamsAppLinks)({
        type: (0, $ckCUa.KnowledgeCardsIntentType).PERSON,
        currentUserId: currentUserId,
        viewAllUrl: viewAllUrl,
        cloudId: commonAttributes.cloudId
    });
    const handleRecentWorkViewAllClick = (e)=>{
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-view-all'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
        if ((0, $dh538.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    const handleCollaboratorsViewAllClick = (e)=>{
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'reporting-lines-link'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).REPORTING_LINES_CLICKED,
            commonAttributes: commonAttributes
        });
        if ((0, $dh538.fg)('platform-adopt-teams-nav-config')) worksWithOnNavigate(e);
    };
    const columnsConfig = [
        // Recent Activity Column
        ...recentActivity.length > 0 ? [
            {
                viewAllLinkOnClick: handleRecentWorkViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recentActivity,
                component: (0, $7b4f6a684ec95ddb$export$65943680306d629),
                header: formatMessage((0, $7lL49.messages).knowledge_cards_recent_work_subheader),
                onClickCallback: (position, shownAfterCardBodyExpanded)=>{
                    fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'recent-work-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                smartLinksAnalyticsContextLocation: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_PERSON_CARD
            }
        ] : [],
        // Recommended Users Column
        ...recommendedUsers.length > 0 ? [
            {
                viewAllLinkOnClick: handleCollaboratorsViewAllClick,
                viewAllLinkHref: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? worksWithHref : `https://hello.atlassian.net/people/${currentUserId || ''}#workswith`,
                data: recommendedUsers,
                component: (0, $80904ce075c98085$export$87f3c1fc8ab2e681),
                onClickCallback: (position, shownAfterCardBodyExpanded)=>{
                    fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'user-list-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $4jIuc.SainAction).COLLABORATOR_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                header: formatMessage((0, $7lL49.messages).knowledge_cards_collaborators_subheader)
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $96d38a1128ace4cb$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl,
        footerButtonText: formatMessage((0, $7lL49.messages).ai_answer_who_questions_view_profile),
        footerButtonAction: (0, $4jIuc.SainAction).VIEW_PROFILE_CLICKED,
        testId: "person-knowledge-card-body"
    });
});


/* person-card-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $7O0l1 = parcelRequire("7O0l1");


var $kPml2 = parcelRequire("kPml2");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");












var $6qyeX = parcelRequire("6qyeX");


















var $39EIK = parcelRequire("39EIK");


var $81TN7 = parcelRequire("81TN7");







const $81b6a36686aa9c71$var$ORG_CHART_DWELL_THRESHOLD = 3000;
const $81b6a36686aa9c71$var$IconPaddingStyles = {
    default: "_u5f31b66 _19bv1b66"
};
const $81b6a36686aa9c71$export$d1ac32de8e31f333 = ({ name: name, accountId: accountId, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { cloudId: cloudId, sessionId: sessionId } = commonAttributes;
    const showAITopics = (0, $dh538.fg)('kd_topics_in_person_card');
    const { profileHref: profileHref, profileOnNavigate: profileOnNavigate } = (0, $6aPlH.useTeamsAppLinks)({
        type: (0, $ckCUa.KnowledgeCardsIntentType).PERSON,
        currentUserId: accountId ?? '',
        cloudId: cloudId
    });
    const [isOrgChartModalOpen, setIsOrgChartModalOpen] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        let dwellTimeout;
        if (isOrgChartModalOpen) dwellTimeout = setTimeout(()=>{
            fireAnalyticsEvent((0, $fJBWn.onPersonCardOrgChartDwelled)(commonAttributes));
        }, $81b6a36686aa9c71$var$ORG_CHART_DWELL_THRESHOLD);
        return ()=>{
            clearTimeout(dwellTimeout);
        };
    }, [
        isOrgChartModalOpen,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const subText = [
        jobTitle,
        department
    ].filter((text)=>!!text).join(', ');
    const trimmedSubText = subText.length > 250 ? `${subText.slice(0, 250)}...` : subText;
    const orgText = /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        color: "color.text.subtlest",
        children: trimmedSubText
    });
    const timeAndLocationComponent = (location || time) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $81b6a36686aa9c71$var$IconPaddingStyles.default,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kPml2))), {
                    label: ""
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "medium",
                color: "color.text.subtlest",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    children: [
                        location && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: location
                        }),
                        time && location && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: "\u2022"
                        }),
                        time && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: time
                        })
                    ]
                })
            })
        ]
    });
    const additionalInfo = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            timeAndLocationComponent,
            showAITopics && /*#__PURE__*/ (0, $l998X.jsx)((0, $39EIK.KnowledgeCardsTopics), {
                cloudId: cloudId,
                userId: accountId ?? '',
                userName: name,
                sessionId: sessionId,
                v2styles: true
            })
        ]
    });
    const media = /*#__PURE__*/ (0, $l998X.jsx)((0, $81TN7.KnowledgeCardsPicture), {
        src: avatarUrl || '',
        alt: ""
    });
    const handleLinkClick = (e)=>{
        if ((0, $dh538.fg)('platform-adopt-teams-nav-config')) profileOnNavigate(e);
    };
    const openOrgChartModal = ()=>{
        setIsOrgChartModalOpen(true);
        fireAnalyticsEvent((0, $fJBWn.onPersonCardOrgChartShown)(commonAttributes));
    };
    const closeOrgChartModal = ()=>setIsOrgChartModalOpen(false);
    const orgChartButton = ((0, $01aV7.isHello)(cloudId) || (0, $dh538.fg)('kd_person_card_org_chart_button')) && accountId ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7O0l1))),
        label: formatMessage((0, $7lL49.messages).knowledge_cards_person_org_chart_label),
        isTooltipDisabled: false,
        onClick: openOrgChartModal,
        testId: "person-card-org-chart-button"
    }) : null;
    const ClickWrapper = ({ children: children, userId: userId })=>// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $l998X.jsx)("div", {
            onClick: ()=>{
                fireAnalyticsEvent((0, $fJBWn.onPersonCardOrgChartCardClicked)(commonAttributes));
            },
            children: children
        }, `${userId}-org-chart-card`);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cde523f011251e7a$export$c7c90b1402552129), {
                name: name,
                email: email,
                profileUrl: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
                profileLinkText: formatMessage((0, $7lL49.messages).ai_answer_who_questions_view_profile),
                media: media,
                orgText: orgText,
                additionalInfo: additionalInfo,
                onLinkClick: handleLinkClick,
                headerActions: orgChartButton,
                testId: "person-knowledge-card-header"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: accountId && isOrgChartModalOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
                    onClose: closeOrgChartModal,
                    testId: "person-card-org-chart-modal",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                children: formatMessage((0, $7lL49.messages).knowledge_cards_person_org_chart_modal_header)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6qyeX.default), {
                                userId: accountId,
                                product: "personKnowledgeCardOrgChart",
                                WrappedWithProfilecard: ClickWrapper
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                    ]
                })
            })
        ]
    });
};


const $87d080fba1bc83df$var$ScrollableContainerStyles = {
    default: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _otyru2gc _1e0c1txw"
};
const $87d080fba1bc83df$var$CardContainerStyles = {
    default: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
    refresh: "_2rko12b0 _zulppxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _n3tdpxbi",
    disclaimer: "_19bvpxbi _u5f3pxbi"
};
const $87d080fba1bc83df$var$PersonCardWrapperStyles = {
    default: "_1bsbmgvx _1bto1l2s _o5724jg8",
    flex: "_i0dlmgvx _16jlidpf _1o9zidpf"
};
const $87d080fba1bc83df$var$USERS_SCROLL_OFFSET = 392;
const $87d080fba1bc83df$var$messages = (0, $cgtv4.defineMessages)({
    multiple_people_matches_header: {
        id: "search_ai.knowledge_cards.multiple_people_matches_header",
        defaultMessage: "People matches"
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    }
});
const $87d080fba1bc83df$var$IndividualPersonKnowledgeCard = ({ primaryUser: primaryUser })=>{
    if (!primaryUser) return null;
    const showKnowledgeCardBody = (primaryUser?.recentActivity?.length || 0) > 0 || (primaryUser?.collaborators?.length || 0) > 0;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $87d080fba1bc83df$var$CardContainerStyles.refresh,
            testId: "individual-person-knowledge-card",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $81b6a36686aa9c71$export$d1ac32de8e31f333), {
                    accountId: primaryUser.account_id,
                    name: primaryUser.name,
                    email: primaryUser.email,
                    avatarUrl: primaryUser.avatar_url,
                    profileUrl: primaryUser.profile_url,
                    jobTitle: primaryUser.job_title,
                    department: primaryUser.department,
                    location: primaryUser.location,
                    time: primaryUser.time
                }),
                showKnowledgeCardBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $65205934451f1233$export$4fb305a2fc986af3), {}),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        showKnowledgeCardBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $6dbe17f3dfb7fa03$export$2460aa15a0a1d61e), {
                            currentUserId: primaryUser.account_id ?? '',
                            recommendedUsers: primaryUser.collaborators || [],
                            recentActivity: primaryUser.recentActivity || [],
                            profileUrl: primaryUser.profile_url || ''
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $87d080fba1bc83df$var$CardContainerStyles.disclaimer,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                                showFeedbackButtons: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $87d080fba1bc83df$export$8cdcd522f66fdfa8 = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, userDetails: { id: requestingUserId }, setData: setData, sourceProduct: sourceProduct, loading: loading, traceHeaders: traceHeaders } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const activityClient = (0, $e31DP.useActivityClient)('v3', 'people');
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [selectedUser, setSelectedUser] = (0, $42omo.useState)();
    const [primaryUser, setPrimaryUser] = (0, $42omo.useState)();
    const { answerString: answerString, cloudId: cloudId, workspaceId: workspaceId } = commonAttributes;
    const [isPersonCardLoading, setIsPersonCardLoading] = (0, $42omo.useState)(false);
    const userResults = (0, $c97be5ff4a9e42e9$export$d905ae2a714518e8)({
        answerString: answerString
    }).parsedResult;
    const ScrollWrapper = userResults.length > 3 ? (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9c7756fe8b395d80$export$8e346a7c6ff89602), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $87d080fba1bc83df$var$ScrollableContainerStyles.default,
                children: props.children
            })
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const getHandleSelectUser = (0, $42omo.useCallback)((index)=>()=>{
            setSelectedUser(index);
            if ((0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).PERSON_SELECTED,
                commonAttributes: commonAttributes
            });
        }, [
        commonAttributes,
        fireSAINUsageEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (userResults.length === 1) setSelectedUser(0);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userResults
    ]);
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            if (selectedUser !== undefined) {
                setIsPersonCardLoading(true);
                return (0, $95de468340d80197$export$3e632a26e137d79e)({
                    accountId: userResults[selectedUser].id,
                    tenantId: cloudId,
                    requestingUserId: requestingUserId || '',
                    activityClient: activityClient,
                    locale: locale,
                    workspaceId: workspaceId,
                    product: sourceProduct ?? '',
                    traceHeaders: traceHeaders
                }).then((data)=>{
                    setPrimaryUser(data);
                }).catch((error)=>{
                    setData({
                        errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                        disclaimer: null,
                        format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                    if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
                        error: error,
                        functionName: 'fetchPrimaryUserData: PersonKnowledgeCard'
                    });
                }).finally(()=>{
                    setIsPersonCardLoading(false);
                });
            }
        };
        fetchData(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedUser
    ]);
    (0, $42omo.useEffect)(()=>{
        onFMPReached?.();
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardShown)({
            ...commonAttributes,
            cardType: (0, $ckCUa.KnowledgeCardsIntentType).PERSON
        })); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (loading || isPersonCardLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bb7252f08ce189c0$export$a08238eb59773648), {});
    if (userResults.length === 0) return null;
    if (selectedUser !== undefined || userResults.length === 1) return /*#__PURE__*/ (0, $l998X.jsx)($87d080fba1bc83df$var$IndividualPersonKnowledgeCard, {
        primaryUser: primaryUser
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: (0, $dh538.fg)('kd_smart_answers_update_person_carousel') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $d44aca612cf62bf3$export$61c045a5252abd1d), {
                    heading: formatMessage($87d080fba1bc83df$var$messages.multiple_people_matches_header),
                    scrollOffset: $87d080fba1bc83df$var$USERS_SCROLL_OFFSET,
                    children: userResults.map((user, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            onClick: getHandleSelectUser(index),
                            xcss: (0, $1Whri.cx)($87d080fba1bc83df$var$PersonCardWrapperStyles.default, $87d080fba1bc83df$var$PersonCardWrapperStyles.flex),
                            testId: "person-knowledge-card-wrapper",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2YIh2.PersonCard), {
                                data: {
                                    id: user.id,
                                    name: user.name,
                                    jobTitle: user.title ?? '',
                                    avatarUrl: user.avatarUrl,
                                    localTime: (0, $5iH4l.formatTimeKnowledgeCard)({
                                        locale: locale,
                                        zoneInfo: user.zoneInfo
                                    }),
                                    location: user.location ?? ''
                                }
                            })
                        }, user.id))
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                    showFeedbackButtons: true
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(ScrollWrapper, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        space: "space.200",
                        children: userResults.map((user, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                onClick: getHandleSelectUser(index),
                                xcss: $87d080fba1bc83df$var$PersonCardWrapperStyles.default,
                                testId: "person-knowledge-card-wrapper",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2YIh2.PersonCard), {
                                    data: {
                                        id: user.id,
                                        name: user.name,
                                        jobTitle: user.title ?? '',
                                        avatarUrl: user.avatarUrl,
                                        localTime: (0, $5iH4l.formatTimeKnowledgeCard)({
                                            locale: locale,
                                            zoneInfo: user.zoneInfo
                                        }),
                                        location: user.location ?? ''
                                    }
                                })
                            }, user.id))
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                    showFeedbackButtons: true
                })
            ]
        })
    });
};


/* team-knowledge-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $aoVih = parcelRequire("aoVih");




















// Taken from https://gist.github.com/keesey/e09d0af833476385b9ee13b6d26a2b84 to avoid adding a package dependency for a single static function
function $543b523bba0606c4$var$getEditDistance(a, b) {
    const an = a ? a.length : 0;
    const bn = b ? b.length : 0;
    if (an === 0) return bn;
    if (bn === 0) return an;
    const matrix = new Array(bn + 1);
    for(let i = 0; i <= bn; ++i){
        let row = matrix[i] = new Array(an + 1);
        row[0] = i;
    }
    const firstRow = matrix[0];
    for(let j = 1; j <= an; ++j)firstRow[j] = j;
    for(let i = 1; i <= bn; ++i){
        for(let j = 1; j <= an; ++j)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1], matrix[i][j - 1], matrix[i - 1][j]) + 1;
    }
    return matrix[bn][an];
}
const $543b523bba0606c4$export$ebacab8290144e11 = (query, teamName)=>{
    return $543b523bba0606c4$var$getEditDistance(query, teamName) / query.length;
};













































const $74c535a007a750ca$export$21ff1f39b993b08e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ currentUserId: currentUserId, recommendedUsers: recommendedUsers, recentActivity: recentActivity, profileUrl: profileUrl, viewAllUrl: viewAllUrl, teamId: teamId })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { viewAllLink: viewAllLink, viewAllOnNavigate: viewAllOnNavigate, profileHref: profileHref } = (0, $6aPlH.useTeamsAppLinks)({
        type: (0, $ckCUa.KnowledgeCardsIntentType).TEAM,
        currentUserId: currentUserId,
        viewAllUrl: viewAllUrl,
        cloudId: commonAttributes.cloudId,
        teamId: teamId
    });
    const handleRecentWorkViewAllClick = (e)=>{
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-view-all'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
        if ((0, $dh538.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    const handleTeamMembersViewAllClick = (e)=>{
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'team-members-view-all'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).TEAM_MEMBER_CLICKED,
            commonAttributes: commonAttributes
        });
        if ((0, $dh538.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    // Determine which columns to render
    const hasRecentActivity = recentActivity.length > 0;
    const hasTeamMembers = recommendedUsers.length > 0;
    const columnsConfig = [
        // Recent Activity Column
        ...hasRecentActivity ? [
            {
                viewAllLinkOnClick: handleRecentWorkViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recentActivity,
                component: (0, $7b4f6a684ec95ddb$export$65943680306d629),
                header: formatMessage((0, $7lL49.messages).knowledge_cards_recent_work_subheader),
                onClickCallback: (position, shownAfterCardBodyExpanded)=>{
                    fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'recent-work-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                smartLinksAnalyticsContextLocation: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_TEAM_CARD
            }
        ] : [],
        // Team Members Column
        ...hasTeamMembers ? [
            {
                viewAllLinkOnClick: handleTeamMembersViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recommendedUsers,
                component: (0, $80904ce075c98085$export$87f3c1fc8ab2e681),
                onClickCallback: (position, shownAfterCardBodyExpanded)=>{
                    fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'user-list-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $4jIuc.SainAction).TEAM_MEMBER_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                header: formatMessage((0, $7lL49.messages).knowledge_cards_team_members_subheader)
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $96d38a1128ace4cb$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl,
        footerButtonText: formatMessage((0, $7lL49.messages).knowledge_cards_view_team),
        footerButtonAction: (0, $4jIuc.SainAction).VIEW_TEAM_PAGE_CLICKED,
        testId: 'team-knowledge-card-body'
    });
});


/* team-card-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


















var $alaek = parcelRequire("alaek");














const $18dd3147ab1a4221$var$styles = {
    orgIcon: "_u5f31b66 _19bv1b66"
};
const $18dd3147ab1a4221$export$972f15901814fb3d = ({ name: name, accountId: accountId, email: email, avatarUrl: avatarUrl, teamId: teamId, profileUrl: profileUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = commonAttributes;
    const { profileHref: profileHref, profileOnNavigate: profileOnNavigate } = (0, $6aPlH.useTeamsAppLinks)({
        type: (0, $ckCUa.KnowledgeCardsIntentType).TEAM,
        currentUserId: accountId ?? '',
        cloudId: cloudId,
        teamId: teamId
    });
    const media = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $alaek.default), {
            size: "xlarge",
            src: avatarUrl || undefined,
            name: name
        })
    });
    const orgText = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $18dd3147ab1a4221$var$styles.orgIcon,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7O0l1))), {
                    label: ""
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtlest",
                children: formatMessage((0, $7lL49.messages).knowledge_cards_team_subheader)
            })
        ]
    });
    const handleLinkClick = (e)=>{
        if ((0, $dh538.fg)('platform-adopt-teams-nav-config')) profileOnNavigate(e);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cde523f011251e7a$export$c7c90b1402552129), {
        name: name,
        email: email,
        profileUrl: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
        profileLinkText: formatMessage((0, $7lL49.messages).knowledge_cards_view_team),
        media: media,
        orgText: orgText,
        onLinkClick: handleLinkClick,
        testId: 'team-knowledge-card-header'
    });
};


const $217f267d537298d5$var$CardContainerStyles = {
    default: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
    refresh: "_2rko12b0 _zulppxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _n3tdpxbi",
    disclaimer: "_19bvpxbi _u5f3pxbi"
};
const $217f267d537298d5$export$224d36db19d00a29 = /*#__PURE__*/ (0, $42omo.memo)(({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, userDetails: { id: currentUserId } } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { answerString: answerString, query: query } = commonAttributes;
    const data = (0, $c97be5ff4a9e42e9$export$d905ae2a714518e8)({
        answerString: answerString
    }).parsedResult;
    const editDistanceRatio = (0, $543b523bba0606c4$export$ebacab8290144e11)(query, data.name);
    (0, $42omo.useEffect)(()=>{
        if (data.id) {
            onFMPReached?.();
            fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardShown)({
                ...commonAttributes,
                cardType: (0, $ckCUa.KnowledgeCardsIntentType).TEAM,
                extraAttributes: {
                    editDistance: editDistanceRatio
                }
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const showKnowledgeCardBody = (data.recentActivity?.length || 0) > 0 || (data.members?.length || 0) > 0;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.200",
        children: [
            (0, $dh538.fg)('enable_team_site_assignment') && /*#__PURE__*/ (0, $l998X.jsxs)((0, $aoVih.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $7lL49.messages).ai_answer_dialog_teams_not_found_message
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                        href: "https://support.atlassian.com/platform-experiences/docs/understanding-team-visibility/",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $7lL49.messages).ai_answer_dialog_teams_not_found_message_link
                        })
                    })
                ]
            }),
            data.id ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                xcss: $217f267d537298d5$var$CardContainerStyles.refresh,
                testId: "team-knowledge-card",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $18dd3147ab1a4221$export$972f15901814fb3d), {
                        name: data.name,
                        avatarUrl: data.avatarUrl,
                        profileUrl: data.url,
                        teamId: data.id
                    }),
                    showKnowledgeCardBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $65205934451f1233$export$4fb305a2fc986af3), {}),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        children: [
                            showKnowledgeCardBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $74c535a007a750ca$export$21ff1f39b993b08e), {
                                currentUserId: currentUserId || '',
                                recentActivity: data.recentActivity,
                                recommendedUsers: data.members,
                                viewAllUrl: data.url || '',
                                teamId: data.id
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $217f267d537298d5$var$CardContainerStyles.disclaimer,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                                    showFeedbackButtons: true
                                })
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
});


const $1b0a370bd67241fc$export$ab2444a256fc8a9b = ({ onFMPReached: onFMPReached })=>{
    const { isAnswered: isAnswered, hasError: hasError, smartAnswersRoute: smartAnswersRoute, loading: loading, commonAttributes: commonAttributes, baseQuery: baseQuery } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId, brand: brand, searchSessionId: searchSessionId, workspaceId: workspaceId, sourceProduct: sourceProduct, query: query } = commonAttributes;
    // Jira NL to JQL Card doesn't populate the context with hasError, isAnswered so we use a separate condition
    if (smartAnswersRoute === (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY) return /*#__PURE__*/ (0, $l998X.jsx)((0, $8bdd0346cf0b7eb0$export$ba6b7dafd54d334), {
        title: query,
        query: baseQuery ?? '',
        cloudId: cloudId,
        aiBrand: brand,
        searchSessionId: searchSessionId,
        workspaceId: workspaceId,
        product: sourceProduct ?? '',
        onFMPReached: onFMPReached
    });
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bb7252f08ce189c0$export$a08238eb59773648), {
        queryIntent: smartAnswersRoute
    });
    if (isAnswered && !hasError) switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).TEAM:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $217f267d537298d5$export$224d36db19d00a29), {
                onFMPReached: onFMPReached
            });
        case (0, $f7lNm.QueryIntent).PERSON:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $87d080fba1bc83df$export$8cdcd522f66fdfa8), {
                onFMPReached: onFMPReached
            });
        case (0, $f7lNm.QueryIntent).TOPIC:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gt6aY.TopicKnowledgeCard), {
                onFMPReached: onFMPReached
            });
        case (0, $f7lNm.QueryIntent).AGENT:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8176bf10f680ba0f$export$f3d65ac3e9ec58cd), {
                onFMPReached: onFMPReached
            });
        case (0, $f7lNm.QueryIntent).ORG_CHART:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $87d080fba1bc83df$export$8cdcd522f66fdfa8), {
                onFMPReached: onFMPReached
            });
        default:
            return null;
    }
    return null;
};





/* smart-answer-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $fwDOR = parcelRequire("fwDOR");








































/* streaming-early-stop-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 










































var $df7ed = parcelRequire("df7ed");







const $30fab9b241e9e86b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    ai_answer_card_collapse_button: {
        id: "search_ai.ai_answer_card_collapse_button",
        defaultMessage: "Collapse"
    },
    ai_answer_card_expand_button: {
        id: "search_ai.ai_answer_card_expand_button",
        defaultMessage: "Expand"
    },
    ai_answer_card_tab_ai_answer: {
        id: "search_ai.ai_answer_card_tab_ai_answer",
        defaultMessage: "AI Answer"
    },
    ai_answer_card_tab_sources: {
        id: "search_ai.ai_answer_card_tab_sources",
        defaultMessage: "Sources"
    },
    ai_answer_card_tab_sources_with_pluralization: {
        id: "search_ai.ai_answer_card_tab_sources_with_pluralization",
        defaultMessage: "{sourcesCount, plural, one {Source} other {Sources {sourcesCount}}}"
    },
    ai_answer_card_read_more_button: {
        id: "search_ai.ai_answer_card_read_more_button",
        defaultMessage: "Read more"
    },
    ai_answer_card_show_more_button: {
        id: "search_ai.ai_answer_card_show_more_button",
        defaultMessage: "Show more"
    },
    ai_answer_open_chat_input_box_ask_rovo: {
        id: "search_ai.ai_answer_open_chat_input_box_ask_rovo",
        defaultMessage: "Ask Rovo anything"
    },
    ai_answer_card_early_stop_text: {
        id: "search_ai.ai_answer_card_early_stop_text",
        defaultMessage: "Rovo couldn't generate an answer for \"{searchQuery}\". Try rephrasing your query."
    },
    ai_answer_card_early_stop_close_button_label: {
        id: "search_ai.ai_answer_card_early_stop_close_button",
        defaultMessage: "Close"
    }
});


const $6c81a6c460861b6e$var$styles = {
    root: "_1bsb1osq",
    onlineDebuggerButtonContainer: "_18u01wug _1bsb1ns9"
};
const $6c81a6c460861b6e$export$97b52c363fbe053e = ()=>{
    const [dismissed, setDismissed] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { baseQuery: baseQuery, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        const cachedAnswer = (0, $epS7s.getSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY)); // Only fire analytics event once per cached answer
        if (cachedAnswer) {
            (0, $epS7s.deleteSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY));
            fireAnalyticsEvent((0, $4xTru.onStreamingEarlyStopCardShown)(commonAttributes));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dismissCard = (0, $42omo.useCallback)(()=>{
        setDismissed(true);
        fireAnalyticsEvent((0, $4xTru.onStreamingEarlyStopCardDismissed)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const showOnlineDebuggerButton = (0, $dh538.fg)('kd_sain_online_debugger');
    if (dismissed) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $df7ed.KnowledgeCard), {
        name: "sain-streaming-early-stop-card",
        size: "full",
        testId: "sain-streaming-early-stop-card",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            xcss: $6c81a6c460861b6e$var$styles.root,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "bold",
                            children: formatMessage((0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_early_stop_text, {
                                searchQuery: baseQuery
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                            label: formatMessage((0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_early_stop_close_button_label),
                            onClick: dismissCard,
                            appearance: "subtle",
                            spacing: "compact",
                            testId: "sain-early-stop-error-card-dismiss-button"
                        })
                    ]
                }),
                showOnlineDebuggerButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $6c81a6c460861b6e$var$styles.onlineDebuggerButtonContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jTYav.OnlineDebuggerButton), {})
                })
            ]
        })
    });
};


/* definition-error.tsx generated by @compiled/babel-plugin v0.36.1 */ 






















var $1s5hv = parcelRequire("1s5hv");










const $f444507c1ee2a540$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $f444507c1ee2a540$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $f444507c1ee2a540$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $f444507c1ee2a540$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $f444507c1ee2a540$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $f444507c1ee2a540$export$d04cd98bb7625919 = 'customfield_10047';
const $f444507c1ee2a540$export$dd6343c56092a345 = '3655ce1d-16b8-4630-9e93-6c39069625fa';





parcelRequire("42omo");





var $aD1SW = parcelRequire("aD1SW");

var $6uGcC = parcelRequire("6uGcC");


var $3sFtD = parcelRequire("3sFtD");




const $710a59a2e41f348f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    edit_definition_modal_header_edit: {
        id: "search_ai.edit_definition_modal_header_edit",
        defaultMessage: "Edit definition"
    },
    edit_definition_modal_header_create: {
        id: "search_ai.edit_definition_modal_header_create",
        defaultMessage: "Add a definition"
    },
    edit_definition_modal_subheader_text: {
        id: "search_ai.edit_definition_modal_subheader_text",
        defaultMessage: "You can edit definitions to help teammates better understand terms."
    },
    edit_definition_modal_subheader_link_text: {
        id: "search_ai.edit_definition_modal_subheader_link_text",
        defaultMessage: "More on editing definitions"
    },
    edit_definition_text_box_label: {
        id: "search_ai.edit_definition_text_box_label",
        defaultMessage: "Definition"
    },
    edit_definition_text_box_label_with_count: {
        id: "search_ai.edit_definition_text_box_label_with_count",
        defaultMessage: "Edit definition, {count} of {max} characters used. Start typing to enter text."
    },
    edit_definition_no_definition: {
        id: "search_ai.edit_definition_no_definition",
        defaultMessage: "Enter definition"
    },
    edit_definition_over_max_length: {
        id: "search_ai.edit_definition_over_max_length",
        defaultMessage: "Definition must be {max} characters or fewer."
    },
    edit_definition_source_label: {
        id: "search_ai.edit_definition_source_label",
        defaultMessage: "Source"
    },
    edit_definition_add_source_label: {
        id: "search_ai.edit_definition_add_source_label",
        defaultMessage: "Add a source (optional)"
    },
    edit_definition_restricted_to_label: {
        id: "search_ai.edit_definition_restricted_to_label",
        defaultMessage: "Show this definition"
    },
    edit_definition_restricted_to_space_subline: {
        id: "search_ai.edit_definition_restricted_to_space_subline",
        defaultMessage: "Previous definition will still show in other spaces."
    },
    edit_definition_restricted_to_site_subline: {
        id: "search_ai.edit_definition_restricted_to_site_subline",
        defaultMessage: "Previous definition will still show on other sites."
    },
    edit_definition_restricted_to_project_subline: {
        id: "search_ai.edit_definition_restricted_to_project_subline",
        defaultMessage: "Previous definition will still show in other projects."
    },
    edit_definition_restricted_to_page_subline: {
        id: "search_ai.edit_definition_restricted_to_page_subline",
        defaultMessage: "Previous definition will still show on other pages."
    },
    edit_definition_restricted_to_blogpost_subline: {
        id: "search_ai.edit_definition_restricted_to_blogpost_subline",
        defaultMessage: "Previous definition will still show on other blogposts."
    },
    edit_definition_source_search_box_placeholder: {
        id: "search_ai.edit_definition_source_search_box_placeholder",
        defaultMessage: "Search or paste a Confluence link"
    },
    edit_definition_back_button: {
        id: "search_ai.edit_definition_back_button",
        defaultMessage: "Back"
    },
    edit_definition_update_button: {
        id: "search_ai.edit_definition_update_button",
        defaultMessage: "Update"
    },
    edit_definition_source_option_metadata_updated_text: {
        id: "search_ai.edit_definition_source_option_metadata_updated_text",
        defaultMessage: "Updated"
    },
    edit_definition_update_confirmation_title: {
        id: "search_ai.edit_definition_update_confirmation_title",
        defaultMessage: "Definition updated \uD83C\uDF89"
    },
    edit_definition_update_confirmation_description: {
        id: "search_ai.edit_definition_update_confirmation_description",
        defaultMessage: "You've made work clearer for your teammates."
    },
    edit_definition_restricted_to_project_subline_galaxia: {
        id: "search_ai.edit_definition_restricted_to_project_subline-galaxia",
        defaultMessage: "Previous definition will still show in other spaces."
    }
});


const $d3ceefd4d089bcb8$export$7475d9ffda76c69b = ({ onDismissed: onDismissed, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        onDismissed: ()=>onDismissed(),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
            id: "definition-update-success-adflag",
            title: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_update_confirmation_title),
            description: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_update_confirmation_description),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: "Success",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            testId: testId
        })
    });
};


/* edit-definition-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $igBZP = parcelRequire("igBZP");











var $bfgIy = parcelRequire("bfgIy");


var $a3fRD = parcelRequire("a3fRD");

























var $7p2SJ = parcelRequire("7p2SJ");

var $6T8v4 = parcelRequire("6T8v4");











var $9pwVP = parcelRequire("9pwVP");


var $xhg8G = parcelRequire("xhg8G");


var $9KkVf = parcelRequire("9KkVf");








var $e6Iiv = parcelRequire("e6Iiv");


var $auTg8 = parcelRequire("auTg8");


var $gVoWJ = parcelRequire("gVoWJ");


var $1JdaQ = parcelRequire("1JdaQ");


var $aRZzN = parcelRequire("aRZzN");


var $aUwPP = parcelRequire("aUwPP");


var $5HHoF = parcelRequire("5HHoF");


var $1KHo7 = parcelRequire("1KHo7");





var $b7FrM = parcelRequire("b7FrM");


var $6eZqW = parcelRequire("6eZqW");







const $131be2c19d5d7968$export$3b4150834edadf59 = (query)=>{
    const pageOrBlogRegex = /spaces\/.*\/(pages|blog)/;
    const spaceRegex = /https:\/\/[^\/]+\/wiki\/spaces\/(?!.*\/(pages|blog)).*/;
    // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    const confluenceTinyRegex = RegExp("\\/wiki\\/x\\/(?<resourceId>[^\\/(?)]+)$");
    const queryParts = query.split('/');
    const queryParamsRemoved = query.split('?')[0];
    if (query.match(pageOrBlogRegex)) // e.g. https://hello.atlassian.net/wiki/spaces/AAI/pages/3665fakeId/Test+Page+Title
    return {
        searchQuery: queryParts[queryParts.length - 1],
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined
    };
    else if (query.match(spaceRegex)) {
        // e.g. https://hello.atlassian.net/wiki/spaces/SK1/overview
        const spacesIndex = queryParts.indexOf('spaces');
        return {
            searchQuery: '',
            entities: [
                'ati:cloud:confluence:space'
            ],
            spacesFilter: [
                spacesIndex > -1 ? queryParts[spacesIndex + 1] : ''
            ]
        };
    } else if (queryParamsRemoved.match(confluenceTinyRegex)) // e.g. https://hello.atlassian.net/wiki/x/4c942w
    return {
        searchQuery: '',
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined,
        needsLinkResolution: true
    };
    return {
        searchQuery: query,
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost',
            'ati:cloud:confluence:space'
        ],
        spacesFilter: undefined
    };
};
const $131be2c19d5d7968$export$248ff3a730ef0924 = ({ selectedScope: selectedScope, productScopes: productScopes, cloudId: cloudId })=>{
    let contentARI = '';
    let spaceARI = '';
    let projectARI = '';
    if ('contentARI' in productScopes) {
        contentARI = productScopes.contentARI;
        spaceARI = productScopes.spaceARI;
    }
    if ('projectARI' in productScopes) projectARI = productScopes.projectARI;
    switch(selectedScope){
        case (0, $9KkVf.EditedDefinitionScope).PAGE:
        case (0, $9KkVf.EditedDefinitionScope).BLOGPOST:
            return contentARI;
        case (0, $9KkVf.EditedDefinitionScope).SPACE:
            return spaceARI;
        case (0, $9KkVf.EditedDefinitionScope).PROJECT:
            return projectARI;
        default:
            return cloudId;
    }
};
const $131be2c19d5d7968$export$40e11c80593ec8d4 = (definitionDetails)=>{
    const definitionReferenceDetails = definitionDetails.confluenceEntity;
    return {
        nlpResult: definitionDetails.definition,
        uniqueSources: definitionDetails.confluenceEntity ? [
            {
                id: definitionReferenceDetails?.id || '',
                title: definitionReferenceDetails?.title || '',
                url: definitionDetails.referenceUrl || '',
                type: definitionReferenceDetails?.type || '',
                // for now we only allow users to add a source from Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReferenceDetails?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: {
            name: definitionDetails.editor?.name || '',
            id: definitionDetails.editor?.accountId || ''
        },
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
    };
};
const $131be2c19d5d7968$export$7f32babab6e8c339 = (str)=>{
    return str.replace(/[\u200c]/g, '');
};


const $b874189e677abb1d$export$18a9461578883ec4 = ({ value: value, setValue: setValue, setCharCount: setCharCount, assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy })=>{
    const { preset: preset } = (0, $1JdaQ.usePreset)(()=>(0, $gVoWJ.createDefaultPreset)({
            allowUndoRedoButtons: true,
            textFormatting: {
                responsiveToolbarMenu: true
            }
        }).add((0, $aUwPP.indentationPlugin)).add((0, $5HHoF.listPlugin)).add([
            (0, $1KHo7.toolbarListsIndentationPlugin),
            {
                showIndentationButtons: true,
                allowHeadingAndParagraphIndentation: false
            }
        ]), []);
    const adfEncoder = (0, $42omo.useMemo)(()=>new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $aRZzN.MarkdownTransformer)(schema)), []);
    const initializeEditor = (0, $42omo.useCallback)((actions)=>{
        const encodedValue = adfEncoder.encode(value);
        actions.replaceDocument(encodedValue);
    }, [
        value,
        adfEncoder
    ]);
    const onEditorChange = (0, $42omo.useCallback)((editorView)=>{
        const { markdown: markdown } = (0, $6eZqW.convertProsemirrorToMarkdown)({
            editorView: editorView,
            fragment: editorView.state.doc.content
        });
        // ? Editor component seems to add invisible characters in certain cases. Using this function to remove them and set back to the definition state.
        const markdownWithoutInvisibleChars = (0, $131be2c19d5d7968$export$7f32babab6e8c339)(markdown);
        setValue(markdownWithoutInvisibleChars);
        setCharCount?.(markdownWithoutInvisibleChars.length);
    }, [
        setValue,
        setCharCount
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auTg8.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e6Iiv.ComposableEditor), {
                    appearance: "comment",
                    preset: preset,
                    shouldFocus: true,
                    quickInsert: false,
                    minHeight: 170,
                    maxHeight: 90,
                    onEditorReady: initializeEditor,
                    onChange: onEditorChange,
                    assistiveLabel: assistiveLabel,
                    assistiveDescribedBy: assistiveDescribedBy
                })
            })
        })
    });
};



/* radial-progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 








// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34a7854a5a3a66c0$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});
const $34a7854a5a3a66c0$var$CanvasWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1bsbuuw1 _4t3iuuw1 _154i17hu _1ltv17hu _t9ec185q",
            __cmplp.className
        ])
    });
});
const $34a7854a5a3a66c0$export$a4badf890ec26dc0 = ({ current: current, max: max })=>{
    const canvasRef = (0, $42omo.useRef)(null);
    // Draw the current circle progress bar
    (0, $42omo.useEffect)(()=>{
        const ctx = canvasRef.current?.getContext('2d');
        if (ctx) {
            if (current >= max) {
                ctx.beginPath();
                ctx.strokeStyle = '#E91618';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
            } else {
                ctx.beginPath();
                ctx.strokeStyle = '#DCDFE4';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
                ctx.beginPath();
                ctx.strokeStyle = '#22A06B';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, -0.5 * Math.PI, 2 * Math.PI * (current / max) - 0.5 * Math.PI);
                ctx.stroke();
            }
        }
    }, [
        current,
        max
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($34a7854a5a3a66c0$var$Wrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)($34a7854a5a3a66c0$var$CanvasWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)("canvas", {
                ref: canvasRef,
                height: 200,
                width: 200
            })
        })
    });
};


/* restriction-option-formatter.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






const $543a21d2965741c7$var$styles = {
    optionWrapper: "_11c8fhey _syazi7uo"
};
const $543a21d2965741c7$export$66608c4e05327916 = (option)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $543a21d2965741c7$var$styles.optionWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100",
            children: [
                option.icon,
                option.label
            ]
        })
    });
};


/* source-option-formatter.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $lE8sM = parcelRequire("lE8sM");


var $bueVT = parcelRequire("bueVT");


var $5yCDo = parcelRequire("5yCDo");





var $cHaKZ = parcelRequire("cHaKZ");












const $8705ac0bd6b28f92$var$styles = {
    sourceOptionWrapper: "_zulputpp _1e0c1txw _4cvr1h6o _1bah1yb4 _vchhusvi _80omtlke _irr319i6 _d0altlke",
    sourceOptionTitle: "_11c8fhey _syazi7uo",
    sourceOptionMetadata: "_11c8wadc _1e0c1txw _syaz1rpy",
    sourceOptionMetatadataSeparator: "_18u01b66 _2hwx1b66",
    sourceImageContainer: "_4t3i1tcg _1bsb1tcg"
};
const $8705ac0bd6b28f92$var$SourceSpaceImage = ({ source: source })=>{
    return source.iconUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $8705ac0bd6b28f92$var$styles.sourceImageContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
            src: source.iconUrl,
            alt: ""
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: "",
        appearance: "blueBold",
        shape: "square",
        size: "24"
    });
};
const $8705ac0bd6b28f92$export$bd0bc6e060a5a86f = ({ source: source, canClear: canClear, onClickSource: onClickSource, onRemoveSource: onRemoveSource })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $8C5kA.default)();
    let sourceIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $5yCDo.default), {
        label: ""
    });
    if (source.type === 'space') sourceIcon = /*#__PURE__*/ (0, $l998X.jsx)($8705ac0bd6b28f92$var$SourceSpaceImage, {
        source: source
    });
    else if (source.type === 'blogpost') sourceIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $bueVT.default), {
        label: ""
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $8705ac0bd6b28f92$var$styles.sourceOptionWrapper,
        onClick: onClickSource,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                alignItems: "center",
                gap: "space.150",
                children: [
                    sourceIcon,
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $8705ac0bd6b28f92$var$styles.sourceOptionTitle,
                                children: source.title
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                xcss: $8705ac0bd6b28f92$var$styles.sourceOptionMetadata,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: source.container
                                    }),
                                    source.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $8705ac0bd6b28f92$var$styles.sourceOptionMetatadataSeparator,
                                        children: `\u{2022}`
                                    }),
                                    source.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: `${formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_source_option_metadata_updated_text)} ${formatDate(source.lastModified, {
                                            year: 'numeric',
                                            month: 'short',
                                            day: '2-digit'
                                        })}`
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            canClear ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                testId: `remove-source-${source.id}`,
                appearance: "subtle",
                onClick: onRemoveSource,
                label: "remove-source-option-button",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev)))
            }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {})
        ]
    });
};

















const $c7ce0372232aad14$export$41f2c817c42b2303 = `
	mutation CreateDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$editedDefinition: String!
		$scope: KnowledgeDiscoveryDefinitionScope!
		$entityIdInScope: String!
		$referenceContentId: String
		$referenceUrl: String
		) {
		knowledgeDiscovery {
			createDefinition(
				input: {
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				definition: $editedDefinition
				scope: $scope
				entityIdInScope: $entityIdInScope
				referenceContentId: $referenceContentId
				referenceUrl: $referenceUrl
				}
			) @optIn(to: "KnowledgeDiscovery Create definition") {
			success
			errors {
				message
			}
			definitionDetails {
				keyPhrase
				definition
				editor {
					... on User {
						name
						accountId
					}
				}
				referenceUrl
				confluenceEntity {
					... on ConfluencePage {
					id
					type
					title
					space {
						name
					}
					}
					... on ConfluenceBlogPost {
					id
					type
					title
					space {
						name
					}
					}
				}
			}
		}
	}
  }
`;



const $219b0f3f8b8a9b06$export$4c5c8822f1a42b9f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    const createDefinition = (0, $42omo.useCallback)(async ({ keyPhrase: keyPhrase, editedDefinition: editedDefinition, scope: scope, referenceContentId: referenceContentId, referenceUrl: referenceUrl })=>{
        const { cloudId: cloudId } = commonAttributes;
        const { workspaceId: workspaceId, productScopes: productScopes } = curatedDefinitionScopeConfig;
        const entityIdInScope = (0, $131be2c19d5d7968$export$248ff3a730ef0924)({
            selectedScope: scope,
            cloudId: cloudId,
            productScopes: productScopes
        });
        // check needed to account for Spaces being added as sources and submitted
        const contentId = 'contentARI' in productScopes && referenceContentId === entityIdInScope ? productScopes.contentARI : referenceContentId;
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $c7ce0372232aad14$export$41f2c817c42b2303),
            variables: {
                workspaceId: workspaceId || '',
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: scope,
                entityIdInScope: entityIdInScope,
                referenceContentId: contentId,
                referenceUrl: referenceUrl
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.createDefinition?.success) {
                const definitionDetails = response.data.knowledgeDiscovery.createDefinition.definitionDetails;
                return definitionDetails && (0, $131be2c19d5d7968$export$40e11c80593ec8d4)(definitionDetails) || {
                    nlpResult: '',
                    format: (0, $7Zbm6.NLPSearchResultFormat).PLAINTEXT,
                    uniqueSources: [],
                    errorState: null,
                    disclaimer: null
                };
            } else throw new Error('createDefinition mutation unsuccessful');
        });
    }, [
        commonAttributes,
        curatedDefinitionScopeConfig,
        sourceProduct
    ]);
    return {
        createDefinition: createDefinition
    };
};















var $4lrdQ = parcelRequire("4lrdQ");

const $51ed168a8de3aa85$export$beaccb66a6ac7cc5 = `
	query ReadingAidsReferenceSearchQuery(
			$experience: String!
			$analytics: SearchAnalyticsInput
			$query: String!
			$filters: SearchFilterInput!
			$first: Int
		) {
		search {
			results: search(
				experience: $experience
				analytics: $analytics
				query: $query
				filters: $filters
				first: $first
			) {
				edges {
					node {
						type
						id
						title
						url
						iconUrl
						... on SearchConfluencePageBlogAttachment {
							lastModified
							space {
								name
							}
						}
						... on SearchConfluenceSpace {
							id
							title
							url
						}
					}
				}
			}
		}
	}
`;



const $8ba66724c9ef875b$var$OBJECT_RESOLVE_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $8ba66724c9ef875b$export$11c4e3b6769b440d = ()=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId, extraAttributes: extraAttributes, workspaceId: workspaceId } = commonAttributes;
    const { readingAidsSessionId: readingAidsSessionId } = extraAttributes;
    const searchSources = (0, $42omo.useCallback)(async (query)=>{
        const { searchQuery: searchQuery, entities: entities, spacesFilter: spacesFilter, needsLinkResolution: needsLinkResolution } = (0, $131be2c19d5d7968$export$3b4150834edadf59)(query);
        let details;
        if (needsLinkResolution) details = await (0, $4lrdQ.fetchRestResponse)({
            url: $8ba66724c9ef875b$var$OBJECT_RESOLVE_ENDPOINT,
            body: [
                {
                    resourceUrl: query.split('?')[0]
                }
            ]
        });
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $51ed168a8de3aa85$export$beaccb66a6ac7cc5),
            variables: {
                experience: 'curated-definition-source-search',
                analytics: {
                    searchSessionId: readingAidsSessionId
                },
                query: details?.[0]?.body?.data?.name ?? searchQuery,
                filters: {
                    entities: entities,
                    locations: [
                        cloudId ? `ari:cloud:confluence::site/${cloudId}` : ''
                    ],
                    confluenceFilters: {
                        titleMatchOnly: true,
                        spacesFilter: spacesFilter
                    }
                },
                first: 5
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            })
        }).then((response)=>{
            if (response.data) return response.data.search.results.edges.map((edge)=>({
                    id: edge.node?.id || '',
                    type: edge.node?.type || '',
                    title: edge.node?.title || '',
                    container: edge.node?.space?.name || '',
                    url: edge.node?.url || '',
                    iconUrl: edge.node?.iconUrl || '',
                    lastModified: edge.node?.lastModified || ''
                }));
            return [];
        });
    }, [
        cloudId,
        readingAidsSessionId,
        workspaceId,
        sourceProduct
    ]);
    return {
        searchSources: searchSources
    };
};


const $0b273c023ce36571$var$MAX_DEFINITION_LENGTH = 500;
const $0b273c023ce36571$var$editDefintionModalStyles = {
    editDefinitionTextboxLabelContainer: "_85i51b66",
    editDefinitionTextboxErrorMessageContainer: "_1q511b66",
    radialProgressBarContainer: "_85i5v77o",
    restrictionSelectSublineContainer: "_1q511b66"
};
const $0b273c023ce36571$export$ea8c8594ad1f3bf3 = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, closeEditModal: closeEditModal, openFeedbackOptionsModal: openFeedbackOptionsModal, isCreateDefinition: isCreateDefinition, onSaveEditModal: onSaveEditModal })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, setData: setData, answerEditor: answerEditor, additionalQueryContext: additionalQueryContext } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, query: keyPhrase } = commonAttributes;
    const [editedDefinition, setEditedDefinition] = (0, $42omo.useState)(answerString);
    const [charCount, setCharCount] = (0, $42omo.useState)(0);
    const emptyDefinition = editedDefinition.trim() === '';
    const definitionOverMaxLength = charCount > $0b273c023ce36571$var$MAX_DEFINITION_LENGTH;
    const updateDefinitionDisabled = emptyDefinition || definitionOverMaxLength;
    const [sourceSearchInput, setSourceSearchInput] = (0, $42omo.useState)('');
    const [source, setSource] = (0, $42omo.useState)(null);
    const { definitionRestrictionOptions: definitionRestrictionOptions } = curatedDefinitionScopeConfig;
    const defaultRestrictionOption = definitionRestrictionOptions[0];
    const [audienceRestriction, setAudienceRestriction] = (0, $42omo.useState)(defaultRestrictionOption.value);
    const [updateDefinitionLoading, setUpdateDefinitionLoading] = (0, $42omo.useState)(false);
    const setDefinition = (0, $42omo.useCallback)((value)=>{
        setEditedDefinition(value);
    }, [
        setEditedDefinition
    ]);
    const { searchSources: searchSources } = (0, $8ba66724c9ef875b$export$11c4e3b6769b440d)();
    const onSourceSearchInputChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') setSourceSearchInput(input);
    };
    const onSelectSource = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setSource(newValue);
    };
    const onSelectRestrictionOption = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setAudienceRestriction(newValue?.value || (0, $9KkVf.EditedDefinitionScope).ORGANIZATION);
    };
    const { createDefinition: createDefinition } = (0, $219b0f3f8b8a9b06$export$4c5c8822f1a42b9f)({
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const onUpdateDefinition = async ()=>{
        setUpdateDefinitionLoading(true);
        try {
            const updatedDefinition = await createDefinition({
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: audienceRestriction,
                referenceContentId: source ? source.id : null,
                referenceUrl: source ? source.url : null
            });
            setUpdateDefinitionLoading(false);
            setSource(null);
            fireAnalyticsEvent((0, $9pwVP.onCuratedDefinitionUpdateButtonClicked)({
                commonAttributes: commonAttributes,
                newDefinition: editedDefinition,
                restrictedScope: audienceRestriction,
                sourceSelected: !!source,
                aiDefinitionEdited: !!!answerEditor
            }));
            setData(updatedDefinition);
            (0, $epS7s.setSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                query: keyPhrase,
                additionalContext: additionalQueryContext || '',
                data: updatedDefinition
            }));
            closeEditModal();
            onSaveEditModal?.();
        } catch (error) {
            fireAnalyticsEvent((0, $xhg8G.updateDefinitionErrorPayload)(error, commonAttributes));
            setUpdateDefinitionLoading(false);
        }
    };
    let conditionalSublineMessage;
    switch(audienceRestriction){
        case (0, $9KkVf.EditedDefinitionScope).SPACE:
            conditionalSublineMessage = (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_space_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).PROJECT:
            conditionalSublineMessage = (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_project_subline_galaxia : (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_project_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).PAGE:
            conditionalSublineMessage = (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_page_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).BLOGPOST:
            conditionalSublineMessage = (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_space_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).ORGANIZATION:
            conditionalSublineMessage = (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_site_subline;
            break;
        default:
            conditionalSublineMessage = (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_site_subline;
            break;
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
        onClose: closeEditModal,
        shouldScrollInViewport: true,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                    children: formatMessage(isCreateDefinition ? (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_modal_header_create : (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_modal_header_edit)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                            as: "p",
                            color: "color.text.subtle",
                            children: [
                                formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_modal_subheader_text),
                                ' ',
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: "https://support.atlassian.com/rovo/docs/add-or-edit-a-definition/",
                                    children: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_modal_subheader_link_text)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                        alignBlock: "center",
                                        grow: "fill",
                                        spread: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $0b273c023ce36571$var$editDefintionModalStyles.editDefinitionTextboxLabelContainer,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtle",
                                                    weight: "bold",
                                                    size: "small",
                                                    children: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_text_box_label)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                                alignBlock: "center",
                                                space: "space.075",
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                                        as: "span",
                                                        size: "small",
                                                        color: "color.text.subtle",
                                                        children: [
                                                            charCount,
                                                            "/",
                                                            $0b273c023ce36571$var$MAX_DEFINITION_LENGTH
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                        xcss: $0b273c023ce36571$var$editDefintionModalStyles.radialProgressBarContainer,
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $34a7854a5a3a66c0$export$a4badf890ec26dc0), {
                                                            current: charCount,
                                                            max: $0b273c023ce36571$var$MAX_DEFINITION_LENGTH
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $b874189e677abb1d$export$18a9461578883ec4), {
                                    value: editedDefinition,
                                    setValue: setDefinition,
                                    setCharCount: setCharCount,
                                    assistiveLabel: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_text_box_label_with_count, {
                                        count: charCount,
                                        max: $0b273c023ce36571$var$MAX_DEFINITION_LENGTH
                                    }),
                                    assistiveDescribedBy: "edit-definition-text-box-error-message"
                                }),
                                updateDefinitionDisabled && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    alignBlock: "center",
                                    space: "space.050",
                                    xcss: $0b273c023ce36571$var$editDefintionModalStyles.editDefinitionTextboxErrorMessageContainer,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                            label: "",
                                            color: "var(--ds-text-danger, #AE2E24)",
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            color: "color.text.danger",
                                            size: "small",
                                            id: "edit-definition-text-box-error-message",
                                            children: emptyDefinition ? formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_no_definition) : formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_over_max_length, {
                                                max: $0b273c023ce36571$var$MAX_DEFINITION_LENGTH
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                                    htmlFor: "edit-definition-source-select",
                                    children: formatMessage(source ? (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_source_label : (0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_add_source_label)
                                }),
                                source ? /*#__PURE__*/ (0, $l998X.jsx)((0, $8705ac0bd6b28f92$export$bd0bc6e060a5a86f), {
                                    source: source,
                                    onClickSource: ()=>{
                                        window.open(source.url, '_blank')?.focus();
                                    },
                                    canClear: true,
                                    onRemoveSource: (e)=>{
                                        e.stopPropagation();
                                        setSource(null);
                                    }
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $7p2SJ.default), {
                                    components: {
                                        DropdownIndicator: ()=>null
                                    },
                                    loadOptions: (0, (/*@__PURE__*/$parcel$interopDefault($igBZP)))((input)=>searchSources(input), 500),
                                    formatOptionLabel: (sourceOption)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $8705ac0bd6b28f92$export$bd0bc6e060a5a86f), {
                                            source: sourceOption,
                                            canClear: false
                                        }),
                                    onChange: onSelectSource,
                                    inputValue: sourceSearchInput,
                                    onInputChange: onSourceSearchInputChange,
                                    placeholder: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_source_search_box_placeholder),
                                    menuPosition: "fixed",
                                    inputId: "edit-definition-source-select"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                                    htmlFor: "edit-definition-restriction-select",
                                    children: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_restricted_to_label)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                    options: definitionRestrictionOptions,
                                    defaultValue: defaultRestrictionOption,
                                    onChange: onSelectRestrictionOption,
                                    formatOptionLabel: (0, $543a21d2965741c7$export$66608c4e05327916),
                                    isSearchable: false,
                                    menuPosition: "fixed",
                                    inputId: "edit-definition-restriction-select",
                                    descriptionId: "edit-definition-restriction-subline"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $0b273c023ce36571$var$editDefintionModalStyles.restrictionSelectSublineContainer,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.subtle",
                                        size: "small",
                                        children: formatMessage(conditionalSublineMessage)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                children: [
                    openFeedbackOptionsModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: ()=>{
                            closeEditModal();
                            openFeedbackOptionsModal();
                        },
                        children: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_back_button)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: updateDefinitionDisabled ? 'default' : 'primary',
                        isLoading: updateDefinitionLoading,
                        onClick: onUpdateDefinition,
                        isDisabled: updateDefinitionDisabled,
                        children: formatMessage((0, $710a59a2e41f348f$export$defe85febe8b728c).edit_definition_update_button)
                    })
                ]
            })
        ]
    });
};





const $3d203e0ef15a161e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    definition_no_answer_error: {
        id: "search_ai.definition_no_answer_error",
        defaultMessage: "{brand} doesn\u2019t have enough data to provide a definition right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base."
    },
    definition_no_answer_acceptable_use_error: {
        id: "search_ai.definition_no_answer_acceptable_use_error",
        defaultMessage: "{brand} can\u2019t provide you with a definition, as it might go against {acceptableUseLink}"
    },
    definition_no_answer_acceptable_use_link: {
        id: "search_ai.definition_no_answer_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    definition_no_answer_network_error: {
        id: "search_ai.definition_no_answer_network_error",
        defaultMessage: "{brand} can't provide a definition right now. Read more in our {supportLink}"
    },
    definitions_support_link_text: {
        id: "search_ai.definitions_support_link_text",
        defaultMessage: "support documentation"
    },
    definition_no_answer_add_definition_button: {
        id: "search_ai.definition_no_answer_add_definition_button",
        defaultMessage: "Add definition"
    },
    definitions_no_answer_error_state_hipaa: {
        id: "search_ai.definitions_no_answer_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    definitions_no_answer_hipaa_compliance_link: {
        id: "search_ai.definitions_no_answer_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    }
});


const $351ba46eec5db167$var$styles = {
    errorPadding: "_n3tdu2gc",
    errorMessage: "_11c8fhey _syazi7uo"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $351ba46eec5db167$var$InfoLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz1ap6",
            __cmplp.className
        ])
    });
});
const $351ba46eec5db167$export$f874592093e19f27 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { brand: brand, commonAttributes: { errorState: errorState }, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const createDefinitionEnabled = !!definitionCurationOptions;
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $42omo.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $42omo.useState)(false);
    const showAddDefinitionButton = createDefinitionEnabled && (errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswer || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerHydration || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerRelevantContent || errorState === (0, $7Zbm6.NLPSearchErrorState).Default);
    const errorMessage = (0, $42omo.useMemo)(()=>{
        switch(errorState){
            case (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $3d203e0ef15a161e$export$defe85febe8b728c).definition_no_answer_acceptable_use_error,
                    values: {
                        acceptableUseLink: /*#__PURE__*/ (0, $l998X.jsx)($351ba46eec5db167$var$InfoLink, {
                            href: (0, $f444507c1ee2a540$export$96cc4126cdc27248),
                            target: '_blank',
                            children: formatMessage((0, $3d203e0ef15a161e$export$defe85febe8b728c).definition_no_answer_acceptable_use_link)
                        }),
                        brand: brand === (0, $f7lNm.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NetworkError:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $7Zbm6.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $3d203e0ef15a161e$export$defe85febe8b728c).definition_no_answer_network_error,
                    values: {
                        brand: brand === (0, $f7lNm.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo',
                        supportLink: /*#__PURE__*/ (0, $l998X.jsx)($351ba46eec5db167$var$InfoLink, {
                            href: (0, $f444507c1ee2a540$export$50e6b843de210064),
                            target: '_blank',
                            children: formatMessage((0, $3d203e0ef15a161e$export$defe85febe8b728c).definitions_support_link_text)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $3d203e0ef15a161e$export$defe85febe8b728c).definitions_no_answer_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ (0, $l998X.jsx)($351ba46eec5db167$var$InfoLink, {
                            href: (0, $f444507c1ee2a540$export$dd87179defae3659),
                            target: '_blank',
                            children: formatMessage((0, $3d203e0ef15a161e$export$defe85febe8b728c).definitions_no_answer_hipaa_compliance_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswer:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerHydration:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerRelevantContent:
            case (0, $7Zbm6.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $3d203e0ef15a161e$export$defe85febe8b728c).definition_no_answer_error,
                    values: {
                        brand: brand === (0, $f7lNm.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
        }
    }, [
        errorState,
        formatMessage,
        brand
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $351ba46eec5db167$var$styles.errorPadding,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $351ba46eec5db167$var$styles.errorMessage,
                        children: errorMessage
                    }),
                    showAddDefinitionButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        justifyContent: "end",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "default",
                            onClick: ()=>setShowEditDefinitionModal(true),
                            children: formatMessage((0, $3d203e0ef15a161e$export$defe85febe8b728c).definition_no_answer_add_definition_button)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: showEditDefinitionModal && showAddDefinitionButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $0b273c023ce36571$export$ea8c8594ad1f3bf3), {
                    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                    closeEditModal: ()=>setShowEditDefinitionModal(false),
                    isCreateDefinition: true,
                    onSaveEditModal: ()=>setDisplaySuccessFlag(true)
                })
            }),
            displaySuccessFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $d3ceefd4d089bcb8$export$7475d9ffda76c69b), {
                onDismissed: ()=>setDisplaySuccessFlag(false)
            })
        ]
    });
};








/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $7sObp = parcelRequire("7sObp");




const $cb9f1b890dd10de2$export$aef3857145d55f98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz1ap6",
            __cmplp.className
        ])
    });
});
const $cb9f1b890dd10de2$export$d74b491f1ba95e72 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, serveDefinitionUXExp: serveDefinitionUXExp, isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_17h6egw": (0, $7sObp.default)(__cmplp.serveDefinitionUXExp ? "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"),
            "--_4xki78": (0, $7sObp.default)(__cmplp.serveDefinitionUXExp ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f7lNm.READING_AIDS_DIALOG_WIDTH) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${0, $f7lNm.READING_AIDS_DIALOG_WIDTH} - 40px)`),
            "--_1wfhr4q": (0, $7sObp.default)(__cmplp.isExpanded ? 'fit-content' : '120px')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isReadingAids ? "_11c819vw _syaz1tmo _p12fpz6t _c71l127i _18m915vq _o0u91d09" : "_11c8fhey _syaz1sqi _18m91wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $cb9f1b890dd10de2$export$95fe272adfa518ad = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7yuyx _1bsb1op3 _1e0c1txw _1bahh9n0 _kqswstnw _154is0ka _80omtlke _n3td1b66 _ca0qpxbi _syazi7uo _k615idpf",
            __cmplp.className
        ])
    });
});
const $cb9f1b890dd10de2$export$b67ed19cd3a08e2a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q72k08 _11c81d4k _1e0c1txw _1bahh9n0 _1bsb12it _u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$44332785c3f496a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _zulp1b66 _1e0c1txw _2lx21bp4 _19pk12x7 _syaz1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$9565d20b767b486c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _zg8l1m30",
            __cmplp.className
        ])
    });
});
const $cb9f1b890dd10de2$export$91af142108bc801 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _w8l57vkz _17527vkz",
            __cmplp.className
        ])
    });
});
const $cb9f1b890dd10de2$export$98216a18f8eab723 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _syaz1rpy _1hbs12x7 _187z1ns9 _1q9ti7a9",
            __cmplp.isReadingAids ? "_19pku2gc _5yeu1snc _vpzragmp _1wd2vv82" : "_19pkutpp",
            __cmplp.className
        ])
    });
});
const $cb9f1b890dd10de2$export$8b7c724d5e9e5867 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o",
            __cmplp.isReadingAids ? "_2rko1l7b _1yt41b66 _10j719i6 _irr319i6 _1di613ro" : "_1yt4192y _1pelze3t",
            __cmplp.className
        ])
    });
});
const $cb9f1b890dd10de2$export$1dbaa1694f314ea0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _16jlcs5v _p12f1ssb _q7cvidpf _14z2i4vh _h6f416jw _1jeo1ap6 _paa61b66 _1tjt1gpt _16vj1gpt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$71052642a2e14680 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _p12f1ssb _syaz1rpy _o5721q9c _1bto1l2s _1mcm7vkz _jq7j7vkz _12krv77o _1kyvv77o _2hhfv77o _stn9v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$c9da66979beaa252 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$aa7530cfcbaddfa5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1ul9idpf _1ufy15vq _turg15vq _1hw71kw7 _5lhmtlke _43ds1rpy _2cf31l2s _oxk41rpy _1cay1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$253480f9791b8fdf = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$855079ed5415eeab = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _11c8wadc _1e0c1txw _syaz1rpy _5lhmtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cb9f1b890dd10de2$export$e6c91310e7bd6430 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});


const $e987865c989cf24e$export$ffa24cd7196ce1b0 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { advancedSearchUrl: advancedSearchUrl, commonAttributes: commonAttributes, isReadingAids: isReadingAids, brand: brand, smartAnswersRoute: smartAnswersRoute, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    const { errorState: errorState, errorCode: errorCode, answerCardType: answerCardType, source: source, apiSource: apiSource, searchSessionId: searchSessionId, sessionId: sessionId, queryHash: queryHash } = commonAttributes;
    const { trackAIResultError: trackAIResultError } = (0, $fYQcF.useAIEventsInstrumentation)();
    (0, $42omo.useEffect)(()=>{
        if (errorState !== (0, $7Zbm6.NLPSearchErrorState).Default) {
            trackAIResultError({
                aiErrorMessage: errorState || '',
                aiErrorCode: errorCode ?? 0
            }, {
                attributes: {
                    aiExperienceName: (0, $3f9d8952278ae5ef$export$38439c13a4683ecf)(smartAnswersRoute),
                    aiFeatureName: isReadingAids ? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}` : 'smartAnswers',
                    aiInteractionId: isReadingAids ? undefined : searchSessionId,
                    aiInteractionType: isReadingAids ? undefined : 'searchSessionId'
                }
            });
            if ((0, $dh538.fg)('kd_enable_networkerror_logging')) (0, $4Zqgi.logger).error({
                error: {
                    errorState: errorState,
                    errorCode: errorCode,
                    answerCardType: answerCardType,
                    source: source,
                    apiSource: apiSource,
                    sessionId: sessionId,
                    queryHash: queryHash
                },
                functionName: 'AIAnswerError'
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const brandName = brand === (0, $f7lNm.AiBrand).ROVO ? 'Rovo' : 'Atlassian Intelligence';
    const errorMessage = (0, $42omo.useMemo)(()=>{
        switch(errorState){
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswer:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerHydration:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerRelevantContent:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_no_answer,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$aef3857145d55f98), {
                            href: (0, $f7lNm.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_onboarding_banner_tooltip_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_keyword,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$aef3857145d55f98), {
                            href: (0, $f7lNm.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_onboarding_banner_tooltip_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_acceptable_use,
                    values: {
                        brandName: brandName,
                        acceptableUseLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$aef3857145d55f98), {
                            href: (0, $f7lNm.ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_error_state_acceptable_use_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).SubjectiveQuery:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_subjective_query,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_open_ai_rate_limit_error,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$aef3857145d55f98), {
                            href: (0, $f7lNm.ATLASSIAN_AI_USAGE_LIMITS_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_support_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_no_who_is_answer,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NetworkError:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $7Zbm6.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_network,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$aef3857145d55f98), {
                            href: (0, $f7lNm.ATLASSIAN_AI_TROUBLESHOOT_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_support_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$aef3857145d55f98), {
                            href: (0, $f7lNm.ATLASSIAN_HIPAA_COMPLICANCE_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_hipaa_compliance_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).EarlyStop:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6c81a6c460861b6e$export$97b52c363fbe053e), {});
            case (0, $7Zbm6.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_component_result_error_text,
                    values: {
                        brandName: brandName,
                        advancedSearchLink: !!advancedSearchUrl ? (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__knowledge-disc') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            href: advancedSearchUrl,
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_result_error_advanced_search_link)
                        }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                        /*#__PURE__*/ (0, $l998X.jsx)("a", {
                            href: advancedSearchUrl,
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_result_error_advanced_search_link)
                        }) : formatMessage((0, $7lL49.messages).ai_answer_component_result_error_advanced_search_link)
                    }
                });
        }
    }, [
        advancedSearchUrl,
        errorState,
        formatMessage,
        brandName
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "ai-answer-error-container",
        children: isReadingAids ? /*#__PURE__*/ (0, $l998X.jsx)((0, $351ba46eec5db167$export$f874592093e19f27), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$d74b491f1ba95e72), {
                isReadingAids: isReadingAids,
                isExpanded: true,
                children: errorMessage
            })
        })
    });
};

















/* animated-single-line-show-more.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $ghftu = parcelRequire("ghftu");







var $cOrQJ = parcelRequire("cOrQJ");


var $f7f027650ecd4d70$var$UpdatedDarkThemeStops = /*#__PURE__*/ function(UpdatedDarkThemeStops) {
    UpdatedDarkThemeStops["ORANGE"] = "#FCA700";
    UpdatedDarkThemeStops["GREEN"] = "#82B536";
    UpdatedDarkThemeStops["BLUE"] = "#357DE8";
    UpdatedDarkThemeStops["PURPLE"] = "#BF63F3";
    return UpdatedDarkThemeStops;
}($f7f027650ecd4d70$var$UpdatedDarkThemeStops || {});
var $f7f027650ecd4d70$var$UpdatedLightThemeStops = /*#__PURE__*/ function(UpdatedLightThemeStops) {
    UpdatedLightThemeStops["ORANGE"] = "#FCA700";
    UpdatedLightThemeStops["GREEN"] = "#6A9A23";
    UpdatedLightThemeStops["BLUE"] = "#1868DB";
    UpdatedLightThemeStops["PURPLE"] = "#AF59E0";
    return UpdatedLightThemeStops;
}($f7f027650ecd4d70$var$UpdatedLightThemeStops || {})// Helper function to convert hex color to rgba with alpha
;
const $f7f027650ecd4d70$var$hexToRgba = (hex, alpha)=>{
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}; // This injects a CSS property into the document for the --gradient-angle variable.
// This is needed so the browser understands how to animate the gradient-angle as an angle
// value. This is done this way because compiled doesn't support CSS variables at this time.
let $f7f027650ecd4d70$var$propertyInjected = false;
const $f7f027650ecd4d70$var$useGradientAngleProperty = ()=>{
    (0, $42omo.useEffect)(()=>{
        if ($f7f027650ecd4d70$var$propertyInjected) return;
        $f7f027650ecd4d70$var$propertyInjected = true;
        try {
            const style = document.createElement('style');
            style.innerHTML = `
				@property --gradient-angle {
					syntax: '<angle>';
					initial-value: 0deg;
					inherits: false;
				}
			`;
            document.head.appendChild(style); // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {}
    }, []);
};
const $f7f027650ecd4d70$var$unboundedStyles = {
    root: "_kqswh2mm",
    lineStyles: "_4t3it94y",
    lineNotStreamingStyles: "_bfhk1l7x",
    showMoreButtonWrapperStyles: "_1r04idpf _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o",
    showMoreButtonStyles: "_2rko1qi0 _1dqonqa1 _189ee4h9 _1h6d1l7x _bfhkvuon _vchhusvi _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1bsb1j4a _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke"
}; // Keyframes for rotating the gradient angle
// ts-ignore because jira build is failing, but this is legit
// @ts-ignore
const $f7f027650ecd4d70$var$rotateGradient = null;
const $f7f027650ecd4d70$var$lineAnimation = null;
const $f7f027650ecd4d70$var$lightModeAnimatedStyles = null;
const $f7f027650ecd4d70$var$darkModeAnimatedStyles = null;
const $f7f027650ecd4d70$export$8a1fad5d74d43878 = ({ isStreaming: isStreaming, showMoreButtonVisible: showMoreButtonVisible, onClickShowMoreButton: onClickShowMoreButton })=>{
    $f7f027650ecd4d70$var$useGradientAngleProperty();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $f7f027650ecd4d70$var$unboundedStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $f7f027650ecd4d70$var$unboundedStyles.lineStyles,
                    "_y44v1hk1",
                    isStreaming ? colorMode === 'dark' ? "_11q7nt6a" : "_11q71qln" : $f7f027650ecd4d70$var$unboundedStyles.lineNotStreamingStyles
                ]),
                style: {
                    "--_1i41aq5": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#1868DB", 1)),
                    "--_ki6hwq": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#357DE8", 1)),
                    "--_1vk81z2": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#82B536", 1)),
                    "--_92idzx": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#FCA700", 1)),
                    "--_9dqj5t": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#BF63F3", 1)),
                    "--_t9jq7i": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#6A9A23", 1)),
                    "--_1456abr": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#FCA700", 1)),
                    "--_wnwy7": (0, $7sObp.default)($f7f027650ecd4d70$var$hexToRgba("#AF59E0", 1))
                }
            }),
            showMoreButtonVisible && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $f7f027650ecd4d70$var$unboundedStyles.showMoreButtonWrapperStyles
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
                    onClick: onClickShowMoreButton,
                    className: (0, $gMc0m.default)([
                        $f7f027650ecd4d70$var$unboundedStyles.showMoreButtonStyles
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                label: ''
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtle",
                                weight: "medium",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_show_more_button
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};





/* smart-answer-card-body-complete.tsx generated by @compiled/babel-plugin v0.36.1 */ 































var $iA4lt = parcelRequire("iA4lt");














var $7gpC4 = parcelRequire("7gpC4");





var $gNXND = parcelRequire("gNXND");


var $eXmBZ = parcelRequire("eXmBZ");











var $1GzhS = parcelRequire("1GzhS");


var $eLJ6t = parcelRequire("eLJ6t");

/* open-chat-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $cOQz3 = parcelRequire("cOQz3");








var $lBFuf = parcelRequire("lBFuf");




























const $70755bd71f512b39$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    ai_answer_component_ai_answer_open_chat: {
        id: "search_ai.ai_answer_open_chat",
        defaultMessage: "Open chat"
    },
    ai_answer_component_ai_answer_ask_more_chat: {
        id: "search_ai.ai_answer_ask_more_chat",
        defaultMessage: "Ask more in Chat"
    },
    ai_answer_component_ai_answer_ask_more_chat_submit: {
        id: "search_ai.ai_answer_ask_more_chat_submit",
        defaultMessage: "Submit"
    }
});


const $201eb101f1d7d1b2$var$styles = {
    chatButtonContainer: "_1bsb1ns9"
};
const $201eb101f1d7d1b2$export$dc40dedc9df6e59f = ({ prompt: prompt, answerString: answerString, query: query, source: source })=>{
    const { commonAttributes: commonAttributes, isReadingAids: isReadingAids, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    const onOpenChatClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onOpenChatButtonClick)({
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).OPEN_CHAT_CLICKED,
            commonAttributes: commonAttributes
        });
        // callback is shared with followups
        // used in the issue model view to open up chat in a new tab
        // this is because we don't have access to dismiss the issue view modal
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(prompt);
            return;
        }
        publish({
            type: 'chat-new',
            source: source,
            data: {
                name: query.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: prompt
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                sourceId: commonAttributes.searchSessionId
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        onClose,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        prompt,
        source,
        readingAidsOptions
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: serveDefinitionUXUpdates && isReadingAids || (0, $59vy4.SAINFeatureControl).isLuminaEnabled() ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $201eb101f1d7d1b2$var$styles.chatButtonContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))),
                spacing: (0, $59vy4.SAINFeatureControl).isLuminaEnabled() ? 'default' : 'compact',
                shouldFitContainer: false,
                onClick: onOpenChatClick,
                testId: "definition-open-chat-button",
                children: formatMessage((0, $70755bd71f512b39$export$defe85febe8b728c).ai_answer_component_ai_answer_open_chat)
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
            onClick: onOpenChatClick,
            children: formatMessage((0, $70755bd71f512b39$export$defe85febe8b728c).ai_answer_component_ai_answer_open_chat)
        })
    });
};








/* definition-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 







































/* edit-history-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $abC4X = parcelRequire("abC4X");





var $hxQwS = parcelRequire("hxQwS");


var $13WX1 = parcelRequire("13WX1");


var $chO1Z = parcelRequire("chO1Z");


var $eG1e2 = parcelRequire("eG1e2");


var $ctmPb = parcelRequire("ctmPb");


var $bTdbD = parcelRequire("bTdbD");


var $9RVmI = parcelRequire("9RVmI");


























var $9hlns = parcelRequire("9hlns");










var $a2dru = parcelRequire("a2dru");








var $1e2E5 = parcelRequire("1e2E5");



const $12d864bdedc72b33$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};


function $1f21b79a6ec763c8$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $42omo.useState)({});
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = (0, $12d864bdedc72b33$export$4d25b49b6dc1b540)(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const languageFile = await fetchLanguageFile(finalLocale);
                const newMessages = languageFile.default || languageFile;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        fetchLanguageFile,
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $1f21b79a6ec763c8$var$WithMessages = ({ children: children, fetchLanguageFile: fetchLanguageFile })=>{
    const intl = (0, $8C5kA.default)();
    const { messages: messages } = $1f21b79a6ec763c8$export$5ac26fa9b941854e(intl.locale, fetchLanguageFile);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        messages: messages,
        locale: intl.locale,
        children: children
    });
};
function $1f21b79a6ec763c8$export$45d3ca664b6e3027(Component, fetchLanguageFile) {
    return (props)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)($1f21b79a6ec763c8$var$WithMessages, {
            fetchLanguageFile: fetchLanguageFile,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
}



























function $78d46856006a28da$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("iAOL9"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("fpuOJ"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("hIWnD"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("kowUg"));
        case 'et-EE':
        case 'et':
            return (parcelRequire("ec87V"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("crPsa"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("1g9BR"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("liDh5"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("fhixu"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("gspOw"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("gS2lk"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("2et3H"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("6hthv"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("f7DsF"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("ktyEo"));
        case 'pt-PT':
            return (parcelRequire("ePgIY"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("2WnrZ"));
        case 'sk-SK':
        case 'sk':
            return (parcelRequire("elRti"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("2MpFd"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("2IhrR"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("hPKNs"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("cu72h"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("b4dj1"));
        case 'zh-TW':
        case 'zh-HK':
        case 'zh':
            return (parcelRequire("edFdS"));
        case 'zh-ZH':
        case 'zh-CN':
            return (parcelRequire("gNPDA"));
    }
    return Promise.resolve({
        default: {}
    });
}





const $484a81e8faa8c222$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    justNow: {
        id: "com.atlassian.migrations-platform.mpt-timeago.ui.just-now",
        defaultMessage: "just now"
    }
});


const $b6771c3a2a278459$var$SECOND = 1;
const $b6771c3a2a278459$var$MINUTE = 60;
const $b6771c3a2a278459$var$HOUR = $b6771c3a2a278459$var$MINUTE * 60;
const $b6771c3a2a278459$var$DAY = $b6771c3a2a278459$var$HOUR * 24;
const $b6771c3a2a278459$var$WEEK = $b6771c3a2a278459$var$DAY * 7;
const $b6771c3a2a278459$var$MONTH = $b6771c3a2a278459$var$WEEK * 4.345;
const $b6771c3a2a278459$var$YEAR = $b6771c3a2a278459$var$MONTH * 12;
const $b6771c3a2a278459$var$units = [
    [
        'year',
        $b6771c3a2a278459$var$YEAR
    ],
    [
        'month',
        $b6771c3a2a278459$var$MONTH
    ],
    [
        'week',
        $b6771c3a2a278459$var$WEEK
    ],
    [
        'day',
        $b6771c3a2a278459$var$DAY
    ],
    [
        'hour',
        $b6771c3a2a278459$var$HOUR
    ],
    [
        'minute',
        $b6771c3a2a278459$var$MINUTE
    ],
    [
        'second',
        $b6771c3a2a278459$var$SECOND
    ]
];
const $b6771c3a2a278459$var$getRelativeTimeProps = (timeDifferenceInSeconds)=>{
    const relevantUnit = $b6771c3a2a278459$var$units.find((unit)=>{
        return timeDifferenceInSeconds >= unit[1];
    }) || $b6771c3a2a278459$var$units[0];
    let props = {
        value: -Math.floor(timeDifferenceInSeconds / relevantUnit[1]),
        unit: relevantUnit[0]
    };
    // Only create the update interval if time difference in seconds, minutes or hours
    // FormattedRelativeTime no longer supports higher than 'hour' for interval update
    // read "Limitation" on https://formatjs.io/docs/react-intl/components/#formattedrelativetime
    if ([
        'second',
        'minute',
        'hour'
    ].includes(relevantUnit[0])) return {
        ...props,
        updateIntervalInSeconds: 60
    };
    return props;
};
const $b6771c3a2a278459$var$TimeAgo = ({ date: date })=>{
    const differenceInSeconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    const isLessThanOneMinuteAgo = differenceInSeconds < 60;
    const [showJustNow, setShowJustNow] = (0, $42omo.useState)(isLessThanOneMinuteAgo);
    (0, $42omo.useEffect)(()=>{
        let timeout;
        if (isLessThanOneMinuteAgo) {
            setShowJustNow(true);
            // gonna refresh only once after difference time has passed
            const refreshTime = (60 - differenceInSeconds) * 1000;
            timeout = setTimeout(()=>{
                setShowJustNow(false);
            }, refreshTime);
        }
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        differenceInSeconds,
        isLessThanOneMinuteAgo
    ]);
    if (showJustNow) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $484a81e8faa8c222$export$defe85febe8b728c).justNow
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
        numeric: "always",
        ...$b6771c3a2a278459$var$getRelativeTimeProps(differenceInSeconds)
    });
};
var $b6771c3a2a278459$export$2e2bcd8739ae039 = (0, $1f21b79a6ec763c8$export$45d3ca664b6e3027)($b6771c3a2a278459$var$TimeAgo, (0, $78d46856006a28da$export$c08b58fa4727b0d2));











const $7f9955248cded24a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    readingAidsEditHistoryHeader: {
        id: "contextual-reading-aids.edit-history.header.text",
        defaultMessage: "Edit History"
    },
    readingAidsEditHistoryDescription: {
        id: "contextual-reading-aids.edit-history.description.text",
        defaultMessage: "See all the edits for {queryText}"
    },
    readingAidsEditHistoryCardEdited: {
        id: "contextual-reading-aids.edit-history.card.edited",
        defaultMessage: "{editorName} edited"
    },
    readingAidsEditHistoryCardErrorText: {
        id: "contextual-reading-aids.edit-history.card.error-text",
        defaultMessage: "An error has occurred. Please try again later."
    },
    readingAidsEditHistoryVisibilityTextOrg: {
        id: "contextual-reading-aids.edit-history.visibility.text.org",
        defaultMessage: "This definition is visible to anyone in the entire organization"
    },
    readingAidsEditHistoryVisibilitySpace: {
        id: "contextual-reading-aids.edit-history.visibility.text.space",
        defaultMessage: "This definition is visible to anyone in this space"
    },
    readingAidsEditHistoryVisibilityPage: {
        id: "contextual-reading-aids.edit-history.visibility.text.page",
        defaultMessage: "This definition is visible to anyone viewing this page"
    },
    readingAidsEditHistoryVisibilityBlog: {
        id: "contextual-reading-aids.edit-history.visibility.text.blog",
        defaultMessage: "This definition is visible to anyone viewing this blog"
    },
    readingAidsEditHistoryVisibilityProject: {
        id: "contextual-reading-aids.edit-history.visibility.text.Project",
        defaultMessage: "This definition is visible to anyone viewing this project"
    },
    readingAidsEditHistoryVisibilityProjectGalaxia: {
        id: "contextual-reading-aids.edit-history.visibility.text.Project-galaxia",
        defaultMessage: "This definition is visible to anyone viewing this space"
    }
});











const $e50b8914515d41cb$var$DefinitionEditHistoryQuery = `
query DefinitionEditHistoryQuery(
  $workspaceId: String!
  $keyPhrase: String!
	$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
	$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
) {
  knowledgeDiscovery {
    definitionHistory(
      workspaceId: $workspaceId
      keyPhrase: $keyPhrase
      confluenceScopeId: $confluenceScopeId
			jiraScopeId: $jiraScopeId
    ) @optIn(to: "KnowledgeDiscovery Get definition history") {
      __typename
      ... on KnowledgeDiscoveryDefinitionList {
        definitions {
          keyPhrase
          definition
          createdAt
          scope
          editor {
            name
            accountId
            picture
          }
          referenceUrl
          confluenceEntity {
            ... on ConfluencePage {
              id
              type
              title
            }
            ... on ConfluenceBlogPost {
              id
              type
              title
            }
          }
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $e50b8914515d41cb$export$9ad350b72fa486e = {
    operationName: 'DefinitionEditHistoryQuery',
    query: $e50b8914515d41cb$var$DefinitionEditHistoryQuery
};


const $74ea6a75ef49310d$export$fd57168bc668244 = (productScopes)=>{
    if ('contentARI' in productScopes) return {
        confluenceScopeId: {
            contentId: productScopes.contentARI,
            spaceId: productScopes.spaceARI
        }
    };
    else return {
        jiraScopeId: {
            projectId: productScopes.projectARI
        }
    };
};


const $a1d51587e7cd682a$export$584199b95393a773 = ({ query: query, curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const loading = data === undefined && error === undefined;
    const scopeIds = (0, $74ea6a75ef49310d$export$fd57168bc668244)(curatedDefinitionScopeConfig.productScopes);
    (0, $42omo.useEffect)(()=>{
        const fireRequest = async ()=>{
            try {
                const res = await (0, $9EFEY.fetchAggResponse)({
                    graphQuery: (0, $e50b8914515d41cb$export$9ad350b72fa486e).query,
                    operationName: (0, $e50b8914515d41cb$export$9ad350b72fa486e).operationName,
                    variables: {
                        workspaceId: curatedDefinitionScopeConfig.workspaceId,
                        keyPhrase: query,
                        ...scopeIds
                    },
                    headers: (0, $6yuru.createAtlAttributionHeader)({
                        atlWorkspaceId: curatedDefinitionScopeConfig.workspaceId,
                        tenantId: curatedDefinitionScopeConfig.cloudId,
                        product: curatedDefinitionScopeConfig.product
                    })
                });
                const { data: data, errors: errors } = res;
                if (!errors && !!data) setData(data);
                else throw new Error(errors?.map((e)=>e.message).join(', '));
            } catch (e) {
                setError(e);
            }
        };
        fireRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const definitions = !error && !data?.knowledgeDiscovery?.definitionHistory?.message ? data?.knowledgeDiscovery?.definitionHistory?.definitions || [] : [];
    return {
        definitions: definitions,
        loading: loading
    };
};


const $d30730e216903aee$var$styles = {
    loadingSpinner: "_1e0c1txw _1bah1h6o _4t3i1osq _1bsb1osq",
    editHistoryWrapper: "_zulppxbi _11c8fhey _1e0c1txw _2lx21bp4 _n3tdv47k",
    editHistoryDescription: "_zulp1b66 _syazi7uo",
    editedDefinitionCardContainer: "_zulpu2gc _1e0c1txw _2lx21bp4",
    editedDefinitionScopeText: "_1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rpy",
    editedDefinitionCard: "_2rkoy0do _zulppxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx2vrvc _4cvr1y6m _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    editedDefinitionAvatar: "_2rko1tk5",
    editedDefinitionCardBody: "_11c8fhey _zulputpp _1e0c1txw _2lx21bp4 _1bsb1osq _syazi7uo",
    editedDefinitionCardHeaderWrapper: "_zulpze3t _1e0c1txw _2lx21bp4",
    editedDefinitionCardHeader: "_zulp1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _syazazsu _otyru2gc",
    editedDefinitionCardEditor: "_k48p1pd9 _syazi7uo",
    editedDefinitionCardReference: "_1e0c1txw _4cvr1h6o",
    editedDefinitionCardReferenceTitle: "_18u01b66",
    editedDefinitionCardHeaderSpacer: "_1bsb1osq _syaz1gmx _19pkv77o _otyridpf"
};

const $d30730e216903aee$var$MarkdownRenderer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gdXLD")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $d30730e216903aee$var$ScopeDescription = ({ scope: scope })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let scopeDescription = '';
    let ScopeIcon;
    switch(scope){
        case (0, $9KkVf.EditedDefinitionScope).ORGANIZATION:
            scopeDescription = formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryVisibilityTextOrg);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ctmPb)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).SPACE:
            scopeDescription = formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryVisibilitySpace);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($bTdbD)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).PAGE:
            scopeDescription = formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryVisibilityPage);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($chO1Z)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).BLOGPOST:
            scopeDescription = formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryVisibilityBlog);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).PROJECT:
            scopeDescription = formatMessage((0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryVisibilityProjectGalaxia : (0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryVisibilityProject);
            ScopeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                    color: "var(--ds-icon, #292A2E)",
                    label: ""
                });
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $d30730e216903aee$var$styles.editedDefinitionScopeText,
        space: "space.050",
        children: [
            scopeDescription,
            " ",
            /*#__PURE__*/ (0, $l998X.jsx)(ScopeIcon, {
                label: ""
            })
        ]
    });
};
const $d30730e216903aee$export$6c43ad171ca78b4f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: { query: query } } = (0, $eRXI0.useAIAnswerContext)();
    const { definitions: definitions, loading: loading } = (0, $a1d51587e7cd682a$export$584199b95393a773)({
        query: query,
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const hasError = definitions.length === 0 && !loading;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
        onClose: onClose,
        height: 600,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                    children: formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryHeader)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    xcss: $d30730e216903aee$var$styles.editHistoryWrapper,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            xcss: $d30730e216903aee$var$styles.editHistoryDescription,
                            children: formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryDescription, {
                                queryText: /*#__PURE__*/ (0, $l998X.jsx)("b", {
                                    children: query
                                })
                            })
                        }),
                        hasError || loading ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            xcss: $d30730e216903aee$var$styles.loadingSpinner,
                            children: [
                                loading && /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                                    size: "large",
                                    testId: "definition-history-loading-spinner"
                                }),
                                hasError && /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
                                    header: formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryCardErrorText)
                                })
                            ]
                        }) : definitions.map((item, index)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                xcss: $d30730e216903aee$var$styles.editedDefinitionCardContainer,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)($d30730e216903aee$var$ScopeDescription, {
                                        scope: item.scope
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                        xcss: $d30730e216903aee$var$styles.editedDefinitionCard,
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $d30730e216903aee$var$styles.editedDefinitionAvatar,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                                                    src: item.editor?.picture || '',
                                                    width: "32px",
                                                    height: "32px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                xcss: $d30730e216903aee$var$styles.editedDefinitionCardBody,
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                        xcss: $d30730e216903aee$var$styles.editedDefinitionCardHeaderWrapper,
                                                        children: [
                                                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                                                xcss: $d30730e216903aee$var$styles.editedDefinitionCardHeader,
                                                                children: [
                                                                    formatMessage((0, $7f9955248cded24a$export$defe85febe8b728c).readingAidsEditHistoryCardEdited, {
                                                                        editorName: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                                            xcss: $d30730e216903aee$var$styles.editedDefinitionCardEditor,
                                                                            children: item.editor?.name || ''
                                                                        })
                                                                    }),
                                                                    " \u2219 ",
                                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b6771c3a2a278459$export$2e2bcd8739ae039), {
                                                                        date: Number(item.createdAt) * 1000
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $l998X.jsx)("hr", {
                                                                role: "presentation",
                                                                className: (0, $gMc0m.default)([
                                                                    $d30730e216903aee$var$styles.editedDefinitionCardHeaderSpacer
                                                                ])
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                                        "data-testid": `rendered-markdown-definition-${index}`,
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                                            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)($d30730e216903aee$var$MarkdownRenderer, {
                                                                disallowedElements: (0, $dh538.fg)('hybrid_orchestrator_enable_image_search') ? undefined : [
                                                                    'img'
                                                                ],
                                                                children: item.definition
                                                            })
                                                        })
                                                    }),
                                                    item.referenceUrl && item.confluenceEntity?.title && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                        xcss: $d30730e216903aee$var$styles.editedDefinitionCardReference,
                                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $2Nwuj.default), {
                                                            appearance: "subtle",
                                                            target: "_blank",
                                                            href: item.referenceUrl,
                                                            children: [
                                                                item.confluenceEntity.type === 'BLOG_POST' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hxQwS.default), {
                                                                    label: ""
                                                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $13WX1.default), {
                                                                    label: ""
                                                                }),
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                                    xcss: $d30730e216903aee$var$styles.editedDefinitionCardReferenceTitle,
                                                                    children: item.confluenceEntity.title || ''
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, `edited-definition-history-card-${index}`))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
        ]
    });
};















var $eEA8O = parcelRequire("eEA8O");


var $9zIwY = parcelRequire("9zIwY");


var $9FnLD = parcelRequire("9FnLD");





var $6fnsQ = parcelRequire("6fnsQ");



















const $2284517eed0ad738$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    definition_footer_defined_by_text: {
        id: "search_ai.definition_footer_defined_by_text",
        defaultMessage: "Defined by"
    },
    definition_footer_see_edit_history: {
        id: "search_ai.definition_footer_see_edit_history",
        defaultMessage: "See all edit history"
    },
    definition_footer_like_button_tooltip: {
        id: "search_ai.definition_footer_like_button_tooltip",
        defaultMessage: "Good response"
    },
    definition_footer_dislike_button_tooltip: {
        id: "search_ai.definition_footer_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    definition_footer_hide_term_definition_message: {
        id: "search_ai.definition_footer_hide_term_definition_message",
        defaultMessage: "Don't define this again"
    },
    definition_footer_beta_status_label: {
        id: "search_ai.definition_footer.beta_status_label",
        defaultMessage: "Beta"
    },
    definition_footer_disclaimer: {
        id: "search_ai.definition_footer_disclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    definition_footer_powered_by_AI: {
        id: "search_ai.definition_footer_powered_by_AI",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    definition_footer_feedback_options_modal_header_feedback_only: {
        id: "search_ai.definition_footer_feedback_options_modal_header_feedback_only",
        defaultMessage: "Leave feedback"
    },
    definition_footer_feedback_options_modal_header: {
        id: "search_ai.definition_footer_feedback_options_modal_header",
        defaultMessage: "Correct definition or leave feedback"
    },
    definition_footer_feedback_options_edit_definition_option: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option",
        defaultMessage: "I want to edit this definition"
    },
    definition_footer_feedback_options_edit_definition_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option_subtext",
        defaultMessage: "Update the definition."
    },
    definition_footer_feedback_options_leave_feedback_option: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option",
        defaultMessage: "I want to leave feedback about this feature"
    },
    definition_footer_feedback_options_leave_feedback_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option_subtext",
        defaultMessage: "Share your feedback so we can improve these experiences."
    },
    definition_footer_feedback_modal_header: {
        id: "search_ai.definition_footer_feedback_modal_header",
        defaultMessage: "Help us improve Definitions"
    },
    definition_footer_feedback_consent_checkbox_label: {
        id: "search_ai.definition_footer_feedback_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    definition_footer_feedback_report_label: {
        id: "search_ai.definition_footer_feedback_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    definition_footer_feedback_report_details_label: {
        id: "search_ai.definition_footer_feedback_report_details_label",
        defaultMessage: "Describe the issue"
    },
    definition_footer_feedback_report_empty_option_share_label: {
        id: "search_ai.definition_footer_feedback_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    definition_footer_feedback_report_relevance_option_label: {
        id: "search_ai.definition_footer_feedback_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    definition_footer_feedback_report_inaccurate_option_label: {
        id: "search_ai.definition_footer_feedback_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    definition_footer_feedback_report_offensive_option_label: {
        id: "search_ai.definition_footer_feedback_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    definition_footer_feedback_report_other_option_label: {
        id: "search_ai.definition_footer_feedback_report_other_option_label",
        defaultMessage: "Something else"
    },
    definition_footer_feedback_summary_placeholder_label: {
        id: "search_ai.definition_footer_feedback_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    definition_footer_feedback_flag_description: {
        id: "search_ai.definition_footer_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    }
});


/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 










const $987ad772240399b4$export$5d384d799a8fb604 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_169wk05": (0, $7sObp.default)(__cmplp.active ? "var(--ds-text-accent-blue, #1558BC)" : "var(--ds-text-subtlest, #6B6E76)"),
            "--_hohrgu": (0, $7sObp.default)(__cmplp.isDisabled ? 'not-allowed' : 'default')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omucgo _1nj11ire",
            __cmplp.className
        ])
    });
});
const $987ad772240399b4$export$8b5c58bc12f52d53 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_12hn1sub",
            __cmplp.className
        ])
    });
});


const $8428b38cee92438f$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        position: 'top',
        content: tooltipContent,
        children: ({ onClick: _onClick, ...tooltipProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                "aria-label": tooltipContent,
                spacing: 'none',
                appearance: isDisabled ? 'subtle-link' : 'subtle',
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $987ad772240399b4$export$5d384d799a8fb604), {
                    active: active,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        cursor: 'pointer'
                    },
                    ...testId && {
                        'data-testid': testId
                    },
                    isDisabled: isDisabled || false,
                    children: icon
                }),
                ...!isDisabled && {
                    onClick: onClickHandler
                },
                ...tooltipProps
            })
    });
};
const $8428b38cee92438f$export$c633fc044a8b8981 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $9pwVP.onLikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent
    ]);
    const dislikeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setShowFeedbackOptionsModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $9pwVP.onDislikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setShowFeedbackOptionsModal,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($8428b38cee92438f$var$FeedbackButton, {
                active: liked === true,
                onClick: likeButtonCallback,
                tooltipContent: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_like_button_tooltip),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                    label: "",
                    spacing: "spacious",
                    color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
                    size: serveDefinitionUXUpdates ? 'small' : 'medium'
                }),
                isDisabled: liked && likesDisabled,
                testId: "definition-footer-like-button"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($8428b38cee92438f$var$FeedbackButton, {
                active: liked === false,
                onClick: dislikeButtonCallback,
                tooltipContent: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_dislike_button_tooltip),
                icon: serveDefinitionUXUpdates ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
                    label: "",
                    spacing: "spacious",
                    size: "small",
                    color: "var(--ds-icon, #292A2E)"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $987ad772240399b4$export$8b5c58bc12f52d53), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                        label: "",
                        spacing: "spacious",
                        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`
                    })
                }),
                isDisabled: !liked && likesDisabled,
                testId: "definition-footer-dislike-button"
            })
        ]
    });
};


/* feedback-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 



















const $b9e065a1f0645f46$var$styles = {
    root: "_n3tdpxbi"
};

const $b9e065a1f0645f46$var$AkFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $b9e065a1f0645f46$export$5efdacda4e928df9 = ({ setFeedbackModal: setFeedbackModal, isCuratedDefinition: isCuratedDefinition, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, userDetails: { name: name, id: id } } = (0, $eRXI0.useAIAnswerContext)();
    const { errorState: errorState } = commonAttributes;
    const [hasConsent, setConsent] = (0, $42omo.useState)(false);
    const feedbackContextObject = {
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        isCuratedDefinition: isCuratedDefinition
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $42omo.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)($b9e065a1f0645f46$var$AkFeedbackCollector, {
                locale: locale,
                onClose: ()=>setFeedbackModal(false),
                onSubmit: ()=>{
                    setDisplayFlag(true);
                },
                customContent: isCuratedDefinition ? undefined : /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                    label: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_consent_checkbox_label),
                    onChange: toggleConsentCheckbox,
                    isChecked: hasConsent
                }),
                atlassianAccountId: id,
                name: name,
                entrypointId: (0, $f444507c1ee2a540$export$dd6343c56092a345),
                additionalFields: [
                    {
                        id: (0, $f444507c1ee2a540$export$d04cd98bb7625919),
                        value: feedbackContext
                    }
                ],
                feedbackTitle: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_modal_header),
                feedbackTitleDetails: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b9e065a1f0645f46$var$styles.root,
                    children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_label)
                }),
                feedbackGroupLabels: {
                    empty: {
                        fieldLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_empty_option_share_label)
                    },
                    question: {
                        fieldLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_relevance_option_label)
                    },
                    comment: {
                        fieldLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_inaccurate_option_label)
                    },
                    bug: {
                        fieldLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_offensive_option_label)
                    },
                    suggestion: {
                        fieldLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_report_other_option_label)
                    }
                },
                summaryPlaceholder: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_summary_placeholder_label)
            })
        })
    });
};


/* feedback-options-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1Zr9M = parcelRequire("1Zr9M");


var $7yOcR = parcelRequire("7yOcR");















var $fVUfS = parcelRequire("fVUfS");


const $784f31c0b8c9f08d$var$styles = {
    feedbackOptionsWrapper: "_zulppxbi _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _n3td1ejb",
    feedbackOption: "_2rko12b0 _1bsb1osq _4t3i8vuz _bfhksm61 _irr31dpa",
    feedbackOptionIconWrapper: "_2rkolb4i _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg",
    feedbackOptionText: "_11c8fhey _syazi7uo",
    feedbackOptionSubText: "_11c8wadc _syaz1rpy"
};
const $784f31c0b8c9f08d$export$dc5d3996368c6525 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setShowEditDefinitionModal: setShowEditDefinitionModal, setShowFeedbackModal: setShowFeedbackModal, editDefinitionEnabled: editDefinitionEnabled })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
        onClose: ()=>setShowFeedbackOptionsModal(false),
        shouldReturnFocus: false,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                    children: formatMessage(editDefinitionEnabled ? (0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_options_modal_header : (0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_options_modal_header_feedback_only)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $784f31c0b8c9f08d$var$styles.feedbackOptionsWrapper,
                    children: [
                        editDefinitionEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            xcss: $784f31c0b8c9f08d$var$styles.feedbackOption,
                            onClick: ()=>{
                                setShowFeedbackOptionsModal(false);
                                setShowEditDefinitionModal(true);
                            },
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                gap: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        backgroundColor: "color.background.accent.blue.subtle",
                                        xcss: $784f31c0b8c9f08d$var$styles.feedbackOptionIconWrapper,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                                            spacing: "spacious",
                                            label: "",
                                            color: "var(--ds-icon-inverse, #FFFFFF)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                        direction: "column",
                                        gap: "space.025",
                                        alignItems: "start",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $784f31c0b8c9f08d$var$styles.feedbackOptionText,
                                                children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_options_edit_definition_option)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $784f31c0b8c9f08d$var$styles.feedbackOptionSubText,
                                                children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_options_edit_definition_option_subtext)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            xcss: $784f31c0b8c9f08d$var$styles.feedbackOption,
                            onClick: ()=>{
                                setShowFeedbackOptionsModal(false);
                                setShowFeedbackModal(true);
                            },
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                gap: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        backgroundColor: "color.background.accent.blue.subtle",
                                        xcss: $784f31c0b8c9f08d$var$styles.feedbackOptionIconWrapper,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                                            spacing: "spacious",
                                            label: "",
                                            color: "var(--ds-icon-inverse, #FFFFFF)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                        direction: "column",
                                        gap: "space.025",
                                        alignItems: "start",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $784f31c0b8c9f08d$var$styles.feedbackOptionText,
                                                children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_options_leave_feedback_option)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $784f31c0b8c9f08d$var$styles.feedbackOptionSubText,
                                                children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_options_leave_feedback_option_subtext)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/* footer-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $lM0k7 = parcelRequire("lM0k7");
























var $7c52C = parcelRequire("7c52C");


var $8j9VY = parcelRequire("8j9VY");














/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes



parcelRequire("42omo");

const $cfdb019f175cb54a$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 15.3L17.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 15.3L6.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 10.3L6.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 10.3L17.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 16.8V19.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.00012 12.8L5.00012 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 8.80003L12.0001 5.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.0002 12.8L19.0002 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            })
        ]
    });








const $2d509230fe7bac35$var$styles = {
    aiFooter: "_1e0c1txw _4cvr1h6o _1bah1yb4 _ca0q1b66 _n3td1b66 _19bvv47k _u5f3v47k _uwhke4h9 _15a5nqa1 _1i531l7x _1bsb1osq",
    aiFooterUpdates: "_19bvpxbi _u5f3pxbi",
    rovoWrapper: "_ca0q1b66 _n3td1b66",
    contentMayVaryWrapper: "_zulp1b66 _11c8wadc _1e0c1txw _4cvr1h6o _syaz1rpy",
    brandWrapper: "_11c8wadc _1e0c1txw _4cvr1h6o _syaz1rpy",
    editedByFooter: "_1e0c1txw _4cvr1h6o _1bah1yb4 _ca0qutpp _n3tdutpp _19bvv47k _u5f3v47k _uwhke4h9 _15a5nqa1 _1i531l7x",
    editedByWrapper: "_2rko1rr0 _1e0c1txw _bfhki8nm _19bv1b66 _u5f31b66 _18u01b66 _80omtlke _irr3plhp",
    definedByWrapper: "_18u0u2gc",
    activeEditedByWrapper: "_2rko1rr0 _1e0c1txw _bfhkplhp _19bv1b66 _u5f31b66 _18u01b66 _80omtlke",
    editHistoryWrapper: "_11c8wadc _1e0c1txw _syaz13af _19bv1ejb _80omtlke _bfhksm61 _9oik1r31 _1bnx8stv _jf4cnqa1"
};

const $2d509230fe7bac35$var$AkFeedbackFlag = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $2d509230fe7bac35$export$8c09939f07ae58e2 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { answerEditor: answerEditor, brand: brand, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const [showFeedbackOptionsModal, setShowFeedbackOptionsModal] = (0, $42omo.useState)(false);
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $42omo.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $42omo.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $42omo.useState)(false);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($2d509230fe7bac35$var$styles.aiFooter, serveDefinitionUXUpdates && $2d509230fe7bac35$var$styles.aiFooterUpdates),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $2d509230fe7bac35$var$styles.contentMayVaryWrapper,
                        children: [
                            brand === (0, $f7lNm.AiBrand).ROVO ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_beta_status_label)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                                label: "",
                                color: "var(--ds-icon-subtle, #505258)",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                rel: "noopener noreferrer",
                                appearance: "subtle",
                                href: (0, $f444507c1ee2a540$export$59da2b3b71a076c7),
                                children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_disclaimer)
                            })
                        ]
                    }),
                    !serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $2d509230fe7bac35$var$styles.brandWrapper,
                        children: brand === (0, $f7lNm.AiBrand).ROVO ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                alignItems: "center",
                                gap: "space.025",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        rel: "noopener noreferrer",
                                        appearance: "subtle",
                                        href: (0, $f444507c1ee2a540$export$2c1028e1e7bf5557),
                                        children: "Rovo"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
                                        label: "",
                                        color: "var(--ds-icon-subtle, #505258)",
                                        spacing: "spacious"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            alignItems: "center",
                            gap: "space.025",
                            children: [
                                formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_powered_by_AI),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cfdb019f175cb54a$export$eaf821108be3620b), {
                                    greyed: true,
                                    size: "large"
                                })
                            ]
                        })
                    }),
                    serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8428b38cee92438f$export$c633fc044a8b8981), {
                            setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
                            setDisplayFlag: setDisplayFlag
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6xdDU.default), {
                children: [
                    showFeedbackOptionsModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $784f31c0b8c9f08d$export$dc5d3996368c6525), {
                        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
                        setShowEditDefinitionModal: setShowEditDefinitionModal,
                        setShowFeedbackModal: setShowFeedbackModal,
                        editDefinitionEnabled: editDefinitionEnabled
                    }),
                    showFeedbackModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $b9e065a1f0645f46$export$5efdacda4e928df9), {
                        setFeedbackModal: setShowFeedbackModal,
                        isCuratedDefinition: !!answerEditor,
                        setDisplayFlag: setDisplayFlag
                    }),
                    showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $0b273c023ce36571$export$ea8c8594ad1f3bf3), {
                        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                        closeEditModal: ()=>setShowEditDefinitionModal(false),
                        openFeedbackOptionsModal: ()=>setShowFeedbackOptionsModal(true),
                        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
                    })
                ]
            }),
            displayFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($2d509230fe7bac35$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_flag_description)
                    })
                })
            }),
            displaySuccessFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $d3ceefd4d089bcb8$export$7475d9ffda76c69b), {
                onDismissed: ()=>setDisplaySuccessFlag(false)
            })
        ]
    });
};
const $2d509230fe7bac35$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT = '/gateway/api/directory/graphql';
const $2d509230fe7bac35$var$profileClient = new (0, $7c52C.default)({
    url: $2d509230fe7bac35$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT
});
const $2d509230fe7bac35$export$686a5e20bce13f8f = ({ setShowEditHistoryModal: setShowEditHistoryModal })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [editorActive, setEditorActive] = (0, $42omo.useState)(false);
    const { answerEditor: answerEditor, commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId } = commonAttributes;
    if (!answerEditor) return null; // This line should not be reachable since the component is only rendered when answerEditor is defined
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $2d509230fe7bac35$var$styles.editedByFooter,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            gap: "space.100",
            alignItems: "start",
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lM0k7))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $2d509230fe7bac35$var$styles.definedByWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_defined_by_text)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $8j9VY.default), {
                            userId: answerEditor.id,
                            cloudId: cloudId,
                            resourceClient: $2d509230fe7bac35$var$profileClient,
                            trigger: "click",
                            onVisibilityChange: setEditorActive,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                xcss: editorActive ? $2d509230fe7bac35$var$styles.activeEditedByWrapper : $2d509230fe7bac35$var$styles.editedByWrapper,
                                children: [
                                    "@",
                                    answerEditor.name
                                ]
                            })
                        })
                    ]
                }),
                !serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $2d509230fe7bac35$var$styles.editHistoryWrapper,
                    onClick: ()=>{
                        fireAnalyticsEvent((0, $9pwVP.onCuratedDefinitionSeeEditHistoryButtonClicked)(commonAttributes));
                        setShowEditHistoryModal(true);
                    },
                    children: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_see_edit_history)
                })
            ]
        })
    });
};












const $bccd8fae77123cba$export$8a69382ce91c952a = `
	mutation ToggleDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$isDisabled: Boolean
		) {
		knowledgeDiscovery {
			updateUserKeyPhraseInteraction(
				input: {
					workspaceId: $workspaceId
					keyPhrase: $keyPhrase
					isDisabled: $isDisabled
				}
			) @optIn(to: "KnowledgeDiscovery Update User KeyPhrase Interaction") {
				success
				errors {
					message
				}
			}
		}
	}
`;


const $d491ddb6c5306e7b$export$6e73bcf8826d31a5 = ()=>{
    const toggleDefinition = (0, $42omo.useCallback)(async ({ workspaceId: workspaceId, keyPhrase: keyPhrase, isDisabled: isDisabled, cloudId: cloudId, product: product })=>{
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $bccd8fae77123cba$export$8a69382ce91c952a),
            variables: {
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: isDisabled
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.updateUserKeyPhraseInteraction?.success) return {
                toggleDefinitionSuccess: true
            };
            else throw new Error('toggleDefinition mutation unsuccessful');
        });
    }, []);
    return {
        toggleDefinition: toggleDefinition
    };
};


const $16f998d00c2c3aa2$var$styles = {
    root: "_11c8fhey _1e0c1txw _4cvr1h6o _otyr1b66 _syaz1sqi _19bv1ejb _u5f31ejb"
};

const $16f998d00c2c3aa2$var$AkFeedbackFlag = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
const $16f998d00c2c3aa2$export$9de8ba80314e4213 = ()=>{
    const { answerEditor: answerEditor, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, definitionToggleEnabled: definitionToggleEnabled, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    const { query: keyPhrase, workspaceId: workspaceId, cloudId: cloudId } = commonAttributes;
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const [showFeedbackOptionsModal, setShowFeedbackOptionsModal] = (0, $42omo.useState)(false);
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $42omo.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $42omo.useState)(false);
    const [showEditHistoryModal, setShowEditHistoryModal] = (0, $42omo.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $42omo.useState)(false);
    const cachedTermDefinitionDisabled = JSON.parse((0, $epS7s.getSessionItem)($16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
    const [termDefinitionDisabled, setTermDefinitionDisabled] = (0, $42omo.useState)(cachedTermDefinitionDisabled.keyPhrase === keyPhrase);
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    const { toggleDefinition: toggleDefinition } = (0, $d491ddb6c5306e7b$export$6e73bcf8826d31a5)();
    const onToggleDefinitionDisable = async ()=>{
        try {
            setTermDefinitionDisabled((current)=>!current);
            await toggleDefinition({
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: !termDefinitionDisabled,
                cloudId: cloudId,
                product: sourceProduct ?? ''
            });
            if (termDefinitionDisabled) (0, $epS7s.deleteSessionItem)($16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY);
            else {
                fireAnalyticsEvent((0, $9pwVP.onClickDisableDefinition)(commonAttributes));
                (0, $epS7s.setSessionItem)($16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                    keyPhrase: keyPhrase
                }));
            }
        } catch (error) {
            setTermDefinitionDisabled((current)=>!current);
            fireAnalyticsEvent((0, $xhg8G.toggleDefinitionErrorPayload)(error, commonAttributes));
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            !hasError && isAnswered && !serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                justifyContent: "space-between",
                xcss: $16f998d00c2c3aa2$var$styles.root,
                testId: "definition-answer-card-footer",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8428b38cee92438f$export$c633fc044a8b8981), {
                            setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
                            setDisplayFlag: setDisplayFlag
                        })
                    }),
                    definitionToggleEnabled && (0, $dh538.fg)('kd_definitions_toggle_definition') && /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                        isChecked: termDefinitionDisabled,
                        label: (0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_hide_term_definition_message.defaultMessage,
                        value: (0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_hide_term_definition_message.defaultMessage,
                        onChange: onToggleDefinitionDisable
                    })
                ]
            }),
            answerEditor ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2d509230fe7bac35$export$686a5e20bce13f8f), {
                setShowEditHistoryModal: setShowEditHistoryModal
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2d509230fe7bac35$export$8c09939f07ae58e2), {}),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6xdDU.default), {
                children: [
                    showEditHistoryModal && editDefinitionEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $d30730e216903aee$export$6c43ad171ca78b4f), {
                        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                        onClose: ()=>setShowEditHistoryModal(false)
                    }),
                    showFeedbackOptionsModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $784f31c0b8c9f08d$export$dc5d3996368c6525), {
                        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
                        setShowEditDefinitionModal: setShowEditDefinitionModal,
                        setShowFeedbackModal: setShowFeedbackModal,
                        editDefinitionEnabled: editDefinitionEnabled
                    }),
                    showFeedbackModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $b9e065a1f0645f46$export$5efdacda4e928df9), {
                        setFeedbackModal: setShowFeedbackModal,
                        isCuratedDefinition: !!answerEditor,
                        setDisplayFlag: setDisplayFlag
                    }),
                    showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $0b273c023ce36571$export$ea8c8594ad1f3bf3), {
                        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                        closeEditModal: ()=>setShowEditDefinitionModal(false),
                        openFeedbackOptionsModal: ()=>setShowFeedbackOptionsModal(true),
                        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
                    })
                ]
            }),
            displayFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($16f998d00c2c3aa2$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $2284517eed0ad738$export$defe85febe8b728c).definition_footer_feedback_flag_description)
                    })
                })
            }),
            displaySuccessFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $d3ceefd4d089bcb8$export$7475d9ffda76c69b), {
                onDismissed: ()=>setDisplaySuccessFlag(false)
            })
        ]
    });
};





parcelRequire("42omo");

















/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $9c08bd9e3182a321$export$cc8053471b180c28 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _19pkpxbi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$8d7f456736fee90f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8i4vh",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$39edbe3e7f6a9ca1 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c11p5 _yv0e13mt _1bsb1osq _4t3i8vuz _19pku2gc",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$d0be8a9d033ca7b8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19ituvea _2rko1qi0 _1e0c1txw _4cvr1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _vchhusvi _9oik1r31 _1bnxglyw _jf4cnqa1 _1dbz130s",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$e739e9e96a0d2dd9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bahitcz _4cvr1y6m _4t3i1osq _1bsb1osq _18u0u2gc _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$790f6d80b0f65f30 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81qyo _1reo15vq _18m915vq _syazi7uo _1bsb1osq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$7b9fc87d1d9e8ecd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syaz1rpy _1bsb1osq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$8aac4e350897fa7 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_x3doia51 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1y6m _vchhusvi",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$12179e87966a5f65 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8i4vh _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$ca13badcf6359d46 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c11p5 _yv0e13mt _1bsb1osq _4t3i8vuz _19pku2gc",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$e2651635b6d243b0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19ituvea _2rko1qi0 _1e0c1txw _4cvr1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _vchhusvi _bfhk1j9a _9oik1r31 _1bnxglyw _jf4cnqa1 _1dbz130s",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$da4b6fad053f23b9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bahitcz _4cvr1y6m _4t3i1osq _1bsb1osq _18u0u2gc _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$a9060ca8bb68e9b6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81qyo _1reo15vq _18m915vq _syazi7uo _1bsb1osq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $9c08bd9e3182a321$export$eadd90c494f8440c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syaz1rpy _1bsb1osq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});


const $b5c07244ed83c859$export$b03d109098afe32f = ()=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const { parsedResult: parsedResult } = (0, $c97be5ff4a9e42e9$export$b273f870e024eb5d)(answerString);
    const additionalUserResults = parsedResult.slice(1);
    const numAdditionalUserResults = additionalUserResults.length;
    return numAdditionalUserResults ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $9c08bd9e3182a321$export$8aac4e350897fa7), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$12179e87966a5f65), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_who_questions_footer_header,
                    values: {
                        numMatches: numAdditionalUserResults
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$ca13badcf6359d46), {
                children: additionalUserResults.map((userResult)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $9c08bd9e3182a321$export$e2651635b6d243b0), {
                        href: userResult.profile_url || undefined,
                        onClick: (event)=>{
                            onNavigate(event);
                            fireAnalyticsEvent((0, $4xTru.onWhoAdditionalMatchProfileClick)({
                                ...commonAttributes,
                                additionalMatchUserName: userResult.name,
                                additionalMatchTitle: userResult.job_title || ''
                            }));
                        },
                        onContextMenu: (event)=>{
                            onNavigate(event);
                            fireAnalyticsEvent((0, $4xTru.onWhoAdditionalMatchProfileContextMenuClick)({
                                ...commonAttributes,
                                additionalMatchUserName: userResult.name,
                                additionalMatchTitle: userResult.job_title || ''
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                                src: userResult.avatar_url || undefined,
                                size: "medium",
                                testId: userResult.name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $9c08bd9e3182a321$export$da4b6fad053f23b9), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$a9060ca8bb68e9b6), {
                                        children: userResult.name
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$eadd90c494f8440c), {
                                        children: userResult.job_title
                                    })
                                ]
                            })
                        ]
                    }, userResult.name))
            })
        ]
    }) : null;
};









































/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides












var $afneb = parcelRequire("afneb");

const $21c70bc822f819a6$var$AIAnswerContentBrandBase = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _ca0q1b66 _u5f31ejb _n3td1b66 _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $21c70bc822f819a6$export$f32f097f63664c4b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $21c70bc822f819a6$var$AIAnswerContentBrandBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $21c70bc822f819a6$export$5d9a293726695cdb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $21c70bc822f819a6$var$AIAnswerContentBrandBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$89b1508f9c43b29e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _x3doia51 _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qutpp _u5f31ejb _n3tdutpp _19bv1ejb _1n261g80",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$71c5dacfc0533c82 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hm6gxd": (0, $7sObp.default)(__cmplp.isCompact ? `0px ${"var(--ds-space-300, 24px)"}` : 'unset')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1yt410s4 _1e0c1txw _4cvr1h6o _19pku2gc _otyru2gc _syaz1sqi",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$3ecfdaeafbf376d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_x3doia51 _1e0c1txw _4cvr1h6o _1bah1yb4 _ca0qutpp _u5f3v47k _n3tdutpp _19bvv47k",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$67e0ee90a7929c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$8b91051e793e6316 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n3tdpxbi",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$5d384d799a8fb604 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_169wk05": (0, $7sObp.default)(__cmplp.active ? "var(--ds-text-accent-blue, #1558BC)" : "var(--ds-text-subtlest, #6B6E76)"),
            "--_hohrgu": (0, $7sObp.default)(__cmplp.isDisabled ? 'not-allowed' : 'default')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omucgo _1nj11ire",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$8b5c58bc12f52d53 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_12hn1sub",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$5f010f0938bf2ddf = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _11c8i4vh _1e0c1txw _4cvr1h6o _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$4748ec30b6814a73 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $afneb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19it1s83 _bfhkhp5a _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qs1ic2",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$3ace3579ea4ef5c6 = "var(--ds-text-subtlest, #6B6E76)";
const $21c70bc822f819a6$export$36d7978a35f7466a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$88cbb6347ed48127 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz1ap6",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$e7c72fdbfb487eeb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$ff0eb486c968b1bb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _2rko1rr0 _19itno8c _1e0c1txw _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _syazazsu _bfhk1j9a _1bah1y6m _4cvr1h6o _bfw7no8c _d0altlke _irr3l4ek",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$5d787e808dded622 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$5aea7b80ea7787ea = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEdited: isEdited, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_wilma3": (0, $7sObp.default)(__cmplp.isEdited ? 'row' : 'column'),
            "--_4ot8lk": (0, $7sObp.default)(__cmplp.isEdited ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-250, 20px)"}` : '0')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt417mq _x3doia51 _1e0c1txw _2lx2unan _4cvr1h6o _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$e0e6dbd6257adb05 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_vchhusvi _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$573f5509d5798c1e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$bc95f3ac1425888f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$2b5d58c880974a8a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rpy _1n261g80",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$6f442c0ed7b594b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rpy _1n261g80 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$7c69b4b5db21f97c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rpy _1n261g80 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$ef38e90ca3d2a41d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpv77o _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$9377d0e011027754 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _11c8i4vh _1e0c1txw _4cvr1h6o _syazazsu",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$ee9b6f758b162cc4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$3f6bc9710e818ab5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $afneb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _11c8wadc _bfhk1aqn _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _syaz15cr _k48pi7a9 _1bsb1b11 _4t3ickbl",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$71a80749568094e9 = "var(--ds-icon, #292A2E)";
const $21c70bc822f819a6$export$fd834bc8ea5358c5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _bfhkp2ly _2lx21bp4 _ca0qu2gc _u5f31jfw _n3tdu2gc _19bv1jfw",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$70b847c9bb1b1c9e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _syazqmo9 _k48p1pd9 _4cvr1h6o _18u010v4",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$fd9c97770e8fad3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _syazuq3u",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$1a4c6f3bcc66a8b8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1nu9",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$777bfb96ccd0b774 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$80e5eaef663e340d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _1e0c1txw _bfhki8nm _ca0qze3t _u5f31b66 _n3tdze3t _19bv1b66",
            __cmplp.className
        ])
    });
});
const $21c70bc822f819a6$export$39639e0da97de75b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _syaz13af _19bv1ejb _80omtlke _9oik1r31 _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});


const $26b8fa5a51a5ded2$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon, isReadingAids: isReadingAids })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        position: 'top',
        content: tooltipContent,
        children: ({ onClick: _onClick, ...tooltipProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                "aria-label": tooltipContent,
                spacing: 'none',
                appearance: isDisabled ? 'subtle-link' : 'subtle',
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$5d384d799a8fb604), {
                    active: active,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        cursor: 'pointer'
                    },
                    ...testId && {
                        'data-testid': testId
                    },
                    isDisabled: isDisabled || false,
                    isReadingAids: isReadingAids || false,
                    children: icon
                }),
                ...!isDisabled && {
                    onClick: onClickHandler
                },
                ...tooltipProps
            })
    });
};
const $26b8fa5a51a5ded2$export$c633fc044a8b8981 = ({ setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled, isReadingAids: isReadingAids } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $4xTru.onLikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent
    ]);
    const dislikeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $4xTru.onDislikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setFeedbackModal,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($26b8fa5a51a5ded2$var$FeedbackButton, {
                active: liked === true,
                onClick: likeButtonCallback,
                tooltipContent: formatMessage((0, $7lL49.messages).ai_answer_component_like_button_tooltip),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                    label: "",
                    spacing: "spacious",
                    color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`
                }),
                isDisabled: liked && likesDisabled,
                testId: "ai-answer-like-button",
                isReadingAids: isReadingAids
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($26b8fa5a51a5ded2$var$FeedbackButton, {
                active: liked === false,
                onClick: dislikeButtonCallback,
                tooltipContent: formatMessage((0, $7lL49.messages).ai_answer_component_dislike_button_tooltip),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$8b5c58bc12f52d53), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                        label: "",
                        spacing: "spacious",
                        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`
                    })
                }),
                isDisabled: !liked && likesDisabled,
                testId: "ai-answer-dislike-button",
                isReadingAids: isReadingAids
            })
        ]
    });
};


/* followup-suggestion-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $jluld = parcelRequire("jluld");
































const $2be0e2e39d556c55$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $2be0e2e39d556c55$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    queryText: "_1nmz1hna _y3gn1e5h _299m1dk0",
    whiteSpacePreWrap: "_o5721jtm",
    luminaFollowUpButtonStyleOverrides: "_2rko12b0 _bfhkhfxm"
};
const $2be0e2e39d556c55$export$f087ce3403d54eb5 = ({ omitDialogues: omitDialogues = false })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, setQuery: setQuery, updateContextCache: updateContextCache, onClose: onClose, closeParentDialog: closeParentDialog, callbacks: callbacks, showChatFollowUps: showChatFollowUps } = (0, $eRXI0.useAIAnswerContext)();
    const { followUps: followUps, query: query, answerString: answerString, searchSessionId: searchSessionId, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const showNLPFollowUps = followUps.length > 0;
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const visibleFollowUps = (0, $42omo.useMemo)(()=>{
        return showNLPFollowUps ? followUps.slice(0, 2) : serveErrorStateSuggestedQueriesExp ? errorStateSuggestedQueries.slice(0, 2) : [];
    }, [
        showNLPFollowUps,
        followUps,
        errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp
    ]);
    const showErrorStateSuggestedQueries = visibleFollowUps.length > 0 && !showNLPFollowUps;
    const onPillClick = (0, $42omo.useCallback)((followUp)=>{
        if (showChatFollowUps) publish({
            type: 'chat-new',
            source: 'sain',
            data: {
                name: followUp.substring(0, 30),
                dialogues: omitDialogues ? [] : [
                    {
                        human_message: {
                            content: query
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp,
                sourceId: searchSessionId
            }
        });
        else {
            setQuery(followUp);
            updateContextCache({
                fromFollowUp: true
            });
        }
        fireAnalyticsEvent((0, $4xTru.onFollowUpSuggestionClick)({
            ...commonAttributes,
            followUpString: followUp,
            destination: 'chat'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).FOLLOWUP_CLICKED,
            commonAttributes: commonAttributes
        });
        onClose?.();
        closeParentDialog?.();
        callbacks?.onFollowUpSuggestionClick?.();
    }, [
        fireSAINUsageEvent,
        fireAnalyticsEvent,
        commonAttributes,
        onClose,
        closeParentDialog,
        callbacks,
        publish,
        query,
        answerString,
        searchSessionId,
        setQuery,
        updateContextCache,
        showChatFollowUps,
        omitDialogues
    ]);
    const onSuggestedQueryClick = (0, $42omo.useCallback)((e, suggestedQuery)=>{
        e.preventDefault();
        e.stopPropagation();
        setQuery(suggestedQuery);
        fireAnalyticsEvent((0, $4xTru.onErrorStateSuggestedQueryClick)({
            ...commonAttributes,
            errorStateSuggestedQuery: suggestedQuery
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).ERROR_STATE_SUGGESTED_QUERY_CLICKED,
            commonAttributes: commonAttributes
        });
        onClose?.();
        closeParentDialog?.();
    }, [
        setQuery,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        onClose,
        closeParentDialog,
        commonAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (showErrorStateSuggestedQueries) fireAnalyticsEvent((0, $4xTru.onErrorStateSuggestedQueriesShown)({
            ...commonAttributes,
            showErrorStateSuggestedQueries: visibleFollowUps
        }));
    }, [
        showErrorStateSuggestedQueries,
        fireAnalyticsEvent,
        commonAttributes,
        visibleFollowUps
    ]);
    return visibleFollowUps.length > 0 ? visibleFollowUps.map((followUp, index)=>{
        if (showChatFollowUps && (0, $59vy4.SAINFeatureControl).isLuminaEnabled()) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $2be0e2e39d556c55$var$styles.luminaFollowUpButtonStyleOverrides,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))),
                onClick: ()=>onPillClick(followUp),
                testId: "smart-answer-follow-up-button",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    maxLines: 1,
                    color: "color.text.subtle",
                    weight: "medium",
                    children: followUp
                })
            }, followUp)
        });
        if (showChatFollowUps && !showErrorStateSuggestedQueries) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ab1fW.FollowUpButton), {
                onClick: ()=>onPillClick(followUp),
                followUpText: followUp,
                followUpIndex: index,
                followUpType: "UNAVAILABLE",
                experienceId: "sain"
            })
        }, followUp);
        if (showErrorStateSuggestedQueries) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: $2be0e2e39d556c55$var$styles.button,
                onClick: (e)=>onSuggestedQueryClick(e, followUp),
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $2be0e2e39d556c55$var$stylesCompiled.pillLineHeight
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.075",
                        alignBlock: "baseline",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                                color: "currentColor",
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: (0, $1Whri.cx)($2be0e2e39d556c55$var$styles.queryText, $2be0e2e39d556c55$var$styles.whiteSpacePreWrap),
                                children: followUp
                            })
                        ]
                    })
                })
            })
        }, followUp);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $21c70bc822f819a6$export$ff0eb486c968b1bb), {
                onClick: ()=>onPillClick(followUp),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        label: "",
                        color: "var(--ds-icon, #292A2E)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$5d787e808dded622), {
                        children: followUp
                    })
                ]
            })
        }, followUp);
    }) : null;
};




const $536772676f624703$var$AkFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $536772676f624703$var$AkFeedbackFlag = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $536772676f624703$export$9e8b51119c9a7742 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { brand: brand, cardTemplate: cardTemplate, sourceProduct: sourceProduct, showGenericFooter: showGenericFooter } = (0, $eRXI0.useAIAnswerContext)();
    const isSacWithCenteredFooter = sourceProduct === 'sac' && (0, $dh538.fg)('fg_search_ai-footer_sac');
    const BrandWrapper = isSacWithCenteredFooter ? (0, $21c70bc822f819a6$export$5d9a293726695cdb) : (0, $21c70bc822f819a6$export$f32f097f63664c4b);
    if (showGenericFooter) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $21c70bc822f819a6$export$f32f097f63664c4b), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $21c70bc822f819a6$export$573f5509d5798c1e), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        children: formatMessage((0, $7lL49.messages).ai_answer_dialog_footer_beta_tag)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #7A869A)",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$bc95f3ac1425888f), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$6f442c0ed7b594b3), {
                            rel: "noopener noreferrer",
                            href: (0, $f7lNm.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK),
                            target: "_blank",
                            children: formatMessage((0, $7lL49.messages).ai_answer_dialog_footer_content_quality_short)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$2b5d58c880974a8a), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$ef38e90ca3d2a41d), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$7c69b4b5db21f97c), {
                        rel: "noopener noreferrer",
                        href: (0, $f7lNm.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK),
                        target: "_blank",
                        children: formatMessage((0, $7lL49.messages).ai_answer_dialog_loaded_footer_sac)
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)(BrandWrapper, {
        "data-testid": isSacWithCenteredFooter ? 'ai-answer-brand-wrapper-centered' : 'ai-answer-brand-wrapper',
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $21c70bc822f819a6$export$573f5509d5798c1e), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #626F86)",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$bc95f3ac1425888f), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            rel: "noopener noreferrer",
                            appearance: "subtle",
                            href: sourceProduct === 'sac' ? (0, $f7lNm.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK) : (0, $f7lNm.ATLASSIAN_INTELLIGENCE_TRUST_LINK),
                            children: formatMessage(cardTemplate === (0, $f7lNm.CardTemplate).RIGHT_PANEL ? (0, $7lL49.messages).ai_answer_dialog_footer_content_quality_short : (0, $7lL49.messages).ai_answer_dialog_footer_content_quality_long)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$2b5d58c880974a8a), {
                children: brand === (0, $f7lNm.AiBrand).ROVO ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            rel: "noopener noreferrer",
                            appearance: "subtle",
                            href: (0, $f7lNm.ATLASSIAN_ROVO_LINK),
                            children: "Rovo"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)",
                            spacing: "spacious"
                        })
                    ]
                }) : sourceProduct !== 'sac' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $21c70bc822f819a6$export$ef38e90ca3d2a41d), {
                    children: [
                        formatMessage((0, $7lL49.messages).ai_answer_dialog_loaded_footer),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ6t.default), {
                            greyed: true,
                            size: 'large'
                        })
                    ]
                })
            })
        ]
    });
};
const $536772676f624703$export$3553ee90c7edebc9 = ({ showOpenChat: showOpenChat })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { query: query, answerString: answerString } = commonAttributes;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $21c70bc822f819a6$export$89b1508f9c43b29e), {
        children: [
            showOpenChat && !(0, $dh538.fg)('rovo_ai_mode_entrypoints_enabled') && /*#__PURE__*/ (0, $l998X.jsx)((0, $201eb101f1d7d1b2$export$dc40dedc9df6e59f), {
                prompt: query,
                query: query,
                answerString: answerString,
                source: 'sain'
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2be0e2e39d556c55$export$f087ce3403d54eb5), {})
        ]
    });
};
const $536772676f624703$var$AIAnswerBaseFooter = ({ showWhoAnswer: showWhoAnswer, showOpenChat: showOpenChat })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, userDetails: { name: name, id: id }, readingAidsOptions: readingAidsOptions, loading: loading, brand: brand, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    const { errorState: errorState, answerFormat: answerFormat, followUps: followUps } = commonAttributes;
    const [showFeedbackModal, setFeedbackModal] = (0, $42omo.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    const [hasConsent, setConsent] = (0, $42omo.useState)(false);
    const [topicsNotRelevant, setTopicsNotRelevant] = (0, $42omo.useState)(false);
    const feedbackContextObject = {
        searchSessionId: commonAttributes.searchSessionId,
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        topicsNotRelevant: topicsNotRelevant ? true : undefined
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $42omo.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    const toggleTopicsNotRelevantCheckbox = (0, $42omo.useCallback)(()=>{
        setTopicsNotRelevant(!topicsNotRelevant);
    }, [
        topicsNotRelevant
    ]);
    const topicsEnabled = (0, $dh538.fg)('kd_topics_in_person_card');
    const brandName = brand === (0, $f7lNm.AiBrand).ROVO ? 'Rovo' : sourceProduct === 'sac' ? '' : 'Atlassian Intelligence';
    const renderOpenChatButton = showOpenChat && showChatFollowUps && !loading && isAnswered && (0, $dh538.fg)('kd_smart_answers_open_chat');
    // Custom feedback options
    const SAC_CUSTOM_FEEDBACK_OPTIONS = [
        {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: "Wasn\u2019t relevant",
            value: 'not_relevant'
        },
        {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: "Wasn\u2019t accurate",
            value: 'not_accurate'
        },
        {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Too slow',
            value: 'too_slow'
        },
        {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Unhelpful links',
            value: 'unuseful_links'
        },
        {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Other',
            value: 'other'
        }
    ];
    const GENERIC_FEEDBACK_GROUPS_LABELS = {
        empty: {
            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_empty_option_share_label)
        },
        question: {
            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_relevance_option_label)
        },
        comment: {
            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_inaccurate_option_label)
        },
        bug: {
            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_offensive_option_label)
        },
        suggestion: {
            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_other_option_label)
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            showWhoAnswer && answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON && /*#__PURE__*/ (0, $l998X.jsx)((0, $b5c07244ed83c859$export$b03d109098afe32f), {}),
            !loading && /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$71c5dacfc0533c82), {
                isCompact: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26b8fa5a51a5ded2$export$c633fc044a8b8981), {
                    setDisplayFlag: setDisplayFlag,
                    setFeedbackModal: setFeedbackModal
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$export$9e8b51119c9a7742, {}),
            (renderOpenChatButton || followUps.length > 0) && /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$export$3553ee90c7edebc9, {
                showOpenChat: renderOpenChatButton
            }),
            showFeedbackModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                children: sourceProduct === 'sac' ? /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>setFeedbackModal(false),
                    onSubmit: ()=>{
                        setDisplayFlag(true);
                    },
                    customContent: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                        space: "space.050",
                        children: [
                            sourceProduct !== 'sac' && /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $7lL49.messages).ai_answer_component_report_consent_checkbox_label),
                                onChange: toggleConsentCheckbox,
                                isChecked: hasConsent
                            }),
                            topicsEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $7lL49.messages).ai_answer_component_topics_not_relevant_checkbox_label),
                                onChange: toggleTopicsNotRelevantCheckbox,
                                isChecked: topicsNotRelevant
                            })
                        ]
                    }),
                    atlassianAccountId: id,
                    name: name,
                    entrypointId: (0, $f7lNm.FEEDBACK_ENTRYPOINT_ID_SAIN),
                    additionalFields: [
                        {
                            id: (0, $f7lNm.FEEDBACK_CONTEXT_CF),
                            value: feedbackContext
                        }
                    ],
                    feedbackTitle: formatMessage((0, $7lL49.messages).ai_answer_component_report_modal_title, {
                        brandName: brandName
                    }),
                    feedbackTitleDetails: /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$8b91051e793e6316), {
                        children: formatMessage((0, $7lL49.messages).ai_answer_component_report_summary_label)
                    }),
                    customFeedbackOptions: SAC_CUSTOM_FEEDBACK_OPTIONS,
                    showDefaultTextFields: sourceProduct !== 'sac',
                    descriptionDefaultValue: sourceProduct === 'sac' ? 'sac feedback' : '',
                    summaryPlaceholder: formatMessage((0, $7lL49.messages).ai_answer_component_summary_placeholder_label)
                }) : /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>setFeedbackModal(false),
                    onSubmit: ()=>{
                        setDisplayFlag(true);
                    },
                    customContent: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                        space: "space.050",
                        children: [
                            sourceProduct !== 'sac' && /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $7lL49.messages).ai_answer_component_report_consent_checkbox_label),
                                onChange: toggleConsentCheckbox,
                                isChecked: hasConsent
                            }),
                            topicsEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $7lL49.messages).ai_answer_component_topics_not_relevant_checkbox_label),
                                onChange: toggleTopicsNotRelevantCheckbox,
                                isChecked: topicsNotRelevant
                            })
                        ]
                    }),
                    atlassianAccountId: id,
                    name: name,
                    entrypointId: (0, $f7lNm.FEEDBACK_ENTRYPOINT_ID_SAIN),
                    additionalFields: [
                        {
                            id: (0, $f7lNm.FEEDBACK_CONTEXT_CF),
                            value: feedbackContext
                        }
                    ],
                    feedbackTitle: formatMessage((0, $7lL49.messages).ai_answer_component_report_modal_title, {
                        brandName: brandName
                    }),
                    feedbackTitleDetails: /*#__PURE__*/ (0, $l998X.jsx)((0, $21c70bc822f819a6$export$8b91051e793e6316), {
                        children: formatMessage((0, $7lL49.messages).ai_answer_component_report_summary_label)
                    }),
                    feedbackGroupLabels: GENERIC_FEEDBACK_GROUPS_LABELS,
                    summaryPlaceholder: formatMessage((0, $7lL49.messages).ai_answer_component_summary_placeholder_label)
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $7lL49.messages).ai_answer_component_feedback_flag_description)
                    })
                })
            })
        ]
    });
};
const $536772676f624703$export$74b8b3463af67a4d = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$var$AIAnswerBaseFooter, {
        showOpenChat: true
    });
};
const $536772676f624703$var$AIAnswerDialogFooter = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$var$AIAnswerBaseFooter, {
        showWhoAnswer: true
    });
};
const $536772676f624703$export$37858bd8fa3d5915 = ()=>{
    const { isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $eRXI0.useAIAnswerContext)();
    switch(cardTemplate){
        case (0, $f7lNm.CardTemplate).SMART_ANSWER:
            return /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$export$74b8b3463af67a4d, {});
        default:
            return isReadingAids ? /*#__PURE__*/ (0, $l998X.jsx)((0, $16f998d00c2c3aa2$export$9de8ba80314e4213), {}) : /*#__PURE__*/ (0, $l998X.jsx)($536772676f624703$var$AIAnswerDialogFooter, {});
    }
};











/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 













































var $8HDcK = parcelRequire("8HDcK");











/* knowledge-smart-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $buthI = parcelRequire("buthI");


var $8tdj3 = parcelRequire("8tdj3");
















var $5TXU5 = parcelRequire("5TXU5");

var $hpUsb = parcelRequire("hpUsb");

var $8NpDA = parcelRequire("8NpDA");

var $1lLfV = parcelRequire("1lLfV");

var $8zS2j = parcelRequire("8zS2j");

var $5znEc = parcelRequire("5znEc");


var $9CM6e = parcelRequire("9CM6e");








var $ehPkL = parcelRequire("ehPkL");




const $07cd2b23ce2416f5$export$61d53a7e0f2f3df1 = {
    'Google Drive': 'Google Drive',
    Loom: 'Loom',
    Google: 'Google',
    GoogleDrive: 'GoogleDrive'
};


const $a2fc748ca8a6408e$var$messages = (0, $cgtv4.defineMessages)({
    navigate_button: {
        id: "search_ai.action_card_navigate_button",
        defaultMessage: "Navigate"
    }
});
const $a2fc748ca8a6408e$var$unboundStyles = {
    compactContainer: "_2rko1mok _19pkidpf _2hwx1wug _otyridpf _18u01wug _1h6d1l7x _1dqonqa1 _189ee4h9 _bfhksm61 _80omtlke _1e0c1txw _4cvr1h6o _1bsb1osq _p12f1gwv _1tket9kd _5pue1osq _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa",
    actionCardContainer: "_2rko1mok _4bfu1r31 _1hmsglyw _ajmmnqa1 _1h6d1l7x _1dqonqa1 _189ee4h9 _bfhksm61 _1e0c1txw _4cvr1h6o _p12f1gwv _1bsb1osq _ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi",
    actionCardButton: "_y3gnusic",
    fallbackContainer: "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi",
    embeddedCardContainer: "_1bsb1osq _umhnidpf _9xfsidpf _4d6gidpf _6tqjidpf _hmmtj0fz _1kbq1mok _172kusvi _9pbr1r31 _yeu2glyw _xne81o36 _ybkb1osq",
    richSourceCardContainer: "_1bsb1osq _12uwidpf _1ftqidpf _7wrtidpf _1gonidpf _1vzo1mok _jce3usvi _ybkb1osq _1chl1wug",
    titleBlockCss: "_zulpu2gc _13mh1pd9 _2yhz13af",
    compactTitleBlockCss: "_1hgg1qyo _137lv77o",
    footerBlockCss: "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb"
};
function $a2fc748ca8a6408e$var$constructSourceUrl({ source: source, searchSessionId: searchSessionId }) {
    if (source.product === 'Confluence' && !!searchSessionId) {
        const url = new URL(source.url);
        url.searchParams.append('search_id', searchSessionId);
        return url.toString();
    }
    return source.url;
}
var $a2fc748ca8a6408e$export$c32f46c9d34bc809 = /*#__PURE__*/ function(CardVariant) {
    CardVariant["COMPACT"] = "COMPACT";
    CardVariant["FULL"] = "FULL";
    CardVariant["DROPDOWN_SOURCE"] = "DROPDOWN_SOURCE";
    CardVariant["ACTION_CARD"] = "ACTION_CARD";
    return CardVariant;
}({});
const $a2fc748ca8a6408e$var$createCardClickHandler = (source, index, searchSessionId, onClickHandler, sourceCardType)=>(e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $01aV7.extractUrlHostname)(source.url),
            sourceCardType: sourceCardType
        });
        e.preventDefault();
        window.open($a2fc748ca8a6408e$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
const $a2fc748ca8a6408e$var$createCardErrorHandler = (componentName)=>()=>{
        (0, $4Zqgi.logger).error({
            error: new Error(`Error rendering ${componentName}`),
            functionName: componentName
        });
    };
function $a2fc748ca8a6408e$var$SimpleFallbackCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const handleClick = (e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $01aV7.extractUrlHostname)(source.url),
            sourceCardType: 'compact'
        });
        e.preventDefault();
        window.open($a2fc748ca8a6408e$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: source.url,
        xcss: $a2fc748ca8a6408e$var$unboundStyles.compactContainer,
        onClick: handleClick,
        testId: "knowledge-smart-card-fallback",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $a2fc748ca8a6408e$var$unboundStyles.fallbackContainer,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ehPkL.AppIcon), {
                        app: source.product,
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.025",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "medium",
                                weight: "medium",
                                maxLines: 1,
                                children: source.title || source.url
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtle",
                                maxLines: 1,
                                children: source.product || ''
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $a2fc748ca8a6408e$var$ActionCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a2fc748ca8a6408e$var$unboundStyles.actionCardContainer,
        testId: "knowledge-smart-card-action-card",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.150",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                            label: "",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
                            appearance: "gray",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.025",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "bold",
                                    size: "medium",
                                    maxLines: 1,
                                    children: source.title
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: source.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        appearance: "subtle",
                                        children: source.url
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $a2fc748ca8a6408e$var$unboundStyles.actionCardButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                        href: source.url,
                        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                        onClick: $a2fc748ca8a6408e$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'action-card'),
                        children: formatMessage($a2fc748ca8a6408e$var$messages.navigate_button)
                    })
                })
            ]
        })
    });
}
function $a2fc748ca8a6408e$var$CompactKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $a2fc748ca8a6408e$var$unboundStyles.compactContainer,
            testId: "knowledge-smart-card-compact",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                appearance: "block",
                url: source.url,
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: true,
                    hideBackground: true,
                    hideElevation: true,
                    size: (0, $5TXU5.SmartLinkSize).Medium,
                    removeBlockRestriction: true
                },
                fallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$SimpleFallbackCard, {
                        source: source,
                        index: index,
                        searchSessionId: searchSessionId,
                        onClickHandler: onClickHandler
                    }),
                onClick: $a2fc748ca8a6408e$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'compact'),
                onError: $a2fc748ca8a6408e$var$createCardErrorHandler('CompactKnowledgeSmartCard'),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                    maxLines: 1,
                    size: (0, $5TXU5.SmartLinkSize).Small,
                    subtitle: [
                        {
                            name: (0, $5TXU5.ElementName).Provider
                        }
                    ],
                    position: (0, $5TXU5.SmartLinkPosition).Center,
                    hideIcon: true,
                    className: (0, $gMc0m.default)([
                        $a2fc748ca8a6408e$var$unboundStyles.compactTitleBlockCss
                    ])
                })
            })
        })
    });
}
function $a2fc748ca8a6408e$var$StandardKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const footerActions = (0, $42omo.useMemo)(()=>[
            {
                name: (0, $5TXU5.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const topMetadata = [
        {
            name: (0, $5TXU5.ElementName).AuthorGroup
        },
        {
            name: (0, $5TXU5.ElementName).AssignedTo
        },
        {
            name: (0, $5TXU5.ElementName).CreatedBy
        },
        {
            name: (0, $5TXU5.ElementName).ModifiedOn
        }
    ];
    const titleMetadata = [
        {
            name: (0, $5TXU5.ElementName).State
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $a2fc748ca8a6408e$var$unboundStyles.richSourceCardContainer,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hpUsb.Card), {
                appearance: "block",
                url: source.url,
                fallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$SimpleFallbackCard, {
                        source: source,
                        index: index,
                        searchSessionId: searchSessionId,
                        onClickHandler: onClickHandler
                    }),
                ui: {
                    removeBlockRestriction: true
                },
                onClick: $a2fc748ca8a6408e$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'rich-flexible'),
                onError: $a2fc748ca8a6408e$var$createCardErrorHandler('StandardKnowledgeSmartCard'),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                        maxLines: 1,
                        metadata: titleMetadata,
                        className: (0, $gMc0m.default)([
                            $a2fc748ca8a6408e$var$unboundStyles.titleBlockCss
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1lLfV.default), {
                        primary: topMetadata,
                        maxLines: 1
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8NpDA.default), {
                        actions: footerActions,
                        className: (0, $gMc0m.default)([
                            $a2fc748ca8a6408e$var$unboundStyles.footerBlockCss
                        ])
                    })
                ]
            })
        })
    });
}
function $a2fc748ca8a6408e$var$EmbeddedKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $a2fc748ca8a6408e$var$unboundStyles.embeddedCardContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
                appearance: "embed",
                fallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$SimpleFallbackCard, {
                        source: source,
                        index: index,
                        searchSessionId: searchSessionId,
                        onClickHandler: onClickHandler
                    }),
                inheritDimensions: true,
                frameStyle: "show",
                url: source.url,
                onClick: $a2fc748ca8a6408e$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'embedded'),
                onError: $a2fc748ca8a6408e$var$createCardErrorHandler('EmbeddedKnowledgeSmartCard')
            })
        })
    });
}
function $a2fc748ca8a6408e$var$DropdownSourceSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hpUsb.Card), {
            appearance: "block",
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                size: (0, $5TXU5.SmartLinkSize).Medium,
                removeBlockRestriction: true
            },
            url: source.url,
            onClick: $a2fc748ca8a6408e$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'dropdown-source'),
            onError: $a2fc748ca8a6408e$var$createCardErrorHandler('DropdownSourceSmartCard'),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                    maxLines: 1,
                    size: (0, $5TXU5.SmartLinkSize).Medium
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                    maxLines: 2
                })
            ]
        })
    });
} /**
   * @deprecated Use KnowledgeSmartCard from @atlassian/lumina instead.
   *
   * @example
   * import { KnowledgeSmartCard } from '@atlassian/lumina';
   */ 
const $a2fc748ca8a6408e$export$dfe41ae7345cd34b = ({ source: source, variant: variant, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler })=>{
    // Apply defaults for internal components
    const internalProps = {
        source: source,
        index: index || 0,
        searchSessionId: searchSessionId || '',
        onClickHandler: onClickHandler || (()=>{})
    };
    if (variant === "COMPACT") return /*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$CompactKnowledgeSmartCard, {
        ...internalProps
    });
    if (variant === "DROPDOWN_SOURCE") return /*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$DropdownSourceSmartCard, {
        ...internalProps
    });
    if (variant === "ACTION_CARD") return /*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$ActionCard, {
        ...internalProps
    });
    const shouldUseEmbedded = source.product && source.product in (0, $07cd2b23ce2416f5$export$61d53a7e0f2f3df1);
    if (shouldUseEmbedded) return /*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$EmbeddedKnowledgeSmartCard, {
        ...internalProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($a2fc748ca8a6408e$var$StandardKnowledgeSmartCard, {
        ...internalProps
    });
};





const $8d72635bfc0b232f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    sources_title: {
        id: "search_ai.sources_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    }
});


/* source-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 






















var $j5Rp4 = parcelRequire("j5Rp4");






















const $b578d109a323f8ce$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hPQo9")).then(({ Card: Card })=>({
            default: Card
        })));
const $b578d109a323f8ce$var$resolveUrlPlaceholder = (url)=>{
    const textFragmentRegex = new RegExp('#:~:text=.*$', 'g');
    const urlWithoutTextFragment = url?.replace(textFragmentRegex, '');
    const maxLength = 30;
    const truncatedUrl = urlWithoutTextFragment.length > maxLength ? urlWithoutTextFragment.slice(0, maxLength) + '...' : urlWithoutTextFragment;
    return truncatedUrl;
};
const $b578d109a323f8ce$var$constructSourceUrl = ({ source: source, searchSessionId: searchSessionId })=>{
    if (source.product === 'Confluence') {
        const url = new URL(source.url);
        url.searchParams.append('search_id', searchSessionId);
        return url.toString();
    } else return source.url;
};
const $b578d109a323f8ce$var$fallbackComponent = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler })=>()=>{
        return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__knowledge-disc') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: $b578d109a323f8ce$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }),
            onClick: ()=>onClickHandler(index, source, (0, $01aV7.extractUrlHostname)(source.url)),
            rel: "noopener noreferrer",
            target: "_blank",
            children: source.title ?? source.url
        }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, $l998X.jsx)("a", {
            href: $b578d109a323f8ce$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }),
            onClick: ()=>onClickHandler(index, source, (0, $01aV7.extractUrlHostname)(source.url)),
            rel: "noopener noreferrer",
            target: "_blank",
            children: source.title ?? source.url
        });
    };
const $b578d109a323f8ce$export$c74cbf75d6285884 = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler, enableSmartLinkSources: enableSmartLinkSources })=>{
    const SmartLinkSource = /*#__PURE__*/ (0, $l998X.jsx)($b578d109a323f8ce$var$Card, {
        appearance: "inline",
        url: source.url,
        removeTextHighlightingFromTitle: true,
        showHoverPreview: true,
        fallbackComponent: $b578d109a323f8ce$var$fallbackComponent({
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        }),
        onClick: (e)=>{
            onClickHandler(index, source, (0, $01aV7.extractUrlHostname)(source.url));
            e.preventDefault();
            window.open($b578d109a323f8ce$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }), '_blank', 'noopener, noreferrer');
        },
        onError: ()=>{},
        resolvingPlaceholder: $b578d109a323f8ce$var$resolveUrlPlaceholder(source.url),
        placeholder: $b578d109a323f8ce$var$resolveUrlPlaceholder(source.url)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: enableSmartLinkSources ? SmartLinkSource : $b578d109a323f8ce$var$fallbackComponent({
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        })()
    });
};
const $b578d109a323f8ce$var$styles = {
    root: "_2rkopb1k _1h6d1l7x _1dqonqa1 _189ee4h9 _ltoz1xki _1e0c1txw _4t3ic4ae _1bah1fhb _n3tdpxbi _19bvpxbi _u5f3pxbi _ca0qpxbi",
    unresolvedActionContainerOuter: "_1e0c1txw _1bahh9n0 _19pk1wug",
    unresolvedActionContainerInner: "_2rko12b0 _11c8fhey _1h6d1l7x _1dqonqa1 _189ee4h9 _4cvr1h6o _bfhksm61 _syazazsu _1e0c116y _k48p1wq8 _1bah1h6o _1tke1tcg _n3tdze3t _19bvutpp _u5f3utpp _ca0qze3t _y3gn1h6o",
    footerContainer: "_19pk1wug"
};
const $b578d109a323f8ce$var$unboundStyles = {
    root: "_j2xy1txw _981a1fhb"
};
function $b578d109a323f8ce$var$sourceFlexibleSmartCardFallbackComponent({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: $b578d109a323f8ce$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }),
            onClick: ()=>onClickHandler({
                    index: index,
                    source: source,
                    hostname: (0, $01aV7.extractUrlHostname)(source.url),
                    sourceCardType: 'flexible-fallback'
                }),
            rel: "noopener noreferrer",
            target: "_blank",
            children: source.title ?? source.url
        });
}
function $b578d109a323f8ce$var$CustomUnresolvedActionContainer({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b578d109a323f8ce$var$styles.unresolvedActionContainerOuter,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $b578d109a323f8ce$var$styles.unresolvedActionContainerInner,
            children: children
        })
    });
}
function $b578d109a323f8ce$export$a3614e3c35940d79({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($b578d109a323f8ce$var$styles.root, $b578d109a323f8ce$var$unboundStyles.root),
            children: /*#__PURE__*/ (0, $l998X.jsxs)($b578d109a323f8ce$var$Card, {
                appearance: "block",
                ui: {
                    clickableContainer: true,
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    removeBlockRestriction: true
                },
                url: source.url,
                fallbackComponent: $b578d109a323f8ce$var$sourceFlexibleSmartCardFallbackComponent({
                    index: index,
                    source: source,
                    searchSessionId: searchSessionId,
                    onClickHandler: onClickHandler
                }),
                onClick: (e)=>{
                    onClickHandler({
                        index: index,
                        source: source,
                        hostname: (0, $01aV7.extractUrlHostname)(source.url),
                        sourceCardType: 'flexible'
                    });
                    e.preventDefault();
                    window.open($b578d109a323f8ce$var$constructSourceUrl({
                        source: source,
                        searchSessionId: searchSessionId
                    }), '_blank', 'noopener, noreferrer');
                },
                onError: ()=>{
                    (0, $4Zqgi.logger).error({
                        error: new Error('Error rendering source card'),
                        functionName: 'SourceFlexibleSmartCard'
                    });
                },
                resolvingPlaceholder: $b578d109a323f8ce$var$resolveUrlPlaceholder(source.url),
                placeholder: $b578d109a323f8ce$var$resolveUrlPlaceholder(source.url),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ehPkL.AppIcon), {
                                app: source.product,
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                                hideIcon: true,
                                hideRetry: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1lLfV.default), {
                        maxLines: 1,
                        primary: [
                            {
                                name: (0, $5TXU5.ElementName).AuthorGroup
                            },
                            {
                                name: (0, $5TXU5.ElementName).ModifiedOn
                            },
                            {
                                name: (0, $5TXU5.ElementName).SentOn
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                        maxLines: 2
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $b578d109a323f8ce$var$styles.footerContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8NpDA.default), {
                            actions: [
                                {
                                    name: (0, $5TXU5.ActionName).PreviewAction,
                                    hideIcon: true,
                                    size: (0, $5TXU5.SmartLinkSize).Small
                                },
                                {
                                    name: (0, $5TXU5.ActionName).CopyLinkAction,
                                    hideIcon: true,
                                    size: (0, $5TXU5.SmartLinkSize).Small
                                }
                            ],
                            hideProvider: true
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $j5Rp4.default), {
                        Container: $b578d109a323f8ce$var$CustomUnresolvedActionContainer
                    })
                ]
            })
        })
    });
}


const $7bc926104ea83677$var$CAROUSEL_SOURCE_CARD_WIDTH = 350;
const $7bc926104ea83677$var$CAROUSEL_SOURCE_OFFSET = $7bc926104ea83677$var$CAROUSEL_SOURCE_CARD_WIDTH + 16; // width + gap
const $7bc926104ea83677$var$styles = {
    cardTitle: "_19pkutpp _otyrpxbi",
    container: "_1bsb1osq _19pk12x7",
    carouselSourceCardContainer: "_1reo15vq _18m915vq _i0dl1edt _16jlidpf _1o9zidpf _o5721btx _1bsb1edt _p12f1edt"
};
const $7bc926104ea83677$var$unboundStyles = {
    smartCard: "_4t3ic8t1 _109oc8t1 _f1b9c8t1"
};
const $7bc926104ea83677$var$sourcesContainerStyles = null;
const $7bc926104ea83677$var$freeFlowLinksStyles = null;
const $7bc926104ea83677$var$Sources = ({ sources: sources, searchSessionId: searchSessionId, onClickHandler: onClickHandler, allowFreeflowLayout: allowFreeflowLayout, verticalLayout: verticalLayout, enableSmartLinkSources: enableSmartLinkSources = true })=>{
    const [showAllSources, setShowAllSources] = (0, $42omo.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const canExpand = sources.length > 1 && verticalLayout;
    const visibleSources = showAllSources || !verticalLayout ? sources : sources.slice(0, 1);
    const onExpandButtonClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onExpandButtonClicked)({
            ...commonAttributes,
            expandButtonSource: 'sources'
        }));
        setShowAllSources(!showAllSources);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllSources
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: visibleSources.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx2vrvc _ae4v1h6o _gy1p1b66",
                    allowFreeflowLayout && "_1e0c1nu9 _vwz4cs5v _2hwx12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b578d109a323f8ce$export$c74cbf75d6285884), {
                        index: index,
                        source: source,
                        searchSessionId: searchSessionId,
                        onClickHandler: onClickHandler,
                        enableSmartLinkSources: enableSmartLinkSources
                    }, `search-ai-answer-source-${index}`),
                    index === 0 && canExpand && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        onClick: onExpandButtonClick,
                        icon: (iconProps)=>showAllSources ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                color: "currentColor",
                                testId: "collapse-sources-icon",
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                color: "currentColor",
                                testId: "expand-sources-icon",
                                size: "small"
                            }),
                        label: showAllSources ? 'Collapse sources button' : 'Expand sources button',
                        spacing: "compact",
                        appearance: "subtle"
                    })
                ]
            }, `ai-answer-source-${index}`))
    });
};
const $7bc926104ea83677$var$LayoutWrapper = (props)=>{
    if (props.allowFreeflowLayout) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        children: props.children
    });
    else if (props.verticalLayout) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        space: "space.075",
        children: props.children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        space: "space.075",
        shouldWrap: true,
        children: props.children
    });
};
const $7bc926104ea83677$export$bbbfd63fa7f32357 = (props)=>{
    const { sources: ogSources, searchSessionId: searchSessionId, title: title, onClickHandler: onClickHandler = ()=>{}, allowFreeflowLayout: allowFreeflowLayout = false, verticalLayout: verticalLayout = false, limit: limit, enableSmartLinkSources: enableSmartLinkSources, isReadingAids: isReadingAids = false } = props;
    const sourcesTitle = title ?? (0, $8d72635bfc0b232f$export$defe85febe8b728c).sources_title;
    const sources = limit ? ogSources.slice(0, limit) : ogSources;
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const MaybeSmartCardProvider = enableSmartLinkSources !== false ? (0, $7bZ3i.SmartCardProvider) : (0, $42omo.Fragment);
    if (!sources.length) return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $7bc926104ea83677$var$styles.cardTitle,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        as: "h2",
                        size: "xxsmall",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtlest",
                            size: "small",
                            weight: "bold",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...sourcesTitle,
                                values: {
                                    numSources: sources.length
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $7bc926104ea83677$var$styles.container,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($7bc926104ea83677$var$LayoutWrapper, {
                        allowFreeflowLayout: allowFreeflowLayout,
                        verticalLayout: verticalLayout,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                            data: isReadingAids ? (0, $4xTru.getSmartLinksAnalyticsContextData)({
                                location: (0, $4xTru.SmartLinksAnalyticsContextLocation).AI_DEFINITION,
                                commonAttributes: commonAttributes
                            }) : (0, $4xTru.getSmartLinksAnalyticsContextData)({
                                location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                                commonAttributes: commonAttributes
                            }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)(MaybeSmartCardProvider, {
                                children: /*#__PURE__*/ (0, $l998X.jsx)($7bc926104ea83677$var$Sources, {
                                    sources: sources,
                                    searchSessionId: searchSessionId,
                                    onClickHandler: onClickHandler,
                                    allowFreeflowLayout: allowFreeflowLayout,
                                    verticalLayout: verticalLayout,
                                    enableSmartLinkSources: enableSmartLinkSources
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
function $7bc926104ea83677$var$AISourcesCarouselHeading({ numSources: numSources }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        as: "h2",
        size: "xxsmall",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            color: "color.text.subtlest",
            size: "small",
            weight: "bold",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $8d72635bfc0b232f$export$defe85febe8b728c).sources_title,
                values: {
                    numSources: numSources
                }
            })
        })
    });
}
function $7bc926104ea83677$export$919320f9832aec1d(props) {
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { sources: sources, searchSessionId: searchSessionId, onClickHandler: onClickHandler, isReadingAids: isReadingAids = false } = props;
    const serveSAINSourceRichness = (0, $dh538.fg)('kd_sain_source_richness');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $7bc926104ea83677$var$styles.container,
                testId: "ai-sources-carousel",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: isReadingAids ? (0, $4xTru.getSmartLinksAnalyticsContextData)({
                        location: (0, $4xTru.SmartLinksAnalyticsContextLocation).AI_DEFINITION,
                        commonAttributes: commonAttributes
                    }) : (0, $4xTru.getSmartLinksAnalyticsContextData)({
                        location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                        commonAttributes: commonAttributes
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d44aca612cf62bf3$export$61c045a5252abd1d), {
                            heading: /*#__PURE__*/ (0, $l998X.jsx)($7bc926104ea83677$var$AISourcesCarouselHeading, {
                                numSources: sources.length
                            }),
                            scrollOffset: $7bc926104ea83677$var$CAROUSEL_SOURCE_OFFSET,
                            children: serveSAINSourceRichness ? sources.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($7bc926104ea83677$var$styles.carouselSourceCardContainer, $7bc926104ea83677$var$unboundStyles.smartCard),
                                    children: (0, $dh538.fg)('kd_use_common_knowledge_card') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $8HDcK.KnowledgeSmartCard), {
                                        index: index,
                                        source: source,
                                        searchSessionId: searchSessionId,
                                        onClickHandler: onClickHandler
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $a2fc748ca8a6408e$export$dfe41ae7345cd34b), {
                                        index: index,
                                        source: source,
                                        searchSessionId: searchSessionId,
                                        onClickHandler: onClickHandler
                                    })
                                }, `search-ai-answer-source-${index}`)) : sources.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $7bc926104ea83677$var$styles.carouselSourceCardContainer,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b578d109a323f8ce$export$a3614e3c35940d79), {
                                        index: index,
                                        source: source,
                                        searchSessionId: searchSessionId,
                                        onClickHandler: onClickHandler
                                    })
                                }, `search-ai-answer-source-${index}`))
                        })
                    })
                })
            })
        })
    });
}














const $dcc08d64d101deb3$export$6be22f9840eb8748 = ({ aiAnswerDialogContext: aiAnswerDialogContext, isCitation: isCitation = false })=>{
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    // Validate context
    if (!aiAnswerDialogContext || !aiAnswerDialogContext.commonAttributes) throw new Error("useKnowledgeSmartCardAnalytics requires a valid AIAnswerContext. Ensure you pass the context from useAIAnswerContext().");
    const { commonAttributes: commonAttributes, callbacks: callbacks } = aiAnswerDialogContext;
    const handleSmartCardClick = (0, $42omo.useCallback)(({ index: index, source: source, hostname: hostname, sourceCardType: sourceCardType })=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceCardType: sourceCardType,
            sourceProduct: source?.product || '',
            isCitation: !!isCitation,
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source?.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        isCitation
    ]);
    return {
        handleSmartCardClick: handleSmartCardClick,
        searchSessionId: commonAttributes.searchSessionId
    };
};














function $7223e25f351c072f$export$fd29db098e42c3fc(observeTargetRef, resizeObserverCallback, pollInterval = 100, additionalDeps = []) {
    const resizeObserverRef = (0, $42omo.useRef)(null);
    const pollIntervalRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const observeDelayedTarget = ()=>{
            if (!observeTargetRef.current) return;
            // clear polling once target is ready
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
            resizeObserverRef.current = new ResizeObserver(resizeObserverCallback);
            resizeObserverRef.current.observe(observeTargetRef.current);
        };
        // start polling for the target
        observeDelayedTarget(); // check immediately
        pollIntervalRef.current = setInterval(observeDelayedTarget, pollInterval);
        return ()=>{
            if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
            if (resizeObserverRef.current) resizeObserverRef.current.disconnect();
        };
    }, [
        ...additionalDeps
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}


function $71dfce27a5e3997b$export$d112da4490f261ea(contentRef, containerRef, collapsed, additionalDeps = []) {
    const [isContentTruncated, setIsContentTruncated] = (0, $42omo.useState)(false);
    // Only measure when collapsed is true
    const measureTruncation = (0, $42omo.useCallback)(()=>{
        if (!collapsed) return;
        if (contentRef.current && containerRef.current) {
            const contentHeight = contentRef.current.getBoundingClientRect().height;
            const containerHeight = containerRef.current.getBoundingClientRect().height;
            setIsContentTruncated(contentHeight > containerHeight);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collapsed,
        contentRef,
        containerRef,
        ...additionalDeps
    ]);
    // Measure truncation and reset state when collapsed state changes
    (0, $42omo.useEffect)(()=>{
        if (!collapsed) {
            setIsContentTruncated(false);
            return;
        }
        measureTruncation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collapsed,
        contentRef,
        containerRef,
        ...additionalDeps
    ]);
    (0, $7223e25f351c072f$export$fd29db098e42c3fc)(contentRef, measureTruncation);
    return isContentTruncated;
}


/* ai-collapse.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $2AytZ = parcelRequire("2AytZ");






















const $4ca05c48d3d76392$var$styles = {
    collapsableContainer: "_1reo15vq _18m915vq _19bvpxbi _u5f3pxbi _ca0qu2gc",
    header: "_19bvpxbi _u5f3pxbi _ca0qutpp",
    pointer: "_80omtlke",
    rootCollapsed: "_4t3i68cl _1nwp1n9w",
    rootCollapsedWithReadMore: "_1reo15vq _18m915vq _4t3iucft _1bto1l2s _o5721q9c _1nwp1n9w",
    rootExpanded: "_1tke1k53",
    explicitQuestionCollapsed: "_4t3i1ogy _1nwp1n9w",
    explicitQuestionCollapsedWithReadMore: "_4t3i1018 _1bto1l2s _1nwp1n9w",
    explicitQuestionExpanded: "_1tke1q9m",
    pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80om73ad _1bsb1osq",
    luminaContainerOverrides: "_19bvze3t _u5f3ze3t _ca0qze3t",
    luminaHeaderOverrides: "_19bvze3t _u5f3ze3t _ca0qze3t",
    luminaOverrides: "_1tke1j89",
    luminaStandardSAINoverrrides: "_1tkebn52"
};
const $4ca05c48d3d76392$export$127e64693c41156a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, isCollapsed: isCollapsed, onExpandCollapse: onExpandCollapse, title: title, showReadMoreButton: showReadMoreButton, queryIntent: queryIntent, luminaAnswerType: luminaAnswerType }, forwardedRef)=>{
    const containerRef = (0, $42omo.useRef)(null);
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onExpand = ()=>{
        fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
    };
    const onCollapse = ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes));
    const handleExpandCollapse = ()=>{
        if (isCollapsed) onExpand();
        else onCollapse();
        onExpandCollapse?.();
    };
    const handleExpandCollapseButtonClick = (event)=>{
        event.stopPropagation();
        handleExpandCollapse?.();
    };
    const onContainerClick = (event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (isCollapsed && !hasHighlightedText && isClickingOnContainer) handleExpandCollapse?.();
    };
    return(// This Box click handler is just a convenience for mouse users; there's a keyboard-accessible button that supports the same functionality
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            onClick: onContainerClick,
            ref: containerRef,
            xcss: (0, $1Whri.cx)($4ca05c48d3d76392$var$styles.pressable, isCollapsed && $4ca05c48d3d76392$var$styles.pointer),
            role: "none",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    xcss: (0, $1Whri.cx)($4ca05c48d3d76392$var$styles.header, luminaAnswerType && $4ca05c48d3d76392$var$styles.luminaHeaderOverrides),
                    children: [
                        title ? title : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                        luminaAnswerType ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))),
                            label: formatMessage(isCollapsed ? (0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_expand_button : (0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_collapse_button),
                            spacing: "compact",
                            onClick: handleExpandCollapseButtonClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    ref: forwardedRef,
                    xcss: (0, $1Whri.cx)($4ca05c48d3d76392$var$styles.collapsableContainer, queryIntent === (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION ? isCollapsed ? showReadMoreButton ? $4ca05c48d3d76392$var$styles.explicitQuestionCollapsedWithReadMore : $4ca05c48d3d76392$var$styles.explicitQuestionCollapsed : $4ca05c48d3d76392$var$styles.explicitQuestionExpanded : isCollapsed ? showReadMoreButton ? $4ca05c48d3d76392$var$styles.rootCollapsedWithReadMore : $4ca05c48d3d76392$var$styles.rootCollapsed : $4ca05c48d3d76392$var$styles.rootExpanded, luminaAnswerType && $4ca05c48d3d76392$var$styles.luminaContainerOverrides, luminaAnswerType === 'LUMINA' && $4ca05c48d3d76392$var$styles.luminaOverrides, luminaAnswerType === 'STANDARD' && $4ca05c48d3d76392$var$styles.luminaStandardSAINoverrrides),
                    testId: "ai-collapse-container",
                    children: children
                })
            ]
        })
    }));
});





/* react-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $4pEXC = parcelRequire("4pEXC");

/* status-citation.tsx generated by @compiled/babel-plugin v0.36.1 */ 


























const $3574ef4ffa67c8f4$var$styles = {
    root: "_19itglyw _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke"
};
const $3574ef4ffa67c8f4$var$convertColorAppearance = (color)=>{
    switch(color){
        case 'blue':
            return 'inprogress';
        case 'green':
            return 'success';
        case 'red':
            return 'removed';
        case 'yellow':
            return 'moved';
        case 'purple':
            return 'new';
        default:
            return 'default';
    }
};
const $3574ef4ffa67c8f4$export$21553c57082a6434 = ({ localId: localId, text: text, color: color = 'blue' })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    const sources = commonAttributes.sources;
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { source: source, idx: idx } = (0, $42omo.useMemo)(()=>{
        if (!localId.includes('citation')) return {};
        const idx = parseInt(localId.split('-')?.[1]);
        return {
            source: sources[idx - 1],
            idx: idx
        };
    }, [
        localId,
        sources
    ]);
    const handleClick = (0, $42omo.useCallback)((source, idx)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: idx,
            isCitation: true,
            hostname: (0, $01aV7.extractUrlHostname)(source.url),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        });
        window.open(source.url, '_blank', 'noopener, noreferrer');
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent
    ]);
    if (!!source) return /*#__PURE__*/ (0, $l998X.jsx)((0, $90Y9A.StandaloneHoverCard), {
        url: source.url,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            xcss: $3574ef4ffa67c8f4$var$styles.root,
            onClick: ()=>{
                handleClick(source, idx);
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                appearance: "inprogress",
                children: idx
            })
        })
    });
    // Standard lozenge for status nodes
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: $3574ef4ffa67c8f4$var$convertColorAppearance(color),
        children: text
    });
};



const $f09c2f6a72ce8bd1$var$AkReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("1l2X9")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));
const $f09c2f6a72ce8bd1$var$fadeIn = null;
const $f09c2f6a72ce8bd1$var$animatedStyles = {
    container: "_y44vtk0h"
};
const $f09c2f6a72ce8bd1$var$unboundAnimatedStyles = {
    container: "_tzy4idpf",
    listItem: "_22jztk0h _cz7ridpf"
};
const $f09c2f6a72ce8bd1$var$StaggeredChild = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, index: index })=>{
    // If children is a string longer than 10 characters, split it into 3 parts
    if (typeof children === 'string' && children.length > 10) {
        const chunkSize = Math.ceil(children.length / 3);
        const parts = [
            children.slice(0, chunkSize),
            children.slice(chunkSize, chunkSize * 2),
            children.slice(chunkSize * 2)
        ];
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: parts.map((part, partIndex)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                    style: {
                        animationDelay: `${index * 200 + partIndex * 100}ms`
                    },
                    className: (0, $gMc0m.default)([
                        $f09c2f6a72ce8bd1$var$animatedStyles.container,
                        $f09c2f6a72ce8bd1$var$unboundAnimatedStyles.container
                    ]),
                    children: part
                }, partIndex))
        });
    } // For non-strings or short strings, render normally
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            animationDelay: `${index * 200}ms`
        },
        className: (0, $gMc0m.default)([
            $f09c2f6a72ce8bd1$var$animatedStyles.container,
            $f09c2f6a72ce8bd1$var$unboundAnimatedStyles.container
        ]),
        children: children
    });
});
$f09c2f6a72ce8bd1$var$StaggeredChild.displayName = 'StaggeredChild';
const $f09c2f6a72ce8bd1$var$StaggeredAnimatedParagraph = /*#__PURE__*/ (0, $42omo.memo)(({ children: children })=>{
    // Convert children to array to handle staggering
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: childrenArray.map((child, index)=>/*#__PURE__*/ (0, $l998X.jsx)($f09c2f6a72ce8bd1$var$StaggeredChild, {
                index: index,
                children: child
            }, index))
    });
});
$f09c2f6a72ce8bd1$var$StaggeredAnimatedParagraph.displayName = 'StaggeredAnimatedParagraph';
const $f09c2f6a72ce8bd1$var$AnimatedOrderedList = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("ol", {
        ...props,
        className: (0, $gMc0m.default)([
            $f09c2f6a72ce8bd1$var$animatedStyles.container,
            $f09c2f6a72ce8bd1$var$unboundAnimatedStyles.container,
            $f09c2f6a72ce8bd1$var$unboundAnimatedStyles.listItem
        ]),
        children: children
    });
});
$f09c2f6a72ce8bd1$var$AnimatedOrderedList.displayName = 'AnimatedOrderedList';
const $f09c2f6a72ce8bd1$var$AnimatedBulletedList = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("ul", {
        ...props,
        className: (0, $gMc0m.default)([
            $f09c2f6a72ce8bd1$var$animatedStyles.container,
            $f09c2f6a72ce8bd1$var$unboundAnimatedStyles.container,
            $f09c2f6a72ce8bd1$var$unboundAnimatedStyles.listItem
        ]),
        children: children
    });
});
$f09c2f6a72ce8bd1$var$AnimatedBulletedList.displayName = 'AnimatedBulletedList';
const $f09c2f6a72ce8bd1$var$AnimatedHeading = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    // Extract heading level from props (h1, h2, h3, etc.)
    const headingLevel = props.level || 1;
    const HeadingTag = `h${headingLevel}`;
    return /*#__PURE__*/ (0, $l998X.jsx)(HeadingTag, {
        ...props,
        className: (0, $gMc0m.default)([
            $f09c2f6a72ce8bd1$var$animatedStyles.container,
            $f09c2f6a72ce8bd1$var$unboundAnimatedStyles.container
        ]),
        children: children
    });
});
$f09c2f6a72ce8bd1$var$AnimatedHeading.displayName = 'AnimatedHeading'; // Create stable component references to prevent recreation
const $f09c2f6a72ce8bd1$var$StatusComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3574ef4ffa67c8f4$export$21553c57082a6434), {
        ...props
    }));
$f09c2f6a72ce8bd1$var$StatusComponent.displayName = 'StatusComponent';
const $f09c2f6a72ce8bd1$var$MediaComponent = /*#__PURE__*/ (0, $42omo.memo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}));
$f09c2f6a72ce8bd1$var$MediaComponent.displayName = 'MediaComponent';
const $f09c2f6a72ce8bd1$var$MediaSingleComponent = /*#__PURE__*/ (0, $42omo.memo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}));
$f09c2f6a72ce8bd1$var$MediaSingleComponent.displayName = 'MediaSingleComponent'; // Create stable component references
const $f09c2f6a72ce8bd1$var$StreamingParagraphComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>/*#__PURE__*/ (0, $l998X.jsx)($f09c2f6a72ce8bd1$var$StaggeredAnimatedParagraph, {
        ...props
    }));
$f09c2f6a72ce8bd1$var$StreamingParagraphComponent.displayName = 'StreamingParagraphComponent';
const $f09c2f6a72ce8bd1$var$StreamingOrderedListComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>/*#__PURE__*/ (0, $l998X.jsx)($f09c2f6a72ce8bd1$var$AnimatedOrderedList, {
        ...props
    }));
$f09c2f6a72ce8bd1$var$StreamingOrderedListComponent.displayName = 'StreamingOrderedListComponent';
const $f09c2f6a72ce8bd1$var$StreamingBulletedListComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>/*#__PURE__*/ (0, $l998X.jsx)($f09c2f6a72ce8bd1$var$AnimatedBulletedList, {
        ...props
    }));
$f09c2f6a72ce8bd1$var$StreamingBulletedListComponent.displayName = 'StreamingBulletedListComponent';
const $f09c2f6a72ce8bd1$var$StreamingHeadingComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>/*#__PURE__*/ (0, $l998X.jsx)($f09c2f6a72ce8bd1$var$AnimatedHeading, {
        ...props
    }));
$f09c2f6a72ce8bd1$var$StreamingHeadingComponent.displayName = 'StreamingHeadingComponent'; // Create stable nodeComponents objects
const $f09c2f6a72ce8bd1$var$staticNodeComponents = {
    status: $f09c2f6a72ce8bd1$var$StatusComponent,
    media: $f09c2f6a72ce8bd1$var$MediaComponent,
    mediaSingle: $f09c2f6a72ce8bd1$var$MediaSingleComponent
};
const $f09c2f6a72ce8bd1$var$animatedNodeComponents = {
    status: $f09c2f6a72ce8bd1$var$StatusComponent,
    media: $f09c2f6a72ce8bd1$var$MediaComponent,
    mediaSingle: $f09c2f6a72ce8bd1$var$MediaSingleComponent,
    paragraph: $f09c2f6a72ce8bd1$var$StreamingParagraphComponent,
    orderedList: $f09c2f6a72ce8bd1$var$StreamingOrderedListComponent,
    bulletList: $f09c2f6a72ce8bd1$var$StreamingBulletedListComponent,
    heading: $f09c2f6a72ce8bd1$var$StreamingHeadingComponent
};
function $f09c2f6a72ce8bd1$export$687d546b0584d31b({ markdown: markdown, animateComponents: animateComponents = false }) {
    const docContent = (0, $42omo.useMemo)(()=>(0, $4pEXC.encodeAdf)(markdown, true), [
        markdown
    ]);
    const enableImageSearch = (0, $dh538.fg)('hybrid_orchestrator_enable_image_search');
    const config = (0, $42omo.useMemo)(()=>{
        const nodeComponents = animateComponents ? {
            ...$f09c2f6a72ce8bd1$var$animatedNodeComponents
        } : {
            ...$f09c2f6a72ce8bd1$var$staticNodeComponents
        }; // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { media: media, mediaSingle: mediaSingle, ...nodeComponentsWithoutMediaOverrides } = nodeComponents;
        return {
            document: docContent,
            nodeComponents: enableImageSearch ? nodeComponentsWithoutMediaOverrides : nodeComponents,
            smartLinks: {
                ssr: true
            }
        };
    }, [
        docContent,
        animateComponents,
        enableImageSearch
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)($f09c2f6a72ce8bd1$var$AkReactRenderer, {
            ...config
        })
    });
}


/* read-more-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 































const $ce80d5dfebbc4c2c$var$styles = {
    container: "_18zrpxbi _1e0c1txw _ca0q12x7",
    readMoreButton: "_18zrze3t _k48p1wq8 _syaz13af _bfhksm61 _o5721q9c _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h12zz"
};
function $ce80d5dfebbc4c2c$export$e68719f9c8487320({ onClick: onClick }) {
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)(); // Fire analytics event when button is shown
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onReadMoreButtonShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Handle click with analytics
    const handleClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onReadMoreButtonClicked)(commonAttributes));
        if (!(0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).READ_MORE_BUTTON_CLICKED,
            commonAttributes: commonAttributes
        });
        onClick();
    }, [
        fireAnalyticsEvent,
        onClick,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $ce80d5dfebbc4c2c$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: handleClick,
            xcss: $ce80d5dfebbc4c2c$var$styles.readMoreButton,
            testId: "read-more-button",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "medium",
                color: "color.link",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_read_more_button
                })
            })
        })
    });
}



var $8AwZ3 = parcelRequire("8AwZ3");

const $34190cee432537e7$var$styles = {
    fullHeight: "_4t3i1osq",
    sectionContainer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66",
    sourcesTopPadding: "_ca0q1b66",
    nonInteractive: "_lcxvglyw",
    explicitQuestion: "_1tke1edt"
};
function $34190cee432537e7$export$41d38529b1c47f4e({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, queryIntent: queryIntent }) {
    const context = (0, $eRXI0.useAIAnswerContext)();
    const { commonAttributes: commonAttributes, callbacks: callbacks } = context;
    const { answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries, searchSessionId: searchSessionId } = commonAttributes;
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const renderedContentRef = (0, $42omo.useRef)(null);
    const contentContainerRef = (0, $42omo.useRef)(null);
    const completeAnswerAnalyticsEventFiredRef = (0, $42omo.useRef)(false); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $71dfce27a5e3997b$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed, [
        answerString
    ]);
    (0, $42omo.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultCompleteShown)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]);
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated;
    (0, $42omo.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const sourceClickCallback = (0, $42omo.useCallback)(({ index: index, source: source, hostname: hostname, sourceCardType: sourceCardType })=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            sourceCardType: sourceCardType,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        callbacks,
        fireSAINUsageEvent
    ]);
    const { handleSmartCardClick: handleSmartCardClick } = (0, $dcc08d64d101deb3$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        testId: "smart-answer-card-body-complete",
        xcss: (0, $1Whri.cx)($34190cee432537e7$var$styles.fullHeight, queryIntent === (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION && $34190cee432537e7$var$styles.explicitQuestion),
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                alignBlock: "stretch",
                grow: "fill",
                spread: "space-between",
                xcss: $34190cee432537e7$var$styles.fullHeight,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $4ca05c48d3d76392$export$127e64693c41156a), {
                                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    as: "h2",
                                    size: "xxsmall",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.subtlest",
                                        size: "small",
                                        weight: "bold",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $8AwZ3.messages).smart_answer_card_title
                                        })
                                    })
                                }),
                                isCollapsed: collapsed,
                                onExpandCollapse: onExpandCollapseButtonClick,
                                ref: contentContainerRef,
                                showReadMoreButton: showReadMoreButton,
                                queryIntent: queryIntent,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                                        data: (0, $4xTru.getSmartLinksAnalyticsContextData)({
                                            location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                                            commonAttributes: commonAttributes
                                        }),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                id: "ai-answer-result-section",
                                                ref: renderedContentRef,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f09c2f6a72ce8bd1$export$687d546b0584d31b), {
                                                    markdown: answerString
                                                })
                                            })
                                        })
                                    }),
                                    sources.length > 0 && (0, $59vy4.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: (0, $1Whri.cx)($34190cee432537e7$var$styles.sourcesTopPadding, collapsed && $34190cee432537e7$var$styles.nonInteractive),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$919320f9832aec1d), {
                                            sources: sources,
                                            searchSessionId: searchSessionId,
                                            onClickHandler: (0, $dh538.fg)('kd_sain_source_richness') ? handleSmartCardClick : sourceClickCallback
                                        })
                                    }) : null
                                ]
                            }),
                            showReadMoreButton && !(0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $ce80d5dfebbc4c2c$export$e68719f9c8487320), {
                                onClick: onExpandCollapseButtonClick
                            })
                        ]
                    }),
                    !collapsed && sources.length > 0 && !(0, $59vy4.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $34190cee432537e7$var$styles.sectionContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$919320f9832aec1d), {
                            sources: sources,
                            searchSessionId: searchSessionId,
                            onClickHandler: (0, $dh538.fg)('kd_sain_source_richness') ? handleSmartCardClick : sourceClickCallback
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $34190cee432537e7$var$styles.sectionContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                            showFeedbackButtons: true,
                            showCopyButton: true,
                            renderedContentRef: renderedContentRef
                        })
                    })
                ]
            }),
            !collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp ? /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$3553ee90c7edebc9), {
                showOpenChat: true
            }) : null
        ]
    });
}


/* smart-answer-card-body-streaming.tsx generated by @compiled/babel-plugin v0.36.1 */ 









































const $202ab0ef19b41287$var$styles = {
    root: "_1tkebn52",
    explicitQuestion: "_1tke1edt",
    fullHeight: "_4t3i1osq",
    disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66"
};
const $202ab0ef19b41287$export$3c0eed9572e528c8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(function SmartAnswerCardBodyStreaming({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, onVisibleTextComplete: onVisibleTextComplete, streamedTextToDisplay: streamedTextToDisplay, queryIntent: queryIntent }) {
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const resizeObserverTargetContainerRef = (0, $42omo.useRef)(null);
    const resizeObserverTargetRef = (0, $42omo.useRef)(null);
    const isVisibleTextCompleteRef = (0, $42omo.useRef)(false); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $71dfce27a5e3997b$export$d112da4490f261ea)(resizeObserverTargetRef, resizeObserverTargetContainerRef, collapsed, [
        answerString
    ]);
    const showReadMoreButton = collapsed && isContentTruncated;
    const resizeObserverCallback = (0, $42omo.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && resizeObserverTargetRef.current && resizeObserverTargetContainerRef.current) {
            const resizeObserverTargetRefHeight = resizeObserverTargetRef.current.getBoundingClientRect().height;
            const resizeObserverTargetContainerRefHeight = resizeObserverTargetContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = resizeObserverTargetRefHeight > resizeObserverTargetContainerRefHeight;
            if (isVisibleTextComplete) {
                onVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        onVisibleTextComplete
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7223e25f351c072f$export$fd29db098e42c3fc)(resizeObserverTargetRef, resizeObserverCallback);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        testId: "smart-answer-card-body-streaming",
        xcss: (0, $1Whri.cx)($202ab0ef19b41287$var$styles.root, queryIntent === (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION && $202ab0ef19b41287$var$styles.explicitQuestion),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            alignBlock: "stretch",
            grow: "fill",
            spread: "space-between",
            xcss: $202ab0ef19b41287$var$styles.fullHeight,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4ca05c48d3d76392$export$127e64693c41156a), {
                            title: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                as: "h2",
                                size: "xxsmall",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    color: "color.text.subtlest",
                                    size: "small",
                                    weight: "bold",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $8AwZ3.messages).smart_answer_card_title
                                    })
                                })
                            }),
                            isCollapsed: collapsed,
                            onExpandCollapse: onExpandCollapseButtonClick,
                            ref: resizeObserverTargetContainerRef,
                            showReadMoreButton: showReadMoreButton,
                            queryIntent: queryIntent,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                ref: resizeObserverTargetRef,
                                testId: "sain-fmp-target",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f09c2f6a72ce8bd1$export$687d546b0584d31b), {
                                            markdown: streamedTextToDisplay
                                        })
                                    })
                                })
                            })
                        }),
                        showReadMoreButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $ce80d5dfebbc4c2c$export$e68719f9c8487320), {
                            onClick: onExpandCollapseButtonClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $202ab0ef19b41287$var$styles.disclaimer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                        showFeedbackButtons: false
                    })
                })
            ]
        })
    });
}, (prevProps, nextProps)=>{
    return prevProps.collapsed === nextProps.collapsed && prevProps.streamedTextToDisplay === nextProps.streamedTextToDisplay;
});


const $970b2933c74fb6d4$var$styles = {
    fullWidth: "_1bsbauwl _p12f1osq",
    interactive: "_80omtlke",
    loadingPaddingOverrides: "_19bvutpp _u5f3utpp"
};
function $970b2933c74fb6d4$var$SmartAnswerCardComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    const [collapsed, setCollapsed] = (0, $42omo.useState)(true);
    const containerRef = (0, $42omo.useRef)(null);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $42omo.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $42omo.useState)(false);
    const componentRenderTimeRef = (0, $42omo.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $42omo.useRef)(false);
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId, queryHash: queryHash, searchSessionId: searchSessionId } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $42omo.useState)(streamingText);
    (0, $42omo.useEffect)(()=>{
        if (streamingText.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultFirstByteShown)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        streamingText,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText
    ]);
    // Notify context when collapsed state changes
    (0, $42omo.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]);
    // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $42omo.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    const handleExpandCollapseButtonClick = (0, $42omo.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $42omo.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const handleContainerClick = (event)=>{
        const selection = window.getSelection()?.toString() ?? '';
        // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0;
        // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (collapsed && !hasHighlightedText && isClickingOnContainer) {
            setCollapsed(false);
            fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    };
    if (hasError) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $970b2933c74fb6d4$var$styles.fullWidth,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e987865c989cf24e$export$ffa24cd7196ce1b0), {})
    });
    let content = null;
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse) content = /*#__PURE__*/ (0, $l998X.jsx)((0, $kF5LJ.SmartAnswerCardBodyGenerating), {
            queryIntent: queryIntent
        });
        else content = /*#__PURE__*/ (0, $l998X.jsx)((0, $202ab0ef19b41287$export$3c0eed9572e528c8), {
            cloudId: cloudId,
            collapsed: collapsed,
            onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
            onVisibleTextComplete: handleVisibleTextComplete,
            streamedTextToDisplay: streamingTextToDisplay,
            queryIntent: queryIntent
        });
        content = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                    name: "search-ai-dialog-all-text-loading"
                }),
                (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                            dataKey: "queryHash",
                            value: queryHash
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                            dataKey: "searchSessionId",
                            value: searchSessionId
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                            dataKey: "queryIntent",
                            value: queryIntent
                        })
                    ]
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                    data: {
                        queryHash: queryHash,
                        searchSessionId: searchSessionId,
                        queryIntent: queryIntent
                    }
                }),
                content
            ]
        });
    } else content = /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: collapsed ? $970b2933c74fb6d4$var$styles.interactive : undefined,
            onClick: handleContainerClick,
            ref: containerRef,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $34190cee432537e7$export$41d38529b1c47f4e), {
                collapsed: collapsed,
                onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
                queryIntent: queryIntent
            })
        })
    });
    content = /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-ai-dialog-all-text",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
            name: "search-ai-dialog-visible-text",
            children: [
                isVisibleTextComplete ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                    name: "search-ai-dialog-visible-text-loading"
                }),
                (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                            dataKey: "queryHash",
                            value: queryHash
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                            dataKey: "searchSessionId",
                            value: searchSessionId
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                            dataKey: "queryIntent",
                            value: queryIntent
                        })
                    ]
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                    data: {
                        queryHash: queryHash,
                        searchSessionId: searchSessionId,
                        queryIntent: queryIntent
                    }
                }),
                content
            ]
        })
    });
    if ((0, $59vy4.SAINFeatureControl).isLuminaEnabled()) {
        if (!isAnswered && (loading || loading === undefined)) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($970b2933c74fb6d4$var$styles.fullWidth, $970b2933c74fb6d4$var$styles.loadingPaddingOverrides),
            children: [
                content,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f7f027650ecd4d70$export$8a1fad5d74d43878), {
                    isStreaming: true,
                    showMoreButtonVisible: false
                })
            ]
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $970b2933c74fb6d4$var$styles.fullWidth,
            children: content
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eMz0l.AnimatedWrapper), {
        isAnswerComplete: isAnswered && !loading,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $970b2933c74fb6d4$var$styles.fullWidth,
            children: content
        })
    });
}
function $970b2933c74fb6d4$export$827de04ba3667da0({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "smart-answer-card",
        children: /*#__PURE__*/ (0, $l998X.jsx)($970b2933c74fb6d4$var$SmartAnswerCardComponent, {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: queryIntent
        })
    });
}


/* smart-answer-card-consolidated.tsx generated by @compiled/babel-plugin v0.36.1 */ 









































































/* 3p-banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 





























var $5G9KX = parcelRequire("5G9KX");










/* app-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

















const $f6ecdbd657bd5a1b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    bannerMessage: {
        id: "search-ai.3p-banner.message",
        defaultMessage: "Not finding what you're looking for? <text>Connect your apps to search deeper and get better answers.</text>"
    },
    dismissButtonLabel: {
        id: "search-ai.3p-banner.dismiss-button-label",
        defaultMessage: "Dismiss"
    },
    authorizationSuccess: {
        id: "search-ai.3p-banner.authorization-success",
        defaultMessage: "Account connected to {product}."
    },
    authorizationFail: {
        id: "search-ai.3p-banner.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    }
});


const $9124b44d8db9a06f$var$styles = {
    appButton: "_2rko1qi0 _1dqonqa1 _189ee4h9 _1h6d1l7x _bfhkvuon"
};
function $9124b44d8db9a06f$var$AppIcon({ config: config }) {
    const IconComponent = config.iconBorderless || config.icon;
    if (!IconComponent) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        size: "xsmall",
        label: ""
    });
} /**
   * A button component for connecting to a third-party app.
   * Handles OAuth flow when clicked.
   */ 
function $9124b44d8db9a06f$export$a60bf519950b9485({ appKey: appKey, config: config, onAppClick: onAppClick, testId: testId, useOAuthHandlers: useOAuthHandlers }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const productString = typeof config.displayName === 'string' ? config.displayName : appKey;
    const oauthResult = useOAuthHandlers?.({
        product: appKey,
        successFlagTitle: formatMessage((0, $f6ecdbd657bd5a1b$export$defe85febe8b728c).authorizationSuccess, {
            product: productString
        }),
        failFlagTitle: formatMessage((0, $f6ecdbd657bd5a1b$export$defe85febe8b728c).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: config.outboundAuthUrl || ''
    });
    const handleClick = ()=>{
        onAppClick?.(appKey, config);
        if (oauthResult?.onAuthorize) oauthResult.onAuthorize('sain-third-party-banner');
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $9124b44d8db9a06f$var$styles.appButton,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            appearance: "subtle",
            spacing: "compact",
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($9124b44d8db9a06f$var$AppIcon, {
                        config: config
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        children: config.displayName ?? appKey
                    })
                ]
            })
        })
    });
}


const $f750b999ea6d0230$export$ae853feaabdaca37 = 'atlassian.search-ai.3p-banner-dismissed';



const $422665c886017802$var$styles = {
    container: "_2rko1qi0 _ca0qutpp _n3tdutpp _19bvpxbi _u5f3utpp _bfhk1s93",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
}; /**
    * Filters and matches recommended apps against third-party configs.
    * Only returns apps where the config exists and userNeedsOAuth is true.
    */ 
function $422665c886017802$var$getDisplayableApps(recommendedApps, thirdPartyConfigs) {
    return recommendedApps.filter((appKey)=>{
        const config = thirdPartyConfigs[appKey];
        return config && config.userNeedsOAuth === true;
    }).map((appKey)=>({
            key: appKey,
            config: thirdPartyConfigs[appKey]
        }));
} /**
   * A banner component that displays recommended third-party apps for the user to connect.
   * Only shows apps that:
   * 1. Are recommended by the API
   * 2. Have a matching thirdPartyConfig
   * 3. Have userNeedsOAuth set to true
   */ 
function $422665c886017802$export$a56327d3ffcd04a6({ recommendedApps: recommendedApps, thirdPartyConfigs: thirdPartyConfigs, loading: loading = false, onAppClick: onAppClick, testId: testId = 'sain-third-party-banner', useOAuthHandlers: useOAuthHandlers }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(()=>(0, $5G9KX.getLocalStorageItem)((0, $f750b999ea6d0230$export$ae853feaabdaca37)) === true);
    const bannerShownEventFiredRef = (0, $42omo.useRef)(false);
    const displayableApps = (0, $42omo.useMemo)(()=>thirdPartyConfigs ? $422665c886017802$var$getDisplayableApps(recommendedApps, thirdPartyConfigs) : [], [
        recommendedApps,
        thirdPartyConfigs
    ]); // Fire banner shown analytics event only once when the banner is rendered
    (0, $42omo.useEffect)(()=>{
        if (!bannerShownEventFiredRef.current && !isDismissed && !loading && displayableApps.length > 0 && fireAnalyticsEvent) {
            fireAnalyticsEvent((0, $4xTru.onThirdPartyBannerShown)({
                ...commonAttributes,
                displayedAppsCount: displayableApps.length
            }));
            bannerShownEventFiredRef.current = true;
        }
    }, [
        isDismissed,
        loading,
        displayableApps,
        fireAnalyticsEvent,
        recommendedApps.length,
        commonAttributes
    ]);
    const handleAppClick = (appKey, config, appIndex)=>{
        onAppClick?.(appKey, config);
        if (fireAnalyticsEvent) fireAnalyticsEvent((0, $4xTru.onThirdPartyBannerAppClicked)({
            ...commonAttributes,
            appKey: appKey,
            appIndex: appIndex,
            displayedAppsCount: displayableApps.length
        }));
    };
    const handleDismiss = ()=>{
        if (fireAnalyticsEvent) fireAnalyticsEvent((0, $4xTru.onThirdPartyBannerDismissed)({
            ...commonAttributes,
            displayedAppsCount: displayableApps.length
        }));
        (0, $5G9KX.setLocalStorageItem)((0, $f750b999ea6d0230$export$ae853feaabdaca37), 'true');
        setIsDismissed(true);
    }; // Don't render if dismissed, loading, or no apps to display
    if (isDismissed || loading || displayableApps.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $422665c886017802$var$styles.container,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    xcss: $422665c886017802$var$styles.content,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xxsmall",
                            as: "h3",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $f6ecdbd657bd5a1b$export$defe85febe8b728c).bannerMessage,
                                values: {
                                    text: (text)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            color: "color.text.subtle",
                                            children: text
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            space: "space.100",
                            shouldWrap: true,
                            children: displayableApps.map(({ key: key, config: config }, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9124b44d8db9a06f$export$a60bf519950b9485), {
                                    appKey: key,
                                    config: config,
                                    onAppClick: (appKey, appConfig)=>handleAppClick(appKey, appConfig, index),
                                    testId: `${testId}-app`,
                                    useOAuthHandlers: useOAuthHandlers
                                }, key))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            ...iconProps,
                            size: "small"
                        }),
                    label: formatMessage((0, $f6ecdbd657bd5a1b$export$defe85febe8b728c).dismissButtonLabel),
                    appearance: "subtle",
                    spacing: "compact",
                    onClick: handleDismiss,
                    testId: `${testId}-dismiss`
                })
            ]
        })
    });
}






var $aAJEF = parcelRequire("aAJEF");




function $4f81a8b873c2ab06$export$55b55879daccf171({ userId: userId, enabled: enabled = true }) {
    const [recommendedApps, setRecommendedApps] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const fetchRecommendations = (0, $42omo.useCallback)(async ()=>{
        if (!userId || !enabled) {
            setRecommendedApps([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const recommendations = await (0, $aAJEF.getRightPanelRecommendations)({
                userId: userId
            });
            setRecommendedApps(Array.isArray(recommendations) ? recommendations : []);
        } catch (err) {
            setError(err instanceof Error ? err : new Error('Failed to fetch recommendations'));
            (0, $4Zqgi.logger).error({
                error: err,
                functionName: 'use3pRecommendedApps'
            });
            setRecommendedApps([]);
        } finally{
            setLoading(false);
        }
    }, [
        userId,
        enabled
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchRecommendations();
    }, [
        fetchRecommendations
    ]);
    return (0, $42omo.useMemo)(()=>({
            recommendedApps: recommendedApps,
            loading: loading,
            error: error
        }), [
        recommendedApps,
        loading,
        error
    ]);
}





function $0413b419acdae185$export$8f4f0a9c358684c2(streamedTextToDisplay, isStreamComplete = false) {
    const [bufferedContent, setBufferedContent] = (0, $42omo.useState)('');
    (0, $42omo.useEffect)(()=>{
        // Split by newlines to handle various line endings
        const lines = streamedTextToDisplay.split(/\r?\n|\r/);
        // If stream is complete, include all content including the last line
        if (isStreamComplete) {
            const allContent = lines.join('\n');
            if (allContent !== bufferedContent) {
                const delay = bufferedContent === '' ? 0 : 250;
                setTimeout(()=>{
                    setBufferedContent(allContent);
                }, delay);
            }
            return;
        }
        // Only update if we have more than one line (complete sections)
        if (lines.length > 1) {
            // Take everything except the last line (incomplete section)
            const completeSections = lines.slice(0, -1).join('\n');
            // Only update if the complete sections are different from what we already have
            if (completeSections !== bufferedContent) {
                // First section appears immediately, subsequent sections have delay
                const delay = bufferedContent === '' ? 0 : 250;
                setTimeout(()=>{
                    setBufferedContent(completeSections);
                }, delay);
            }
        }
    }, [
        streamedTextToDisplay,
        bufferedContent,
        isStreamComplete
    ]);
    return bufferedContent;
}









/* open-chat-input-box.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $euUgw = parcelRequire("euUgw");













var $9EtP6 = parcelRequire("9EtP6");








const $7c04b3fcd54a41ef$var$styles = {
    root: "_2rkopb1k _1reo15vq _18m915vq _v56496ys _1dqonqa1 _189ee4h9 _1h6d1l7x _1bsb1osq _1pbybfng _ca0qutpp _19bvpxbi _u5f3pxbi _n3tdutpp _bfhkhfxm _vchhusvi",
    rootShownStyles: "_1e0c1ule _tzy4kb7n",
    rootHiddenStyles: "_1e0cglyw _tzy4idpf",
    inputIconButtonWrapperStyles: "_1e0c1txw _4cvr1h6o _1bah1h6o _1pbyni7l"
};
const $7c04b3fcd54a41ef$export$ca627f6f5c214661 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const [showOpenChatInput, setShowOpenChatInput] = (0, $42omo.useState)(true);
    const [inputValue, setInputValue] = (0, $42omo.useState)('');
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { query: query, searchSessionId: searchSessionId } = commonAttributes;
    const isSendDisabled = !inputValue.trim() || inputValue.trim().length === 0;
    const handleKeyDown = (event)=>{
        if (inputValue.trim() && event.key === 'Enter') {
            event.preventDefault();
            sendToChat();
        }
    };
    const sendToChat = (0, $42omo.useCallback)(()=>{
        publish({
            type: 'chat-new',
            source: 'lumina',
            data: {
                name: query.substring(0, 30),
                dialogues: [],
                prompt: inputValue,
                sourceId: searchSessionId
            }
        });
        setShowOpenChatInput(false);
    }, [
        inputValue,
        query,
        searchSessionId,
        publish
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($7c04b3fcd54a41ef$var$styles.root, showOpenChatInput ? $7c04b3fcd54a41ef$var$styles.rootShownStyles : $7c04b3fcd54a41ef$var$styles.rootHiddenStyles),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $7c04b3fcd54a41ef$var$styles.inputIconButtonWrapperStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($iew5c))),
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                    placeholder: formatMessage((0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_open_chat_input_box_ask_rovo),
                    value: inputValue,
                    onChange: (e)=>setInputValue(e.target.value),
                    onKeyDown: handleKeyDown,
                    appearance: "none",
                    minimumRows: 1,
                    style: {
                        paddingTop: '9px'
                    },
                    testId: "lumina-input-to-chat-text-area"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $7c04b3fcd54a41ef$var$styles.inputIconButtonWrapperStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "primary",
                        isDisabled: isSendDisabled,
                        shape: "circle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
                        label: "Send query",
                        onClick: sendToChat,
                        testId: "lumina-input-to-chat-submit"
                    })
                })
            ]
        })
    });
};










const $be41cc33d0cc9810$var$MemoizedRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(function MemoizedRenderer({ contentToRender: contentToRender, showAnimation: showAnimation }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f09c2f6a72ce8bd1$export$687d546b0584d31b), {
        markdown: contentToRender,
        animateComponents: showAnimation
    }, "stable-renderer");
});
const $be41cc33d0cc9810$var$styles = {
    fullWidth: "_1bsbauwl _p12f1osq",
    interactive: "_80omtlke",
    root: "_1tkebn52",
    explicitQuestion: "_1tke1edt",
    fullHeight: "_4t3i1osq",
    disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66",
    followUpChatInputSectionStyles: "_19pkxy5q",
    disclaimerWrapperStyles: "_n3tdutpp _19bvpxbi _15a5nqa1 _1i531l7x _uwhke4h9",
    sectionContainer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66",
    sourcesTopPadding: "_ca0q1b66",
    nonInteractive: "_lcxvglyw",
    loadingPaddingOverrides: "_19bvutpp _u5f3utpp",
    standardSAINMarginOverrides: "_otyru2gc"
};
function $be41cc33d0cc9810$var$SmartAnswerCardConsolidatedComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent, useOAuthHandlers: useOAuthHandlers, thirdPartyConfigs: thirdPartyConfigs }) {
    const [collapsed, setCollapsed] = (0, $42omo.useState)(true);
    const containerRef = (0, $42omo.useRef)(null);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $42omo.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $42omo.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $42omo.useState)(false);
    const componentRenderTimeRef = (0, $42omo.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $42omo.useRef)(false);
    const context = (0, $eRXI0.useAIAnswerContext)();
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse } = context;
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $42omo.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $42omo.useRef)(false);
    const completeAnswerAnalyticsEventFiredRef = (0, $42omo.useRef)(false);
    const renderedContentRef = (0, $42omo.useRef)(null);
    const contentContainerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText
    ]); // Notify context when collapsed state changes
    (0, $42omo.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $42omo.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $42omo.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $71dfce27a5e3997b$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed, [
        streamingText
    ]); // Complete answer analytics
    (0, $42omo.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultCompleteShown)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $42omo.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleExpandCollapseButtonClick = (0, $42omo.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $42omo.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const handleContainerClick = (0, $42omo.useCallback)((event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (collapsed && !hasHighlightedText && isClickingOnContainer) {
            setCollapsed(false);
            fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    }, [
        collapsed,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    const sourceClickCallback = (0, $42omo.useCallback)(({ index: index, source: source, hostname: hostname, sourceCardType: sourceCardType })=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceCardType: sourceCardType,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    const { handleSmartCardClick: handleSmartCardClick } = (0, $dcc08d64d101deb3$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    }); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $42omo.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current && !!streamingTextToDisplay) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete,
        streamingTextToDisplay
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7223e25f351c072f$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback, 100, [
        streamingTextToDisplay
    ]);
    const bufferedContent = (0, $0413b419acdae185$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading);
    (0, $42omo.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultFirstByteShown)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Use answerString when complete, bufferedContent when streaming
    const contentToRender = isAnswered ? answerString : bufferedContent; // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $be41cc33d0cc9810$var$styles.fullWidth,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e987865c989cf24e$export$ffa24cd7196ce1b0), {})
    });
     // Early return for generating state
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse || bufferedContent.length < 1) return (0, $59vy4.SAINFeatureControl).isLuminaEnabled() ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($be41cc33d0cc9810$var$styles.fullWidth, $be41cc33d0cc9810$var$styles.loadingPaddingOverrides),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                name: "search-ai-dialog-all-text",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                        name: "search-ai-dialog-all-text-loading",
                        hold: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                        name: "search-ai-dialog-visible-text",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                                name: "search-ai-dialog-visible-text-loading",
                                hold: true
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $kF5LJ.SmartAnswerCardBodyGenerating), {
                                queryIntent: queryIntent
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $f7f027650ecd4d70$export$8a1fad5d74d43878), {
                                isStreaming: true,
                                showMoreButtonVisible: false
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $be41cc33d0cc9810$var$styles.fullWidth,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                name: "search-ai-dialog-all-text",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                        name: "search-ai-dialog-all-text-loading",
                        hold: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                        name: "search-ai-dialog-visible-text",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                                name: "search-ai-dialog-visible-text-loading",
                                hold: true
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eMz0l.AnimatedWrapper), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kF5LJ.SmartAnswerCardBodyGenerating), {
                                    queryIntent: queryIntent
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($be41cc33d0cc9810$var$styles.fullWidth, (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && $be41cc33d0cc9810$var$styles.loadingPaddingOverrides),
        testId: "smart-answer-card-consolidated",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
            name: "search-ai-dialog-all-text",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                    name: "search-ai-dialog-all-text-loading",
                    hold: loading
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                    name: "search-ai-dialog-visible-text",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                            name: "search-ai-dialog-visible-text-loading",
                            hold: !isVisibleTextComplete
                        }),
                        (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                                    dataKey: "queryHash",
                                    value: queryHash
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                                    dataKey: "searchSessionId",
                                    value: searchSessionId
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                                    dataKey: "queryIntent",
                                    value: queryIntent
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                            data: {
                                queryHash: queryHash,
                                searchSessionId: searchSessionId,
                                queryIntent: queryIntent
                            }
                        }),
                        (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsx)($be41cc33d0cc9810$var$SmartAnswerCardContent, {
                            isStreaming: isStreaming,
                            collapsed: collapsed,
                            queryIntent: queryIntent,
                            showReadMoreButton: showReadMoreButton,
                            handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
                            contentContainerRef: contentContainerRef,
                            renderedContentRef: renderedContentRef,
                            sources: sources,
                            searchSessionId: searchSessionId,
                            sourceClickCallback: (0, $dh538.fg)('kd_sain_source_richness') ? handleSmartCardClick : sourceClickCallback,
                            errorStateSuggestedQueries: errorStateSuggestedQueries,
                            serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
                            commonAttributes: commonAttributes,
                            contentToRender: contentToRender,
                            showAnimation: showAnimation,
                            handleContainerClick: handleContainerClick,
                            containerRef: containerRef,
                            useOAuthHandlers: useOAuthHandlers,
                            thirdPartyConfigs: thirdPartyConfigs
                        }),
                        !(0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $eMz0l.AnimatedWrapper), {
                            isAnswerComplete: isAnswered && !loading,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($be41cc33d0cc9810$var$SmartAnswerCardContent, {
                                isStreaming: isStreaming,
                                collapsed: collapsed,
                                queryIntent: queryIntent,
                                showReadMoreButton: showReadMoreButton,
                                handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
                                contentContainerRef: contentContainerRef,
                                renderedContentRef: renderedContentRef,
                                sources: sources,
                                searchSessionId: searchSessionId,
                                sourceClickCallback: (0, $dh538.fg)('kd_sain_source_richness') ? handleSmartCardClick : sourceClickCallback,
                                errorStateSuggestedQueries: errorStateSuggestedQueries,
                                serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
                                commonAttributes: commonAttributes,
                                contentToRender: contentToRender,
                                showAnimation: showAnimation,
                                handleContainerClick: handleContainerClick,
                                containerRef: containerRef,
                                useOAuthHandlers: useOAuthHandlers,
                                thirdPartyConfigs: thirdPartyConfigs
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $be41cc33d0cc9810$var$SmartAnswerCardContent({ isStreaming: isStreaming, collapsed: collapsed, queryIntent: queryIntent, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, sources: sources, searchSessionId: searchSessionId, sourceClickCallback: sourceClickCallback, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender, showAnimation: showAnimation, handleContainerClick: handleContainerClick, containerRef: containerRef, useOAuthHandlers: useOAuthHandlers, thirdPartyConfigs: thirdPartyConfigs }) {
    const context = (0, $eRXI0.useAIAnswerContext)();
    const { userDetails: userDetails } = context;
    const { recommendedApps: recommendedApps, loading: recommendedAppsLoading } = (0, $4f81a8b873c2ab06$export$55b55879daccf171)({
        userId: userDetails?.id,
        enabled: (0, $59vy4.SAINFeatureControl).isThirdPartyBannerEnabled()
    }); // Show 3P banner only 1/3 of the time
    const shouldShowThirdPartyBannerRateLimited = (0, $42omo.useMemo)(()=>Math.random() < 1 / 3, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(collapsed ? $be41cc33d0cc9810$var$styles.interactive : undefined, (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && $be41cc33d0cc9810$var$styles.standardSAINMarginOverrides),
        onClick: handleContainerClick,
        ref: containerRef,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            alignBlock: "stretch",
            grow: "fill",
            spread: "space-between",
            xcss: (0, $1Whri.cx)(isStreaming ? $be41cc33d0cc9810$var$styles.root : $be41cc33d0cc9810$var$styles.fullHeight, queryIntent === (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION && $be41cc33d0cc9810$var$styles.explicitQuestion),
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    alignBlock: "stretch",
                    grow: "fill",
                    spread: "space-between",
                    xcss: $be41cc33d0cc9810$var$styles.fullHeight,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $4ca05c48d3d76392$export$127e64693c41156a), {
                                    title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: (0, $1Whri.cx)((0, $59vy4.SAINFeatureControl).isLuminaEnabled() && $be41cc33d0cc9810$var$styles.standardSAINMarginOverrides),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            as: "h2",
                                            size: "xxsmall",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                color: "color.text.subtlest",
                                                size: "small",
                                                weight: "bold",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...(0, $8AwZ3.messages).smart_answer_card_title
                                                })
                                            })
                                        })
                                    }),
                                    isCollapsed: collapsed,
                                    onExpandCollapse: handleExpandCollapseButtonClick,
                                    ref: contentContainerRef,
                                    showReadMoreButton: showReadMoreButton,
                                    queryIntent: queryIntent,
                                    luminaAnswerType: (0, $59vy4.SAINFeatureControl).isLuminaEnabled() ? 'STANDARD' : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            ref: renderedContentRef,
                                            id: "ai-answer-result-section",
                                            testId: "sain-fmp-target",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                                                data: (0, $4xTru.getSmartLinksAnalyticsContextData)({
                                                    location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                                                    commonAttributes: commonAttributes
                                                }),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)($be41cc33d0cc9810$var$MemoizedRenderer, {
                                                        contentToRender: contentToRender,
                                                        showAnimation: showAnimation
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                            space: "space.100",
                                            children: [
                                                !isStreaming && sources.length > 0 && (0, $59vy4.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: (0, $1Whri.cx)($be41cc33d0cc9810$var$styles.sourcesTopPadding, collapsed && $be41cc33d0cc9810$var$styles.nonInteractive),
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$919320f9832aec1d), {
                                                        sources: sources,
                                                        searchSessionId: searchSessionId,
                                                        onClickHandler: sourceClickCallback
                                                    })
                                                }),
                                                !isStreaming && recommendedApps.length > 0 && (0, $59vy4.SAINFeatureControl).isThirdPartyBannerEnabled() && shouldShowThirdPartyBannerRateLimited && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: (0, $1Whri.cx)(sources.length <= 0 && $be41cc33d0cc9810$var$styles.sourcesTopPadding, collapsed && $be41cc33d0cc9810$var$styles.nonInteractive),
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $422665c886017802$export$a56327d3ffcd04a6), {
                                                        recommendedApps: recommendedApps,
                                                        thirdPartyConfigs: thirdPartyConfigs,
                                                        useOAuthHandlers: useOAuthHandlers,
                                                        loading: recommendedAppsLoading
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                showReadMoreButton && !(0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $ce80d5dfebbc4c2c$export$e68719f9c8487320), {
                                    onClick: handleExpandCollapseButtonClick
                                }),
                                (showReadMoreButton || isStreaming) && (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $f7f027650ecd4d70$export$8a1fad5d74d43878), {
                                    isStreaming: isStreaming,
                                    showMoreButtonVisible: showReadMoreButton,
                                    onClickShowMoreButton: handleExpandCollapseButtonClick
                                })
                            ]
                        }),
                        !isStreaming && !collapsed && sources.length > 0 && !(0, $59vy4.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $be41cc33d0cc9810$var$styles.sectionContainer,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$919320f9832aec1d), {
                                sources: sources,
                                searchSessionId: searchSessionId,
                                onClickHandler: sourceClickCallback
                            })
                        }),
                        !showReadMoreButton && !isStreaming && (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.150",
                            xcss: $be41cc33d0cc9810$var$styles.followUpChatInputSectionStyles,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                    space: "space.100",
                                    alignBlock: "center",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2be0e2e39d556c55$export$f087ce3403d54eb5), {})
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7c04b3fcd54a41ef$export$ca627f6f5c214661), {}),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $be41cc33d0cc9810$var$styles.disclaimerWrapperStyles,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                                        showFeedbackButtons: !isStreaming,
                                        showCopyButton: false,
                                        renderedContentRef: renderedContentRef
                                    })
                                })
                            ]
                        }),
                        !(0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $be41cc33d0cc9810$var$styles.disclaimer,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                                showFeedbackButtons: !isStreaming,
                                showCopyButton: !isStreaming,
                                renderedContentRef: renderedContentRef
                            })
                        })
                    ]
                }),
                !isStreaming && !(0, $59vy4.SAINFeatureControl).isLuminaEnabled() && (!collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$3553ee90c7edebc9), {
                    showOpenChat: true
                }) : null
            ]
        })
    });
}
function $be41cc33d0cc9810$export$3698d894d0a161e5({ useOAuthHandlers: useOAuthHandlers, thirdPartyConfigs: thirdPartyConfigs, onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "smart-answer-card",
        children: /*#__PURE__*/ (0, $l998X.jsx)($be41cc33d0cc9810$var$SmartAnswerCardConsolidatedComponent, {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: queryIntent,
            thirdPartyConfigs: thirdPartyConfigs,
            useOAuthHandlers: useOAuthHandlers
        })
    });
}


/* smart-answer-card-dynamic-layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $a6IPc = parcelRequire("a6IPc");






























var $fbVTr = parcelRequire("fbVTr");
























/* dynamic-layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










var $4dwEP = parcelRequire("4dwEP");

const $335d77490f3c7595$var$CITATION_REGEX = /\[\^(\d+)\^\]/g;
function $335d77490f3c7595$export$6fdccd51aa07b64f(modelOutput) {
    if (!modelOutput || typeof modelOutput !== 'string') return [];
    // Remove incomplete opening tags at the end (like "<section class="test" without closing >)
    let cleanedContent = modelOutput.replace(/<[^>]*$/, '');
    // Remove inline citation indicators from response for now
    // https://atlassian.slack.com/archives/C09KC9NV23W/p1769026048635919?thread_ts=1769020398.811119&cid=C09KC9NV23W
    cleanedContent = cleanedContent.replace($335d77490f3c7595$var$CITATION_REGEX, '');
    // Remove unclosed carousel tags and their contents to prevent rendering children
    // before the carousel wrapper is complete (which causes visual flickering)
    const carouselOpenTags = cleanedContent.match(/<carousel[^>]*>/g);
    const carouselCloseTags = cleanedContent.match(/<\/carousel>/g);
    const hasUnclosedCarousel = (carouselOpenTags?.length || 0) > (carouselCloseTags?.length || 0);
    if (hasUnclosedCarousel) {
        // Find the last unclosed carousel and remove everything from that point onwards
        const lastCarouselIndex = cleanedContent.lastIndexOf('<carousel');
        if (lastCarouselIndex >= 0) cleanedContent = cleanedContent.substring(0, lastCarouselIndex);
    }
    try {
        const root = (0, $4dwEP.parse)(cleanedContent);
        const body = root.querySelector('body') || root;
        const result = [];
        body.childNodes.forEach((element)=>{
            const jsonElement = $335d77490f3c7595$var$elementToJson(element);
            if (jsonElement) result.push(jsonElement);
        });
        return result;
    } catch  {
        return [];
    }
}
function $335d77490f3c7595$var$elementToJson(element) {
    // node types: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType === 3) {
        // text node
        const text = element.text.trim();
        return text ? text : null;
    }
    // not an element node: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType !== 1) return null;
    const htmlElement = element; // text node already processed
    const result = {
        tag: htmlElement.tagName.toLowerCase()
    };
    // Add attributes if they exist
    if (htmlElement.attributes && Object.keys(htmlElement.attributes).length > 0 && typeof result !== 'string') result.attributes = htmlElement.attributes;
    // Process children
    const children = [];
    htmlElement.childNodes.forEach((child)=>{
        // handles text + element nodes
        const childJson = $335d77490f3c7595$var$elementToJson(child);
        if (childJson) children.push(childJson);
    });
    if (children.length > 0 && typeof result !== 'string') result.children = children;
    return result;
}


/* dynamic-layout-sections.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");








function $89e3a7940b6794ca$export$52e6c7c72e88442f(element) {
    return typeof element !== 'string' && element.tag === 'h';
}


/* dynamic-layout-foldable-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























parcelRequire("42omo");




parcelRequire("42omo");

/* dynamic-layout-carousel.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $dQl1W = parcelRequire("dQl1W");




















/* dynamic-layout-person-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



















const $f7d0b4f854f4baa9$var$PersonCarouselCardStyles = {
    personCardContainer: "_2rko1mok _4bfu1r31 _1hmsglyw _ajmmnqa1 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _p12f1kdj _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa",
    contactInfoSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _18u0u2gc _1ul9idpf _1bto1l2s"
};
const $f7d0b4f854f4baa9$export$da7d0a1972db5125 = ({ component: component })=>{
    const personAttributes = component.attributes;
    const { name: name, job_title: job_title, avatar_url: avatar_url, url: url } = personAttributes || {};
    const context = (0, $eRXI0.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick } = (0, $dcc08d64d101deb3$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    const handleClick = ()=>{
        handleSmartCardClick({
            sourceCardType: 'person-card',
            index: 0,
            source: null
        });
    };
    if (!url) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: url,
        xcss: $f7d0b4f854f4baa9$var$PersonCarouselCardStyles.personCardContainer,
        testId: "dynamic-layout-person-card",
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                        appearance: "circle",
                        src: avatar_url || '',
                        size: "large"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $f7d0b4f854f4baa9$var$PersonCarouselCardStyles.contactInfoSection,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                weight: "bold",
                                size: "medium",
                                maxLines: 1,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                maxLines: 1,
                                children: job_title
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/* dynamic-layout-smart-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $JBlXx = parcelRequire("JBlXx");


const $cb17af1c96196076$var$styles = {
    smartLink: "_1bsb2hgv"
};
/**
 * Convert SmartLinkElement to KnowledgeCardSource format
 */ function $cb17af1c96196076$var$convertToKnowledgeCardSource(component, resolvedData) {
    const url = component.attributes?.url || '';
    const title = component.attributes?.title;
    return {
        id: resolvedData?.['@id'] || url,
        title: title || resolvedData?.name || url,
        url: url,
        product: resolvedData?.generator?.name || null,
        type: resolvedData?.['@type'] || 'link',
        iconUrl: resolvedData?.generator?.icon?.url || null,
        lastModified: resolvedData?.dateModified || null,
        spaceName: null,
        spaceUrl: null,
        ari: resolvedData?.ari
    };
}
const $cb17af1c96196076$export$5c7864f9e8929faf = ({ component: component, variant: variant })=>{
    const url = component.attributes?.url || '';
    const isActionCard = component.attributes?.type === 'action';
    const effectiveVariant = isActionCard ? (0, $8HDcK.CardVariant).ACTION_CARD : variant;
    const { objectResolverData: objectResolverData } = (0, $JBlXx.useFetchSmartLinkData)({
        urls: [
            url
        ]
    });
    const resolvedData = objectResolverData?.[0];
    const source = $cb17af1c96196076$var$convertToKnowledgeCardSource(component, resolvedData);
    const context = (0, $eRXI0.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $dcc08d64d101deb3$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "dynamic-layout-smart-link",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8HDcK.KnowledgeSmartCard), {
            source: source,
            variant: effectiveVariant,
            searchSessionId: searchSessionId,
            onClickHandler: handleSmartCardClick
        })
    });
};
const $cb17af1c96196076$export$6615cf55452a9648 = ({ component: component, variant: variant })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $cb17af1c96196076$var$styles.smartLink,
        children: /*#__PURE__*/ (0, $l998X.jsx)($cb17af1c96196076$export$5c7864f9e8929faf, {
            component: component,
            variant: variant
        })
    });
};


/* dynamic-layout-project-highlight-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











const $7a65a1eb46c1bc84$var$styles = {
    container: "_2rko1mok _1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    summaryBox: "_p12f1wdt"
};
const $7a65a1eb46c1bc84$export$8c4de62228787a7c = ({ component: component })=>{
    const title = component?.attributes?.title || '';
    const text = component?.attributes?.content || '';
    return title || text ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($7a65a1eb46c1bc84$var$styles.container),
        space: "space.200",
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.050",
            xcss: $7a65a1eb46c1bc84$var$styles.summaryBox,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    size: "medium",
                    maxLines: 1,
                    children: title
                }),
                text && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    maxLines: 1,
                    children: text
                })
            ]
        })
    }) : null;
};


// TODO: Fix wonky scroll behaviour on carousel
const $7d7ca4de83e6622d$var$carouselCardWidth = 355; // card width (300px) + gap (space.200 = 16px)
const $7d7ca4de83e6622d$var$scrollWidth = ($7d7ca4de83e6622d$var$carouselCardWidth + 46) * 2;
const $7d7ca4de83e6622d$var$styles = {
    carouselStyles: "_zulpu2gc _1e0c1txw _4cvr1y6m _kqswh2mm _2lx21bp4 _1bsb1osq",
    carouselStylesSingleRow: "_1e0c1txw _4cvr1y6m _kqswh2mm _2lx21bp4 _1bsb1osq _19pkmgjw",
    scrollContainerStyles: "_1reo1wug _18m915vq _1e0c1ule _1bsb1osq _1fjgglyw _1dm8q5uf",
    scrollContainerNoScroll: "_1reo15vq _18m915vq _1e0c1ule _1bsb1osq",
    cardContainerOneItem: "_zulppxbi _1e0c11p5 _yv0ehkll",
    cardContainerTwoItems: "_zulppxbi _1e0c11p5 _yv0ewxkt",
    cardContainerThreePlusItems: "_zulppxbi _1e0c11p5 _yv0e1ckl _wij21bp4 _1ejihkll",
    carouselItemStyles: "_1ul9194s _p12f1gwv",
    carouselItemStylesFoldable: "_1ul9rvwn _p12f4qx2"
};
const $7d7ca4de83e6622d$var$CarouselItemRenderer = ({ child: child, isFoldable: isFoldable })=>{
    const isPeopleCard = typeof child !== 'string' && child.tag === 'people-card';
    const isSmartLink = typeof child !== 'string' && child.tag === 'smart-link';
    const isProjectHighlight = typeof child !== 'string' && child.tag === 'project-highlight-card';
    if (isPeopleCard) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "carousel-item-people-card",
        xcss: isFoldable ? $7d7ca4de83e6622d$var$styles.carouselItemStylesFoldable : $7d7ca4de83e6622d$var$styles.carouselItemStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f7d0b4f854f4baa9$export$da7d0a1972db5125), {
            component: child
        })
    });
    if (isSmartLink) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "carousel-item-smart-link",
        xcss: isFoldable ? $7d7ca4de83e6622d$var$styles.carouselItemStylesFoldable : $7d7ca4de83e6622d$var$styles.carouselItemStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb17af1c96196076$export$5c7864f9e8929faf), {
            component: child,
            variant: (0, $8HDcK.CardVariant).COMPACT
        })
    });
    if (isProjectHighlight) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "carousel-item-project-highlight-card",
        xcss: isFoldable ? $7d7ca4de83e6622d$var$styles.carouselItemStylesFoldable : $7d7ca4de83e6622d$var$styles.carouselItemStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7a65a1eb46c1bc84$export$8c4de62228787a7c), {
            component: child
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {});
};
const $7d7ca4de83e6622d$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $7d7ca4de83e6622d$var$isScrollAtRight = (elem)=>elem ? Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $7d7ca4de83e6622d$export$53535a62c6d2f77b = ({ component: component, position: position, showArrows: showArrows = true, isFoldable: isFoldable = false })=>{
    const scrollContainerRef = (0, $42omo.useRef)(null);
    const [hideLeftScroll, setHideLeftScroll] = (0, $42omo.useState)(true);
    const [hideRightScroll, setHideRightScroll] = (0, $42omo.useState)(false);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key_id = (0, $42omo.useRef)((0, $dQl1W.v4)());
    const carouselChildren = component.children || [];
    const shouldAlignHeader = position === 'single-column';
    const updateArrowVisibility = (0, $42omo.useCallback)(()=>{
        if (scrollContainerRef.current) {
            setHideLeftScroll($7d7ca4de83e6622d$var$isScrollAtLeft(scrollContainerRef.current));
            setHideRightScroll($7d7ca4de83e6622d$var$isScrollAtRight(scrollContainerRef.current));
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer && carouselChildren.length) {
            updateArrowVisibility();
            const unbind = (0, $fFa3V.bind)(scrollContainer, {
                type: 'scroll',
                listener: updateArrowVisibility
            });
            return unbind;
        }
    }, [
        carouselChildren.length,
        updateArrowVisibility
    ]);
    const onScroll = (0, $lvsjl.default)(()=>{
        updateArrowVisibility();
    }, 30);
    const scrollLeft = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft -= $7d7ca4de83e6622d$var$scrollWidth;
    };
    const scrollRight = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft += $7d7ca4de83e6622d$var$scrollWidth;
    };
    if (!carouselChildren || carouselChildren.length < 2) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1bHXt.cx)(shouldAlignHeader ? $7d7ca4de83e6622d$var$styles.carouselStylesSingleRow : $7d7ca4de83e6622d$var$styles.carouselStyles),
        testId: "dynamic-layout-carousel",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                spread: "space-between",
                grow: "fill",
                alignBlock: "center",
                children: [
                    !shouldAlignHeader && component.attributes?.title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        space: "space.100",
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "semibold",
                            size: "small",
                            color: "color.text.accent.gray",
                            testId: "carousel-title",
                            children: component.attributes?.title
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {}),
                    showArrows && (!hideLeftScroll || !hideRightScroll) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                                label: "scroll left",
                                onClick: scrollLeft,
                                shape: "circle",
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: hideLeftScroll
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                                label: "scroll right",
                                onClick: scrollRight,
                                shape: "circle",
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: hideRightScroll
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: carouselChildren.length <= 3 ? $7d7ca4de83e6622d$var$styles.scrollContainerNoScroll : $7d7ca4de83e6622d$var$styles.scrollContainerStyles,
                ref: scrollContainerRef,
                onScroll: onScroll,
                tabIndex: carouselChildren.length > 3 ? 0 : undefined,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: carouselChildren.length === 1 ? $7d7ca4de83e6622d$var$styles.cardContainerOneItem : carouselChildren.length === 2 ? $7d7ca4de83e6622d$var$styles.cardContainerTwoItems : $7d7ca4de83e6622d$var$styles.cardContainerThreePlusItems,
                    children: carouselChildren.map((child, index)=>/*#__PURE__*/ (0, $l998X.jsx)($7d7ca4de83e6622d$var$CarouselItemRenderer, {
                            child: child,
                            index: index,
                            isFoldable: isFoldable
                        }, `${key_id}-${index}`))
                })
            })
        ]
    });
};


/* dynamic-layout-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $8jHAi = parcelRequire("8jHAi");


var $7OYaz = parcelRequire("7OYaz");


var $2Yaht = parcelRequire("2Yaht");





















const $2bd5ed5ad68b93d7$var$styles = {
    documentWrapper: "_kqswh2mm _8vu412b0 _irr3l4ek",
    invisibleLinkWrapper: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1itkglyw _bfhk1j28 _r06hglyw _1pbykb7n",
    pageIconWrapper: "_2rko12b0 _4t3izwfg _1bsbzwfg _vchhusvi _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _1bah1h6o _4cvr1h6o _bfhki8nm",
    documentMetadataIconWrapper: "_19pk1i6y _4t3i1crf _1bsb1crf",
    listDocumentWrapper: "_1bsb1osq",
    showMoreButtonWrapper: "_1bsbcmky"
};
const $2bd5ed5ad68b93d7$var$MAX_VISIBLE_DOCS = 3;
const $2bd5ed5ad68b93d7$var$InvisibleLink = ({ name: name, url: url })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: url,
        xcss: $2bd5ed5ad68b93d7$var$styles.invisibleLinkWrapper,
        "aria-label": name,
        tabIndex: -1
    });
const $2bd5ed5ad68b93d7$var$getDocumentIcon = (itemData)=>{
    if (itemData.url && itemData.url.includes('docs.google.com')) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: ""
    });
    if (itemData.url && itemData.url.includes('loom.com')) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
        color: "var(--ds-icon-discovery, #AF59E1)",
        label: ""
    });
    if (itemData.url && (itemData.url.includes('bitbucket.org') || itemData.url.includes('github.com'))) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))), {
        color: "var(--ds-icon-accent-green, #22A06B)",
        label: ""
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        color: "var(--ds-icon-brand, #1868DB)",
        label: ""
    });
};
const $2bd5ed5ad68b93d7$var$DynamicLayoutListItem = ({ itemData: itemData })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $2bd5ed5ad68b93d7$var$styles.documentWrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($2bd5ed5ad68b93d7$var$InvisibleLink, {
                name: itemData.name,
                url: itemData.url
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.150",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $2bd5ed5ad68b93d7$var$styles.pageIconWrapper,
                        children: $2bd5ed5ad68b93d7$var$getDocumentIcon(itemData)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "large",
                                        maxLines: 1,
                                        children: itemData.name
                                    }),
                                    itemData['atlassian:state'] === 'MERGED' && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                        appearance: "success",
                                        isBold: true,
                                        children: "Merged"
                                    })
                                ]
                            }),
                            itemData.generator && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $2bd5ed5ad68b93d7$var$styles.documentMetadataIconWrapper,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                            src: itemData.generator.icon?.url,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.subtle",
                                        size: "small",
                                        maxLines: 1,
                                        children: itemData.generator.name
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.subtle",
                                        size: "small",
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.subtle",
                                        size: "small",
                                        children: itemData.attributedTo?.name
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $2bd5ed5ad68b93d7$export$ad60ebd47efcfb81 = ({ component: component })=>{
    const [listExpanded, setListExpanded] = (0, $42omo.useState)(false);
    const listChildrenUrls = (0, $42omo.useMemo)(()=>(component.children || []).map((listChild)=>listChild.attributes?.url || '').filter((url)=>!!url), [
        component.children
    ]);
    const { objectResolverData: objectResolverData } = (0, $JBlXx.useFetchSmartLinkData)({
        urls: listChildrenUrls
    });
    const showMoreButtonVisible = objectResolverData.length > $2bd5ed5ad68b93d7$var$MAX_VISIBLE_DOCS;
    const numVisibleDocs = listExpanded ? objectResolverData.length : $2bd5ed5ad68b93d7$var$MAX_VISIBLE_DOCS;
    return objectResolverData.length ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $2bd5ed5ad68b93d7$var$styles.listDocumentWrapper,
        testId: "dynamic-layout-list",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            children: [
                objectResolverData.slice(0, numVisibleDocs).map((data, idx)=>/*#__PURE__*/ (0, $l998X.jsx)($2bd5ed5ad68b93d7$var$DynamicLayoutListItem, {
                        itemData: data
                    }, idx)),
                showMoreButtonVisible && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $2bd5ed5ad68b93d7$var$styles.showMoreButtonWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        onClick: ()=>setListExpanded(!listExpanded),
                        spacing: "compact",
                        children: listExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: "See less"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: "See more"
                        })
                    })
                })
            ]
        })
    }) : null;
};












var $67O0h = parcelRequire("67O0h");




const $b97648543c22c418$export$a75e4056105f395f = ({ component: component })=>{
    const markdown = component.children?.[0];
    const docContent = (0, $42omo.useMemo)(()=>markdown ? (0, $4pEXC.encodeAdf)(markdown, false) : undefined, [
        markdown
    ]);
    return docContent ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "dynamic-layout-markdown",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
            document: docContent
        })
    }) : null;
};
















const $34b084c1a32c927e$var$PROJECT_HIGHLIGHTS_SUB_AGENT_NAME = 'PROJECT_HIGHLIGHTS';
const $34b084c1a32c927e$export$86abf3cfc73e361f = ()=>{
    const { loading: loading, dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages } = (0, $eRXI0.useAIAnswerContext)();
    const projectHighlightsMessage = (0, $42omo.useMemo)(()=>{
        return $34b084c1a32c927e$var$getSubAgentMessage(dynamicLayoutSubAgentMessages, $34b084c1a32c927e$var$PROJECT_HIGHLIGHTS_SUB_AGENT_NAME);
    }, [
        dynamicLayoutSubAgentMessages
    ]);
    const carouselData = (0, $42omo.useMemo)(()=>{
        if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') return null;
        try {
            const projectData = JSON.parse(projectHighlightsMessage.data);
            const children = projectData.highlights.map((highlight)=>({
                    tag: 'project-highlight-card',
                    attributes: {
                        title: highlight.title,
                        content: highlight.content
                    }
                }));
            const carouselComponent = {
                tag: 'carousel',
                children: children
            };
            return carouselComponent;
        } catch (error) {
            return null;
        }
    }, [
        projectHighlightsMessage?.data
    ]);
    if (loading && !projectHighlightsMessage?.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        width: "200px",
        height: "16px",
        isShimmering: true
    });
    if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') return null;
    if (!carouselData) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7d7ca4de83e6622d$export$53535a62c6d2f77b), {
        component: carouselData,
        position: "two-rows-bottom",
        showArrows: false
    });
};
const $34b084c1a32c927e$var$getSubAgentMessage = (messages, subAgentName)=>{
    return messages.find((message)=>message.sub_agent_name === subAgentName);
};


















const $023f3246ca80f9d2$var$RELATED_PEOPLE_SUB_AGENT_NAME = 'ENTITY_RELATED_PEOPLE';
const $023f3246ca80f9d2$export$2f4dfd3f449abf1b = ()=>{
    const { loading: loading, dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages } = (0, $eRXI0.useAIAnswerContext)();
    const relatedPeopleMessage = (0, $42omo.useMemo)(()=>{
        return $023f3246ca80f9d2$var$getSubAgentMessage(dynamicLayoutSubAgentMessages, $023f3246ca80f9d2$var$RELATED_PEOPLE_SUB_AGENT_NAME);
    }, [
        dynamicLayoutSubAgentMessages
    ]);
    const carouselData = (0, $42omo.useMemo)(()=>{
        if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') return null;
        try {
            const peopleData = JSON.parse(relatedPeopleMessage.data);
            const children = peopleData.people.map((person)=>({
                    tag: 'people-card',
                    attributes: {
                        name: person.name,
                        job_title: person.jobTitle,
                        avatar_url: person.avatarUrl,
                        url: person.url
                    }
                }));
            const carouselComponent = {
                tag: 'carousel',
                attributes: {
                    title: 'Related People'
                },
                children: children
            };
            return carouselComponent;
        } catch (error) {
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'carouselData'
            });
            return null;
        }
    }, [
        relatedPeopleMessage?.data
    ]);
    if (loading && !relatedPeopleMessage?.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        width: "200px",
        height: "16px",
        isShimmering: true
    });
    if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') return null;
    if (!carouselData) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7d7ca4de83e6622d$export$53535a62c6d2f77b), {
        component: carouselData,
        position: "two-rows-bottom"
    });
};
const $023f3246ca80f9d2$var$getSubAgentMessage = (messages, subAgentName)=>{
    return messages.find((message)=>message.sub_agent_name === subAgentName);
};


const $786b555aa3923a71$export$84b484f69b67f84e = ({ component: component, position: position, isFoldable: isFoldable = false, variant: variant })=>{
    if (!component || typeof component !== 'string' && !component.tag) return null;
    if (typeof component !== 'string') switch(component.tag){
        case 'md':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b97648543c22c418$export$a75e4056105f395f), {
                component: component
            });
        case 'list':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2bd5ed5ad68b93d7$export$ad60ebd47efcfb81), {
                component: component
            });
        case 'smart-link':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $cb17af1c96196076$export$6615cf55452a9648), {
                component: component,
                variant: variant
            });
        case 'carousel':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $7d7ca4de83e6622d$export$53535a62c6d2f77b), {
                component: component,
                position: position,
                isFoldable: isFoldable
            });
        case 'action-card':
            {
                const actionCard = component;
                // Validate component has a url and convert to smart-link
                if (actionCard.attributes?.url) {
                    const smartLinkComponent = {
                        tag: 'smart-link',
                        attributes: {
                            url: actionCard.attributes.url,
                            title: actionCard.attributes?.title,
                            type: 'action',
                            pos: actionCard.attributes?.pos
                        }
                    };
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cb17af1c96196076$export$6615cf55452a9648), {
                        component: smartLinkComponent,
                        variant: variant
                    });
                }
                return null;
            }
        case 'related-people':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $023f3246ca80f9d2$export$2f4dfd3f449abf1b), {});
        case 'project-highlights':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $34b084c1a32c927e$export$86abf3cfc73e361f), {});
        default:
            return null;
    }
    return null;
};


const $4faaacc8d9a374ca$var$REQUIRED_ELEMENTS_COUNT = 1;
const $4faaacc8d9a374ca$export$1a9cda7e8be08d8 = ({ elements: elements, isFoldable: isFoldable = false })=>{
    if (elements.length < $4faaacc8d9a374ca$var$REQUIRED_ELEMENTS_COUNT) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $786b555aa3923a71$export$84b484f69b67f84e), {
        component: elements[0],
        position: "single-column",
        isFoldable: isFoldable
    });
};


const $2206160a80988a61$var$unboundedStyles = {
    root: "_19pkpxbi _1bsb1osq",
    contentWrapper: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    contentExpanded: "_c71ldgin",
    contentCollapsed: "_1reo15vq _18m915vq _c71lvbgk _1e0ccj1k _sudp1e54 _1yyjkb7n",
    pointer: "_80omtlke"
};
const $2206160a80988a61$var$styles = {
    divider: "_15a5nqa1 _uwhke4h9 _1i531l7x _19pkpxbi",
    headerWrapper: "_otyru2gc"
};
const $2206160a80988a61$export$1f15b0b67d49b0f6 = ({ defaultFoldedState: defaultFoldedState, header: header, content: content, children: children })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const [isFolded, setIsFolded] = (0, $42omo.useState)(defaultFoldedState === 'collapsed');
    const sectionKey = `folded-section-${header?.children || ''}`;
    const handleKeyDown = (event)=>{
        if ((event.key === 'Enter' || event.key === ' ') && isFolded) {
            event.preventDefault();
            setIsFolded(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "dynamic-layout-foldable-section",
        className: (0, $gMc0m.default)([
            $2206160a80988a61$var$unboundedStyles.root,
            isFolded && $2206160a80988a61$var$unboundedStyles.pointer
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: isFolded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))),
                        label: `${isFolded ? 'expand' : 'collapsed'} section`,
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setIsFolded(!isFolded),
                        testId: isFolded ? 'expand-button' : 'collapse-button',
                        "aria-expanded": !isFolded
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        ref: containerRef,
                        onClick: ()=>setIsFolded(false),
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        role: "button",
                        "data-testid": "dynamic-layout-foldable-clickable-section",
                        className: (0, $gMc0m.default)([
                            $2206160a80988a61$var$unboundedStyles.contentWrapper,
                            isFolded ? $2206160a80988a61$var$unboundedStyles.contentCollapsed : $2206160a80988a61$var$unboundedStyles.contentExpanded
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                alignBlock: "center",
                                xcss: $2206160a80988a61$var$styles.headerWrapper,
                                children: header && header.attributes?.show !== 'false' && content && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "bold",
                                    children: header && header.children
                                })
                            }),
                            isFolded ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4faaacc8d9a374ca$export$1a9cda7e8be08d8), {
                                elements: content
                            }, `${sectionKey}-collapsed`) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                children: children
                            }, `${sectionKey}-expanded`)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $2206160a80988a61$var$styles.divider
            })
        ]
    });
};



/* two-column-layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");














const $43cc476783bdbea3$export$7cd3afc49691a77e = (elements, position, defaultIndex)=>{
    const result = [];
    for(let i = 0; i < elements.length; i++){
        const element = elements[i];
        if (typeof element === 'string') continue;
        if (element.attributes?.pos === position || i === defaultIndex && !element.attributes?.pos) result.push(element);
    }
    return result;
};


// Tags that represent text content
const $9a29309e6341ccff$var$TEXT_CONTENT_TAGS = [
    'md',
    'list'
];
// Tags that represent smart links
const $9a29309e6341ccff$var$SMART_LINK_TAGS = [
    'smart-link',
    'action-card'
];
// Max height of a full-size smart link card
const $9a29309e6341ccff$var$FULL_SMART_LINK_CARD_MAX_HEIGHT = 174;
const $9a29309e6341ccff$export$88261377d3b4456a = $9a29309e6341ccff$var$FULL_SMART_LINK_CARD_MAX_HEIGHT * 0.75;
/**
 * Check if an element is text content (markdown or list)
 */ const $9a29309e6341ccff$var$isTextContent = (element)=>typeof element !== 'string' && $9a29309e6341ccff$var$TEXT_CONTENT_TAGS.includes(element.tag);
/**
 * Check if an element is a smart link
 */ const $9a29309e6341ccff$var$isSmartLink = (element)=>typeof element !== 'string' && $9a29309e6341ccff$var$SMART_LINK_TAGS.includes(element.tag);
function $9a29309e6341ccff$export$e6011e70d0aef97f(elements) {
    const textContentRef = (0, $42omo.useRef)(null);
    const [textHeight, setTextHeight] = (0, $42omo.useState)(null);
    // Measure text content height after render
    const handleResize = (0, $42omo.useCallback)((entries)=>{
        const entry = entries[0];
        if (entry) setTextHeight(entry.contentRect.height);
    }, []);
    (0, $7223e25f351c072f$export$fd29db098e42c3fc)(textContentRef, handleResize);
    // Separate elements by position
    const leftElements = (0, $43cc476783bdbea3$export$7cd3afc49691a77e)(elements, 'left', 0);
    const rightElements = (0, $43cc476783bdbea3$export$7cd3afc49691a77e)(elements, 'right', 1);
    // Determine which column has text content and which has smart links
    const leftHasText = leftElements.some($9a29309e6341ccff$var$isTextContent);
    const rightHasSmartLink = rightElements.some($9a29309e6341ccff$var$isSmartLink);
    const leftHasSmartLink = leftElements.some($9a29309e6341ccff$var$isSmartLink);
    const rightHasText = rightElements.some($9a29309e6341ccff$var$isTextContent);
    // Determine card variant based on measured text height
    // Default to compact card and when text content is shorter than 75% of the full-size smart card height
    const isTextMeasured = textHeight !== null;
    const useCompactCard = !isTextMeasured || isTextMeasured && textHeight <= $9a29309e6341ccff$export$88261377d3b4456a;
    const cardVariant = useCompactCard ? (0, $8HDcK.CardVariant).COMPACT : (0, $8HDcK.CardVariant).FULL;
    // Determine which column should have the ref for measurement
    // Left column takes precedence when both columns would need measurement
    // (since only one ref can be attached at a time)
    const leftNeedsMeasurement = leftHasText && rightHasSmartLink;
    const rightNeedsMeasurement = rightHasText && leftHasSmartLink && !leftNeedsMeasurement;
    return {
        textContentRef: textContentRef,
        isTextMeasured: isTextMeasured,
        cardVariant: cardVariant,
        leftNeedsMeasurement: leftNeedsMeasurement,
        rightNeedsMeasurement: rightNeedsMeasurement,
        leftElements: leftElements,
        rightElements: rightElements
    };
}


const $ca6dda496424237e$var$styles = {
    leftColumnStyles: "_16jlkb7n _1o9zkb7n _1ul9idpf",
    rightColumnStyles: "_1o9zidpf _1ul9idpf"
};
const $ca6dda496424237e$var$REQUIRED_ELEMENTS_COUNT = 1;
const $ca6dda496424237e$var$getElementKey = ({ key: key, pos: pos, index: index })=>{
    if (key && pos) return `${key}-${pos}-${index}`;
    if (key) return `${key}-${index}`;
    if (pos) return `${pos}-${index}`;
    return index;
};
const $ca6dda496424237e$export$db5b24d9942615e8 = ({ elements: elements, key: key, isFoldable: isFoldable = false })=>{
    const { textContentRef: textContentRef, leftNeedsMeasurement: leftNeedsMeasurement, rightNeedsMeasurement: rightNeedsMeasurement, leftElements: leftElements, rightElements: rightElements, cardVariant: cardVariant } = (0, $9a29309e6341ccff$export$e6011e70d0aef97f)(elements);
    if (elements.length < $ca6dda496424237e$var$REQUIRED_ELEMENTS_COUNT) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.200",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $ca6dda496424237e$var$styles.leftColumnStyles,
                ref: leftNeedsMeasurement ? textContentRef : undefined,
                testId: "two-column-layout-left",
                children: leftElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $786b555aa3923a71$export$84b484f69b67f84e), {
                        component: element,
                        position: "two-columns-left",
                        isFoldable: isFoldable,
                        variant: cardVariant
                    }, $ca6dda496424237e$var$getElementKey({
                        key: key,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $ca6dda496424237e$var$styles.rightColumnStyles,
                ref: rightNeedsMeasurement ? textContentRef : undefined,
                testId: "two-column-layout-right",
                children: rightElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $786b555aa3923a71$export$84b484f69b67f84e), {
                        component: element,
                        position: "two-columns-right",
                        isFoldable: isFoldable,
                        variant: cardVariant
                    }, $ca6dda496424237e$var$getElementKey({
                        key: key,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            })
        ]
    });
};


/* two-row-layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








const $5dc93f625fecae22$var$styles = {
    rowStyle: "_1bsb1osq"
};
const $5dc93f625fecae22$var$REQUIRED_ELEMENTS_COUNT = 1;
const $5dc93f625fecae22$var$getElementKey = ({ key: key, pos: pos, index: index })=>{
    if (key && pos) return `${key}-${pos}-${index}`;
    if (key) return `${key}-${index}`;
    if (pos) return `${pos}-${index}`;
    return index;
};
const $5dc93f625fecae22$export$1d297c974620e1b5 = ({ elements: elements, key: key, isFoldable: isFoldable = false })=>{
    if (elements.length < $5dc93f625fecae22$var$REQUIRED_ELEMENTS_COUNT) return null;
    const topElements = (0, $43cc476783bdbea3$export$7cd3afc49691a77e)(elements, 'top', 0);
    const bottomElements = (0, $43cc476783bdbea3$export$7cd3afc49691a77e)(elements, 'bottom', 1);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $5dc93f625fecae22$var$styles.rowStyle,
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $5dc93f625fecae22$var$styles.rowStyle,
                children: topElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $786b555aa3923a71$export$84b484f69b67f84e), {
                        component: element,
                        position: "two-rows-top",
                        isFoldable: isFoldable
                    }, $5dc93f625fecae22$var$getElementKey({
                        key: key,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $5dc93f625fecae22$var$styles.rowStyle,
                children: bottomElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $786b555aa3923a71$export$84b484f69b67f84e), {
                        component: element,
                        position: "two-rows-bottom",
                        isFoldable: isFoldable
                    }, $5dc93f625fecae22$var$getElementKey({
                        key: key,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            })
        ]
    });
};


const $4abe52b1ef0b0aca$var$styles = {
    overviewStyle: "_2rko1mok _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhkhfxm _otyrpxbi",
    sectionWrapperStyles: "_19pk1ejb"
};
const $4abe52b1ef0b0aca$export$62abb2537ec99d20 = ({ section: section, defaultFoldedState: defaultFoldedState })=>{
    const layout = section.attributes?.layout || 'one-column';
    const isOverview = section.attributes?.overview === '1';
    const isFoldable = section.attributes?.hasOwnProperty('folded');
    let header;
    let content;
    if (Array.isArray(section.children)) {
        const headerElement = section.children.filter((element)=>(0, $89e3a7940b6794ca$export$52e6c7c72e88442f)(element));
        if (headerElement.length) header = headerElement[0];
        content = section.children?.filter((element)=>!(0, $89e3a7940b6794ca$export$52e6c7c72e88442f)(element));
    }
    if (!content || content && !content.length) return null;
    const renderContent = ()=>{
        switch(layout){
            case 'one-column':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $4faaacc8d9a374ca$export$1a9cda7e8be08d8), {
                    elements: content,
                    isFoldable: isFoldable
                });
            case 'two-columns':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ca6dda496424237e$export$db5b24d9942615e8), {
                    elements: content,
                    isFoldable: isFoldable
                }, section.attributes?.n);
            case 'two-rows':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $5dc93f625fecae22$export$1d297c974620e1b5), {
                    elements: content,
                    isFoldable: isFoldable
                }, section.attributes?.n);
        }
    };
    if (defaultFoldedState) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2206160a80988a61$export$1f15b0b67d49b0f6), {
        defaultFoldedState: defaultFoldedState,
        header: header,
        content: content,
        children: renderContent()
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        alignInline: "start",
        xcss: (0, $1bHXt.cx)(isOverview && $4abe52b1ef0b0aca$var$styles.overviewStyle),
        testId: "dynamic-layout-section",
        "data-layout": layout,
        "data-overview": isOverview,
        children: [
            header && header.attributes?.show !== 'false' && content && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                xcss: $4abe52b1ef0b0aca$var$styles.sectionWrapperStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    children: header && header.children
                })
            }),
            renderContent()
        ]
    });
};


const $0ede3cab708576aa$export$8a161f487bc08d6e = (parsedAnswer)=>{
    let firstFoldableSectionIdx = -1;
    for(let i = 0; i < parsedAnswer.length; i++)if (parsedAnswer[i].attributes?.hasOwnProperty('folded')) {
        firstFoldableSectionIdx = i;
        break;
    }
    return firstFoldableSectionIdx;
};


const $05bff8634172f0be$var$styles = {
    containerStyles: "_y3gn1e5h"
};
const $05bff8634172f0be$export$21094bc4b0d39e4b = ({ contentToRender: contentToRender })=>{
    const parsedAnswer = (0, $335d77490f3c7595$export$6fdccd51aa07b64f)(contentToRender);
    const firstFoldableIndex = (0, $0ede3cab708576aa$export$8a161f487bc08d6e)(parsedAnswer);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $05bff8634172f0be$var$styles.containerStyles,
            testId: "dynamic-layout-container",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                children: parsedAnswer && parsedAnswer.length && parsedAnswer.map((section, index)=>{
                    const isFoldable = section.attributes?.hasOwnProperty('folded');
                    const defaultFoldedState = isFoldable ? index === firstFoldableIndex ? 'expanded' : 'collapsed' : undefined;
                    return(// TODO: rename this component to be singular
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4abe52b1ef0b0aca$export$62abb2537ec99d20), {
                        section: section,
                        defaultFoldedState: defaultFoldedState
                    }, index));
                })
            })
        })
    });
};


/* dynamic-layout-sources-dropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");
















parcelRequire("42omo");





var $dN2lk = parcelRequire("dN2lk");

const $cf600ec688712ec4$var$DEFAULT_MAX_SOURCES_IN_STACK = 3;
function $cf600ec688712ec4$export$ebff7094edd1bb81({ maxSourcesInStack: maxSourcesInStack, sources: sources, testId: testId }) {
    if (sources.length === 0) return null;
    const sourcesForIconStack = [];
    const sourceProductsMap = {};
    maxSourcesInStack = maxSourcesInStack ?? $cf600ec688712ec4$var$DEFAULT_MAX_SOURCES_IN_STACK;
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        if (source.product && !sourceProductsMap[source.product]) {
            sourcesForIconStack.push(source);
            sourceProductsMap[source.product] = true;
        } else if (!source.product && !sourceProductsMap.Unknown) {
            sourcesForIconStack.push(source);
            sourceProductsMap.Unknown = true;
        }
        if (sourcesForIconStack.length === maxSourcesInStack) break;
    }
    const appIcons = sourcesForIconStack.map((source)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ehPkL.AppIcon), {
            app: source.product,
            "data-testid": `app-icon-${source.ari}`,
            size: "xxsmall"
        }, source.ari));
    return appIcons.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dN2lk.IconStack), {
        testId: testId,
        children: appIcons
    }) : null;
}


const $dd3f8fbce9cee668$var$messages = (0, $cgtv4.defineMessages)({
    sources_text: {
        id: "search_ai.dynamic_layout_sources_text",
        defaultMessage: "{numSources, plural, one {Source} other {Sources}}"
    },
    sources_group_title: {
        id: "search_ai.dynamic_layout_sources_group_title",
        defaultMessage: "{numSources, plural, one {{numSources, number} Source} other {{numSources, number} Sources}}"
    }
});
const $dd3f8fbce9cee668$var$styles = {
    dropdownContent: "_p12f1kdj"
};
const $dd3f8fbce9cee668$export$befc5243628631e7 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const context = (0, $eRXI0.useAIAnswerContext)();
    const { commonAttributes: commonAttributes } = context;
    const { sources: sources } = commonAttributes;
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $dcc08d64d101deb3$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    });
    if (!sources || sources.length === 0) return null;
    const numSources = sources.length;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                ref: triggerRef,
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cf600ec688712ec4$export$ebff7094edd1bb81), {
                            sources: sources
                        }),
                        formatMessage($dd3f8fbce9cee668$var$messages.sources_text, {
                            numSources: numSources
                        })
                    ]
                })
            }),
        isOpen: isOpen,
        onOpenChange: (attrs)=>setIsOpen(attrs.isOpen),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $dd3f8fbce9cee668$var$styles.dropdownContent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                title: formatMessage($dd3f8fbce9cee668$var$messages.sources_group_title, {
                    numSources: numSources
                }),
                children: sources.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8HDcK.KnowledgeSmartCard), {
                            source: source,
                            variant: (0, $8HDcK.CardVariant).DROPDOWN_SOURCE,
                            index: index,
                            searchSessionId: searchSessionId,
                            onClickHandler: handleSmartCardClick
                        })
                    }, source.url || index))
            })
        })
    });
};

















const $2cb1106731afa484$var$styles = {
    fullWidth: "_1bsbauwl _p12f1osq _19bvutpp _u5f3utpp _n3tdutpp",
    container: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
    interactive: "_80omtlke _bfhksm61 _1bsb1osq",
    expanded: "_bfhksm61 _1bsb1osq",
    root: "_1tkebn52",
    explicitQuestion: "_1tke1edt",
    fullHeight: "_4t3i1osq",
    followUpChatInputSectionStyles: "_19pkxy5q",
    disclaimerWrapperStyles: "_n3tdutpp _19bvpxbi _15a5nqa1 _1i531l7x _uwhke4h9",
    headerContainer: "_1tke1ylp _n3tdu2gc",
    loadingSkeletonContainer: "_19pkpxbi _otyrpxbi"
};
function $2cb1106731afa484$var$SmartAnswerCardDynamicLayoutComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    const [collapsed, setCollapsed] = (0, $42omo.useState)(true);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $42omo.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $42omo.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $42omo.useState)(false);
    const componentRenderTimeRef = (0, $42omo.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $42omo.useRef)(false);
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse } = (0, $eRXI0.useAIAnswerContext)();
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $42omo.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $42omo.useRef)(false);
    const completeAnswerAnalyticsEventFiredRef = (0, $42omo.useRef)(false);
    const renderedContentRef = (0, $42omo.useRef)(null);
    const contentContainerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText
    ]); // Notify context when collapsed state changes
    (0, $42omo.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $42omo.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $42omo.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $71dfce27a5e3997b$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed); // Complete answer analytics
    (0, $42omo.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultCompleteShown)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $42omo.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleExpandCollapseButtonClick = (0, $42omo.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $42omo.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const sourceClickCallback = (0, $42omo.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $42omo.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7223e25f351c072f$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback);
    const bufferedContent = (0, $0413b419acdae185$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading);
    (0, $42omo.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultFirstByteShown)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Use answerString when complete, bufferedContent when streaming
    const contentToRender = isAnswered ? answerString : bufferedContent; // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $2cb1106731afa484$var$styles.fullWidth,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e987865c989cf24e$export$ffa24cd7196ce1b0), {})
    });
     // Early return for generating state
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse || bufferedContent.length < 1) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $2cb1106731afa484$var$styles.fullWidth,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kF5LJ.SmartAnswerCardBodyGenerating), {
                    queryIntent: queryIntent === (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY ? (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION : queryIntent,
                    heightOverride: "lumina"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f7f027650ecd4d70$export$8a1fad5d74d43878), {
                    isStreaming: true,
                    showMoreButtonVisible: false
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $2cb1106731afa484$var$styles.fullWidth,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-ai-dialog-all-text",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                name: "search-ai-dialog-visible-text",
                children: [
                    isVisibleTextComplete ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                        name: "search-ai-dialog-visible-text-loading"
                    }),
                    (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                                dataKey: "queryHash",
                                value: queryHash
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                                dataKey: "searchSessionId",
                                value: searchSessionId
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                                dataKey: "queryIntent",
                                value: queryIntent
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                        data: {
                            queryHash: queryHash,
                            searchSessionId: searchSessionId,
                            queryIntent: queryIntent
                        }
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($2cb1106731afa484$export$3714848962bfb827, {
                        isStreaming: isStreaming,
                        collapsed: collapsed,
                        isContentTruncated: isContentTruncated,
                        queryIntent: queryIntent,
                        showReadMoreButton: showReadMoreButton,
                        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
                        contentContainerRef: contentContainerRef,
                        renderedContentRef: renderedContentRef,
                        sources: sources,
                        searchSessionId: searchSessionId,
                        sourceClickCallback: sourceClickCallback,
                        errorStateSuggestedQueries: errorStateSuggestedQueries,
                        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
                        commonAttributes: commonAttributes,
                        contentToRender: contentToRender,
                        showAnimation: showAnimation
                    })
                ]
            })
        })
    });
}
function $2cb1106731afa484$export$3714848962bfb827({ isStreaming: isStreaming, collapsed: collapsed, isContentTruncated: isContentTruncated, queryIntent: queryIntent, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender }) {
    const { dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages } = (0, $eRXI0.useAIAnswerContext)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4ca05c48d3d76392$export$127e64693c41156a), {
                isCollapsed: collapsed && (isStreaming || isContentTruncated),
                onExpandCollapse: handleExpandCollapseButtonClick,
                ref: contentContainerRef,
                showReadMoreButton: showReadMoreButton,
                queryIntent: queryIntent === (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY ? (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION : queryIntent,
                luminaAnswerType: "LUMINA",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                        data: (0, $4xTru.getSmartLinksAnalyticsContextData)({
                            location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                            commonAttributes: commonAttributes
                        }),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7bZ3i.SmartCardProvider), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    spread: "space-between",
                                    alignBlock: "center",
                                    xcss: $2cb1106731afa484$var$styles.headerContainer,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            alignBlock: "center",
                                            space: "space.050",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                                                    label: "AI Content",
                                                    size: "medium"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                    as: "h1",
                                                    size: "xsmall",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        ...(0, $8AwZ3.messages).smart_answer_card_dynamic_layout_title
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dd3f8fbce9cee668$export$befc5243628631e7), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    ref: renderedContentRef,
                                    testId: "sain-fmp-target",
                                    children: (0, $dh538.fg)('kd_enable_lumina_package') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fbVTr.LuminaLayout), {
                                        luminaTagResponse: contentToRender,
                                        luminaSubAgentResponse: dynamicLayoutSubAgentMessages,
                                        isStreaming: isStreaming
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $05bff8634172f0be$export$21094bc4b0d39e4b), {
                                        contentToRender: contentToRender
                                    })
                                }),
                                isStreaming && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    space: "space.200",
                                    xcss: $2cb1106731afa484$var$styles.loadingSkeletonContainer,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            width: "100%",
                                            height: "16px",
                                            color: "var(--ds-skeleton-subtle, #17171708)",
                                            borderRadius: '6px'
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            width: "100%",
                                            height: "16px",
                                            color: "var(--ds-skeleton-subtle, #17171708)",
                                            borderRadius: '6px'
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            width: "75%",
                                            height: "16px",
                                            color: "var(--ds-skeleton-subtle, #17171708)",
                                            borderRadius: '6px'
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            (showReadMoreButton || isStreaming) && (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsx)((0, $f7f027650ecd4d70$export$8a1fad5d74d43878), {
                isStreaming: isStreaming,
                showMoreButtonVisible: showReadMoreButton,
                onClickShowMoreButton: handleExpandCollapseButtonClick
            }),
            !isStreaming && (!collapsed || !showReadMoreButton || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                xcss: $2cb1106731afa484$var$styles.followUpChatInputSectionStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        space: "space.100",
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2be0e2e39d556c55$export$f087ce3403d54eb5), {
                            omitDialogues: true
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7c04b3fcd54a41ef$export$ca627f6f5c214661), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $2cb1106731afa484$var$styles.disclaimerWrapperStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                            showFeedbackButtons: !isStreaming,
                            showCopyButton: false,
                            renderedContentRef: renderedContentRef
                        })
                    })
                ]
            }) : null
        ]
    });
}
function $2cb1106731afa484$export$b547d87531f467be({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "smart-answer-card",
        children: /*#__PURE__*/ (0, $l998X.jsx)($2cb1106731afa484$var$SmartAnswerCardDynamicLayoutComponent, {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: queryIntent
        })
    });
}





/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 











var $2azjJ = parcelRequire("2azjJ");

const $c71e4c8897192027$export$476294a9cde8f045 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_90kafy": (0, $7sObp.default)((0, $2azjJ.grid).px)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isReadingAids ? "_1yt41ejb _1bsb1osq _4t3iucft _vchhusvi" : "_1bsbktbq _19pkd9yd",
            __cmplp.className
        ])
    });
});
const $c71e4c8897192027$export$1be966180e49de50 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sx4jwu": (0, $7sObp.default)(__cmplp.isStreaming ? `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} 0` : '0px')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1b66 _1yt41h8p _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _kqswh2mm _vchhusvi _1pby11wp _16qs130s _rfx31b66 _1s6kg985 _16qq5iki _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _1dbx1xgd _9v7at94y _14mj1b66 _aetrb3bt _z0ai1ud2 _1qdg1ud2 _18postnw _1bqq1mrw _1hfk1bhr",
            __cmplp.className
        ])
    });
});
const $c71e4c8897192027$export$91478cb6ad63ea84 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpv77o _1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq _4t3i1tcg _syaz1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c71e4c8897192027$export$a550342571a01571 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c71e4c8897192027$export$61f15f4516003460 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _1e0c1txw _1bsb1osq _4t3i7vkz _bfhkizff",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c71e4c8897192027$export$90ec299a95f41a29 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_o0efd2": (0, $7sObp.default)(__cmplp.width ? __cmplp.width : '100%'),
            "--_6auco7": (0, $7sObp.default)(__cmplp.height ? __cmplp.height : '16px')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _11q7lm00 _y44v1sal _1e0c1txw _1bsb1eet _4t3ivw99",
            __cmplp.className
        ])
    });
}); // copied from /platform/packages/search/search-ai/src/ai-answer-dialog/ai-answer-body/ai-answer-result/styled.tsx
const $c71e4c8897192027$export$95fe272adfa518ad = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7yuyx _19pk11bb _2hwxt94y _otyridpf _18u0t94y _4t3i1jfw _1bsb1osq _kqswh2mm _1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c71e4c8897192027$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3iucft _vchhusvi _ca0q1ejb _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c71e4c8897192027$export$636ea4c09615ceed = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _18u0v77o _syaz1rpy",
            __cmplp.className
        ])
    });
});





/* definition-answer-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $fT2ta = parcelRequire("fT2ta");

















var $bXlEj = parcelRequire("bXlEj");







var $7DCm4 = parcelRequire("7DCm4");

/* DefinitionSources.tsx generated by @compiled/babel-plugin v0.36.1 */ 






































var $cqFuK = parcelRequire("cqFuK");

const $be55ba5576248393$export$ee4edf16a7c39598 = (error, source)=>{
    if (error instanceof Error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1) || '',
            ...'details' in error && {
                details: error.details
            },
            ...'errorCode' in error && {
                errorCode: error.errorCode
            }
        }
    };
    if (error instanceof Object && 'error' in error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.error instanceof Error ? error.error.name : '',
            errorMessage: error.error instanceof Error ? error.error.message : typeof error === 'string' ? error : '',
            errorStack: error.error instanceof Error ? error.error.stack?.split('\n').at(1) : '',
            reason: 'reason' in error ? error.reason : '',
            details: 'details' in error ? error.details : ''
        }
    };
    return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            reason: error instanceof Object && 'reason' in error ? error.reason : '',
            details: error instanceof Object && 'details' in error ? error.details : ''
        }
    };
};
const $be55ba5576248393$export$13b0ccf9f6015e4c = (error, source)=>({
        action: 'failed',
        actionSubject: 'aiAnswerDialogNonStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    });
const $be55ba5576248393$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $be55ba5576248393$export$960f61383b799882 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiSourceFetchSmartlinkData',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};





const $b0794e201d444137$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $b0794e201d444137$export$6d6d0aa8067b2c97 = ({ urls: urls })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [objectResolverData, setObjectResolverData] = (0, $42omo.useState)([]);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const urlKeys = (0, $42omo.useMemo)(()=>urls.join('|'), [
        urls
    ]);
    (0, $42omo.useEffect)(()=>{
        const fetchObjectResolver = async ()=>{
            if (!urls.length) {
                setIsLoading(false);
                return;
            }
            try {
                const objectResolver = await (0, $4lrdQ.fetchRestResponse)({
                    url: $b0794e201d444137$var$OBJECT_RESOLVER_ENDPOINT,
                    body: urls.map((url)=>({
                            resourceUrl: url
                        }))
                });
                if (!objectResolver) {
                    setIsLoading(false);
                    return;
                }
                const objectData = objectResolver.filter((obj)=>obj.status === 200);
                setObjectResolverData(objectData.map((objData)=>objData.body));
                setIsLoading(false);
            } catch (error) {
                if (error instanceof Object && 'message' in error) fireAnalyticsEvent((0, $be55ba5576248393$export$960f61383b799882)(error, commonAttributes));
                setIsLoading(false);
            }
        };
        fetchObjectResolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        urlKeys
    ]);
    return {
        isLoading: isLoading,
        objectResolverData: objectResolverData
    };
};


/* DefinitionSource.tsx generated by @compiled/babel-plugin v0.36.1 */ 

























const $fb63dedc7010dc41$var$toTitleCase = (sourceCategory)=>sourceCategory.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
const $fb63dedc7010dc41$var$styles = {
    root: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    sourceIconWrapperStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb7vkz _4t3i7vkz"
};
const $fb63dedc7010dc41$export$c7fb9dc39c758aa3 = ({ sourceData: sourceData, index: index })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    const is1PSource = sourceData.data.generator?.name === 'Confluence';
    const sourceMetadata = is1PSource ? sourceData.data.summary : sourceData.entityData?.type ? $fb63dedc7010dc41$var$toTitleCase(sourceData.entityData.type.category) : undefined;
    const onClickSource = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            sourceProduct: sourceData.data.generator?.name.toLowerCase() || '',
            ...commonAttributes
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireAnalyticsEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: sourceData.data.url,
        xcss: $fb63dedc7010dc41$var$styles.root,
        target: "_blank",
        onClick: onClickSource,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    space: "space.100",
                    children: [
                        sourceData.data.generator && /*#__PURE__*/ (0, $l998X.jsx)((0, $ehPkL.AppIcon), {
                            app: sourceData.data.generator.name.toLowerCase(),
                            size: "xxsmall"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                maxLines: 1,
                                weight: "medium",
                                children: sourceData.data.name
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        maxLines: 2,
                        color: "color.text.subtle",
                        size: "small",
                        children: sourceMetadata
                    })
                })
            ]
        })
    });
};


const $b5507f16187f0872$var$messages = (0, $cgtv4.defineMessages)({
    definition_sources_stack_text: {
        id: "search_ai.definition_sources_stack_text",
        defaultMessage: "{numResolvedSources, plural, =1 {{numResolvedSources, number} Source} other {{numResolvedSources, number} Sources}}"
    },
    definition_source_stack_text: {
        id: "search_ai.definition_source_stack_text",
        defaultMessage: "source"
    }
});
const $b5507f16187f0872$var$styles = {
    root: "_ca0qu2gc _u5f3pxbi _19bvpxbi _n3tdu2gc",
    sourcesStackContainerStyles: "_2rko1qi0 _1dqonqa1 _189ee4h9 _1h6d1l7x _1bsb1ns9 _19bvutpp _u5f3utpp _ca0q12x7 _n3td12x7",
    dividerStyles: "_15a5nqa1 _uwhke4h9 _1i531l7x"
};
const $b5507f16187f0872$var$DEFINITION_MAX_SOURCES = 3;
const $b5507f16187f0872$export$63e4658af6ffde25 = ({ sources: sources })=>{
    const [sourcesExpanded, setSourcesExpanded] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const sourcesUrls = sources.map((source)=>source.url).slice(0, $b5507f16187f0872$var$DEFINITION_MAX_SOURCES);
    const { objectResolverData: objectResolverData } = (0, $b0794e201d444137$export$6d6d0aa8067b2c97)({
        urls: sourcesUrls
    });
    const numResolvedSources = objectResolverData.length;
    return numResolvedSources === 0 ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b5507f16187f0872$var$styles.root,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            onClick: ()=>setSourcesExpanded(!sourcesExpanded),
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cf600ec688712ec4$export$ebff7094edd1bb81), {
                                        maxSourcesInStack: $b5507f16187f0872$var$DEFINITION_MAX_SOURCES,
                                        sources: sources.slice(0, numResolvedSources)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.subtle",
                                        children: formatMessage($b5507f16187f0872$var$messages.definition_sources_stack_text, {
                                            numResolvedSources: numResolvedSources
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            onClick: ()=>setSourcesExpanded(!sourcesExpanded),
                            icon: (iconProps)=>sourcesExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...iconProps,
                                    size: "small"
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            appearance: "subtle",
                            label: sourcesExpanded ? 'Collapse sources button' : 'Expand sources button',
                            testId: "definitions-sources-expand"
                        })
                    ]
                }),
                sourcesExpanded && /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $b5507f16187f0872$var$styles.dividerStyles
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            space: "space.200",
                            children: objectResolverData.map((sourceData, idx)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fb63dedc7010dc41$export$c7fb9dc39c758aa3), {
                                    sourceData: sourceData,
                                    index: idx
                                }, `${sourceData.data.url}-${idx}`))
                        })
                    ]
                })
            ]
        })
    });
};


/* loading-dot-wave.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $eabfebdecced7503$var$loadingDotWaveWrapperStyles = null;
const $eabfebdecced7503$export$c7f94e62a2f54f71 = ({ width: width, height: height = 15 })=>{
    const canvasRef = (0, $42omo.useRef)(null);
    const dotsRef = (0, $42omo.useRef)([]);
    const animationRef = (0, $42omo.useRef)();
    const timeRef = (0, $42omo.useRef)(0); // Calculate number of dots based on consistent spacing
    const dotRadius = 2;
    const idealSpacing = width < 18 ? 6 : 8.4;
    const availableWidth = width - dotRadius * 2;
    const maxDots = Math.floor(availableWidth / idealSpacing) + 1;
    const dotCount = Math.max(2, maxDots); // Initialize dots
    const initDots = (0, $42omo.useCallback)(()=>{
        const dots = [];
        const centerY = height / 2; // Calculate available space for dots (subtract padding for dot radius on both sides)
        const availableWidth = width - 1 - dotRadius * 2;
        const spacing = dotCount > 1 ? availableWidth / (dotCount - 1) : 0;
        for(let i = 0; i < dotCount; i++)dots.push({
            x: dotRadius + i * spacing,
            // Start from dotRadius to avoid cutoff
            y: centerY,
            baseY: centerY,
            phase: i / dotCount * Math.PI * 2,
            size: dotRadius
        });
        return dots;
    }, [
        dotCount,
        height,
        width
    ]);
    // Gradient for dots
    const createGradient = (0, $42omo.useCallback)((ctx, x)=>{
        const gradient = ctx.createRadialGradient(x, 0, 0, x, 0, dotRadius); // Calculate position along the available width for color interpolation
        const availableWidth = width - dotRadius * 2;
        const adjustedX = x - dotRadius;
        const position = availableWidth > 0 ? Math.max(0, Math.min(1, adjustedX / availableWidth)) : 0; // Create linear gradient with colors: #0065FF → #0267FF → #BF63F3 → #FFA900
        const colors = [
            {
                r: 0,
                g: 101,
                b: 255
            },
            // #0065FF
            {
                r: 2,
                g: 103,
                b: 255
            },
            // #0267FF
            {
                r: 191,
                g: 99,
                b: 243
            },
            // #BF63F3
            {
                r: 255,
                g: 169,
                b: 0
            }
        ];
        let color;
        if (position <= 0.33) {
            // Interpolate between #0065FF and #0267FF
            const localPos = position / 0.33;
            const color1 = colors[0];
            const color2 = colors[1];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        } else if (position <= 0.66) {
            // Interpolate between #0267FF and #BF63F3
            const localPos = (position - 0.33) / 0.33;
            const color1 = colors[1];
            const color2 = colors[2];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        } else {
            // Interpolate between #BF63F3 and #FFA900
            const localPos = (position - 0.66) / 0.34;
            const color1 = colors[2];
            const color2 = colors[3];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        }
        gradient.addColorStop(0, `rgb(${color.r}, ${color.g}, ${color.b})`);
        gradient.addColorStop(1, `rgb(${Math.floor(color.r * 0.8)}, ${Math.floor(color.g * 0.8)}, ${Math.floor(color.b * 0.8)})`);
        return gradient;
    }, [
        width
    ]);
    // Animation loop
    const animate = (0, $42omo.useCallback)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height); // Update time
        timeRef.current += 0.08; // Update and draw dots
        dotsRef.current.forEach((dot)=>{
            // Calculate wave motion
            const waveOffset = Math.sin(timeRef.current + dot.phase);
            dot.y = dot.baseY + waveOffset; // Apply gradient to this dot
            const gradient = createGradient(ctx, dot.x); // Draw dot
            ctx.beginPath();
            ctx.arc(dot.x, dot.y, dot.size, 0, Math.PI * 2);
            ctx.fillStyle = gradient;
            ctx.fill(); // Add subtle shadow
            ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';
            ctx.shadowBlur = 2;
            ctx.shadowOffsetY = 1;
        });
        // Continue animation
        animationRef.current = requestAnimationFrame(animate);
    }, [
        canvasRef,
        createGradient
    ]);
    // Initialize dots when width changes
    (0, $42omo.useEffect)(()=>{
        dotsRef.current = initDots();
    }, [
        width,
        dotCount,
        height,
        initDots
    ]);
    // Set up canvas and start animation
    (0, $42omo.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        // Set canvas dimensions
        canvas.width = width;
        canvas.height = height; // Start animation
        animationRef.current = requestAnimationFrame(animate); // Cleanup
        return ()=>{
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };
    }, [
        animate,
        height,
        width
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154imgjw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("canvas", {
            ref: canvasRef,
            width: width,
            height: height
        })
    });
};






























parcelRequire("42omo");
















var $aK1zu = parcelRequire("aK1zu");



































const $81113bb4df4a7cc5$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    recentWorkListTitle: {
        id: "search_ai.ai_answer_dialog.recent_work_list.title",
        defaultMessage: "Recently worked on"
    },
    viewAllLink: {
        id: "search_ai.ai_answer_dialog.recent_work_list.view_all_link",
        defaultMessage: "View all"
    },
    showMore: {
        id: "search_ai.ai_answer_dialog.recent_work_list.show_more",
        defaultMessage: "Show more"
    },
    no_activity_error_text: {
        id: "search_ai.ai_answer_dialog.recent_work_list.no_activity_error_text",
        defaultMessage: "Atlassian Intelligence doesn\u2019t have enough data to provide a response right now. This may be because {user} is new and they haven't interacted with Confluence yet. In the meantime, try asking a different question."
    }
});












var $5dK2X = parcelRequire("5dK2X");








/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $c074d3e7482ed959$export$9a485269bf2c8987 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$3c95e3d61376d5b6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$df8ab4b5e2ff1243 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _2rkofajl _kqswh2mm _1e0c1ule _19bvu2gc _u5f3u2gc _nt751r31 _49pcglyw _1hvwidpf _7ehi1boc _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$246596915c6a37b0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$c779e0225c7a4abb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _1o9zidpf _1bsb1ejb _4t3i1ejb _19pku2gc _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$37f6bd651093c20a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _18u0pxbi _1bah1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$398e991be65309e3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_u5f3u2gc _n3tdv77o _1e0c1txw _4cvr1h6o _1i7v1qyo _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _umv415vq _wwzv15vq _1fjn1o8l _125xi7uo _5rkt1l2s _5xln1q9c",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$6a9e1330548eac8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _syaz1rpy _1bto1l2s _o5721q9c _u5f3u2gc _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$6e18a3d821f78b73 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_aetr1lxz _1rec1b66 _1k961b66",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$a644bde83ad79b45 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$ce4b6a469c26f53f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _18u0u2gc _ekv6wadc _13bowadc _1sc1wadc _ep9t78py _1gfl78py _1oh278py _9r1z78py _yhjm78py _99zt78py _f5ga78py _1gqn78py _1m2u78py _hstc78py _11lv78py _9n9o78py _iijb261p _jq8g261p _1xjx261p",
            __cmplp.className
        ])
    });
});
const $c074d3e7482ed959$export$73d0188d97126121 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _19pkpxbi _syaz1sqi",
            __cmplp.className
        ])
    });
});


const $f1355db5a929751d$export$9adc0410c9970c44 = ({ index: index, title: title, iconUrl: iconUrl, url: url, container: container, event: event, contributors: contributors, timestamp: timestamp, othersCount: othersCount })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $8C5kA.default)();
    const { userDetails: { id: currentUserId }, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const description = (0, $f0eed913fd2c0cbd$export$4d98da88c6a5014a)({
        currentUserId: !!currentUserId ? currentUserId : '',
        event: event,
        contributors: contributors,
        othersCount: othersCount,
        formatMessage: formatMessage,
        formatDate: formatDate,
        timestamp: new Date(timestamp)
    });
    const onClick = (0, $42omo.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkItemClick)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    const onContextMenuClick = (0, $42omo.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkItemContextMenuClick)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$df8ab4b5e2ff1243), {
        href: url,
        onClick: onClick,
        onContextMenu: onContextMenuClick,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $c074d3e7482ed959$export$246596915c6a37b0), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$c779e0225c7a4abb), {
                    src: iconUrl,
                    alt: ""
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $c074d3e7482ed959$export$37f6bd651093c20a), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$398e991be65309e3), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                as: "p",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $c074d3e7482ed959$export$6a9e1330548eac8), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$6e18a3d821f78b73), {
                                    children: container
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$a644bde83ad79b45), {
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};



const $6aee33a7cff9d280$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER = 5;
const $6aee33a7cff9d280$export$66aebd6b65f0e0cf = ({ name: name, activities: activities, viewAllUrl: viewAllUrl })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const cachedExpanded = JSON.parse((0, $epS7s.getSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}').recentWorkListExpanded;
    const [expanded, setExpanded] = (0, $42omo.useState)(cachedExpanded !== undefined ? cachedExpanded : false);
    const { updateContextCache: updateContextCache, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const expandRecentWorkList = (0, $42omo.useCallback)(()=>{
        setExpanded(true);
        updateContextCache({
            recentWorkListExpanded: true
        });
    }, [
        updateContextCache
    ]);
    const onLinkClick = (0, $42omo.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkLinkClick)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const onLinkContextMenuClick = (0, $42omo.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkLinkContextMenuClick)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const showExpandedItems = activities.length > $6aee33a7cff9d280$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER ? expanded : true;
    const shownActivities = showExpandedItems ? activities : activities.slice(0, $6aee33a7cff9d280$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER);
    if (activities.length === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$73d0188d97126121), {
        children: formatMessage((0, $81113bb4df4a7cc5$export$defe85febe8b728c).no_activity_error_text, {
            user: name
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$9a485269bf2c8987), {
                children: formatMessage((0, $81113bb4df4a7cc5$export$defe85febe8b728c).recentWorkListTitle)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$3c95e3d61376d5b6), {
                children: shownActivities.map((activity, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f1355db5a929751d$export$9adc0410c9970c44), {
                        index: index,
                        title: activity.title,
                        iconUrl: activity.iconUrl,
                        url: activity.url,
                        container: activity.containerName,
                        event: activity.event,
                        contributors: activity.contributors,
                        timestamp: activity.timestamp,
                        othersCount: activity.othersCount
                    }, `recent-work-item-${index}`))
            }),
            showExpandedItems ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$ce4b6a469c26f53f), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                    appearance: 'link',
                    href: viewAllUrl,
                    onClick: onLinkClick,
                    onContextMenu: onLinkContextMenuClick,
                    children: formatMessage((0, $81113bb4df4a7cc5$export$defe85febe8b728c).viewAllLink)
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                children: !!viewAllUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $c074d3e7482ed959$export$ce4b6a469c26f53f), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                        appearance: "link",
                        onClick: expandRecentWorkList,
                        children: formatMessage((0, $81113bb4df4a7cc5$export$defe85febe8b728c).showMore)
                    })
                })
            })
        ]
    });
};





parcelRequire("42omo");





var $69PnT = parcelRequire("69PnT");



















/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766









const $ab263af7a0246d6d$export$32d100979bcc384a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$455d3c20a8814267 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$509293bf46c921a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1bah1y6m _4cvr1y6m _4t3i1osq _1bsb1osq _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$dbd921847e022785 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkopb1k _1bsbt9kd _4t3it9kd",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$255011ab851083fa = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$2561140795d9b6bc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81af2",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$4748d4ea7eaeeee9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkv77o _1e0c1txw _1n261g80 _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$6703f231e80ecbdc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$56b2c11ed41d99f1 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syaz1rpy _18u0v77o",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$83dd167b9bbf48eb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_e3qc1b66",
            __cmplp.className
        ])
    });
});
const $ab263af7a0246d6d$export$bb93002cdcc6fd86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});





parcelRequire("42omo");





var $oeZjt = parcelRequire("oeZjt");


var $kevJM = parcelRequire("kevJM");











var $dcJ7R = parcelRequire("dcJ7R");








var $c25514636e607d9b$export$70291e6ea210ef9 = /*#__PURE__*/ function(UserInfoTypeFormat) {
    UserInfoTypeFormat["JOBTITLE"] = "JOB_TITLE";
    UserInfoTypeFormat["DEPARTMENT"] = "DEPARTMENT";
    UserInfoTypeFormat["LOCATION"] = "LOCATION";
    UserInfoTypeFormat["TIME"] = "TIME";
    UserInfoTypeFormat["EMAIL"] = "EMAIL";
    return UserInfoTypeFormat;
}({});
const $c25514636e607d9b$var$userInfoTypeMapper = {
    ["JOB_TITLE"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_role_icon,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))), {
            label: "",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-suitcase-icon"
        })
    },
    ["DEPARTMENT"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_department_icon,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7O0l1))), {
            label: "",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-department-icon"
        })
    },
    ["LOCATION"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_location_icon,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kPml2))), {
            label: "",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-location-icon"
        })
    },
    ["TIME"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_local_time_icon,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: "",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-emoji-frequent-icon"
        })
    },
    ["EMAIL"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_email_icon,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldfch))), {
            label: "",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-email-icon"
        })
    }
};
const $c25514636e607d9b$export$aaf1b21561a4fb8b = ({ userInfo: userInfo, userInfoType: userInfoType, applyAdditionalTopIconPadding: applyAdditionalTopIconPadding })=>{
    return userInfo ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ab263af7a0246d6d$export$6703f231e80ecbdc), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            space: "space.075",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    position: "top",
                    content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...$c25514636e607d9b$var$userInfoTypeMapper[userInfoType].tooltipMessage
                    }),
                    children: applyAdditionalTopIconPadding ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ab263af7a0246d6d$export$83dd167b9bbf48eb), {
                        children: $c25514636e607d9b$var$userInfoTypeMapper[userInfoType].icon
                    }) : $c25514636e607d9b$var$userInfoTypeMapper[userInfoType].icon
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ab263af7a0246d6d$export$56b2c11ed41d99f1), {
                    children: userInfo
                })
            ]
        })
    }) : null;
};


const $ad3ad4c3f9dfb105$export$cf8aeccda7668aa5 = ({ accountId: accountId, name: name, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const profileLink = commonAttributes.brand === (0, $f7lNm.AiBrand).AI ? `/wiki/people/${accountId}` : profileUrl;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ab263af7a0246d6d$export$32d100979bcc384a), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ab263af7a0246d6d$export$455d3c20a8814267), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ab263af7a0246d6d$export$dbd921847e022785), {
                    src: avatarUrl || '',
                    alt: name
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $ab263af7a0246d6d$export$509293bf46c921a), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $ab263af7a0246d6d$export$255011ab851083fa), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ab263af7a0246d6d$export$2561140795d9b6bc), {
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $ab263af7a0246d6d$export$bb93002cdcc6fd86), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
                                            spacing: "spacious",
                                            label: "",
                                            color: `var(--ds-text-accent-blue, ${(0, $6fnsQ.B400)})`
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                            href: profileLink || '',
                                            onClick: (event)=>{
                                                onNavigate(event);
                                                fireAnalyticsEvent((0, $4xTru.onWhoPrimaryViewProfileClick)({
                                                    ...commonAttributes,
                                                    primaryUserName: name
                                                }));
                                            },
                                            onContextMenu: (event)=>{
                                                onNavigate(event);
                                                fireAnalyticsEvent((0, $4xTru.onWhoPrimaryViewProfileContextMenuClick)({
                                                    ...commonAttributes,
                                                    primaryUserName: name
                                                }));
                                            },
                                            children: formatMessage((0, $7lL49.messages).ai_answer_who_questions_view_profile)
                                        })
                                    ]
                                })
                            ]
                        }),
                        (jobTitle || department) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $ab263af7a0246d6d$export$4748d4ea7eaeeee9), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c25514636e607d9b$export$aaf1b21561a4fb8b), {
                                    userInfo: jobTitle || '',
                                    userInfoType: (0, $c25514636e607d9b$export$70291e6ea210ef9).JOBTITLE
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c25514636e607d9b$export$aaf1b21561a4fb8b), {
                                    userInfo: department || '',
                                    userInfoType: (0, $c25514636e607d9b$export$70291e6ea210ef9).DEPARTMENT
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $ab263af7a0246d6d$export$4748d4ea7eaeeee9), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c25514636e607d9b$export$aaf1b21561a4fb8b), {
                                    userInfo: location || '',
                                    userInfoType: (0, $c25514636e607d9b$export$70291e6ea210ef9).LOCATION
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c25514636e607d9b$export$aaf1b21561a4fb8b), {
                                    userInfo: time || '',
                                    userInfoType: (0, $c25514636e607d9b$export$70291e6ea210ef9).TIME,
                                    applyAdditionalTopIconPadding: true
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c25514636e607d9b$export$aaf1b21561a4fb8b), {
                                    userInfo: email || '',
                                    userInfoType: (0, $c25514636e607d9b$export$70291e6ea210ef9).EMAIL,
                                    applyAdditionalTopIconPadding: true
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





parcelRequire("42omo");




















const $c1ec86efaaa8b92c$var$WHO_SECTION_MAX_ITEMS = 3;
const $c1ec86efaaa8b92c$export$2fdd09f06ec66b1 = ({ sectionId: sectionId, sectionHeader: sectionHeader, sectionResults: sectionResults, avatarAppearance: avatarAppearance })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const getSectionResultMetadata = (sectionResult)=>{
        if ('containerType' in sectionResult) switch(sectionResult.containerType){
            case (0, $7Zbm6.NLPSearchResultContainerDataTypeContainerType).ConfluenceSpace:
                return 'Confluence';
            case (0, $7Zbm6.NLPSearchResultContainerDataTypeContainerType).JiraProject:
                return 'Jira Software';
            default:
                return '';
        }
        if ('title' in sectionResult) return sectionResult.title || '';
        if ('memberCount' in sectionResult) return formatMessage((0, $7lL49.messages).ai_answer_who_question_team_section_member_count, {
            count: sectionResult.memberCount
        });
        return '';
    };
    return sectionResults && sectionResults.length ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $9c08bd9e3182a321$export$cc8053471b180c28), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$8d7f456736fee90f), {
                children: formatMessage(sectionHeader)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$39edbe3e7f6a9ca1), {
                children: sectionResults.slice(0, $c1ec86efaaa8b92c$var$WHO_SECTION_MAX_ITEMS).map((sectionResult)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $9c08bd9e3182a321$export$d0be8a9d033ca7b8), {
                        href: sectionResult.url || undefined,
                        onClick: (event)=>{
                            onNavigate(event);
                            fireAnalyticsEvent((0, $4xTru.onWhoPrimaryCoordinationPillClick)({
                                ...commonAttributes,
                                resultSection: sectionId,
                                resultTitle: sectionResult.name
                            }));
                        },
                        onContextMenu: ()=>{
                            fireAnalyticsEvent((0, $4xTru.onWhoPrimaryCoordinationPillContextMenuClick)({
                                ...commonAttributes,
                                resultSection: sectionId,
                                resultTitle: sectionResult.name
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                                appearance: avatarAppearance,
                                src: sectionResult.iconUrl || sectionResult.picture || sectionResult.avatarUrl || undefined,
                                size: "medium"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $9c08bd9e3182a321$export$e739e9e96a0d2dd9), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$790f6d80b0f65f30), {
                                        children: sectionResult.name
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9c08bd9e3182a321$export$7b9fc87d1d9e8ecd), {
                                        children: getSectionResultMetadata(sectionResult)
                                    })
                                ]
                            })
                        ]
                    }, sectionResult.name))
            })
        ]
    }) : null;
};


const $f34f0937e021b65d$export$f11b3e733b5a589b = ()=>{
    const { commonAttributes: commonAttributes, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, cloudId: cloudId, sessionId: sessionId } = commonAttributes;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const whoResult = {
        user_metadata: (0, $c97be5ff4a9e42e9$export$b273f870e024eb5d)(answerString).parsedResult
    };
    const userResults = whoResult.user_metadata;
    // BE will always return first object as the primary user result
    const primaryUser = userResults[0];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ad3ad4c3f9dfb105$export$cf8aeccda7668aa5), {
                accountId: primaryUser.account_id,
                name: primaryUser.name,
                email: primaryUser.email,
                avatarUrl: primaryUser.avatar_url,
                profileUrl: primaryUser.profile_url,
                jobTitle: primaryUser.job_title,
                department: primaryUser.department,
                location: primaryUser.location,
                time: primaryUser.time
            }),
            isAdminHubAIEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aK1zu.AITopicsByPerson), {
                cloudId: cloudId,
                userId: primaryUser.account_id ?? '',
                userName: primaryUser.name,
                sessionId: sessionId
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $c1ec86efaaa8b92c$export$2fdd09f06ec66b1), {
                sectionId: "frequent_locations",
                sectionHeader: (0, $7lL49.messages).ai_answer_who_questions_frequent_locations_header,
                sectionResults: primaryUser.containers,
                avatarAppearance: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c1ec86efaaa8b92c$export$2fdd09f06ec66b1), {
                sectionId: "frequent_collaborators",
                sectionHeader: (0, $7lL49.messages).ai_answer_who_questions_frequent_collaborators_header,
                sectionResults: primaryUser.collaborators?.slice(0, 3),
                avatarAppearance: "circle"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c1ec86efaaa8b92c$export$2fdd09f06ec66b1), {
                sectionId: "teams",
                sectionHeader: (0, $7lL49.messages).ai_answer_who_questions_teams_header,
                sectionResults: primaryUser.teams,
                avatarAppearance: "square"
            }),
            primaryUser.recentActivity && /*#__PURE__*/ (0, $l998X.jsx)((0, $6aee33a7cff9d280$export$66aebd6b65f0e0cf), {
                name: primaryUser.name,
                activities: primaryUser.recentActivity,
                viewAllUrl: primaryUser.viewAllLink
            })
        ]
    });
};














const $2133918edead0ea4$export$ff8068fc50f478b4 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const workResult = {
        user_metadata_with_activity: (0, $c97be5ff4a9e42e9$export$b273f870e024eb5d)(answerString).parsedResult
    };
    const userWorkResult = workResult.user_metadata_with_activity[0];
    const activities = userWorkResult.recentActivity;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ad3ad4c3f9dfb105$export$cf8aeccda7668aa5), {
                name: userWorkResult.name,
                email: userWorkResult.email,
                avatarUrl: userWorkResult.avatar_url,
                profileUrl: userWorkResult.profile_url,
                jobTitle: userWorkResult.job_title,
                department: userWorkResult.department,
                location: userWorkResult.location,
                time: userWorkResult.time
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6aee33a7cff9d280$export$66aebd6b65f0e0cf), {
                name: userWorkResult.name,
                activities: activities,
                viewAllUrl: userWorkResult.viewAllLink
            })
        ]
    });
};


const $284094860717141d$export$135cee1a1b919871 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const { parsedType: parsedType } = (0, $c97be5ff4a9e42e9$export$b273f870e024eb5d)(answerString);
    switch(parsedType){
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WHO:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $f34f0937e021b65d$export$f11b3e733b5a589b), {});
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WORK:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2133918edead0ea4$export$ff8068fc50f478b4), {});
        case (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $217f267d537298d5$export$224d36db19d00a29), {});
        default:
            return null;
    }
};


























const $c81f62ac06382b4f$export$f8279a5be196ce2f = ()=>{
    const [isResultOverflow, setResultOverflow] = (0, $42omo.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $42omo.useState)(false);
    const wrapperRef = (0, $42omo.useRef)(null);
    const contentRef = (0, $42omo.useRef)(null);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const onCloseDialog = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerReturnLinkClick)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const enableShowMoreBlur = cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT && isReadingAids;
    (0, $42omo.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $cb9f1b890dd10de2$export$d74b491f1ba95e72), {
                isReadingAids: isReadingAids && cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT,
                ref: wrapperRef,
                isExpanded: isResultExpanded,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ref: contentRef,
                        children: answerString
                    }),
                    enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$95fe272adfa518ad), {
                        onClick: ()=>setResultExpanded(true),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$b67ed19cd3a08e2a), {
                            children: formatMessage((0, $7lL49.messages).ai_answer_expand_button_label)
                        })
                    })
                ]
            }),
            !isReadingAids && onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$855079ed5415eeab), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_dialog_cancel_label,
                    values: {
                        searchResultsLink: // eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlassian/a11y/click-events-have-key-events, @atlaskit/design-system/no-html-anchor, @atlassian/a11y/no-static-element-interactions
                        /*#__PURE__*/ (0, $l998X.jsx)("a", {
                            onClick: onCloseDialog,
                            children: formatMessage((0, $7lL49.messages).ai_answer_dialog_search_results_label)
                        })
                    }
                })
            })
        ]
    });
};














































const $26d84f90c8afc6f6$var$ReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("1l2X9")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));

const $26d84f90c8afc6f6$var$MarkdownRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gdXLD")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $26d84f90c8afc6f6$export$b6ab675c6c26c40f = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isResultOverflow, setResultOverflow] = (0, $42omo.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $42omo.useState)(false);
    const wrapperRef = (0, $42omo.useRef)(null);
    const contentRef = (0, $42omo.useRef)(null);
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, answerFormat: answerFormat } = commonAttributes;
    const onCloseDialog = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerReturnLinkClick)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    const enableShowMoreBlur = cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT && isReadingAids && !serveDefinitionUXUpdates;
    (0, $42omo.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        if (serveDefinitionUXUpdates) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        serveDefinitionUXUpdates
    ]);
    const docContent = (0, $42omo.useMemo)(()=>(0, $4pEXC.encodeAdf)(answerString, false), [
        answerString
    ]);
    const FormattedResult = (0, $42omo.useMemo)(()=>{
        let content;
        switch(answerFormat){
            case (0, $7Zbm6.NLPSearchResultFormat).ADF:
                content = /*#__PURE__*/ (0, $l998X.jsx)($26d84f90c8afc6f6$var$ReactRenderer, {
                    document: JSON.parse(answerString),
                    nodeComponents: (0, $dh538.fg)('hybrid_orchestrator_enable_image_search') ? undefined : {
                        // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                        // Followup ticket to re-enable image rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                        media: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                        mediaSingle: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {})
                    }
                });
                break;
            case (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN:
                if (!isReadingAids && ((0, $dh538.fg)('kd_smart_answers_use_adf_encoder') || (0, $dh538.fg)('kd_smart_answers_use_adf_encoder_jira'))) {
                    content = /*#__PURE__*/ (0, $l998X.jsx)($26d84f90c8afc6f6$var$ReactRenderer, {
                        document: docContent,
                        nodeComponents: {
                            status: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3574ef4ffa67c8f4$export$21553c57082a6434), {
                                    ...props
                                }),
                            // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                            // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                            ...!(0, $dh538.fg)('hybrid_orchestrator_enable_image_search') ? {
                                media: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                                mediaSingle: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {})
                            } : undefined
                        }
                    });
                    break;
                }
                // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                content = /*#__PURE__*/ (0, $l998X.jsx)($26d84f90c8afc6f6$var$MarkdownRenderer, {
                    disallowedElements: (0, $dh538.fg)('hybrid_orchestrator_enable_image_search') ? undefined : [
                        'img'
                    ],
                    children: answerString
                });
                break;
            default:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {});
        }
        return content;
    }, [
        answerFormat,
        answerString,
        docContent,
        isReadingAids
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$d74b491f1ba95e72), {
                id: "ai-answer-result-section",
                ref: wrapperRef,
                isReadingAids: isReadingAids && cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT,
                isExpanded: isResultExpanded || serveDefinitionUXUpdates,
                serveDefinitionUXExp: serveDefinitionUXUpdates,
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    ref: contentRef,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                            data: (0, $4xTru.getSmartLinksAnalyticsContextData)({
                                location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                                commonAttributes: commonAttributes
                            }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                                children: FormattedResult
                            })
                        })
                    })
                })
            }),
            enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$95fe272adfa518ad), {
                onClick: ()=>setResultExpanded(true),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$b67ed19cd3a08e2a), {
                    children: formatMessage((0, $7lL49.messages).ai_answer_expand_button_label)
                })
            }),
            !isReadingAids && onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $cb9f1b890dd10de2$export$855079ed5415eeab), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7lL49.messages).ai_answer_dialog_cancel_label,
                    values: {
                        searchResultsLink: // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, @atlassian/a11y/anchor-is-valid, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions
                        /*#__PURE__*/ (0, $l998X.jsx)("a", {
                            onClick: onCloseDialog,
                            children: formatMessage((0, $7lL49.messages).ai_answer_dialog_search_results_label)
                        })
                    }
                })
            })
        ]
    });
};


/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766











const $e289d21f2bc4318a$export$373eea644718ed14 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, serveDefinitionsUXExp: serveDefinitionsUXExp, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_9ebqy0": (0, $7sObp.default)(__cmplp.serveDefinitionsUXExp ? `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-050, 4px)"}` : `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-050, 4px)"}`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isReadingAids ? "_zulpu2gc _1yt4t9l9 _1e0c1txw _2lx21bp4 _4cvr1y6m" : "_zulpu2gc _1yt4126b _1e0c1txw _2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $e289d21f2bc4318a$export$106e8178ce804384 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_u5f31ejb",
            __cmplp.className
        ])
    });
});


const $900fa72344220951$var$AIAnswerResult = ()=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { answerFormat: answerFormat } = commonAttributes;
    (0, $42omo.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const AIAnswerResultComponent = (0, $42omo.useMemo)(()=>{
        switch(answerFormat){
            case (0, $7Zbm6.NLPSearchResultFormat).ADF:
            case (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN:
                return 0, $26d84f90c8afc6f6$export$b6ab675c6c26c40f;
            case (0, $7Zbm6.NLPSearchResultFormat).JSON:
                return 0, $284094860717141d$export$135cee1a1b919871;
            case (0, $7Zbm6.NLPSearchResultFormat).PLAINTEXT:
            default:
                return 0, $c81f62ac06382b4f$export$f8279a5be196ce2f;
        }
    }, [
        answerFormat
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)(AIAnswerResultComponent, {});
};
const $900fa72344220951$export$e2b54fc495614d59 = ()=>{
    const { isAnswered: isAnswered, hasError: hasError, isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $eRXI0.useAIAnswerContext)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e289d21f2bc4318a$export$373eea644718ed14), {
        isReadingAids: isReadingAids && cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT,
        serveDefinitionsUXExp: serveDefinitionUXUpdates,
        children: isAnswered && !hasError ? /*#__PURE__*/ (0, $l998X.jsx)($900fa72344220951$var$AIAnswerResult, {}) : hasError ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e289d21f2bc4318a$export$106e8178ce804384), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e987865c989cf24e$export$ffa24cd7196ce1b0), {})
        }) : null
    });
};






/* ai-answer-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





















parcelRequire("42omo");







/* DisableDefinitionMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $9VJDA = parcelRequire("9VJDA");


var $82gXq = parcelRequire("82gXq");







const $6780a693da5d102f$var$messages = (0, $cgtv4.defineMessages)({
    disable_definitions_more_icon_tooltip: {
        id: "search_ai.disable_definitions_more_icon_tooltip",
        defaultMessage: "See more actions"
    },
    disable_definitions_header: {
        id: "search_ai.disable_definitions_header",
        defaultMessage: "Don\u2019t recommend definitions at all"
    },
    disable_definitions_description: {
        id: "search_ai.disable_definitions_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes."
    }
});
const $6780a693da5d102f$var$DisableDefinitionMenuWrapper = null;
const $6780a693da5d102f$var$DisableDefinitionMenuTextWrapper = null;
const $6780a693da5d102f$var$DisableDefinitionMenuHeaderStyles = null;
const $6780a693da5d102f$var$DisableDefinitionMenuDescriptionStyles = null;
const $6780a693da5d102f$var$DisableDefinitionMenuToggleWrapper = null;
const $6780a693da5d102f$var$MoreIconStyled = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "reading-aids-menu-button-icon",
        color: "var(--ds-icon-subtle, #505258)"
    });
const $6780a693da5d102f$export$a025edc19ca0650a = ()=>{
    const { readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const [menuOpen, setMenuOpen] = (0, $42omo.useState)(false);
    const [disableDefinitions, setDisableDefinitions] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const definitionsDisabled = !!readingAidsOptions?.disableDefinitionsCallbacks?.getDefinitionsDisabled();
        setDisableDefinitions(definitionsDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disableDefinitionsCallbacks = readingAidsOptions?.disableDefinitionsCallbacks;
    return disableDefinitionsCallbacks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        position: "bottom",
        content: formatMessage($6780a693da5d102f$var$messages.disable_definitions_more_icon_tooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            isOpen: menuOpen,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...props,
                    appearance: "subtle",
                    icon: $6780a693da5d102f$var$MoreIconStyled,
                    ref: triggerRef,
                    onClick: ()=>{
                        setMenuOpen(!menuOpen);
                    },
                    testId: "definitions-menu-button",
                    label: "definitions-menu-button"
                }),
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $gMc0m.default)([
                    "_zulpv47k _1e0c1txw _1bsbnklw _2lx2vrvc _1bah1yb4 _1pbykb7n _19pkpxbi _n3tdpxbi _19bvutpp _2hwx12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_zulp1b66 _1e0c1txw _2lx21bp4 _1bsbohmy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    "_11c8fhey _syazi7uo"
                                ]),
                                children: formatMessage($6780a693da5d102f$var$messages.disable_definitions_header)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    "_11c8wadc _syaz1rpy"
                                ]),
                                children: formatMessage($6780a693da5d102f$var$messages.disable_definitions_description)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_1e0c1txw _1bsb1ns9"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                            onChange: ()=>{
                                if (disableDefinitions) disableDefinitionsCallbacks.onEnableDefinitions();
                                else disableDefinitionsCallbacks.onDisableDefinitions();
                                setDisableDefinitions(!disableDefinitions);
                            },
                            isChecked: disableDefinitions,
                            testId: "definitions-toggle-disable"
                        })
                    })
                ]
            })
        })
    }) : null;
};


/* DefinitionsDropdownMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 















































var $iPfZG = parcelRequire("iPfZG");
















var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");





















var $lJsaE = parcelRequire("lJsaE");

const $28923582fdd5ddfd$var$messages = (0, $cgtv4.defineMessages)({
    edit_definition_icon_tooltip: {
        id: "search_ai.curated-definition-edit-def-icon-tooltip",
        defaultMessage: "Edit definition"
    },
    edit_definition_prompt_text: {
        id: "search_ai.edit_definition_prompt_text",
        defaultMessage: "Not quite right? Edit this definition"
    },
    edit_definition_prompt_text_updated: {
        id: "search_ai.edit_definition_prompt_text_updated",
        defaultMessage: "Edit this definition"
    }
});
const $28923582fdd5ddfd$var$EditIconStyled = ()=>{
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`,
        label: "",
        size: serveDefinitionUXUpdates ? 'small' : 'medium'
    });
};
const $28923582fdd5ddfd$export$86ebf34eb079ac26 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editButtonSpotlightId = 'ai-definitions-edit-button';
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    const [showEditModal, setShowEditModal] = (0, $42omo.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $42omo.useState)(false);
    const closeEditModal = (0, $42omo.useCallback)(()=>{
        setShowEditModal(false);
        onClose?.();
    }, [
        setShowEditModal,
        onClose
    ]);
    const openEditModal = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onCuratedDefinitionEditButtonClicked)(commonAttributes));
        setShowEditModal(true);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isAnswered) fireAnalyticsEvent((0, $4xTru.onCuratedDefinitionEditButtonShown)(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            !hasError && /*#__PURE__*/ (0, $l998X.jsxs)((0, $6cnUO.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
                        name: editButtonSpotlightId,
                        children: serveDefinitionUXUpdates ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            iconBefore: $28923582fdd5ddfd$var$EditIconStyled,
                            onClick: openEditModal,
                            spacing: "compact",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtle",
                                size: "small",
                                children: formatMessage($28923582fdd5ddfd$var$messages.edit_definition_prompt_text_updated)
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lJsaE.EditDefinitionWrapper), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "subtle",
                                iconBefore: $28923582fdd5ddfd$var$EditIconStyled,
                                onClick: openEditModal,
                                children: formatMessage($28923582fdd5ddfd$var$messages.edit_definition_prompt_text)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iPfZG.EngagementSpotlight), {
                        engagementId: editButtonSpotlightId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: showEditModal && definitionCurationOptions && /*#__PURE__*/ (0, $l998X.jsx)((0, $0b273c023ce36571$export$ea8c8594ad1f3bf3), {
                    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                    closeEditModal: closeEditModal,
                    onSaveEditModal: ()=>setDisplaySuccessFlag(true)
                })
            }),
            displaySuccessFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $d3ceefd4d089bcb8$export$7475d9ffda76c69b), {
                onDismissed: ()=>setDisplaySuccessFlag(false)
            })
        ]
    });
};









const $9083403dc3251059$var$AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
const $9083403dc3251059$var$messages = (0, $cgtv4.defineMessages)({
    // messages to disable ALL definitions
    disable_definitions_more_icon_tooltip: {
        id: "search_ai.disable_definitions_more_icon_tooltip",
        defaultMessage: "See more actions"
    },
    disable_definitions_header: {
        id: "search_ai.disable_definitions_header",
        defaultMessage: "Don\u2019t recommend definitions at all"
    },
    disable_definitions_description: {
        id: "search_ai.disable_definitions_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes."
    },
    // messages to disable SINGLE definition
    disable_definition_term_header: {
        id: "search_ai.disable_definition_term_header",
        defaultMessage: "Don\u2019t recommend this term"
    },
    disable_definition_term_description: {
        id: "search_ai.disable_definition_term_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight this specific term on any page. Only you will see these changes."
    }
});
const $9083403dc3251059$var$MoreIconStyled = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "definitions-disable-menu-button-icon",
        color: "var(--ds-icon-subtle, #505258)"
    });
const $9083403dc3251059$var$styles = {
    root: "_1bsb3xl8 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    dividerStyles: "_15a5nqa1 _uwhke4h9 _1i531l7x"
};
const $9083403dc3251059$export$6a23f0e401dcf4d9 = ()=>{
    const { commonAttributes: commonAttributes, definitionToggleEnabled: definitionToggleEnabled, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    const [definitionsDropdownMenuOpen, setDefinitionsDropdownMenuOpen] = (0, $42omo.useState)(false);
    const [disableDefinitions, setDisableDefinitions] = (0, $42omo.useState)(false); // the localStorage method to track whether all Definitions are disabled is different
    // between products so we need to get from the product whether Definitions have already been disabled by user
    (0, $42omo.useEffect)(()=>{
        const definitionsDisabled = !!readingAidsOptions?.disableDefinitionsCallbacks?.getDefinitionsDisabled();
        setDisableDefinitions(definitionsDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disableDefinitionsCallbacks = readingAidsOptions?.disableDefinitionsCallbacks; // need to account for non-platformized version
    const { menuOptions: readingAidsMenuOptions } = readingAidsOptions || {};
    const { cloudId: cloudId, query: keyPhrase, workspaceId: workspaceId } = commonAttributes;
    const cachedDefinitionTermDisabled = JSON.parse((0, $epS7s.getSessionItem)($9083403dc3251059$var$AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
    const [disableDefinitionTerm, setDisableDefinitionTerm] = (0, $42omo.useState)(cachedDefinitionTermDisabled.keyPhrase === keyPhrase);
    const { toggleDefinition: toggleDefinition } = (0, $d491ddb6c5306e7b$export$6e73bcf8826d31a5)();
    const onToggleDefinitionTermDisable = async ()=>{
        try {
            setDisableDefinitionTerm((current)=>!current);
            await toggleDefinition({
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: !disableDefinitionTerm,
                cloudId: cloudId,
                product: sourceProduct ?? ''
            });
            if (disableDefinitionTerm) (0, $epS7s.deleteSessionItem)($9083403dc3251059$var$AI_DEFINITION_TOGGLE_CACHE_KEY);
            else {
                fireAnalyticsEvent((0, $9pwVP.onClickDisableDefinition)(commonAttributes));
                (0, $epS7s.setSessionItem)($9083403dc3251059$var$AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                    keyPhrase: keyPhrase
                }));
            }
        } catch (error) {
            setDisableDefinitionTerm((current)=>!current);
            fireAnalyticsEvent((0, $xhg8G.toggleDefinitionErrorPayload)(error, commonAttributes));
        }
    };
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        isOpen: definitionsDropdownMenuOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                ...props,
                appearance: "subtle",
                icon: $9083403dc3251059$var$MoreIconStyled,
                ref: triggerRef,
                onClick: ()=>{
                    setDefinitionsDropdownMenuOpen(!definitionsDropdownMenuOpen);
                },
                testId: "definitions-menu-button",
                label: "definitions-menu-button"
            }),
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $9083403dc3251059$var$styles.root,
            space: "space.100",
            children: [
                disableDefinitionsCallbacks && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "xxsmall",
                                    children: formatMessage($9083403dc3251059$var$messages.disable_definitions_header)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                                    onChange: ()=>{
                                        if (disableDefinitions) disableDefinitionsCallbacks.onEnableDefinitions();
                                        else disableDefinitionsCallbacks.onDisableDefinitions();
                                        setDisableDefinitions(!disableDefinitions);
                                    },
                                    isChecked: disableDefinitions,
                                    testId: "definitions-toggle-disable"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtle",
                            size: "small",
                            children: formatMessage($9083403dc3251059$var$messages.disable_definitions_description)
                        })
                    ]
                }),
                readingAidsMenuOptions && readingAidsMenuOptions.length > 0 && readingAidsMenuOptions.map((option)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "center",
                                spread: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                        size: "xxsmall",
                                        children: formatMessage($9083403dc3251059$var$messages.disable_definitions_header)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                                        onChange: option.onChange,
                                        isChecked: option.toggleState,
                                        testId: "definitions-toggle-disable"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtle",
                                size: "small",
                                children: formatMessage($9083403dc3251059$var$messages.disable_definitions_description)
                            })
                        ]
                    })),
                definitionToggleEnabled && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $9083403dc3251059$var$styles.dividerStyles
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "xxsmall",
                                    children: formatMessage($9083403dc3251059$var$messages.disable_definition_term_header)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                                    onChange: onToggleDefinitionTermDisable,
                                    isChecked: disableDefinitionTerm,
                                    testId: "definition-term-toggle-disable"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtle",
                            size: "small",
                            children: formatMessage($9083403dc3251059$var$messages.disable_definition_term_description)
                        })
                    ]
                }),
                editDefinitionEnabled && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $9083403dc3251059$var$styles.dividerStyles
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $28923582fdd5ddfd$export$86ebf34eb079ac26), {
                                onClose: ()=>setDefinitionsDropdownMenuOpen(false)
                            })
                        })
                    ]
                })
            ]
        })
    });
};





































/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $c4d9cbf994fc14f9$export$206d383e26348657 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1pbykb7n _1xi2idpf _1e0c1txw _1tkexy5q",
            __cmplp.className
        ])
    });
});
const $c4d9cbf994fc14f9$export$e20ae3fbb1f307c3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpv47k _1e0c1txw _ca0qpxbi _n3tdpxbi",
            __cmplp.className
        ])
    });
});
const $c4d9cbf994fc14f9$export$fb2fc14fe9185637 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpv47k _19bvutpp _u5f312x7 _1bsbnklw _1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $c4d9cbf994fc14f9$export$7f1bcad9bf8084f8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _2lx21bp4 _1bsbohmy",
            __cmplp.className
        ])
    });
});
const $c4d9cbf994fc14f9$export$9a3438b6f4e139e4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo",
            __cmplp.className
        ])
    });
});
const $c4d9cbf994fc14f9$export$db2baac4fa175461 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $c4d9cbf994fc14f9$export$832fe7bd333fb9fe = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1ns9",
            __cmplp.className
        ])
    });
});


const $50ff7986b8457dc6$var$messages = (0, $cgtv4.defineMessages)({
    definition_more_icon_tooltip: {
        id: "search_ai.definition_more_icon_tooltip",
        defaultMessage: "See more actions"
    }
});
const $50ff7986b8457dc6$var$renderOptionsMenuControl = ({ onChange: onChange, type: type, isChecked: isChecked })=>{
    switch(type){
        case 'toggle':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                onChange: onChange,
                isChecked: isChecked,
                testId: "ai-answer-options-menu-toggle"
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    }
};
const $50ff7986b8457dc6$var$MoreIconStyled = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "reading-aids-menu-button-icon",
        color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
    });
const $50ff7986b8457dc6$var$AIOptionsMenuOption = ({ header: header, description: description, onChange: onChange, type: type, isChecked: isChecked })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $c4d9cbf994fc14f9$export$fb2fc14fe9185637), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $c4d9cbf994fc14f9$export$7f1bcad9bf8084f8), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $c4d9cbf994fc14f9$export$9a3438b6f4e139e4), {
                        children: header
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $c4d9cbf994fc14f9$export$db2baac4fa175461), {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c4d9cbf994fc14f9$export$832fe7bd333fb9fe), {
                children: $50ff7986b8457dc6$var$renderOptionsMenuControl({
                    onChange: onChange,
                    type: type,
                    isChecked: isChecked
                })
            })
        ]
    });
};
const $50ff7986b8457dc6$export$77d203904974193c = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isMenuOpen, setMenuOpen] = (0, $42omo.useState)(false);
    const { readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const { menuOptions: menuOptions } = readingAidsOptions || {};
    const toggleMenuOpen = (0, $42omo.useCallback)(()=>{
        setMenuOpen(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    return !!menuOptions?.length ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        position: "bottom",
        content: formatMessage($50ff7986b8457dc6$var$messages.definition_more_icon_tooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            isOpen: isMenuOpen,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...props,
                    appearance: "subtle",
                    icon: $50ff7986b8457dc6$var$MoreIconStyled,
                    ref: triggerRef,
                    onClick: toggleMenuOpen,
                    testId: "reading-aids-menu-button",
                    label: "reading-aids-menu-button"
                }),
            shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-knowledge-d'),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4d9cbf994fc14f9$export$e20ae3fbb1f307c3), {
                onClick: (e)=>e.stopPropagation(),
                children: menuOptions?.length && menuOptions.map((menuOption, index)=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)($50ff7986b8457dc6$var$AIOptionsMenuOption, {
                        header: formatMessage(menuOption.label),
                        description: menuOption.description && formatMessage(menuOption.description),
                        onChange: menuOption.onChange,
                        isChecked: menuOption.toggleState,
                        type: menuOption.type
                    }, index);
                })
            })
        })
    }) : null;
};



const $af71153c0679ef22$export$77d2212db482996b = ()=>{
    const platformDisableOn = (0, $dh538.fg)('kd_definitions_confluence_enable_platform');
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c4d9cbf994fc14f9$export$206d383e26348657), {
        children: serveDefinitionUXUpdates ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9083403dc3251059$export$6a23f0e401dcf4d9), {}) : platformDisableOn ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6780a693da5d102f$export$a025edc19ca0650a), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $50ff7986b8457dc6$export$77d203904974193c), {})
    });
};


const $6f2f2b7b6a18595d$var$styles = {
    titleWrapper: "_1bah1yb4 _4cvr1h6o _19pkv47k _2hwx1ejb _18u01ejb",
    titleWrapperUpdateStyles: "_19pkutpp _2hwxpxbi _18u0pxbi",
    definitionTitle: "_11c81e3o _syazi7uo"
};
const $6f2f2b7b6a18595d$export$20a48ed23bb601ed = ()=>{
    const { commonAttributes: commonAttributes, baseQuery: baseQuery } = (0, $eRXI0.useAIAnswerContext)();
    const { query: query } = commonAttributes;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($6f2f2b7b6a18595d$var$styles.titleWrapper, serveDefinitionUXUpdates && $6f2f2b7b6a18595d$var$styles.titleWrapperUpdateStyles),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $6f2f2b7b6a18595d$var$styles.definitionTitle,
                testId: "definition-answer-card-title",
                as: "h2",
                children: baseQuery ? baseQuery : query
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $af71153c0679ef22$export$77d2212db482996b), {})
        ]
    });
};





/* reading-aids-follow-ups.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























































const $76f820f7a10733b3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    definition_open_chat_user_initial_query: {
        id: "search_ai.definitions_open_chat_initial_query",
        defaultMessage: "Define {term}"
    }
});





const $4b04b2dbf66c72a0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    reading_aids_follow_ups_user_initial_query: {
        id: "search_ai.reading_aids_follow_ups_initial_query",
        defaultMessage: "Define {term}"
    }
});


const $8ee4ea5909e3a3b6$var$styles = {
    followUpWrapperStyles: "_19bv1ejb _u5f31ejb _n3tdu2gc",
    followUpWrapperUpdateStyles: "_19bvpxbi _u5f3pxbi",
    dividerStyles: "_15a5nqa1 _uwhke4h9 _1i531l7x"
};
const $8ee4ea5909e3a3b6$export$b5da368bdedbbfc7 = ()=>{
    const { isAnswered: isAnswered, commonAttributes: commonAttributes, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { query: query, answerString: answerString, followUps: followUps } = commonAttributes;
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [showAllFollowUps, setShowAllFollowups] = (0, $42omo.useState)(false);
    const canExpand = followUps.length > 1;
    const visibleFollowUps = showAllFollowUps ? followUps : followUps.slice(0, 1);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    const onFollowupsExpand = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onExpandButtonClicked)({
            ...commonAttributes,
            expandButtonSource: 'follow-ups'
        }));
        setShowAllFollowups(!showAllFollowUps);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllFollowUps
    ]);
    const onFollowUpClick = (0, $42omo.useCallback)((followUp)=>{
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(followUp);
            return;
        }
        fireAnalyticsEvent((0, $4xTru.onFollowUpSuggestionClick)({
            ...commonAttributes,
            followUpString: followUp
        }));
        publish({
            type: 'chat-new',
            source: 'reading-aids',
            data: {
                name: followUp.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: formatMessage((0, $4b04b2dbf66c72a0$export$defe85febe8b728c).reading_aids_follow_ups_user_initial_query, {
                                // query only contains the word that user asked
                                // we want to add the word "define" before it so it makes sense
                                // when this is moved to the chat
                                term: query
                            })
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        formatMessage,
        onClose,
        readingAidsOptions,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    if (!followUps?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8ee4ea5909e3a3b6$var$styles.followUpWrapperStyles, serveDefinitionUXUpdates && $8ee4ea5909e3a3b6$var$styles.followUpWrapperUpdateStyles),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            children: [
                serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $8ee4ea5909e3a3b6$var$styles.dividerStyles
                }),
                visibleFollowUps.map((followUp, index)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        spread: serveDefinitionUXUpdates ? 'space-between' : undefined,
                        children: [
                            serveDefinitionUXUpdates ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))),
                                spacing: "compact",
                                onClick: ()=>onFollowUpClick(followUp),
                                testId: "definition-follow-up-button",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    maxLines: 1,
                                    color: "color.text.subtle",
                                    weight: "medium",
                                    children: followUp
                                })
                            }, followUp) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ab1fW.FollowUpButton), {
                                followUpIndex: index,
                                followUpText: followUp,
                                followUpType: "UNAVAILABLE",
                                experienceId: "reading-aids",
                                onClick: ()=>onFollowUpClick(followUp)
                            }, followUp),
                            index === 0 && canExpand && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                onClick: onFollowupsExpand,
                                icon: (iconProps)=>showAllFollowUps ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                        ...iconProps,
                                        color: "currentColor",
                                        testId: "collapse-follow-ups-icon",
                                        size: "small"
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                        ...iconProps,
                                        color: "currentColor",
                                        testId: "expand-follow-ups-icon",
                                        size: "small"
                                    }),
                                appearance: "subtle",
                                label: showAllFollowUps ? 'Collapse follow ups button' : 'Expand follow ups button'
                            })
                        ]
                    })),
                isAnswered && serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $201eb101f1d7d1b2$export$dc40dedc9df6e59f), {
                    prompt: formatMessage((0, $76f820f7a10733b3$export$defe85febe8b728c).definition_open_chat_user_initial_query, {
                        // query only contains the highlighted word
                        // we want to prefix the word "define" before
                        // when a user's context is moved to chat
                        term: query
                    }),
                    answerString: answerString,
                    query: query,
                    source: 'reading-aids'
                })
            ]
        })
    });
};







const $59e59815342d850f$var$styles = {
    sourcesContainer: "_ca0qidpf _u5f31ejb _n3tdu2gc _19bv1ejb",
    openChatContainer: "_18zr1ejb _85i5u2gc"
};
const $59e59815342d850f$var$MAX_SOURCES = 4;
var $59e59815342d850f$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
const $59e59815342d850f$var$noop = ()=>{};
const $59e59815342d850f$var$OpenChat = ({ answerString: answerString, query: query })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!(0, $dh538.fg)('kd_definitions_open_chat')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $59e59815342d850f$var$styles.openChatContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $201eb101f1d7d1b2$export$dc40dedc9df6e59f), {
            prompt: formatMessage((0, $76f820f7a10733b3$export$defe85febe8b728c).definition_open_chat_user_initial_query, {
                // query only contains the highlighted word
                // we want to prefix the word "define" before
                // when a user's context is moved to chat
                term: query
            }),
            query: query,
            answerString: answerString,
            source: 'reading-aids'
        })
    });
};
const $59e59815342d850f$export$9d3e24a5ad9e38ea = ()=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const enableSmartLinkSources = readingAidsOptions?.enableSmartLinkSources;
    const { searchSessionId: searchSessionId, sources: sources, answerString: answerString, query: query } = commonAttributes;
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $dh538.fg)('kd_definitions_ux_uplift_exp_gate');
    const sourceClickCallback = (0, $42omo.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
        children: (props)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $lJsaE.ReadingAidsWrapper), {
                onClick: (e)=>e.stopPropagation(),
                ...props,
                "data-testId": "definition-answer-card",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f2f2b7b6a18595d$export$20a48ed23bb601ed), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {}),
                    editDefinitionEnabled && !serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $28923582fdd5ddfd$export$86ebf34eb079ac26), {}),
                    !serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $59e59815342d850f$var$styles.sourcesContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$bbbfd63fa7f32357), {
                            sources: sources,
                            searchSessionId: searchSessionId,
                            onClickHandler: sourceClickCallback,
                            limit: $59e59815342d850f$var$MAX_SOURCES,
                            verticalLayout: true,
                            enableSmartLinkSources: enableSmartLinkSources,
                            isReadingAids: true
                        })
                    }),
                    serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)((0, $b5507f16187f0872$export$63e4658af6ffde25), {
                        sources: sources
                    }),
                    showChatFollowUps && /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8ee4ea5909e3a3b6$export$b5da368bdedbbfc7), {})
                            }),
                            isAnswered && !serveDefinitionUXUpdates && /*#__PURE__*/ (0, $l998X.jsx)($59e59815342d850f$var$OpenChat, {
                                answerString: answerString,
                                query: query
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$37858bd8fa3d5915), {})
                ]
            })
    });
};
const $59e59815342d850f$export$d1b852cfff73cbe8 = ()=>{
    const previousAnswerState = (0, $42omo.useRef)();
    const { commonAttributes: commonAttributes, loading: loading, partialResponse: partialResponse, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [continueLoadingAnimation, setContinueLoadingAnimation] = (0, $42omo.useState)(true);
    const { source: source } = commonAttributes;
    const isStreaming = !!partialResponse;
    const { onAnswerStateChange: onAnswerStateChange = $59e59815342d850f$var$noop, definitionLoadingConfig: definitionLoadingConfig } = readingAidsOptions || {};
    (0, $42omo.useLayoutEffect)(()=>{
        if (!loading) {
            const countdownRemainingAnimation = setTimeout(()=>{
                setContinueLoadingAnimation(false);
            }, 3000);
            return ()=>clearTimeout(countdownRemainingAnimation);
        }
    }, [
        loading
    ]);
    (0, $42omo.useEffect)(()=>{
        // update answer state for external consumers
        // using a previous answer state to prevent multiple duplicate calls,
        // especially in the case of loading && streaming
        if ((0, $dh538.fg)('kd_definitions_answer_state_signal')) {
            if (hasError && previousAnswerState.current !== "errored") {
                onAnswerStateChange("errored");
                previousAnswerState.current = "errored";
                (0, $7DCm4.aiDefinitionsLoadUFOExperience).failure();
            } else if (isAnswered && previousAnswerState.current !== "answered") {
                onAnswerStateChange("answered");
                previousAnswerState.current = "answered";
                (0, $7DCm4.aiDefinitionsLoadUFOExperience).success();
            } else if ((loading || isStreaming) && previousAnswerState.current !== "loading") {
                onAnswerStateChange("loading");
                previousAnswerState.current = "loading";
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        loading,
        isStreaming,
        isAnswered,
        hasError
    ]);
    const onLoadingAnimationShown = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes, true)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireAnalyticsEvent
    ]);
    if (loading || isStreaming) {
        if (definitionLoadingConfig) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eabfebdecced7503$export$c7f94e62a2f54f71), {
            width: definitionLoadingConfig.width
        });
         // will keep this old animation as a fallback in case definitionLoadingConfig is not passed in
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bXlEj.DotAnimationLoader), {
            onAnimationShown: onLoadingAnimationShown,
            source: source,
            "data-testid": "ai-answer-animated-loader"
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lJsaE.ReadingAidsPopupContainer), {
        continueAnimation: continueLoadingAnimation,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lJsaE.ReadingAidsContainer), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($59e59815342d850f$export$9d3e24a5ad9e38ea, {})
        })
    });
};









var $kyiqo = parcelRequire("kyiqo");




const $d3c4f32cc234b266$export$a83a35d6598a5fb6 = (0, $kyiqo.metrics).pageSegmentLoad({
    key: 'ai-search-dialog'
}); // Product is automatically prepended to the key
const $d3c4f32cc234b266$export$6220c1b7224eb2a2 = ()=>{
    const { isReadingAids: isReadingAids, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { source: source } = commonAttributes;
    (0, $42omo.useEffect)(()=>{
        $d3c4f32cc234b266$export$a83a35d6598a5fb6.stop({
            customData: {
                isReadingAids: !!isReadingAids,
                source: source
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {});
};


/* legacy-smart-answer-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















/* ai-answer-loading-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























/* collapse.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $jSnXV = parcelRequire("jSnXV");








var $1kVeP = parcelRequire("1kVeP");


var $64M9v = parcelRequire("64M9v");












const $1bc91a785c030963$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title_label: {
        id: "search_ai.smart_answer_card_title",
        defaultMessage: "Answer"
    },
    expand_label: {
        id: "search_ai.smart_answer_expand_label",
        defaultMessage: "Expand"
    },
    collapse_label: {
        id: "search_ai.smart_answer_collapse_label",
        defaultMessage: "Collapse"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_expand_tooltip: {
        id: "search_ai.ai_answer_expand_tooltip",
        defaultMessage: "Expand"
    },
    ai_answer_collapse_tooltip: {
        id: "search_ai.ai_answer_collapse_tooltip",
        defaultMessage: "Collapse"
    }
});


/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 










const $32dccc1d32edcb4a$export$f2207ab910ac3fa8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ibnsxm": (0, $7sObp.default)(__cmplp.isLoading || __cmplp.isStreaming ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, #FFFFFF)"),
            "--_10yp470": (0, $7sObp.default)(__cmplp.isLoading || __cmplp.isStreaming ? 'rotate 3s infinite linear' : 'rotate-end 3s 1 linear')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1b66 _19itia51 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _kqswh2mm _vchhusvi _1pby11wp _rfx31b66 _1s6k1hu4 _16qqxqk1 _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _1dbx1xgd _9v7at94y _14mj1b66 _aetrb3bt _z0ai1ud2 _1qdg1ud2 _18postnw _1bqq1mrw _1hfk1bhr",
            __cmplp.className
        ])
    });
});
const $32dccc1d32edcb4a$export$a550342571a01571 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _19pkpxbi _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $32dccc1d32edcb4a$export$90ec299a95f41a29 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_o0efd2": (0, $7sObp.default)(__cmplp.width ? __cmplp.width : '100%'),
            "--_6auco7": (0, $7sObp.default)(__cmplp.height ? __cmplp.height : '16px')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _11q7lm00 _y44v1sal _1e0c1txw _1bsb1eet _4t3ivw99",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $32dccc1d32edcb4a$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3iucft _vchhusvi _ca0q1ejb _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $32dccc1d32edcb4a$export$636ea4c09615ceed = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _18u0v77o _syaz1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $32dccc1d32edcb4a$export$d2b052e7b4be1756 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omtlke _1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $32dccc1d32edcb4a$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _t9ec1hke",
            __cmplp.className
        ])
    });
});
const $32dccc1d32edcb4a$export$975a268f2c733e4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7yuyx _19pkidpf _2hwxt94y _otyridpf _18u0t94y _94n5idpf _1e0c1ule _4t3i1jfw _kqsw1if8",
            __cmplp.className
        ])
    });
});
const $32dccc1d32edcb4a$export$f243da7eac28085c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1y6m _ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
});


const $a42449dc4c4689f6$var$styles = {
    container: "_1reo15vq _18m915vq _kqswh2mm",
    expanded: "_4t3i1wug",
    collapsed: "_4t3i1w81",
    pointerCursor: "_80omtlke",
    titleContainer: "_11c8wadc _syaz1rpy _k48p1pd9 _ca0qpxbi _u5f31ejb _n3tdze3t _19bv1ejb",
    title: "_ae4v1h6o _4t3i1ou6"
};
var $a42449dc4c4689f6$var$EXPANSION_STATE = /*#__PURE__*/ function(EXPANSION_STATE) {
    EXPANSION_STATE[EXPANSION_STATE["LOADING"] = 1] = "LOADING";
    // still computing if the threshold is crossed
    EXPANSION_STATE[EXPANSION_STATE["COLLAPSED"] = 2] = "COLLAPSED";
    // threshold crossed, render component collapsed
    EXPANSION_STATE[EXPANSION_STATE["EXPANDED"] = 3] = "EXPANDED";
    return EXPANSION_STATE;
}($a42449dc4c4689f6$var$EXPANSION_STATE || {});
const $a42449dc4c4689f6$export$78768a9af065a7b = ({ children: children, collapsed: collapsed, isLoading: isLoading, toggleCollapsedState: toggleCollapsedState = ()=>{}, expandWhenClickedAnywhere: expandWhenClickedAnywhere = false, isStreaming: isStreaming = false, disableCollapse: disableCollapse = false, callbacks: callbacks })=>{
    const [initialExpansionState, setInitialExpansionState] = (0, $42omo.useState)(1);
    const threshold = 150;
    const collapseableContainerRef = (0, $42omo.useCallback)((node)=>{
        if (!node || disableCollapse) return;
        const resizeObserver = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            // delay computation to ensure the observed node has rendered and the height reported is accurate
            setTimeout(()=>{
                const childHeight = node.getBoundingClientRect().height;
                if (isStreaming || isLoading || !Boolean(childHeight)) return;
                 // checking if the length of the answer is smaller than the collapse threshold
                if (childHeight <= threshold && initialExpansionState !== 3) setInitialExpansionState(3);
                else setInitialExpansionState(2);
            }, 100);
        }, 100));
        resizeObserver.observe(node);
    }, // make sure the dependancy array is empty,
    // this is to ensure the resizeObserver is registered just once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $42omo.useEffect)(()=>{
        /**
     * if the answer has finished isLoading and the container is too small to collapse,
     * toggle collapsed state to false
     * this helps external components watching the boolean to know the actual state
     */ if (initialExpansionState === 3 && !isLoading && !isStreaming && collapsed || disableCollapse) {
            toggleCollapsedState();
            callbacks?.onExpandedByDefault?.();
        }
    }, [
        initialExpansionState,
        isLoading,
        isStreaming,
        collapsed,
        callbacks,
        toggleCollapsedState,
        disableCollapse
    ]);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const tooltipText = formatMessage(collapsed ? (0, $1bc91a785c030963$export$defe85febe8b728c).ai_answer_expand_tooltip : (0, $1bc91a785c030963$export$defe85febe8b728c).ai_answer_collapse_tooltip); // allow whole container clicks to expand when enabled
    const onContainerClickHandler = ()=>{
        if (expandWhenClickedAnywhere && collapsed) {
            callbacks?.onExpandClicked?.();
            toggleCollapsedState();
        }
    };
    const onClickHandler = (e)=>{
        // stop container click from being called
        e.stopPropagation();
        if (collapsed) callbacks?.onExpandClicked?.();
        else callbacks?.onCollapseClicked?.();
        toggleCollapsedState();
    }; /**
      * render the non collapsable version
      * - child container's height is lesser than the threshold
      * - collapsed card is externally disabled, ex: for a person card
      */ 
    if (initialExpansionState === 3 || disableCollapse) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a42449dc4c4689f6$var$styles.container, $a42449dc4c4689f6$var$styles.expanded),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            children: [
                !isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    alignBlock: "center",
                    xcss: $a42449dc4c4689f6$var$styles.titleContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $a42449dc4c4689f6$var$styles.title,
                        children: formatMessage((0, $1bc91a785c030963$export$defe85febe8b728c).title_label)
                    })
                }),
                children
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a42449dc4c4689f6$var$styles.container, collapsed ? $a42449dc4c4689f6$var$styles.collapsed : $a42449dc4c4689f6$var$styles.expanded, expandWhenClickedAnywhere && collapsed && $a42449dc4c4689f6$var$styles.pointerCursor),
        onClick: onContainerClickHandler,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                spread: 'space-between',
                xcss: $a42449dc4c4689f6$var$styles.titleContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $a42449dc4c4689f6$var$styles.title,
                        children: formatMessage((0, $1bc91a785c030963$export$defe85febe8b728c).title_label)
                    }),
                    initialExpansionState === 2 && /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        position: 'bottom',
                        content: tooltipText,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$d2b052e7b4be1756), {
                            onClick: onClickHandler,
                            "data-testid": "expand-collapse-toggle",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$e1c22a2ee2645e36), {
                                children: collapsed ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
                                    color: "currentColor",
                                    spacing: "spacious",
                                    label: formatMessage((0, $1bc91a785c030963$export$defe85febe8b728c).expand_label)
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
                                    color: "currentColor",
                                    spacing: "spacious",
                                    label: formatMessage((0, $1bc91a785c030963$export$defe85febe8b728c).collapse_label)
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: collapseableContainerRef,
                children: children
            }),
            initialExpansionState === 2 && collapsed && /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$975a268f2c733e4), {})
        ]
    });
};





/* ai-answer-loading-stream.tsx generated by @compiled/babel-plugin v0.36.1 */ // vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx



















const $1b01177f202b870e$var$styles = {
    container: "_1tke19n7 _ca0qu2gc _u5f31ejb _n3tdu2gc _19bv1ejb",
    containerStylesWithoutStreamingExpand: "_1reo15vq _18m915vq _c71l1lit"
};

const $1b01177f202b870e$var$ReactRenderer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1l2X9")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));

const $1b01177f202b870e$var$MarkdownRenderer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gdXLD")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $1b01177f202b870e$export$9799dac43580176f = ({ markdown: markdown })=>{
    const docContent = (0, $42omo.useMemo)(()=>(0, $4pEXC.encodeAdf)(markdown, false), [
        markdown
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($1b01177f202b870e$var$styles.container, !(0, $dh538.fg)('kd_sain_enable_expand_when_streaming') && $1b01177f202b870e$var$styles.containerStylesWithoutStreamingExpand),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: (0, $dh538.fg)('kd_smart_answers_use_adf_encoder') || (0, $dh538.fg)('kd_smart_answers_use_adf_encoder_jira') ? /*#__PURE__*/ (0, $l998X.jsx)($1b01177f202b870e$var$ReactRenderer, {
                document: docContent,
                nodeComponents: {
                    status: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3574ef4ffa67c8f4$export$21553c57082a6434), {
                            ...props
                        }),
                    // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                    // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                    ...!(0, $dh538.fg)('hybrid_orchestrator_enable_image_search') ? {
                        media: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                        mediaSingle: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {})
                    } : undefined
                }
            }) : // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
            // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
            /*#__PURE__*/ (0, $l998X.jsx)($1b01177f202b870e$var$MarkdownRenderer, {
                disallowedElements: (0, $dh538.fg)('hybrid_orchestrator_enable_image_search') ? undefined : [
                    'img'
                ],
                children: markdown
            })
        })
    });
};


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


parcelRequire("42omo");

// vendored from packages/editor/editor-plugin-ai/src/ui/modal/styles.tsx
const $720cf18cfdb27493$var$GeneratingAnimation = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #0C66E4)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #0C66E4)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #0C66E4)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
var $720cf18cfdb27493$export$2e2bcd8739ae039 = $720cf18cfdb27493$var$GeneratingAnimation;



const $f6bf768beba90733$var$styles = {
    scroll: "_c71l1w81 _ca0qpxbi _18m91wug _1reo15vq _a5o91vhh"
};
const $f6bf768beba90733$export$73cae3a70b740900 = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($f6bf768beba90733$var$LegacySmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    });
};
const $f6bf768beba90733$var$LegacySmartAnswerLoadingDialog = ({ collapsed: collapsed = true, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { partialResponse: partialResponse, queryReasoning: queryReasoning, isReadingAids: isReadingAids, onClose: onClose } = (0, $eRXI0.useAIAnswerContext)();
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    });
    const isQuickSearch = Boolean(!isReadingAids && onClose);
    if (!partialResponse || partialResponse?.format !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $c71e4c8897192027$export$1be966180e49de50), {
        isStreaming: false,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $c71e4c8897192027$export$b6aef1fd050b8edc), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $720cf18cfdb27493$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $c71e4c8897192027$export$636ea4c09615ceed), {
                        children: serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $7lL49.messages).ai_answer_generating_rovo
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$9e8b51119c9a7742), {})
        ]
    });
    if (isQuickSearch) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c71e4c8897192027$export$1be966180e49de50), {
        isStreaming: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7bZ3i.SmartCardProvider), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $f6bf768beba90733$var$styles.scroll,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1b01177f202b870e$export$9799dac43580176f), {
                            markdown: partialResponse.partialNlpResult
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$9e8b51119c9a7742), {})
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c71e4c8897192027$export$1be966180e49de50), {
        isStreaming: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7bZ3i.SmartCardProvider), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $a42449dc4c4689f6$export$78768a9af065a7b), {
                        collapsed: collapsed,
                        isLoading: true,
                        isStreaming: true,
                        expandWhenClickedAnywhere: true,
                        toggleCollapsedState: toggleCollapsedState,
                        callbacks: callbacks,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1b01177f202b870e$export$9799dac43580176f), {
                            markdown: partialResponse.partialNlpResult
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$9e8b51119c9a7742), {})
                ]
            })
        })
    });
};










const $d7d3009f3793d049$var$styles = {
    spacer: "_4t3idlk8 _ca0qv47k",
    errorContainer: "_19pku2gc _otyrpxbi",
    sourcesContainer: "_ca0qidpf _u5f31ejb _n3tdu2gc _19bv1ejb",
    scroll: "_c71ldtre _1reo15vq _18m91wug _a5o91vhh"
};
const $d7d3009f3793d049$var$MAX_SOURCES = 4;
const $d7d3009f3793d049$export$cf72ef8498afcbc2 = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper, onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, initiallyExpanded: initiallyExpanded } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { query: query } = commonAttributes;
    const { answerFormat: answerFormat } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $42omo.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose);
    // reset on each new query
    (0, $42omo.useEffect)(()=>{
        setCollapsed(!initiallyExpanded);
        // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]);
    // Call onFMPReached when answer is loaded
    (0, $42omo.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed);
        // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $42omo.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)(LoadingWrapper, {
        children: // disable collapse/expand when streaming for quick search
        isQuickSearch ? /*#__PURE__*/ (0, $l998X.jsx)((0, $f6bf768beba90733$export$73cae3a70b740900), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $f6bf768beba90733$export$73cae3a70b740900), {
            collapsed: collapsed,
            toggleCollapsedState: toggleCollapsedState,
            callbacks: analyticsCallbacks
        })
    });
    let aiAnswerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $a42449dc4c4689f6$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    if (hasError) aiAnswerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d7d3009f3793d049$var$styles.errorContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    else if (isQuickSearch || answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $d7d3009f3793d049$var$styles.spacer
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: isQuickSearch ? $d7d3009f3793d049$var$styles.scroll : undefined,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(DialogWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
            isLoading: false,
            isStreaming: false,
            children: [
                aiAnswerContent,
                !hasError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $d7d3009f3793d049$var$styles.sourcesContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$bbbfd63fa7f32357), {
                        sources: commonAttributes.sources,
                        searchSessionId: commonAttributes.searchSessionId,
                        onClickHandler: sourceClickCallback,
                        limit: $d7d3009f3793d049$var$MAX_SOURCES,
                        enableSmartLinkSources: true
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$37858bd8fa3d5915), {})
            ]
        })
    });
};


/* legacy-smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v0.36.1 */ 





























const $111129b397a148b4$var$styles = {
    spacer: "_4t3idlk8 _ca0qv47k",
    errorContainer: "_19pku2gc _otyrpxbi",
    sourcesContainer: "_ca0qidpf _u5f31ejb _n3tdu2gc _19bv1ejb"
};
const $111129b397a148b4$var$MAX_SOURCES = 4;
const $111129b397a148b4$export$b054d5cce3d1302d = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper, onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, initiallyExpanded: initiallyExpanded } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $42omo.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose);
    // reset on each new query
    (0, $42omo.useEffect)(()=>{
        setCollapsed(!initiallyExpanded);
        // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]);
    // Call onFMPReached when answer is loaded
    (0, $42omo.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed);
        // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $42omo.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)(LoadingWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f6bf768beba90733$export$73cae3a70b740900), {})
    });
    let aiAnswerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $a42449dc4c4689f6$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    if (hasError) aiAnswerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $111129b397a148b4$var$styles.errorContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    else if (isQuickSearch || answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $111129b397a148b4$var$styles.spacer
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(DialogWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
            isLoading: false,
            isStreaming: false,
            children: [
                aiAnswerContent,
                !hasError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $111129b397a148b4$var$styles.sourcesContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$bbbfd63fa7f32357), {
                        sources: commonAttributes.sources,
                        searchSessionId: commonAttributes.searchSessionId,
                        onClickHandler: sourceClickCallback,
                        limit: $111129b397a148b4$var$MAX_SOURCES,
                        enableSmartLinkSources: true
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$37858bd8fa3d5915), {})
            ]
        })
    });
};


/* smart-answer-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























const $f5159735ac7dbad3$export$22fa983d82ded8f8 = (text)=>{
    if (!text || typeof text !== 'string') return null;
    // Normalize the text by trimming extra whitespace
    const normalizedText = text.trim();
    // Regular expressions to match various date formats, including day of the week
    const datePatterns = [
        // Date ranges (e.g., "May 5th to May 7th, 2025")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\s+to\s+(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)?\s*\d{1,2}(?:st|nd|rd|th)?,?\s+\d{4}\b/i,
        // Day of the week with full date (e.g., "Monday, May 26th")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s+(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Full dates with year (e.g., "May 26, 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},\s+\d{4}\b/i,
        // Dates with ordinals (e.g., "June 30th")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Month and year formats (e.g., "March 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{4}\b/i
    ];
    // Loop through patterns and try to find a match
    for (const pattern of datePatterns){
        const match = normalizedText.match(pattern);
        if (match) return match[0]; // Return the matched date or date range
    }
    // If no date is found, return null
    return null;
};


const $5079ddf97186ff6e$export$9df94c77b0746c3c = (answerStr)=>{
    if (!answerStr || typeof answerStr !== 'string') return null;
    // Remove extra whitespace and normalize
    const normalizedText = answerStr.trim().replace(/\s+/g, ' ');
    // Too short to be an address
    if (normalizedText.length < 5) return null;
    // Comprehensive address pattern
    // This pattern supports:
    // - Street numbers and names
    // - Unit numbers (e.g., #123, Apt 123, Suite 123)
    // - City/region/state names
    // - Optional state abbreviations (e.g., CA, TX, NSW)
    // - Optional postal/ZIP codes
    // - Optional country names
    const addressPattern = /\b\d{1,5}\s+[\w\s\.,\-#]+(?:#\d+|,\s*(?:Apt|Suite|Unit|Room|Fl|Floor)?\s*\d+)?\s*,\s*[\w\s]+,\s*[A-Z]{2,3}(?:\s*\d{4,5}(?:-\d{4})?)?(?:,\s*[A-Za-z\s]+)?\b/i;
    // Match the address in the text
    const match = normalizedText.match(addressPattern);
    if (match) return match[0]; // Return the matched address
    // If no match is found, return null
    return null;
};





/* DateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 








































var $4A7Gn = parcelRequire("4A7Gn");

const $b6a87b24781bef6b$export$1aa02cade2c95a15 = ({ children: children, selectedTabIndex: selectedTabIndex, onChange: onChange })=>{
    const handleChange = (0, $42omo.useCallback)((index)=>{
        onChange?.(index);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4A7Gn.default), {
        onChange: handleChange,
        selected: selectedTabIndex ?? 0,
        id: "ai-answer-tabs",
        children: children
    });
};


/* ai-tabs-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



















var $gCbPZ = parcelRequire("gCbPZ");

var $0DTaW = parcelRequire("0DTaW");



const $b7a45b5b745cdfd5$var$styles = {
    fullHeight: "_4t3i1osq",
    tabListAndButtonInline: "_19bvpxbi _u5f3pxbi _ca0q12x7 _1nw51j28"
};
const $b7a45b5b745cdfd5$export$29246287a2faf86e = ({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, showSourcesTab: showSourcesTab })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between",
        testId: "ai-tabs-header",
        xcss: $b7a45b5b745cdfd5$var$styles.tabListAndButtonInline,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_tab_ai_answer
                        })
                    }),
                    showSourcesTab ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_tab_sources
                        })
                    }) : null
                ]
            }),
            typeof collapsed === 'boolean' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                appearance: "subtle",
                icon: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))),
                label: formatMessage(collapsed ? (0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_expand_button : (0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_collapse_button),
                spacing: "compact",
                onClick: onExpandCollapseButtonClick
            }) : null
        ]
    });
};
const $b7a45b5b745cdfd5$export$fe213eac7ac2fc44 = ({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, sources: sources })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between",
        testId: "ai-tabs-header-with-sources-stack",
        xcss: $b7a45b5b745cdfd5$var$styles.tabListAndButtonInline,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_tab_ai_answer
                        })
                    }),
                    sources && sources.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            space: "space.050",
                            alignBlock: "center",
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cf600ec688712ec4$export$ebff7094edd1bb81), {
                                        sources: sources
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_tab_sources_with_pluralization,
                                        values: {
                                            sourcesCount: sources.length
                                        }
                                    })
                                ]
                            })
                        })
                    }) : null
                ]
            }),
            typeof collapsed === 'boolean' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                appearance: "subtle",
                icon: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))),
                label: formatMessage(collapsed ? (0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_expand_button : (0, $30fab9b241e9e86b$export$defe85febe8b728c).ai_answer_card_collapse_button),
                spacing: "compact",
                onClick: onExpandCollapseButtonClick
            }) : null
        ]
    });
};


/* ai-tabs-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $k0WY4 = parcelRequire("k0WY4");




const $f34926bfd3d2d7be$var$styles = {
    root: "_1reo15vq _18m915vq _n3td12x7 _19bvpxbi _u5f3pxbi _ca0qutpp",
    rootCollapsed: "_4t3i68cl _1nwp1n9w",
    rootCollapsedWithReadMore: "_1reo15vq _18m915vq _4t3iucft _1bto1l2s _o5721q9c _1nwp1n9w",
    rootExpanded: "_1tke1k53",
    explicitQuestionCollapsed: "_4t3i1ogy _1nwp1n9w",
    explicitQuestionCollapsedWithReadMore: "_4t3i1018 _1bto1l2s _o5721q9c _1nwp1n9w",
    explicitQuestionExpanded: "_1tke1q9m",
    fullWidth: "_1bsb1osq"
};
const $f34926bfd3d2d7be$export$43f4112a26740715 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, collapsed: collapsed, showReadMoreButton: showReadMoreButton = false, xcss: xcss, queryIntent: queryIntent }, ref)=>{
    const tabPanelAttributes = (0, $k0WY4.useTabPanel)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ...tabPanelAttributes,
        ref: ref,
        xcss: xcss ?? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $1Whri.cx)($f34926bfd3d2d7be$var$styles.root, queryIntent === (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION ? collapsed ? showReadMoreButton ? $f34926bfd3d2d7be$var$styles.explicitQuestionCollapsedWithReadMore : $f34926bfd3d2d7be$var$styles.explicitQuestionCollapsed : $f34926bfd3d2d7be$var$styles.explicitQuestionExpanded : collapsed ? showReadMoreButton ? $f34926bfd3d2d7be$var$styles.rootCollapsedWithReadMore : $f34926bfd3d2d7be$var$styles.rootCollapsed : $f34926bfd3d2d7be$var$styles.rootExpanded),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $f34926bfd3d2d7be$var$styles.fullWidth,
            children: children
        })
    });
});



























function $a6949a7d3f3d76d1$export$257180ca8df15f46() {
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { callbacks: callbacks, commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    const { searchSessionId: searchSessionId, sources: sources } = commonAttributes;
    const sourceClickCallback = (0, $42omo.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        callbacks,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: (0, $4xTru.getSmartLinksAnalyticsContextData)({
                location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                commonAttributes: commonAttributes
            }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    alignBlock: "center",
                    rowSpace: "space.100",
                    shouldWrap: true,
                    space: "space.050",
                    children: sources.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $b578d109a323f8ce$export$c74cbf75d6285884), {
                            index: index,
                            source: source,
                            searchSessionId: searchSessionId,
                            onClickHandler: sourceClickCallback,
                            enableSmartLinkSources: true
                        }, `search-ai-answer-source-${index}`))
                })
            })
        })
    });
}


var $7d955b18211a45bf$exports = {};
$7d955b18211a45bf$exports = new URL("calendar-dark.a0ed3c18.svg", import.meta.url).toString();


var $59e544052aeecaab$exports = {};
$59e544052aeecaab$exports = new URL("calendar-light.caa4677f.svg", import.meta.url).toString();














parcelRequire("42omo");




const $b4d33197c0e90546$var$defaultKnowledgeCardActionsProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.100'
};
const $b4d33197c0e90546$export$cb4f4efd621b33bb = (props)=>{
    const knowledgeCardActionsProps = {
        ...$b4d33197c0e90546$var$defaultKnowledgeCardActionsProps,
        ...props
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        ...knowledgeCardActionsProps
    });
};





parcelRequire("42omo");




const $1f9c8fbf9f23ff99$export$d7852a48c1d6ef5b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        color: "color.text.subtle",
        children: children
    });
};





parcelRequire("42omo");




const $4a590dcfe386729d$export$ea5f007cec623a83 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        ...props
    });
};


/* KnowledgeCardMedia.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $be05d3862719a1d1$var$knowledgeCardMediaStyles = {
    default: "_2rko12b0 _189eidpf _1e0c1txw _4cvr1h6o",
    compact: "_4t3izwfg _1bsbzwfg",
    full: "_4t3iys9h _1bsbys9h"
};
const $be05d3862719a1d1$export$71b41532401d47f7 = ({ children: children, size: size })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($be05d3862719a1d1$var$knowledgeCardMediaStyles.default, size === 'compact' ? $be05d3862719a1d1$var$knowledgeCardMediaStyles.compact : $be05d3862719a1d1$var$knowledgeCardMediaStyles.full),
        children: children
    });
};





parcelRequire("42omo");







const $0091e8c9fcec1593$export$74276a28ff67aa9f = ({ children: children, size: size, color: color = 'color.text.brand' })=>{
    return size === 'compact' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        as: "h2",
        size: "xsmall",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            color: color,
            weight: "medium",
            children: children
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        as: "h2",
        size: "medium",
        children: children
    });
};





parcelRequire("42omo");




const $950c09f64becb12e$export$663c4a200ce34343 = ({ children: children, color: color = 'color.text.subtle', ...textProps })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        color: color,
        ...textProps,
        children: children
    });
};


const $43d5fc8d61a9e32c$export$ecbf022f1f5d6f16 = ({ name: name, actions: actions, category: category, media: media, primaryDescription: primaryDescription, secondaryDescription: secondaryDescription, size: size, primaryDescriptionColor: primaryDescriptionColor, containerStyles: containerStyles })=>{
    const isCardCompact = size === 'compact';
    const actionsToDisplay = isCardCompact && actions && actions.length > 1 ? [
        actions[0]
    ] : actions;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $df7ed.KnowledgeCard), {
        name: name,
        space: isCardCompact ? 'space.150' : 'space.250',
        size: size,
        containerStyles: containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $be05d3862719a1d1$export$71b41532401d47f7), {
                size: size,
                children: media
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $4a590dcfe386729d$export$ea5f007cec623a83), {
                space: isCardCompact ? 'space.100' : 'space.200',
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $4a590dcfe386729d$export$ea5f007cec623a83), {
                        space: 'space.100',
                        children: [
                            size === 'full' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1f9c8fbf9f23ff99$export$d7852a48c1d6ef5b), {
                                children: category
                            }) : null,
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $4a590dcfe386729d$export$ea5f007cec623a83), {
                                space: isCardCompact ? 'space.0' : 'space.050',
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $0091e8c9fcec1593$export$74276a28ff67aa9f), {
                                        size: size,
                                        color: primaryDescriptionColor,
                                        children: primaryDescription
                                    }),
                                    secondaryDescription ? /*#__PURE__*/ (0, $l998X.jsx)((0, $950c09f64becb12e$export$663c4a200ce34343), {
                                        color: isCardCompact ? 'color.text.subtlest' : 'color.text.subtle',
                                        children: secondaryDescription
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    actionsToDisplay && /*#__PURE__*/ (0, $l998X.jsx)((0, $b4d33197c0e90546$export$cb4f4efd621b33bb), {
                        children: actionsToDisplay.map((action, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                                children: action
                            }, `displayed-action-${index}`))
                    })
                ]
            })
        ]
    });
};


const $4b07b5ddc921c6c4$var$messages = (0, $cgtv4.defineMessages)({
    knowledge_card_date_category: {
        id: "search_ai_knowledge_card_date_category",
        defaultMessage: "Date"
    }
});
const $4b07b5ddc921c6c4$var$styles = {
    fullHeight: "_4t3i1osq",
    containerStyles: "_ca0qze3t _u5f3ze3t _19bvze3t _n3tdze3t",
    disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66"
};
const $4b07b5ddc921c6c4$export$94bf83cfe2387066 = ({ date: date })=>{
    const [selectedTab, setSelectedTab] = (0, $42omo.useState)((0, $f7lNm.AIAnswerTab).AI_ANSWER);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { sources: sources } = commonAttributes;
    const handleTabChange = (0, $42omo.useCallback)((selectedTabIndex)=>{
        const selectedTab = (0, $f7lNm.aiAnswerTabsOrder)[selectedTabIndex];
        setSelectedTab(selectedTab);
        fireAnalyticsEvent((0, $4xTru.onAIAnswerTabClick)({
            ...commonAttributes,
            selectedTab: selectedTab
        }));
    }, [
        setSelectedTab,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $4b07b5ddc921c6c4$var$styles.fullHeight,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $b6a87b24781bef6b$export$1aa02cade2c95a15), {
                onChange: handleTabChange,
                selectedTabIndex: (0, $f7lNm.aiAnswerTabsOrder).indexOf(selectedTab),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a45b5b745cdfd5$export$29246287a2faf86e), {
                        showSourcesTab: sources.length > 0
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $f34926bfd3d2d7be$export$43f4112a26740715), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $43d5fc8d61a9e32c$export$ecbf022f1f5d6f16), {
                            name: "smart-answer-date-knowledge-card",
                            category: formatMessage($4b07b5ddc921c6c4$var$messages.knowledge_card_date_category),
                            primaryDescription: date,
                            media: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($59e544052aeecaab$exports))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7d955b18211a45bf$exports))),
                                alt: ""
                            }),
                            size: "full",
                            containerStyles: $4b07b5ddc921c6c4$var$styles.containerStyles
                        })
                    }),
                    sources.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $f34926bfd3d2d7be$export$43f4112a26740715), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a6949a7d3f3d76d1$export$257180ca8df15f46), {})
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4b07b5ddc921c6c4$var$styles.disclaimer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                    showFeedbackButtons: true,
                    showCopyButton: true,
                    copyText: date
                })
            })
        ]
    });
};


/* LocationCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















var $2MuFw = parcelRequire("2MuFw");































var $828a42acca9b33c7$exports = {};
$828a42acca9b33c7$exports = new URL("location-dark.395fc7dc.svg", import.meta.url).toString();


var $8ceccd6f886fdc7c$exports = {};
$8ceccd6f886fdc7c$exports = new URL("location-light.9d9cfd0a.svg", import.meta.url).toString();



const $9c2103741083fc2f$var$messages = (0, $cgtv4.defineMessages)({
    knowledge_card_location_category: {
        id: "search_ai_knowledge_card_location_category",
        defaultMessage: "Location"
    },
    knowledge_card_location_google_maps_action: {
        id: "search_ai_knowledge_card_location_google_maps_action",
        defaultMessage: "Show on Google Maps"
    }
});
const $9c2103741083fc2f$var$styles = {
    fullHeight: "_4t3i1osq",
    containerStyles: "_ca0qze3t _u5f3ze3t _19bvze3t _n3tdze3t",
    disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66"
};
const $9c2103741083fc2f$var$generateGoogleMapsLink = (location)=>{
    const encodedAddress = encodeURIComponent(location);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};
const $9c2103741083fc2f$export$52cbb82455de8553 = ({ location: location })=>{
    const [selectedTab, setSelectedTab] = (0, $42omo.useState)((0, $f7lNm.AIAnswerTab).AI_ANSWER);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { brand: brand, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, query: query, queryHash: queryHash, searchSessionId: searchSessionId, sources: sources } = commonAttributes;
    const handleTabChange = (0, $42omo.useCallback)((selectedTabIndex)=>{
        const selectedTab = (0, $f7lNm.aiAnswerTabsOrder)[selectedTabIndex];
        setSelectedTab(selectedTab);
        fireAnalyticsEvent((0, $4xTru.onAIAnswerTabClick)({
            ...commonAttributes,
            selectedTab: selectedTab
        }));
    }, [
        setSelectedTab,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const copyLocation = async (location)=>{
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $4xTru.onAIAnswerCopyButtonClicked)(commonAttributes));
        await navigator.clipboard.writeText(location);
    };
    const onClickGoogleMaps = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onNonGenerativeAIAnswerResultShown)({
            answerString: answerString,
            brand: brand,
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            source: 'location_knowledge_card',
            answerCardType: (0, $f7lNm.AnswerCardType).LOCATION
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SHOW_ON_GOOGLE_MAPS_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        answerString,
        brand,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        query,
        queryHash,
        searchSessionId,
        commonAttributes
    ]);
    const googleMapsLink = $9c2103741083fc2f$var$generateGoogleMapsLink(location);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $9c2103741083fc2f$var$styles.fullHeight,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $b6a87b24781bef6b$export$1aa02cade2c95a15), {
                onChange: handleTabChange,
                selectedTabIndex: (0, $f7lNm.aiAnswerTabsOrder).indexOf(selectedTab),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a45b5b745cdfd5$export$29246287a2faf86e), {
                        showSourcesTab: sources.length > 0
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $f34926bfd3d2d7be$export$43f4112a26740715), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $43d5fc8d61a9e32c$export$ecbf022f1f5d6f16), {
                            name: "smart-answer-location-knowledge-card",
                            category: formatMessage($9c2103741083fc2f$var$messages.knowledge_card_location_category),
                            primaryDescription: location,
                            actions: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                                    href: googleMapsLink,
                                    onClick: onClickGoogleMaps,
                                    children: formatMessage($9c2103741083fc2f$var$messages.knowledge_card_location_google_maps_action)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
                                    label: "copy",
                                    onClick: ()=>copyLocation(location)
                                })
                            ],
                            media: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8ceccd6f886fdc7c$exports))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($828a42acca9b33c7$exports))),
                                alt: ''
                            }),
                            size: "full",
                            containerStyles: $9c2103741083fc2f$var$styles.containerStyles
                        })
                    }),
                    sources.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $f34926bfd3d2d7be$export$43f4112a26740715), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a6949a7d3f3d76d1$export$257180ca8df15f46), {})
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $9c2103741083fc2f$var$styles.disclaimer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                    showFeedbackButtons: true,
                    showCopyButton: true,
                    copyText: location
                })
            })
        ]
    });
};


















const $13ed9f6890732b8d$var$styles = {
    spacer: "_4t3idlk8 _ca0qv47k",
    errorContainer: "_ca0qu2gc",
    sourcesContainer: "_ca0qidpf _u5f31ejb _n3tdutpp _19bv1ejb"
};
const $13ed9f6890732b8d$var$MAX_SOURCES = 4;
const $13ed9f6890732b8d$var$SmartAnswerLoadingDialog = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, queryReasoning: queryReasoning, smartAnswersRoute: smartAnswersRoute } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    }); // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN || smartAnswersRoute === (0, $f7lNm.QueryIntent).DATE || smartAnswersRoute === (0, $f7lNm.QueryIntent).LOCATION) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: false,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$b6aef1fd050b8edc), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $720cf18cfdb27493$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$636ea4c09615ceed), {
                        children: serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $1bc91a785c030963$export$defe85febe8b728c).ai_answer_generating_rovo
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$9e8b51119c9a7742), {})
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                data: (0, $4xTru.getSmartLinksAnalyticsContextData)({
                    location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
                    commonAttributes: commonAttributes
                }),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7bZ3i.SmartCardProvider), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $a42449dc4c4689f6$export$78768a9af065a7b), {
                            collapsed: collapsed,
                            isLoading: true,
                            isStreaming: true,
                            expandWhenClickedAnywhere: true,
                            toggleCollapsedState: toggleCollapsedState,
                            callbacks: callbacks,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1b01177f202b870e$export$9799dac43580176f), {
                                markdown: partialResponse.partialNlpResult
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$9e8b51119c9a7742), {})
                    ]
                })
            })
        })
    });
};
const $13ed9f6890732b8d$export$827de04ba3667da0 = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, smartAnswersRoute: smartAnswersRoute, loading: loading, initiallyExpanded: initiallyExpanded } = (0, $eRXI0.useAIAnswerContext)();
    const { answerFormat: answerFormat, answerString: answerString, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [collapsed, setCollapsed] = (0, $42omo.useState)(false); // reset on each new query
    (0, $42omo.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $42omo.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>{
            fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $42omo.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)($13ed9f6890732b8d$var$SmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: analyticsCallbacks
    });
    let answerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $a42449dc4c4689f6$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    if (hasError) answerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $13ed9f6890732b8d$var$styles.errorContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    else if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $13ed9f6890732b8d$var$styles.spacer
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
        ]
    });
    const dateInAnswer = (0, $f5159735ac7dbad3$export$22fa983d82ded8f8)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $f7lNm.QueryIntent).DATE && dateInAnswer) return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
            isLoading: false,
            isStreaming: false,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4b07b5ddc921c6c4$export$94bf83cfe2387066), {
                date: dateInAnswer
            })
        })
    });
    const locationInAnswer = (0, $5079ddf97186ff6e$export$9df94c77b0746c3c)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $f7lNm.QueryIntent).LOCATION && locationInAnswer) return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
            isLoading: false,
            isStreaming: false,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9c2103741083fc2f$export$52cbb82455de8553), {
                location: locationInAnswer
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false,
        children: [
            answerContent,
            !hasError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $13ed9f6890732b8d$var$styles.sourcesContainer,
                testId: "ai-answer-sources",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$bbbfd63fa7f32357), {
                    sources: commonAttributes.sources,
                    searchSessionId: commonAttributes.searchSessionId,
                    onClickHandler: sourceClickCallback,
                    allowFreeflowLayout: true,
                    limit: $13ed9f6890732b8d$var$MAX_SOURCES
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$74b8b3463af67a4d), {})
        ]
    });
};


/* smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v0.36.1 */ 











































const $d27ad07bc57b7433$var$styles = {
    spacer: "_4t3idlk8 _ca0qv47k",
    errorContainer: "_ca0qu2gc",
    sourcesContainer: "_ca0qidpf _u5f31ejb _n3tdutpp _19bv1ejb"
};
const $d27ad07bc57b7433$var$MAX_SOURCES = 4;
const $d27ad07bc57b7433$var$SmartAnswerLoadingDialog = ()=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, queryReasoning: queryReasoning } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    }); // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: false,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$b6aef1fd050b8edc), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $720cf18cfdb27493$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$636ea4c09615ceed), {
                        children: serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $1bc91a785c030963$export$defe85febe8b728c).ai_answer_generating_rovo
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$9e8b51119c9a7742), {})
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: (0, $4xTru.getSmartLinksAnalyticsContextData)({
            location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
                isLoading: true,
                isStreaming: true,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $a42449dc4c4689f6$export$78768a9af065a7b), {
                            collapsed: true,
                            isLoading: true,
                            isStreaming: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1b01177f202b870e$export$9799dac43580176f), {
                                markdown: partialResponse.partialNlpResult
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$9e8b51119c9a7742), {})
                    ]
                })
            })
        })
    });
};
const $d27ad07bc57b7433$var$AnswerCard = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, initiallyExpanded: initiallyExpanded, loading: loading } = (0, $eRXI0.useAIAnswerContext)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [collapsed, setCollapsed] = (0, $42omo.useState)(true); // reset on each new query
    (0, $42omo.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $42omo.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $42omo.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            sourceProduct: source.product || '',
            commonAttributes: commonAttributes
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    let answerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $a42449dc4c4689f6$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    if (hasError) answerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d27ad07bc57b7433$var$styles.errorContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
    });
    else if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $d27ad07bc57b7433$var$styles.spacer
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $900fa72344220951$export$e2b54fc495614d59), {})
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $32dccc1d32edcb4a$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false,
        children: [
            answerContent,
            !hasError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $d27ad07bc57b7433$var$styles.sourcesContainer,
                testId: "ai-answer-sources",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bc926104ea83677$export$bbbfd63fa7f32357), {
                    sources: commonAttributes.sources,
                    searchSessionId: commonAttributes.searchSessionId,
                    onClickHandler: sourceClickCallback,
                    allowFreeflowLayout: true,
                    limit: $d27ad07bc57b7433$var$MAX_SOURCES
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $536772676f624703$export$74b8b3463af67a4d), {})
        ]
    });
};
const $d27ad07bc57b7433$export$7d8a07a50ae14953 = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { loading: loading } = (0, $eRXI0.useAIAnswerContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: loading ? /*#__PURE__*/ (0, $l998X.jsx)($d27ad07bc57b7433$var$SmartAnswerLoadingDialog, {}) : /*#__PURE__*/ (0, $l998X.jsx)($d27ad07bc57b7433$var$AnswerCard, {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        })
    });
};


















var $2NVuz = parcelRequire("2NVuz");


var $3Opgu = parcelRequire("3Opgu");











// Type guards for intent classification
const $5f06a69b1883458c$var$isPersonIntent = (data)=>data.classification === (0, $f7lNm.QueryIntent).PERSON;
/**
 * Registry mapping QueryIntent classification to skip handlers.
 * Add new handlers here to support additional intent types.
 */ const $5f06a69b1883458c$var$intentSkipHandlers = {
    /**
   * PERSON intent: Skip API call if persons array has data.
   * Transform Person[] from intent to NLPSearchPersonResultType format.
   */ [(0, $f7lNm.QueryIntent).PERSON]: (intentData)=>{
        if (!$5f06a69b1883458c$var$isPersonIntent(intentData) || intentData.persons === undefined || intentData.persons === null) return {
            skip: false
        };
        // Transform intent persons to the format expected by knowledge cards
        const mappedPersons = {
            user_metadata_only_cards: intentData.persons.map((person)=>({
                    id: person.accountId,
                    name: person.name,
                    title: person.jobTitle || undefined,
                    avatarUrl: person.picture || undefined,
                    location: person.location || undefined,
                    zoneInfo: person.zoneInfo || undefined
                }))
        };
        return {
            skip: true,
            data: {
                nlpResult: JSON.stringify(mappedPersons),
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                errorState: null,
                disclaimer: null,
                uniqueSources: [],
                extraAPIAnalyticsAttributes: {
                    skippedViaIntentClassification: true,
                    intentClassification: intentData.classification
                }
            }
        };
    }
};
const $5f06a69b1883458c$export$75cd51191584b8ce = (intentData)=>{
    if (!intentData) return {
        skip: false
    };
    const handler = $5f06a69b1883458c$var$intentSkipHandlers[intentData.classification];
    if (!handler) return {
        skip: false
    };
    return handler(intentData);
};


class $99617bfaa4d5362b$export$fc5c9343c5342824 extends Error {
    constructor(message, details, errorCode){
        super(message);
        this.details = void 0;
        this.errorCode = void 0;
        this.name = 'StreamFailedError';
        this.details = details;
        this.errorCode = errorCode;
    }
}


const $eaa7b2059700e470$export$6dbb893b575831e8 = async ({ cloudId: // eslint-disable-next-line @typescript-eslint/no-unused-vars
cloudId, locale: locale, query: query, additional_context: additional_context, source: source, followUpsEnabled: followUpsEnabled = false, getAIAnswer: getAIAnswer, setLoading: setLoading, partialResponse: partialResponse, partialResponseAbortControllerRef: partialResponseAbortControllerRef, setPartialResponse: setPartialResponse, setData: setData, setAnswerStreamed: setAnswerStreamed, parsedFilters: parsedFilters, selectedProduct: selectedProduct, isReadingAids: isReadingAids, fireAnalyticsEvent: fireAnalyticsEvent, setQueryReasoning: setQueryReasoning, setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages, setIsLuminaAnswer: setIsLuminaAnswer, experimentContext: experimentContext, queryIntentClassificationData: queryIntentClassificationData, referrer: referrer })=>{
    if (!getAIAnswer) return;
    if (partialResponse?.partialNlpResult) // clean up any old partial responses
    setPartialResponse(undefined);
    // end any old partial response streams
    partialResponseAbortControllerRef.current?.abort();
    const abortController = new AbortController();
    partialResponseAbortControllerRef.current = abortController;
    // Check if we can skip the AI answer call based on intent classification data.
    // If the intent already has the data we need (e.g., PersonIntent with persons[]),
    // use it directly instead of making another API call.
    if ((0, $dh538.fg)('kd_fe_persons_intent_detection_els')) {
        const skipResult = (0, $5f06a69b1883458c$export$75cd51191584b8ce)(queryIntentClassificationData);
        if (skipResult.skip) {
            setData(skipResult.data);
            (0, $epS7s.setSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                query: query,
                data: skipResult.data
            }));
            setAnswerStreamed(true);
            setLoading(false);
            return;
        }
    }
    // For graphQL getAIAnswer fns we expect each product to pass their own cloudIdARI in order for this component to be more product agnostic
    const aiAnswer = getAIAnswer({
        variables: {
            query: query,
            additional_context: additional_context,
            locale: locale,
            filters: parsedFilters,
            selectedProduct: selectedProduct,
            experience: isReadingAids ? 'readingAids' : source,
            followUpsEnabled: followUpsEnabled,
            experimentContext: experimentContext,
            isQuerySuggestion: !!referrer && referrer === 'zeroQuery'
        }
    });
    // Legacy version of processStreamResponse - used when feature gate is off
    const processStreamResponse = async (answer)=>{
        try {
            let next = await answer.stream.next();
            let answerFormat;
            while(!next.done){
                // setLoading needed here for instances where stream gets interrupted and restarts, ensuring loading state is set while stream is active
                setLoading(true);
                const streamEvent = next.value;
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType) answerFormat = streamEvent.message.format;
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType && (0, $59vy4.SAINFeatureControl).isLuminaEnabled()) {
                    if (streamEvent.message.answer_generation_type === (0, $2NVuz.StreamAnswerGenerationTypes).LUMINA) setIsLuminaAnswer(true);
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace) {
                    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setQueryReasoning(streamEvent.message);
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart) {
                    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setPartialResponse((previousPartialResponse)=>{
                        let previousPartialNlpResult = previousPartialResponse?.partialNlpResult || '';
                        return {
                            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                            partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                        };
                    });
                }
                if ((0, $59vy4.SAINFeatureControl).isLuminaEnabled()) {
                    if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) setDynamicLayoutSubAgentMessages((prevMessages)=>[
                            ...prevMessages,
                            streamEvent.message
                        ]);
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) {
                    setPartialResponse(undefined);
                    setData(streamEvent.message);
                    setLoading(false);
                }
                next = await answer.stream.next();
                if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
                throw 'Aborted';
            }
            const streamEnd = next.value;
            if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
            throw streamEnd;
            if (streamEnd.state === 'complete') {
                setPartialResponse(undefined);
                setData(streamEnd.value.message);
                // Only store to cache if Lumina is disabled
                if (isReadingAids || !(0, $59vy4.SAINFeatureControl).isLuminaEnabled()) (0, $epS7s.setSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                    query: query,
                    data: streamEnd.value.message
                }));
            } else {
                if (streamEnd.reason === 'timeout') {
                    setPartialResponse(undefined);
                    setData({
                        errorState: (0, $7Zbm6.NLPSearchErrorState).TimeoutError,
                        errorCode: 0,
                        format: null,
                        disclaimer: null,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                } else throw streamEnd;
            }
        } catch (error) {
            fireAnalyticsEvent((0, $be55ba5576248393$export$ee4edf16a7c39598)(error, source));
            if (error === 'Aborted') return;
            setPartialResponse(undefined);
            setData({
                errorState: typeof error === 'object' && error !== null && 'details' in error && error?.details === (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR ? (0, $7Zbm6.NLPSearchErrorState).HIPAAError : (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                errorCode: error?.errorCode ? error.errorCode : 0,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null,
                nlpSuggestedQueries: []
            });
        } finally{
            setAnswerStreamed(true);
            setLoading(false);
        }
    };
    // New version with improved error handling using standard JS Error objects
    const processStreamResponseImprovedErrorHandling = async (answer)=>{
        try {
            let next = await answer.stream.next();
            let answerFormat;
            while(!next.done){
                // setLoading needed here for instances where stream gets interrupted and restarts, ensuring loading state is set while stream is active
                setLoading(true);
                const streamEvent = next.value;
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType) answerFormat = streamEvent.message.format;
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType && (0, $59vy4.SAINFeatureControl).isLuminaEnabled()) {
                    if (streamEvent.message.answer_generation_type === (0, $2NVuz.StreamAnswerGenerationTypes).LUMINA) setIsLuminaAnswer(true);
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace) {
                    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setQueryReasoning(streamEvent.message);
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart) {
                    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setPartialResponse((previousPartialResponse)=>{
                        let previousPartialNlpResult = previousPartialResponse?.partialNlpResult || '';
                        return {
                            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                            partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                        };
                    });
                }
                if ((0, $59vy4.SAINFeatureControl).isLuminaEnabled()) {
                    if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) setDynamicLayoutSubAgentMessages((prevMessages)=>[
                            ...prevMessages,
                            streamEvent.message
                        ]);
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) {
                    setPartialResponse(undefined);
                    setData(streamEvent.message);
                    setLoading(false);
                }
                next = await answer.stream.next();
                if (abortController.signal.aborted) throw new Error('Aborted');
            }
            const streamEnd = next.value;
            if (abortController.signal.aborted) throw new Error(streamEnd.state === 'failed' ? streamEnd.reason : 'Aborted');
            if (streamEnd.state === 'complete') {
                setPartialResponse(undefined);
                setData(streamEnd.value.message);
                // Only store to cache if Lumina is disabled
                if (isReadingAids || !(0, $59vy4.SAINFeatureControl).isLuminaEnabled()) (0, $epS7s.setSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                    query: query,
                    data: streamEnd.value.message
                }));
            } else if (streamEnd.reason === 'timeout') {
                setPartialResponse(undefined);
                setData({
                    errorState: (0, $7Zbm6.NLPSearchErrorState).TimeoutError,
                    errorCode: 0,
                    format: null,
                    disclaimer: null,
                    nlpResults: [],
                    uniqueSources: [],
                    nlpFollowUpResults: null
                });
            } else {
                const details = 'details' in streamEnd ? streamEnd.details : undefined;
                const errorCode = 'errorCode' in streamEnd ? streamEnd.errorCode : undefined;
                throw new (0, $99617bfaa4d5362b$export$fc5c9343c5342824)(`Stream failed: ${streamEnd.reason}`, details, errorCode);
            }
        } catch (error) {
            fireAnalyticsEvent((0, $be55ba5576248393$export$ee4edf16a7c39598)(error, source));
            setPartialResponse(undefined);
            if (error instanceof Error && error.message === 'Aborted') setData({
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null,
                nlpSuggestedQueries: []
            });
            // Extract details from StreamFailedError if this is a wrapped stream error
            const details = error instanceof (0, $99617bfaa4d5362b$export$fc5c9343c5342824) ? error.details : undefined;
            const errorCode = error instanceof (0, $99617bfaa4d5362b$export$fc5c9343c5342824) ? error.errorCode ?? 0 : 0;
            setData({
                errorState: details === (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR ? (0, $7Zbm6.NLPSearchErrorState).HIPAAError : (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                errorCode: errorCode,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null,
                nlpSuggestedQueries: []
            });
        } finally{
            setAnswerStreamed(true);
            setLoading(false);
        }
    };
    // If aiAnswer is an object with a type property -- it's a getAIAnswer
    // and we need to handle the new streaming response
    if ('type' in aiAnswer) {
        if ((0, $dh538.fg)('kd_sain_improved_fetch_errors')) processStreamResponseImprovedErrorHandling(aiAnswer);
        else processStreamResponse(aiAnswer);
        return;
    }
    await aiAnswer.then((data)=>{
        if ('type' in data) {
            processStreamResponse(data);
            return;
        }
        setData(data?.nlpSearch || (0, $3Opgu.DEFAULT_EMPTY_NLP_SEARCH_STATE));
        // Only store to cache if Lumina is disabled
        if (isReadingAids || !(0, $59vy4.SAINFeatureControl).isLuminaEnabled()) (0, $epS7s.setSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
            query: query,
            data: data?.nlpSearch || (0, $3Opgu.DEFAULT_EMPTY_NLP_SEARCH_STATE)
        }));
        setLoading(false);
    }).catch((error)=>{
        fireAnalyticsEvent((0, $be55ba5576248393$export$13b0ccf9f6015e4c)(error, source));
        setData({
            errorState: error instanceof DOMException && error.name === 'TimeoutError' ? (0, $7Zbm6.NLPSearchErrorState).TimeoutError : (0, $7Zbm6.NLPSearchErrorState).NetworkError,
            format: null,
            disclaimer: null,
            nlpResults: [],
            uniqueSources: [],
            nlpFollowUpResults: null
        });
        setLoading(false);
    });
};






const $87da9ac7d025ec54$export$e25821f3420be6ad = ({ answerString: answerString, smartAnswersRoute: smartAnswersRoute })=>{
    if (!answerString) return 0;
    const { parsedResult: parsedResult, parsedType: parsedType } = (0, $c97be5ff4a9e42e9$export$d905ae2a714518e8)({
        answerString: answerString,
        smartAnswersRoute: smartAnswersRoute
    });
    switch(parsedType){
        case (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM:
            return 'id' in parsedResult && parsedResult.id ? 1 : 0;
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WHO:
        case (0, $7Zbm6.NLPSearchJSONResultFormat).PERSON:
        case (0, $7Zbm6.NLPSearchJSONResultFormat).AGENT:
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WORK:
            return Array.isArray(parsedResult) ? parsedResult.length : 0;
        default:
            return 0;
    }
};


const $753d84ba93c687b7$var$styles = {
    root: "_kqswh2mm"
};
const $753d84ba93c687b7$export$fd2b85accaf97974 = {
    errorState: (0, $7Zbm6.NLPSearchErrorState).Default,
    format: null,
    disclaimer: null,
    nlpResults: [],
    uniqueSources: []
};
const $753d84ba93c687b7$var$SearchAIDialogComponent = ({ query: query, setQuery: setQuery, additionalQueryContext: additionalQueryContext, cloudId: cloudId, orgId: orgId, getAIAnswer: getAIAnswer, onNavigate: onNavigate, onClose: onClose, advancedSearchUrl: advancedSearchUrl, searchSessionId: searchSessionId, userDetails: userDetails, wrapper: wrapper, loadingWrapper: loadingWrapper, source: source = 'unknown', isReadingAids: isReadingAids = false, readingAidsOptions: readingAidsOptions, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, cardProviderProps: cardProviderProps, baseQuery: baseQuery = '', onLoad: onLoad, followUpsEnabled: followUpsEnabled, selectedFilters: selectedFilters, parsedFilters: parsedFilters, selectedProduct: selectedProduct, mappedProductFilter: mappedProductFilter, answerLoadingRef: answerLoadingRef, smartAnswersRoute: smartAnswersRoute, cardTemplate: cardTemplate = (0, $f7lNm.CardTemplate).DEFAULT, sourceProduct: sourceProduct, workspaceId: workspaceId, brand: brand = (0, $f7lNm.AiBrand).AI, closeParentDialog: closeParentDialog, callbacks: callbacks, isAdminHubAIEnabled: isAdminHubAIEnabled, definitionToggleEnabled: definitionToggleEnabled, showChatFollowUps: showChatFollowUps, showGenericFooter: showGenericFooter = false, initiallyExpanded: initiallyExpanded = false, experimentContext: experimentContext, queryIntentClassificationData: queryIntentClassificationData, referrer: referrer, thirdPartyConfigs: thirdPartyConfigs, useOAuthHandlers: useOAuthHandlers, traceHeaders: traceHeaders })=>{
    const intl = (0, $8C5kA.default)();
    const locale = intl.locale;
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [dwellTracked, setDwellTracked] = (0, $42omo.useState)(false);
    const dwellTrackedRef = (0, $42omo.useRef)(false);
    const partialResponseAbortControllerRef = (0, $42omo.useRef)();
    const [isLuminaAnswer, setIsLuminaAnswer] = (0, $42omo.useState)(false);
    const [partialResponse, setPartialResponse] = (0, $42omo.useState)();
    const [queryReasoning, setQueryReasoning] = (0, $42omo.useState)();
    const [dynamicLayoutSubAgentMessages, setDynamicLayoutSubAgentMessages] = (0, $42omo.useState)([]);
    const [tabHasFocus, setTabHasFocus] = (0, $42omo.useState)(true);
    const [dwellTimer, setDwellTimer] = (0, $42omo.useState)(null);
    const dwellTimerRef = (0, $42omo.useRef)(null);
    const [answerStreamed, setAnswerStreamed] = (0, $42omo.useState)(false);
    const [isFMPReached, setIsFMPReached] = (0, $42omo.useState)(false);
    const [isFmpInViewport, setIsFmpInViewport] = (0, $42omo.useState)(false);
    const [isAnswerExpanded, setIsAnswerExpanded] = (0, $42omo.useState)(initiallyExpanded); // FMP-based dwell timer for analytics sizing
    if ((0, $dh538.fg)('kd_fmp_dwell_observer')) // fg check is stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fa6e2cc169bbcd5a$export$6dde22325042712e)({
        isEnabled: isFMPReached,
        isInViewport: isFmpInViewport,
        tabHasFocus: tabHasFocus,
        thresholdMs: (0, $4jIuc.SAIN_USAGE_DWELL_THRESHOLD),
        onDwellStart: ()=>{
            fireSAINUsageEvent({
                metCriteria: isAnswerExpanded ? (0, $4jIuc.SainAction).FMP_DWELL_START_EXPANDED : (0, $4jIuc.SainAction).FMP_DWELL_START,
                dwellTime: 0,
                commonAttributes: commonAttributes
            });
        },
        onDwellThreshold: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).FMP_DWELL_REACHED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes,
                sourceProduct: sourceProduct
            });
        },
        onDwellEnd: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).FMP_RESULT_EXITED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes,
                sourceProduct: sourceProduct
            });
        }
    });
    const [liked, setLiked] = (0, $42omo.useState)(undefined);
    const [likesDisabled, setLikesDisabled] = (0, $42omo.useState)(false);
    const [initialReported, setInitialReported] = (0, $42omo.useState)(undefined);
    const [nlpSearch, setData] = (0, $42omo.useState)($753d84ba93c687b7$export$fd2b85accaf97974);
    const filtersRef = (0, $42omo.useRef)(selectedFilters);
    const selectedProductRef = (0, $42omo.useRef)(selectedProduct);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const resultRef = (0, $42omo.useRef)(null);
    const initialLoadTs = (0, $42omo.useRef)(Date.now()).current;
    const loadedTsRef = (0, $42omo.useRef)();
    const fmpLoadedTsRef = (0, $42omo.useRef)();
    const dwellTimeRef = (0, $42omo.useRef)();
    const sainReverAllExperiment = (0, $c6GJD.default).getExperimentValue('sain_revert_all_experiment', 'enable', false);
    const kdSainTabsExperienceRevert = (0, $c6GJD.default).getExperimentValue('kd_sain_tabs_experience_revert', 'enable', false);
    const { serveExperiment: kdSainSmoothStreamingExperiment } = (0, $eUEtI.getSAINLayerFrontendExperiment)({
        abTestId: 'kd_sain_smooth_streaming_non_hello_exp'
    });
    const shouldServeTabsExperiment = sainReverAllExperiment || kdSainTabsExperienceRevert;
    const markLoadedTs = ()=>{
        loadedTsRef.current = Date.now();
        return loadedTsRef.current - initialLoadTs;
    };
    const fmpMarkLoadedTs = ()=>{
        if (fmpLoadedTsRef.current) return fmpLoadedTsRef.current - initialLoadTs;
    };
    const startViewportDwell = ()=>{
        dwellTimeRef.current = Date.now();
    };
    const markViewportDwell = ()=>{
        if (dwellTimeRef.current) return Date.now() - dwellTimeRef.current;
        return 0;
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const sessionId = (0, $f342a64f1825e9b1$export$baca5c7d93c77000)({
        userId: userDetails.id || '',
        cloudId: cloudId,
        source: source
    });
    const activityClient = (0, $e31DP.useActivityClient)('v3', 'people');
    const isAnswered = !loading && nlpSearch.errorState === null;
    const hasError = !loading && !!nlpSearch.errorState && nlpSearch.errorState !== (0, $7Zbm6.NLPSearchErrorState).Default;
    const answerString = nlpSearch.nlpResults?.length ? nlpSearch.nlpResults[0].nlpResult : nlpSearch.nlpResult || '';
    const answerFormat = nlpSearch.format;
    const followUps = nlpSearch.nlpFollowUpResults?.followUps;
    const errorStateSuggestedQueries = nlpSearch.nlpSuggestedQueries;
    const sources = nlpSearch.uniqueSources;
    const disclaimer = nlpSearch.disclaimer;
    const answerEditor = nlpSearch.nlpResultEditor;
    const extraAPIAnalyticsAttributes = nlpSearch.extraAPIAnalyticsAttributes;
    const requestId = nlpSearch.extraAPIAnalyticsAttributes?.requestId;
    const answerCardType = (0, $01aV7.getAnswerCardType)(isReadingAids, smartAnswersRoute);
    const commonAttributes = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            orgId: orgId ?? '',
            queryHash: (0, $01aV7.sha256Hash)(query),
            baseQueryHash: (0, $01aV7.sha256Hash)(baseQuery),
            query: query,
            appliedFilters: parsedFilters,
            searchSessionId: searchSessionId,
            source: source,
            answerString: answerString,
            answerLength: answerString.length,
            answerWordCount: answerString.split(/\s+/).length,
            answerFormat: answerFormat,
            answerCardType: answerCardType,
            sources: sources,
            followUps: followUps || [],
            errorStateSuggestedQueries: errorStateSuggestedQueries || [],
            errorState: nlpSearch.errorState,
            errorCode: nlpSearch.errorCode,
            extraAttributes: {
                featureGates: {
                    precomputedDefinitionsEnabled: (0, $dh538.fg)('kd_enable_precomputed_definitions')
                },
                ...extraAnalyticsAttributes,
                ...extraAPIAnalyticsAttributes
            },
            apiSource: 'assistance-service',
            workspaceId: workspaceId ?? '',
            sessionId: sessionId,
            brand: brand
        }), [
        cloudId,
        orgId,
        query,
        baseQuery,
        parsedFilters,
        searchSessionId,
        source,
        answerString,
        answerFormat,
        nlpSearch.errorState,
        nlpSearch.errorCode,
        extraAnalyticsAttributes,
        extraAPIAnalyticsAttributes,
        workspaceId,
        sessionId,
        brand,
        answerCardType,
        followUps,
        sources,
        errorStateSuggestedQueries
    ]);
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const onNavigateWithMouseEvent = (0, $42omo.useCallback)((event)=>{
        if (!event.ctrlKey && !event.metaKey) onNavigate();
    }, [
        onNavigate
    ]);
    const getAIAnswerFn = (0, $42omo.useCallback)(()=>{
        switch(smartAnswersRoute){
            case (0, $f7lNm.QueryIntent).PERSON:
                return (_args)=>(0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? (0, $95de468340d80197$export$3b2275a59c992e87)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    }) : (0, $95de468340d80197$export$b40bb50f32e7d452)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $f7lNm.QueryIntent).TEAM:
                return (_args)=>(0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? (0, $8cade13bd59126b4$export$b9b0423f67d54dce)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        siteId: cloudId,
                        teamQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    }) : (0, $8cade13bd59126b4$export$1d3fe260188fa7d9)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        siteId: cloudId,
                        teamQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $f7lNm.QueryIntent).TOPIC:
                return (_args)=>(0, $906cce6160529aee$export$d25837238feb3ab6)({
                        cloudId: cloudId,
                        query: query,
                        workspaceId: workspaceId ?? '',
                        sourceProduct: sourceProduct,
                        traceHeaders: traceHeaders
                    });
            case (0, $f7lNm.QueryIntent).AGENT:
                return ()=>(0, $5047116fb00cd75d$export$9cab63c7e0de7ad8)({
                        query: query,
                        sourceProduct: sourceProduct ?? '',
                        limit: 7,
                        cloudId: cloudId,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
                // data fetching is handled by the JiraNlToJqlCard internally,
                // this is to prevent streaming from being called
                setLoading(false);
                return null;
            case (0, $f7lNm.QueryIntent).ORG_CHART:
                return ()=>(0, $95de468340d80197$export$b40bb50f32e7d452)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            default:
        }
        return getAIAnswer;
    }, [
        getAIAnswer,
        smartAnswersRoute,
        query,
        orgId,
        cloudId,
        activityClient,
        sourceProduct,
        workspaceId,
        traceHeaders
    ]);
    const updateContextCache = (0, $42omo.useCallback)(({ collapsed: collapsed, liked: liked, reported: reported, recentWorkListExpanded: recentWorkListExpanded, sourcesExpanded: sourcesExpanded, fromFollowUp: fromFollowUp })=>{
        // Do not store session cache if Lumina
        if ((0, $59vy4.SAINFeatureControl).isLuminaEnabled() && !isReadingAids) return;
        const currentCache = JSON.parse((0, $epS7s.getSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}');
        (0, $epS7s.setSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
            query: query,
            additionalContext: additionalQueryContext || '',
            data: nlpSearch,
            collapsed: collapsed === undefined ? currentCache.collapsed : collapsed,
            liked: liked === undefined ? currentCache.liked : liked,
            reported: reported === undefined ? currentCache.reported : reported,
            fromFollowUp: fromFollowUp === undefined ? currentCache.fromFollowUp : fromFollowUp,
            recentWorkListExpanded: recentWorkListExpanded === undefined ? currentCache.recentWorkListExpanded : recentWorkListExpanded,
            sourcesExpanded: sourcesExpanded === undefined ? currentCache.sourcesExpanded : sourcesExpanded,
            ...(0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? {
                extraAPIAnalyticsAttributes: {
                    requestId: requestId
                }
            } : {}
        }));
    }, [
        query,
        additionalQueryContext,
        nlpSearch,
        requestId,
        isReadingAids
    ]);
    const onFMPReached = (0, $42omo.useCallback)(()=>{
        setIsFMPReached(true);
        fmpLoadedTsRef.current = Date.now();
    }, []);
    const onAnswerExpandedChange = (0, $42omo.useCallback)((expanded)=>{
        setIsAnswerExpanded(expanded);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (answerLoadingRef) answerLoadingRef.current = !!loading;
    }, [
        loading,
        answerLoadingRef
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $d3c4f32cc234b266$export$a83a35d6598a5fb6).start(); // Reset FMP dwell tracking for new queries
        setIsFMPReached(false);
        setIsFmpInViewport(false);
        if (dwellTimer) {
            clearTimeout(dwellTimer);
            setDwellTimer(null);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    const handleIntersect = (entries)=>{
        entries.forEach((entry)=>{
            if (!loading && (isAnswered || hasError)) {
                if (entry.isIntersecting) {
                    startViewportDwell();
                    fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogViewed)({
                        ...commonAttributes
                    }));
                    if ((0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) {
                        if (smartAnswersRoute !== (0, $f7lNm.QueryIntent).TEAM && smartAnswersRoute !== (0, $f7lNm.QueryIntent).PERSON && smartAnswersRoute !== (0, $f7lNm.QueryIntent).AGENT && !dwellTrackedRef.current) dwellTimerRef.current = setTimeout(()=>{
                            dwellTrackedRef.current = true;
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).DWELL_REACHED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, (0, $4jIuc.SAIN_USAGE_DWELL_THRESHOLD));
                    } else if (smartAnswersRoute !== (0, $f7lNm.QueryIntent).TEAM && smartAnswersRoute !== (0, $f7lNm.QueryIntent).PERSON && !dwellTracked) {
                        const usageTimer = setTimeout(()=>{
                            setDwellTracked(true);
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).DWELL_REACHED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, (0, $4jIuc.SAIN_USAGE_DWELL_THRESHOLD));
                        setDwellTimer(usageTimer);
                    }
                } else {
                    fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogHidden)({
                        ...commonAttributes
                    }, markViewportDwell()));
                    if (dwellTimerRef.current && (0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) {
                        clearTimeout(dwellTimerRef.current);
                        dwellTimerRef.current = null;
                    }
                }
            }
        });
    };
    (0, $42omo.useLayoutEffect)(()=>{
        const observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.3
        });
        if (resultRef.current && tabHasFocus) observer.observe(resultRef.current);
        return ()=>{
            observer?.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        resultRef,
        isAnswered,
        hasError,
        tabHasFocus
    ]); // FMP dwell intersection observer
    (0, $42omo.useLayoutEffect)(()=>{
        // Use different thresholds based on expanded state:
        // - Collapsed: 1.0 (100% in viewport)
        // - Expanded: 0.3 (30% in viewport)
        const threshold = isAnswerExpanded ? 0.3 : 1.0;
        const fmpObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (isFMPReached) // Always update viewport state when FMP is reached, regardless of tab focus
                // Tab focus is handled separately in the dwell timer hook
                setIsFmpInViewport(entry.isIntersecting);
            });
        }, {
            threshold: threshold
        });
        if (resultRef.current && isFMPReached) fmpObserver.observe(resultRef.current);
        return ()=>{
            fmpObserver?.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resultRef,
        isFMPReached,
        isAnswerExpanded
    ]);
    (0, $42omo.useEffect)(()=>{
        const cached = JSON.parse((0, $epS7s.getSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}');
        if (cached?.query === query && cached?.additionalContext === additionalQueryContext) {
            setData(cached.data);
            if (cached.liked !== undefined) {
                setLiked(cached.liked); // if a like is cached, disable likes
                setLikesDisabled(true);
            }
            if (cached.reported !== undefined) setInitialReported(cached.reported);
            setLoading(false);
        } else {
            (0, $epS7s.deleteSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY));
            setLoading(true);
            setLiked(undefined);
            setLikesDisabled(false);
            (0, $eaa7b2059700e470$export$6dbb893b575831e8)({
                cloudId: cloudId,
                locale: locale,
                query: query,
                additional_context: additionalQueryContext,
                source: source,
                followUpsEnabled: followUpsEnabled && !cached.fromFollowUp,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning,
                setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
                setIsLuminaAnswer: setIsLuminaAnswer,
                experimentContext: experimentContext,
                queryIntentClassificationData: queryIntentClassificationData,
                referrer: referrer
            });
        }
        filtersRef.current = selectedFilters;
        if ((0, $dh538.fg)('kd_fix_duplicate_sain_stream_calls')) selectedProductRef.current = selectedProduct;
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query,
        additionalQueryContext
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!((0, $59vy4.SAINFeatureControl).isThirdPartyBannerEnabled() || (0, $dh538.fg)('kd_hide_sain_for_unsupported_product_filters')) && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(filtersRef.current, selectedFilters) || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(selectedProductRef.current, selectedProduct)) {
            (0, $epS7s.deleteSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY));
            setLoading(true);
            setLiked(undefined);
            setLikesDisabled(false);
            (0, $eaa7b2059700e470$export$6dbb893b575831e8)({
                cloudId: cloudId,
                locale: locale,
                query: query,
                source: source,
                followUpsEnabled: followUpsEnabled,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning,
                setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
                setIsLuminaAnswer: setIsLuminaAnswer,
                experimentContext: experimentContext,
                queryIntentClassificationData: queryIntentClassificationData,
                referrer: referrer
            });
        }
        filtersRef.current = selectedFilters;
        selectedProductRef.current = selectedProduct; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedFilters,
        selectedProduct
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isAnswered) {
            // if a person or team query returns no data don't log result shown
            const numAddtlWhoMatches = smartAnswersRoute === (0, $f7lNm.QueryIntent).PERSON ? (0, $87da9ac7d025ec54$export$e25821f3420be6ad)({
                answerString: answerString,
                smartAnswersRoute: smartAnswersRoute
            }) : 0;
            if ((smartAnswersRoute === (0, $f7lNm.QueryIntent).PERSON || smartAnswersRoute === (0, $f7lNm.QueryIntent).TEAM || smartAnswersRoute === (0, $f7lNm.QueryIntent).AGENT) && (0, $87da9ac7d025ec54$export$e25821f3420be6ad)({
                answerString: answerString,
                smartAnswersRoute: smartAnswersRoute
            }) < 1) {
                markLoadedTs();
                callbacks?.onAIAnswerAnalyticsFired?.();
                return;
            }
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultShown)({
                ...commonAttributes,
                isStreamed: answerStreamed,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs(),
                extraAttributes: {
                    ...commonAttributes.extraAttributes,
                    multipleUserResultsShown: numAddtlWhoMatches > 0,
                    numAddtlWhoMatches: numAddtlWhoMatches,
                    isCuratedDefinition: !!answerEditor,
                    isPrecomputedDefinition: nlpSearch.customDefinitionType === (0, $7Zbm6.NLPSearchCustomDefinitionType).PRECOMPUTED
                }
            }));
            if (numAddtlWhoMatches > 0) fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            callbacks?.onAIAnswerAnalyticsFired?.();
        } else if (hasError) {
            fireAnalyticsEvent((0, $4xTru.onAIAnswerNotShown)({
                ...commonAttributes,
                isStreamed: answerStreamed,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs()
            }));
            callbacks?.onAIAnswerAnalyticsFired?.();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        trackAIInteractionInit();
        fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogQueryIntent)(commonAttributes));
        if (!isReadingAids && query && smartAnswersRoute) fireAnalyticsEvent((0, $4xTru.onSmartAnswerRouteDetection)(commonAttributes, smartAnswersRoute));
        return ()=>{
            fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogHidden)({
                ...commonAttributes
            }, markViewportDwell()));
            fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogUnmount)({
                ...commonAttributes,
                isReadingAids: isReadingAids,
                sourceProduct: sourceProduct,
                dwellTime: loadedTsRef.current ? Date.now() - loadedTsRef.current : 0,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs()
            }));
            trackAIInteractionDismiss();
            if (!loadedTsRef.current) fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogDroppedOff)({
                ...commonAttributes
            }));
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        const handleWindowBlurOrClose = ()=>{
            if (tabHasFocus && !loading && (isAnswered || hasError)) {
                fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogHidden)({
                    ...commonAttributes
                }, markViewportDwell()));
                if (dwellTimerRef.current && (0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) {
                    clearTimeout(dwellTimerRef.current);
                    dwellTimerRef.current = null;
                }
            }
            setTabHasFocus(false);
        };
        const handleWindowFocus = ()=>{
            setTabHasFocus(true);
            if (!dwellTrackedRef.current && !dwellTimerRef.current && (0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) dwellTimerRef.current = setTimeout(()=>{
                dwellTrackedRef.current = true;
                fireSAINUsageEvent({
                    metCriteria: (0, $4jIuc.SainAction).DWELL_REACHED,
                    dwellTime: markViewportDwell(),
                    commonAttributes: commonAttributes
                });
            }, (0, $4jIuc.SAIN_USAGE_DWELL_THRESHOLD));
        };
        const removeBlurListener = (0, $fFa3V.bind)(window, {
            type: 'blur',
            listener: handleWindowBlurOrClose
        });
        const removeFocusListener = (0, $fFa3V.bind)(window, {
            type: 'focus',
            listener: handleWindowFocus
        });
        const removeCloseListener = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: handleWindowBlurOrClose
        });
        return ()=>{
            removeBlurListener();
            removeFocusListener();
            removeCloseListener();
            if ((0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) {
                if (dwellTimerRef.current) {
                    clearTimeout(dwellTimerRef.current);
                    dwellTimerRef.current = null;
                }
            } else if (dwellTimer) clearTimeout(dwellTimer);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tabHasFocus,
        loading
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (onLoad && !loading && (isAnswered || hasError)) onLoad();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered,
        hasError
    ]);
    const AIDialogWrapper = wrapper ? wrapper : (0, $7DA0P.SearchDialog);
    const AILoadingWrapper = loadingWrapper ? loadingWrapper : (0, $c71e4c8897192027$export$476294a9cde8f045);
    const renderDefinition = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $59e59815342d850f$export$d1b852cfff73cbe8), {}); // SAIN in FPS
    const renderSearchPageSmartAnswer = ()=>{
        if ((smartAnswersRoute === (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY || smartAnswersRoute === (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM || smartAnswersRoute === (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION) && shouldServeTabsExperiment) return /*#__PURE__*/ (0, $l998X.jsx)(AIDialogWrapper, {
            children: (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && isLuminaAnswer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2cb1106731afa484$export$b547d87531f467be), {
                onFMPReached: onFMPReached,
                onAnswerExpandedChange: onAnswerExpandedChange,
                queryIntent: smartAnswersRoute
            }) : (0, $dh538.fg)('kd_smooth_streaming_fg') || kdSainSmoothStreamingExperiment ? /*#__PURE__*/ (0, $l998X.jsx)((0, $be41cc33d0cc9810$export$3698d894d0a161e5), {
                onFMPReached: onFMPReached,
                onAnswerExpandedChange: onAnswerExpandedChange,
                queryIntent: smartAnswersRoute,
                useOAuthHandlers: useOAuthHandlers,
                thirdPartyConfigs: thirdPartyConfigs
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $970b2933c74fb6d4$export$827de04ba3667da0), {
                onFMPReached: onFMPReached,
                onAnswerExpandedChange: onAnswerExpandedChange,
                queryIntent: smartAnswersRoute
            })
        });
        else if ((0, $dh538.fg)('kd_sain_enable_expand_when_streaming')) return /*#__PURE__*/ (0, $l998X.jsx)(AIDialogWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $13ed9f6890732b8d$export$827de04ba3667da0), {
                onFMPReached: onFMPReached,
                onAnswerExpandedChange: onAnswerExpandedChange
            })
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)(AIDialogWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d27ad07bc57b7433$export$7d8a07a50ae14953), {
                onFMPReached: onFMPReached,
                onAnswerExpandedChange: onAnswerExpandedChange
            })
        });
    };
    const renderSearchPageKnowledgeCard = ()=>/*#__PURE__*/ (0, $l998X.jsx)(AIDialogWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1b0a370bd67241fc$export$ab2444a256fc8a9b), {
                onFMPReached: onFMPReached
            })
        }); // Quick search and advanced search
    const renderDefaultSmartAnswer = ()=>{
        return (0, $dh538.fg)('kd_sain_enable_expand_when_streaming') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d7d3009f3793d049$export$cf72ef8498afcbc2), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper,
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $111129b397a148b4$export$b054d5cce3d1302d), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper,
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        });
    };
    const renderExperience = ()=>{
        switch(smartAnswersRoute){
            case (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY:
            case (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM:
            case (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION:
            case (0, $f7lNm.QueryIntent).DATE:
            case (0, $f7lNm.QueryIntent).LOCATION:
                return renderSearchPageSmartAnswer();
            case (0, $f7lNm.QueryIntent).PERSON:
            case (0, $f7lNm.QueryIntent).TEAM:
            case (0, $f7lNm.QueryIntent).TOPIC:
            case (0, $f7lNm.QueryIntent).AGENT:
            case (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            case (0, $f7lNm.QueryIntent).ORG_CHART:
                return renderSearchPageKnowledgeCard();
            default:
                return isReadingAids ? renderDefinition() : renderDefaultSmartAnswer();
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eRXI0.AIAnswerContext).Provider, {
        value: {
            loading: loading,
            partialResponse: partialResponse,
            isAnswered: isAnswered,
            hasError: hasError,
            advancedSearchUrl: advancedSearchUrl,
            userDetails: userDetails,
            disclaimer: disclaimer,
            onNavigate: onNavigateWithMouseEvent,
            onClose: onClose,
            updateContextCache: updateContextCache,
            fireAnalyticsEvent: fireAnalyticsEvent,
            setQuery: setQuery,
            setData: setData,
            commonAttributes: commonAttributes,
            liked: liked,
            setLiked: setLiked,
            likesDisabled: likesDisabled,
            setLikesDisabled: setLikesDisabled,
            initialReported: initialReported,
            isReadingAids: isReadingAids,
            dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages,
            setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
            readingAidsOptions: readingAidsOptions,
            cardProviderProps: cardProviderProps,
            baseQuery: baseQuery,
            cardTemplate: cardTemplate,
            smartAnswersRoute: smartAnswersRoute,
            queryIntentClassificationData: queryIntentClassificationData,
            brand: brand,
            answerEditor: answerEditor,
            closeParentDialog: closeParentDialog,
            additionalQueryContext: additionalQueryContext,
            callbacks: callbacks,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            definitionToggleEnabled: definitionToggleEnabled,
            sourceProduct: sourceProduct,
            showChatFollowUps: showChatFollowUps,
            queryReasoning: queryReasoning,
            showGenericFooter: showGenericFooter ?? false,
            initiallyExpanded: initiallyExpanded ?? false,
            traceHeaders: traceHeaders
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $753d84ba93c687b7$var$styles.root,
                ref: resultRef,
                children: renderExperience()
            }),
            !loading && (isAnswered || hasError) && /*#__PURE__*/ (0, $l998X.jsx)((0, $d3c4f32cc234b266$export$6220c1b7224eb2a2), {})
        ]
    });
};
const $753d84ba93c687b7$export$effb3597bac74419 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { definitionExperienceName: definitionExperienceName, isReadingAids: isReadingAids, source: source, sourceProduct: sourceProduct, sourceSubProduct: sourceSubProduct, smartAnswersRoute: smartAnswersRoute, query: query, userGeneratedAI: userGeneratedAI } = props;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-ai-dialog",
        children: [
            (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "hasSAINComponent",
                        value: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "sainExperienceName",
                        value: (0, $3f9d8952278ae5ef$export$38439c13a4683ecf)(smartAnswersRoute)
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                data: {
                    hasSAINComponent: true,
                    sainExperienceName: (0, $3f9d8952278ae5ef$export$38439c13a4683ecf)(smartAnswersRoute)
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aZJLt.ErrorBoundary), {
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
                    config: {
                        product: sourceProduct ?? 'unknown',
                        subproduct: sourceSubProduct ?? 'unknown',
                        aiFeatureName: isReadingAids ? 'aiDefinitions' : 'smartAnswers',
                        aiExperienceName: isReadingAids ? definitionExperienceName : (0, $3f9d8952278ae5ef$export$38439c13a4683ecf)(smartAnswersRoute),
                        proactiveGeneratedAI: userGeneratedAI ? 0 : 1,
                        userGeneratedAI: userGeneratedAI ? 1 : 0,
                        isAIFeature: 1,
                        source: source,
                        channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
                    },
                    children: (0, $dh538.fg)('kd_enable_smart_answer_key') || (0, $59vy4.SAINFeatureControl).isLuminaEnabled() ? /*#__PURE__*/ (0, $42omo.createElement)($753d84ba93c687b7$var$SearchAIDialogComponent, {
                        ...props,
                        key: query
                    }) : /*#__PURE__*/ (0, $l998X.jsx)($753d84ba93c687b7$var$SearchAIDialogComponent, {
                        ...props
                    })
                })
            })
        ]
    });
});
module.exports["DEFAULT_EMPTY_NLP_SEARCH_STATE"] = $753d84ba93c687b7$export$fd2b85accaf97974;
module.exports["SearchAIDialog"] = $753d84ba93c687b7$export$effb3597bac74419;

});

parcelRegister("5iH4l", function(module, exports) {

var $fHxn4 = parcelRequire("fHxn4");


var $4Zqgi = parcelRequire("4Zqgi");

const $8824b7954958f70c$export$f7dcb977daa6621d = (email)=>{
    // try catch is for the clipboard function
    try {
        navigator.clipboard.writeText(email);
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onEmailCopy'
        });
    }
};
function $8824b7954958f70c$export$10e7203252b63b0e(ari) {
    return ari.split('/').pop() || '';
}
const $8824b7954958f70c$var$MAX_CONTRIBUTORS = 3;
const $8824b7954958f70c$export$737fdf482f7ddb38 = (recentWork)=>{
    const uniqRecents = new Set();
    return recentWork.reduce((result, recentWorkItem)=>{
        const containerName = recentWorkItem.containers.length > 0 ? recentWorkItem.containers[0].name : recentWorkItem.object.product;
        // creating a key with the container name and title to
        // prevent the posibilty of multiple items with the same name
        const key = `${containerName}:${recentWorkItem.object.name || ''}`;
        if (uniqRecents.has(key)) return result;
        uniqRecents.add(key);
        const curRecentWorkItem = {
            title: recentWorkItem.object.name || '',
            url: recentWorkItem.object.url,
            containerName: containerName,
            event: recentWorkItem.eventType,
            timestamp: recentWorkItem.timestamp,
            iconUrl: !!recentWorkItem.object.icon ? recentWorkItem.object.icon.value : '',
            contributors: recentWorkItem.contributors.slice(0, 3).map((contributor)=>({
                    name: contributor.name,
                    id: contributor.accountId
                })),
            othersCount: recentWorkItem.contributors.length > $8824b7954958f70c$var$MAX_CONTRIBUTORS ? recentWorkItem.contributors.length - $8824b7954958f70c$var$MAX_CONTRIBUTORS : 0,
            contentTypeName: recentWorkItem.object.__typename
        };
        return result.concat(curRecentWorkItem);
    }, []);
};
const $8824b7954958f70c$export$b8d37f4ee3cee5b6 = ({ locale: locale, zoneInfo: zoneInfo })=>{
    return zoneInfo ? new Date().toLocaleTimeString(locale, {
        timeZone: zoneInfo,
        hour: 'numeric',
        minute: 'numeric'
    }).replace(' ', '').toLowerCase() : undefined;
};
const $8824b7954958f70c$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $8824b7954958f70c$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $8824b7954958f70c$var$getAtlasHost = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
    return isStaging ? $8824b7954958f70c$var$ATLAS_STAGING_URL : $8824b7954958f70c$var$ATLAS_PROD_URL;
};
const $8824b7954958f70c$var$getAtlasURL = (orgId)=>{
    const atlasHost = $8824b7954958f70c$var$getAtlasHost();
    return orgId ? `${atlasHost}/o/${orgId}` : atlasHost;
};
const $8824b7954958f70c$export$d00d38d973440568 = (agent, orgId)=>{
    const atlasURL = $8824b7954958f70c$var$getAtlasURL(orgId);
    return `${atlasURL}/people/agent/${agent.id}`;
};
const $8824b7954958f70c$export$782629dc0d11ee5c = (teamId, orgId)=>{
    const atlasURL = $8824b7954958f70c$var$getAtlasURL(orgId);
    return `${atlasURL}/people/team/${teamId}`;
};
const $8824b7954958f70c$export$8a4355009b280d8c = (cloudId)=>new (0, $fHxn4.default)({
        url: '/gateway/api/directory/graphql',
        productIdentifier: 'rovo',
        cloudId: cloudId
    });
module.exports["onEmailCopy"] = $8824b7954958f70c$export$f7dcb977daa6621d;
module.exports["trimARI"] = $8824b7954958f70c$export$10e7203252b63b0e;
module.exports["sanitizeAndMapRecentWorkActivity"] = $8824b7954958f70c$export$737fdf482f7ddb38;
module.exports["formatTimeKnowledgeCard"] = $8824b7954958f70c$export$b8d37f4ee3cee5b6;
module.exports["getAgentProfileUrl"] = $8824b7954958f70c$export$d00d38d973440568;
module.exports["getTeamProfileUrl"] = $8824b7954958f70c$export$782629dc0d11ee5c;
module.exports["createProfileClient"] = $8824b7954958f70c$export$8a4355009b280d8c;

});

parcelRegister("eMz0l", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $cOrQJ = parcelRequire("cOrQJ");

var $4fe7183f3a0f31fd$var$DarkThemeStops = /*#__PURE__*/ function(DarkThemeStops) {
    DarkThemeStops["BLUE800"] = "#0055CC";
    DarkThemeStops["TEAL500"] = "#37B4C3";
    DarkThemeStops["YELLOW500"] = "#CF9F02";
    return DarkThemeStops;
}($4fe7183f3a0f31fd$var$DarkThemeStops || {});
var $4fe7183f3a0f31fd$var$LightThemeStops = /*#__PURE__*/ function(LightThemeStops) {
    LightThemeStops["BLUE600"] = "#1D7AFC";
    LightThemeStops["TEAL300"] = "#8BDBE5";
    LightThemeStops["YELLOW200"] = "#F8E6A0";
    return LightThemeStops;
}($4fe7183f3a0f31fd$var$LightThemeStops || {});
var $4fe7183f3a0f31fd$var$UpdatedDarkThemeStops = /*#__PURE__*/ function(UpdatedDarkThemeStops) {
    UpdatedDarkThemeStops["ORANGE"] = "#FCA700";
    UpdatedDarkThemeStops["GREEN"] = "#82B536";
    UpdatedDarkThemeStops["BLUE"] = "#357DE8";
    UpdatedDarkThemeStops["PURPLE"] = "#BF63F3";
    return UpdatedDarkThemeStops;
}($4fe7183f3a0f31fd$var$UpdatedDarkThemeStops || {});
var $4fe7183f3a0f31fd$var$UpdatedLightThemeStops = /*#__PURE__*/ function(UpdatedLightThemeStops) {
    UpdatedLightThemeStops["ORANGE"] = "#FCA700";
    UpdatedLightThemeStops["GREEN"] = "#6A9A23";
    UpdatedLightThemeStops["BLUE"] = "#1868DB";
    UpdatedLightThemeStops["PURPLE"] = "#AF59E0";
    return UpdatedLightThemeStops;
}($4fe7183f3a0f31fd$var$UpdatedLightThemeStops || {});
const $4fe7183f3a0f31fd$var$PRE_PULSE_ANIMATION_DURATION = 200;
const $4fe7183f3a0f31fd$var$TOTAL_PULSE_ANIMATION_DURATION = 800; // Helper function to convert hex color to rgba with alpha
const $4fe7183f3a0f31fd$var$hexToRgba = (hex, alpha)=>{
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}; // This injects a CSS property into the document for the --gradient-angle variable.
// This is needed so the browser understands how to animate the gradient-angle as an angle
// value. This is done this way because compiled doesn't support CSS variables at this time.
let $4fe7183f3a0f31fd$var$propertyInjected = false;
const $4fe7183f3a0f31fd$var$useGradientAngleProperty = ()=>{
    (0, $42omo.useEffect)(()=>{
        if ($4fe7183f3a0f31fd$var$propertyInjected) return;
        $4fe7183f3a0f31fd$var$propertyInjected = true;
        try {
            const style = document.createElement('style');
            style.innerHTML = `
      			@property --gradient-angle {
        			syntax: '<angle>';
        			initial-value: 0deg;
        			inherits: false;
      			}
    		`;
            document.head.appendChild(style);
        } catch (e) {}
    }, []);
};
// Keyframes for rotating the gradient angle
// ts-ignore because jira build is failing, but this is legit
// @ts-ignore
const $4fe7183f3a0f31fd$var$rotate = null; // Rainbow border styles
// Note: the actual gradient background varies by light/dark theme - this is added down below
const $4fe7183f3a0f31fd$var$borderCss = null; // Inner content box
const $4fe7183f3a0f31fd$var$innerBoxCss = null;
const $4fe7183f3a0f31fd$var$lightBackgroundGradientCss = null;
const $4fe7183f3a0f31fd$var$darkBackgroundGradientCss = null;
const $4fe7183f3a0f31fd$var$backgroundGlowContainerCss = null;
const $4fe7183f3a0f31fd$var$backgroundBlurCss = null;
const $4fe7183f3a0f31fd$var$lightBackgroundDefaultGradientCss = null; // Light theme blur with alpha transparency for loading states
const $4fe7183f3a0f31fd$var$lightBackgroundGeneratingGradientCss = null;
const $4fe7183f3a0f31fd$var$lightBackgroundTransparentGradientCss = null;
const $4fe7183f3a0f31fd$var$lightBackgroundPulseGradientCss = null;
const $4fe7183f3a0f31fd$var$darkBackgroundDefaultGradientCss = null; // Dark theme blur with alpha transparency for loading states
const $4fe7183f3a0f31fd$var$darkBackgroundGeneratingGradientCss = null;
const $4fe7183f3a0f31fd$var$darkBackgroundPulseGradientCss = null;
const $4fe7183f3a0f31fd$var$darkBackgroundTransparentGradientCss = null;
const $4fe7183f3a0f31fd$var$loadingStateStyles = {
    generating: "_j7hqandv _5sagymdr _1pglp3kn _tip812c5",
    'pre-pulse': "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _n3tdidpf _ca0qidpf _19bvidpf _u5f3idpf",
    pulse: "_j7hqandv _5sag1cqc _1pglp3kn _tip812c5 _ju25cx05",
    generated: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _n3tdidpf _ca0qidpf _19bvidpf _u5f3idpf"
};
const $4fe7183f3a0f31fd$export$ca874e6b8d314598 = ({ children: children, isAnswerComplete: isAnswerComplete = false, loadingState: loadingState, testId: testId })=>{
    $4fe7183f3a0f31fd$var$useGradientAngleProperty();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)(); // Internal state for automatic transitions
    const [internalLoadingState, setInternalLoadingState] = (0, $42omo.useState)('generating'); // Use external loadingState if provided, otherwise use internal state
    const currentLoadingState = loadingState ?? internalLoadingState; // Handle automatic transitions when answer is complete
    (0, $42omo.useEffect)(()=>{
        if (!isAnswerComplete || loadingState) // Don't auto-transition if external loadingState is provided
        return;
         // Start phase 2 transitions
        let timeoutIds = []; // Transition to pre-pulse immediately
        setInternalLoadingState('pre-pulse'); // Transition to pulse after 200ms
        timeoutIds.push(setTimeout(()=>{
            setInternalLoadingState('pulse');
        }, $4fe7183f3a0f31fd$var$PRE_PULSE_ANIMATION_DURATION)); // Transition to generated after 800ms total (600ms after pulse)
        timeoutIds.push(setTimeout(()=>{
            setInternalLoadingState('generated');
        }, $4fe7183f3a0f31fd$var$TOTAL_PULSE_ANIMATION_DURATION)); // Cleanup timeouts
        return ()=>{
            timeoutIds.forEach(clearTimeout);
        };
    }, [
        isAnswerComplete,
        loadingState
    ]); // Reset to generating when answer becomes incomplete
    (0, $42omo.useEffect)(()=>{
        if (!isAnswerComplete && !loadingState) setInternalLoadingState('generating');
    }, [
        isAnswerComplete,
        loadingState
    ]); // Simplified approach for Compiled compatibility
    const isGenerating = currentLoadingState === 'generating';
    const isPrePulse = currentLoadingState === 'pre-pulse';
    const isPulse = currentLoadingState === 'pulse';
    const isGenerated = currentLoadingState === 'generated';
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _1reoewfl _18m9ewfl _1m1q1i1e _kqswh2mm _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y",
            !isReducedMotion ? colorMode === 'dark' ? isGenerating ? "_11q71q3g" : isPrePulse ? "_11q714cm" : isPulse ? "_11q79npj" : isGenerated ? "_11q714cm" : "_11q71kvu" : isGenerating ? "_11q71u9v" : isPrePulse ? "_11q71786" : isPulse ? "_11q71rsp" : isGenerated ? "_11q71786" : "_11q717xt" : colorMode === 'dark' ? "_11q7jwdd" : "_11q7et15",
            !isReducedMotion && $4fe7183f3a0f31fd$var$loadingStateStyles[currentLoadingState],
            isReducedMotion && isPrePulse && $4fe7183f3a0f31fd$var$loadingStateStyles[currentLoadingState],
            isReducedMotion && isGenerated && $4fe7183f3a0f31fd$var$loadingStateStyles[currentLoadingState]
        ]),
        style: {
            "--_92idzx": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 1)),
            "--_1vk81z2": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#82B536", 1)),
            "--_ki6hwq": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#357DE8", 1)),
            "--_9dqj5t": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#BF63F3", 1)),
            "--_1jec5hf": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0)),
            "--_8b5chw": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#82B536", 0)),
            "--_gvxzl9": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#357DE8", 0)),
            "--_ujjfrh": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#BF63F3", 0)),
            "--_3g7mui": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0.5)),
            "--_14o0mv1": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#82B536", 0.5)),
            "--_4a9n2u": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#357DE8", 0.5)),
            "--_ts8ymb": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#BF63F3", 0.5)),
            "--_1ysqspb": (0, $7sObp.default)("#FCA700"),
            "--_1kd2sou": (0, $7sObp.default)("#82B536"),
            "--_zaeqnl": (0, $7sObp.default)("#357DE8"),
            "--_wanli": (0, $7sObp.default)("#BF63F3"),
            "--_1456abr": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 1)),
            "--_t9jq7i": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#6A9A23", 1)),
            "--_1i41aq5": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#1868DB", 1)),
            "--_wnwy7": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#AF59E0", 1)),
            "--_jkwta5": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0)),
            "--_6jnsza": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#6A9A23", 0)),
            "--_1v3r5g3": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#1868DB", 0)),
            "--_1vct74": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#AF59E0", 0)),
            "--_1b9vnnu": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0.5)),
            "--_1tdjujc": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#6A9A23", 0.5)),
            "--_2itg5h": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#1868DB", 0.5)),
            "--_xlhaqx": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#AF59E0", 0.5)),
            "--_1c36rch": (0, $7sObp.default)("#FCA700"),
            "--_hciyaa": (0, $7sObp.default)("#6A9A23"),
            "--_1pbtgh9": (0, $7sObp.default)("#1868DB"),
            "--_26o6n0": (0, $7sObp.default)("#AF59E0"),
            "--_y94hvq": (0, $7sObp.default)("#0055CC"),
            "--_vps1rq": (0, $7sObp.default)("#37B4C3"),
            "--_a0mweg": (0, $7sObp.default)("#CF9F02"),
            "--_i6w5ag": (0, $7sObp.default)("#1D7AFC"),
            "--_7nv8o6": (0, $7sObp.default)("#8BDBE5"),
            "--_1ey9p4c": (0, $7sObp.default)("#F8E6A0")
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_11q7glyw _kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1pbyidpf _lcxvglyw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_1m1q1i1e _1bsb1osq _4t3i1osq _kdam1m5u",
                        colorMode === 'dark' ? isGenerating ? "_11q71q3g" : isPrePulse ? "_11q714cm" : isPulse ? "_11q79npj" : isGenerated ? "_11q714cm" : "_11q71kvu" : isGenerating ? "_11q71u9v" : isPrePulse ? "_11q71786" : isPulse ? "_11q71rsp" : isGenerated ? "_11q71786" : "_11q717xt",
                        !isReducedMotion && ""
                    ]),
                    style: {
                        "--_92idzx": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 1)),
                        "--_1vk81z2": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#82B536", 1)),
                        "--_ki6hwq": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#357DE8", 1)),
                        "--_9dqj5t": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#BF63F3", 1)),
                        "--_1jec5hf": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0)),
                        "--_8b5chw": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#82B536", 0)),
                        "--_gvxzl9": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#357DE8", 0)),
                        "--_ujjfrh": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#BF63F3", 0)),
                        "--_3g7mui": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0.5)),
                        "--_14o0mv1": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#82B536", 0.5)),
                        "--_4a9n2u": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#357DE8", 0.5)),
                        "--_ts8ymb": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#BF63F3", 0.5)),
                        "--_1ysqspb": (0, $7sObp.default)("#FCA700"),
                        "--_1kd2sou": (0, $7sObp.default)("#82B536"),
                        "--_zaeqnl": (0, $7sObp.default)("#357DE8"),
                        "--_wanli": (0, $7sObp.default)("#BF63F3"),
                        "--_1456abr": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 1)),
                        "--_t9jq7i": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#6A9A23", 1)),
                        "--_1i41aq5": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#1868DB", 1)),
                        "--_wnwy7": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#AF59E0", 1)),
                        "--_jkwta5": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0)),
                        "--_6jnsza": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#6A9A23", 0)),
                        "--_1v3r5g3": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#1868DB", 0)),
                        "--_1vct74": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#AF59E0", 0)),
                        "--_1b9vnnu": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#FCA700", 0.5)),
                        "--_1tdjujc": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#6A9A23", 0.5)),
                        "--_2itg5h": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#1868DB", 0.5)),
                        "--_xlhaqx": (0, $7sObp.default)($4fe7183f3a0f31fd$var$hexToRgba("#AF59E0", 0.5)),
                        "--_1c36rch": (0, $7sObp.default)("#FCA700"),
                        "--_hciyaa": (0, $7sObp.default)("#6A9A23"),
                        "--_1pbtgh9": (0, $7sObp.default)("#1868DB"),
                        "--_26o6n0": (0, $7sObp.default)("#AF59E0")
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_2rko12b0 _bfhkvuon _kqswh2mm _1pbycs5v _1bsb1osq"
                ]),
                children: children
            })
        ]
    });
};
module.exports["AnimatedWrapper"] = $4fe7183f3a0f31fd$export$ca874e6b8d314598;

});

parcelRegister("4xTru", function(module, exports) {

var $01aV7 = parcelRequire("01aV7");


var $cqFuK = parcelRequire("cqFuK");

const $ff3ce01b804423d2$export$17e25c724e0ebb55 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'surfaced',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'queryIntent',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$cae33476d80498a = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'dropoff',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$e1c446b3b8b22ff = (props, dwellTime)=>{
    const { query: query, source: source } = props;
    return {
        action: 'hidden',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            dwellTime: dwellTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$e9cccbc780a694f3 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'viewed',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$a43930cde520e30 = (props, isAnimated)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            isAnimated: isAnimated
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$67b8bcd639e29c44 = (props, smartAnswersRoute)=>{
    const { query: query, source: source } = props;
    return {
        action: 'classified',
        actionSubject: 'aiAnswerRoute',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            smartAnswersRoute: smartAnswersRoute
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$c075b0a4ec670c87 = ({ isReadingAids: isReadingAids, sourceProduct: sourceProduct, dwellTime: dwellTime, loadTime: loadTime, fmpLoadTime: fmpLoadTime, ...props })=>{
    const { query: query, source: source, searchSessionId: searchSessionId } = props;
    return {
        action: 'unmounted',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            aiFeatureName: isReadingAids ? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}` : 'smartAnswers',
            aiInteractionId: isReadingAids ? undefined : searchSessionId,
            aiInteractionType: isReadingAids ? undefined : 'searchSessionId',
            dwellTime: dwellTime,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$bc6497c5d340e00a = ({ isStreamed: isStreamed, loadTime: loadTime, fmpLoadTime: fmpLoadTime, ...props })=>{
    const { query: query, answerString: answerString, source: source, cloudId: cloudId } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            cloudId: cloudId,
            isStreamed: isStreamed,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$5a7faebf1192b4e4 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, answerString: answerString, answerCardType: answerCardType, fmpLoadTime: fmpLoadTime, resourceType: resourceType })=>{
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType,
            fmpLoadTime: fmpLoadTime,
            resourceType: resourceType
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$bd496fce1657ba31 = ({ isStreamed: isStreamed, loadTime: loadTime, fmpLoadTime: fmpLoadTime, ...props })=>{
    const { query: query, answerString: answerString, source: source, errorState: errorState } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerError',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            isStreamed: isStreamed,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime,
            errorState: errorState
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$a499208a458c0e59 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$d5927f4d78af7f29 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerCollapse',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$9402fab525dc0906 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$aef55698754fc321 = ({ sourceIndex: sourceIndex, isCitation: isCitation, hostname: hostname, sourceCardType: sourceCardType, sourceProduct: sourceProduct, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            sourceIndex: sourceIndex,
            isCitation: isCitation,
            sourceCardType: sourceCardType,
            sourceProduct: sourceProduct,
            ...hostname ? {
                metadata: {
                    hostname: hostname
                }
            } : {}
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$3dedd72888bd21a1 = ({ sourceIndex: sourceIndex, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            sourceIndex: sourceIndex
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$e6acda7cbaefba32 = ({ expanded: expanded, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            expanded: expanded
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$e7233899affc4477 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReturnLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$473e6bca52fdbe16 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDeselectLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$47b58698bef30558 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDeselectDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$67d198681f64796b = (props)=>{
    const { query: query, answerString: answerString, source: source, feedbackSentiment: feedbackSentiment, feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact } = props;
    return {
        action: 'submitted',
        actionSubject: 'aiAnswerFeedback',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            feedbackSentiment: feedbackSentiment,
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$9daed4df08e246d1 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReportButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$f1956b3bd380b51e = ({ followUpString: followUpString, destination: destination, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiFollowUpSuggestion',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            followUpHash: (0, $01aV7.sha256Hash)(followUpString),
            destination: destination
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            followUpString: followUpString
        }
    };
};
const $ff3ce01b804423d2$export$c1460cbf6075b68 = ({ showErrorStateSuggestedQueries: showErrorStateSuggestedQueries, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiErrorStateSuggestedQueries',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            showErrorStateSuggestedQueries: showErrorStateSuggestedQueries
        }
    };
};
const $ff3ce01b804423d2$export$97c5ff7b106e0023 = ({ errorStateSuggestedQuery: errorStateSuggestedQuery, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiErrorStateSuggestedQuery',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            errorStateSuggestedQueryHash: (0, $01aV7.sha256Hash)(errorStateSuggestedQuery)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            errorStateSuggestedQuery: errorStateSuggestedQuery
        }
    };
};
const $ff3ce01b804423d2$export$689a00fa0f31e3ff = ({ experimentCohort: experimentCohort, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerOpenChatButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            experimentCohort: experimentCohort
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$e6174e7fdfd73609 = ({ expandButtonSource: expandButtonSource, ...props })=>{
    const { query: query } = props;
    return {
        action: 'clicked',
        actionSubject: 'expandButton',
        actionSubjectId: expandButtonSource,
        source: props.source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$924cae8b31b3ec43 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};
const $ff3ce01b804423d2$export$7bc7dfa120866cd2 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};
const $ff3ce01b804423d2$export$da5ff760e0ba649b = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            resultSection: resultSection
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};
const $ff3ce01b804423d2$export$305f2a0f7fa9a25f = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            resultSection: resultSection
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};
const $ff3ce01b804423d2$export$4bb2ae9dc67cd713 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};
const $ff3ce01b804423d2$export$caffb77a39b6cd1 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};
const $ff3ce01b804423d2$export$5c8be2d1a7dc557 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            index: index
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$440c60ade2f202a9 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            index: index
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$b22e9ed865dfbcfa = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$3eb2378888745842 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$f32beb894f554d19 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$ff4d21c4c98bfb06 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionNextButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};
const $ff3ce01b804423d2$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$9dee3cc92d823001 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$476afff83df695b3 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerCopy',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$8aac675f87e67286 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerReadMoreButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$f0624d0c866f1dff = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReadMoreButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$91710431dd421e57 = (props, isAnimated)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'knowledgeCardLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            isAnimated: isAnimated
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$10fed66da45c02f6 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, loadTime: loadTime, success: success, answerCardType: answerCardType, answerString: answerString, endState: endState })=>{
    return {
        action: 'loaded',
        actionSubject: 'aiAnswerJiraNlToJqlCard',
        source: source,
        eventType: 'track',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            loadTime: loadTime,
            success: success,
            answerCardType: answerCardType,
            endState: endState
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$ea403d9edffb26a2 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, issuekey: issuekey, answerCardType: answerCardType, answerString: answerString })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerJiraCardWorkItemLink',
        source: source,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType
        },
        nonPrivacySafeAttributes: {
            answerString: answerString,
            query: query,
            issuekey: issuekey
        }
    };
};
const $ff3ce01b804423d2$export$447238500b8bc926 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, answerCardType: answerCardType, answerString: answerString })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerJiraCardViewAll',
        source: source,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
var $ff3ce01b804423d2$export$3a434349d1106dd4 = /*#__PURE__*/ function(SmartLinksAnalyticsContextLocation) {
    SmartLinksAnalyticsContextLocation["AI_DEFINITION"] = "ai-definition";
    SmartLinksAnalyticsContextLocation["SAIN_AGENT_CARD"] = "sain-agent-card";
    SmartLinksAnalyticsContextLocation["SAIN_BOOKMARK"] = "sain-bookmark";
    SmartLinksAnalyticsContextLocation["SAIN_JIRA_ISSUE_CARD"] = "sain-jira-issue-card";
    SmartLinksAnalyticsContextLocation["SAIN_JIRA_NL_TO_JQL_CARD"] = "sain-jira-nl-to-jql-card";
    SmartLinksAnalyticsContextLocation["SAIN_PERSON_CARD"] = "sain-person-card";
    SmartLinksAnalyticsContextLocation["SAIN_Q_AND_A_CARD"] = "sain-q-and-a-card";
    SmartLinksAnalyticsContextLocation["SAIN_TEAM_CARD"] = "sain-team-card";
    SmartLinksAnalyticsContextLocation["SEARCH_RESULT_CONFLUENCE_CARD"] = "search-result-confluence-card";
    return SmartLinksAnalyticsContextLocation;
}({});
const $ff3ce01b804423d2$export$eb9a0c30af65bc0b = ({ location: location, commonAttributes: commonAttributes })=>{
    return {
        attributes: {
            location: location,
            ...(0, $cqFuK.filterCommonAttributes)(commonAttributes)
        },
        location: // Below is added for the future implementation of Linking Platform namespaced analytic context
        location
    };
};
const $ff3ce01b804423d2$export$48c2363cbebfe859 = (props)=>{
    const { source: source, elementType: elementType } = props;
    return {
        action: 'viewed',
        actionSubject: 'aiResultHover',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            elementType: elementType
        }
    };
};
const $ff3ce01b804423d2$export$ccaa86fdb4ea3d58 = (props)=>{
    const { source: source, elementType: elementType, hoverTime: hoverTime } = props;
    return {
        action: 'dismissed',
        actionSubject: 'aiResultHover',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            elementType: elementType,
            hoverTime: hoverTime
        }
    };
};
const $ff3ce01b804423d2$export$732cac0318736348 = (props)=>{
    const { query: query, answerString: answerString, source: source, selectedTab: selectedTab } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerTab',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            selectedTab: selectedTab
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$f3109245f09f7746 = (props)=>{
    const { query: query, answerString: answerString, source: source, answerHeight: answerHeight, containerHeight: containerHeight, whitespaceHeight: whitespaceHeight, queryIntent: queryIntent } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResultComplete',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            answerHeight: answerHeight,
            containerHeight: containerHeight,
            whitespaceHeight: whitespaceHeight,
            queryIntent: queryIntent
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$c68095583a3c17cc = (props)=>{
    const { query: query, answerString: answerString, source: source, timeToFirstByte: timeToFirstByte } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResultFirstByte',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            timeToFirstByte: timeToFirstByte
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$efbf193d50ae9f9b = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerStreamingEarlyStopCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$d0aa7585daee6b3c = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'dismissed',
        actionSubject: 'aiAnswerStreamingEarlyStopCard',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$f4842cd462275250 = (props)=>{
    const { source: source, displayedAppsCount: displayedAppsCount } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerThirdPartyBanner',
        source: source,
        eventType: 'track',
        attributes: {
            displayedAppsCount: displayedAppsCount,
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    };
};
const $ff3ce01b804423d2$export$600f614e99e954f6 = (props)=>{
    const { source: source, appKey: appKey, appIndex: appIndex, displayedAppsCount: displayedAppsCount } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerThirdPartyBannerAppButton',
        source: source,
        eventType: 'ui',
        attributes: {
            appKey: appKey,
            appIndex: appIndex,
            displayedAppsCount: displayedAppsCount,
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    };
};
const $ff3ce01b804423d2$export$39617c8c5cfdd601 = (props)=>{
    const { source: source, displayedAppsCount: displayedAppsCount } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerThirdPartyBannerDismissButton',
        source: source,
        eventType: 'ui',
        attributes: {
            displayedAppsCount: displayedAppsCount,
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    };
};
module.exports["onAIAnswerDialogQueryIntent"] = $ff3ce01b804423d2$export$17e25c724e0ebb55;
module.exports["onAIAnswerDialogDroppedOff"] = $ff3ce01b804423d2$export$cae33476d80498a;
module.exports["onAIAnswerDialogHidden"] = $ff3ce01b804423d2$export$e1c446b3b8b22ff;
module.exports["onAIAnswerDialogViewed"] = $ff3ce01b804423d2$export$e9cccbc780a694f3;
module.exports["onAIAnswerLoadingDialogShown"] = $ff3ce01b804423d2$export$a43930cde520e30;
module.exports["onSmartAnswerRouteDetection"] = $ff3ce01b804423d2$export$67b8bcd639e29c44;
module.exports["onAIAnswerDialogUnmount"] = $ff3ce01b804423d2$export$c075b0a4ec670c87;
module.exports["onAIAnswerResultShown"] = $ff3ce01b804423d2$export$bc6497c5d340e00a;
module.exports["onNonGenerativeAIAnswerResultShown"] = $ff3ce01b804423d2$export$5a7faebf1192b4e4;
module.exports["onAIAnswerNotShown"] = $ff3ce01b804423d2$export$bd496fce1657ba31;
module.exports["aiAnswerExpandClicked"] = $ff3ce01b804423d2$export$a499208a458c0e59;
module.exports["aiAnswerCollapseClicked"] = $ff3ce01b804423d2$export$d5927f4d78af7f29;
module.exports["aiAnswerExpandShown"] = $ff3ce01b804423d2$export$9402fab525dc0906;
module.exports["onAIAnswerSourceClick"] = $ff3ce01b804423d2$export$aef55698754fc321;
module.exports["onAIAnswerReturnLinkClick"] = $ff3ce01b804423d2$export$e7233899affc4477;
module.exports["onLikeButtonClick"] = $ff3ce01b804423d2$export$5b155f527aff26b9;
module.exports["onDislikeButtonClick"] = $ff3ce01b804423d2$export$c4c8b81ee90e6af2;
module.exports["onDeselectLikeButtonClick"] = $ff3ce01b804423d2$export$473e6bca52fdbe16;
module.exports["onDeselectDislikeButtonClick"] = $ff3ce01b804423d2$export$47b58698bef30558;
module.exports["onFeedbackSubmit"] = $ff3ce01b804423d2$export$67d198681f64796b;
module.exports["onFollowUpSuggestionClick"] = $ff3ce01b804423d2$export$f1956b3bd380b51e;
module.exports["onErrorStateSuggestedQueriesShown"] = $ff3ce01b804423d2$export$c1460cbf6075b68;
module.exports["onErrorStateSuggestedQueryClick"] = $ff3ce01b804423d2$export$97c5ff7b106e0023;
module.exports["onOpenChatButtonClick"] = $ff3ce01b804423d2$export$689a00fa0f31e3ff;
module.exports["onExpandButtonClicked"] = $ff3ce01b804423d2$export$e6174e7fdfd73609;
module.exports["onWhoPrimaryViewProfileClick"] = $ff3ce01b804423d2$export$924cae8b31b3ec43;
module.exports["onWhoPrimaryViewProfileContextMenuClick"] = $ff3ce01b804423d2$export$7bc7dfa120866cd2;
module.exports["onWhoPrimaryCoordinationPillClick"] = $ff3ce01b804423d2$export$da5ff760e0ba649b;
module.exports["onWhoPrimaryCoordinationPillContextMenuClick"] = $ff3ce01b804423d2$export$305f2a0f7fa9a25f;
module.exports["onWhoAdditionalMatchProfileClick"] = $ff3ce01b804423d2$export$4bb2ae9dc67cd713;
module.exports["onWhoAdditionalMatchProfileContextMenuClick"] = $ff3ce01b804423d2$export$caffb77a39b6cd1;
module.exports["onRecentWorkItemClick"] = $ff3ce01b804423d2$export$5c8be2d1a7dc557;
module.exports["onRecentWorkItemContextMenuClick"] = $ff3ce01b804423d2$export$440c60ade2f202a9;
module.exports["onRecentWorkLinkClick"] = $ff3ce01b804423d2$export$b22e9ed865dfbcfa;
module.exports["onRecentWorkLinkContextMenuClick"] = $ff3ce01b804423d2$export$3eb2378888745842;
module.exports["onCuratedDefinitionEditButtonClicked"] = $ff3ce01b804423d2$export$f32beb894f554d19;
module.exports["onCuratedDefinitionEditButtonShown"] = $ff3ce01b804423d2$export$9dee3cc92d823001;
module.exports["onAIAnswerCopyButtonClicked"] = $ff3ce01b804423d2$export$476afff83df695b3;
module.exports["onReadMoreButtonShown"] = $ff3ce01b804423d2$export$8aac675f87e67286;
module.exports["onReadMoreButtonClicked"] = $ff3ce01b804423d2$export$f0624d0c866f1dff;
module.exports["onKnowledgeCardLoadingDialogShown"] = $ff3ce01b804423d2$export$91710431dd421e57;
module.exports["onJiraNlToJqlCardLoaded"] = $ff3ce01b804423d2$export$10fed66da45c02f6;
module.exports["onJiraIssueKeyClicked"] = $ff3ce01b804423d2$export$ea403d9edffb26a2;
module.exports["onJiraViewAllButtonClicked"] = $ff3ce01b804423d2$export$447238500b8bc926;
module.exports["SmartLinksAnalyticsContextLocation"] = $ff3ce01b804423d2$export$3a434349d1106dd4;
module.exports["getSmartLinksAnalyticsContextData"] = $ff3ce01b804423d2$export$eb9a0c30af65bc0b;
module.exports["onAIResultHoverStart"] = $ff3ce01b804423d2$export$48c2363cbebfe859;
module.exports["onAIResultHoverStop"] = $ff3ce01b804423d2$export$ccaa86fdb4ea3d58;
module.exports["onAIAnswerTabClick"] = $ff3ce01b804423d2$export$732cac0318736348;
module.exports["onAIAnswerResultCompleteShown"] = $ff3ce01b804423d2$export$f3109245f09f7746;
module.exports["onAIAnswerResultFirstByteShown"] = $ff3ce01b804423d2$export$c68095583a3c17cc;
module.exports["onStreamingEarlyStopCardShown"] = $ff3ce01b804423d2$export$efbf193d50ae9f9b;
module.exports["onStreamingEarlyStopCardDismissed"] = $ff3ce01b804423d2$export$d0aa7585daee6b3c;
module.exports["onThirdPartyBannerShown"] = $ff3ce01b804423d2$export$f4842cd462275250;
module.exports["onThirdPartyBannerAppClicked"] = $ff3ce01b804423d2$export$600f614e99e954f6;
module.exports["onThirdPartyBannerDismissed"] = $ff3ce01b804423d2$export$39617c8c5cfdd601;

});

parcelRegister("9lp28", function(module, exports) {
/* ai-disclaimer-and-feedback.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $2MuFw = parcelRequire("2MuFw");


var $eXmBZ = parcelRequire("eXmBZ");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eRXI0 = parcelRequire("eRXI0");


var $4xTru = parcelRequire("4xTru");


var $jLyYG = parcelRequire("jLyYG");


var $4jIuc = parcelRequire("4jIuc");


var $cVtio = parcelRequire("cVtio");


var $8s0lk = parcelRequire("8s0lk");





var $42omo = parcelRequire("42omo");




















var $9zIwY = parcelRequire("9zIwY");


var $9FnLD = parcelRequire("9FnLD");


var $6fnsQ = parcelRequire("6fnsQ");




const $2067d1e392749491$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    ai_feedback_report_consent_checkbox_label: {
        id: "search_ai.ai_feedback_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_feedback_provide_additional_feedback_title: {
        id: "search_ai.ai_feedback_provide_additional_feedback_title",
        defaultMessage: "Provide additional feedback"
    },
    ai_feedback_like_button_tooltip: {
        id: "search_ai.ai_feedback_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_feedback_dislike_button_tooltip: {
        id: "search_ai.ai_feedback_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_feedback_can_contact_checkbox_label: {
        id: "search_ai.ai_feedback_can_contact_checkbox_label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the {privatePolicyLink}"
    },
    ai_feedback_private_policy_link: {
        id: "search_ai.ai_feedback_private_policy_link",
        defaultMessage: "Atlassian Privacy Policy"
    },
    ai_feedback_reason_out_of_date: {
        id: "search_ai.ai_feedback_reason_out_of_date",
        defaultMessage: "Out of date"
    },
    ai_feedback_reason_inaccurate: {
        id: "search_ai.ai_feedback_reason_inaccurate",
        defaultMessage: "Inaccurate"
    },
    ai_feedback_reason_too_long: {
        id: "search_ai.ai_feedback_reason_too_long",
        defaultMessage: "Too long"
    },
    ai_feedback_reason_too_short: {
        id: "search_ai.ai_feedback_reason_too_short",
        defaultMessage: "Too short"
    },
    ai_feedback_reason_wrong_sources: {
        id: "search_ai.ai_feedback_reason_wrong_sources",
        defaultMessage: "Wrong sources"
    },
    ai_feedback_reason_inappropriate: {
        id: "search_ai.ai_feedback_reason_inappropriate",
        defaultMessage: "Inappropriate or harmful"
    },
    ai_feedback_reason_other: {
        id: "search_ai.ai_feedback_reason_other",
        defaultMessage: "Other"
    },
    ai_feedback_reason_up_to_date: {
        id: "search_ai.ai_feedback_reason_up_to_date",
        defaultMessage: "Up to date"
    },
    ai_feedback_reason_accurate: {
        id: "search_ai.ai_feedback_reason_accurate",
        defaultMessage: "Accurate"
    },
    ai_feedback_reason_helpful: {
        id: "search_ai.ai_feedback_reason_helpful",
        defaultMessage: "Helpful"
    },
    ai_feedback_reason_following_instructions: {
        id: "search_ai.ai_feedback_reason_following_instructions",
        defaultMessage: "Following instructions"
    },
    ai_feedback_reason_good_sources: {
        id: "search_ai.ai_feedback_reason_good_sources",
        defaultMessage: "Good sources"
    },
    ai_feedback_flag_title: {
        id: "search_ai.ai_feedback_flag_title",
        defaultMessage: "Thank you"
    },
    ai_feedback_flag_description: {
        id: "search_ai.ai_feedback_flag_description",
        defaultMessage: "Your feedback helps to improve Rovo"
    },
    ai_feedback_flag_close_action: {
        id: "search_ai.ai_feedback_flag_close_action",
        defaultMessage: "I'm done"
    },
    ai_feedback_what_hasnt_gone_well_title: {
        id: "search_ai.ai_feedback_what_hasnt_gone_well_title",
        defaultMessage: "What hasn't gone well?"
    },
    ai_feedback_what_has_gone_well_title: {
        id: "search_ai.ai_feedback_what_has_gone_well_title",
        defaultMessage: "What has been going well?"
    },
    ai_feedback_additional_feedback_label: {
        id: "search_ai.ai_feedback_additional_feedback_label",
        defaultMessage: "Additional feedback"
    },
    ai_feedback_additional_feedback_placeholder: {
        id: "search_ai.ai_feedback_additional_feedback_placeholder",
        defaultMessage: "Tell us more"
    }
});


const $48e10f0b3cbbaf7c$var$LikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $48e10f0b3cbbaf7c$var$ActiveLikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: "",
        color: "var(--ds-icon-selected, #1868DB)"
    });
const $48e10f0b3cbbaf7c$var$DislikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $48e10f0b3cbbaf7c$var$ActiveDislikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
        label: "",
        color: `var(--ds-icon-selected, ${(0, $6fnsQ.B300)})`
    });
const $48e10f0b3cbbaf7c$export$ee3da02b14ab91be = ({ liked: liked, setLiked: setLiked, setShowDisplayFlag: setShowDisplayFlag, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler, onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (liked === undefined || liked === false) {
            setShowDisplayFlag(true);
            setLiked(true);
            onLikeButtonClickHandler && onLikeButtonClickHandler(e);
        } else {
            setLiked(undefined);
            onDeselectLikeButtonClickHandler && onDeselectLikeButtonClickHandler(e);
        }
    }, [
        setShowDisplayFlag,
        setLiked,
        onLikeButtonClickHandler,
        liked,
        onDeselectLikeButtonClickHandler
    ]);
    const dislikeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (liked === undefined || liked === true) {
            setShowDisplayFlag(true);
            setLiked(false);
            onDislikeButtonClickHandler && onDislikeButtonClickHandler(e);
        } else {
            setLiked(undefined);
            onDeselectDislikeButtonClickHandler && onDeselectDislikeButtonClickHandler(e);
        }
    }, [
        setShowDisplayFlag,
        setLiked,
        onDislikeButtonClickHandler,
        liked,
        onDeselectDislikeButtonClickHandler
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: liked === true ? $48e10f0b3cbbaf7c$var$ActiveLikeIcon : $48e10f0b3cbbaf7c$var$LikeIcon,
                isSelected: liked === true,
                onClick: likeButtonCallback,
                label: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_like_button_tooltip),
                appearance: liked === true ? 'primary' : 'subtle',
                isTooltipDisabled: false,
                spacing: "compact",
                testId: "ai-answer-like-button",
                shape: "circle"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: liked === false ? $48e10f0b3cbbaf7c$var$ActiveDislikeIcon : $48e10f0b3cbbaf7c$var$DislikeIcon,
                isSelected: liked === false,
                onClick: dislikeButtonCallback,
                label: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_dislike_button_tooltip),
                appearance: liked === false ? 'primary' : 'subtle',
                isTooltipDisabled: false,
                spacing: "compact",
                testId: "ai-answer-dislike-button",
                shape: "circle"
            })
        ]
    });
};












var $ccHMk = parcelRequire("ccHMk");


var $7gpC4 = parcelRequire("7gpC4");


var $6rSJC = parcelRequire("6rSJC");

var $fb3kw = parcelRequire("fb3kw");







var $eyWa4 = parcelRequire("eyWa4");




var $9EtP6 = parcelRequire("9EtP6");


var $f7lNm = parcelRequire("f7lNm");



const $39978988dc52f4fb$var$AkFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));
var $39978988dc52f4fb$export$1cf63b56d5de87d5 = /*#__PURE__*/ function(FeedbackCollectorModalVariant) {
    FeedbackCollectorModalVariant["POSITIVE"] = "positive";
    FeedbackCollectorModalVariant["NEGATIVE"] = "negative";
    return FeedbackCollectorModalVariant;
}({});
const $39978988dc52f4fb$export$21ca6c649ed55a5a = ({ entrypointId: entrypointId, attributes: attributes, attributesWithConsent: attributesWithConsent, userId: userId, userName: userName, onClose: onClose, onSubmit: onSubmit, variant: variant })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [hasConsent, setConsent] = (0, $42omo.useState)(false);
    const [canContact, setCanContact] = (0, $42omo.useState)(false);
    const [selectedReasons, setSelectedReasons] = (0, $42omo.useState)([]);
    const [description, setDescription] = (0, $42omo.useState)('');
    const POSITIVE_FEEDBACK_REASONS = [
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_up_to_date),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_accurate),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_helpful),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_following_instructions),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_good_sources),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_other)
    ];
    const NEGATIVE_FEEDBACK_REASONS = [
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_out_of_date),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_inaccurate),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_too_long),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_too_short),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_wrong_sources),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_inappropriate),
        formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_reason_other)
    ];
    const feedbackOptions = variant === "positive" ? POSITIVE_FEEDBACK_REASONS : NEGATIVE_FEEDBACK_REASONS;
    const handleReasonClick = (option)=>{
        setSelectedReasons((prev)=>prev.includes(option) ? prev.filter((r)=>r !== option) : [
                ...prev,
                option
            ]);
    };
    const feedbackObject = {
        ...attributes,
        ...hasConsent ? attributesWithConsent : {},
        ...selectedReasons.length > 0 ? {
            'Feedback Reasons': selectedReasons.join(', ')
        } : {}
    };
    const feedbackContext = Object.entries(feedbackObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $42omo.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    const sendMetadata = {
        userId: userId
    };
    const getDescriptionWithMetadata = ()=>`
	${description}

	\`\`\`
	${JSON.stringify(sendMetadata, null, 2)}
	\`\`\`
  `;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)($39978988dc52f4fb$var$AkFeedbackCollector, {
            onClose: onClose,
            onSubmit: ()=>onSubmit({
                    feedbackOptions: selectedReasons,
                    additionalFeedbackAdded: description.length > 0,
                    includeResponse: hasConsent,
                    canContact: canContact
                }),
            showTypeField: false,
            showDefaultTextFields: false,
            atlassianAccountId: userId,
            name: userName,
            entrypointId: entrypointId,
            additionalFields: [
                {
                    id: (0, $f7lNm.FEEDBACK_CONTEXT_CF),
                    value: feedbackContext
                },
                {
                    id: 'customfield_10043',
                    value: canContact ? [
                        {
                            id: '10109'
                        }
                    ] : [
                        {
                            id: '10111'
                        }
                    ]
                }
            ],
            feedbackTitle: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_provide_additional_feedback_title),
            descriptionDefaultValue: getDescriptionWithMetadata(),
            summaryDefaultValue: description,
            canBeContactedFieldId: "undefined",
            showRequiredFieldsSummary: false,
            customContent: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.150",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                weight: "bold",
                                color: "color.text.subtle",
                                children: formatMessage(variant === "positive" ? (0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_what_has_gone_well_title : (0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_what_hasnt_gone_well_title)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                space: "space.100",
                                shouldWrap: true,
                                children: feedbackOptions.map((option)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        isSelected: selectedReasons.includes(option),
                                        onClick: ()=>handleReasonClick(option),
                                        children: option
                                    }, option))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                name: "feedback-summary",
                                label: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_additional_feedback_label),
                                isRequired: false,
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                        ...fieldProps,
                                        name: "feedback-collector-description",
                                        minimumRows: 6,
                                        placeholder: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_additional_feedback_placeholder),
                                        onChange: (e)=>setDescription(e.target.value),
                                        value: description
                                    })
                            }),
                            Object.keys(attributesWithConsent).length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6rSJC.default), {
                                name: "search-ai-include-prompt-and-response",
                                defaultIsChecked: hasConsent,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                        ...fieldProps,
                                        label: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_report_consent_checkbox_label),
                                        onChange: toggleConsentCheckbox
                                    })
                            }) : undefined,
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6rSJC.default), {
                                name: "can-be-contacted",
                                defaultIsChecked: canContact,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                        ...fieldProps,
                                        label: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_can_contact_checkbox_label, {
                                            privatePolicyLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                target: "_blank",
                                                children: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_private_policy_link)
                                            })
                                        }),
                                        onChange: (event)=>setCanContact(event.target.checked)
                                    })
                            })
                        ]
                    })
                ]
            })
        })
    });
};






const $748cc916965f036b$export$c71de71744353b85 = (0, $42omo.lazy)(()=>(parcelRequire("2oh9Z")).then(({ AIFeedbackFlag: AIFeedbackFlag })=>({
            default: AIFeedbackFlag
        })));



const $75319d601d9e2e47$export$41116a477d95163a = function AIFeedback({ entrypointId: entrypointId, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler, onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler, onFeedbackSubmitHandler: onFeedbackSubmitHandler, userDetails: userDetails, attributes: attributes, attributesWithConsent: attributesWithConsent = {}, liked: externalLike // set like state from the outside
 }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [showFeedbackModal, setShowFeedbackModal] = (0, $42omo.useState)(false);
    const [showDisplayFlag, setShowDisplayFlag] = (0, $42omo.useState)(false);
    const [liked, setLiked] = (0, $42omo.useState)(externalLike);
    const onFeedbackSubmit = ({ feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact })=>{
        onFeedbackSubmitHandler?.({
            liked: liked,
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.050",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $48e10f0b3cbbaf7c$export$ee3da02b14ab91be), {
                    setShowDisplayFlag: setShowDisplayFlag,
                    onLikeButtonClickHandler: onLikeButtonClickHandler,
                    onDislikeButtonClickHandler: onDislikeButtonClickHandler,
                    onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
                    onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
                    liked: liked,
                    setLiked: setLiked
                })
            }),
            showFeedbackModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $39978988dc52f4fb$export$21ca6c649ed55a5a), {
                entrypointId: entrypointId,
                attributes: attributes,
                attributesWithConsent: attributesWithConsent,
                userId: userDetails.id,
                userName: userDetails.name,
                onClose: ()=>setShowFeedbackModal(false),
                onSubmit: onFeedbackSubmit,
                variant: liked ? (0, $39978988dc52f4fb$export$1cf63b56d5de87d5).POSITIVE : (0, $39978988dc52f4fb$export$1cf63b56d5de87d5).NEGATIVE
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $748cc916965f036b$export$c71de71744353b85), {
                    displayFlag: showDisplayFlag,
                    onDismissed: ()=>setShowDisplayFlag(false),
                    description: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_flag_description),
                    title: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_flag_title),
                    actions: [
                        {
                            content: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_provide_additional_feedback_title),
                            onClick: ()=>{
                                setShowDisplayFlag(false);
                                setShowFeedbackModal(true);
                            }
                        },
                        {
                            content: formatMessage((0, $2067d1e392749491$export$defe85febe8b728c).ai_feedback_flag_close_action),
                            onClick: ()=>setShowDisplayFlag(false)
                        }
                    ]
                })
            })
        ]
    });
};






var $jTYav = parcelRequire("jTYav");

/* sain-more-options-dropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $52EPl = parcelRequire("52EPl");


var $9VJDA = parcelRequire("9VJDA");


var $5nBzc = parcelRequire("5nBzc");





var $gdv5Z = parcelRequire("gdv5Z");



























var $1Zr9M = parcelRequire("1Zr9M");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");

















var $epS7s = parcelRequire("epS7s");





var $hAecz = parcelRequire("hAecz");

const $40c78a8e52f40a1e$var$ColoredEditIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: ""
    });
const $40c78a8e52f40a1e$export$bfae871beaee7eb7 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isPromptOverrideModalOpen, setIsPromptOverrideModalOpen] = (0, $42omo.useState)(false);
    const [promptText, setPromptText] = (0, $42omo.useState)('');
    // Load stored prompt when modal opens
    (0, $42omo.useEffect)(()=>{
        if (isPromptOverrideModalOpen) {
            const stored = (0, $epS7s.getSessionItem)((0, $f7lNm.PROMPT_OVERRIDE_SESSION_KEY));
            setPromptText(stored || '');
        }
    }, [
        isPromptOverrideModalOpen
    ]);
    const openPromptOverrideModal = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        setIsPromptOverrideModalOpen(true);
    }, []);
    const closePromptOverrideModal = (0, $42omo.useCallback)(()=>{
        setIsPromptOverrideModalOpen(false);
    }, []);
    const handleSave = (0, $42omo.useCallback)(()=>{
        const trimmedPrompt = promptText.trim();
        if (trimmedPrompt) (0, $epS7s.setSessionItem)((0, $f7lNm.PROMPT_OVERRIDE_SESSION_KEY), trimmedPrompt);
        else (0, $epS7s.deleteSessionItem)((0, $f7lNm.PROMPT_OVERRIDE_SESSION_KEY));
        closePromptOverrideModal();
    }, [
        promptText,
        closePromptOverrideModal
    ]);
    const handleTextChange = (0, $42omo.useCallback)((e)=>{
        setPromptText(e.target.value);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: $40c78a8e52f40a1e$var$ColoredEditIcon,
                label: formatMessage((0, $hAecz.messages).prompt_override_button_label),
                onClick: openPromptOverrideModal,
                appearance: "subtle",
                isTooltipDisabled: false,
                spacing: "compact",
                testId: "prompt-override-button",
                color: "var(--ds-icon-subtlest, #6B6E76)",
                shape: (0, $dh538.fg)('kd_sain_feedback_collector_ux_uplift_rollout') ? 'circle' : 'default'
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isPromptOverrideModalOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
                    onClose: closePromptOverrideModal,
                    width: "large",
                    testId: "prompt-override-modal",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $hAecz.messages).prompt_override_modal_title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                                space: "space.200",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                        space: "space.100",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                weight: "semibold",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...(0, $hAecz.messages).prompt_override_custom_prompt_label
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                value: promptText,
                                                onChange: handleTextChange,
                                                placeholder: formatMessage((0, $hAecz.messages).prompt_override_textarea_placeholder),
                                                testId: "prompt-override-textarea",
                                                resize: "vertical"
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                space: "space.100",
                                                spread: "space-between",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "color.text.subtlest",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        ...(0, $hAecz.messages).prompt_override_help_text
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "subtle",
                                        onClick: closePromptOverrideModal,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $hAecz.messages).prompt_override_cancel_button
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "primary",
                                        onClick: handleSave,
                                        testId: "prompt-override-save-button",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $hAecz.messages).prompt_override_save_button
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};


const $4ffa81ac2d70de56$var$messages = (0, $cgtv4.defineMessages)({
    debugger_menu_item: {
        id: "search_ai.debugger_menu_item",
        defaultMessage: "Debugger"
    },
    prompt_override_menu_item: {
        id: "search_ai.prompt_override_menu_item",
        defaultMessage: "Prompt override"
    },
    store_message_label: {
        id: "search_ai.store_message_label",
        defaultMessage: "Record this message to help us improve answer quality"
    },
    internal_lozenge: {
        id: "search_ai.internal_lozenge",
        defaultMessage: "INTERNAL"
    }
});
const $4ffa81ac2d70de56$var$styles = {
    checkboxWrapper: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
    dropdownContent: "_1bsb1mjv _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $4ffa81ac2d70de56$var$DROPDOWN_Z_INDEX = 900;
function $4ffa81ac2d70de56$export$fcbb8fd6209efbc6() {
    const isArizeGateOn = (0, $dh538.fg)('kd_sain_enable_arize_hello_only');
    const showOnlineDebuggerButton = (0, $dh538.fg)('kd_sain_online_debugger');
    const showPromptOverrideButton = (0, $dh538.fg)('convo_ai_sain_enable_prompt_override_hello_only');
    const [storeMessage, setStoreMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(()=>{
        try {
            const stored = localStorage.getItem('search-ai.sain.store_message');
            return stored === null || stored === 'true';
        } catch  {
            return true;
        }
    });
    const onStoreMessageChange = (e)=>{
        e.stopPropagation();
        const next = e.target.checked;
        setStoreMessage(next);
        try {
            localStorage.setItem('search-ai.sain.store_message', String(next));
        } catch  {}
    };
    const onMoreOptionsClick = (event)=>{
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                ...props,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: "More options",
                appearance: "subtle",
                spacing: "compact",
                testId: "sain-more-options-button",
                onClick: (e)=>{
                    onMoreOptionsClick(e);
                    props.onClick?.(e);
                }
            }),
        placement: "bottom-end",
        zIndex: $4ffa81ac2d70de56$var$DROPDOWN_Z_INDEX,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $4ffa81ac2d70de56$var$styles.dropdownContent,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.100",
                children: [
                    showOnlineDebuggerButton && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.075",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $jTYav.OnlineDebuggerButton), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...$4ffa81ac2d70de56$var$messages.debugger_menu_item
                                })
                            })
                        ]
                    }),
                    showPromptOverrideButton && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.075",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $40c78a8e52f40a1e$export$bfae871beaee7eb7), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...$4ffa81ac2d70de56$var$messages.prompt_override_menu_item
                                })
                            })
                        ]
                    }),
                    isArizeGateOn && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "center",
                                space: "space.075",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $4ffa81ac2d70de56$var$styles.checkboxWrapper,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                            isChecked: storeMessage,
                                            onChange: onStoreMessageChange,
                                            testId: "sain-store-message-checkbox"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...$4ffa81ac2d70de56$var$messages.store_message_label
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                paddingInlineStart: "space.400",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                    appearance: "default",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...$4ffa81ac2d70de56$var$messages.internal_lozenge
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}


const $470ec8ca325aaf2e$var$messages = (0, $cgtv4.defineMessages)({
    ai_content_disclaimer: {
        id: "search_ai.ai_content_disclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    ai_answer_component_copy_button: {
        id: "search_ai.ai_answer_component_copy_button",
        defaultMessage: "Copy"
    }
});
const $470ec8ca325aaf2e$var$copyIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: "copy"
    });
const $470ec8ca325aaf2e$var$styles = {
    heightWrapper: "_4t3i1tcg"
};
function $470ec8ca325aaf2e$export$7c1b08f310ac0a6a({ showFeedbackButtons: showFeedbackButtons, showCopyButton: showCopyButton, showAIUsageDisclaimer: showAIUsageDisclaimer = true, copyText: copyText, renderedContentRef: renderedContentRef }) {
    const { commonAttributes: commonAttributes, isAnswered: isAnswered } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { answerString: answerString } = commonAttributes;
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const isArizeGateOn = (0, $dh538.fg)('kd_sain_enable_arize_hello_only');
    const showOnlineDebuggerButton = isAnswered && (0, $dh538.fg)('kd_sain_online_debugger');
    const showPromptOverrideButton = (0, $dh538.fg)('convo_ai_sain_enable_prompt_override_hello_only');
    const hasMoreOptions = isAnswered && (isArizeGateOn || showPromptOverrideButton);
    const showOnlineDebuggerInline = showOnlineDebuggerButton && !hasMoreOptions;
    const onLinkClickHandler = (event)=>{
        event.stopPropagation();
    };
    const onLikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onLikeButtonClickHandler();
    };
    const onDislikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDislikeButtonClickHandler();
    };
    const onDeselectLikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDeselectLikeButtonClickHandler();
    };
    const onDeselectDislikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDeselectDislikeButtonClickHandler();
    };
    const onCopyButtonClickHandler = async (event)=>{
        event.stopPropagation();
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $4xTru.onAIAnswerCopyButtonClicked)(commonAttributes));
        if (copyText) await navigator.clipboard.writeText(copyText);
        else try {
            const node = renderedContentRef?.current;
            if (node) {
                const htmlBlob = new Blob([
                    node.innerHTML
                ], {
                    type: 'text/html'
                });
                const textBlob = new Blob([
                    answerString
                ], {
                    type: 'text/plain'
                });
                await navigator.clipboard.write([
                    new ClipboardItem({
                        'text/html': htmlBlob,
                        'text/plain': textBlob
                    })
                ]);
            } else await navigator.clipboard.writeText(answerString);
        } catch  {
            await navigator.clipboard.writeText(answerString);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "end",
        grow: "fill",
        spread: "space-between",
        xcss: $470ec8ca325aaf2e$var$styles.heightWrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.025",
                children: showAIUsageDisclaimer ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            size: "small",
                            spacing: "compact"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                appearance: "subtle",
                                href: (0, $f7lNm.ATLASSIAN_INTELLIGENCE_TRUST_LINK),
                                onClick: onLinkClickHandler,
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...$470ec8ca325aaf2e$var$messages.ai_content_disclaimer
                                })
                            })
                        })
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    showFeedbackButtons ? (0, $dh538.fg)('kd_sain_feedback_collector_ux_uplift_rollout') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $75319d601d9e2e47$export$41116a477d95163a), {
                        entrypointId: feedbackOptions.entrypointId,
                        userDetails: feedbackOptions.userDetails,
                        attributes: feedbackOptions.attributes,
                        attributesWithConsent: feedbackOptions.attributesWithConsent,
                        onLikeButtonClickHandler: onLikeButtonClickHandler,
                        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
                        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
                        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
                        onFeedbackSubmitHandler: feedbackOptions.onFeedbackSubmitHandler
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8s0lk.AIFeedbackV2), {
                        entrypointId: feedbackOptions.entrypointId,
                        userDetails: feedbackOptions.userDetails,
                        attributes: feedbackOptions.attributes,
                        attributesWithConsent: feedbackOptions.attributesWithConsent,
                        onLikeButtonClickHandler: onLikeButtonClickHandler,
                        onDislikeButtonClickHandler: onDislikeButtonClickHandler
                    }) : null,
                    showCopyButton ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: $470ec8ca325aaf2e$var$copyIcon,
                        label: formatMessage($470ec8ca325aaf2e$var$messages.ai_answer_component_copy_button),
                        onClick: onCopyButtonClickHandler,
                        appearance: "subtle",
                        isTooltipDisabled: false,
                        spacing: "compact",
                        shape: (0, $dh538.fg)('kd_sain_feedback_collector_ux_uplift_rollout') ? 'circle' : 'default',
                        testId: "copy-button"
                    }) : null,
                    showOnlineDebuggerInline && /*#__PURE__*/ (0, $l998X.jsx)((0, $jTYav.OnlineDebuggerButton), {}),
                    hasMoreOptions && /*#__PURE__*/ (0, $l998X.jsx)((0, $4ffa81ac2d70de56$export$fcbb8fd6209efbc6), {})
                ]
            })
        ]
    });
}
module.exports["AIDisclaimerAndFeedback"] = $470ec8ca325aaf2e$export$7c1b08f310ac0a6a;

});

parcelRegister("jLyYG", function(module, exports) {

var $4jIuc = parcelRequire("4jIuc");


var $cVtio = parcelRequire("cVtio");


var $f7lNm = parcelRequire("f7lNm");


var $eRXI0 = parcelRequire("eRXI0");


var $4xTru = parcelRequire("4xTru");

function $62c12b100a19433b$export$7cac3b748a811283() {
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, updateContextCache: updateContextCache, userDetails: userDetails } = (0, $eRXI0.useAIAnswerContext)();
    const { query: query, errorState: errorState, searchSessionId: searchSessionId, source: source, queryHash: queryHash, cloudId: cloudId, answerString: answerString, extraAttributes: extraAttributes } = commonAttributes;
    const { originalQuery: originalQuery } = extraAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const onLikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $4xTru.onLikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDislikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $4xTru.onDislikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDeselectLikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: undefined
        });
        fireAnalyticsEvent((0, $4xTru.onDeselectLikeButtonClick)(commonAttributes));
    };
    const onDeselectDislikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: undefined
        });
        fireAnalyticsEvent((0, $4xTru.onDeselectDislikeButtonClick)(commonAttributes));
    };
    const onFeedbackSubmitHandler = ({ liked: liked, feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact })=>{
        fireAnalyticsEvent((0, $4xTru.onFeedbackSubmit)({
            ...commonAttributes,
            feedbackSentiment: liked ? 'positive' : 'negative',
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        }));
    };
    const feedbackAttributes = {
        searchSessionId: searchSessionId,
        source: source,
        queryHash: queryHash,
        cloudId: cloudId,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState
    };
    const feedbackAttributesWithConsent = {
        transformedPrompt: query,
        originalPrompt: originalQuery,
        answer: answerString
    };
    const feedbackOptions = {
        attributes: feedbackAttributes,
        attributesWithConsent: feedbackAttributesWithConsent,
        entrypointId: (0, $f7lNm.FEEDBACK_ENTRYPOINT_ID_SAIN),
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
        onFeedbackSubmitHandler: onFeedbackSubmitHandler,
        userDetails: userDetails
    };
    return feedbackOptions;
}
module.exports["useSmartAnswerCardFeedbackOptions"] = $62c12b100a19433b$export$7cac3b748a811283;

});

parcelRegister("6yoZS", function(module, exports) {

let $4c594eef01830b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c594eef01830b0b$var$load("hhss7"),
    $4c594eef01830b0b$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("2oh9Z", function(module, exports) {

let $1bdb224b9705156a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bdb224b9705156a$var$load("6wr18"),
    $1bdb224b9705156a$var$load("ffEVr"),
    $1bdb224b9705156a$var$load("c4B8Z")
]).then(()=>parcelRequire('8JHkQ'));

});

parcelRegister("hPQo9", function(module, exports) {

let $cfbfd6613f33f018$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cfbfd6613f33f018$var$load("deebc"),
    $cfbfd6613f33f018$var$load("lb9xb")
]).then(()=>parcelRequire('54RS5'));

});

parcelRegister("kF5LJ", function(module, exports) {
/* smart-answer-card-body-generating.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $1Whri = parcelRequire("1Whri");


var $gj7hi = parcelRequire("gj7hi");


var $7hpmn = parcelRequire("7hpmn");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kpYGL = parcelRequire("kpYGL");


var $eRXI0 = parcelRequire("eRXI0");


var $lqjTE = parcelRequire("lqjTE");


var $4xTru = parcelRequire("4xTru");


var $cVtio = parcelRequire("cVtio");


var $59vy4 = parcelRequire("59vy4");


var $f7lNm = parcelRequire("f7lNm");


var $8AwZ3 = parcelRequire("8AwZ3");


var $iew5c = parcelRequire("iew5c");

const $d6829585d3fda9a7$var$styles = {
    containerNewSAINLoading: "_u5f3pxbi _19bvpxbi _ca0qpxbi _n3tdpxbi _4t3ibn52",
    inline: "_19bvu2gc _u5f3u2gc _n3tdu2gc _ca0qu2gc",
    inlineAnimation: "_1e0c116y _s7n4nkob",
    jiraNlToJqlCardHeightOverride: "_4t3iwigc",
    navigationalCardHeightOverride: "_4t3i1178",
    explicitQuestion: "_4t3i1edt",
    standardSAINHeightOverride: "_4t3i1ijo _ca0qze3t _19bvze3t _u5f3ze3t",
    luminaHeightOverride: "_4t3i1j89 _ca0qze3t _19bvze3t _u5f3ze3t"
};
function $d6829585d3fda9a7$export$950bbac928c95aa6({ heightOverride: heightOverride, queryIntent: queryIntent }) {
    const { commonAttributes: commonAttributes, queryReasoning: queryReasoning } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)(); // TODO: Temporary function for TEAMEU - normalize reasoning strings by lowercasing first letter and removing trailing periods
    const normalizeReasoningString = (str)=>{
        if (!str) return str;
        let result = `${str.charAt(0).toLowerCase()}${str.slice(1)}`; // Remove trailing period if it exists
        if (result.endsWith('.')) result = result.slice(0, -1);
        return result;
    };
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: (0, $1Whri.cx)($d6829585d3fda9a7$var$styles.containerNewSAINLoading, heightOverride === 'jiraNlToJqlCard' && $d6829585d3fda9a7$var$styles.jiraNlToJqlCardHeightOverride, heightOverride === 'navigationalCard' && $d6829585d3fda9a7$var$styles.navigationalCardHeightOverride, !heightOverride && (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && $d6829585d3fda9a7$var$styles.standardSAINHeightOverride, heightOverride === 'lumina' && (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && $d6829585d3fda9a7$var$styles.luminaHeightOverride, queryIntent === (0, $f7lNm.QueryIntent).EXPLICIT_QUESTION && $d6829585d3fda9a7$var$styles.explicitQuestion),
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: 'space.100',
                xcss: $d6829585d3fda9a7$var$styles.inline,
                alignBlock: "start",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($iew5c))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                        color: 'color.text.subtle',
                        children: [
                            queryReasoning ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $8AwZ3.messages).smart_answer_card_rovo_generating,
                                values: {
                                    queryReasoning: normalizeReasoningString(queryReasoning)
                                }
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $8AwZ3.messages).smart_answer_card_rovo_is_thinking
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "span",
                                xcss: $d6829585d3fda9a7$var$styles.inlineAnimation,
                                children: isReducedMotion ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lqjTE.ReducedMotionRovoGeneratingAnimation), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lqjTE.RovoGeneratingAnimation), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                width: "100%",
                height: "16px",
                color: "var(--ds-skeleton-subtle, #17171708)",
                borderRadius: '6px'
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                width: "100%",
                height: "16px",
                color: "var(--ds-skeleton-subtle, #17171708)",
                borderRadius: '6px'
            }),
            (0, $59vy4.SAINFeatureControl).isLuminaEnabled() ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                width: "75%",
                height: "16px",
                color: "var(--ds-skeleton-subtle, #17171708)",
                borderRadius: '6px'
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                width: "90%",
                height: "16px",
                color: "var(--ds-skeleton-subtle, #17171708)",
                borderRadius: '6px'
            }),
            heightOverride === 'lumina' && (0, $59vy4.SAINFeatureControl).isLuminaEnabled() && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "256px",
                        height: "166px",
                        color: "var(--ds-skeleton-subtle, #17171708)",
                        borderRadius: '6px'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "256px",
                        height: "166px",
                        color: "var(--ds-skeleton-subtle, #17171708)",
                        borderRadius: '6px'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "256px",
                        height: "166px",
                        color: "var(--ds-skeleton-subtle, #17171708)",
                        borderRadius: '6px'
                    })
                ]
            })
        ]
    });
}
module.exports["SmartAnswerCardBodyGenerating"] = $d6829585d3fda9a7$export$950bbac928c95aa6;

});

parcelRegister("gt6aY", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $eXmBZ = parcelRequire("eXmBZ");


var $2Nwuj = parcelRequire("2Nwuj");


var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");


var $3gadb = parcelRequire("3gadb");


var $fYQcF = parcelRequire("fYQcF");


var $eRXI0 = parcelRequire("eRXI0");


var $4xTru = parcelRequire("4xTru");


var $4jIuc = parcelRequire("4jIuc");


var $cVtio = parcelRequire("cVtio");


var $9QyHN = parcelRequire("9QyHN");


var $f7lNm = parcelRequire("f7lNm");


var $fJBWn = parcelRequire("fJBWn");


var $gUXWz = parcelRequire("gUXWz");


var $ckCUa = parcelRequire("ckCUa");


var $01aV7 = parcelRequire("01aV7");


var $9lp28 = parcelRequire("9lp28");

/* separator-line.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $c02b6ab90219fd1b$var$styles = {
    line: "_4t3it94y _1bsb1osq _bfhk18j9"
};
const $c02b6ab90219fd1b$export$8be205ba9c2e6f62 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $c02b6ab90219fd1b$var$styles.line
    });



var $df7ed = parcelRequire("df7ed");

const $df2bb866570ca03f$var$messages = (0, $cgtv4.defineMessages)({
    topic_knowledge_card_why_tooltip: {
        id: "search_ai.topic_knowledge_card.why_tooltip",
        defaultMessage: "We think your search might be related to {topicName}"
    },
    topic_knowledge_card_people_heading: {
        id: "search_ai.topic_knowledge_card.people_heading",
        defaultMessage: "People"
    },
    topic_knowledge_card_people_view_all_cta: {
        id: "search_ai.topic_knowledge_card.people_view_all_cta",
        defaultMessage: "View all"
    }
});
const $df2bb866570ca03f$export$559a249c395cc3e2 = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, brand: brand, cloudId: cloudId, query: query, searchSessionId: searchSessionId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { tenantContext: { cloudUrl: cloudUrl } } = (0, $9QyHN.useTenantContext)(cloudId);
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $01aV7.sha256Hash)(query),
            brand: brand,
            source: 'topic_knowledge_card',
            query: query,
            answerString: answerString,
            answerCardType: (0, $f7lNm.AnswerCardType).TOPIC
        }), [
        searchSessionId,
        query,
        brand,
        answerString
    ]);
    (0, $42omo.useEffect)(()=>{
        onFMPReached?.();
        trackAIInteractionInit();
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $4xTru.onNonGenerativeAIAnswerResultShown)(analyticsAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleTopicClick = ()=>{
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).TOPIC_KNOWLEDGE_CARD_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $fJBWn.onNonGenerativeKnowledgeCardLinkClick)(analyticsAttributes));
    };
    const topicData = JSON.parse(answerString);
    const relatedUsers = topicData.users;
    const topicUrl = cloudUrl ? `${cloudUrl}/wiki/topics/${topicData.topic.id}` : '';
    const getUserUrl = (userId)=>{
        return cloudUrl ? `${cloudUrl}/wiki/people/${userId}` : '';
    };
    // if reached here, this means we query intent as topic
    // but topic query did not find topic for id returned by query intent
    if (topicData.topic.message) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $df7ed.KnowledgeCard), {
        name: "smart-answers-topic-knowledge-card",
        size: "full",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.150",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    alignBlock: "center",
                    space: "space.075",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            href: topicUrl,
                            appearance: "subtle",
                            onClick: handleTopicClick,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "large",
                                color: "color.link",
                                weight: "semibold",
                                children: topicData.topic.name
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                            content: formatMessage($df2bb866570ca03f$var$messages.topic_knowledge_card_why_tooltip, {
                                topicName: topicData.topic.name
                            }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                                label: "",
                                size: "small",
                                color: "var(--ds-text-subtlest, #6B6E76)"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    color: "color.text.subtle",
                    children: topicData.topic.description
                }),
                relatedUsers.nodes && relatedUsers.nodes.length > 0 && /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $c02b6ab90219fd1b$export$8be205ba9c2e6f62), {}),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            spread: "space-between",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    as: "h6",
                                    size: "small",
                                    children: formatMessage($df2bb866570ca03f$var$messages.topic_knowledge_card_people_heading)
                                }),
                                relatedUsers.nodes.length > 4 && /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: topicUrl,
                                    appearance: "subtle",
                                    onClick: handleTopicClick,
                                    testId: "view-all-people-cta",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: formatMessage($df2bb866570ca03f$var$messages.topic_knowledge_card_people_view_all_cta)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
                            templateColumns: "1fr 1fr",
                            gap: "space.100",
                            children: relatedUsers.nodes.slice(0, 4).map(({ user: user })=>user && /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: getUserUrl(user.accountId),
                                    appearance: "subtle",
                                    testId: "topic-person-row",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gUXWz.KnowledgeCardsRow), {
                                        primaryText: user.name,
                                        secondaryText: user.extendedProfile?.jobTitle ?? '',
                                        pictureUrl: user.picture,
                                        type: (0, $ckCUa.KnowledgeCardsRowType).PERSON
                                    })
                                }, user.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                    showFeedbackButtons: true
                })
            ]
        })
    });
};
module.exports["TopicKnowledgeCard"] = $df2bb866570ca03f$export$559a249c395cc3e2;

});

parcelRegister("fJBWn", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");

const $0ef9710cd4578c20$export$44d9aa4134474084 = (props)=>{
    const { source: source, cardType: cardType } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            cardType: cardType
        }
    };
};
const $0ef9710cd4578c20$export$63a5aef02e499ea6 = (props)=>{
    const { source: source, location: location, position: position, shownAfterCardBodyExpanded: shownAfterCardBodyExpanded } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            location: location,
            position: position,
            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
        }
    };
};
const $0ef9710cd4578c20$export$89dd6b6e370100a2 = (props)=>{
    const { answerString: answerString, brand: brand, query: query, queryHash: queryHash, searchSessionId: searchSessionId, source: source, targetMarker: targetMarker, answerCardType: answerCardType, location: location } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            brand: brand,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            targetMarker: targetMarker,
            location: location,
            answerCardType: answerCardType
        },
        nonPrivacySafeAttributes: {
            answerString: answerString,
            query: query
        }
    };
};
const $0ef9710cd4578c20$export$6266151addd8e413 = (props)=>{
    const { source: source, agentCount: agentCount } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAgentKnowledgeCardCarousel',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            agentCount: agentCount
        }
    };
};
const $0ef9710cd4578c20$export$885a78bb6bce677d = (props)=>{
    const { source: source, agentId: agentId, position: position } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAgentKnowledgeCardCarousel',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            agentId: agentId,
            position: position
        }
    };
};
const $0ef9710cd4578c20$export$4ce3543705832c97 = (props)=>{
    const { source: source, agentId: agentId } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAgentKnowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            agentId: agentId
        }
    };
};
const $0ef9710cd4578c20$export$4dea9d9ba0f4fd15 = (props)=>{
    const { source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'personCardOrgChartModal',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    };
};
const $0ef9710cd4578c20$export$c275ac680f034541 = (props)=>{
    const { source: source } = props;
    return {
        action: 'dwelled',
        actionSubject: 'personCardOrgChartModal',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    };
};
const $0ef9710cd4578c20$export$3014182e23d6ae90 = (props)=>{
    const { source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'personCardOrgChartCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    };
};
module.exports["onKnowledgeCardShown"] = $0ef9710cd4578c20$export$44d9aa4134474084;
module.exports["onKnowledgeCardLinkClick"] = $0ef9710cd4578c20$export$63a5aef02e499ea6;
module.exports["onNonGenerativeKnowledgeCardLinkClick"] = $0ef9710cd4578c20$export$89dd6b6e370100a2;
module.exports["onAgentKnowledgeCardCarouselShown"] = $0ef9710cd4578c20$export$6266151addd8e413;
module.exports["onAgentKnowledgeCardCarouselItemClick"] = $0ef9710cd4578c20$export$885a78bb6bce677d;
module.exports["onIndividualAgentKnowledgeCardShown"] = $0ef9710cd4578c20$export$4ce3543705832c97;
module.exports["onPersonCardOrgChartShown"] = $0ef9710cd4578c20$export$4dea9d9ba0f4fd15;
module.exports["onPersonCardOrgChartDwelled"] = $0ef9710cd4578c20$export$c275ac680f034541;
module.exports["onPersonCardOrgChartCardClicked"] = $0ef9710cd4578c20$export$3014182e23d6ae90;

});

parcelRegister("ckCUa", function(module, exports) {
var $06be783e8a38a786$export$ba9062c439fa44bc = /*#__PURE__*/ function(KnowledgeCardsIntentType) {
    KnowledgeCardsIntentType["PERSON"] = "PERSON";
    KnowledgeCardsIntentType["TEAM"] = "TEAM";
    KnowledgeCardsIntentType["AGENT"] = "AGENT";
    return KnowledgeCardsIntentType;
}({});
var $06be783e8a38a786$export$f6d5eb0487369ad6 = /*#__PURE__*/ function(KnowledgeCardsRowType) {
    KnowledgeCardsRowType["PERSON"] = "PERSON";
    KnowledgeCardsRowType["WORK"] = "WORK";
    KnowledgeCardsRowType["AGENT"] = "AGENT";
    return KnowledgeCardsRowType;
}({});
module.exports["KnowledgeCardsIntentType"] = $06be783e8a38a786$export$ba9062c439fa44bc;
module.exports["KnowledgeCardsRowType"] = $06be783e8a38a786$export$f6d5eb0487369ad6;

});

parcelRegister("df7ed", function(module, exports) {
/* KnowledgeCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $hnvzE = parcelRequire("hnvzE");

const $cdd630add952c875$var$knowledgeCardStyles = {
    default: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
    compact: "_ca0qutpp _u5f3utpp _19bvutpp _n3tdutpp",
    full: "_ca0qpxbi _u5f3pxbi _19bvpxbi _n3tdpxbi"
};
const $cdd630add952c875$var$defaultInlineProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.050'
};
const $cdd630add952c875$export$ab2444a256fc8a9b = ({ name: name, size: size, children: children, containerStyles: containerStyles, ...inlineProps })=>{
    const knowledgeCardProps = {
        ...$cdd630add952c875$var$defaultInlineProps,
        ...inlineProps
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: name,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "section",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                ...knowledgeCardProps,
                xcss: containerStyles ?? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $1Whri.cx)($cdd630add952c875$var$knowledgeCardStyles.default, size === 'full' ? $cdd630add952c875$var$knowledgeCardStyles.full : $cdd630add952c875$var$knowledgeCardStyles.compact),
                children: children
            })
        })
    });
};
module.exports["KnowledgeCard"] = $cdd630add952c875$export$ab2444a256fc8a9b;

});

parcelRegister("fid2I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $ay6Zz = parcelRequire("ay6Zz");


var $fDXXi = parcelRequire("fDXXi");


var $3H8bj = parcelRequire("3H8bj");











var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");




const $c5d687266db499bd$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const [profileData, setProfileData] = (0, $42omo.useState)();
    const getProfileData = async ()=>{
        setIsLoading(true);
        try {
            const profileData = await fetchUserProfile?.();
            setProfileData(profileData);
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    };
    return {
        profileData: profileData,
        isLoading: isLoading,
        error: error,
        getProfileData: getProfileData
    };
};



var $8nlrk = parcelRequire("8nlrk");







const $5e63c4f6f09cc793$var$PopupTriggerInner = ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const onKeyPress = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showProfilecard();
        }
    }, [
        showProfilecard
    ]);
    const onClick = (0, $42omo.useCallback)((event)=>{
        // Prevent the click event from propagating to parent containers.
        event.stopPropagation();
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $42omo.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props,
        ...containerListeners,
        ref: ref,
        "aria-labelledby": ariaLabelledBy,
        children: children
    });
};
const $5e63c4f6f09cc793$export$95d4acdbab2fc6ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef($5e63c4f6f09cc793$var$PopupTriggerInner);


/* ProfileCardWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $98c6b3cc3dd56ce8$var$styles = {
    wrapper: "_1bsb1gwv"
};
const $98c6b3cc3dd56ce8$export$59abd6feb7dc8540 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $98c6b3cc3dd56ce8$var$styles.wrapper,
        testId: testId,
        children: children
    });
};


const $2976a306533d0f4b$var$DELAY_MS_SHOW = 800;
const $2976a306533d0f4b$var$DELAY_MS_HIDE = 200;
function $2976a306533d0f4b$var$ProfileCardTriggerInner({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, testId: testId, fireAnalytics: fireAnalytics, fireAnalyticsNext: fireAnalyticsNext, ...popupProps }, ref) {
    const showDelay = trigger === 'click' ? 0 : $2976a306533d0f4b$var$DELAY_MS_SHOW;
    const hideDelay = trigger === 'click' ? 0 : $2976a306533d0f4b$var$DELAY_MS_HIDE;
    const showTimer = (0, $42omo.useRef)(0);
    const hideTimer = (0, $42omo.useRef)(0);
    const [visible, setVisible] = (0, $42omo.useState)(false);
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $c5d687266db499bd$export$6cace87f7d7a9738)({
        fetchUserProfile: fetchProfile
    });
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    const hideProfilecard = (0, $42omo.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
        }, hideDelay);
    }, [
        hideDelay
    ]);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            hideProfilecard: hideProfilecard
        }), [
        hideProfilecard
    ]);
    const showProfilecard = (0, $42omo.useCallback)(async ()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                getProfileData?.();
                setVisible(true);
                if ((0, $dh538.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (fireAnalyticsNext) fireAnalyticsNext(`ui.${(0, $bUp2E.getActionSubject)(profileCardType)}.triggered`, {
                        method: trigger,
                        ...(0, $bUp2E.PACKAGE_META_DATA),
                        firedAt: Math.round((0, $caPHA.getPageTime)())
                    });
                } else if (fireAnalytics) fireAnalytics((0, $bUp2E.cardTriggered)(profileCardType, trigger));
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        getProfileData,
        fireAnalytics,
        profileCardType,
        trigger,
        fireAnalyticsNext
    ]);
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        ...popupProps,
        isOpen: !!visible,
        onClose: hideProfilecard,
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: popupProps.autoFocus ?? trigger === 'click',
        zIndex: (0, $dTk3A.layers).modal(),
        shouldFitContainer: false,
        trigger: (triggerProps)=>{
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $5e63c4f6f09cc793$export$95d4acdbab2fc6ef), {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ref: triggerProps.ref,
                hideProfilecard: hideProfilecard,
                showProfilecard: showProfilecard,
                children: children,
                ariaLabelledBy: ariaLabelledBy,
                trigger: trigger,
                "data-testid": testId
            });
        },
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                onMouseEnter: onMouseEnter,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard,
                "data-testid": "profile-card--trigger-content",
                children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $98c6b3cc3dd56ce8$export$59abd6feb7dc8540), {
                    testId: "profilecard.profilecardtrigger.loading",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8nlrk.LoadingState), {
                        fireAnalytics: fireAnalyticsNext,
                        profileType: profileCardType
                    })
                }) : renderProfileCard({
                    profileData: profileData,
                    error: error
                })
            })
    });
}
const $2976a306533d0f4b$var$ProfileCardTrigger = /*#__PURE__*/ (0, $42omo.forwardRef)($2976a306533d0f4b$var$ProfileCardTriggerInner);
var $2976a306533d0f4b$export$2e2bcd8739ae039 = $2976a306533d0f4b$var$ProfileCardTrigger;



var $joVWg = parcelRequire("joVWg");

const $85101be166a0301f$export$64983741fea6a45d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ ...props }, ref)=>{
    const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId } = props;
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    /**
		 * @TODO replace with `getAgentCreator` from `@atlassian/rovo-agent-components`
		 * @deprecated use `getAgentCreator` from `@atlassian/rovo-agent-components`
		 */ const getCreator = async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'FORGE':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                const userId = (0, $3H8bj.getAAIDFromARI)(creator) || '';
                try {
                    if (!userId || !cloudId) return undefined;
                    if (authoringTeam) return {
                        type: 'CUSTOMER',
                        name: authoringTeam.displayName ?? '',
                        profileLink: authoringTeam.profileUrl ?? ''
                    };
                    const { href: profileHref } = (0, $ay6Zz.navigateToTeamsApp)({
                        type: 'USER',
                        payload: {
                            userId: userId
                        },
                        cloudId: cloudId
                    });
                    const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireEvent);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${userId}`,
                        id: userId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    };
    const fetchAgentProfile = async ()=>{
        const agentProfileResult = await resourceClient.getRovoAgentProfile({
            type: 'agent',
            value: userId
        }, fireEvent);
        const agentInfo = agentProfileResult.restData;
        const agentCreatorInfo = await getCreator({
            creator_type: agentInfo.creator_type,
            creator: agentInfo.creator || undefined,
            authoringTeam: agentProfileResult.aggData?.authoringTeam ?? undefined
        });
        return {
            ...agentInfo,
            creatorInfo: agentCreatorInfo
        };
    };
    const renderProfileCard = ({ profileData: profileData, error: error })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $joVWg.AgentProfileCardLazy), {
                agent: profileData,
                hasError: !!error,
                cloudId: props.cloudId,
                errorType: error,
                onChatClick: props.onChatClick,
                onConversationStartersClick: props.onConversationStartersClick,
                resourceClient: props.resourceClient,
                onDeleteAgent: props.onDeleteAgent,
                addFlag: props.addFlag
            })
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2976a306533d0f4b$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        trigger: "hover",
        renderProfileCard: renderProfileCard,
        fetchProfile: fetchAgentProfile,
        fireAnalyticsNext: fireEvent,
        profileCardType: "agent"
    });
});
module.exports["AgentProfileCardTrigger"] = $85101be166a0301f$export$64983741fea6a45d;

});

parcelRegister("fcHIm", function(module, exports) {

let $b119e2ce0becde8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b119e2ce0becde8c$var$load("ht5OT"),
    $b119e2ce0becde8c$var$load("sj9Xz"),
    $b119e2ce0becde8c$var$load("hv4mn"),
    $b119e2ce0becde8c$var$load("dYtBN"),
    $b119e2ce0becde8c$var$load("6wr18"),
    $b119e2ce0becde8c$var$load("kjZZD"),
    $b119e2ce0becde8c$var$load("ffEVr"),
    $b119e2ce0becde8c$var$load("dTsOE"),
    $b119e2ce0becde8c$var$load("hhss7"),
    $b119e2ce0becde8c$var$load("3QIea"),
    $b119e2ce0becde8c$var$load("k0nPy"),
    $b119e2ce0becde8c$var$load("EfTik")
]).then(()=>parcelRequire('1JhVb'));

});

parcelRegister("6aPlH", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ay6Zz = parcelRequire("ay6Zz");


var $ckCUa = parcelRequire("ckCUa");

const $3f11fc057a81a32a$export$cf6047b656d24746 = (props)=>{
    const { cloudId: cloudId, currentUserId: currentUserId, viewAllUrl: viewAllUrl } = props;
    const backupViewAllUrl = `https://hello.atlassian.net/people/${currentUserId}/work`;
    const { href: profileWorkList, onNavigate: profileWorkListOnNavigate } = (0, $ay6Zz.navigateToTeamsApp)(props.type === (0, $ckCUa.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER_WORK',
        payload: {
            userId: currentUserId || ''
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const { href: worksWithHref, onNavigate: worksWithOnNavigate } = (0, $ay6Zz.navigateToTeamsApp)(props.type === (0, $ckCUa.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER',
        payload: {
            userId: currentUserId || '',
            section: 'workswith'
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const { href: profileHref, onNavigate: profileOnNavigate } = (0, $ay6Zz.navigateToTeamsApp)(props.type === (0, $ckCUa.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER',
        payload: {
            userId: currentUserId || ''
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const toUser = (userId)=>(0, $ay6Zz.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            },
            cloudId: cloudId
        });
    const viewAllLink = (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileWorkList : viewAllUrl || backupViewAllUrl;
    return {
        viewAllLink: viewAllLink,
        viewAllOnNavigate: profileWorkListOnNavigate,
        worksWithHref: worksWithHref,
        worksWithOnNavigate: worksWithOnNavigate,
        profileHref: profileHref,
        profileOnNavigate: profileOnNavigate,
        toUser: toUser
    };
};
module.exports["useTeamsAppLinks"] = $3f11fc057a81a32a$export$cf6047b656d24746;

});

parcelRegister("4lrdQ", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");

async function $6cb082cfb14beb2a$export$ebe243ab960e089b({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchRestResponse"] = $6cb082cfb14beb2a$export$ebe243ab960e089b;

});

parcelRegister("iAOL9", function(module, exports) {

let $d892f68f3bd1972f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d892f68f3bd1972f$var$load("6PtxN").then(()=>parcelRequire('9cUZf'));

});

parcelRegister("fpuOJ", function(module, exports) {

let $b381187dc30c069f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b381187dc30c069f$var$load("8RKtn").then(()=>parcelRequire('cS5ft'));

});

parcelRegister("hIWnD", function(module, exports) {

let $ce73d4d378dc6ba0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce73d4d378dc6ba0$var$load("fCIoO").then(()=>parcelRequire('l3Frt'));

});

parcelRegister("kowUg", function(module, exports) {

let $ed8f9314d3c0fcb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed8f9314d3c0fcb1$var$load("1geBW").then(()=>parcelRequire('9pPbe'));

});

parcelRegister("ec87V", function(module, exports) {

let $a5587d7c667036f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5587d7c667036f6$var$load("5WU5D").then(()=>parcelRequire('70wEJ'));

});

parcelRegister("crPsa", function(module, exports) {

let $90ffeb32a10fd11e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90ffeb32a10fd11e$var$load("i1Uow").then(()=>parcelRequire('ens8B'));

});

parcelRegister("1g9BR", function(module, exports) {

let $0eaebd51f6ef80f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0eaebd51f6ef80f4$var$load("3ZuKT").then(()=>parcelRequire('lTWYv'));

});

parcelRegister("liDh5", function(module, exports) {

let $f819be81021b23f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f819be81021b23f1$var$load("5nJlY").then(()=>parcelRequire('httMJ'));

});

parcelRegister("fhixu", function(module, exports) {

let $b1f6d30ac3bc6f1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1f6d30ac3bc6f1c$var$load("Uq5C2").then(()=>parcelRequire('cJNTM'));

});

parcelRegister("gspOw", function(module, exports) {

let $bfb348f335a868d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfb348f335a868d8$var$load("9TzAL").then(()=>parcelRequire('kwZvX'));

});

parcelRegister("gS2lk", function(module, exports) {

let $c48381c361792028$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c48381c361792028$var$load("oPAjm").then(()=>parcelRequire('3VJvn'));

});

parcelRegister("2et3H", function(module, exports) {

let $1a036e03a53adafc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a036e03a53adafc$var$load("3fvcK").then(()=>parcelRequire('h3moD'));

});

parcelRegister("6hthv", function(module, exports) {

let $492b0b4c67cc7041$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $492b0b4c67cc7041$var$load("iMYDs").then(()=>parcelRequire('jvfqc'));

});

parcelRegister("f7DsF", function(module, exports) {

let $b0261ea60ceebbcc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0261ea60ceebbcc$var$load("jPHqC").then(()=>parcelRequire('jSIPf'));

});

parcelRegister("ktyEo", function(module, exports) {

let $ee8164f4f688db50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee8164f4f688db50$var$load("3saM6").then(()=>parcelRequire('7zudc'));

});

parcelRegister("ePgIY", function(module, exports) {

let $acb2cd3a971987ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $acb2cd3a971987ec$var$load("4hCdo").then(()=>parcelRequire('hhvtx'));

});

parcelRegister("2WnrZ", function(module, exports) {

let $2243305465912713$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2243305465912713$var$load("78gs3").then(()=>parcelRequire('dTaKK'));

});

parcelRegister("elRti", function(module, exports) {

let $a72c813168189fc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a72c813168189fc7$var$load("2XhMA").then(()=>parcelRequire('85LXv'));

});

parcelRegister("2MpFd", function(module, exports) {

let $2063f8bf23663cd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2063f8bf23663cd0$var$load("f7Egw").then(()=>parcelRequire('lvHbY'));

});

parcelRegister("2IhrR", function(module, exports) {

let $1f9d39b7f09507b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f9d39b7f09507b3$var$load("aiZUj").then(()=>parcelRequire('fXIaw'));

});

parcelRegister("hPKNs", function(module, exports) {

let $cfbb7ff5fe7d88da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfbb7ff5fe7d88da$var$load("6rH3p").then(()=>parcelRequire('eOYcj'));

});

parcelRegister("cu72h", function(module, exports) {

let $916dbe8ef7527020$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $916dbe8ef7527020$var$load("lS1VG").then(()=>parcelRequire('9Em42'));

});

parcelRegister("b4dj1", function(module, exports) {

let $80ea63b57c81192c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80ea63b57c81192c$var$load("fFbe4").then(()=>parcelRequire('724Re'));

});

parcelRegister("edFdS", function(module, exports) {

let $a5a241903c01a478$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5a241903c01a478$var$load("7JTjB").then(()=>parcelRequire('5AG9d'));

});

parcelRegister("gNPDA", function(module, exports) {

let $c3b9471185cbe7fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3b9471185cbe7fb$var$load("dMjyc").then(()=>parcelRequire('9G0tf'));

});

parcelRegister("gdXLD", function(module, exports) {

let $bcfc38c4f0033efd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcfc38c4f0033efd$var$load("iraZ1").then(()=>parcelRequire('5VIW2'));

});

parcelRegister("ehPkL", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $1bY7o = parcelRequire("1bY7o");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");




parcelRequire("42omo");

function $ddfac4772597e4fc$export$600af2172b0f5fb() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-19.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $9feb222af1dce22a$export$be8cba599441db6e() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5802 7.40457L9.75898 12.1789L12.7683 17.2427C12.7871 17.2812 12.7965 17.3198 12.7871 17.3584C12.7777 17.397 12.7401 17.368 12.6836 17.3777H10.5301C10.3796 17.3777 10.2762 17.368 10.2104 17.2716C10.0129 16.8665 9.806 16.471 9.60851 16.0659C9.41103 15.6705 9.19473 15.2654 8.96903 14.8507C8.74334 14.4359 8.51764 14.0212 8.29194 13.5968H8.27313C8.07565 14.0115 7.85935 14.4263 7.64306 14.841C7.42677 15.2558 7.21047 15.6705 7.00359 16.0756C6.78729 16.4807 6.571 16.8954 6.3547 17.2909C6.31709 17.3873 6.24186 17.397 6.13841 17.397H4.06952C4.0319 17.397 4.00369 17.4163 4.00369 17.368C3.99429 17.3295 4.00369 17.2909 4.0225 17.262L6.94716 12.3429L4.09773 7.39492C4.06952 7.35634 4.06011 7.31776 4.07892 7.29847C4.09773 7.26953 4.13535 7.25989 4.17296 7.25989H6.30768C6.3547 7.25989 6.40173 7.26953 6.43934 7.27918C6.47696 7.29847 6.50517 7.3274 6.53338 7.36598C6.71206 7.78073 6.91895 8.19547 7.13524 8.61021C7.36094 9.02496 7.57723 9.43006 7.81233 9.83515C8.03803 10.2403 8.24492 10.6453 8.44241 11.0601H8.46122C8.6587 10.6357 8.86559 10.221 9.07248 9.81586C9.27937 9.41077 9.49566 9.00567 9.71196 8.60057C9.92825 8.19547 10.1351 7.78073 10.342 7.38528C10.3514 7.34669 10.3702 7.30811 10.3985 7.28882C10.4361 7.26953 10.4737 7.25989 10.5207 7.26953H12.505C12.552 7.25989 12.599 7.28882 12.6084 7.33705C12.6178 7.34669 12.599 7.38528 12.5802 7.40457Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.9248 17.5803C16.2289 17.5899 15.533 17.4453 14.9029 17.1463C14.3105 16.8666 13.8215 16.4036 13.4829 15.8345C13.135 15.2462 12.9657 14.5131 12.9657 13.6354C12.9563 12.9217 13.135 12.2176 13.4829 11.6003C13.8403 10.9733 14.3575 10.4525 14.9782 10.1053C15.6364 9.72911 16.4264 9.54585 17.3574 9.54585C17.4044 9.54585 17.4702 9.54585 17.5549 9.5555C17.711 9.5733 17.8464 9.43978 17.8464 9.28259V6.52691C17.8464 6.45939 17.8746 6.42081 17.9404 6.42081H19.791C19.8299 6.42081 19.873 6.41051 19.9052 6.43245C19.9189 6.44186 19.9299 6.45544 19.937 6.4702C19.9425 6.48177 19.9435 6.50762 19.9435 6.50762C19.9435 6.50762 19.9435 6.50762 19.9435 6.50762V15.6898C19.9435 15.8635 19.9529 16.0564 19.9623 16.2686C19.9811 16.4711 19.9905 16.664 19.9999 16.828C19.9999 16.8955 19.9717 16.9534 19.9059 16.9823C19.4169 17.1945 18.8996 17.3488 18.373 17.4453C17.8934 17.5321 17.4138 17.5803 16.9248 17.5803ZM17.5438 15.7015C17.7293 15.7077 17.8464 15.5265 17.8464 15.3409V11.666C17.8464 11.5147 17.7428 11.3763 17.5925 11.3591C17.489 11.3495 17.3856 11.3399 17.2821 11.3399C16.9154 11.3399 16.5486 11.417 16.2195 11.5906C15.8998 11.7546 15.627 11.9957 15.4201 12.3044C15.2133 12.613 15.1098 13.0278 15.1098 13.5293C15.1004 13.8669 15.1568 14.2045 15.2697 14.5228C15.3637 14.7832 15.5048 15.0147 15.6929 15.2076C15.8715 15.3812 16.0878 15.5162 16.3323 15.5934C16.5862 15.6802 16.8496 15.7188 17.1129 15.7188C17.2409 15.7188 17.3612 15.7108 17.4737 15.7022C17.4964 15.7004 17.521 15.7007 17.5438 15.7015Z",
                fill: "#FF61F6"
            })
        ]
    });
}





parcelRequire("42omo");

function $ddb96d62bbe64059$export$f28fe6c5ebff8c30() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.5114 14.3589C13.4961 13.9874 13.4858 13.6157 13.4829 13.2439C13.4806 12.9476 13.4822 12.6512 13.4798 12.3549C13.4779 12.1238 13.4776 11.8926 13.4483 11.6628C13.4314 11.5303 13.4041 11.4003 13.3459 11.2789C13.2429 11.0639 13.0729 10.9187 12.8595 10.8216C12.562 10.6863 12.2524 10.6769 11.9374 10.742C11.6833 10.7945 11.4482 10.8957 11.2248 11.0259C11.1582 11.0647 11.0935 11.1066 11.0248 11.1522C11.0248 11.139 11.0248 11.1317 11.0248 11.1242C11.024 10.9117 11.0232 10.6993 11.0223 10.4868C11.0205 10.0525 11.0181 9.61825 11.0083 9.18407C11.0075 9.14589 11.0068 9.1076 11.003 9.06965C10.9985 9.02436 10.9605 8.99346 10.9209 9.00118C10.7482 9.03488 10.5756 9.06898 10.403 9.10296C10.182 9.14651 9.96017 9.18597 9.73703 9.21771C9.63006 9.23294 9.52302 9.24761 9.41605 9.26266C9.40776 9.26384 9.39813 9.26496 9.39433 9.27313C9.38968 9.28299 9.39892 9.28864 9.4053 9.29306C9.41476 9.29956 9.4137 9.30885 9.41498 9.31786C9.43737 9.47365 9.45467 9.63006 9.46883 9.7868C9.49083 10.0299 9.5041 10.2737 9.51339 10.5176C9.52722 10.8799 9.53366 11.2423 9.53607 11.6048C9.54323 12.6756 9.53573 13.7464 9.52577 14.8172C9.52515 14.8822 9.54228 14.8991 9.60722 14.8982C9.9839 14.8933 10.3605 14.8882 10.7372 14.8834C10.8454 14.882 10.9536 14.8819 11.0617 14.88C11.1067 14.8793 11.1419 14.8617 11.1375 14.803C11.1263 14.6534 11.1212 14.5034 11.1135 14.3536C11.0966 14.0279 11.0824 13.7021 11.0754 13.376C11.0725 13.24 11.0686 13.104 11.0675 12.968C11.065 12.6502 11.064 12.3324 11.0619 12.0146C11.0618 12.0001 11.0668 11.9933 11.0802 11.9881C11.1314 11.9683 11.1821 11.9472 11.233 11.9266C11.3449 11.8813 11.4598 11.8553 11.582 11.8677C11.6869 11.8784 11.7678 11.9237 11.8182 12.0183C11.8354 12.0504 11.8491 12.0839 11.8596 12.1188C11.9079 12.2798 11.9208 12.4461 11.9309 12.6124C11.9449 12.8432 11.9481 13.0743 11.9491 13.3054C11.9514 13.8152 11.9454 14.3249 11.943 14.8346C11.9427 14.8967 11.9627 14.9166 12.025 14.9164C12.2432 14.9154 12.4613 14.9063 12.6794 14.9013C12.7968 14.8986 12.9143 14.8968 13.0318 14.9015C13.1743 14.9071 13.3167 14.9164 13.4594 14.9164C13.5133 14.9164 13.5378 14.89 13.5351 14.8365C13.527 14.6775 13.5179 14.5184 13.5113 14.3592L13.5114 14.3589Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.9366 9.01969C19.8949 9.01381 19.8552 9.02663 19.8151 9.03307C19.5797 9.07063 19.3445 9.10948 19.1092 9.14766C18.8849 9.18405 18.6607 9.22071 18.4363 9.25626C18.3593 9.26846 18.3278 9.30709 18.335 9.3844C18.3477 9.52166 18.3605 9.65887 18.372 9.79624C18.3901 10.0134 18.4071 10.2308 18.4246 10.448C18.4441 10.6912 18.4592 10.9349 18.473 11.1785C18.4862 11.4092 18.4974 11.64 18.5087 11.8708C18.5253 12.2067 18.5413 12.5427 18.5572 12.8786C18.5601 12.9403 18.5901 12.9699 18.6524 12.9689C18.8259 12.966 18.9992 12.9627 19.1727 12.9596C19.1727 12.959 19.1727 12.9585 19.1727 12.9579C19.2109 12.9579 19.2491 12.9584 19.2874 12.9578C19.4272 12.9557 19.567 12.9535 19.7069 12.9509C19.7598 12.9499 19.7931 12.9184 19.7943 12.8695C19.7981 12.7158 19.8008 12.5621 19.8057 12.4084C19.8128 12.1849 19.8201 11.9614 19.8299 11.7379C19.8428 11.4466 19.8577 11.1554 19.8727 10.8642C19.8815 10.6958 19.8914 10.5274 19.9024 10.3592C19.9159 10.1537 19.9299 9.94834 19.9456 9.74312C19.9583 9.57691 19.9737 9.41088 19.9879 9.24479C19.9923 9.19379 19.9984 9.14279 20 9.09168C20.0016 9.04511 19.9823 9.02619 19.9366 9.01969H19.9366Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.8688 14.1793C19.8688 13.9604 19.8688 13.7414 19.8688 13.5225C19.8688 13.4553 19.8458 13.4339 19.7778 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3336 13.4735 19.0533 13.4827 18.7725 13.4746C18.6672 13.4715 18.562 13.4672 18.4571 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3715 13.5886 18.3713 13.6537 18.3731 13.7185C18.3774 13.8731 18.3778 14.0277 18.3757 14.1823C18.3727 14.4096 18.372 14.6369 18.3711 14.8643C18.3709 14.9132 18.3988 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.695 14.9194C18.9465 14.9041 19.198 14.9013 19.4498 14.9076C19.5653 14.9104 19.6808 14.9132 19.7964 14.9166C19.8276 14.9174 19.8511 14.9065 19.864 14.8775C19.8706 14.8627 19.8688 14.8464 19.8688 14.8306C19.8689 14.6135 19.8688 14.3964 19.8688 14.1793Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.07031 14.2687C8.61418 12.7687 8.15801 11.2688 7.70189 9.76881C7.63667 9.55441 7.57151 9.34 7.50612 9.1256C7.48597 9.05949 7.43526 9.0268 7.36791 9.03771C7.25763 9.05557 7.14763 9.07522 7.03735 9.09313C6.67802 9.15152 6.31852 9.20884 5.96031 9.274C5.86772 9.29085 5.80132 9.34224 5.77154 9.43248C5.18325 11.2134 4.59553 12.9943 4.00768 14.7753C3.98317 14.8496 4.01849 14.8982 4.09703 14.8982C4.53249 14.8982 4.96801 14.8982 5.40348 14.8983C5.42128 14.8983 5.43902 14.8983 5.45593 14.8922C5.47636 14.8849 5.49142 14.8721 5.49635 14.8498C5.51896 14.7472 5.54136 14.6445 5.56425 14.5419C5.6335 14.2314 5.70297 13.921 5.77233 13.6105C5.77546 13.5964 5.77815 13.5867 5.79847 13.587C6.27581 13.5939 6.7532 13.6 7.23054 13.6053C7.25254 13.6055 7.26054 13.6121 7.26508 13.633C7.3552 14.0446 7.446 14.456 7.53669 14.8675C7.54811 14.9193 7.56759 14.935 7.62116 14.9357C7.63141 14.9358 7.64165 14.9352 7.6519 14.9349C7.90072 14.9282 8.14961 14.9214 8.34341 14.9162C8.65494 14.9162 8.91138 14.9165 9.16782 14.9161C9.22923 14.916 9.25593 14.8791 9.2383 14.8211C9.18226 14.6369 9.12623 14.4528 9.07025 14.2686L9.07031 14.2687ZM7.00544 12.4829C6.70517 12.4823 6.4049 12.4822 6.10457 12.483C6.07881 12.4831 6.07909 12.4754 6.08486 12.4548C6.22089 11.9665 6.3497 11.4762 6.47397 10.9849C6.50952 10.8442 6.54289 10.703 6.57737 10.562C6.57866 10.5569 6.58056 10.5518 6.58465 10.5392C6.6816 10.937 6.76787 11.3295 6.85732 11.7211C6.91319 11.966 6.96978 12.2107 7.02739 12.4552C7.03299 12.479 7.02834 12.4829 7.0055 12.4828L7.00544 12.4829Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.6715 14.483C17.6508 14.1846 17.6368 13.8858 17.6337 13.5866C17.6292 13.1505 17.6392 12.7144 17.6459 12.2783C17.6489 12.0854 17.6451 11.8927 17.6116 11.7017C17.5626 11.4229 17.427 11.1973 17.2 11.0277C17.0326 10.9026 16.8409 10.8332 16.6391 10.7888C16.3129 10.7171 15.9826 10.7133 15.6513 10.735C15.4224 10.75 15.1954 10.7808 14.9697 10.822C14.7443 10.8632 14.5215 10.9154 14.3015 10.9796C14.2482 10.9951 14.2304 11.018 14.2279 11.0738C14.225 11.1361 14.2232 11.1986 14.2205 11.2609C14.2138 11.4201 14.2068 11.5793 14.2002 11.7385C14.1971 11.812 14.193 11.8856 14.1925 11.9591C14.192 12.0256 14.2482 12.0552 14.2961 12.0363C14.4737 11.9667 14.6519 11.899 14.8344 11.8434C15.1069 11.7603 15.3843 11.7096 15.6705 11.7156C15.765 11.7175 15.8584 11.726 15.9472 11.7617C16.0354 11.797 16.0909 11.8595 16.1043 11.9553C16.11 11.996 16.1065 12.0371 16.106 12.0781C16.1057 12.1005 16.0979 12.1097 16.0745 12.1129C15.9739 12.127 15.8735 12.1417 15.7735 12.1592C15.4704 12.2122 15.1722 12.2838 14.8841 12.3937C14.6487 12.4835 14.426 12.5963 14.2307 12.7575C14.0093 12.9403 13.8519 13.1654 13.7916 13.4492C13.733 13.7249 13.7543 13.9976 13.8446 14.2642C13.9131 14.4664 14.0269 14.6385 14.1966 14.7708C14.3761 14.9107 14.5826 14.976 14.8076 14.9892C14.8076 14.9907 14.8078 14.9922 14.808 14.9937H14.9647C14.9647 14.9921 14.9647 14.9906 14.9649 14.989C15.0468 14.9825 15.1278 14.9702 15.2076 14.9506C15.5361 14.87 15.8352 14.7248 16.1143 14.5361C16.1279 14.527 16.1412 14.5175 16.1583 14.5057V14.5414C16.1583 14.6448 16.1582 14.7483 16.1584 14.8517C16.1585 14.9143 16.1809 14.9365 16.2426 14.9356C16.3964 14.9334 16.5502 14.9309 16.7041 14.9288C17.0099 14.9245 17.3157 14.9204 17.6215 14.9161C17.6734 14.9154 17.696 14.8915 17.6952 14.8397C17.6951 14.8341 17.6948 14.8285 17.6945 14.823C17.6868 14.7095 17.6793 14.5962 17.6714 14.4828L17.6715 14.483ZM16.1219 13.3558C16.1219 13.4806 16.1214 13.6055 16.1224 13.7302C16.1226 13.7497 16.1161 13.76 16.0995 13.7695C15.9485 13.857 15.7891 13.9147 15.6115 13.9032C15.4004 13.8894 15.2482 13.7607 15.226 13.5542C15.2022 13.3329 15.2951 13.1667 15.5135 13.0711C15.6245 13.0225 15.7419 12.9981 15.861 12.9813C15.9384 12.9704 16.0164 12.9631 16.0939 12.9531C16.1155 12.9503 16.1227 12.9553 16.1224 12.9785C16.1213 13.1043 16.1219 13.2301 16.1219 13.3558Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $7f1ad59b32ead886$export$88b64eee273831fd() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
}





parcelRequire("42omo");

function $29a96fe4504d29d4$export$5e013c7991ef7bd0() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-507.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.0516 7.60124C11.0073 7.54277 10.9568 7.51208 10.9007 7.51208C10.8545 7.51208 10.8122 7.53281 10.7851 7.55016C10.3591 7.88478 9.77609 9.30229 9.29834 11.1701L9.72131 11.1749C10.5565 11.1844 11.419 11.1942 12.2715 11.2073C12.0468 10.3518 11.8344 9.61843 11.6397 9.02646C11.3552 8.16124 11.1629 7.77393 11.0516 7.60124Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 12.0001C20 16.4183 16.4183 20.0001 12 20.0001C7.58169 20.0001 4 16.4183 4 12.0001C4 7.58181 7.58169 4.00012 12 4.00012C16.4183 4.00012 20 7.58181 20 12.0001ZM17.9088 11.8171C17.9088 11.6117 17.764 11.4404 17.569 11.4014C17.5679 11.4012 17.5667 11.4009 17.5655 11.4006C17.5632 11.4003 17.561 11.3995 17.5587 11.3992L17.5508 11.3984C17.5301 11.395 17.5091 11.3929 17.4876 11.3926L17.4315 11.3873C16.0916 11.2914 14.7131 11.2536 13.4199 11.2278L13.4173 11.2183C12.788 8.85747 12.0018 6.44382 10.9417 6.44382C9.9539 6.44831 9.06345 8.03418 8.29446 11.1584C7.75116 11.1514 7.2559 11.1439 6.78892 11.1359C6.76241 11.1354 6.73863 11.1352 6.71743 11.1352C6.61783 11.1352 6.56916 11.1394 6.54506 11.1426C6.28209 11.1892 6.09124 11.4186 6.09124 11.6883C6.09124 11.9633 6.29655 12.1992 6.56402 12.2377L6.56948 12.2433H8.04257C7.90586 12.8684 7.78602 13.4865 7.68594 14.0821L7.64209 14.3442L7.64161 14.3567C7.64257 14.559 7.80787 14.7235 8.00996 14.7235C8.13815 14.7235 8.2543 14.6567 8.32064 14.5526L8.33108 14.5609L9.05526 12.2433H12.5435C12.81 13.2502 13.0864 14.2899 13.4517 15.2657C13.6471 15.7874 14.1044 17.0094 14.8688 17.0155H14.8774C16.0604 17.0155 16.5214 15.1047 16.8268 13.8398C16.8924 13.5677 16.9491 13.3327 17.0026 13.16L17.0239 13.0886H17.0238C17.0289 13.0719 17.0316 13.0543 17.0316 13.0358C17.0316 12.9346 16.9496 12.8525 16.8484 12.8525C16.7698 12.8525 16.703 12.9018 16.6768 12.9712L16.6765 12.971L16.6508 13.0421C16.5504 13.32 16.4575 13.5828 16.3753 13.8157L16.369 13.8332C15.857 15.2833 15.6233 15.9452 15.1655 15.9453L15.1542 15.9452L15.1478 15.9461L15.1364 15.9458C14.5504 15.9458 13.9986 13.5635 13.7908 12.6668C13.7549 12.5114 13.7219 12.3688 13.6916 12.2433H17.481C17.5521 12.2433 17.6191 12.2255 17.6779 12.1947C17.6784 12.1945 17.6787 12.1943 17.679 12.1942C17.685 12.1911 17.6906 12.1876 17.6964 12.1842C17.7028 12.1805 17.7091 12.1768 17.7152 12.1728C17.7182 12.1709 17.7211 12.1688 17.724 12.1667C17.7332 12.1604 17.742 12.1539 17.7507 12.1468C17.7513 12.1463 17.7518 12.1458 17.7524 12.1453C17.8479 12.0671 17.9088 11.9486 17.9088 11.8171Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $6712df246ca23297$export$671541d0c7918cd9() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#F06A6A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9553 12.3807C14.2737 12.3807 12.9105 13.7439 12.9105 15.4256C12.9105 17.1072 14.2737 18.4704 15.9553 18.4704C17.6369 18.4704 19 17.1072 19 15.4256C19 13.7439 17.6369 12.3807 15.9553 12.3807ZM8.04475 12.381C6.3632 12.381 5 13.7439 5 15.4256C5 17.1072 6.3632 18.4704 8.04475 18.4704C9.72637 18.4704 11.0896 17.1072 11.0896 15.4256C11.0896 13.7439 9.72637 12.381 8.04475 12.381ZM15.0447 8.57471C15.0447 10.2564 13.6816 11.6197 12 11.6197C10.3184 11.6197 8.95526 10.2564 8.95526 8.57471C8.95526 6.89336 10.3184 5.53003 12 5.53003C13.6816 5.53003 15.0447 6.89336 15.0447 8.57471Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $5d06adcb9db7f090$export$abf71a44e930800c() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                width: "24",
                height: "24",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        id: "Icon-Architecture-BG/64/Storage",
                        fill: "#7AA116",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            id: "Rectangle",
                            x: "0",
                            y: "0",
                            width: "24",
                            height: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
                        transform: "scale(0.3) translate(12.999900, 11.999600)",
                        fill: "#FFFFFF",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
                            id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
                        })
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $70454930bfdc1b5b$export$2dcf704e717ca168() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.5 7.30929V16.4293L15.75 19.5L9.9375 17.3839V19.4818L6.64714 15.1821L16.2375 15.9321V7.71964L19.5 7.30929ZM16.3029 7.76786L10.9221 4.5V6.64393L5.98071 8.09571L4.5 9.99643V14.3132L6.61929 15.2486V9.71679L16.3029 7.76786Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $a3086153acbe9efd$export$adedf1569d7107de() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0071F7"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.8589 15.3516C20.0587 15.6312 20.0187 15.9907 19.779 16.1905C19.4994 16.3902 19.0999 16.3502 18.9002 16.1106L17.5021 14.313L16.1439 16.0706C15.9441 16.3502 15.5447 16.3502 15.265 16.1505C14.9854 15.9508 14.9455 15.5913 15.1452 15.3116L16.7431 13.2344L15.1452 11.1571C14.9455 10.8775 15.0254 10.478 15.265 10.2783C15.5447 10.0786 15.9441 10.1585 16.1439 10.3982L17.5021 12.1958L18.9002 10.478C19.0999 10.1984 19.4595 10.1585 19.779 10.3582C20.0587 10.5579 20.0587 10.9574 19.8589 11.237L18.301 13.2743L19.8589 15.3516ZM12.5886 15.1119C11.55 15.1119 10.7111 14.313 10.7111 13.2743C10.7111 12.2757 11.55 11.4368 12.5886 11.4368C13.6272 11.4368 14.4661 12.2757 14.4661 13.2743C14.4261 14.313 13.5873 15.1119 12.5886 15.1119ZM7.07591 15.1119C6.03729 15.1119 5.19841 14.313 5.19841 13.2743C5.19841 12.2757 6.03729 11.4368 7.07591 11.4368C8.11453 11.4368 8.95342 12.2757 8.95342 13.2743C8.95342 14.313 8.11453 15.1119 7.07591 15.1119ZM12.5886 10.2384C11.4301 10.2384 10.3915 10.8775 9.8722 11.8362C9.35289 10.8775 8.31427 10.2384 7.11586 10.2384C6.39682 10.2384 5.75766 10.478 5.23835 10.8376V8.28097C5.23835 7.96139 4.95873 7.68176 4.63915 7.68176C4.27963 7.68176 4 7.96139 4 8.28097V13.3143C4.03995 14.9921 5.39814 16.3103 7.07591 16.3103C8.27432 16.3103 9.31294 15.6312 9.83225 14.6725C10.3516 15.6312 11.3902 16.3103 12.5486 16.3103C14.2664 16.3103 15.6645 14.9521 15.6645 13.2344C15.7045 11.5966 14.3063 10.2384 12.5886 10.2384Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $33bbad668c06286f$export$3ad1ba1bf426d64a() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1737_5849)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1737_5849",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
}





parcelRequire("42omo");

function $07312a4c36093ee3$export$393452da0e179bab() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-115.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
                fill: "black"
            })
        ]
    });
}





parcelRequire("42omo");

function $649aeb4f72eb8e0e$export$e67ec9178da81ba8() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-747.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 13.8484C5.74119 13.8676 5.74119 13.9156 5.77446 13.9349L8.90847 15.7448C8.93934 15.7626 8.95836 15.7956 8.95836 15.8312V19.4501C8.95836 19.4885 8.99997 19.5125 9.03327 19.4933L12.1673 17.6834C12.1981 17.6656 12.2172 17.6326 12.2172 17.597V13.9492C12.2172 13.9136 12.1981 13.8806 12.1672 13.8628L8.95836 12.0106L5.77446 13.8484Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 6.32257C5.74119 6.3418 5.74119 6.38983 5.77446 6.40903L8.90847 8.21896C8.93934 8.23681 8.95836 8.26975 8.95836 8.30542V12.0108L12.2172 10.1288V6.42346C12.2172 6.38779 12.1981 6.35482 12.1672 6.33697L9.00828 4.51363C8.97741 4.49578 8.93934 4.49578 8.90847 4.51363L5.77446 6.32257Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2173 10.1281L15.4261 11.9813C15.457 11.9991 15.4761 12.0321 15.4761 12.0678V15.6866C15.4761 15.7251 15.5177 15.7491 15.5509 15.7299L18.6849 13.9199C18.7158 13.9021 18.7348 13.8691 18.7348 13.8335V10.1858C18.7348 10.1501 18.7158 10.1171 18.6849 10.0993L15.526 8.27594C15.4951 8.25812 15.457 8.25812 15.4261 8.27594L12.2173 10.1281Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $28635332c9030ba5$export$5e2362bb78414664() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0061FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0098 8.48964L8.24219 10.8931L12.0098 13.2965L8.24219 15.7L4.47461 13.2836L8.24219 10.8801L4.47461 8.48964L8.24219 6.08618L12.0098 8.48964ZM8.2227 16.473L11.9903 14.0695L15.7579 16.473L11.9903 18.8765L8.2227 16.473ZM12.0098 13.2836L15.7773 10.8801L12.0098 8.48964L15.7579 6.08618L19.5254 8.48964L15.7579 10.8931L19.5254 13.2965L15.7579 15.7L12.0098 13.2836Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $cd7b17c4dcd78e0d$export$54e0f4982aa79afe() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 12C12 11.337 12.254 10.7011 12.7061 10.2322C13.1582 9.76339 13.7714 9.5 14.4107 9.5C15.0501 9.5 15.6633 9.76339 16.1153 10.2322C16.5674 10.7011 16.8214 11.337 16.8214 12C16.8214 12.663 16.5674 13.2989 16.1153 13.7678C15.6633 14.2366 15.0501 14.5 14.4107 14.5C13.7714 14.5 13.1582 14.2366 12.7061 13.7678C12.254 13.2989 12 12.663 12 12Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.17871 17C7.17871 16.337 7.4327 15.7011 7.88479 15.2322C8.33689 14.7634 8.95006 14.5 9.58943 14.5H12.0001V17C12.0001 17.663 11.7462 18.2989 11.2941 18.7678C10.842 19.2366 10.2288 19.5 9.58943 19.5C8.95006 19.5 8.33689 19.2366 7.88479 18.7678C7.4327 18.2989 7.17871 17.663 7.17871 17V17Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 4.5V9.5H14.4107C15.0501 9.5 15.6633 9.23661 16.1153 8.76777C16.5674 8.29893 16.8214 7.66304 16.8214 7C16.8214 6.33696 16.5674 5.70107 16.1153 5.23223C15.6633 4.76339 15.0501 4.5 14.4107 4.5H12Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.17871 7C7.17871 7.66304 7.4327 8.29893 7.88479 8.76777C8.33689 9.23661 8.95006 9.5 9.58943 9.5H12.0001V4.5H9.58943C8.95006 4.5 8.33689 4.76339 7.88479 5.23223C7.4327 5.70107 7.17871 6.33696 7.17871 7V7Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.17871 12C7.17871 12.663 7.4327 13.2989 7.88479 13.7678C8.33689 14.2366 8.95006 14.5 9.58943 14.5H12.0001V9.5H9.58943C8.95006 9.5 8.33689 9.76339 7.88479 10.2322C7.4327 10.7011 7.17871 11.337 7.17871 12V12Z",
                        fill: "#A259FF"
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $245cc3e615a9d0f0$export$327de5bc0476c8b8() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#09C6FA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.6954 4.25008C15.7025 4.25008 16.7099 4.25338 17.7183 4.25008C18.2271 4.24619 18.6802 4.38244 19.0651 4.72054C19.4877 5.09067 19.7328 5.55604 19.7349 6.11783C19.7436 8.16046 19.767 10.2037 19.7289 12.2454C19.6945 14.0838 19.0364 15.7066 17.8236 17.091C16.5561 18.5389 14.9606 19.4014 13.0546 19.6709C11.5776 19.8805 10.1533 19.6736 8.79837 19.0498C6.90652 18.179 5.57016 16.7631 4.79229 14.8358C4.32449 13.676 4.16198 12.4628 4.29456 11.2138C4.46875 9.57492 5.09668 8.1346 6.17833 6.89283C7.22587 5.69708 8.52271 4.90171 10.0581 4.49714C10.7129 4.32786 11.3871 4.2451 12.0634 4.25098C12.9401 4.25158 13.8175 4.25128 14.6954 4.25008ZM13.1971 11.1482C12.6063 11.1482 12.0155 11.1464 11.4247 11.15C11.322 11.15 11.2897 11.1323 11.3274 11.0221C11.4729 10.5945 11.6099 10.1642 11.7503 9.73443C11.895 9.29243 12.0394 8.85042 12.1837 8.40841C12.2211 8.29372 12.1837 8.20089 12.084 8.14459C11.9844 8.08829 11.8838 8.10895 11.8087 8.20268C11.7668 8.25509 11.7291 8.31079 11.689 8.36529C11.0002 9.32517 10.3118 10.2847 9.62382 11.244C9.34987 11.6257 9.07501 12.0067 8.79926 12.3868C8.76505 12.4287 8.74371 12.4796 8.73781 12.5334C8.73192 12.5872 8.74172 12.6415 8.76604 12.6898C8.81722 12.8 8.9115 12.842 9.02673 12.8464C9.07581 12.8482 9.1252 12.8479 9.17428 12.8479H12.5042C12.7054 12.8479 12.709 12.8479 12.6449 13.0456C12.3744 13.8747 12.1026 14.7032 11.8296 15.5311C11.7802 15.6809 11.8036 15.7737 11.9113 15.8336C12.0191 15.8935 12.1128 15.8677 12.2106 15.7437C12.2247 15.7264 12.2376 15.7081 12.2507 15.6898C13.2284 14.3369 14.2055 12.9839 15.182 11.6309C15.2554 11.5294 15.2919 11.4237 15.2299 11.3063C15.168 11.1889 15.0626 11.1461 14.9288 11.1467C14.3518 11.1503 13.7745 11.1482 13.1971 11.1482Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

function $6a7d1e69fe712847$export$6da1c7984975c183() {
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
        })
    });
}





parcelRequire("42omo");

function $43a1f6f54a8f6e01$export$e8e65f186ccd8749() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $9fec69967aee1632$export$8b4e5326778cce0f() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-363.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.7331 10.3948L19.7115 10.3373L17.5339 4.65705C17.4898 4.54552 17.4114 4.4509 17.31 4.3869C17.2343 4.33846 17.1483 4.30842 17.059 4.29919C16.9696 4.28996 16.8793 4.30179 16.7953 4.33375C16.7113 4.3657 16.636 4.41688 16.5754 4.4832C16.5147 4.54951 16.4705 4.6291 16.4461 4.7156L14.9763 9.21564H9.02381L7.55392 4.7156C7.5294 4.62923 7.48504 4.54979 7.42438 4.4836C7.36371 4.41742 7.28842 4.36632 7.20451 4.3344C7.1206 4.30247 7.03039 4.29059 6.94107 4.2997C6.85175 4.30882 6.7658 4.33868 6.69007 4.3869C6.58865 4.4509 6.51022 4.54552 6.46615 4.65705L4.28957 10.3383L4.26697 10.3948C3.95361 11.2138 3.91501 12.1125 4.15698 12.9553C4.39895 13.7981 4.90838 14.5394 5.60846 15.0674L5.61668 15.0736L5.63517 15.088L8.94779 17.5706L10.5913 18.8125L11.5897 19.5675C11.7068 19.656 11.8496 19.7038 11.9964 19.7038C12.1432 19.7038 12.2861 19.656 12.4032 19.5675L13.4016 18.8125L15.0451 17.5706L18.3813 15.0736L18.3906 15.0664C19.0906 14.5386 19.6001 13.7975 19.8423 12.9549C20.0844 12.1123 20.0461 11.2138 19.7331 10.3948Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.7329 10.3948L19.7114 10.3373C18.6504 10.555 17.6507 11.0047 16.7839 11.6541L12.0024 15.2698L15.047 17.5706L18.3832 15.0736L18.3925 15.0664C19.0922 14.5383 19.6012 13.7971 19.843 12.9545C20.0848 12.1119 20.0462 11.2135 19.7329 10.3948Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.94775 17.5708L10.5912 18.8126L11.5896 19.5676C11.7068 19.6561 11.8496 19.7039 11.9964 19.7039C12.1432 19.7039 12.286 19.6561 12.4032 19.5676L13.4016 18.8126L15.045 17.5708L12.0005 15.2699L8.94775 17.5708Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.21598 11.6541C6.34952 11.005 5.35016 10.5556 4.28957 10.3383L4.26697 10.3948C3.95361 11.2137 3.91501 12.1124 4.15698 12.9552C4.39895 13.798 4.90838 14.5393 5.60846 15.0674L5.61668 15.0735L5.63517 15.0879L8.94779 17.5706L11.9944 15.2697L7.21598 11.6541Z",
                fill: "#FC6D26"
            })
        ]
    });
}





parcelRequire("42omo");

function $bc8429e13282fa5c$export$856bad9032bbc5ed() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.52273 17.625H7.90909V11.8295L4.5 9.27271V16.6023C4.5 17.1682 4.95852 17.625 5.52273 17.625Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.0908 17.625H18.4772C19.0431 17.625 19.4999 17.1665 19.4999 16.6023V9.27271L16.0908 11.8295",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.0908 7.3977V11.8295L19.4999 9.2727V7.90906C19.4999 6.64429 18.0562 5.92327 17.0454 6.68179",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.90918 11.8295V7.39771L12.0001 10.4659L16.091 7.39771V11.8295L12.0001 14.8977",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.5 7.90931V9.27294L7.90909 11.8298V7.39794L6.95455 6.68203C5.94205 5.92351 4.5 6.64453 4.5 7.90931Z",
                        fill: "#C5221F"
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $f723749284877ab9$export$5d128e0a6ffc0558() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-124.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.8208 8.17936L12.3822 7.7973L8.17949 8.17936L7.79736 12.0001L8.17942 15.8207L12.0001 16.2983L15.8208 15.8207L16.2029 11.9046L15.8208 8.17936Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.74654 14.1071C9.46096 13.9142 9.26322 13.6324 9.15527 13.2599L9.81819 12.9867C9.87837 13.216 9.98341 13.3936 10.1334 13.5197C10.2824 13.6458 10.4639 13.7079 10.6759 13.7079C10.8928 13.7079 11.079 13.642 11.2347 13.5101C11.3903 13.3783 11.4687 13.2102 11.4687 13.0068C11.4687 12.7986 11.3866 12.6285 11.2223 12.4967C11.058 12.365 10.8517 12.299 10.6052 12.299H10.2222V11.6428H10.566C10.7781 11.6428 10.9567 11.5856 11.1019 11.4709C11.2471 11.3563 11.3197 11.1997 11.3197 11C11.3197 10.8224 11.2547 10.681 11.1249 10.575C10.995 10.469 10.8306 10.4155 10.631 10.4155C10.4362 10.4155 10.2814 10.4671 10.1668 10.5712C10.0522 10.6753 9.96904 10.8033 9.91655 10.9542L9.26039 10.681C9.34728 10.4346 9.50684 10.2168 9.74081 10.0287C9.97484 9.8405 10.2738 9.74591 10.6367 9.74591C10.9051 9.74591 11.1468 9.79752 11.3608 9.90162C11.5747 10.0057 11.7428 10.15 11.8641 10.3333C11.9854 10.5176 12.0456 10.724 12.0456 10.9532C12.0456 11.1872 11.9893 11.3849 11.8766 11.5473C11.7638 11.7097 11.6253 11.8338 11.461 11.9208V11.9599C11.6779 12.0507 11.8546 12.1892 11.994 12.3754C12.1325 12.5617 12.2022 12.7843 12.2022 13.0441C12.2022 13.3039 12.1363 13.536 12.0045 13.7394C11.8726 13.9429 11.6902 14.1034 11.4591 14.2199C11.227 14.3364 10.9662 14.3956 10.6768 14.3956C10.3416 14.3966 10.0321 14.3001 9.74654 14.1071Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.8145 10.8175L13.0905 11.3438L12.7266 10.7917L14.0323 9.84991H14.5328V14.2924H13.8145V10.8175Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.8208 19.2592L19.2593 15.8206L17.54 15.0565L15.8208 15.8206L15.0566 17.5399L15.8208 19.2592Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.41504 17.54L8.17915 19.2593H15.8205V15.8207H8.17915L7.41504 17.54Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.88689 4.74078C5.25366 4.74078 4.74072 5.25372 4.74072 5.88695V15.8207L6.46001 16.5848L8.17929 15.8207V8.17935H15.8206L16.5847 6.46007L15.8207 4.74078H5.88689Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.74072 15.8207V18.1131C4.74072 18.7464 5.25366 19.2593 5.88689 19.2593H8.17929V15.8207H4.74072Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.8203 8.17945V15.8208H19.2589V8.17945L17.5396 7.41534L15.8203 8.17945Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M19.2589 8.17929V5.88689C19.2589 5.25359 18.7459 4.74072 18.1127 4.74072H15.8203V8.17929H19.2589Z",
                        fill: "#1967D2"
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $c341e8e2d9bbb303$export$e16bd899bb4eebf9() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.20962 17.0782L5.91523 18.2907C6.06186 18.546 6.27262 18.7466 6.52005 18.8925L9.04009 14.5529H4C4 14.8355 4.07331 15.1181 4.21993 15.3734L5.20962 17.0782Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 9.44751L9.47995 5.10791C9.23253 5.25378 9.02176 5.45435 8.87514 5.70962L4.21993 13.7324C4.07601 13.9822 4.00019 14.265 4 14.5529H9.04009L12 9.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.4799 18.8925C17.7273 18.7466 17.9381 18.546 18.0847 18.2907L18.3779 17.7893L19.78 15.3734C19.9266 15.1181 19.9999 14.8355 19.9999 14.5529H14.9595L16.032 16.6497L17.4799 18.8925Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 9.4475L14.5201 5.1079C14.2726 4.96203 13.9886 4.8891 13.6953 4.8891H10.3047C10.0115 4.8891 9.7274 4.97115 9.47998 5.1079L12 9.4475Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.9594 14.5529H9.03958L6.51953 18.8925C6.76695 19.0383 7.05103 19.1113 7.34427 19.1113H16.6547C16.9479 19.1113 17.232 19.0292 17.4794 18.8925L14.9594 14.5529Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.4525 9.72101L15.1249 5.70962C14.9782 5.45435 14.7675 5.25378 14.52 5.10791L12 9.44751L14.9599 14.5529H19.9908C19.9908 14.2703 19.9175 13.9877 19.7709 13.7324L17.4525 9.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $f8ec2e28f7c99a9d$export$c9a6a66ee7acc43a() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FF5C35"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $f17c70c4cfb4081d$export$68470e68dec0bc46() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.0232 12.0808C20.0002 12.2346 19.9148 12.3512 19.8075 12.4584C17.3508 14.9147 14.895 17.3719 12.4389 19.8288C12.4116 19.8561 12.3853 19.8845 12.3562 19.9098C12.2424 20.0088 12.113 20.0247 11.9781 19.9655C11.845 19.9072 11.7732 19.798 11.7632 19.6539C11.7574 19.5702 11.7891 19.4944 11.8388 19.4264C11.9362 19.2931 12.0329 19.1593 12.13 19.0257C12.7486 18.1738 13.3672 17.3218 13.9859 16.47C14.3904 15.913 14.795 15.3562 15.1995 14.7994C15.3066 14.6519 15.4141 14.5047 15.5208 14.357C15.5315 14.3423 15.5483 14.3295 15.5454 14.3065C15.5243 14.3004 15.5082 14.3131 15.4912 14.32C14.8996 14.5611 14.308 14.8024 13.7166 15.0438C13.2263 15.2439 12.7362 15.4442 12.246 15.6446C11.1843 16.0784 10.1224 16.5119 9.06106 16.9467C8.97552 16.9817 8.88978 17.0024 8.79819 16.9813C8.65305 16.9479 8.54691 16.8331 8.52155 16.684C8.49883 16.5505 8.56326 16.4093 8.68877 16.3339C8.9313 16.1881 9.17582 16.0455 9.41951 15.9016C10.289 15.3879 11.1584 14.8742 12.028 14.3607C12.7979 13.9061 13.568 13.4519 14.338 12.9974C14.3655 12.9812 14.3924 12.9642 14.4339 12.9389C14.3588 12.9323 14.2988 12.9253 14.2387 12.922C13.9713 12.9073 13.7038 12.894 13.4363 12.8793C13.2181 12.8673 13 12.8547 12.7819 12.8415C12.5296 12.8261 12.2774 12.8095 12.0251 12.7943C11.9225 12.788 11.8197 12.7846 11.717 12.7786C11.5224 12.7673 11.3279 12.7548 11.1333 12.7432C11.0542 12.7385 10.975 12.7358 10.8959 12.7303C10.7057 12.7172 10.515 12.711 10.3246 12.6999C10.0723 12.6852 9.82012 12.6679 9.56774 12.6531C9.48432 12.6482 9.40084 12.6449 9.31742 12.6397C9.0523 12.6232 8.78686 12.6112 8.52161 12.5966C8.29917 12.5844 8.07679 12.5711 7.85434 12.5583C7.62765 12.5453 7.40082 12.5335 7.17426 12.519C6.95188 12.5048 6.72956 12.4913 6.50699 12.4805C6.28229 12.4696 6.05785 12.4551 5.83328 12.4422C5.61083 12.4294 5.38845 12.4166 5.166 12.4038C4.94356 12.391 4.72111 12.3791 4.49873 12.3648C4.43675 12.3608 4.37431 12.3592 4.31284 12.3523C4.16358 12.3353 4.05918 12.256 4.00602 12.1135C3.99707 12.0894 3.99243 12.0637 3.97705 12.0422V11.9393C3.99733 11.9207 3.99932 11.8936 4.0091 11.8701C4.06504 11.736 4.16332 11.6549 4.30917 11.6409C4.4307 11.6293 4.5528 11.6239 4.67464 11.6167C4.89921 11.6034 5.12378 11.5908 5.34835 11.5778C5.5708 11.565 5.79318 11.5517 6.01569 11.5395C6.28312 11.5249 6.55069 11.513 6.818 11.4964C6.89929 11.4914 6.98058 11.4877 7.06188 11.483C7.24364 11.4725 7.42528 11.4591 7.60705 11.4487C7.79532 11.438 7.98384 11.432 8.17185 11.4184C8.25315 11.4125 8.33451 11.4106 8.4158 11.4056C8.60606 11.3938 8.79639 11.3816 8.98672 11.3705C9.08938 11.3644 9.19223 11.3612 9.2949 11.355C9.54721 11.3397 9.79945 11.3229 10.0518 11.3077C10.2741 11.2942 10.4967 11.282 10.7191 11.2693C10.9458 11.2563 11.1726 11.2433 11.3993 11.2303C11.6196 11.2176 11.8398 11.2048 12.0602 11.1922C12.2847 11.1792 12.5093 11.1658 12.7339 11.1535C13.0014 11.1389 13.2689 11.127 13.5362 11.1105C13.6175 11.1055 13.6988 11.1016 13.7801 11.0971C13.9812 11.0858 14.1821 11.0732 14.3832 11.0609C14.3985 11.0599 14.4156 11.0646 14.4308 11.0529C14.4137 11.033 14.3934 11.0251 14.3751 11.0143C13.5146 10.5062 12.654 9.99844 11.7936 9.49047C10.898 8.96178 10.0024 8.43308 9.10689 7.90432C8.96837 7.82258 8.82909 7.74206 8.69192 7.65813C8.56776 7.58211 8.50449 7.44392 8.52374 7.31442C8.55817 7.0829 8.80701 6.93975 9.02933 7.03359C9.54483 7.25121 10.0641 7.45969 10.5821 7.67152C11.5167 8.05372 12.4516 8.43553 13.3863 8.81767C14.0887 9.10486 14.7912 9.39225 15.4938 9.679C15.5099 9.68556 15.5262 9.70217 15.5467 9.68743C15.5473 9.66503 15.5315 9.65177 15.5205 9.63665C15.1123 9.07442 14.7037 8.51251 14.2954 7.95041C13.7824 7.24426 13.2698 6.53792 12.7569 5.8317C12.4532 5.41352 12.1522 4.99341 11.8443 4.57832C11.679 4.35536 11.8105 4.07621 12.0167 4.01719C12.031 4.01313 12.0443 4.00579 12.0581 4C12.101 4 12.1439 4 12.1868 4C12.282 4.02349 12.354 4.08136 12.4221 4.14939C14.8857 6.61367 17.3497 9.07744 19.8147 11.5404C19.9208 11.6464 20.0037 11.7613 20.0233 11.9138V12.081L20.0232 12.0808Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $e210e3d638a9f31f$export$8d789f76fde3e05() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "#5753F3"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
}





parcelRequire("42omo");

function $975bad8ec722883c$export$8664694e1d7db2a0() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $83380eab7f65abc9$export$38410c1d5582587e() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0122 5.5H13.1097L14.6951 8.28547L11.2073 5.5H9.30491L11.0488 8.90456L7.40244 5.5H5.5L7.40244 9.83362L5.5 18.5H7.40244L11.0488 9.21453L9.30491 18.5H11.2073L14.6951 8.59544L13.1097 18.5H15.0122L18.5 7.6664L15.0122 5.5Z",
                fill: "black"
            })
        ]
    });
}





parcelRequire("42omo");

function $14b5b34168aa3868$export$37b4104f63b2f4bd() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.36594 16.7731C6.03435 16.7738 5.70851 16.6807 5.42172 16.5032C5.13492 16.3257 4.89744 16.0701 4.73354 15.7627C4.57214 15.4574 4.49165 15.111 4.50068 14.7606C4.50972 14.4103 4.60793 14.0691 4.78482 13.7738L8.14648 8.14287C8.31854 7.84024 8.56281 7.59175 8.85436 7.42277C9.14592 7.2538 9.47429 7.1704 9.80595 7.18109C10.1373 7.18956 10.4607 7.2918 10.7429 7.47734C11.0251 7.66289 11.256 7.92507 11.412 8.23707C11.7254 8.86914 11.6862 9.6296 11.3109 10.2229L7.95133 15.8538C7.78097 16.137 7.54634 16.3697 7.2692 16.5304C6.99206 16.6911 6.68137 16.7746 6.36594 16.7731Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1321 16.7728C11.454 16.7728 10.8301 16.3861 10.5025 15.7647C10.3415 15.4602 10.2612 15.1148 10.2702 14.7653C10.2793 14.4159 10.3773 14.0756 10.5538 13.7811L13.9091 8.16313C14.0786 7.85625 14.322 7.60333 14.614 7.43061C14.9061 7.25789 15.2361 7.17165 15.5699 7.18084C16.2537 7.19679 16.8733 7.60475 17.1867 8.2429C17.4979 8.88105 17.4523 9.64607 17.0656 10.2379L13.7111 15.8559C13.5412 16.1378 13.3075 16.3696 13.0316 16.5299C12.7556 16.6901 12.4463 16.7737 12.1321 16.7728Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.7693 16.82C18.7251 16.82 19.4999 16.0108 19.4999 15.0126C19.4999 14.0145 18.7251 13.2053 17.7693 13.2053C16.8134 13.2053 16.0386 14.0145 16.0386 15.0126C16.0386 16.0108 16.8134 16.82 17.7693 16.82Z",
                fill: "#00CA72"
            })
        ]
    });
}





parcelRequire("42omo");

function $55733c527f2afdac$export$807a21e0dcf114c4() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.6754 16.1763C12.6757 14.0134 12.6843 11.8504 12.6739 9.68758C12.6654 7.94483 13.8929 6.44038 15.5576 6.08234C15.8132 6.02736 16.0709 5.99181 16.3335 6.00416C16.3754 6.06652 16.3699 6.13777 16.3701 6.20736C16.3708 6.83713 16.371 7.46704 16.3698 8.09681C16.3696 8.17062 16.3803 8.24819 16.3276 8.31236C15.8848 8.32742 15.5243 8.50576 15.2565 8.86034C15.089 9.08221 14.9992 9.3339 14.9928 9.61332C14.9914 9.67342 14.9908 9.73352 14.9908 9.79377C14.9908 11.8638 14.9908 13.9339 14.9905 16.0039C14.9905 16.0639 14.9863 16.1238 14.9842 16.1839C14.9391 16.2353 14.8769 16.2339 14.8176 16.2342C14.1625 16.2368 13.5073 16.2368 12.8522 16.2342C12.7888 16.2339 12.7197 16.2401 12.6755 16.1763H12.6754Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.9958 9.66997C19.997 9.7251 19.9991 9.78023 19.9991 9.83536C19.9992 12.6608 19.9994 15.4861 19.9988 18.3115C19.9988 18.5251 20.0262 18.4962 19.8174 18.4965C19.1651 18.4977 18.5127 18.497 17.8602 18.497C17.8251 18.497 17.7899 18.4955 17.7548 18.497C17.7016 18.4992 17.684 18.4709 17.6862 18.4226C17.6871 18.4025 17.6862 18.3825 17.6862 18.3623C17.6865 15.4716 17.6867 12.5811 17.687 9.69046C17.687 9.68548 17.6874 9.68036 17.6876 9.67539C17.7236 9.6043 17.7918 9.60324 17.8563 9.60294C18.5111 9.59948 19.1658 9.59963 19.8206 9.60249C19.8869 9.60279 19.9509 9.61213 19.9956 9.66982L19.9958 9.66997Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.31589 9.65845C6.31815 9.71343 6.32222 9.76841 6.32222 9.82339C6.32252 12.6568 6.32267 15.4902 6.32222 18.3237C6.32222 18.5291 6.34511 18.5007 6.1493 18.501C5.48729 18.502 4.82529 18.502 4.16344 18.5002C4.11208 18.5002 4.05183 18.5251 4.01025 18.4692C4.02758 18.4151 4.01538 18.3598 4.01538 18.3053C4.01628 15.4761 4.01613 12.6469 4.01613 9.81781C4.01613 9.61688 4.02682 9.60212 4.22535 9.60121C4.85738 9.5985 5.4894 9.59941 6.12143 9.60106C6.19072 9.60121 6.26407 9.59579 6.31604 9.65845H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.3296 18.485C11.282 18.508 11.2309 18.499 11.1813 18.4991C10.5242 18.5006 9.86683 18.5014 9.20965 18.5021C9.1845 18.5021 9.15949 18.5029 9.13434 18.502C9.06545 18.4995 9.02985 18.4615 9.02754 18.3881C9.02709 18.373 9.02754 18.358 9.02754 18.3429C9.02754 15.4932 9.02754 12.6434 9.02769 9.79368C9.02769 9.74864 9.03101 9.70361 9.03282 9.65842C9.08463 9.59651 9.15738 9.60103 9.22667 9.60073C9.86141 9.59907 10.4961 9.59907 11.1309 9.60073C11.2003 9.60088 11.2728 9.59711 11.3247 9.65857C11.3267 9.72364 11.3305 9.78871 11.3305 9.85378C11.3308 11.899 11.3306 13.9442 11.3311 15.9892C11.3311 16.0542 11.3234 16.1197 11.3409 16.1837C11.3704 16.2444 11.3702 16.3096 11.3702 16.3748C11.3704 17.0109 11.371 17.647 11.3696 18.283C11.3696 18.3521 11.3782 18.4246 11.3296 18.4847V18.485Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.3247 9.65883C10.5607 9.65883 9.79675 9.65883 9.03263 9.65868C9.00822 9.44901 8.97343 9.24296 8.87477 9.05166C8.60861 8.53577 8.0406 8.24174 7.47124 8.32896C6.89584 8.41707 6.43884 8.87166 6.34515 9.45007C6.33401 9.5192 6.32557 9.58879 6.31593 9.65823C5.60302 9.65823 4.89011 9.65793 4.17719 9.65778C4.15716 9.65778 4.13682 9.65944 4.11694 9.65763C4.04795 9.65145 4.01226 9.67751 4.01753 9.75132C4.02039 9.79123 4.01783 9.8316 4.01783 9.87182C4.01783 12.6882 4.01783 15.5048 4.01753 18.3212C4.01753 18.3709 4.01286 18.4206 4.01015 18.4697C3.99267 18.4307 4.00307 18.3902 4.00307 18.351C4.00231 15.501 4.00201 12.6509 4.00277 9.80087C4.00277 9.28513 4.06874 8.77888 4.27389 8.30139C4.8172 7.03749 5.76675 6.26101 7.12404 6.04561C9.03022 5.74301 10.8088 6.97166 11.247 8.85389C11.3084 9.11794 11.3462 9.38605 11.3246 9.65883H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.3295 18.4854C11.3295 17.7731 11.3295 17.0608 11.3299 16.3486C11.3299 16.2938 11.3216 16.2382 11.3408 16.1844C11.7857 16.1819 12.2307 16.1793 12.6756 16.1768C12.7253 16.1795 12.7752 16.1844 12.8249 16.1844C13.5447 16.1849 14.2644 16.1846 14.9843 16.1844C14.9865 16.2343 14.9909 16.2843 14.9909 16.3342C14.9913 16.9954 14.9912 17.6568 14.9912 18.3181C14.9912 18.3532 14.99 18.3883 14.9909 18.4232C14.9921 18.4723 14.9705 18.4981 14.9201 18.4975C14.885 18.4972 14.8499 18.4982 14.8149 18.4982C13.7077 18.4982 12.6006 18.4982 11.4933 18.4981C11.4385 18.4981 11.3829 18.5051 11.3296 18.4853L11.3295 18.4854Z",
                fill: "#FFAA00"
            })
        ]
    });
}





parcelRequire("42omo");

function $862eece563b2b3e7$export$694ff710b1e20299() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.72382 5.14736L14.0236 4.53432C15.0431 4.44687 15.305 4.50582 15.9461 4.97186L18.5955 6.83828C19.0325 7.15927 19.178 7.24672 19.178 7.59621V17.8325C19.178 18.474 18.945 18.8535 18.1295 18.9114L8.49127 19.4952C7.87928 19.5241 7.58784 19.4367 7.26729 19.0282L5.31628 16.4912C4.96634 16.0243 4.82129 15.6748 4.82129 15.2662V6.16734C4.82129 5.6428 5.05423 5.20541 5.72382 5.14736Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0236 4.53447L5.72382 5.14751C5.05423 5.20541 4.82129 5.64295 4.82129 6.16734V15.2662C4.82129 15.6746 4.96634 16.0241 5.31628 16.4912L7.26729 19.0281C7.58784 19.4365 7.87928 19.5241 8.49127 19.495L18.1296 18.9115C18.9446 18.8535 19.1781 18.474 19.1781 17.8326V7.59636C19.1781 7.26487 19.0472 7.16932 18.6617 6.88643L15.9461 4.97186C15.3052 4.50582 15.0431 4.44687 14.0236 4.53432V4.53447ZM8.70921 7.42882C7.92218 7.48177 7.74368 7.49377 7.29669 7.13032L6.16031 6.22644C6.04482 6.10944 6.10286 5.96349 6.39386 5.9344L14.3727 5.35136C15.0427 5.29286 15.3916 5.5264 15.6536 5.7304L17.0221 6.72188C17.0806 6.75143 17.2261 6.92588 17.051 6.92588L8.81121 7.42192L8.70921 7.42882ZM7.79168 17.7452V9.05539C7.79168 8.67589 7.90823 8.50085 8.25712 8.47145L17.721 7.91736C18.042 7.88841 18.1871 8.0924 18.1871 8.4713V17.1032C18.1871 17.4827 18.1286 17.8037 17.6046 17.8326L8.54827 18.3576C8.02433 18.3866 7.79183 18.2121 7.79183 17.7452H7.79168ZM16.7315 9.52128C16.7896 9.78377 16.7315 10.0463 16.469 10.0763L16.0325 10.1628V16.5786C15.6535 16.7826 15.3046 16.8992 15.013 16.8992C14.547 16.8992 14.4306 16.7532 14.0815 16.3161L11.2271 11.8252V16.1702L12.13 16.3746C12.13 16.3746 12.13 16.8996 11.4015 16.8996L9.39305 17.0162C9.33455 16.8992 9.39305 16.6077 9.5966 16.5497L10.1211 16.4042V10.6593L9.3932 10.6004C9.3347 10.3379 9.4802 9.95882 9.88819 9.92942L12.0432 9.78437L15.0131 14.3333V10.3089L14.2561 10.2219C14.1976 9.90047 14.4306 9.66692 14.7215 9.63842L16.7315 9.52128Z",
                fill: "#292A2E"
            })
        ]
    });
}





parcelRequire("42omo");

function $e639aeb102e9bd55$export$62b570fbaf793397() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $9a0f3be089c1e397$export$d905606eb58fea64() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $477f6e8600c1261e$export$e9a3fd43f9d4bddc() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-731.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.33974 9.0588C7.33988 9.05866 7.33996 9.05847 7.33996 9.05827C7.33996 7.60876 7.34084 6.15925 7.3382 4.70974C7.3382 4.5796 7.33644 4.4987 7.51495 4.50002C9.30876 4.51057 11.1026 4.49738 12.8964 4.51892C13.9116 4.53123 14.8801 4.77262 15.7546 5.30858C16.8256 5.96414 17.4222 6.94066 17.6117 8.16868C17.8148 9.48551 17.6012 10.7206 16.7918 11.8057C16.1033 12.7294 15.1439 13.2175 14.0285 13.4329C13.3347 13.567 12.6326 13.5846 11.9309 13.5899C10.4668 13.6013 9.00231 13.5912 7.53781 13.5991C7.36414 13.6 7.33557 13.5411 7.33645 13.3859C7.34172 11.9438 7.33952 10.5014 7.33952 9.05933C7.33952 9.05913 7.3396 9.05894 7.33974 9.0588Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.35232 17.4818C7.35232 16.8821 7.35539 16.2819 7.34968 15.6822C7.34836 15.5516 7.36463 15.4905 7.52246 15.4931C8.14414 15.5037 8.76626 15.5024 9.38794 15.4931C9.53215 15.4909 9.55281 15.5415 9.55237 15.6681C9.54798 16.89 9.5471 18.1118 9.55325 19.3333C9.55413 19.4753 9.50841 19.5003 9.37959 19.499C8.75791 19.4929 8.13579 19.4911 7.51411 19.4999C7.3699 19.5021 7.34836 19.452 7.34968 19.3249C7.35583 18.7102 7.35232 18.096 7.35232 17.4813V17.4818Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.54312 8.99636C9.54312 8.1834 9.54488 7.37088 9.54093 6.55791C9.54049 6.43788 9.55148 6.37589 9.70184 6.37677C10.7051 6.38424 11.7084 6.36446 12.7113 6.38776C13.2833 6.40095 13.8408 6.53021 14.3464 6.81996C15.0103 7.20028 15.3295 7.79604 15.3967 8.54042C15.4464 9.09221 15.4223 9.63697 15.1853 10.1514C14.8072 10.9723 14.1037 11.3416 13.2675 11.521C12.8942 11.601 12.5143 11.6195 12.1332 11.6195C11.3422 11.619 10.5513 11.612 9.76075 11.6247C9.56818 11.6278 9.53697 11.565 9.53917 11.3913C9.5484 10.5933 9.54312 9.79481 9.54312 8.9968V8.99636Z",
                fill: "#04AB38"
            })
        ]
    });
}





parcelRequire("42omo");

function $006cce1c724be652$export$e66a8d6ac96d6ba1() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#017737"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.2336 10.1635C10.2336 11.5838 10.9541 13.1159 12.5396 13.1159C13.7154 13.1159 14.9043 12.198 14.9043 10.1427C14.9043 8.34075 13.9697 7.13106 12.5787 7.13106C11.4453 7.13106 10.2336 7.92728 10.2336 10.1635ZM13.1373 4.5C15.9802 4.5 17.8917 6.75159 17.8917 10.1032C17.8917 13.4022 15.878 15.7053 12.9993 15.7053C11.6268 15.7053 10.7476 15.1175 10.2879 14.6919C10.2912 14.7928 10.2933 14.9058 10.2933 15.0264V19.5H7.34834V7.58072C7.34834 7.40743 7.29292 7.3526 7.12122 7.3526H6.1084V4.74238H8.5796C9.71739 4.74238 10.0086 5.32145 10.0641 5.76782C10.5259 5.25017 11.4833 4.5 13.1373 4.5Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $efcf56f434bcddf3$export$8a27e4cfebfdcb7() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-602.5",
                y: "-507.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.4031 4H13.1618C12.7971 4 12.5015 4.29563 12.5015 4.66032V19.3397C12.5015 19.7044 12.7971 20 13.1618 20H17.4031C17.7677 20 18.0634 19.7044 18.0634 19.3397V4.66032C18.0634 4.29563 17.7677 4 17.4031 4Z",
                fill: "#B25400"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3394V19.9998H6.66032C6.29562 19.9998 6 19.7041 6 19.3394V12.6601C6 12.2954 6.29562 11.9998 6.66032 11.9998H10.9016C11.2663 11.9998 11.5619 12.2954 11.5619 12.6601V19.3394Z",
                fill: "#F3CD32"
            })
        ]
    });
}





parcelRequire("42omo");

function $7c447d6854bf566f$export$89e1f2a7c57f2a4d() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M3 5.71326H21V18.2868H3V5.71326Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask0_719_13847)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.4738 7.08983C11.0548 6.48497 11.8635 6.11041 12.7569 6.11041C13.9481 6.11041 14.9804 6.77218 15.5363 7.75821C16.0297 7.53763 16.5642 7.42374 17.1047 7.42402C19.2488 7.42402 20.9892 9.17769 20.9892 11.3417C20.9892 13.5056 19.2488 15.2593 17.1047 15.2593C16.8426 15.2593 16.5872 15.233 16.337 15.1832C15.8506 16.0501 14.9209 16.6391 13.862 16.6391C13.431 16.6399 13.0054 16.5422 12.6179 16.3532C12.1249 17.5113 10.9767 18.3253 9.63998 18.3253C8.24366 18.3253 7.0591 17.4451 6.60248 16.2076C6.39925 16.2505 6.1921 16.2721 5.98439 16.2719C4.32336 16.2719 2.97998 14.9087 2.97998 13.2344C2.97998 12.1094 3.58483 11.13 4.48219 10.6006C4.29181 10.1621 4.19382 9.689 4.19432 9.21091C4.19432 7.27856 5.7627 5.7168 7.69505 5.7168C8.82667 5.7168 9.83917 6.25614 10.4745 7.09327",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6037 12.2516C5.59239 12.2812 5.60774 12.2873 5.61138 12.2925C5.64519 12.317 5.67954 12.3348 5.71395 12.3547C5.89792 12.452 6.07131 12.4804 6.25263 12.4804C6.62189 12.4804 6.85153 12.2839 6.85153 11.9675V11.9613C6.85153 11.6688 6.59211 11.5623 6.34991 11.4862L6.31821 11.4759C6.1349 11.4165 5.97674 11.3647 5.97674 11.2443V11.2381C5.97674 11.1349 6.06939 11.0588 6.21233 11.0588C6.37115 11.0588 6.56042 11.1117 6.68152 11.1786C6.68152 11.1786 6.71739 11.2018 6.73042 11.1671C6.7375 11.1484 6.79925 10.9832 6.80586 10.9646C6.81288 10.9453 6.80057 10.9306 6.78793 10.9231C6.64896 10.8384 6.45705 10.7808 6.25852 10.7808L6.22166 10.7809C5.8835 10.7809 5.64725 10.9854 5.64725 11.2779V11.2842C5.64725 11.5926 5.90798 11.6932 6.15151 11.7627L6.19069 11.7748C6.36804 11.8294 6.52157 11.8768 6.52157 12.0012V12.0074C6.52157 12.1219 6.42164 12.2072 6.2615 12.2072C6.19922 12.2072 6.00076 12.2062 5.78569 12.0703C5.75968 12.0551 5.74486 12.0442 5.72481 12.0319C5.71422 12.0255 5.68775 12.0139 5.67623 12.0486L5.60344 12.2511M11.0101 12.2511C10.9987 12.2806 11.0141 12.2868 11.0179 12.292C11.0515 12.3165 11.086 12.3342 11.1204 12.3541C11.3044 12.4514 11.4778 12.4799 11.6591 12.4799C12.0284 12.4799 12.258 12.2833 12.258 11.967V11.9608C12.258 11.6683 11.9993 11.5618 11.7564 11.4856L11.7247 11.4754C11.5414 11.416 11.3832 11.3642 11.3832 11.2438V11.2376C11.3832 11.1344 11.4759 11.0583 11.6188 11.0583C11.7776 11.0583 11.9662 11.1112 12.088 11.1781C12.088 11.1781 12.1239 11.2012 12.137 11.1666C12.144 11.1479 12.2058 10.9826 12.2118 10.9641C12.2188 10.9447 12.2065 10.9301 12.1939 10.9226C12.0549 10.8378 11.863 10.7803 11.6645 10.7803L11.6275 10.7804C11.2894 10.7804 11.0531 10.9849 11.0531 11.2774V11.2837C11.0531 11.5921 11.3139 11.6926 11.5574 11.7621L11.5965 11.7743C11.7745 11.8288 11.9274 11.8762 11.9274 12.0006V12.0069C11.9274 12.1213 11.8275 12.2067 11.6673 12.2067C11.6049 12.2067 11.4059 12.2056 11.1915 12.0697C11.1655 12.0546 11.1503 12.0441 11.1306 12.0314C11.1239 12.0272 11.0927 12.015 11.0821 12.0481L11.0093 12.2506M14.7019 11.6312C14.7019 11.8098 14.6686 11.9508 14.6033 12.0507C14.5382 12.1493 14.4398 12.1976 14.3029 12.1976C14.1659 12.1976 14.0679 12.1497 14.0037 12.0514C13.9391 11.9521 13.9065 11.8105 13.9065 11.6318C13.9065 11.4532 13.9393 11.3129 14.0037 11.2143C14.0678 11.1163 14.1652 11.0693 14.3029 11.0693C14.4405 11.0693 14.5385 11.1168 14.6033 11.2143C14.669 11.3129 14.7019 11.4532 14.7019 11.6318M15.0103 11.3003C14.9799 11.1977 14.9329 11.1077 14.87 11.0323C14.8071 10.9568 14.7277 10.8959 14.6331 10.8523C14.5391 10.8083 14.4279 10.7861 14.3022 10.7861C14.1765 10.7861 14.066 10.8084 13.9713 10.8523C13.8773 10.8962 13.7973 10.9568 13.7344 11.0323C13.6717 11.1077 13.6246 11.1977 13.5941 11.3003C13.564 11.4022 13.5487 11.5134 13.5487 11.6318C13.5487 11.7503 13.564 11.8615 13.5941 11.9634C13.6244 12.0659 13.6715 12.1559 13.7344 12.2314C13.7973 12.3068 13.8773 12.3671 13.9713 12.4101C14.066 12.4529 14.1771 12.4748 14.3022 12.4748C14.4273 12.4748 14.5385 12.4529 14.6324 12.4101C14.7264 12.3672 14.8065 12.3068 14.8693 12.2314C14.9321 12.1559 14.9792 12.0659 15.0096 11.9634C15.0397 11.8615 15.055 11.7503 15.055 11.6318C15.055 11.514 15.0397 11.4022 15.0096 11.3003M17.5442 12.1473C17.5341 12.1174 17.5048 12.1287 17.5048 12.1287C17.46 12.1458 17.4122 12.1617 17.3612 12.1696C17.3099 12.1777 17.2527 12.1818 17.1925 12.1818C17.0436 12.1818 16.9244 12.1374 16.8397 12.0494C16.7544 11.9614 16.7067 11.8198 16.7074 11.6279C16.7078 11.4532 16.7501 11.3221 16.8258 11.2215C16.9006 11.1223 17.0158 11.0707 17.168 11.0707C17.295 11.0707 17.3923 11.0854 17.4942 11.1173C17.4942 11.1173 17.5184 11.1278 17.53 11.096C17.557 11.0212 17.577 10.9676 17.6061 10.8856C17.6143 10.8621 17.5942 10.8521 17.5868 10.8493C17.5468 10.8337 17.4525 10.8081 17.381 10.7973C17.3142 10.7871 17.2367 10.7818 17.1494 10.7818C17.0197 10.7818 16.9045 10.804 16.8059 10.8479C16.7073 10.8918 16.6239 10.9525 16.5578 11.0279C16.4916 11.1033 16.4413 11.1933 16.4075 11.2959C16.3741 11.3978 16.3572 11.5097 16.3572 11.6281C16.3572 11.8836 16.4261 12.0907 16.5624 12.2422C16.6987 12.3944 16.9039 12.4712 17.1712 12.4712C17.3294 12.4712 17.4915 12.4393 17.608 12.3931C17.608 12.3931 17.6302 12.3824 17.6206 12.3565L17.5445 12.1473M18.0838 11.4591C18.0985 11.3598 18.1257 11.2771 18.1685 11.2129C18.2325 11.115 18.33 11.0614 18.467 11.0614C18.6039 11.0614 18.6946 11.1153 18.7595 11.2129C18.8025 11.2775 18.8213 11.3632 18.8283 11.4591L18.0805 11.459L18.0838 11.4591ZM19.1228 11.2407C19.0965 11.1421 19.0314 11.0422 18.9891 10.9965C18.9216 10.9244 18.8561 10.8734 18.7906 10.8457C18.696 10.8054 18.5942 10.7848 18.4914 10.785C18.3611 10.785 18.2426 10.807 18.1467 10.8518C18.0507 10.8969 17.97 10.9584 17.9064 11.0351C17.843 11.1119 17.7953 11.2025 17.7648 11.3064C17.7344 11.409 17.719 11.5215 17.719 11.6393C17.719 11.7598 17.735 11.8716 17.7663 11.9728C17.798 12.0748 17.8491 12.1641 17.9179 12.2382C17.9867 12.313 18.0747 12.3712 18.1806 12.4123C18.2858 12.4529 18.4135 12.4741 18.5598 12.4736C18.8616 12.4726 19.0204 12.4054 19.0852 12.369C19.0968 12.3626 19.1077 12.3514 19.0941 12.3191L19.0259 12.1279C19.0155 12.0994 18.9866 12.1097 18.9866 12.1097C18.9119 12.1376 18.806 12.1878 18.5578 12.1871C18.3957 12.1869 18.2759 12.139 18.2005 12.064C18.1237 11.9873 18.0853 11.8754 18.0794 11.7166L19.1249 11.7174C19.1249 11.7174 19.1525 11.7171 19.1553 11.6903C19.1564 11.6791 19.1911 11.4759 19.1242 11.2409L19.1228 11.2407ZM9.7257 11.4591C9.74046 11.3598 9.76772 11.2771 9.81041 11.2129C9.87447 11.115 9.97188 11.0614 10.1089 11.0614C10.2458 11.0614 10.3365 11.1153 10.4014 11.2129C10.4443 11.2775 10.4631 11.3632 10.4702 11.4591L9.72239 11.459L9.7257 11.4591ZM10.7647 11.2407C10.7385 11.1421 10.6733 11.0422 10.631 10.9965C10.5635 10.9244 10.498 10.8734 10.4325 10.8457C10.3379 10.8054 10.2361 10.7848 10.1333 10.785C10.003 10.785 9.88453 10.807 9.78857 10.8518C9.69261 10.8969 9.61188 10.9584 9.54835 11.0351C9.48502 11.1119 9.43717 11.2025 9.40673 11.3064C9.37636 11.409 9.36107 11.5215 9.36107 11.6393C9.36107 11.7598 9.37689 11.8716 9.40845 11.9728C9.44008 12.0748 9.49117 12.1641 9.55933 12.2382C9.62816 12.313 9.71617 12.3712 9.82206 12.4123C9.92728 12.4529 10.0543 12.4741 10.2012 12.4736C10.503 12.4726 10.6618 12.4054 10.7267 12.369C10.7382 12.3626 10.7492 12.3514 10.7355 12.3191L10.6673 12.1279C10.6568 12.0994 10.628 12.1097 10.628 12.1097C10.5532 12.1376 10.4473 12.1878 10.1991 12.1871C10.0377 12.1869 9.91722 12.139 9.84178 12.064C9.76501 11.9873 9.72663 11.8754 9.72067 11.7166L10.7663 11.7174C10.7663 11.7174 10.7938 11.7171 10.7966 11.6903C10.7978 11.6791 10.8324 11.4759 10.7654 11.2409L10.7647 11.2407ZM7.46908 12.1407C7.42812 12.108 7.42243 12.1 7.40886 12.0788C7.38815 12.0468 7.37756 12.0014 7.37756 11.9431C7.37756 11.8518 7.408 11.7856 7.47087 11.7413C7.47021 11.7414 7.56087 11.6632 7.77396 11.6658C7.86881 11.6675 7.96343 11.6756 8.05719 11.69V12.1645H8.05733C8.05733 12.1645 7.92497 12.193 7.77542 12.202C7.56299 12.2148 7.46902 12.1409 7.46968 12.1411L7.46908 12.1407ZM7.88467 11.4062C7.84232 11.4031 7.78739 11.4015 7.72188 11.4015C7.63254 11.4015 7.54585 11.4127 7.46511 11.4345C7.38372 11.4565 7.31026 11.4905 7.24739 11.5357C7.18435 11.5807 7.1325 11.6396 7.09585 11.7078C7.05886 11.7766 7.04 11.8574 7.04 11.9487C7.04 12.0413 7.05608 12.1214 7.08784 12.1869C7.11897 12.2519 7.16583 12.3081 7.22417 12.3504C7.2822 12.3926 7.35387 12.4238 7.43659 12.4424C7.51865 12.4611 7.6113 12.4706 7.71321 12.4706C7.82042 12.4706 7.92696 12.4616 8.03019 12.4441C8.11812 12.429 8.20571 12.4119 8.29292 12.3931C8.32772 12.3851 8.36637 12.3745 8.36637 12.3745C8.39218 12.368 8.3902 12.3404 8.3902 12.3404L8.3896 11.3874C8.3896 11.1783 8.33375 11.0228 8.2235 10.9269C8.11364 10.8309 7.95283 10.7826 7.74438 10.7826C7.66629 10.7826 7.53989 10.7932 7.46445 10.8083C7.46445 10.8083 7.23681 10.8525 7.14283 10.9261C7.14283 10.9261 7.12219 10.9388 7.13344 10.9676L7.20756 11.1661C7.21675 11.1919 7.24183 11.1831 7.24183 11.1831C7.24183 11.1831 7.24971 11.18 7.25897 11.1745C7.45949 11.0653 7.71361 11.0686 7.71361 11.0686C7.82611 11.0686 7.91346 11.0914 7.97169 11.1361C8.02867 11.1798 8.05772 11.246 8.05772 11.3849V11.4291C7.96839 11.4161 7.88567 11.4086 7.88567 11.4086L7.88467 11.4062ZM16.2891 10.8682C16.2906 10.8647 16.2914 10.8609 16.2914 10.8571C16.2914 10.8533 16.2907 10.8495 16.2892 10.846C16.2878 10.8425 16.2856 10.8394 16.2829 10.8367C16.2802 10.834 16.2769 10.832 16.2734 10.8306C16.2556 10.8238 16.1669 10.8051 16.0987 10.8009C15.9677 10.7926 15.8949 10.8148 15.8294 10.8441C15.7646 10.8733 15.693 10.9202 15.6533 10.9745L15.6532 10.8474C15.6532 10.83 15.6408 10.8159 15.6232 10.8159H15.3559C15.3385 10.8159 15.326 10.83 15.326 10.8474V12.4026C15.326 12.411 15.3293 12.419 15.3353 12.425C15.3412 12.4309 15.3492 12.4343 15.3577 12.4343H15.6316C15.64 12.4343 15.6481 12.4309 15.654 12.425C15.6599 12.419 15.6633 12.411 15.6633 12.4026V11.6217C15.6633 11.5171 15.6748 11.4133 15.6977 11.3477C15.7204 11.2829 15.7511 11.2313 15.7891 11.1942C15.8252 11.1584 15.8695 11.1319 15.9181 11.1168C15.9637 11.1037 16.0109 11.0971 16.0584 11.0971C16.113 11.0971 16.1729 11.1111 16.1729 11.1111C16.193 11.1133 16.2042 11.101 16.211 11.0829C16.2289 11.0352 16.2798 10.8923 16.2897 10.8639",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.1503C13.6961 10.14 13.6616 10.1319 13.6267 10.1258C13.5799 10.118 13.5324 10.1143 13.4849 10.1148C13.2961 10.1148 13.1472 10.1681 13.0427 10.2735C12.939 10.378 12.8684 10.5373 12.833 10.7469L12.8202 10.8177H12.5832C12.5832 10.8177 12.5543 10.8165 12.5482 10.848L12.5093 11.0651C12.5066 11.0859 12.5155 11.0988 12.5433 11.0987H12.774L12.5399 12.4052C12.5216 12.5104 12.5006 12.597 12.4774 12.6626C12.4545 12.7273 12.4321 12.7758 12.4046 12.811C12.3779 12.8451 12.3527 12.8702 12.309 12.8848C12.273 12.8969 12.2316 12.9025 12.1862 12.9025C12.1609 12.9025 12.1273 12.8982 12.1025 12.8933C12.0777 12.8884 12.0648 12.8828 12.0462 12.875C12.0462 12.875 12.0191 12.8647 12.0085 12.8918C11.9998 12.914 11.9383 13.0831 11.931 13.104C11.9236 13.1246 11.934 13.1409 11.9471 13.1456C11.9778 13.1566 12.0007 13.1636 12.0425 13.1735C12.1006 13.1872 12.1496 13.188 12.1954 13.188C12.2915 13.188 12.3791 13.1745 12.4517 13.1483C12.5247 13.1219 12.5883 13.0759 12.6446 13.0137C12.7054 12.9465 12.7436 12.8761 12.7802 12.7802C12.8164 12.6851 12.8473 12.567 12.8719 12.4294L13.1071 11.0987H13.451C13.451 11.0987 13.48 11.0998 13.486 11.0683L13.5249 10.8513C13.5276 10.8305 13.5187 10.8175 13.4908 10.8177H13.1571C13.1587 10.8101 13.1739 10.6927 13.2122 10.5822C13.2286 10.535 13.2593 10.497 13.2854 10.4708C13.3098 10.4459 13.3397 10.4273 13.3728 10.4164C13.4091 10.4052 13.4469 10.3998 13.4849 10.4003C13.5163 10.4003 13.5471 10.4041 13.5706 10.4089C13.603 10.4158 13.6156 10.4195 13.624 10.422C13.6581 10.4324 13.6626 10.4223 13.6693 10.4058L13.7491 10.1867C13.7573 10.1631 13.7373 10.1532 13.7299 10.1503ZM9.0662 12.408C9.0662 12.4255 9.05376 12.4397 9.03629 12.4397H8.75947C8.74193 12.4397 8.72949 12.4255 8.72949 12.408V10.18C8.72949 10.1626 8.74193 10.1485 8.75947 10.1485H9.03629C9.05376 10.1485 9.0662 10.1626 9.0662 10.18V12.408Z",
                fill: "#FFFFFE"
            })
        ]
    });
}





parcelRequire("42omo");

function $b531ccdd63c7956d$export$ddeafef64c08610e() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-779.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.2634 5.12647C13.1313 4.90729 12.9448 4.72597 12.722 4.6001C12.4992 4.47423 12.2477 4.40808 11.9918 4.40808C11.7359 4.40808 11.4844 4.47423 11.2616 4.6001C11.0388 4.72597 10.8523 4.90729 10.7202 5.12647L8.62849 8.70913C10.2265 9.50694 11.588 10.7089 12.5779 12.1956C13.5677 13.6823 14.1514 15.4021 14.2711 17.1842H12.8024C12.683 15.6566 12.1667 14.1867 11.3047 12.9199C10.4427 11.6531 9.26492 10.6334 7.8878 9.96162L5.95183 13.309C6.726 13.6562 7.40046 14.1925 7.91318 14.8686C8.4259 15.5446 8.76042 16.3387 8.88598 17.1778H5.51314C5.47313 17.175 5.43447 17.1622 5.40062 17.1407C5.36677 17.1192 5.33881 17.0896 5.31926 17.0546C5.2997 17.0196 5.28917 16.9803 5.28861 16.9402C5.28805 16.9001 5.29747 16.8605 5.31604 16.8249L6.25065 15.2355C5.93401 14.9713 5.57212 14.7667 5.18253 14.6315L4.25746 16.2209C4.16115 16.3861 4.09863 16.5688 4.07353 16.7584C4.04842 16.9479 4.06124 17.1406 4.11122 17.3251C4.16121 17.5097 4.24737 17.6825 4.3647 17.8335C4.48203 17.9844 4.62819 18.1106 4.7947 18.2046C5.01407 18.3282 5.26134 18.3938 5.51314 18.3953H10.1321C10.2179 17.3368 10.0289 16.274 9.58332 15.3099C9.13777 14.3459 8.45081 13.5132 7.58898 12.8926L8.32331 11.621C9.41096 12.3681 10.285 13.3858 10.8592 14.5738C11.4334 15.7618 11.6879 17.0789 11.5976 18.3953H15.5109C15.602 16.4012 15.1682 14.418 14.2528 12.6441C13.3373 10.8701 11.9724 9.36748 10.2943 8.28633L11.7788 5.74318C11.8119 5.68775 11.8655 5.64764 11.928 5.63156C11.9906 5.61549 12.0569 5.62476 12.1126 5.65735C12.2811 5.74954 18.5627 16.7105 18.6803 16.8377C18.701 16.8748 18.7115 16.9168 18.7108 16.9593C18.7101 17.0019 18.6982 17.0435 18.6763 17.0799C18.6543 17.1164 18.6232 17.1464 18.5859 17.1669C18.5487 17.1874 18.5066 17.1978 18.4641 17.1969H16.9509C16.97 17.6017 16.97 18.0054 16.9509 18.4081H18.4705C18.6634 18.4093 18.8547 18.3723 19.0333 18.2991C19.2118 18.226 19.3741 18.1181 19.5107 17.9818C19.6473 17.8455 19.7554 17.6835 19.829 17.5051C19.9025 17.3267 19.94 17.1355 19.9391 16.9426C19.9393 16.6877 19.8713 16.4374 19.742 16.2178L13.2634 5.12647Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $06c972470f79d6df$export$829928eabc615ce1() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0473 4.00178C10.4382 3.99842 8.86528 4.4785 7.53234 5.37978C6.19941 6.28105 5.16796 7.56197 4.57171 9.05646C3.97546 10.5509 3.84191 12.1901 4.18837 13.7614C4.53483 15.3327 5.34532 16.7637 6.51478 17.8688C6.78908 18.13 7.14782 18.2844 7.52608 18.3041C7.90434 18.3237 8.27713 18.2073 8.57701 17.9759C9.56641 17.2396 10.7668 16.842 12.0001 16.842C13.2334 16.842 14.4339 17.2396 15.4233 17.9759C15.726 18.2078 16.1021 18.3232 16.4828 18.301C16.8635 18.2788 17.2236 18.1205 17.4973 17.8549C18.6576 16.7539 19.4626 15.3314 19.8092 13.7698C20.1558 12.2082 20.0282 10.5787 19.4426 9.09017C18.8571 7.60161 17.8404 6.32184 16.5228 5.41488C15.2052 4.50793 13.6467 4.01512 12.0473 3.99963M12.0001 16.0379C11.4713 16.0522 10.9451 15.9586 10.4536 15.7628C9.96216 15.567 9.51573 15.2731 9.1416 14.8991C8.76746 14.525 8.47347 14.0787 8.27754 13.5873C8.08161 13.0959 7.98787 12.5697 8.00202 12.0408C8.00202 10.9805 8.42326 9.96353 9.17305 9.21374C9.92284 8.46395 10.9398 8.04272 12.0001 8.04272C13.0605 8.04272 14.0774 8.46395 14.8272 9.21374C15.577 9.96353 15.9983 10.9805 15.9983 12.0408C16.0124 12.5697 15.9187 13.0959 15.7227 13.5873C15.5268 14.0787 15.2328 14.525 14.8587 14.8991C14.4846 15.2731 14.0381 15.567 13.5467 15.7628C13.0552 15.9586 12.529 16.0522 12.0001 16.0379Z",
                fill: "#62D84E"
            })
        ]
    });
}





parcelRequire("42omo");

function $ab1ed0d0771df855$export$53d8bcde0f28cd56() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-650.5",
                y: "-28.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#0B1228",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.1863 13.1429C14.6523 13.1429 16.6514 11.0962 16.6514 8.57143C16.6514 6.0467 14.6523 4 12.1863 4C9.72029 4 7.72119 6.0467 7.72119 8.57143C7.72119 11.0962 9.72029 13.1429 12.1863 13.1429Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.907 16.9525C18.1675 16.9525 20 15.0763 20 12.762C20 10.4477 18.1675 8.57153 15.907 8.57153C13.6465 8.57153 11.814 10.4477 11.814 12.762C11.814 15.0763 13.6465 16.9525 15.907 16.9525Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.7443 20.0001C14.4911 20.0001 15.9071 18.5504 15.9071 16.762C15.9071 14.9737 14.4911 13.5239 12.7443 13.5239C10.9976 13.5239 9.58154 14.9737 9.58154 16.762C9.58154 18.5504 10.9976 20.0001 12.7443 20.0001Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.9302 8.12585V16.2554C12.9283 16.5379 12.7611 16.7916 12.506 16.8992C12.4248 16.9344 12.3374 16.9525 12.2492 16.9525H9.58506C9.58134 16.8878 9.58134 16.8268 9.58134 16.762C9.5801 16.6984 9.58258 16.6348 9.58878 16.5716C9.65688 15.3538 10.3896 14.2794 11.4827 13.7944V13.0858C9.04996 12.6911 7.39032 10.3521 7.77583 7.86137C7.77851 7.84412 7.78127 7.82688 7.78414 7.80966C7.80266 7.68118 7.82876 7.55396 7.86228 7.42871H12.2493C12.6247 7.43017 12.9287 7.74144 12.9302 8.12585Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78421C7.37074 10.2958 9.00415 12.6544 11.4325 13.0777C11.5061 13.0906 11.5799 13.1015 11.654 13.1105C10.5005 13.6705 9.65993 15.261 9.58849 16.5715C9.5823 16.6348 9.57981 16.6984 9.58104 16.7619C9.58104 16.8267 9.58104 16.8877 9.58476 16.9524C9.59147 17.0805 9.60765 17.2078 9.63313 17.3334H11.8769C12.1528 17.3315 12.4006 17.1603 12.5057 16.8991C12.54 16.8159 12.5578 16.7265 12.5578 16.6362V8.50671C12.5564 8.12245 12.2526 7.81125 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78418C7.37079 10.296 9.00445 12.6548 11.4331 13.078C11.4828 13.0867 11.5326 13.0945 11.5825 13.1014C10.4662 13.7018 9.65879 15.2884 9.58883 16.5715H11.8772C12.2521 16.5686 12.5553 16.2581 12.5581 15.8743V8.50671C12.5567 8.1223 12.2527 7.81103 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.505 7.80957H7.78405C7.39371 10.1568 8.8303 12.4172 11.0845 13.0027C10.231 14.0012 9.70744 15.2502 9.58871 16.5715H11.505C11.8805 16.57 12.1845 16.2587 12.1859 15.8743V8.50671C12.1857 8.12178 11.881 7.80978 11.505 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.68205 7.80957H11.504C11.8807 7.80957 12.186 8.1222 12.186 8.50786V15.4922C12.186 15.8779 11.8807 16.1905 11.504 16.1905H4.68205C4.30536 16.1905 4 15.8779 4 15.4922V8.50786C4 8.1222 4.30536 7.80957 4.68205 7.80957Z",
                        fill: "#026D71"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.04621 11.9147C6.88638 11.8062 6.75286 11.6617 6.65588 11.4922C6.56192 11.3151 6.51508 11.1158 6.52007 10.9143C6.5117 10.6415 6.60162 10.3751 6.77272 10.1658C6.95251 9.95618 7.1849 9.80099 7.44472 9.717C7.74082 9.61722 8.05096 9.56805 8.36267 9.57148C8.77258 9.55614 9.18193 9.61482 9.57197 9.74481V10.621C9.40249 10.5159 9.21791 10.4388 9.02499 10.3924C8.81567 10.3399 8.60088 10.3135 8.38536 10.314C8.15809 10.3054 7.93227 10.3544 7.72787 10.4564C7.57007 10.5261 7.46774 10.6851 7.46741 10.861C7.46677 10.9677 7.50682 11.0705 7.57904 11.1475C7.66434 11.2382 7.76525 11.3121 7.87672 11.3654C8.00074 11.4286 8.18679 11.5127 8.43485 11.6176C8.46217 11.6264 8.48879 11.6374 8.51448 11.6504C8.75862 11.748 8.99415 11.867 9.21848 12.0058C9.38837 12.113 9.53095 12.26 9.63449 12.4347C9.74064 12.6328 9.79209 12.8566 9.78332 13.0824C9.79544 13.3624 9.71174 13.6381 9.54667 13.8618C9.38213 14.0674 9.16216 14.219 8.91411 14.2976C8.62236 14.3912 8.31786 14.4365 8.01215 14.4317C7.73787 14.433 7.46399 14.41 7.19355 14.3631C6.96521 14.3249 6.74237 14.2578 6.53011 14.1635V13.2397C6.733 13.388 6.95967 13.4989 7.19988 13.5673C7.43928 13.6437 7.68814 13.6845 7.93886 13.6884C8.17091 13.7035 8.40255 13.6532 8.60863 13.5429C8.75299 13.4595 8.84079 13.3015 8.83709 13.1319C8.83806 13.0138 8.79244 12.9004 8.71058 12.8172C8.60879 12.7149 8.49093 12.6308 8.36194 12.5684C8.2131 12.4922 7.99393 12.3918 7.70445 12.2671C7.47415 12.1723 7.25365 12.0543 7.04621 11.9147Z",
                        fill: "white"
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $9b849d7a4dcdcc83$export$b33fb54b08bb6422() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-603.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                        fill: "#ECB22E"
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $8144f4c303aabc2c$export$dd0ad7bd8a5794f4() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-171.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.2708 12.9524C12.0781 12.5707 11.8938 12.2011 11.6762 11.8499C11.4003 11.4042 11.1009 10.9773 10.6919 10.6414C10.3847 10.3891 10.0444 10.2293 9.63382 10.2899C9.27961 10.3422 8.99393 10.5287 8.73676 10.7652C8.60099 10.8901 8.47697 11.0271 8.36318 11.1923C8.42475 11.2006 8.47588 11.2054 8.52636 11.2146C8.8921 11.2813 9.17343 11.4943 9.4269 11.7487C9.85292 12.1767 10.1699 12.6838 10.4539 13.2121C11.0905 14.3964 11.5574 15.6505 11.9569 16.9316C11.9608 16.944 11.9643 16.9564 11.9732 16.9859C13.5754 13.1534 15.383 9.45358 17.8734 6.12915L17.9021 6.13874C17.9021 6.22486 17.9021 6.31098 17.9021 6.39688C17.9021 9.19064 17.9052 11.9844 17.9002 14.7784C17.8986 15.6202 17.8858 16.4624 17.8233 17.3027C17.8027 17.5811 17.7742 17.8593 17.6754 18.1242C17.5601 18.4333 17.3395 18.5127 17.0594 18.338C16.8218 18.1898 16.6373 17.9825 16.4822 17.754C16.1504 17.2654 15.831 16.7687 15.6093 16.2167C15.5952 16.1814 15.5917 16.1009 15.5142 16.1761C15.009 16.6673 14.4222 17.0471 13.8187 17.4003C12.0839 18.4152 10.2293 19.1317 8.28355 19.6187C7.58535 19.7934 6.88193 19.9416 6.1735 20.0672C6.10497 20.0794 6.08734 20.0753 6.10192 19.997C6.19656 19.4857 6.23986 18.9697 6.23986 18.449C6.23856 14.0349 6.23964 9.6208 6.23638 5.20669C6.23638 5.09615 6.26314 5.07239 6.37128 5.07239C10.1708 5.07544 13.9701 5.075 17.7696 5.075H17.9017C15.5708 7.38279 13.6026 9.93061 12.2715 12.9526L12.2708 12.9524Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $3dc24bf0d5a17529$export$86ab8f6f2448222e() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.0639 9.32966C11.0639 8.76566 11.5259 8.54366 12.2939 8.54366C13.3979 8.54366 14.7899 8.87966 15.8939 9.47366V6.06566C14.6879 5.58566 13.4999 5.39966 12.2999 5.39966C9.35395 5.39966 7.39795 6.93566 7.39795 9.50366C7.39795 13.5057 12.9119 12.8697 12.9119 14.5977C12.9119 15.2637 12.3299 15.4797 11.5199 15.4797C10.3139 15.4797 8.77795 14.9877 7.55995 14.3217V17.7717C8.90995 18.3537 10.2719 18.5997 11.5199 18.5997C14.5379 18.5997 16.6139 17.1057 16.6139 14.5077C16.5899 10.1877 11.0639 10.9557 11.0639 9.32966Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $3f281fc297b7435c$export$1bcbc9c337da86da() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-506.5",
                y: "-603.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $2c76645f7d847b00$export$e5f255e151507cba() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-731.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.7653 5.01575H7.2667C6.03236 5.01575 5.03174 6.01638 5.03174 7.25072V16.7493C5.03174 17.9837 6.03236 18.9843 7.2667 18.9843H16.7653C17.9996 18.9843 19.0002 17.9837 19.0002 16.7493V7.25072C19.0002 6.01638 17.9996 5.01575 16.7653 5.01575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.98402 11.5604L10.7664 9.9593L10.7699 9.95712L13.6369 8.30708C13.7578 8.23724 13.7635 8.02335 13.6282 7.94565L13.5334 7.89152C13.3951 7.81295 13.2161 7.7108 13.1397 7.66628C13.0728 7.62983 12.9976 7.61118 12.9214 7.61209C12.8452 7.61301 12.7705 7.63347 12.7045 7.67151C12.6368 7.7108 8.12065 10.3072 7.96961 10.3932C7.88062 10.4441 7.77988 10.4708 7.67737 10.4708C7.57485 10.4708 7.47412 10.4441 7.38512 10.3932L5 9.00726V10.1854L5.02444 10.1994C5.61985 10.5464 7.02892 11.3671 7.37377 11.5613C7.58286 11.6792 7.78278 11.6766 7.98402 11.5604Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.98402 13.9142L10.7629 12.3148L10.7734 12.3087L13.6369 10.6608C13.7578 10.591 13.7635 10.3767 13.6282 10.2994L13.5334 10.2453C13.3955 10.1667 13.2161 10.0646 13.1397 10.02C13.0728 9.98359 12.9976 9.96494 12.9214 9.96585C12.8452 9.96677 12.7705 9.98723 12.7045 10.0253C12.6368 10.0641 8.12065 12.661 7.96961 12.7465C7.88062 12.7974 7.77988 12.8242 7.67737 12.8242C7.57485 12.8242 7.47412 12.7974 7.38512 12.7465C7.24282 12.6645 5 11.361 5 11.361V12.5387L5.02444 12.5531C5.62029 12.9002 7.02892 13.7204 7.37377 13.9151C7.58286 14.0329 7.78278 14.0303 7.98402 13.9142Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.7668 14.6663L7.98402 16.2679C7.78279 16.384 7.58242 16.3866 7.37377 16.2688C7.02892 16.0741 5.62029 15.2539 5.02444 14.9069L5 14.8924V13.7147L7.38512 15.1002C7.5654 15.2046 7.7889 15.2032 7.96961 15.1002C8.12065 15.0147 12.6368 12.4178 12.7045 12.3785C12.7705 12.3405 12.8452 12.32 12.9214 12.3191C12.9976 12.3182 13.0728 12.3369 13.1397 12.3733C13.3022 12.4673 13.4652 12.5604 13.6286 12.6527C13.7639 12.7304 13.7578 12.9447 13.6369 13.0146L10.7668 14.6663Z",
                fill: "#DE483A"
            })
        ]
    });
}





parcelRequire("42omo");

function $ff24ccd2e8eec06d$export$4079343fb47e7f0d() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-554.5",
                y: "-363.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M20.5 6.177H3.5V18.551H20.5V6.177Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                mask: "url(#mask0_719_13847)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.77473 18.5019C5.62694 18.5019 4.55554 14.5209 4.31548 13.7465C3.71261 11.8018 3.52935 10.05 3.50994 9.86618C3.39799 8.80539 4.24877 8.06718 5.18252 8.06718C5.8895 8.06718 6.71005 8.49041 6.81877 9.51726C6.83761 9.68995 6.98136 11.1795 7.48984 12.8026C8.02049 14.4964 8.58341 15.1479 8.98879 15.1479C9.64347 15.1479 10.0429 13.4664 10.396 11.8653C10.6562 10.6857 10.9374 9.49712 11.4926 8.44128C12.4585 6.60445 13.9181 6.177 15.1791 6.177C17.944 6.177 19.3278 9.38049 19.3278 10.2105C19.3278 11.5975 18.1965 11.9513 17.7062 11.9513C16.6338 11.9513 16.2703 11.2327 15.9643 10.6029C15.689 10.0363 15.4016 9.56515 15.0299 9.56515C14.9078 9.56515 14.7946 9.62698 14.69 9.73341C13.7662 10.6723 13.4565 15.584 11.6095 17.4612C10.5856 18.5019 9.47152 18.5019 8.77473 18.5019Z",
                        fill: "#00BBFF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M18.8181 8.06718C18.6934 8.06718 18.5681 8.07894 18.4451 8.1032C19.0296 8.94596 19.3221 9.82891 19.3221 10.2104C19.3221 11.5975 18.1907 11.9512 17.7004 11.9512C17.3178 11.9512 17.0254 11.8597 16.7937 11.7134C16.7916 11.7221 16.7895 11.7307 16.7873 11.7394C16.7184 12.0147 16.664 12.3159 16.5698 12.6092C16.3888 13.1729 16.1446 13.8168 15.8839 14.3151C15.6028 14.8523 15.3246 15.1666 14.9929 15.1501C14.6157 15.1314 14.3099 14.6452 13.9298 13.2711C13.8072 12.8281 13.6937 12.3423 13.5885 11.8653C13.3276 10.6822 13.0074 9.49254 12.4598 8.44128C11.5653 6.72426 10.0396 6.177 8.82156 6.177C7.69192 6.177 6.84795 6.71182 6.18495 7.3857C6.00175 7.57192 5.80158 7.82283 5.60059 8.11766C6.17886 8.25694 6.72565 8.69224 6.81293 9.51716C6.83015 9.67444 6.95085 10.9237 7.35628 12.3714C7.4726 12.0084 7.64222 11.4709 8.03625 10.6029C8.22939 10.2054 8.40369 9.94325 8.56092 9.78348C8.70514 9.63686 8.83499 9.57634 8.95193 9.57634C9.07804 9.57634 9.50861 9.69177 9.92778 11.1628C10.4477 12.9869 10.8346 15.8898 12.3086 17.4312C12.9587 18.1111 13.8685 18.551 15.1294 18.551C16.2358 18.551 17.1582 18.0637 17.8159 17.3859C18.8973 16.2712 19.4898 14.4284 19.7011 13.7465C20.3026 11.8064 20.4711 10.0518 20.4907 9.86618C20.6026 8.80539 19.709 8.06718 18.8181 8.06718Z",
                        fill: "#316AFF"
                    })
                ]
            })
        ]
    });
}





parcelRequire("42omo");

function $5f5d32c70f5a63e8$export$9969d63eaadfddf7() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-219.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#03363D"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.6092 9.34881V17.3365H4.99316L11.6092 9.34881ZM11.6092 6.48242C11.6092 7.35976 11.2607 8.20117 10.6403 8.82155C10.0199 9.44192 9.17853 9.79044 8.30119 9.79044C7.42384 9.79044 6.58244 9.44192 5.96206 8.82155C5.34169 8.20117 4.99316 7.35976 4.99316 6.48242H11.6092ZM12.6991 17.3372C12.6991 16.4598 13.0477 15.6184 13.668 14.9981C14.2884 14.3777 15.1298 14.0292 16.0072 14.0292C16.8845 14.0292 17.7259 14.3777 18.3463 14.9981C18.9667 15.6184 19.3152 16.4598 19.3152 17.3372H12.6991ZM12.6991 14.4708V6.48242H19.3166L12.6991 14.4701V14.4708Z",
                fill: "white"
            })
        ]
    });
}





parcelRequire("42omo");

function $3da03c02f1e28d89$export$81c909fcf490b72b() {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    });
}


/**
 * A RovoLogo is a subset API that works for both @atlaskit/logo and @atlaskit/icon
 * We use one or the other depending on 1P or 3P and need a consistent API internall
 */ 


parcelRequire("42omo");

/* svg-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $f95ec2a2406cb31b$var$styles = {
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStylesSmall: "_1bsb7vkz _4t3i7vkz",
    iconContainerStylesMedium: "_1bsb1tcg _4t3i1tcg",
    iconContainerStylesLarge: "_1bsbzwfg _4t3izwfg",
    iconContainerStylesXlarge: "_1bsbzwfg _4t3izwfg"
};
function $f95ec2a2406cb31b$export$1776e6671850176d({ glyph: SVG, label: label, size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($f95ec2a2406cb31b$var$styles.iconContainerStyles, size === 'small' && $f95ec2a2406cb31b$var$styles.iconContainerStylesSmall, size === 'medium' && $f95ec2a2406cb31b$var$styles.iconContainerStylesMedium, size === 'large' && $f95ec2a2406cb31b$var$styles.iconContainerStylesLarge, size === 'xlarge' && $f95ec2a2406cb31b$var$styles.iconContainerStylesXlarge),
        "aria-label": label,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)(SVG, {})
    });
}


function $2aacac2388c218c6$var$isCorrectableRovoSize(size) {
    return [
        'xsmall',
        'xxsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
}
/**
 * Due a bug in ADS custom icons are one size smaller (than atlaskit/logo)
 * To accommodate for this behavior you need to use one size bigger than what you need
 * See: https://atlassian.slack.com/archives/CFJ9DU39U/p1714096323217799
 */ const $2aacac2388c218c6$var$correctedSize = {
    xsmall: 'small',
    xxsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $2aacac2388c218c6$export$dae027fade2c6d1d = function RovoLogoFromSVG(glyph, defaultLabel = '', defaultSize) {
    return ({ label: label = defaultLabel, size: size = defaultSize, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f95ec2a2406cb31b$export$1776e6671850176d), {
            label: label,
            glyph: glyph,
            size: size && $2aacac2388c218c6$var$isCorrectableRovoSize(size) ? $2aacac2388c218c6$var$correctedSize[size] : 'medium',
            testId: testId
        });
};
const $2aacac2388c218c6$export$32db889b380fa03c = function RovoLogoFromLogo(LogoComponent, defaultLabel = '') {
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'small',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
};
function $2aacac2388c218c6$export$d9dd23d057506f56(iconGlyph, iconLabel, size) {
    return $2aacac2388c218c6$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}


const $62b8bb78b7be4ba7$var$AppKeys1P = {
    Atlas: 'Atlas',
    Bitbucket: 'Bitbucket',
    Compass: 'Compass',
    Confluence: 'Confluence',
    Jira: 'Jira',
    JiraProductDiscovery: 'Jira Product Discovery',
    JiraServiceManagement: 'Jira Service Management',
    Trello: 'Trello',
    Focus: 'Mercury'
};
const $62b8bb78b7be4ba7$var$AppKeys3P = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'Figma',
    Github: 'Github',
    GoogleDrive: 'Google',
    GoogleDriveProvider: 'Google Drive provider',
    GoogleDriveSmartLink: 'Google Drive',
    GoogleSheetsSmartLink: 'GoogleDrive',
    Loom: 'Loom',
    OneDrive: 'One Drive',
    Dropbox: 'Dropbox',
    Slack: 'Slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3'
};
const $62b8bb78b7be4ba7$var$app1PIcons = {
    [$62b8bb78b7be4ba7$var$AppKeys1P.Confluence]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.ConfluenceIcon), 'Confluence'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.Atlas]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $4Nwes.AtlassianIcon), 'Home'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.Jira]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.JiraIcon), 'Jira'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.JiraProductDiscovery]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.JiraServiceManagement]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.JiraServiceManagementIcon), 'Jira Service Management'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.Bitbucket]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.BitbucketIcon), 'Bitbucket'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.Trello]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.TrelloIcon), 'Trello'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.Compass]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.CompassIcon), 'Compass'),
    [$62b8bb78b7be4ba7$var$AppKeys1P.Focus]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.FocusIcon), 'Focus')
};
const $62b8bb78b7be4ba7$var$app3PIcons = {
    [$62b8bb78b7be4ba7$var$AppKeys3P.AdobeXD]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $9feb222af1dce22a$export$be8cba599441db6e), 'Adobe XD'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.AdobeSign]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $ddfac4772597e4fc$export$600af2172b0f5fb), 'Adobe Sign'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Aha]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $ddb96d62bbe64059$export$f28fe6c5ebff8c30), 'Aha'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Airtable]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $7f1ad59b32ead886$export$88b64eee273831fd), 'Airtable'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Amplitude]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $29a96fe4504d29d4$export$5e013c7991ef7bd0), 'Amplitude'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Asana]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $6712df246ca23297$export$671541d0c7918cd9), 'Asana'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.AzureDevops]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $70454930bfdc1b5b$export$2dcf704e717ca168), 'Azure Devops'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Box]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $a3086153acbe9efd$export$adedf1569d7107de), 'Box'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Canva]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $33bbad668c06286f$export$3ad1ba1bf426d64a), 'Canva'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Docusign]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $07312a4c36093ee3$export$393452da0e179bab), 'Docusign'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Dovetail]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $649aeb4f72eb8e0e$export$e67ec9178da81ba8), 'Dovetail'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Dropbox]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $28635332c9030ba5$export$5e2362bb78414664), 'Dropbox'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Figma]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $cd7b17c4dcd78e0d$export$54e0f4982aa79afe), 'Figma'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Freshservice]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $245cc3e615a9d0f0$export$327de5bc0476c8b8), 'Freshservice'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Gmail]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $bc8429e13282fa5c$export$856bad9032bbc5ed), 'Gmail'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Github]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $43a1f6f54a8f6e01$export$e8e65f186ccd8749), 'Github'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Gitlab]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $9fec69967aee1632$export$8b4e5326778cce0f), 'Gitlab'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.GoogleCalendar]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $f723749284877ab9$export$5d128e0a6ffc0558), 'Google Calendar'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Hubspot]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $f8ec2e28f7c99a9d$export$c9a6a66ee7acc43a), 'Hubspot'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Lucid]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $975bad8ec722883c$export$8664694e1d7db2a0), 'Lucid'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Loom]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $e210e3d638a9f31f$export$8d789f76fde3e05), 'Loom'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Miro]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $83380eab7f65abc9$export$38410c1d5582587e), 'Miro'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Monday]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $14b5b34168aa3868$export$37b4104f63b2f4bd), 'Monday'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Mural]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $55733c527f2afdac$export$807a21e0dcf114c4), 'Mural'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Notion]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $862eece563b2b3e7$export$694ff710b1e20299), 'Notion'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.OutlookCalendar]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $e639aeb102e9bd55$export$62b570fbaf793397), 'Outlook Calendar'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.OutlookMail]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $9a0f3be089c1e397$export$d905606eb58fea64), 'Outlook Mail'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Pipedrive]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $006cce1c724be652$export$e66a8d6ac96d6ba1), 'Pipedrive'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Salesforce]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $7c447d6854bf566f$export$89e1f2a7c57f2a4d), 'Salesforce'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Sentry]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $b531ccdd63c7956d$export$ddeafef64c08610e), 'Sentry'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Sharepoint]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $ab1ed0d0771df855$export$53d8bcde0f28cd56), 'Sharepoint'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Slack]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $9b849d7a4dcdcc83$export$b33fb54b08bb6422), 'Slack'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Smartsheet]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $8144f4c303aabc2c$export$dd0ad7bd8a5794f4), 'Smartsheet'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Stripe]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $3dc24bf0d5a17529$export$86ab8f6f2448222e), 'Stripe'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Teams]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $3f281fc297b7435c$export$1bcbc9c337da86da), 'Teams'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Todoist]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $2c76645f7d847b00$export$e5f255e151507cba), 'Todoist'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Webex]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $ff24ccd2e8eec06d$export$4079343fb47e7f0d), 'Webex'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Zeplin]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $3da03c02f1e28d89$export$81c909fcf490b72b), 'Zeplin'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Zendesk]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $5f5d32c70f5a63e8$export$9969d63eaadfddf7), 'Zendesk'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.Gitbook]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $6a7d1e69fe712847$export$6da1c7984975c183), 'Gitbook'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.AtlassianWebCrawler]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), 'Atlassian Web Crawler'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.ConfluenceDC]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.ConfluenceIcon), 'Confluence'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.JiraDC]: (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, $lAFHW.JiraIcon), 'Jira'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.LaunchDarkly]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $f17c70c4cfb4081d$export$68470e68dec0bc46), 'LaunchDarkly'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.PagerDuty]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $477f6e8600c1261e$export$e9a3fd43f9d4bddc), 'PagerDuty'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.PowerBI]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $efcf56f434bcddf3$export$8a27e4cfebfdcb7), 'PowerBI'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.ServiceNow]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $06c972470f79d6df$export$829928eabc615ce1), 'ServiceNow'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.AWSS3]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $5d06adcb9db7f090$export$abf71a44e930800c), 'AWSS3'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.GoogleDrive]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $c341e8e2d9bbb303$export$e16bd899bb4eebf9), 'GoogleDrive'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.GoogleDriveProvider]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $c341e8e2d9bbb303$export$e16bd899bb4eebf9), 'GoogleDrive'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.GoogleDriveSmartLink]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $c341e8e2d9bbb303$export$e16bd899bb4eebf9), 'GoogleDrive'),
    [$62b8bb78b7be4ba7$var$AppKeys3P.GoogleSheetsSmartLink]: (0, $2aacac2388c218c6$export$d9dd23d057506f56)((0, $c341e8e2d9bbb303$export$e16bd899bb4eebf9), 'GoogleDrive')
};
const $62b8bb78b7be4ba7$var$appIcons = {
    ...$62b8bb78b7be4ba7$var$app1PIcons,
    ...$62b8bb78b7be4ba7$var$app3PIcons
};
const $62b8bb78b7be4ba7$export$1ba5735493686b70 = {
    ...$62b8bb78b7be4ba7$var$AppKeys1P,
    ...$62b8bb78b7be4ba7$var$AppKeys3P
};
const $62b8bb78b7be4ba7$var$FallbackIcon = (0, $2aacac2388c218c6$export$32db889b380fa03c)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))));
const $62b8bb78b7be4ba7$export$5153830bdfb71453 = /*#__PURE__*/ (0, $42omo.memo)(function AppIcon({ app: app, size: size, fallbackIcon: fallbackIcon }) {
    if (!app) return fallbackIcon ? fallbackIcon : /*#__PURE__*/ (0, $l998X.jsx)($62b8bb78b7be4ba7$var$FallbackIcon, {
        size: size,
        label: ""
    });
    const appKey = Object.values($62b8bb78b7be4ba7$export$1ba5735493686b70).find((value)=>value.toLowerCase() === app.toLowerCase());
    const Icon = appKey ? $62b8bb78b7be4ba7$var$appIcons[appKey] : null;
    return Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        size: size,
        testId: "app-icon"
    }) : fallbackIcon ? fallbackIcon : /*#__PURE__*/ (0, $l998X.jsx)($62b8bb78b7be4ba7$var$FallbackIcon, {
        size: size,
        label: ""
    });
});
module.exports["AppIcon"] = $62b8bb78b7be4ba7$export$5153830bdfb71453;

});

parcelRegister("1l2X9", function(module, exports) {

let $0f9a0b0950ca4751$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f9a0b0950ca4751$var$load("cPSQq").then(()=>parcelRequire('fLCGB'));

});

parcelRegister("fbVTr", function(module, exports) {
/* lumina-layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7bZ3i = parcelRequire("7bZ3i");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $4dwEP = parcelRequire("4dwEP");

const $944aa94b7874c817$var$CITATION_REGEX = /\[\^(\d+)\^\]/g;
function $944aa94b7874c817$export$e375e629e7745579(modelOutput, previousParsedAnswer, sectionHashCache) {
    if (!modelOutput || typeof modelOutput !== 'string') return [];
    try {
        const cleanedContent = $944aa94b7874c817$var$cleanStreamingContent(modelOutput);
        const sections = $944aa94b7874c817$var$parseHTMLToSections(cleanedContent);
        const stabilizedSections = $944aa94b7874c817$var$stabilizeSectionReferences(sections, previousParsedAnswer, sectionHashCache);
        return stabilizedSections;
    } catch  {
        return [];
    }
}
/**
 * Cleans streaming content by removing incomplete tags and citation markers
 */ function $944aa94b7874c817$var$cleanStreamingContent(content) {
    // Remove inline citation indicators
    // https://atlassian.slack.com/archives/C09KC9NV23W/p1769026048635919?thread_ts=1769020398.811119&cid=C09KC9NV23W
    let cleaned = content.replace($944aa94b7874c817$var$CITATION_REGEX, '');
    // Remove incomplete opening tags at the end
    cleaned = cleaned.replace(/<[^>]*$/, '');
    // Remove unclosed carousel tags to prevent visual flickering
    cleaned = $944aa94b7874c817$var$removeUnclosedCarousels(cleaned);
    return cleaned;
}
/**
 * Removes unclosed carousel tags and their contents to prevent rendering children
 * before the carousel wrapper is complete (which causes visual flickering)
 */ function $944aa94b7874c817$var$removeUnclosedCarousels(content) {
    const openTags = content.match(/<carousel[^>]*>/g);
    const closeTags = content.match(/<\/carousel>/g);
    const hasUnclosedCarousel = (openTags?.length || 0) > (closeTags?.length || 0);
    if (hasUnclosedCarousel) {
        const lastCarouselIndex = content.lastIndexOf('<carousel');
        if (lastCarouselIndex >= 0) return content.substring(0, lastCarouselIndex);
    }
    return content;
}
/**
 * Parses HTML string into section objects
 */ function $944aa94b7874c817$var$parseHTMLToSections(htmlContent) {
    const root = (0, $4dwEP.parse)(htmlContent);
    const body = root.querySelector('body') || root;
    const sections = [];
    body.childNodes.forEach((element)=>{
        const jsonElement = $944aa94b7874c817$var$elementToJson(element);
        if (jsonElement) sections.push(jsonElement);
    });
    return sections;
}
/**
 * Stabilizes section references by reusing unchanged sections from previous parse
 * This optimization prevents unnecessary re-renders in React components
 */ function $944aa94b7874c817$var$stabilizeSectionReferences(sections, previousParsedAnswer, sectionHashCache) {
    // No optimization if no cache provided
    if (!sectionHashCache) return sections;
    // First parse - initialize cache
    if (!previousParsedAnswer || previousParsedAnswer.length === 0) {
        sections.forEach((section, i)=>{
            const hash = JSON.stringify(section);
            sectionHashCache.set(i, hash);
        });
        return sections;
    }
    // Subsequent parses - reuse stable references
    const stabilized = sections.map((section, i)=>{
        // Check if this section existed in the previous parse
        // If yes: compare hashes to decide whether to reuse or recreate
        // If no: this is a new section being added during streaming
        if (i < previousParsedAnswer.length) {
            const newHash = JSON.stringify(section);
            const prevHash = sectionHashCache.get(i);
            // Reuse previous reference if content unchanged
            if (prevHash === newHash) return previousParsedAnswer[i];
            // Content changed, update cache
            sectionHashCache.set(i, newHash);
            return section;
        }
        // New section, cache its hash
        const newHash = JSON.stringify(section);
        sectionHashCache.set(i, newHash);
        return section;
    });
    // Clean up cache for removed sections
    if (sections.length < previousParsedAnswer.length) for(let i = sections.length; i < previousParsedAnswer.length; i++)sectionHashCache.delete(i);
    return stabilized;
}
function $944aa94b7874c817$var$elementToJson(element) {
    // node types: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType === 3) {
        // text node
        const text = element.text.trim();
        return text ? text : null;
    }
    // not an element node: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType !== 1) return null;
    const htmlElement = element; // text node already processed
    const result = {
        tag: htmlElement.tagName.toLowerCase()
    };
    // Add attributes if they exist
    if (htmlElement.attributes && Object.keys(htmlElement.attributes).length > 0 && typeof result !== 'string') result.attributes = htmlElement.attributes;
    // Process children
    const children = [];
    htmlElement.childNodes.forEach((child)=>{
        // handles text + element nodes
        const childJson = $944aa94b7874c817$var$elementToJson(child);
        if (childJson) children.push(childJson);
    });
    if (children.length > 0 && typeof result !== 'string') result.children = children;
    return result;
}


/* lumina-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1bHXt = parcelRequire("1bHXt");


var $u9agA = parcelRequire("u9agA");










var $cO1el = parcelRequire("cO1el");

/* animated-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");




const $dd4edbf57792132d$var$fadeIn = null;
const $dd4edbf57792132d$var$styles = {
    animatedContainer: "_y44vtk0h _1wpz1fhb _tzy4idpf",
    nonAnimatedContainer: "_1e0c1bgi"
};
const $dd4edbf57792132d$export$9382739d0e79620f = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, isStreaming: isStreaming = false })=>{
    if (isStreaming) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $dd4edbf57792132d$var$styles.animatedContainer
        ]),
        children: children
    }, "animated-container-div");
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $dd4edbf57792132d$var$styles.nonAnimatedContainer
        ]),
        children: children
    }, "animated-container-div");
});
$dd4edbf57792132d$export$9382739d0e79620f.displayName = 'AnimatedContainer';


const $f578abe134f80a62$export$a4c5b7d08a7d4edf = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, isStreaming: isStreaming = false, id: id, level: level = 'h2' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dd4edbf57792132d$export$9382739d0e79620f), {
        isStreaming: isStreaming,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
            size: "xsmall",
            as: level,
            id: id,
            children: children
        })
    });
});
$f578abe134f80a62$export$a4c5b7d08a7d4edf.displayName = 'AnimatedHeader';





parcelRequire("42omo");




parcelRequire("42omo");

/* carousel-element.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $fFa3V = parcelRequire("fFa3V");


var $lvsjl = parcelRequire("lvsjl");


var $dQl1W = parcelRequire("dQl1W");


var $1qfLF = parcelRequire("1qfLF");


var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");






var $iXCQx = parcelRequire("iXCQx");


var $8HDcK = parcelRequire("8HDcK");


/* project-highlight-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");








const $a88c8e03a1362412$var$styles = {
    container: "_2rko1mok _1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    summaryBox: "_p12f1wdt"
};
const $a88c8e03a1362412$export$234acf94f0f3118e = ({ component: component })=>{
    const title = component?.attributes?.title || '';
    const text = component?.attributes?.content || '';
    return title || text ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($a88c8e03a1362412$var$styles.container),
        space: "space.200",
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.050",
            xcss: $a88c8e03a1362412$var$styles.summaryBox,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    size: "medium",
                    maxLines: 1,
                    children: title
                }),
                text && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    maxLines: 1,
                    children: text
                })
            ]
        })
    }) : null;
};


/* related-person-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $auNCB = parcelRequire("auNCB");









const $8ce39b05d9494371$var$PersonCarouselCardStyles = {
    personCardContainer: "_2rko1mok _4bfu1r31 _1hmsglyw _ajmmnqa1 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _p12f1kdj _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa",
    contactInfoSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _18u0u2gc _1ul9idpf _1bto1l2s"
};
const $8ce39b05d9494371$export$412ce534c98e8f03 = ({ component: component })=>{
    const personAttributes = component.attributes;
    const { name: name, job_title: job_title, avatar_url: avatar_url, url: url } = personAttributes || {};
    if (!url) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: url,
        xcss: $8ce39b05d9494371$var$PersonCarouselCardStyles.personCardContainer,
        testId: "lumina-layout-person-card",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                        appearance: "circle",
                        src: avatar_url || '',
                        size: "large"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $8ce39b05d9494371$var$PersonCarouselCardStyles.contactInfoSection,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                weight: "bold",
                                size: "medium",
                                maxLines: 1,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                maxLines: 1,
                                children: job_title
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/* smartlink-element.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $dwp40 = parcelRequire("dwp40");

async function $9f87b17e5213600b$var$fetchRestResponse({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
const $9f87b17e5213600b$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $9f87b17e5213600b$export$ce7efc011dbfc5b9 = ({ urls: urls })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [objectResolverData, setObjectResolverData] = (0, $42omo.useState)([]);
    const urlKeys = (0, $42omo.useMemo)(()=>urls.join('|'), [
        urls
    ]);
    (0, $42omo.useEffect)(()=>{
        const fetchObjectResolver = async ()=>{
            if (!urls.length) {
                setIsLoading(false);
                return;
            }
            try {
                setIsLoading(true);
                const objectResolver = await $9f87b17e5213600b$var$fetchRestResponse({
                    url: $9f87b17e5213600b$var$OBJECT_RESOLVER_ENDPOINT,
                    body: urls.map((url)=>({
                            resourceUrl: url
                        }))
                });
                if (!objectResolver) {
                    setIsLoading(false);
                    return;
                }
                const objectData = objectResolver.filter((obj)=>obj.status === 200);
                setObjectResolverData(objectData.map((objData)=>objData.body.data));
                setIsLoading(false);
            } catch  {
                setIsLoading(false);
            }
        };
        fetchObjectResolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        urlKeys
    ]);
    return {
        isLoading: isLoading,
        objectResolverData: objectResolverData
    };
};






const $3588fdba5f517647$var$styles = {
    smartLink: "_1bsb2hgv"
};
/**
 * Convert SmartLinkElement to KnowledgeCardSource format
 */ function $3588fdba5f517647$var$convertToKnowledgeCardSource(component, resolvedData) {
    const url = component.attributes?.url || '';
    const title = component.attributes?.title;
    return {
        id: resolvedData?.['@id'] || url,
        title: title || resolvedData?.name || url,
        url: url,
        product: resolvedData?.generator?.name || null,
        type: resolvedData?.['@type'] || 'link',
        iconUrl: resolvedData?.generator?.icon?.url || null,
        lastModified: resolvedData?.dateModified || null,
        spaceName: null,
        spaceUrl: null,
        ari: resolvedData?.ari
    };
}
const $3588fdba5f517647$export$b63c2c8154b9321f = ({ component: component, variant: variant, isStandalone: isStandalone, isStreaming: isStreaming = false })=>{
    const url = component.attributes?.url || '';
    const isActionCard = component.attributes?.type === 'action';
    const effectiveVariant = isActionCard ? (0, $8HDcK.CardVariant).ACTION_CARD : variant;
    const { objectResolverData: objectResolverData } = (0, $9f87b17e5213600b$export$ce7efc011dbfc5b9)({
        urls: [
            url
        ]
    });
    const resolvedData = objectResolverData?.[0];
    const source = $3588fdba5f517647$var$convertToKnowledgeCardSource(component, resolvedData);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dd4edbf57792132d$export$9382739d0e79620f), {
        isStreaming: isStreaming,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: isStandalone && $3588fdba5f517647$var$styles.smartLink,
            testId: "lumina-layout-smart-link",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8HDcK.KnowledgeSmartCard), {
                source: source,
                variant: effectiveVariant
            }, url)
        })
    });
};


const $7e8d059c01b56b89$var$carouselCardWidth = 355; // card width (300px) + gap (space.200 = 16px)
const $7e8d059c01b56b89$var$scrollWidth = ($7e8d059c01b56b89$var$carouselCardWidth + 46) * 2;
const $7e8d059c01b56b89$var$styles = {
    carouselStyles: "_zulpu2gc _1e0c1txw _4cvr1y6m _kqswh2mm _2lx21bp4 _1bsb1osq",
    carouselStylesSingleRow: "_1e0c1txw _4cvr1y6m _kqswh2mm _2lx21bp4 _1bsb1osq _19pkmgjw",
    scrollContainerStyles: "_1reo1wug _18m915vq _1e0c1ule _1bsb1osq _1fjgglyw _1dm8q5uf",
    scrollContainerNoScroll: "_1reo15vq _18m915vq _1e0c1ule _1bsb1osq",
    cardContainerOneItem: "_zulppxbi _1e0c11p5 _yv0ehkll",
    cardContainerTwoItems: "_zulppxbi _1e0c11p5 _yv0ewxkt",
    cardContainerThreePlusItems: "_zulppxbi _1e0c11p5 _yv0e1ckl _wij21bp4 _1ejihkll",
    carouselItemStyles: "_1ul9194s _p12f1gwv",
    carouselItemStylesFoldable: "_1ul9rvwn _p12f4qx2"
};
const $7e8d059c01b56b89$var$CarouselItemRenderer = ({ child: child, isFoldable: isFoldable, isStreaming: isStreaming })=>{
    const isProjectHighlight = typeof child !== 'string' && child.tag === 'project-highlight-card';
    const isRelatedPeopleCard = typeof child !== 'string' && child.tag === 'people-card';
    const isSmartLink = typeof child !== 'string' && child.tag === 'smart-link';
    if (isProjectHighlight) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "carousel-item-project-highlight-card",
        xcss: isFoldable ? $7e8d059c01b56b89$var$styles.carouselItemStylesFoldable : $7e8d059c01b56b89$var$styles.carouselItemStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a88c8e03a1362412$export$234acf94f0f3118e), {
            component: child
        })
    });
    if (isRelatedPeopleCard) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "carousel-item-people-card",
        xcss: isFoldable ? $7e8d059c01b56b89$var$styles.carouselItemStylesFoldable : $7e8d059c01b56b89$var$styles.carouselItemStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8ce39b05d9494371$export$412ce534c98e8f03), {
            component: child
        })
    });
    if (isSmartLink) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "carousel-item-smart-link",
        xcss: isFoldable ? $7e8d059c01b56b89$var$styles.carouselItemStylesFoldable : $7e8d059c01b56b89$var$styles.carouselItemStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3588fdba5f517647$export$b63c2c8154b9321f), {
            component: child,
            variant: (0, $8HDcK.CardVariant).COMPACT,
            isStreaming: isStreaming
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {});
};
const $7e8d059c01b56b89$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $7e8d059c01b56b89$var$isScrollAtRight = (elem)=>elem ? Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $7e8d059c01b56b89$export$5a8dc035195828f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ component: component, position: position, showArrows: showArrows = true, isFoldable: isFoldable = false, isStreaming: isStreaming = false })=>{
    const scrollContainerRef = (0, $42omo.useRef)(null);
    const [hideLeftScroll, setHideLeftScroll] = (0, $42omo.useState)(true);
    const [hideRightScroll, setHideRightScroll] = (0, $42omo.useState)(false);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key_id = (0, $42omo.useRef)((0, $dQl1W.v4)());
    const carouselChildren = component.children || [];
    const shouldAlignHeader = position === 'single-column';
    const updateArrowVisibility = (0, $42omo.useCallback)(()=>{
        if (scrollContainerRef.current) {
            setHideLeftScroll($7e8d059c01b56b89$var$isScrollAtLeft(scrollContainerRef.current));
            setHideRightScroll($7e8d059c01b56b89$var$isScrollAtRight(scrollContainerRef.current));
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer && carouselChildren.length) {
            updateArrowVisibility();
            const unbind = (0, $fFa3V.bind)(scrollContainer, {
                type: 'scroll',
                listener: updateArrowVisibility
            });
            return unbind;
        }
    }, [
        carouselChildren.length,
        updateArrowVisibility
    ]);
    const [onScroll] = (0, $lvsjl.default)(()=>{
        updateArrowVisibility();
    }, 30);
    const scrollLeft = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft -= $7e8d059c01b56b89$var$scrollWidth;
    };
    const scrollRight = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft += $7e8d059c01b56b89$var$scrollWidth;
    };
    if (!carouselChildren || carouselChildren.length < 2) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dd4edbf57792132d$export$9382739d0e79620f), {
        isStreaming: isStreaming,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1bHXt.cx)(shouldAlignHeader ? $7e8d059c01b56b89$var$styles.carouselStylesSingleRow : $7e8d059c01b56b89$var$styles.carouselStyles),
            testId: "lumina-layout-carousel",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    grow: "fill",
                    alignBlock: "center",
                    children: [
                        !shouldAlignHeader && component.attributes?.title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            space: "space.100",
                            alignBlock: "center",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                weight: "semibold",
                                size: "small",
                                color: "color.text.accent.gray",
                                testId: "carousel-title",
                                children: component.attributes?.title
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {}),
                        showArrows && (!hideLeftScroll || !hideRightScroll) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                                    label: "scroll left",
                                    onClick: scrollLeft,
                                    shape: "circle",
                                    appearance: "subtle",
                                    spacing: "compact",
                                    isDisabled: hideLeftScroll
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                                    label: "scroll right",
                                    onClick: scrollRight,
                                    shape: "circle",
                                    appearance: "subtle",
                                    spacing: "compact",
                                    isDisabled: hideRightScroll
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: carouselChildren.length <= 3 ? $7e8d059c01b56b89$var$styles.scrollContainerNoScroll : $7e8d059c01b56b89$var$styles.scrollContainerStyles,
                    ref: scrollContainerRef,
                    onScroll: onScroll,
                    tabIndex: carouselChildren.length > 3 ? 0 : undefined,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: carouselChildren.length === 1 ? $7e8d059c01b56b89$var$styles.cardContainerOneItem : carouselChildren.length === 2 ? $7e8d059c01b56b89$var$styles.cardContainerTwoItems : $7e8d059c01b56b89$var$styles.cardContainerThreePlusItems,
                        children: carouselChildren.map((child, index)=>/*#__PURE__*/ (0, $l998X.jsx)($7e8d059c01b56b89$var$CarouselItemRenderer, {
                                child: child,
                                index: index,
                                isFoldable: isFoldable,
                                isStreaming: isStreaming
                            }, `${key_id.current}-${index}`))
                    })
                })
            ]
        })
    });
});


const $335d968982bb4b8c$export$69746635676f73c5 = ({ data: data, isStreaming: isStreaming = false })=>{
    if (!data) return null;
    try {
        const projectHighlightsData = data;
        const projectHighlightsCarouselChildren = projectHighlightsData.highlights.map((projectHighlight)=>({
                tag: 'project-highlight-card',
                attributes: {
                    title: projectHighlight.title,
                    content: projectHighlight.content
                }
            }));
        if (!projectHighlightsCarouselChildren.length) return null;
        const projectHighlightsCarouselComponent = {
            tag: 'carousel',
            children: projectHighlightsCarouselChildren
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $7e8d059c01b56b89$export$5a8dc035195828f2), {
            component: projectHighlightsCarouselComponent,
            position: "two-rows-bottom",
            showArrows: false,
            isStreaming: isStreaming
        });
    } catch  {
        return null;
    }
};





parcelRequire("42omo");


const $a4d9b67d0d68e4da$export$7d1c5f3a997c97e2 = ({ data: data, isStreaming: isStreaming = false })=>{
    if (!data) return null;
    try {
        const relatedPeopleData = data;
        const relatedPeopleCarouselChildren = relatedPeopleData.people.map((person)=>({
                tag: 'people-card',
                attributes: {
                    name: person.name,
                    job_title: person.jobTitle,
                    avatar_url: person.avatarUrl,
                    url: person.url
                }
            }));
        if (!relatedPeopleCarouselChildren.length) return null;
        const relatedPeopleCarouselComponent = {
            tag: 'carousel',
            attributes: {
                title: 'Related People'
            },
            children: relatedPeopleCarouselChildren
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $7e8d059c01b56b89$export$5a8dc035195828f2), {
            component: relatedPeopleCarouselComponent,
            position: "two-rows-bottom",
            isStreaming: isStreaming
        });
    } catch  {
        return null;
    }
};



/* markdown-element.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $67O0h = parcelRequire("67O0h");


var $4pEXC = parcelRequire("4pEXC");

const $71dd9323b59c030f$var$fadeIn = null;
const $71dd9323b59c030f$var$animatedStyles = {
    container: "_y44vtk0h"
};
const $71dd9323b59c030f$var$unboundAnimatedStyles = {
    container: "_tzy4idpf",
    listItem: "_22jztk0h _cz7ridpf"
}; // Animated components for streaming
const $71dd9323b59c030f$var$StaggeredChild = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, index: index })=>{
    // If children is a string longer than 10 characters, split it into 3 parts
    if (typeof children === 'string' && children.length > 10) {
        const chunkSize = Math.ceil(children.length / 3);
        const parts = [
            children.slice(0, chunkSize),
            children.slice(chunkSize, chunkSize * 2),
            children.slice(chunkSize * 2)
        ];
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: parts.map((part, partIndex)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                    style: {
                        animationDelay: `${index * 200 + partIndex * 100}ms`
                    },
                    className: (0, $gMc0m.default)([
                        $71dd9323b59c030f$var$animatedStyles.container,
                        $71dd9323b59c030f$var$unboundAnimatedStyles.container
                    ]),
                    children: part
                }, partIndex))
        });
    } // For non-strings or short strings, render normally
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            animationDelay: `${index * 200}ms`
        },
        className: (0, $gMc0m.default)([
            $71dd9323b59c030f$var$animatedStyles.container,
            $71dd9323b59c030f$var$unboundAnimatedStyles.container
        ]),
        children: children
    });
});
$71dd9323b59c030f$var$StaggeredChild.displayName = 'StaggeredChild';
const $71dd9323b59c030f$var$AnimatedParagraph = /*#__PURE__*/ (0, $42omo.memo)(({ children: children })=>{
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).filter((child)=>{
        // Defensive: Filter out 0 (in case it leaks through from other code paths)
        // React.Children.toArray already filters out null, undefined, and false
        if (child === 0) return false;
         // Filter out empty strings
        return child !== '';
    }); // If no valid children after filtering, return null
    if (childrenArray.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "p",
        children: childrenArray.map((child, index)=>{
            // Use content-based keys to preserve component identity during streaming
            // This prevents re-animating existing content when new content is added
            const key = typeof child === 'string' ? `${child.substring(0, 20)}-${index}` // Use content prefix + index
             : index;
            return /*#__PURE__*/ (0, $l998X.jsx)($71dd9323b59c030f$var$StaggeredChild, {
                index: index,
                children: child
            }, key);
        })
    });
});
$71dd9323b59c030f$var$AnimatedParagraph.displayName = 'AnimatedParagraph';
const $71dd9323b59c030f$var$AnimatedOrderedList = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("ol", {
        ...props,
        className: (0, $gMc0m.default)([
            $71dd9323b59c030f$var$animatedStyles.container,
            $71dd9323b59c030f$var$unboundAnimatedStyles.container,
            $71dd9323b59c030f$var$unboundAnimatedStyles.listItem
        ]),
        children: children
    });
});
$71dd9323b59c030f$var$AnimatedOrderedList.displayName = 'AnimatedOrderedList';
const $71dd9323b59c030f$var$AnimatedBulletedList = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("ul", {
        ...props,
        className: (0, $gMc0m.default)([
            $71dd9323b59c030f$var$animatedStyles.container,
            $71dd9323b59c030f$var$unboundAnimatedStyles.container,
            $71dd9323b59c030f$var$unboundAnimatedStyles.listItem
        ]),
        children: children
    });
});
$71dd9323b59c030f$var$AnimatedBulletedList.displayName = 'AnimatedBulletedList';
const $71dd9323b59c030f$var$AnimatedHeading = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    const headingLevel = props.level || 1;
    const HeadingTag = `h${headingLevel}`;
    return /*#__PURE__*/ (0, $l998X.jsx)(HeadingTag, {
        ...props,
        className: (0, $gMc0m.default)([
            $71dd9323b59c030f$var$animatedStyles.container,
            $71dd9323b59c030f$var$unboundAnimatedStyles.container
        ]),
        children: children
    });
});
$71dd9323b59c030f$var$AnimatedHeading.displayName = 'AnimatedHeading'; // Node components for ReactRenderer
const $71dd9323b59c030f$var$animatedNodeComponents = {
    paragraph: $71dd9323b59c030f$var$AnimatedParagraph,
    orderedList: $71dd9323b59c030f$var$AnimatedOrderedList,
    bulletList: $71dd9323b59c030f$var$AnimatedBulletedList,
    heading: $71dd9323b59c030f$var$AnimatedHeading
};
const $71dd9323b59c030f$export$306d71fe0c137f28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ component: component, isStreaming: isStreaming = false })=>{
    const markdown = component.children?.[0]; // Use streaming flag to control Smart Links processing
    const docContent = (0, $42omo.useMemo)(()=>markdown ? (0, $4pEXC.encodeAdf)(markdown) : undefined, [
        markdown
    ]); // Memoize renderer config
    const rendererConfig = (0, $42omo.useMemo)(()=>{
        if (!docContent) return undefined;
        return {
            document: docContent,
            nodeComponents: $71dd9323b59c030f$var$animatedNodeComponents,
            // Enable smart links
            smartLinks: {
                ssr: true
            }
        };
    }, [
        docContent
    ]);
    if (!rendererConfig) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: isStreaming ? 'markdown-element-streaming' : 'markdown-element',
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                ...rendererConfig
            })
        })
    });
});



/**
 * Adapter for smart link elements
 * Ensures all smart links are rendered as standalone cards
 */ const $0722f66029f524e8$var$SmartLinkElementAdapter = ({ component: component, variant: variant, isStreaming: isStreaming })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3588fdba5f517647$export$b63c2c8154b9321f), {
        component: component,
        variant: variant,
        isStandalone: true,
        isStreaming: isStreaming
    });
/**
 * Adapter for action card elements
 * Converts action card elements into smart link elements with validation
 */ const $0722f66029f524e8$var$ActionCardElementAdapter = ({ component: component, variant: variant, isStreaming: isStreaming })=>{
    const actionCard = component;
    // Validate component has a url and convert to smart link
    if (!actionCard.attributes?.url) return null;
    const smartLinkComponent = {
        tag: 'smart-link',
        attributes: {
            url: actionCard.attributes.url,
            title: actionCard.attributes?.title,
            type: 'action',
            pos: actionCard.attributes?.pos
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3588fdba5f517647$export$b63c2c8154b9321f), {
        component: smartLinkComponent,
        variant: variant,
        isStandalone: true,
        isStreaming: isStreaming
    });
};
/**
 * Adapter for related people sub-agent elements
 * Extracts related people data from the sub-agent data map
 */ const $0722f66029f524e8$var$RelatedPeopleElementAdapter = ({ subAgentDataMap: subAgentDataMap, isStreaming: isStreaming })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a4d9b67d0d68e4da$export$7d1c5f3a997c97e2), {
        data: subAgentDataMap.relatedPeople,
        isStreaming: isStreaming
    });
/**
 * Adapter for project highlights sub-agent elements
 * Extracts project highlights data from the sub-agent data map
 */ const $0722f66029f524e8$var$ProjectHighlightsElementAdapter = ({ subAgentDataMap: subAgentDataMap, isStreaming: isStreaming })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $335d968982bb4b8c$export$69746635676f73c5), {
        data: subAgentDataMap.projectHighlights,
        isStreaming: isStreaming
    });
const $0722f66029f524e8$export$b2fda7bfcffcc236 = {
    'action-card': $0722f66029f524e8$var$ActionCardElementAdapter,
    carousel: (0, $7e8d059c01b56b89$export$5a8dc035195828f2),
    md: (0, $71dd9323b59c030f$export$306d71fe0c137f28),
    'project-highlights': $0722f66029f524e8$var$ProjectHighlightsElementAdapter,
    'related-people': $0722f66029f524e8$var$RelatedPeopleElementAdapter,
    'smart-link': $0722f66029f524e8$var$SmartLinkElementAdapter
};


/**
 * Valid layout types for section elements
 */ function $c0b099fcb91307c0$export$52e6c7c72e88442f(element) {
    return typeof element !== 'string' && element.tag === 'h';
}





parcelRequire("42omo");

/* foldable-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");







const $b5cf2de2bfc3af1b$var$MAX_EXPANDED_HEIGHT = '500px'; // Only webkit-specific styles that require @compiled/react
const $b5cf2de2bfc3af1b$var$unboundedStyles = {
    lineClamp: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54 _1yyjkb7n"
};
const $b5cf2de2bfc3af1b$var$styles = {
    root: "_19pkpxbi _1bsb1osq",
    rootPointer: "_80omtlke",
    contentWrapper: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    contentExpanded: "_c71ldgin",
    contentCollapsed: "_c71lvbgk",
    divider: "_15a5nqa1 _uwhke4h9 _1i531l7x _19pkpxbi",
    headerWrapper: "_otyru2gc"
}; /**
    * FoldableWrapper - A reusable wrapper for making any layout foldable
    * This is used by foldable layout renderers, not directly by LuminaSection
    *
    * Accessibility notes:
    * - When collapsed: Clickable section is interactive (expands on click/keyboard)
    * - When expanded: Only IconButton is interactive (collapses on click)
    * - IconButton has aria-expanded and aria-controls
    * - Content region has proper ARIA semantics with aria-labelledby
    * - Preview content remains accessible when collapsed (no aria-hidden)
    */ 
const $b5cf2de2bfc3af1b$export$852db9b4a485dca = ({ defaultFoldedState: defaultFoldedState = 'expanded', header: header, content: content, children: children, isStreaming: isStreaming = false, renderElement: renderElement })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const [isFolded, setIsFolded] = (0, $42omo.useState)(defaultFoldedState === 'collapsed');
    const sectionKey = `folded-section-${header?.children || ''}`; // Generate unique IDs for ARIA relationships
    const contentId = (0, $42omo.useId)();
    const headerId = (0, $42omo.useId)();
    const headerText = header?.children || 'section'; // Find the best element for preview when collapsed
    // Prefer text-based elements (md, list) over visual elements (carousel, smart-link, etc.)
    const previewElement = content.length === 0 ? undefined : content.find((element)=>{
        if (typeof element === 'string') return true;
        return element.tag === 'md' || element.tag === 'ul' || element.tag === 'ol' || element.tag === 'list';
    }) || content[0]; // Only handle keyboard events when collapsed
    const handleKeyDown = (event)=>{
        if ((event.key === 'Enter' || event.key === ' ') && isFolded) {
            event.preventDefault();
            setIsFolded(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($b5cf2de2bfc3af1b$var$styles.root, isFolded && $b5cf2de2bfc3af1b$var$styles.rootPointer),
        testId: "lumina-layout-foldable-section",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: isFolded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))),
                        label: `${isFolded ? 'Expand' : 'Collapse'} ${headerText}`,
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setIsFolded(!isFolded),
                        testId: isFolded ? 'expand-button' : 'collapse-button',
                        "aria-expanded": !isFolded,
                        "aria-controls": contentId
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        ref: containerRef,
                        onClick: isFolded ? ()=>setIsFolded(false) : undefined,
                        onKeyDown: isFolded ? handleKeyDown : undefined,
                        tabIndex: isFolded ? 0 : undefined,
                        role: isFolded ? 'button' : undefined,
                        "aria-label": isFolded ? `Expand ${headerText}` : undefined,
                        "aria-controls": isFolded ? contentId : undefined,
                        "data-testid": "lumina-layout-foldable-clickable-section",
                        className: (0, $gMc0m.default)([
                            $b5cf2de2bfc3af1b$var$styles.contentWrapper,
                            isFolded ? $b5cf2de2bfc3af1b$var$styles.contentCollapsed : $b5cf2de2bfc3af1b$var$styles.contentExpanded
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                alignBlock: "center",
                                xcss: $b5cf2de2bfc3af1b$var$styles.headerWrapper,
                                children: header && header.attributes?.show !== 'false' && content && /*#__PURE__*/ (0, $l998X.jsx)((0, $f578abe134f80a62$export$a4c5b7d08a7d4edf), {
                                    id: headerId,
                                    isStreaming: isStreaming,
                                    children: header.children
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                id: contentId,
                                role: "region",
                                "aria-labelledby": headerId,
                                children: isFolded ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    className: (0, $gMc0m.default)([
                                        $b5cf2de2bfc3af1b$var$unboundedStyles.lineClamp
                                    ]),
                                    children: previewElement && renderElement({
                                        component: previewElement,
                                        position: 'single-column',
                                        isFoldable: true
                                    })
                                }, `${sectionKey}-collapsed`) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    children: children
                                }, `${sectionKey}-expanded`)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b5cf2de2bfc3af1b$var$styles.divider
            })
        ]
    });
};





const $6663e79b738242a4$export$1a9cda7e8be08d8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    if (props.content.length < 1) return null;
    return props.renderElement({
        component: props.content[0],
        position: 'single-column',
        isFoldable: props.isFoldable
    });
}, (prevProps, nextProps)=>{
    return prevProps.content === nextProps.content && prevProps.isFoldable === nextProps.isFoldable && prevProps.isStreaming === nextProps.isStreaming && prevProps.subAgentDataMap === nextProps.subAgentDataMap;
});


/* two-columns-layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 



















function $b5bc31a34d91a5df$export$fd29db098e42c3fc(observeTargetRef, resizeObserverCallback, pollInterval = 100, additionalDeps = []) {
    const resizeObserverRef = (0, $42omo.useRef)(null);
    const pollIntervalRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const observeDelayedTarget = ()=>{
            if (!observeTargetRef.current) return;
            // clear polling once target is ready
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
            resizeObserverRef.current = new ResizeObserver(resizeObserverCallback);
            resizeObserverRef.current.observe(observeTargetRef.current);
        };
        // start polling for the target
        observeDelayedTarget(); // check immediately
        pollIntervalRef.current = setInterval(observeDelayedTarget, pollInterval);
        return ()=>{
            if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
            if (resizeObserverRef.current) resizeObserverRef.current.disconnect();
        };
    }, [
        ...additionalDeps
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}


const $a726ad27191f1430$export$7cd3afc49691a77e = (elements, position, defaultIndex)=>{
    const result = [];
    for(let i = 0; i < elements.length; i++){
        const element = elements[i];
        if (typeof element === 'string') continue;
        if (element.attributes?.pos === position || i === defaultIndex && !element.attributes?.pos) result.push(element);
    }
    return result;
};


// Tags that represent text content
const $a48c677329749195$var$TEXT_CONTENT_TAGS = [
    'md',
    'list'
];
// Tags that represent smart links
const $a48c677329749195$var$SMART_LINK_TAGS = [
    'smart-link',
    'action-card'
];
// Max height of a full-size smart link card
const $a48c677329749195$var$FULL_SMART_LINK_CARD_MAX_HEIGHT = 174;
const $a48c677329749195$export$88261377d3b4456a = $a48c677329749195$var$FULL_SMART_LINK_CARD_MAX_HEIGHT * 0.75;
/**
 * Check if an element is text content (markdown or list)
 */ const $a48c677329749195$var$isTextContent = (element)=>typeof element !== 'string' && $a48c677329749195$var$TEXT_CONTENT_TAGS.includes(element.tag);
/**
 * Check if an element is a smart link
 */ const $a48c677329749195$var$isSmartLink = (element)=>typeof element !== 'string' && $a48c677329749195$var$SMART_LINK_TAGS.includes(element.tag);
function $a48c677329749195$export$e6011e70d0aef97f(elements) {
    const textContentRef = (0, $42omo.useRef)(null);
    const [textHeight, setTextHeight] = (0, $42omo.useState)(null);
    // Measure text content height after render
    const handleResize = (0, $42omo.useCallback)((entries)=>{
        const entry = entries[0];
        if (entry) setTextHeight(entry.contentRect.height);
    }, []);
    (0, $b5bc31a34d91a5df$export$fd29db098e42c3fc)(textContentRef, handleResize);
    // Separate elements by position
    const leftElements = (0, $a726ad27191f1430$export$7cd3afc49691a77e)(elements, 'left', 0);
    const rightElements = (0, $a726ad27191f1430$export$7cd3afc49691a77e)(elements, 'right', 1);
    // Determine which column has text content and which has smart links
    const leftHasText = leftElements.some($a48c677329749195$var$isTextContent);
    const rightHasSmartLink = rightElements.some($a48c677329749195$var$isSmartLink);
    const leftHasSmartLink = leftElements.some($a48c677329749195$var$isSmartLink);
    const rightHasText = rightElements.some($a48c677329749195$var$isTextContent);
    // Determine card variant based on measured text height
    // Default to compact card and when text content is shorter than 75% of the full-size smart card height
    const isTextMeasured = textHeight !== null;
    const useCompactCard = !isTextMeasured || isTextMeasured && textHeight <= $a48c677329749195$export$88261377d3b4456a;
    const cardVariant = useCompactCard ? (0, $8HDcK.CardVariant).COMPACT : (0, $8HDcK.CardVariant).FULL;
    // Determine which column should have the ref for measurement
    // Left column takes precedence when both columns would need measurement
    // (since only one ref can be attached at a time)
    const leftNeedsMeasurement = leftHasText && rightHasSmartLink;
    const rightNeedsMeasurement = rightHasText && leftHasSmartLink && !leftNeedsMeasurement;
    return {
        textContentRef: textContentRef,
        isTextMeasured: isTextMeasured,
        cardVariant: cardVariant,
        leftNeedsMeasurement: leftNeedsMeasurement,
        rightNeedsMeasurement: rightNeedsMeasurement,
        leftElements: leftElements,
        rightElements: rightElements
    };
}


const $fc86a93765b435c6$export$ed928b8607b8b4cd = ({ key: key, pos: pos, index: index })=>{
    if (key && pos) return `${key}-${pos}-${index}`;
    if (key) return `${key}-${index}`;
    if (pos) return `${pos}-${index}`;
    return index;
};


const $349983d64f67881b$var$columnStyles = {
    leftColumnStyles: "_16jlkb7n _1o9zkb7n _1ul9idpf",
    rightColumnStyles: "_1o9zidpf _1ul9idpf"
};
const $349983d64f67881b$export$fcf2a74f0286e542 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { textContentRef: textContentRef, leftNeedsMeasurement: leftNeedsMeasurement, rightNeedsMeasurement: rightNeedsMeasurement, leftElements: leftElements, rightElements: rightElements, cardVariant: cardVariant } = (0, $a48c677329749195$export$e6011e70d0aef97f)(props.content);
    if (props.content.length < 2) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.200",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $349983d64f67881b$var$columnStyles.leftColumnStyles,
                ref: leftNeedsMeasurement ? textContentRef : undefined,
                testId: "two-column-layout-left",
                children: leftElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                        children: props.renderElement({
                            component: element,
                            position: 'two-columns-left',
                            variant: cardVariant,
                            isFoldable: props.isFoldable
                        })
                    }, (0, $fc86a93765b435c6$export$ed928b8607b8b4cd)({
                        key: props.sectionKey,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $349983d64f67881b$var$columnStyles.rightColumnStyles,
                ref: rightNeedsMeasurement ? textContentRef : undefined,
                testId: "two-column-layout-right",
                children: rightElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                        children: props.renderElement({
                            component: element,
                            position: 'two-columns-right',
                            variant: cardVariant,
                            isFoldable: props.isFoldable
                        })
                    }, (0, $fc86a93765b435c6$export$ed928b8607b8b4cd)({
                        key: props.sectionKey,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            })
        ]
    });
}, (prevProps, nextProps)=>{
    return prevProps.content === nextProps.content && prevProps.isFoldable === nextProps.isFoldable && prevProps.isStreaming === nextProps.isStreaming && prevProps.subAgentDataMap === nextProps.subAgentDataMap;
});


/* two-rows-layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 












const $5da91cc668d72fd4$var$rowStyles = {
    rowStyle: "_1bsb1osq"
};
const $5da91cc668d72fd4$export$a5b98da5c2b58aac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    if (props.content.length < 2) return null;
    const topElements = (0, $a726ad27191f1430$export$7cd3afc49691a77e)(props.content, 'top', 0);
    const bottomElements = (0, $a726ad27191f1430$export$7cd3afc49691a77e)(props.content, 'bottom', 1);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $5da91cc668d72fd4$var$rowStyles.rowStyle,
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $5da91cc668d72fd4$var$rowStyles.rowStyle,
                children: topElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                        children: props.renderElement({
                            component: element,
                            position: 'two-rows-top',
                            isFoldable: props.isFoldable
                        })
                    }, (0, $fc86a93765b435c6$export$ed928b8607b8b4cd)({
                        key: props.sectionKey,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $5da91cc668d72fd4$var$rowStyles.rowStyle,
                children: bottomElements.map((element, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                        children: props.renderElement({
                            component: element,
                            position: 'two-rows-bottom',
                            isFoldable: props.isFoldable
                        })
                    }, (0, $fc86a93765b435c6$export$ed928b8607b8b4cd)({
                        key: props.sectionKey,
                        pos: element.attributes?.pos,
                        index: index
                    })))
            })
        ]
    });
}, (prevProps, nextProps)=>{
    return prevProps.content === nextProps.content && prevProps.isFoldable === nextProps.isFoldable && prevProps.isStreaming === nextProps.isStreaming && prevProps.subAgentDataMap === nextProps.subAgentDataMap;
});


/**
 * Higher-order component that wraps any layout component with FoldableWrapper
 * This eliminates code duplication for all foldable layout variants
 */ const $fadd3985a34ed156$var$makeFoldable = (BaseLayout)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $b5cf2de2bfc3af1b$export$852db9b4a485dca), {
            defaultFoldedState: props.defaultFoldedState,
            header: props.header,
            content: props.content,
            isStreaming: props.isStreaming,
            renderElement: props.renderElement,
            children: /*#__PURE__*/ (0, $l998X.jsx)(BaseLayout, {
                ...props
            })
        });
    };
};
// Create foldable versions by wrapping base components
const $fadd3985a34ed156$var$OneColumnFoldableLayout = $fadd3985a34ed156$var$makeFoldable((0, $6663e79b738242a4$export$1a9cda7e8be08d8));
const $fadd3985a34ed156$var$TwoColumnsFoldableLayout = $fadd3985a34ed156$var$makeFoldable((0, $349983d64f67881b$export$fcf2a74f0286e542));
const $fadd3985a34ed156$var$TwoRowsFoldableLayout = $fadd3985a34ed156$var$makeFoldable((0, $5da91cc668d72fd4$export$a5b98da5c2b58aac));
const $fadd3985a34ed156$export$436877424f7f3246 = {
    'one-column': (0, $6663e79b738242a4$export$1a9cda7e8be08d8),
    'one-column-foldable': $fadd3985a34ed156$var$OneColumnFoldableLayout,
    overview: (0, $6663e79b738242a4$export$1a9cda7e8be08d8),
    'two-columns': (0, $349983d64f67881b$export$fcf2a74f0286e542),
    'two-columns-foldable': $fadd3985a34ed156$var$TwoColumnsFoldableLayout,
    'two-rows': (0, $5da91cc668d72fd4$export$a5b98da5c2b58aac),
    'two-rows-foldable': $fadd3985a34ed156$var$TwoRowsFoldableLayout
};


const $405a4c4bd2a911cf$var$styles = {
    overviewStyle: "_2rko1mok _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhkhfxm _otyrpxbi",
    sectionWrapperStyles: "_19pk1ejb"
};
const $405a4c4bd2a911cf$export$a8f74688b79f0c73 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ section: section, subAgentDataMap: subAgentDataMap, defaultFoldedState: defaultFoldedState, isStreaming: isStreaming = false })=>{
    const sectionKey = section.attributes?.n;
    const layout = section.attributes?.layout || 'one-column';
    const isOverview = section.attributes?.overview === '1';
    const isFoldable = section.attributes?.folded === '1';
    // Wrapper function to render elements using the map
    const renderElement = (0, $42omo.useCallback)((options)=>{
        if (typeof options.component === 'string' || !options.component.tag) return null;
        const props = {
            position: options.position,
            variant: options.variant,
            isFoldable: options.isFoldable ?? false,
            isStreaming: isStreaming,
            subAgentDataMap: subAgentDataMap
        };
        const ElementComponent = (0, $0722f66029f524e8$export$b2fda7bfcffcc236)[options.component.tag];
        return ElementComponent ? /*#__PURE__*/ (0, $l998X.jsx)(ElementComponent, {
            component: options.component,
            ...props
        }) : null;
    }, [
        isStreaming,
        subAgentDataMap
    ]);
    // Memoize content and header extraction to prevent unnecessary re-renders
    // When parser reuses section objects, section.children will have stable reference
    const content = (0, $42omo.useMemo)(()=>{
        if (!Array.isArray(section.children)) return undefined;
        return section.children.filter((element)=>!(0, $c0b099fcb91307c0$export$52e6c7c72e88442f)(element));
    }, [
        section.children
    ]);
    const header = (0, $42omo.useMemo)(()=>{
        if (!Array.isArray(section.children)) return undefined;
        const headerElements = section.children.filter((element)=>(0, $c0b099fcb91307c0$export$52e6c7c72e88442f)(element));
        return headerElements.length ? headerElements[0] : undefined;
    }, [
        section.children
    ]);
    if (!content || content && !content.length) return null;
    // Create props for layout renderer
    const layoutProps = {
        content: content,
        isFoldable: isFoldable,
        isStreaming: isStreaming,
        sectionKey: sectionKey,
        subAgentDataMap: subAgentDataMap,
        renderElement: renderElement,
        header: header,
        defaultFoldedState: defaultFoldedState
    };
    // Determine layout type (add -foldable suffix if needed, but never for overview)
    const layoutType = isFoldable && layout !== 'overview' ? `${layout}-foldable` : layout;
    // Render layout using the map
    const renderContent = ()=>{
        const LayoutComponent = (0, $fadd3985a34ed156$export$436877424f7f3246)[layoutType];
        return LayoutComponent ? /*#__PURE__*/ (0, $l998X.jsx)(LayoutComponent, {
            ...layoutProps
        }) : null;
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        alignInline: "start",
        xcss: (0, $1bHXt.cx)(isOverview && $405a4c4bd2a911cf$var$styles.overviewStyle),
        testId: "lumina-layout-section",
        "data-layout": layout,
        "data-overview": isOverview,
        children: [
            header && header.attributes?.show !== 'false' && content && !isFoldable && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                xcss: $405a4c4bd2a911cf$var$styles.sectionWrapperStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f578abe134f80a62$export$a4c5b7d08a7d4edf), {
                    isStreaming: isStreaming,
                    children: header.children
                })
            }),
            renderContent()
        ]
    });
}, (prevProps, nextProps)=>{
    // Only re-render if props actually changed
    return prevProps.section === nextProps.section && prevProps.subAgentDataMap === nextProps.subAgentDataMap && prevProps.defaultFoldedState === nextProps.defaultFoldedState && prevProps.isStreaming === nextProps.isStreaming;
});


const $44b52cc43e398fc2$export$8a161f487bc08d6e = (parsedAnswer)=>{
    let firstFoldableSectionIdx = -1;
    for(let i = 0; i < parsedAnswer.length; i++)if (parsedAnswer[i].attributes?.folded === '1') {
        firstFoldableSectionIdx = i;
        break;
    }
    return firstFoldableSectionIdx;
};


const $7e0d5f72a870a6b3$var$styles = {
    containerStyles: "_y3gn1e5h"
};
const $7e0d5f72a870a6b3$var$LuminaLayoutInner = ({ luminaTagResponse: luminaTagResponse, luminaSubAgentResponse: luminaSubAgentResponse, isStreaming: isStreaming = false })=>{
    // Refs for parser stability optimization
    const parsedAnswerRef = (0, $42omo.useRef)([]);
    const sectionHashCacheRef = (0, $42omo.useRef)(new Map());
    const parsedAnswer = (0, $42omo.useMemo)(()=>{
        const result = (0, $944aa94b7874c817$export$e375e629e7745579)(luminaTagResponse, parsedAnswerRef.current, sectionHashCacheRef.current);
        // Update the ref after parsing for next render
        parsedAnswerRef.current = result;
        return result;
    }, [
        luminaTagResponse
    ]);
    const firstFoldableIndex = (0, $42omo.useMemo)(()=>(0, $44b52cc43e398fc2$export$8a161f487bc08d6e)(parsedAnswer), [
        parsedAnswer
    ]);
    // Parse sub-agent responses once and create a lookup map
    const subAgentDataMap = (0, $42omo.useMemo)(()=>{
        if (!luminaSubAgentResponse) return {};
        const map = {};
        luminaSubAgentResponse.forEach((response)=>{
            try {
                if (response.sub_agent_name === 'PROJECT_HIGHLIGHTS') map.projectHighlights = JSON.parse(response.data);
                else if (response.sub_agent_name === 'ENTITY_RELATED_PEOPLE') map.relatedPeople = JSON.parse(response.data);
            // eslint-disable-next-line no-unused-vars
            } catch (_error) {
            // TODO: add proper error logging
            }
        });
        return map;
    }, [
        luminaSubAgentResponse
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $7e0d5f72a870a6b3$var$styles.containerStyles,
            testId: "lumina-layout-container",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                children: parsedAnswer && parsedAnswer.length && parsedAnswer.map((section, index)=>{
                    const isFoldable = section.attributes?.folded === '1';
                    const defaultFoldedState = isFoldable ? index === firstFoldableIndex ? 'expanded' : 'collapsed' : undefined;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $405a4c4bd2a911cf$export$a8f74688b79f0c73), {
                        section: section,
                        subAgentDataMap: subAgentDataMap,
                        defaultFoldedState: defaultFoldedState,
                        isStreaming: isStreaming
                    }, index);
                })
            })
        })
    });
};
const $7e0d5f72a870a6b3$export$4a0e4fac99de0a72 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($7e0d5f72a870a6b3$var$LuminaLayoutInner);
$7e0d5f72a870a6b3$export$4a0e4fac99de0a72.displayName = 'LuminaLayout';
module.exports["LuminaLayout"] = $7e0d5f72a870a6b3$export$4a0e4fac99de0a72;

});

parcelRegister("asvGx", function(module, exports) {
"use strict";
var $79d518eea6e34b0e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $79d518eea6e34b0e$var$node_1 = $79d518eea6e34b0e$var$__importDefault((parcelRequire("1vK45")));

const $79d518eea6e34b0e$var$type_1 = $79d518eea6e34b0e$var$__importDefault((parcelRequire("luckw")));
class $79d518eea6e34b0e$var$CommentNode extends $79d518eea6e34b0e$var$node_1.default {
    clone() {
        return new $79d518eea6e34b0e$var$CommentNode(this.rawText, null, undefined, this.rawTagName);
    }
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */ get text() {
        return this.rawText;
    }
    toString() {
        return `<!--${this.rawText}-->`;
    }
    constructor(rawText, parentNode = null, range, rawTagName = '!--'){
        super(parentNode, range);
        this.rawText = rawText;
        this.rawTagName = rawTagName;
        /**
         * Node Type declaration.
         * @type {Number}
         */ this.nodeType = $79d518eea6e34b0e$var$type_1.default.COMMENT_NODE;
    }
}
module.exports.default = $79d518eea6e34b0e$var$CommentNode;

});

parcelRegister("1vK45", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jopS9 = parcelRequire("jopS9");

/**
 * Node Class as base class for TextNode and HTMLElement.
 */ class $119c6b3b10e48544$var$Node {
    /**
     * Remove current node
     */ remove() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            this.parentNode.childNodes = children.filter((child)=>{
                return this !== child;
            });
            this.parentNode = null;
        }
        return this;
    }
    get innerText() {
        return this.rawText;
    }
    get textContent() {
        return (0, $jopS9.decode)(this.rawText);
    }
    set textContent(val) {
        this.rawText = (0, $jopS9.encode)(val);
    }
    constructor(parentNode = null, range){
        this.parentNode = parentNode;
        this.childNodes = [];
        Object.defineProperty(this, 'range', {
            enumerable: false,
            writable: true,
            configurable: true,
            value: range !== null && range !== void 0 ? range : [
                -1,
                -1
            ]
        });
    }
}
module.exports.default = $119c6b3b10e48544$var$Node;

});

parcelRegister("jopS9", function(module, exports) {
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */ (function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code,
    // and use it as `root`.
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ // All astral symbols.
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    // All ASCII symbols (not just printable ASCII) except those listed in the
    // first column of the overrides table.
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
    // code points listed in the first column of the overrides table on
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = {
        '\xAD': 'shy',
        '\u200C': 'zwnj',
        '\u200D': 'zwj',
        '\u200E': 'lrm',
        '\u2063': 'ic',
        '\u2062': 'it',
        '\u2061': 'af',
        '\u200F': 'rlm',
        '\u200B': 'ZeroWidthSpace',
        '\u2060': 'NoBreak',
        '\u0311': 'DownBreve',
        '\u20DB': 'tdot',
        '\u20DC': 'DotDot',
        '\t': 'Tab',
        '\n': 'NewLine',
        '\u2008': 'puncsp',
        '\u205F': 'MediumSpace',
        '\u2009': 'thinsp',
        '\u200A': 'hairsp',
        '\u2004': 'emsp13',
        '\u2002': 'ensp',
        '\u2005': 'emsp14',
        '\u2003': 'emsp',
        '\u2007': 'numsp',
        '\xA0': 'nbsp',
        '\u205F\u200A': 'ThickSpace',
        '\u203E': 'oline',
        '_': 'lowbar',
        '\u2010': 'dash',
        '\u2013': 'ndash',
        '\u2014': 'mdash',
        '\u2015': 'horbar',
        ',': 'comma',
        ';': 'semi',
        '\u204F': 'bsemi',
        ':': 'colon',
        '\u2A74': 'Colone',
        '!': 'excl',
        '\xA1': 'iexcl',
        '?': 'quest',
        '\xBF': 'iquest',
        '.': 'period',
        '\u2025': 'nldr',
        '\u2026': 'mldr',
        '\xB7': 'middot',
        '\'': 'apos',
        '\u2018': 'lsquo',
        '\u2019': 'rsquo',
        '\u201A': 'sbquo',
        '\u2039': 'lsaquo',
        '\u203A': 'rsaquo',
        '"': 'quot',
        '\u201C': 'ldquo',
        '\u201D': 'rdquo',
        '\u201E': 'bdquo',
        '\xAB': 'laquo',
        '\xBB': 'raquo',
        '(': 'lpar',
        ')': 'rpar',
        '[': 'lsqb',
        ']': 'rsqb',
        '{': 'lcub',
        '}': 'rcub',
        '\u2308': 'lceil',
        '\u2309': 'rceil',
        '\u230A': 'lfloor',
        '\u230B': 'rfloor',
        '\u2985': 'lopar',
        '\u2986': 'ropar',
        '\u298B': 'lbrke',
        '\u298C': 'rbrke',
        '\u298D': 'lbrkslu',
        '\u298E': 'rbrksld',
        '\u298F': 'lbrksld',
        '\u2990': 'rbrkslu',
        '\u2991': 'langd',
        '\u2992': 'rangd',
        '\u2993': 'lparlt',
        '\u2994': 'rpargt',
        '\u2995': 'gtlPar',
        '\u2996': 'ltrPar',
        '\u27E6': 'lobrk',
        '\u27E7': 'robrk',
        '\u27E8': 'lang',
        '\u27E9': 'rang',
        '\u27EA': 'Lang',
        '\u27EB': 'Rang',
        '\u27EC': 'loang',
        '\u27ED': 'roang',
        '\u2772': 'lbbrk',
        '\u2773': 'rbbrk',
        '\u2016': 'Vert',
        '\xA7': 'sect',
        '\xB6': 'para',
        '@': 'commat',
        '*': 'ast',
        '/': 'sol',
        'undefined': null,
        '&': 'amp',
        '#': 'num',
        '%': 'percnt',
        '\u2030': 'permil',
        '\u2031': 'pertenk',
        '\u2020': 'dagger',
        '\u2021': 'Dagger',
        '\u2022': 'bull',
        '\u2043': 'hybull',
        '\u2032': 'prime',
        '\u2033': 'Prime',
        '\u2034': 'tprime',
        '\u2057': 'qprime',
        '\u2035': 'bprime',
        '\u2041': 'caret',
        '`': 'grave',
        '\xB4': 'acute',
        '\u02DC': 'tilde',
        '^': 'Hat',
        '\xAF': 'macr',
        '\u02D8': 'breve',
        '\u02D9': 'dot',
        '\xA8': 'die',
        '\u02DA': 'ring',
        '\u02DD': 'dblac',
        '\xB8': 'cedil',
        '\u02DB': 'ogon',
        '\u02C6': 'circ',
        '\u02C7': 'caron',
        '\xB0': 'deg',
        '\xA9': 'copy',
        '\xAE': 'reg',
        '\u2117': 'copysr',
        '\u2118': 'wp',
        '\u211E': 'rx',
        '\u2127': 'mho',
        '\u2129': 'iiota',
        '\u2190': 'larr',
        '\u219A': 'nlarr',
        '\u2192': 'rarr',
        '\u219B': 'nrarr',
        '\u2191': 'uarr',
        '\u2193': 'darr',
        '\u2194': 'harr',
        '\u21AE': 'nharr',
        '\u2195': 'varr',
        '\u2196': 'nwarr',
        '\u2197': 'nearr',
        '\u2198': 'searr',
        '\u2199': 'swarr',
        '\u219D': 'rarrw',
        '\u219D\u0338': 'nrarrw',
        '\u219E': 'Larr',
        '\u219F': 'Uarr',
        '\u21A0': 'Rarr',
        '\u21A1': 'Darr',
        '\u21A2': 'larrtl',
        '\u21A3': 'rarrtl',
        '\u21A4': 'mapstoleft',
        '\u21A5': 'mapstoup',
        '\u21A6': 'map',
        '\u21A7': 'mapstodown',
        '\u21A9': 'larrhk',
        '\u21AA': 'rarrhk',
        '\u21AB': 'larrlp',
        '\u21AC': 'rarrlp',
        '\u21AD': 'harrw',
        '\u21B0': 'lsh',
        '\u21B1': 'rsh',
        '\u21B2': 'ldsh',
        '\u21B3': 'rdsh',
        '\u21B5': 'crarr',
        '\u21B6': 'cularr',
        '\u21B7': 'curarr',
        '\u21BA': 'olarr',
        '\u21BB': 'orarr',
        '\u21BC': 'lharu',
        '\u21BD': 'lhard',
        '\u21BE': 'uharr',
        '\u21BF': 'uharl',
        '\u21C0': 'rharu',
        '\u21C1': 'rhard',
        '\u21C2': 'dharr',
        '\u21C3': 'dharl',
        '\u21C4': 'rlarr',
        '\u21C5': 'udarr',
        '\u21C6': 'lrarr',
        '\u21C7': 'llarr',
        '\u21C8': 'uuarr',
        '\u21C9': 'rrarr',
        '\u21CA': 'ddarr',
        '\u21CB': 'lrhar',
        '\u21CC': 'rlhar',
        '\u21D0': 'lArr',
        '\u21CD': 'nlArr',
        '\u21D1': 'uArr',
        '\u21D2': 'rArr',
        '\u21CF': 'nrArr',
        '\u21D3': 'dArr',
        '\u21D4': 'iff',
        '\u21CE': 'nhArr',
        '\u21D5': 'vArr',
        '\u21D6': 'nwArr',
        '\u21D7': 'neArr',
        '\u21D8': 'seArr',
        '\u21D9': 'swArr',
        '\u21DA': 'lAarr',
        '\u21DB': 'rAarr',
        '\u21DD': 'zigrarr',
        '\u21E4': 'larrb',
        '\u21E5': 'rarrb',
        '\u21F5': 'duarr',
        '\u21FD': 'loarr',
        '\u21FE': 'roarr',
        '\u21FF': 'hoarr',
        '\u2200': 'forall',
        '\u2201': 'comp',
        '\u2202': 'part',
        '\u2202\u0338': 'npart',
        '\u2203': 'exist',
        '\u2204': 'nexist',
        '\u2205': 'empty',
        '\u2207': 'Del',
        '\u2208': 'in',
        '\u2209': 'notin',
        '\u220B': 'ni',
        '\u220C': 'notni',
        '\u03F6': 'bepsi',
        '\u220F': 'prod',
        '\u2210': 'coprod',
        '\u2211': 'sum',
        '+': 'plus',
        '\xB1': 'pm',
        '\xF7': 'div',
        '\xD7': 'times',
        '<': 'lt',
        '\u226E': 'nlt',
        '<\u20D2': 'nvlt',
        '=': 'equals',
        '\u2260': 'ne',
        '=\u20E5': 'bne',
        '\u2A75': 'Equal',
        '>': 'gt',
        '\u226F': 'ngt',
        '>\u20D2': 'nvgt',
        '\xAC': 'not',
        '|': 'vert',
        '\xA6': 'brvbar',
        '\u2212': 'minus',
        '\u2213': 'mp',
        '\u2214': 'plusdo',
        '\u2044': 'frasl',
        '\u2216': 'setmn',
        '\u2217': 'lowast',
        '\u2218': 'compfn',
        '\u221A': 'Sqrt',
        '\u221D': 'prop',
        '\u221E': 'infin',
        '\u221F': 'angrt',
        '\u2220': 'ang',
        '\u2220\u20D2': 'nang',
        '\u2221': 'angmsd',
        '\u2222': 'angsph',
        '\u2223': 'mid',
        '\u2224': 'nmid',
        '\u2225': 'par',
        '\u2226': 'npar',
        '\u2227': 'and',
        '\u2228': 'or',
        '\u2229': 'cap',
        '\u2229\uFE00': 'caps',
        '\u222A': 'cup',
        '\u222A\uFE00': 'cups',
        '\u222B': 'int',
        '\u222C': 'Int',
        '\u222D': 'tint',
        '\u2A0C': 'qint',
        '\u222E': 'oint',
        '\u222F': 'Conint',
        '\u2230': 'Cconint',
        '\u2231': 'cwint',
        '\u2232': 'cwconint',
        '\u2233': 'awconint',
        '\u2234': 'there4',
        '\u2235': 'becaus',
        '\u2236': 'ratio',
        '\u2237': 'Colon',
        '\u2238': 'minusd',
        '\u223A': 'mDDot',
        '\u223B': 'homtht',
        '\u223C': 'sim',
        '\u2241': 'nsim',
        '\u223C\u20D2': 'nvsim',
        '\u223D': 'bsim',
        '\u223D\u0331': 'race',
        '\u223E': 'ac',
        '\u223E\u0333': 'acE',
        '\u223F': 'acd',
        '\u2240': 'wr',
        '\u2242': 'esim',
        '\u2242\u0338': 'nesim',
        '\u2243': 'sime',
        '\u2244': 'nsime',
        '\u2245': 'cong',
        '\u2247': 'ncong',
        '\u2246': 'simne',
        '\u2248': 'ap',
        '\u2249': 'nap',
        '\u224A': 'ape',
        '\u224B': 'apid',
        '\u224B\u0338': 'napid',
        '\u224C': 'bcong',
        '\u224D': 'CupCap',
        '\u226D': 'NotCupCap',
        '\u224D\u20D2': 'nvap',
        '\u224E': 'bump',
        '\u224E\u0338': 'nbump',
        '\u224F': 'bumpe',
        '\u224F\u0338': 'nbumpe',
        '\u2250': 'doteq',
        '\u2250\u0338': 'nedot',
        '\u2251': 'eDot',
        '\u2252': 'efDot',
        '\u2253': 'erDot',
        '\u2254': 'colone',
        '\u2255': 'ecolon',
        '\u2256': 'ecir',
        '\u2257': 'cire',
        '\u2259': 'wedgeq',
        '\u225A': 'veeeq',
        '\u225C': 'trie',
        '\u225F': 'equest',
        '\u2261': 'equiv',
        '\u2262': 'nequiv',
        '\u2261\u20E5': 'bnequiv',
        '\u2264': 'le',
        '\u2270': 'nle',
        '\u2264\u20D2': 'nvle',
        '\u2265': 'ge',
        '\u2271': 'nge',
        '\u2265\u20D2': 'nvge',
        '\u2266': 'lE',
        '\u2266\u0338': 'nlE',
        '\u2267': 'gE',
        '\u2267\u0338': 'ngE',
        '\u2268\uFE00': 'lvnE',
        '\u2268': 'lnE',
        '\u2269': 'gnE',
        '\u2269\uFE00': 'gvnE',
        '\u226A': 'll',
        '\u226A\u0338': 'nLtv',
        '\u226A\u20D2': 'nLt',
        '\u226B': 'gg',
        '\u226B\u0338': 'nGtv',
        '\u226B\u20D2': 'nGt',
        '\u226C': 'twixt',
        '\u2272': 'lsim',
        '\u2274': 'nlsim',
        '\u2273': 'gsim',
        '\u2275': 'ngsim',
        '\u2276': 'lg',
        '\u2278': 'ntlg',
        '\u2277': 'gl',
        '\u2279': 'ntgl',
        '\u227A': 'pr',
        '\u2280': 'npr',
        '\u227B': 'sc',
        '\u2281': 'nsc',
        '\u227C': 'prcue',
        '\u22E0': 'nprcue',
        '\u227D': 'sccue',
        '\u22E1': 'nsccue',
        '\u227E': 'prsim',
        '\u227F': 'scsim',
        '\u227F\u0338': 'NotSucceedsTilde',
        '\u2282': 'sub',
        '\u2284': 'nsub',
        '\u2282\u20D2': 'vnsub',
        '\u2283': 'sup',
        '\u2285': 'nsup',
        '\u2283\u20D2': 'vnsup',
        '\u2286': 'sube',
        '\u2288': 'nsube',
        '\u2287': 'supe',
        '\u2289': 'nsupe',
        '\u228A\uFE00': 'vsubne',
        '\u228A': 'subne',
        '\u228B\uFE00': 'vsupne',
        '\u228B': 'supne',
        '\u228D': 'cupdot',
        '\u228E': 'uplus',
        '\u228F': 'sqsub',
        '\u228F\u0338': 'NotSquareSubset',
        '\u2290': 'sqsup',
        '\u2290\u0338': 'NotSquareSuperset',
        '\u2291': 'sqsube',
        '\u22E2': 'nsqsube',
        '\u2292': 'sqsupe',
        '\u22E3': 'nsqsupe',
        '\u2293': 'sqcap',
        '\u2293\uFE00': 'sqcaps',
        '\u2294': 'sqcup',
        '\u2294\uFE00': 'sqcups',
        '\u2295': 'oplus',
        '\u2296': 'ominus',
        '\u2297': 'otimes',
        '\u2298': 'osol',
        '\u2299': 'odot',
        '\u229A': 'ocir',
        '\u229B': 'oast',
        '\u229D': 'odash',
        '\u229E': 'plusb',
        '\u229F': 'minusb',
        '\u22A0': 'timesb',
        '\u22A1': 'sdotb',
        '\u22A2': 'vdash',
        '\u22AC': 'nvdash',
        '\u22A3': 'dashv',
        '\u22A4': 'top',
        '\u22A5': 'bot',
        '\u22A7': 'models',
        '\u22A8': 'vDash',
        '\u22AD': 'nvDash',
        '\u22A9': 'Vdash',
        '\u22AE': 'nVdash',
        '\u22AA': 'Vvdash',
        '\u22AB': 'VDash',
        '\u22AF': 'nVDash',
        '\u22B0': 'prurel',
        '\u22B2': 'vltri',
        '\u22EA': 'nltri',
        '\u22B3': 'vrtri',
        '\u22EB': 'nrtri',
        '\u22B4': 'ltrie',
        '\u22EC': 'nltrie',
        '\u22B4\u20D2': 'nvltrie',
        '\u22B5': 'rtrie',
        '\u22ED': 'nrtrie',
        '\u22B5\u20D2': 'nvrtrie',
        '\u22B6': 'origof',
        '\u22B7': 'imof',
        '\u22B8': 'mumap',
        '\u22B9': 'hercon',
        '\u22BA': 'intcal',
        '\u22BB': 'veebar',
        '\u22BD': 'barvee',
        '\u22BE': 'angrtvb',
        '\u22BF': 'lrtri',
        '\u22C0': 'Wedge',
        '\u22C1': 'Vee',
        '\u22C2': 'xcap',
        '\u22C3': 'xcup',
        '\u22C4': 'diam',
        '\u22C5': 'sdot',
        '\u22C6': 'Star',
        '\u22C7': 'divonx',
        '\u22C8': 'bowtie',
        '\u22C9': 'ltimes',
        '\u22CA': 'rtimes',
        '\u22CB': 'lthree',
        '\u22CC': 'rthree',
        '\u22CD': 'bsime',
        '\u22CE': 'cuvee',
        '\u22CF': 'cuwed',
        '\u22D0': 'Sub',
        '\u22D1': 'Sup',
        '\u22D2': 'Cap',
        '\u22D3': 'Cup',
        '\u22D4': 'fork',
        '\u22D5': 'epar',
        '\u22D6': 'ltdot',
        '\u22D7': 'gtdot',
        '\u22D8': 'Ll',
        '\u22D8\u0338': 'nLl',
        '\u22D9': 'Gg',
        '\u22D9\u0338': 'nGg',
        '\u22DA\uFE00': 'lesg',
        '\u22DA': 'leg',
        '\u22DB': 'gel',
        '\u22DB\uFE00': 'gesl',
        '\u22DE': 'cuepr',
        '\u22DF': 'cuesc',
        '\u22E6': 'lnsim',
        '\u22E7': 'gnsim',
        '\u22E8': 'prnsim',
        '\u22E9': 'scnsim',
        '\u22EE': 'vellip',
        '\u22EF': 'ctdot',
        '\u22F0': 'utdot',
        '\u22F1': 'dtdot',
        '\u22F2': 'disin',
        '\u22F3': 'isinsv',
        '\u22F4': 'isins',
        '\u22F5': 'isindot',
        '\u22F5\u0338': 'notindot',
        '\u22F6': 'notinvc',
        '\u22F7': 'notinvb',
        '\u22F9': 'isinE',
        '\u22F9\u0338': 'notinE',
        '\u22FA': 'nisd',
        '\u22FB': 'xnis',
        '\u22FC': 'nis',
        '\u22FD': 'notnivc',
        '\u22FE': 'notnivb',
        '\u2305': 'barwed',
        '\u2306': 'Barwed',
        '\u230C': 'drcrop',
        '\u230D': 'dlcrop',
        '\u230E': 'urcrop',
        '\u230F': 'ulcrop',
        '\u2310': 'bnot',
        '\u2312': 'profline',
        '\u2313': 'profsurf',
        '\u2315': 'telrec',
        '\u2316': 'target',
        '\u231C': 'ulcorn',
        '\u231D': 'urcorn',
        '\u231E': 'dlcorn',
        '\u231F': 'drcorn',
        '\u2322': 'frown',
        '\u2323': 'smile',
        '\u232D': 'cylcty',
        '\u232E': 'profalar',
        '\u2336': 'topbot',
        '\u233D': 'ovbar',
        '\u233F': 'solbar',
        '\u237C': 'angzarr',
        '\u23B0': 'lmoust',
        '\u23B1': 'rmoust',
        '\u23B4': 'tbrk',
        '\u23B5': 'bbrk',
        '\u23B6': 'bbrktbrk',
        '\u23DC': 'OverParenthesis',
        '\u23DD': 'UnderParenthesis',
        '\u23DE': 'OverBrace',
        '\u23DF': 'UnderBrace',
        '\u23E2': 'trpezium',
        '\u23E7': 'elinters',
        '\u2423': 'blank',
        '\u2500': 'boxh',
        '\u2502': 'boxv',
        '\u250C': 'boxdr',
        '\u2510': 'boxdl',
        '\u2514': 'boxur',
        '\u2518': 'boxul',
        '\u251C': 'boxvr',
        '\u2524': 'boxvl',
        '\u252C': 'boxhd',
        '\u2534': 'boxhu',
        '\u253C': 'boxvh',
        '\u2550': 'boxH',
        '\u2551': 'boxV',
        '\u2552': 'boxdR',
        '\u2553': 'boxDr',
        '\u2554': 'boxDR',
        '\u2555': 'boxdL',
        '\u2556': 'boxDl',
        '\u2557': 'boxDL',
        '\u2558': 'boxuR',
        '\u2559': 'boxUr',
        '\u255A': 'boxUR',
        '\u255B': 'boxuL',
        '\u255C': 'boxUl',
        '\u255D': 'boxUL',
        '\u255E': 'boxvR',
        '\u255F': 'boxVr',
        '\u2560': 'boxVR',
        '\u2561': 'boxvL',
        '\u2562': 'boxVl',
        '\u2563': 'boxVL',
        '\u2564': 'boxHd',
        '\u2565': 'boxhD',
        '\u2566': 'boxHD',
        '\u2567': 'boxHu',
        '\u2568': 'boxhU',
        '\u2569': 'boxHU',
        '\u256A': 'boxvH',
        '\u256B': 'boxVh',
        '\u256C': 'boxVH',
        '\u2580': 'uhblk',
        '\u2584': 'lhblk',
        '\u2588': 'block',
        '\u2591': 'blk14',
        '\u2592': 'blk12',
        '\u2593': 'blk34',
        '\u25A1': 'squ',
        '\u25AA': 'squf',
        '\u25AB': 'EmptyVerySmallSquare',
        '\u25AD': 'rect',
        '\u25AE': 'marker',
        '\u25B1': 'fltns',
        '\u25B3': 'xutri',
        '\u25B4': 'utrif',
        '\u25B5': 'utri',
        '\u25B8': 'rtrif',
        '\u25B9': 'rtri',
        '\u25BD': 'xdtri',
        '\u25BE': 'dtrif',
        '\u25BF': 'dtri',
        '\u25C2': 'ltrif',
        '\u25C3': 'ltri',
        '\u25CA': 'loz',
        '\u25CB': 'cir',
        '\u25EC': 'tridot',
        '\u25EF': 'xcirc',
        '\u25F8': 'ultri',
        '\u25F9': 'urtri',
        '\u25FA': 'lltri',
        '\u25FB': 'EmptySmallSquare',
        '\u25FC': 'FilledSmallSquare',
        '\u2605': 'starf',
        '\u2606': 'star',
        '\u260E': 'phone',
        '\u2640': 'female',
        '\u2642': 'male',
        '\u2660': 'spades',
        '\u2663': 'clubs',
        '\u2665': 'hearts',
        '\u2666': 'diams',
        '\u266A': 'sung',
        '\u2713': 'check',
        '\u2717': 'cross',
        '\u2720': 'malt',
        '\u2736': 'sext',
        '\u2758': 'VerticalSeparator',
        '\u27C8': 'bsolhsub',
        '\u27C9': 'suphsol',
        '\u27F5': 'xlarr',
        '\u27F6': 'xrarr',
        '\u27F7': 'xharr',
        '\u27F8': 'xlArr',
        '\u27F9': 'xrArr',
        '\u27FA': 'xhArr',
        '\u27FC': 'xmap',
        '\u27FF': 'dzigrarr',
        '\u2902': 'nvlArr',
        '\u2903': 'nvrArr',
        '\u2904': 'nvHarr',
        '\u2905': 'Map',
        '\u290C': 'lbarr',
        '\u290D': 'rbarr',
        '\u290E': 'lBarr',
        '\u290F': 'rBarr',
        '\u2910': 'RBarr',
        '\u2911': 'DDotrahd',
        '\u2912': 'UpArrowBar',
        '\u2913': 'DownArrowBar',
        '\u2916': 'Rarrtl',
        '\u2919': 'latail',
        '\u291A': 'ratail',
        '\u291B': 'lAtail',
        '\u291C': 'rAtail',
        '\u291D': 'larrfs',
        '\u291E': 'rarrfs',
        '\u291F': 'larrbfs',
        '\u2920': 'rarrbfs',
        '\u2923': 'nwarhk',
        '\u2924': 'nearhk',
        '\u2925': 'searhk',
        '\u2926': 'swarhk',
        '\u2927': 'nwnear',
        '\u2928': 'toea',
        '\u2929': 'tosa',
        '\u292A': 'swnwar',
        '\u2933': 'rarrc',
        '\u2933\u0338': 'nrarrc',
        '\u2935': 'cudarrr',
        '\u2936': 'ldca',
        '\u2937': 'rdca',
        '\u2938': 'cudarrl',
        '\u2939': 'larrpl',
        '\u293C': 'curarrm',
        '\u293D': 'cularrp',
        '\u2945': 'rarrpl',
        '\u2948': 'harrcir',
        '\u2949': 'Uarrocir',
        '\u294A': 'lurdshar',
        '\u294B': 'ldrushar',
        '\u294E': 'LeftRightVector',
        '\u294F': 'RightUpDownVector',
        '\u2950': 'DownLeftRightVector',
        '\u2951': 'LeftUpDownVector',
        '\u2952': 'LeftVectorBar',
        '\u2953': 'RightVectorBar',
        '\u2954': 'RightUpVectorBar',
        '\u2955': 'RightDownVectorBar',
        '\u2956': 'DownLeftVectorBar',
        '\u2957': 'DownRightVectorBar',
        '\u2958': 'LeftUpVectorBar',
        '\u2959': 'LeftDownVectorBar',
        '\u295A': 'LeftTeeVector',
        '\u295B': 'RightTeeVector',
        '\u295C': 'RightUpTeeVector',
        '\u295D': 'RightDownTeeVector',
        '\u295E': 'DownLeftTeeVector',
        '\u295F': 'DownRightTeeVector',
        '\u2960': 'LeftUpTeeVector',
        '\u2961': 'LeftDownTeeVector',
        '\u2962': 'lHar',
        '\u2963': 'uHar',
        '\u2964': 'rHar',
        '\u2965': 'dHar',
        '\u2966': 'luruhar',
        '\u2967': 'ldrdhar',
        '\u2968': 'ruluhar',
        '\u2969': 'rdldhar',
        '\u296A': 'lharul',
        '\u296B': 'llhard',
        '\u296C': 'rharul',
        '\u296D': 'lrhard',
        '\u296E': 'udhar',
        '\u296F': 'duhar',
        '\u2970': 'RoundImplies',
        '\u2971': 'erarr',
        '\u2972': 'simrarr',
        '\u2973': 'larrsim',
        '\u2974': 'rarrsim',
        '\u2975': 'rarrap',
        '\u2976': 'ltlarr',
        '\u2978': 'gtrarr',
        '\u2979': 'subrarr',
        '\u297B': 'suplarr',
        '\u297C': 'lfisht',
        '\u297D': 'rfisht',
        '\u297E': 'ufisht',
        '\u297F': 'dfisht',
        '\u299A': 'vzigzag',
        '\u299C': 'vangrt',
        '\u299D': 'angrtvbd',
        '\u29A4': 'ange',
        '\u29A5': 'range',
        '\u29A6': 'dwangle',
        '\u29A7': 'uwangle',
        '\u29A8': 'angmsdaa',
        '\u29A9': 'angmsdab',
        '\u29AA': 'angmsdac',
        '\u29AB': 'angmsdad',
        '\u29AC': 'angmsdae',
        '\u29AD': 'angmsdaf',
        '\u29AE': 'angmsdag',
        '\u29AF': 'angmsdah',
        '\u29B0': 'bemptyv',
        '\u29B1': 'demptyv',
        '\u29B2': 'cemptyv',
        '\u29B3': 'raemptyv',
        '\u29B4': 'laemptyv',
        '\u29B5': 'ohbar',
        '\u29B6': 'omid',
        '\u29B7': 'opar',
        '\u29B9': 'operp',
        '\u29BB': 'olcross',
        '\u29BC': 'odsold',
        '\u29BE': 'olcir',
        '\u29BF': 'ofcir',
        '\u29C0': 'olt',
        '\u29C1': 'ogt',
        '\u29C2': 'cirscir',
        '\u29C3': 'cirE',
        '\u29C4': 'solb',
        '\u29C5': 'bsolb',
        '\u29C9': 'boxbox',
        '\u29CD': 'trisb',
        '\u29CE': 'rtriltri',
        '\u29CF': 'LeftTriangleBar',
        '\u29CF\u0338': 'NotLeftTriangleBar',
        '\u29D0': 'RightTriangleBar',
        '\u29D0\u0338': 'NotRightTriangleBar',
        '\u29DC': 'iinfin',
        '\u29DD': 'infintie',
        '\u29DE': 'nvinfin',
        '\u29E3': 'eparsl',
        '\u29E4': 'smeparsl',
        '\u29E5': 'eqvparsl',
        '\u29EB': 'lozf',
        '\u29F4': 'RuleDelayed',
        '\u29F6': 'dsol',
        '\u2A00': 'xodot',
        '\u2A01': 'xoplus',
        '\u2A02': 'xotime',
        '\u2A04': 'xuplus',
        '\u2A06': 'xsqcup',
        '\u2A0D': 'fpartint',
        '\u2A10': 'cirfnint',
        '\u2A11': 'awint',
        '\u2A12': 'rppolint',
        '\u2A13': 'scpolint',
        '\u2A14': 'npolint',
        '\u2A15': 'pointint',
        '\u2A16': 'quatint',
        '\u2A17': 'intlarhk',
        '\u2A22': 'pluscir',
        '\u2A23': 'plusacir',
        '\u2A24': 'simplus',
        '\u2A25': 'plusdu',
        '\u2A26': 'plussim',
        '\u2A27': 'plustwo',
        '\u2A29': 'mcomma',
        '\u2A2A': 'minusdu',
        '\u2A2D': 'loplus',
        '\u2A2E': 'roplus',
        '\u2A2F': 'Cross',
        '\u2A30': 'timesd',
        '\u2A31': 'timesbar',
        '\u2A33': 'smashp',
        '\u2A34': 'lotimes',
        '\u2A35': 'rotimes',
        '\u2A36': 'otimesas',
        '\u2A37': 'Otimes',
        '\u2A38': 'odiv',
        '\u2A39': 'triplus',
        '\u2A3A': 'triminus',
        '\u2A3B': 'tritime',
        '\u2A3C': 'iprod',
        '\u2A3F': 'amalg',
        '\u2A40': 'capdot',
        '\u2A42': 'ncup',
        '\u2A43': 'ncap',
        '\u2A44': 'capand',
        '\u2A45': 'cupor',
        '\u2A46': 'cupcap',
        '\u2A47': 'capcup',
        '\u2A48': 'cupbrcap',
        '\u2A49': 'capbrcup',
        '\u2A4A': 'cupcup',
        '\u2A4B': 'capcap',
        '\u2A4C': 'ccups',
        '\u2A4D': 'ccaps',
        '\u2A50': 'ccupssm',
        '\u2A53': 'And',
        '\u2A54': 'Or',
        '\u2A55': 'andand',
        '\u2A56': 'oror',
        '\u2A57': 'orslope',
        '\u2A58': 'andslope',
        '\u2A5A': 'andv',
        '\u2A5B': 'orv',
        '\u2A5C': 'andd',
        '\u2A5D': 'ord',
        '\u2A5F': 'wedbar',
        '\u2A66': 'sdote',
        '\u2A6A': 'simdot',
        '\u2A6D': 'congdot',
        '\u2A6D\u0338': 'ncongdot',
        '\u2A6E': 'easter',
        '\u2A6F': 'apacir',
        '\u2A70': 'apE',
        '\u2A70\u0338': 'napE',
        '\u2A71': 'eplus',
        '\u2A72': 'pluse',
        '\u2A73': 'Esim',
        '\u2A77': 'eDDot',
        '\u2A78': 'equivDD',
        '\u2A79': 'ltcir',
        '\u2A7A': 'gtcir',
        '\u2A7B': 'ltquest',
        '\u2A7C': 'gtquest',
        '\u2A7D': 'les',
        '\u2A7D\u0338': 'nles',
        '\u2A7E': 'ges',
        '\u2A7E\u0338': 'nges',
        '\u2A7F': 'lesdot',
        '\u2A80': 'gesdot',
        '\u2A81': 'lesdoto',
        '\u2A82': 'gesdoto',
        '\u2A83': 'lesdotor',
        '\u2A84': 'gesdotol',
        '\u2A85': 'lap',
        '\u2A86': 'gap',
        '\u2A87': 'lne',
        '\u2A88': 'gne',
        '\u2A89': 'lnap',
        '\u2A8A': 'gnap',
        '\u2A8B': 'lEg',
        '\u2A8C': 'gEl',
        '\u2A8D': 'lsime',
        '\u2A8E': 'gsime',
        '\u2A8F': 'lsimg',
        '\u2A90': 'gsiml',
        '\u2A91': 'lgE',
        '\u2A92': 'glE',
        '\u2A93': 'lesges',
        '\u2A94': 'gesles',
        '\u2A95': 'els',
        '\u2A96': 'egs',
        '\u2A97': 'elsdot',
        '\u2A98': 'egsdot',
        '\u2A99': 'el',
        '\u2A9A': 'eg',
        '\u2A9D': 'siml',
        '\u2A9E': 'simg',
        '\u2A9F': 'simlE',
        '\u2AA0': 'simgE',
        '\u2AA1': 'LessLess',
        '\u2AA1\u0338': 'NotNestedLessLess',
        '\u2AA2': 'GreaterGreater',
        '\u2AA2\u0338': 'NotNestedGreaterGreater',
        '\u2AA4': 'glj',
        '\u2AA5': 'gla',
        '\u2AA6': 'ltcc',
        '\u2AA7': 'gtcc',
        '\u2AA8': 'lescc',
        '\u2AA9': 'gescc',
        '\u2AAA': 'smt',
        '\u2AAB': 'lat',
        '\u2AAC': 'smte',
        '\u2AAC\uFE00': 'smtes',
        '\u2AAD': 'late',
        '\u2AAD\uFE00': 'lates',
        '\u2AAE': 'bumpE',
        '\u2AAF': 'pre',
        '\u2AAF\u0338': 'npre',
        '\u2AB0': 'sce',
        '\u2AB0\u0338': 'nsce',
        '\u2AB3': 'prE',
        '\u2AB4': 'scE',
        '\u2AB5': 'prnE',
        '\u2AB6': 'scnE',
        '\u2AB7': 'prap',
        '\u2AB8': 'scap',
        '\u2AB9': 'prnap',
        '\u2ABA': 'scnap',
        '\u2ABB': 'Pr',
        '\u2ABC': 'Sc',
        '\u2ABD': 'subdot',
        '\u2ABE': 'supdot',
        '\u2ABF': 'subplus',
        '\u2AC0': 'supplus',
        '\u2AC1': 'submult',
        '\u2AC2': 'supmult',
        '\u2AC3': 'subedot',
        '\u2AC4': 'supedot',
        '\u2AC5': 'subE',
        '\u2AC5\u0338': 'nsubE',
        '\u2AC6': 'supE',
        '\u2AC6\u0338': 'nsupE',
        '\u2AC7': 'subsim',
        '\u2AC8': 'supsim',
        '\u2ACB\uFE00': 'vsubnE',
        '\u2ACB': 'subnE',
        '\u2ACC\uFE00': 'vsupnE',
        '\u2ACC': 'supnE',
        '\u2ACF': 'csub',
        '\u2AD0': 'csup',
        '\u2AD1': 'csube',
        '\u2AD2': 'csupe',
        '\u2AD3': 'subsup',
        '\u2AD4': 'supsub',
        '\u2AD5': 'subsub',
        '\u2AD6': 'supsup',
        '\u2AD7': 'suphsub',
        '\u2AD8': 'supdsub',
        '\u2AD9': 'forkv',
        '\u2ADA': 'topfork',
        '\u2ADB': 'mlcp',
        '\u2AE4': 'Dashv',
        '\u2AE6': 'Vdashl',
        '\u2AE7': 'Barv',
        '\u2AE8': 'vBar',
        '\u2AE9': 'vBarv',
        '\u2AEB': 'Vbar',
        '\u2AEC': 'Not',
        '\u2AED': 'bNot',
        '\u2AEE': 'rnmid',
        '\u2AEF': 'cirmid',
        '\u2AF0': 'midcir',
        '\u2AF1': 'topcir',
        '\u2AF2': 'nhpar',
        '\u2AF3': 'parsim',
        '\u2AFD': 'parsl',
        '\u2AFD\u20E5': 'nparsl',
        '\u266D': 'flat',
        '\u266E': 'natur',
        '\u266F': 'sharp',
        '\xA4': 'curren',
        '\xA2': 'cent',
        '$': 'dollar',
        '\xA3': 'pound',
        '\xA5': 'yen',
        '\u20AC': 'euro',
        '\xB9': 'sup1',
        '\xBD': 'half',
        '\u2153': 'frac13',
        '\xBC': 'frac14',
        '\u2155': 'frac15',
        '\u2159': 'frac16',
        '\u215B': 'frac18',
        '\xB2': 'sup2',
        '\u2154': 'frac23',
        '\u2156': 'frac25',
        '\xB3': 'sup3',
        '\xBE': 'frac34',
        '\u2157': 'frac35',
        '\u215C': 'frac38',
        '\u2158': 'frac45',
        '\u215A': 'frac56',
        '\u215D': 'frac58',
        '\u215E': 'frac78',
        '\uD835\uDCB6': 'ascr',
        '\uD835\uDD52': 'aopf',
        '\uD835\uDD1E': 'afr',
        '\uD835\uDD38': 'Aopf',
        '\uD835\uDD04': 'Afr',
        '\uD835\uDC9C': 'Ascr',
        '\xAA': 'ordf',
        '\xE1': 'aacute',
        '\xC1': 'Aacute',
        '\xE0': 'agrave',
        '\xC0': 'Agrave',
        '\u0103': 'abreve',
        '\u0102': 'Abreve',
        '\xE2': 'acirc',
        '\xC2': 'Acirc',
        '\xE5': 'aring',
        '\xC5': 'angst',
        '\xE4': 'auml',
        '\xC4': 'Auml',
        '\xE3': 'atilde',
        '\xC3': 'Atilde',
        '\u0105': 'aogon',
        '\u0104': 'Aogon',
        '\u0101': 'amacr',
        '\u0100': 'Amacr',
        '\xE6': 'aelig',
        '\xC6': 'AElig',
        '\uD835\uDCB7': 'bscr',
        '\uD835\uDD53': 'bopf',
        '\uD835\uDD1F': 'bfr',
        '\uD835\uDD39': 'Bopf',
        '\u212C': 'Bscr',
        '\uD835\uDD05': 'Bfr',
        '\uD835\uDD20': 'cfr',
        '\uD835\uDCB8': 'cscr',
        '\uD835\uDD54': 'copf',
        '\u212D': 'Cfr',
        '\uD835\uDC9E': 'Cscr',
        '\u2102': 'Copf',
        '\u0107': 'cacute',
        '\u0106': 'Cacute',
        '\u0109': 'ccirc',
        '\u0108': 'Ccirc',
        '\u010D': 'ccaron',
        '\u010C': 'Ccaron',
        '\u010B': 'cdot',
        '\u010A': 'Cdot',
        '\xE7': 'ccedil',
        '\xC7': 'Ccedil',
        '\u2105': 'incare',
        '\uD835\uDD21': 'dfr',
        '\u2146': 'dd',
        '\uD835\uDD55': 'dopf',
        '\uD835\uDCB9': 'dscr',
        '\uD835\uDC9F': 'Dscr',
        '\uD835\uDD07': 'Dfr',
        '\u2145': 'DD',
        '\uD835\uDD3B': 'Dopf',
        '\u010F': 'dcaron',
        '\u010E': 'Dcaron',
        '\u0111': 'dstrok',
        '\u0110': 'Dstrok',
        '\xF0': 'eth',
        '\xD0': 'ETH',
        '\u2147': 'ee',
        '\u212F': 'escr',
        '\uD835\uDD22': 'efr',
        '\uD835\uDD56': 'eopf',
        '\u2130': 'Escr',
        '\uD835\uDD08': 'Efr',
        '\uD835\uDD3C': 'Eopf',
        '\xE9': 'eacute',
        '\xC9': 'Eacute',
        '\xE8': 'egrave',
        '\xC8': 'Egrave',
        '\xEA': 'ecirc',
        '\xCA': 'Ecirc',
        '\u011B': 'ecaron',
        '\u011A': 'Ecaron',
        '\xEB': 'euml',
        '\xCB': 'Euml',
        '\u0117': 'edot',
        '\u0116': 'Edot',
        '\u0119': 'eogon',
        '\u0118': 'Eogon',
        '\u0113': 'emacr',
        '\u0112': 'Emacr',
        '\uD835\uDD23': 'ffr',
        '\uD835\uDD57': 'fopf',
        '\uD835\uDCBB': 'fscr',
        '\uD835\uDD09': 'Ffr',
        '\uD835\uDD3D': 'Fopf',
        '\u2131': 'Fscr',
        '\uFB00': 'fflig',
        '\uFB03': 'ffilig',
        '\uFB04': 'ffllig',
        '\uFB01': 'filig',
        'fj': 'fjlig',
        '\uFB02': 'fllig',
        '\u0192': 'fnof',
        '\u210A': 'gscr',
        '\uD835\uDD58': 'gopf',
        '\uD835\uDD24': 'gfr',
        '\uD835\uDCA2': 'Gscr',
        '\uD835\uDD3E': 'Gopf',
        '\uD835\uDD0A': 'Gfr',
        '\u01F5': 'gacute',
        '\u011F': 'gbreve',
        '\u011E': 'Gbreve',
        '\u011D': 'gcirc',
        '\u011C': 'Gcirc',
        '\u0121': 'gdot',
        '\u0120': 'Gdot',
        '\u0122': 'Gcedil',
        '\uD835\uDD25': 'hfr',
        '\u210E': 'planckh',
        '\uD835\uDCBD': 'hscr',
        '\uD835\uDD59': 'hopf',
        '\u210B': 'Hscr',
        '\u210C': 'Hfr',
        '\u210D': 'Hopf',
        '\u0125': 'hcirc',
        '\u0124': 'Hcirc',
        '\u210F': 'hbar',
        '\u0127': 'hstrok',
        '\u0126': 'Hstrok',
        '\uD835\uDD5A': 'iopf',
        '\uD835\uDD26': 'ifr',
        '\uD835\uDCBE': 'iscr',
        '\u2148': 'ii',
        '\uD835\uDD40': 'Iopf',
        '\u2110': 'Iscr',
        '\u2111': 'Im',
        '\xED': 'iacute',
        '\xCD': 'Iacute',
        '\xEC': 'igrave',
        '\xCC': 'Igrave',
        '\xEE': 'icirc',
        '\xCE': 'Icirc',
        '\xEF': 'iuml',
        '\xCF': 'Iuml',
        '\u0129': 'itilde',
        '\u0128': 'Itilde',
        '\u0130': 'Idot',
        '\u012F': 'iogon',
        '\u012E': 'Iogon',
        '\u012B': 'imacr',
        '\u012A': 'Imacr',
        '\u0133': 'ijlig',
        '\u0132': 'IJlig',
        '\u0131': 'imath',
        '\uD835\uDCBF': 'jscr',
        '\uD835\uDD5B': 'jopf',
        '\uD835\uDD27': 'jfr',
        '\uD835\uDCA5': 'Jscr',
        '\uD835\uDD0D': 'Jfr',
        '\uD835\uDD41': 'Jopf',
        '\u0135': 'jcirc',
        '\u0134': 'Jcirc',
        '\u0237': 'jmath',
        '\uD835\uDD5C': 'kopf',
        '\uD835\uDCC0': 'kscr',
        '\uD835\uDD28': 'kfr',
        '\uD835\uDCA6': 'Kscr',
        '\uD835\uDD42': 'Kopf',
        '\uD835\uDD0E': 'Kfr',
        '\u0137': 'kcedil',
        '\u0136': 'Kcedil',
        '\uD835\uDD29': 'lfr',
        '\uD835\uDCC1': 'lscr',
        '\u2113': 'ell',
        '\uD835\uDD5D': 'lopf',
        '\u2112': 'Lscr',
        '\uD835\uDD0F': 'Lfr',
        '\uD835\uDD43': 'Lopf',
        '\u013A': 'lacute',
        '\u0139': 'Lacute',
        '\u013E': 'lcaron',
        '\u013D': 'Lcaron',
        '\u013C': 'lcedil',
        '\u013B': 'Lcedil',
        '\u0142': 'lstrok',
        '\u0141': 'Lstrok',
        '\u0140': 'lmidot',
        '\u013F': 'Lmidot',
        '\uD835\uDD2A': 'mfr',
        '\uD835\uDD5E': 'mopf',
        '\uD835\uDCC2': 'mscr',
        '\uD835\uDD10': 'Mfr',
        '\uD835\uDD44': 'Mopf',
        '\u2133': 'Mscr',
        '\uD835\uDD2B': 'nfr',
        '\uD835\uDD5F': 'nopf',
        '\uD835\uDCC3': 'nscr',
        '\u2115': 'Nopf',
        '\uD835\uDCA9': 'Nscr',
        '\uD835\uDD11': 'Nfr',
        '\u0144': 'nacute',
        '\u0143': 'Nacute',
        '\u0148': 'ncaron',
        '\u0147': 'Ncaron',
        '\xF1': 'ntilde',
        '\xD1': 'Ntilde',
        '\u0146': 'ncedil',
        '\u0145': 'Ncedil',
        '\u2116': 'numero',
        '\u014B': 'eng',
        '\u014A': 'ENG',
        '\uD835\uDD60': 'oopf',
        '\uD835\uDD2C': 'ofr',
        '\u2134': 'oscr',
        '\uD835\uDCAA': 'Oscr',
        '\uD835\uDD12': 'Ofr',
        '\uD835\uDD46': 'Oopf',
        '\xBA': 'ordm',
        '\xF3': 'oacute',
        '\xD3': 'Oacute',
        '\xF2': 'ograve',
        '\xD2': 'Ograve',
        '\xF4': 'ocirc',
        '\xD4': 'Ocirc',
        '\xF6': 'ouml',
        '\xD6': 'Ouml',
        '\u0151': 'odblac',
        '\u0150': 'Odblac',
        '\xF5': 'otilde',
        '\xD5': 'Otilde',
        '\xF8': 'oslash',
        '\xD8': 'Oslash',
        '\u014D': 'omacr',
        '\u014C': 'Omacr',
        '\u0153': 'oelig',
        '\u0152': 'OElig',
        '\uD835\uDD2D': 'pfr',
        '\uD835\uDCC5': 'pscr',
        '\uD835\uDD61': 'popf',
        '\u2119': 'Popf',
        '\uD835\uDD13': 'Pfr',
        '\uD835\uDCAB': 'Pscr',
        '\uD835\uDD62': 'qopf',
        '\uD835\uDD2E': 'qfr',
        '\uD835\uDCC6': 'qscr',
        '\uD835\uDCAC': 'Qscr',
        '\uD835\uDD14': 'Qfr',
        '\u211A': 'Qopf',
        '\u0138': 'kgreen',
        '\uD835\uDD2F': 'rfr',
        '\uD835\uDD63': 'ropf',
        '\uD835\uDCC7': 'rscr',
        '\u211B': 'Rscr',
        '\u211C': 'Re',
        '\u211D': 'Ropf',
        '\u0155': 'racute',
        '\u0154': 'Racute',
        '\u0159': 'rcaron',
        '\u0158': 'Rcaron',
        '\u0157': 'rcedil',
        '\u0156': 'Rcedil',
        '\uD835\uDD64': 'sopf',
        '\uD835\uDCC8': 'sscr',
        '\uD835\uDD30': 'sfr',
        '\uD835\uDD4A': 'Sopf',
        '\uD835\uDD16': 'Sfr',
        '\uD835\uDCAE': 'Sscr',
        '\u24C8': 'oS',
        '\u015B': 'sacute',
        '\u015A': 'Sacute',
        '\u015D': 'scirc',
        '\u015C': 'Scirc',
        '\u0161': 'scaron',
        '\u0160': 'Scaron',
        '\u015F': 'scedil',
        '\u015E': 'Scedil',
        '\xDF': 'szlig',
        '\uD835\uDD31': 'tfr',
        '\uD835\uDCC9': 'tscr',
        '\uD835\uDD65': 'topf',
        '\uD835\uDCAF': 'Tscr',
        '\uD835\uDD17': 'Tfr',
        '\uD835\uDD4B': 'Topf',
        '\u0165': 'tcaron',
        '\u0164': 'Tcaron',
        '\u0163': 'tcedil',
        '\u0162': 'Tcedil',
        '\u2122': 'trade',
        '\u0167': 'tstrok',
        '\u0166': 'Tstrok',
        '\uD835\uDCCA': 'uscr',
        '\uD835\uDD66': 'uopf',
        '\uD835\uDD32': 'ufr',
        '\uD835\uDD4C': 'Uopf',
        '\uD835\uDD18': 'Ufr',
        '\uD835\uDCB0': 'Uscr',
        '\xFA': 'uacute',
        '\xDA': 'Uacute',
        '\xF9': 'ugrave',
        '\xD9': 'Ugrave',
        '\u016D': 'ubreve',
        '\u016C': 'Ubreve',
        '\xFB': 'ucirc',
        '\xDB': 'Ucirc',
        '\u016F': 'uring',
        '\u016E': 'Uring',
        '\xFC': 'uuml',
        '\xDC': 'Uuml',
        '\u0171': 'udblac',
        '\u0170': 'Udblac',
        '\u0169': 'utilde',
        '\u0168': 'Utilde',
        '\u0173': 'uogon',
        '\u0172': 'Uogon',
        '\u016B': 'umacr',
        '\u016A': 'Umacr',
        '\uD835\uDD33': 'vfr',
        '\uD835\uDD67': 'vopf',
        '\uD835\uDCCB': 'vscr',
        '\uD835\uDD19': 'Vfr',
        '\uD835\uDD4D': 'Vopf',
        '\uD835\uDCB1': 'Vscr',
        '\uD835\uDD68': 'wopf',
        '\uD835\uDCCC': 'wscr',
        '\uD835\uDD34': 'wfr',
        '\uD835\uDCB2': 'Wscr',
        '\uD835\uDD4E': 'Wopf',
        '\uD835\uDD1A': 'Wfr',
        '\u0175': 'wcirc',
        '\u0174': 'Wcirc',
        '\uD835\uDD35': 'xfr',
        '\uD835\uDCCD': 'xscr',
        '\uD835\uDD69': 'xopf',
        '\uD835\uDD4F': 'Xopf',
        '\uD835\uDD1B': 'Xfr',
        '\uD835\uDCB3': 'Xscr',
        '\uD835\uDD36': 'yfr',
        '\uD835\uDCCE': 'yscr',
        '\uD835\uDD6A': 'yopf',
        '\uD835\uDCB4': 'Yscr',
        '\uD835\uDD1C': 'Yfr',
        '\uD835\uDD50': 'Yopf',
        '\xFD': 'yacute',
        '\xDD': 'Yacute',
        '\u0177': 'ycirc',
        '\u0176': 'Ycirc',
        '\xFF': 'yuml',
        '\u0178': 'Yuml',
        '\uD835\uDCCF': 'zscr',
        '\uD835\uDD37': 'zfr',
        '\uD835\uDD6B': 'zopf',
        '\u2128': 'Zfr',
        '\u2124': 'Zopf',
        '\uD835\uDCB5': 'Zscr',
        '\u017A': 'zacute',
        '\u0179': 'Zacute',
        '\u017E': 'zcaron',
        '\u017D': 'Zcaron',
        '\u017C': 'zdot',
        '\u017B': 'Zdot',
        '\u01B5': 'imped',
        '\xFE': 'thorn',
        '\xDE': 'THORN',
        '\u0149': 'napos',
        '\u03B1': 'alpha',
        '\u0391': 'Alpha',
        '\u03B2': 'beta',
        '\u0392': 'Beta',
        '\u03B3': 'gamma',
        '\u0393': 'Gamma',
        '\u03B4': 'delta',
        '\u0394': 'Delta',
        '\u03B5': 'epsi',
        '\u03F5': 'epsiv',
        '\u0395': 'Epsilon',
        '\u03DD': 'gammad',
        '\u03DC': 'Gammad',
        '\u03B6': 'zeta',
        '\u0396': 'Zeta',
        '\u03B7': 'eta',
        '\u0397': 'Eta',
        '\u03B8': 'theta',
        '\u03D1': 'thetav',
        '\u0398': 'Theta',
        '\u03B9': 'iota',
        '\u0399': 'Iota',
        '\u03BA': 'kappa',
        '\u03F0': 'kappav',
        '\u039A': 'Kappa',
        '\u03BB': 'lambda',
        '\u039B': 'Lambda',
        '\u03BC': 'mu',
        '\xB5': 'micro',
        '\u039C': 'Mu',
        '\u03BD': 'nu',
        '\u039D': 'Nu',
        '\u03BE': 'xi',
        '\u039E': 'Xi',
        '\u03BF': 'omicron',
        '\u039F': 'Omicron',
        '\u03C0': 'pi',
        '\u03D6': 'piv',
        '\u03A0': 'Pi',
        '\u03C1': 'rho',
        '\u03F1': 'rhov',
        '\u03A1': 'Rho',
        '\u03C3': 'sigma',
        '\u03A3': 'Sigma',
        '\u03C2': 'sigmaf',
        '\u03C4': 'tau',
        '\u03A4': 'Tau',
        '\u03C5': 'upsi',
        '\u03A5': 'Upsilon',
        '\u03D2': 'Upsi',
        '\u03C6': 'phi',
        '\u03D5': 'phiv',
        '\u03A6': 'Phi',
        '\u03C7': 'chi',
        '\u03A7': 'Chi',
        '\u03C8': 'psi',
        '\u03A8': 'Psi',
        '\u03C9': 'omega',
        '\u03A9': 'ohm',
        '\u0430': 'acy',
        '\u0410': 'Acy',
        '\u0431': 'bcy',
        '\u0411': 'Bcy',
        '\u0432': 'vcy',
        '\u0412': 'Vcy',
        '\u0433': 'gcy',
        '\u0413': 'Gcy',
        '\u0453': 'gjcy',
        '\u0403': 'GJcy',
        '\u0434': 'dcy',
        '\u0414': 'Dcy',
        '\u0452': 'djcy',
        '\u0402': 'DJcy',
        '\u0435': 'iecy',
        '\u0415': 'IEcy',
        '\u0451': 'iocy',
        '\u0401': 'IOcy',
        '\u0454': 'jukcy',
        '\u0404': 'Jukcy',
        '\u0436': 'zhcy',
        '\u0416': 'ZHcy',
        '\u0437': 'zcy',
        '\u0417': 'Zcy',
        '\u0455': 'dscy',
        '\u0405': 'DScy',
        '\u0438': 'icy',
        '\u0418': 'Icy',
        '\u0456': 'iukcy',
        '\u0406': 'Iukcy',
        '\u0457': 'yicy',
        '\u0407': 'YIcy',
        '\u0439': 'jcy',
        '\u0419': 'Jcy',
        '\u0458': 'jsercy',
        '\u0408': 'Jsercy',
        '\u043A': 'kcy',
        '\u041A': 'Kcy',
        '\u045C': 'kjcy',
        '\u040C': 'KJcy',
        '\u043B': 'lcy',
        '\u041B': 'Lcy',
        '\u0459': 'ljcy',
        '\u0409': 'LJcy',
        '\u043C': 'mcy',
        '\u041C': 'Mcy',
        '\u043D': 'ncy',
        '\u041D': 'Ncy',
        '\u045A': 'njcy',
        '\u040A': 'NJcy',
        '\u043E': 'ocy',
        '\u041E': 'Ocy',
        '\u043F': 'pcy',
        '\u041F': 'Pcy',
        '\u0440': 'rcy',
        '\u0420': 'Rcy',
        '\u0441': 'scy',
        '\u0421': 'Scy',
        '\u0442': 'tcy',
        '\u0422': 'Tcy',
        '\u045B': 'tshcy',
        '\u040B': 'TSHcy',
        '\u0443': 'ucy',
        '\u0423': 'Ucy',
        '\u045E': 'ubrcy',
        '\u040E': 'Ubrcy',
        '\u0444': 'fcy',
        '\u0424': 'Fcy',
        '\u0445': 'khcy',
        '\u0425': 'KHcy',
        '\u0446': 'tscy',
        '\u0426': 'TScy',
        '\u0447': 'chcy',
        '\u0427': 'CHcy',
        '\u045F': 'dzcy',
        '\u040F': 'DZcy',
        '\u0448': 'shcy',
        '\u0428': 'SHcy',
        '\u0449': 'shchcy',
        '\u0429': 'SHCHcy',
        '\u044A': 'hardcy',
        '\u042A': 'HARDcy',
        '\u044B': 'ycy',
        '\u042B': 'Ycy',
        '\u044C': 'softcy',
        '\u042C': 'SOFTcy',
        '\u044D': 'ecy',
        '\u042D': 'Ecy',
        '\u044E': 'yucy',
        '\u042E': 'YUcy',
        '\u044F': 'yacy',
        '\u042F': 'YAcy',
        '\u2135': 'aleph',
        '\u2136': 'beth',
        '\u2137': 'gimel',
        '\u2138': 'daleth'
    };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
        '"': '&quot;',
        '&': '&amp;',
        '\'': '&#x27;',
        '<': '&lt;',
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        '>': '&gt;',
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        '`': '&#x60;'
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'abreve': '\u0103',
        'Abreve': '\u0102',
        'ac': '\u223E',
        'acd': '\u223F',
        'acE': '\u223E\u0333',
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'acy': '\u0430',
        'Acy': '\u0410',
        'aelig': '\xE6',
        'AElig': '\xC6',
        'af': '\u2061',
        'afr': '\uD835\uDD1E',
        'Afr': '\uD835\uDD04',
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'alefsym': '\u2135',
        'aleph': '\u2135',
        'alpha': '\u03B1',
        'Alpha': '\u0391',
        'amacr': '\u0101',
        'Amacr': '\u0100',
        'amalg': '\u2A3F',
        'amp': '&',
        'AMP': '&',
        'and': '\u2227',
        'And': '\u2A53',
        'andand': '\u2A55',
        'andd': '\u2A5C',
        'andslope': '\u2A58',
        'andv': '\u2A5A',
        'ang': '\u2220',
        'ange': '\u29A4',
        'angle': '\u2220',
        'angmsd': '\u2221',
        'angmsdaa': '\u29A8',
        'angmsdab': '\u29A9',
        'angmsdac': '\u29AA',
        'angmsdad': '\u29AB',
        'angmsdae': '\u29AC',
        'angmsdaf': '\u29AD',
        'angmsdag': '\u29AE',
        'angmsdah': '\u29AF',
        'angrt': '\u221F',
        'angrtvb': '\u22BE',
        'angrtvbd': '\u299D',
        'angsph': '\u2222',
        'angst': '\xC5',
        'angzarr': '\u237C',
        'aogon': '\u0105',
        'Aogon': '\u0104',
        'aopf': '\uD835\uDD52',
        'Aopf': '\uD835\uDD38',
        'ap': '\u2248',
        'apacir': '\u2A6F',
        'ape': '\u224A',
        'apE': '\u2A70',
        'apid': '\u224B',
        'apos': '\'',
        'ApplyFunction': '\u2061',
        'approx': '\u2248',
        'approxeq': '\u224A',
        'aring': '\xE5',
        'Aring': '\xC5',
        'ascr': '\uD835\uDCB6',
        'Ascr': '\uD835\uDC9C',
        'Assign': '\u2254',
        'ast': '*',
        'asymp': '\u2248',
        'asympeq': '\u224D',
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'awconint': '\u2233',
        'awint': '\u2A11',
        'backcong': '\u224C',
        'backepsilon': '\u03F6',
        'backprime': '\u2035',
        'backsim': '\u223D',
        'backsimeq': '\u22CD',
        'Backslash': '\u2216',
        'Barv': '\u2AE7',
        'barvee': '\u22BD',
        'barwed': '\u2305',
        'Barwed': '\u2306',
        'barwedge': '\u2305',
        'bbrk': '\u23B5',
        'bbrktbrk': '\u23B6',
        'bcong': '\u224C',
        'bcy': '\u0431',
        'Bcy': '\u0411',
        'bdquo': '\u201E',
        'becaus': '\u2235',
        'because': '\u2235',
        'Because': '\u2235',
        'bemptyv': '\u29B0',
        'bepsi': '\u03F6',
        'bernou': '\u212C',
        'Bernoullis': '\u212C',
        'beta': '\u03B2',
        'Beta': '\u0392',
        'beth': '\u2136',
        'between': '\u226C',
        'bfr': '\uD835\uDD1F',
        'Bfr': '\uD835\uDD05',
        'bigcap': '\u22C2',
        'bigcirc': '\u25EF',
        'bigcup': '\u22C3',
        'bigodot': '\u2A00',
        'bigoplus': '\u2A01',
        'bigotimes': '\u2A02',
        'bigsqcup': '\u2A06',
        'bigstar': '\u2605',
        'bigtriangledown': '\u25BD',
        'bigtriangleup': '\u25B3',
        'biguplus': '\u2A04',
        'bigvee': '\u22C1',
        'bigwedge': '\u22C0',
        'bkarow': '\u290D',
        'blacklozenge': '\u29EB',
        'blacksquare': '\u25AA',
        'blacktriangle': '\u25B4',
        'blacktriangledown': '\u25BE',
        'blacktriangleleft': '\u25C2',
        'blacktriangleright': '\u25B8',
        'blank': '\u2423',
        'blk12': '\u2592',
        'blk14': '\u2591',
        'blk34': '\u2593',
        'block': '\u2588',
        'bne': '=\u20E5',
        'bnequiv': '\u2261\u20E5',
        'bnot': '\u2310',
        'bNot': '\u2AED',
        'bopf': '\uD835\uDD53',
        'Bopf': '\uD835\uDD39',
        'bot': '\u22A5',
        'bottom': '\u22A5',
        'bowtie': '\u22C8',
        'boxbox': '\u29C9',
        'boxdl': '\u2510',
        'boxdL': '\u2555',
        'boxDl': '\u2556',
        'boxDL': '\u2557',
        'boxdr': '\u250C',
        'boxdR': '\u2552',
        'boxDr': '\u2553',
        'boxDR': '\u2554',
        'boxh': '\u2500',
        'boxH': '\u2550',
        'boxhd': '\u252C',
        'boxhD': '\u2565',
        'boxHd': '\u2564',
        'boxHD': '\u2566',
        'boxhu': '\u2534',
        'boxhU': '\u2568',
        'boxHu': '\u2567',
        'boxHU': '\u2569',
        'boxminus': '\u229F',
        'boxplus': '\u229E',
        'boxtimes': '\u22A0',
        'boxul': '\u2518',
        'boxuL': '\u255B',
        'boxUl': '\u255C',
        'boxUL': '\u255D',
        'boxur': '\u2514',
        'boxuR': '\u2558',
        'boxUr': '\u2559',
        'boxUR': '\u255A',
        'boxv': '\u2502',
        'boxV': '\u2551',
        'boxvh': '\u253C',
        'boxvH': '\u256A',
        'boxVh': '\u256B',
        'boxVH': '\u256C',
        'boxvl': '\u2524',
        'boxvL': '\u2561',
        'boxVl': '\u2562',
        'boxVL': '\u2563',
        'boxvr': '\u251C',
        'boxvR': '\u255E',
        'boxVr': '\u255F',
        'boxVR': '\u2560',
        'bprime': '\u2035',
        'breve': '\u02D8',
        'Breve': '\u02D8',
        'brvbar': '\xA6',
        'bscr': '\uD835\uDCB7',
        'Bscr': '\u212C',
        'bsemi': '\u204F',
        'bsim': '\u223D',
        'bsime': '\u22CD',
        'bsol': '\\',
        'bsolb': '\u29C5',
        'bsolhsub': '\u27C8',
        'bull': '\u2022',
        'bullet': '\u2022',
        'bump': '\u224E',
        'bumpe': '\u224F',
        'bumpE': '\u2AAE',
        'bumpeq': '\u224F',
        'Bumpeq': '\u224E',
        'cacute': '\u0107',
        'Cacute': '\u0106',
        'cap': '\u2229',
        'Cap': '\u22D2',
        'capand': '\u2A44',
        'capbrcup': '\u2A49',
        'capcap': '\u2A4B',
        'capcup': '\u2A47',
        'capdot': '\u2A40',
        'CapitalDifferentialD': '\u2145',
        'caps': '\u2229\uFE00',
        'caret': '\u2041',
        'caron': '\u02C7',
        'Cayleys': '\u212D',
        'ccaps': '\u2A4D',
        'ccaron': '\u010D',
        'Ccaron': '\u010C',
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'ccirc': '\u0109',
        'Ccirc': '\u0108',
        'Cconint': '\u2230',
        'ccups': '\u2A4C',
        'ccupssm': '\u2A50',
        'cdot': '\u010B',
        'Cdot': '\u010A',
        'cedil': '\xB8',
        'Cedilla': '\xB8',
        'cemptyv': '\u29B2',
        'cent': '\xA2',
        'centerdot': '\xB7',
        'CenterDot': '\xB7',
        'cfr': '\uD835\uDD20',
        'Cfr': '\u212D',
        'chcy': '\u0447',
        'CHcy': '\u0427',
        'check': '\u2713',
        'checkmark': '\u2713',
        'chi': '\u03C7',
        'Chi': '\u03A7',
        'cir': '\u25CB',
        'circ': '\u02C6',
        'circeq': '\u2257',
        'circlearrowleft': '\u21BA',
        'circlearrowright': '\u21BB',
        'circledast': '\u229B',
        'circledcirc': '\u229A',
        'circleddash': '\u229D',
        'CircleDot': '\u2299',
        'circledR': '\xAE',
        'circledS': '\u24C8',
        'CircleMinus': '\u2296',
        'CirclePlus': '\u2295',
        'CircleTimes': '\u2297',
        'cire': '\u2257',
        'cirE': '\u29C3',
        'cirfnint': '\u2A10',
        'cirmid': '\u2AEF',
        'cirscir': '\u29C2',
        'ClockwiseContourIntegral': '\u2232',
        'CloseCurlyDoubleQuote': '\u201D',
        'CloseCurlyQuote': '\u2019',
        'clubs': '\u2663',
        'clubsuit': '\u2663',
        'colon': ':',
        'Colon': '\u2237',
        'colone': '\u2254',
        'Colone': '\u2A74',
        'coloneq': '\u2254',
        'comma': ',',
        'commat': '@',
        'comp': '\u2201',
        'compfn': '\u2218',
        'complement': '\u2201',
        'complexes': '\u2102',
        'cong': '\u2245',
        'congdot': '\u2A6D',
        'Congruent': '\u2261',
        'conint': '\u222E',
        'Conint': '\u222F',
        'ContourIntegral': '\u222E',
        'copf': '\uD835\uDD54',
        'Copf': '\u2102',
        'coprod': '\u2210',
        'Coproduct': '\u2210',
        'copy': '\xA9',
        'COPY': '\xA9',
        'copysr': '\u2117',
        'CounterClockwiseContourIntegral': '\u2233',
        'crarr': '\u21B5',
        'cross': '\u2717',
        'Cross': '\u2A2F',
        'cscr': '\uD835\uDCB8',
        'Cscr': '\uD835\uDC9E',
        'csub': '\u2ACF',
        'csube': '\u2AD1',
        'csup': '\u2AD0',
        'csupe': '\u2AD2',
        'ctdot': '\u22EF',
        'cudarrl': '\u2938',
        'cudarrr': '\u2935',
        'cuepr': '\u22DE',
        'cuesc': '\u22DF',
        'cularr': '\u21B6',
        'cularrp': '\u293D',
        'cup': '\u222A',
        'Cup': '\u22D3',
        'cupbrcap': '\u2A48',
        'cupcap': '\u2A46',
        'CupCap': '\u224D',
        'cupcup': '\u2A4A',
        'cupdot': '\u228D',
        'cupor': '\u2A45',
        'cups': '\u222A\uFE00',
        'curarr': '\u21B7',
        'curarrm': '\u293C',
        'curlyeqprec': '\u22DE',
        'curlyeqsucc': '\u22DF',
        'curlyvee': '\u22CE',
        'curlywedge': '\u22CF',
        'curren': '\xA4',
        'curvearrowleft': '\u21B6',
        'curvearrowright': '\u21B7',
        'cuvee': '\u22CE',
        'cuwed': '\u22CF',
        'cwconint': '\u2232',
        'cwint': '\u2231',
        'cylcty': '\u232D',
        'dagger': '\u2020',
        'Dagger': '\u2021',
        'daleth': '\u2138',
        'darr': '\u2193',
        'dArr': '\u21D3',
        'Darr': '\u21A1',
        'dash': '\u2010',
        'dashv': '\u22A3',
        'Dashv': '\u2AE4',
        'dbkarow': '\u290F',
        'dblac': '\u02DD',
        'dcaron': '\u010F',
        'Dcaron': '\u010E',
        'dcy': '\u0434',
        'Dcy': '\u0414',
        'dd': '\u2146',
        'DD': '\u2145',
        'ddagger': '\u2021',
        'ddarr': '\u21CA',
        'DDotrahd': '\u2911',
        'ddotseq': '\u2A77',
        'deg': '\xB0',
        'Del': '\u2207',
        'delta': '\u03B4',
        'Delta': '\u0394',
        'demptyv': '\u29B1',
        'dfisht': '\u297F',
        'dfr': '\uD835\uDD21',
        'Dfr': '\uD835\uDD07',
        'dHar': '\u2965',
        'dharl': '\u21C3',
        'dharr': '\u21C2',
        'DiacriticalAcute': '\xB4',
        'DiacriticalDot': '\u02D9',
        'DiacriticalDoubleAcute': '\u02DD',
        'DiacriticalGrave': '`',
        'DiacriticalTilde': '\u02DC',
        'diam': '\u22C4',
        'diamond': '\u22C4',
        'Diamond': '\u22C4',
        'diamondsuit': '\u2666',
        'diams': '\u2666',
        'die': '\xA8',
        'DifferentialD': '\u2146',
        'digamma': '\u03DD',
        'disin': '\u22F2',
        'div': '\xF7',
        'divide': '\xF7',
        'divideontimes': '\u22C7',
        'divonx': '\u22C7',
        'djcy': '\u0452',
        'DJcy': '\u0402',
        'dlcorn': '\u231E',
        'dlcrop': '\u230D',
        'dollar': '$',
        'dopf': '\uD835\uDD55',
        'Dopf': '\uD835\uDD3B',
        'dot': '\u02D9',
        'Dot': '\xA8',
        'DotDot': '\u20DC',
        'doteq': '\u2250',
        'doteqdot': '\u2251',
        'DotEqual': '\u2250',
        'dotminus': '\u2238',
        'dotplus': '\u2214',
        'dotsquare': '\u22A1',
        'doublebarwedge': '\u2306',
        'DoubleContourIntegral': '\u222F',
        'DoubleDot': '\xA8',
        'DoubleDownArrow': '\u21D3',
        'DoubleLeftArrow': '\u21D0',
        'DoubleLeftRightArrow': '\u21D4',
        'DoubleLeftTee': '\u2AE4',
        'DoubleLongLeftArrow': '\u27F8',
        'DoubleLongLeftRightArrow': '\u27FA',
        'DoubleLongRightArrow': '\u27F9',
        'DoubleRightArrow': '\u21D2',
        'DoubleRightTee': '\u22A8',
        'DoubleUpArrow': '\u21D1',
        'DoubleUpDownArrow': '\u21D5',
        'DoubleVerticalBar': '\u2225',
        'downarrow': '\u2193',
        'Downarrow': '\u21D3',
        'DownArrow': '\u2193',
        'DownArrowBar': '\u2913',
        'DownArrowUpArrow': '\u21F5',
        'DownBreve': '\u0311',
        'downdownarrows': '\u21CA',
        'downharpoonleft': '\u21C3',
        'downharpoonright': '\u21C2',
        'DownLeftRightVector': '\u2950',
        'DownLeftTeeVector': '\u295E',
        'DownLeftVector': '\u21BD',
        'DownLeftVectorBar': '\u2956',
        'DownRightTeeVector': '\u295F',
        'DownRightVector': '\u21C1',
        'DownRightVectorBar': '\u2957',
        'DownTee': '\u22A4',
        'DownTeeArrow': '\u21A7',
        'drbkarow': '\u2910',
        'drcorn': '\u231F',
        'drcrop': '\u230C',
        'dscr': '\uD835\uDCB9',
        'Dscr': '\uD835\uDC9F',
        'dscy': '\u0455',
        'DScy': '\u0405',
        'dsol': '\u29F6',
        'dstrok': '\u0111',
        'Dstrok': '\u0110',
        'dtdot': '\u22F1',
        'dtri': '\u25BF',
        'dtrif': '\u25BE',
        'duarr': '\u21F5',
        'duhar': '\u296F',
        'dwangle': '\u29A6',
        'dzcy': '\u045F',
        'DZcy': '\u040F',
        'dzigrarr': '\u27FF',
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'easter': '\u2A6E',
        'ecaron': '\u011B',
        'Ecaron': '\u011A',
        'ecir': '\u2256',
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'ecolon': '\u2255',
        'ecy': '\u044D',
        'Ecy': '\u042D',
        'eDDot': '\u2A77',
        'edot': '\u0117',
        'eDot': '\u2251',
        'Edot': '\u0116',
        'ee': '\u2147',
        'efDot': '\u2252',
        'efr': '\uD835\uDD22',
        'Efr': '\uD835\uDD08',
        'eg': '\u2A9A',
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'egs': '\u2A96',
        'egsdot': '\u2A98',
        'el': '\u2A99',
        'Element': '\u2208',
        'elinters': '\u23E7',
        'ell': '\u2113',
        'els': '\u2A95',
        'elsdot': '\u2A97',
        'emacr': '\u0113',
        'Emacr': '\u0112',
        'empty': '\u2205',
        'emptyset': '\u2205',
        'EmptySmallSquare': '\u25FB',
        'emptyv': '\u2205',
        'EmptyVerySmallSquare': '\u25AB',
        'emsp': '\u2003',
        'emsp13': '\u2004',
        'emsp14': '\u2005',
        'eng': '\u014B',
        'ENG': '\u014A',
        'ensp': '\u2002',
        'eogon': '\u0119',
        'Eogon': '\u0118',
        'eopf': '\uD835\uDD56',
        'Eopf': '\uD835\uDD3C',
        'epar': '\u22D5',
        'eparsl': '\u29E3',
        'eplus': '\u2A71',
        'epsi': '\u03B5',
        'epsilon': '\u03B5',
        'Epsilon': '\u0395',
        'epsiv': '\u03F5',
        'eqcirc': '\u2256',
        'eqcolon': '\u2255',
        'eqsim': '\u2242',
        'eqslantgtr': '\u2A96',
        'eqslantless': '\u2A95',
        'Equal': '\u2A75',
        'equals': '=',
        'EqualTilde': '\u2242',
        'equest': '\u225F',
        'Equilibrium': '\u21CC',
        'equiv': '\u2261',
        'equivDD': '\u2A78',
        'eqvparsl': '\u29E5',
        'erarr': '\u2971',
        'erDot': '\u2253',
        'escr': '\u212F',
        'Escr': '\u2130',
        'esdot': '\u2250',
        'esim': '\u2242',
        'Esim': '\u2A73',
        'eta': '\u03B7',
        'Eta': '\u0397',
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'euro': '\u20AC',
        'excl': '!',
        'exist': '\u2203',
        'Exists': '\u2203',
        'expectation': '\u2130',
        'exponentiale': '\u2147',
        'ExponentialE': '\u2147',
        'fallingdotseq': '\u2252',
        'fcy': '\u0444',
        'Fcy': '\u0424',
        'female': '\u2640',
        'ffilig': '\uFB03',
        'fflig': '\uFB00',
        'ffllig': '\uFB04',
        'ffr': '\uD835\uDD23',
        'Ffr': '\uD835\uDD09',
        'filig': '\uFB01',
        'FilledSmallSquare': '\u25FC',
        'FilledVerySmallSquare': '\u25AA',
        'fjlig': 'fj',
        'flat': '\u266D',
        'fllig': '\uFB02',
        'fltns': '\u25B1',
        'fnof': '\u0192',
        'fopf': '\uD835\uDD57',
        'Fopf': '\uD835\uDD3D',
        'forall': '\u2200',
        'ForAll': '\u2200',
        'fork': '\u22D4',
        'forkv': '\u2AD9',
        'Fouriertrf': '\u2131',
        'fpartint': '\u2A0D',
        'frac12': '\xBD',
        'frac13': '\u2153',
        'frac14': '\xBC',
        'frac15': '\u2155',
        'frac16': '\u2159',
        'frac18': '\u215B',
        'frac23': '\u2154',
        'frac25': '\u2156',
        'frac34': '\xBE',
        'frac35': '\u2157',
        'frac38': '\u215C',
        'frac45': '\u2158',
        'frac56': '\u215A',
        'frac58': '\u215D',
        'frac78': '\u215E',
        'frasl': '\u2044',
        'frown': '\u2322',
        'fscr': '\uD835\uDCBB',
        'Fscr': '\u2131',
        'gacute': '\u01F5',
        'gamma': '\u03B3',
        'Gamma': '\u0393',
        'gammad': '\u03DD',
        'Gammad': '\u03DC',
        'gap': '\u2A86',
        'gbreve': '\u011F',
        'Gbreve': '\u011E',
        'Gcedil': '\u0122',
        'gcirc': '\u011D',
        'Gcirc': '\u011C',
        'gcy': '\u0433',
        'Gcy': '\u0413',
        'gdot': '\u0121',
        'Gdot': '\u0120',
        'ge': '\u2265',
        'gE': '\u2267',
        'gel': '\u22DB',
        'gEl': '\u2A8C',
        'geq': '\u2265',
        'geqq': '\u2267',
        'geqslant': '\u2A7E',
        'ges': '\u2A7E',
        'gescc': '\u2AA9',
        'gesdot': '\u2A80',
        'gesdoto': '\u2A82',
        'gesdotol': '\u2A84',
        'gesl': '\u22DB\uFE00',
        'gesles': '\u2A94',
        'gfr': '\uD835\uDD24',
        'Gfr': '\uD835\uDD0A',
        'gg': '\u226B',
        'Gg': '\u22D9',
        'ggg': '\u22D9',
        'gimel': '\u2137',
        'gjcy': '\u0453',
        'GJcy': '\u0403',
        'gl': '\u2277',
        'gla': '\u2AA5',
        'glE': '\u2A92',
        'glj': '\u2AA4',
        'gnap': '\u2A8A',
        'gnapprox': '\u2A8A',
        'gne': '\u2A88',
        'gnE': '\u2269',
        'gneq': '\u2A88',
        'gneqq': '\u2269',
        'gnsim': '\u22E7',
        'gopf': '\uD835\uDD58',
        'Gopf': '\uD835\uDD3E',
        'grave': '`',
        'GreaterEqual': '\u2265',
        'GreaterEqualLess': '\u22DB',
        'GreaterFullEqual': '\u2267',
        'GreaterGreater': '\u2AA2',
        'GreaterLess': '\u2277',
        'GreaterSlantEqual': '\u2A7E',
        'GreaterTilde': '\u2273',
        'gscr': '\u210A',
        'Gscr': '\uD835\uDCA2',
        'gsim': '\u2273',
        'gsime': '\u2A8E',
        'gsiml': '\u2A90',
        'gt': '>',
        'Gt': '\u226B',
        'GT': '>',
        'gtcc': '\u2AA7',
        'gtcir': '\u2A7A',
        'gtdot': '\u22D7',
        'gtlPar': '\u2995',
        'gtquest': '\u2A7C',
        'gtrapprox': '\u2A86',
        'gtrarr': '\u2978',
        'gtrdot': '\u22D7',
        'gtreqless': '\u22DB',
        'gtreqqless': '\u2A8C',
        'gtrless': '\u2277',
        'gtrsim': '\u2273',
        'gvertneqq': '\u2269\uFE00',
        'gvnE': '\u2269\uFE00',
        'Hacek': '\u02C7',
        'hairsp': '\u200A',
        'half': '\xBD',
        'hamilt': '\u210B',
        'hardcy': '\u044A',
        'HARDcy': '\u042A',
        'harr': '\u2194',
        'hArr': '\u21D4',
        'harrcir': '\u2948',
        'harrw': '\u21AD',
        'Hat': '^',
        'hbar': '\u210F',
        'hcirc': '\u0125',
        'Hcirc': '\u0124',
        'hearts': '\u2665',
        'heartsuit': '\u2665',
        'hellip': '\u2026',
        'hercon': '\u22B9',
        'hfr': '\uD835\uDD25',
        'Hfr': '\u210C',
        'HilbertSpace': '\u210B',
        'hksearow': '\u2925',
        'hkswarow': '\u2926',
        'hoarr': '\u21FF',
        'homtht': '\u223B',
        'hookleftarrow': '\u21A9',
        'hookrightarrow': '\u21AA',
        'hopf': '\uD835\uDD59',
        'Hopf': '\u210D',
        'horbar': '\u2015',
        'HorizontalLine': '\u2500',
        'hscr': '\uD835\uDCBD',
        'Hscr': '\u210B',
        'hslash': '\u210F',
        'hstrok': '\u0127',
        'Hstrok': '\u0126',
        'HumpDownHump': '\u224E',
        'HumpEqual': '\u224F',
        'hybull': '\u2043',
        'hyphen': '\u2010',
        'iacute': '\xED',
        'Iacute': '\xCD',
        'ic': '\u2063',
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'icy': '\u0438',
        'Icy': '\u0418',
        'Idot': '\u0130',
        'iecy': '\u0435',
        'IEcy': '\u0415',
        'iexcl': '\xA1',
        'iff': '\u21D4',
        'ifr': '\uD835\uDD26',
        'Ifr': '\u2111',
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'ii': '\u2148',
        'iiiint': '\u2A0C',
        'iiint': '\u222D',
        'iinfin': '\u29DC',
        'iiota': '\u2129',
        'ijlig': '\u0133',
        'IJlig': '\u0132',
        'Im': '\u2111',
        'imacr': '\u012B',
        'Imacr': '\u012A',
        'image': '\u2111',
        'ImaginaryI': '\u2148',
        'imagline': '\u2110',
        'imagpart': '\u2111',
        'imath': '\u0131',
        'imof': '\u22B7',
        'imped': '\u01B5',
        'Implies': '\u21D2',
        'in': '\u2208',
        'incare': '\u2105',
        'infin': '\u221E',
        'infintie': '\u29DD',
        'inodot': '\u0131',
        'int': '\u222B',
        'Int': '\u222C',
        'intcal': '\u22BA',
        'integers': '\u2124',
        'Integral': '\u222B',
        'intercal': '\u22BA',
        'Intersection': '\u22C2',
        'intlarhk': '\u2A17',
        'intprod': '\u2A3C',
        'InvisibleComma': '\u2063',
        'InvisibleTimes': '\u2062',
        'iocy': '\u0451',
        'IOcy': '\u0401',
        'iogon': '\u012F',
        'Iogon': '\u012E',
        'iopf': '\uD835\uDD5A',
        'Iopf': '\uD835\uDD40',
        'iota': '\u03B9',
        'Iota': '\u0399',
        'iprod': '\u2A3C',
        'iquest': '\xBF',
        'iscr': '\uD835\uDCBE',
        'Iscr': '\u2110',
        'isin': '\u2208',
        'isindot': '\u22F5',
        'isinE': '\u22F9',
        'isins': '\u22F4',
        'isinsv': '\u22F3',
        'isinv': '\u2208',
        'it': '\u2062',
        'itilde': '\u0129',
        'Itilde': '\u0128',
        'iukcy': '\u0456',
        'Iukcy': '\u0406',
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'jcirc': '\u0135',
        'Jcirc': '\u0134',
        'jcy': '\u0439',
        'Jcy': '\u0419',
        'jfr': '\uD835\uDD27',
        'Jfr': '\uD835\uDD0D',
        'jmath': '\u0237',
        'jopf': '\uD835\uDD5B',
        'Jopf': '\uD835\uDD41',
        'jscr': '\uD835\uDCBF',
        'Jscr': '\uD835\uDCA5',
        'jsercy': '\u0458',
        'Jsercy': '\u0408',
        'jukcy': '\u0454',
        'Jukcy': '\u0404',
        'kappa': '\u03BA',
        'Kappa': '\u039A',
        'kappav': '\u03F0',
        'kcedil': '\u0137',
        'Kcedil': '\u0136',
        'kcy': '\u043A',
        'Kcy': '\u041A',
        'kfr': '\uD835\uDD28',
        'Kfr': '\uD835\uDD0E',
        'kgreen': '\u0138',
        'khcy': '\u0445',
        'KHcy': '\u0425',
        'kjcy': '\u045C',
        'KJcy': '\u040C',
        'kopf': '\uD835\uDD5C',
        'Kopf': '\uD835\uDD42',
        'kscr': '\uD835\uDCC0',
        'Kscr': '\uD835\uDCA6',
        'lAarr': '\u21DA',
        'lacute': '\u013A',
        'Lacute': '\u0139',
        'laemptyv': '\u29B4',
        'lagran': '\u2112',
        'lambda': '\u03BB',
        'Lambda': '\u039B',
        'lang': '\u27E8',
        'Lang': '\u27EA',
        'langd': '\u2991',
        'langle': '\u27E8',
        'lap': '\u2A85',
        'Laplacetrf': '\u2112',
        'laquo': '\xAB',
        'larr': '\u2190',
        'lArr': '\u21D0',
        'Larr': '\u219E',
        'larrb': '\u21E4',
        'larrbfs': '\u291F',
        'larrfs': '\u291D',
        'larrhk': '\u21A9',
        'larrlp': '\u21AB',
        'larrpl': '\u2939',
        'larrsim': '\u2973',
        'larrtl': '\u21A2',
        'lat': '\u2AAB',
        'latail': '\u2919',
        'lAtail': '\u291B',
        'late': '\u2AAD',
        'lates': '\u2AAD\uFE00',
        'lbarr': '\u290C',
        'lBarr': '\u290E',
        'lbbrk': '\u2772',
        'lbrace': '{',
        'lbrack': '[',
        'lbrke': '\u298B',
        'lbrksld': '\u298F',
        'lbrkslu': '\u298D',
        'lcaron': '\u013E',
        'Lcaron': '\u013D',
        'lcedil': '\u013C',
        'Lcedil': '\u013B',
        'lceil': '\u2308',
        'lcub': '{',
        'lcy': '\u043B',
        'Lcy': '\u041B',
        'ldca': '\u2936',
        'ldquo': '\u201C',
        'ldquor': '\u201E',
        'ldrdhar': '\u2967',
        'ldrushar': '\u294B',
        'ldsh': '\u21B2',
        'le': '\u2264',
        'lE': '\u2266',
        'LeftAngleBracket': '\u27E8',
        'leftarrow': '\u2190',
        'Leftarrow': '\u21D0',
        'LeftArrow': '\u2190',
        'LeftArrowBar': '\u21E4',
        'LeftArrowRightArrow': '\u21C6',
        'leftarrowtail': '\u21A2',
        'LeftCeiling': '\u2308',
        'LeftDoubleBracket': '\u27E6',
        'LeftDownTeeVector': '\u2961',
        'LeftDownVector': '\u21C3',
        'LeftDownVectorBar': '\u2959',
        'LeftFloor': '\u230A',
        'leftharpoondown': '\u21BD',
        'leftharpoonup': '\u21BC',
        'leftleftarrows': '\u21C7',
        'leftrightarrow': '\u2194',
        'Leftrightarrow': '\u21D4',
        'LeftRightArrow': '\u2194',
        'leftrightarrows': '\u21C6',
        'leftrightharpoons': '\u21CB',
        'leftrightsquigarrow': '\u21AD',
        'LeftRightVector': '\u294E',
        'LeftTee': '\u22A3',
        'LeftTeeArrow': '\u21A4',
        'LeftTeeVector': '\u295A',
        'leftthreetimes': '\u22CB',
        'LeftTriangle': '\u22B2',
        'LeftTriangleBar': '\u29CF',
        'LeftTriangleEqual': '\u22B4',
        'LeftUpDownVector': '\u2951',
        'LeftUpTeeVector': '\u2960',
        'LeftUpVector': '\u21BF',
        'LeftUpVectorBar': '\u2958',
        'LeftVector': '\u21BC',
        'LeftVectorBar': '\u2952',
        'leg': '\u22DA',
        'lEg': '\u2A8B',
        'leq': '\u2264',
        'leqq': '\u2266',
        'leqslant': '\u2A7D',
        'les': '\u2A7D',
        'lescc': '\u2AA8',
        'lesdot': '\u2A7F',
        'lesdoto': '\u2A81',
        'lesdotor': '\u2A83',
        'lesg': '\u22DA\uFE00',
        'lesges': '\u2A93',
        'lessapprox': '\u2A85',
        'lessdot': '\u22D6',
        'lesseqgtr': '\u22DA',
        'lesseqqgtr': '\u2A8B',
        'LessEqualGreater': '\u22DA',
        'LessFullEqual': '\u2266',
        'LessGreater': '\u2276',
        'lessgtr': '\u2276',
        'LessLess': '\u2AA1',
        'lesssim': '\u2272',
        'LessSlantEqual': '\u2A7D',
        'LessTilde': '\u2272',
        'lfisht': '\u297C',
        'lfloor': '\u230A',
        'lfr': '\uD835\uDD29',
        'Lfr': '\uD835\uDD0F',
        'lg': '\u2276',
        'lgE': '\u2A91',
        'lHar': '\u2962',
        'lhard': '\u21BD',
        'lharu': '\u21BC',
        'lharul': '\u296A',
        'lhblk': '\u2584',
        'ljcy': '\u0459',
        'LJcy': '\u0409',
        'll': '\u226A',
        'Ll': '\u22D8',
        'llarr': '\u21C7',
        'llcorner': '\u231E',
        'Lleftarrow': '\u21DA',
        'llhard': '\u296B',
        'lltri': '\u25FA',
        'lmidot': '\u0140',
        'Lmidot': '\u013F',
        'lmoust': '\u23B0',
        'lmoustache': '\u23B0',
        'lnap': '\u2A89',
        'lnapprox': '\u2A89',
        'lne': '\u2A87',
        'lnE': '\u2268',
        'lneq': '\u2A87',
        'lneqq': '\u2268',
        'lnsim': '\u22E6',
        'loang': '\u27EC',
        'loarr': '\u21FD',
        'lobrk': '\u27E6',
        'longleftarrow': '\u27F5',
        'Longleftarrow': '\u27F8',
        'LongLeftArrow': '\u27F5',
        'longleftrightarrow': '\u27F7',
        'Longleftrightarrow': '\u27FA',
        'LongLeftRightArrow': '\u27F7',
        'longmapsto': '\u27FC',
        'longrightarrow': '\u27F6',
        'Longrightarrow': '\u27F9',
        'LongRightArrow': '\u27F6',
        'looparrowleft': '\u21AB',
        'looparrowright': '\u21AC',
        'lopar': '\u2985',
        'lopf': '\uD835\uDD5D',
        'Lopf': '\uD835\uDD43',
        'loplus': '\u2A2D',
        'lotimes': '\u2A34',
        'lowast': '\u2217',
        'lowbar': '_',
        'LowerLeftArrow': '\u2199',
        'LowerRightArrow': '\u2198',
        'loz': '\u25CA',
        'lozenge': '\u25CA',
        'lozf': '\u29EB',
        'lpar': '(',
        'lparlt': '\u2993',
        'lrarr': '\u21C6',
        'lrcorner': '\u231F',
        'lrhar': '\u21CB',
        'lrhard': '\u296D',
        'lrm': '\u200E',
        'lrtri': '\u22BF',
        'lsaquo': '\u2039',
        'lscr': '\uD835\uDCC1',
        'Lscr': '\u2112',
        'lsh': '\u21B0',
        'Lsh': '\u21B0',
        'lsim': '\u2272',
        'lsime': '\u2A8D',
        'lsimg': '\u2A8F',
        'lsqb': '[',
        'lsquo': '\u2018',
        'lsquor': '\u201A',
        'lstrok': '\u0142',
        'Lstrok': '\u0141',
        'lt': '<',
        'Lt': '\u226A',
        'LT': '<',
        'ltcc': '\u2AA6',
        'ltcir': '\u2A79',
        'ltdot': '\u22D6',
        'lthree': '\u22CB',
        'ltimes': '\u22C9',
        'ltlarr': '\u2976',
        'ltquest': '\u2A7B',
        'ltri': '\u25C3',
        'ltrie': '\u22B4',
        'ltrif': '\u25C2',
        'ltrPar': '\u2996',
        'lurdshar': '\u294A',
        'luruhar': '\u2966',
        'lvertneqq': '\u2268\uFE00',
        'lvnE': '\u2268\uFE00',
        'macr': '\xAF',
        'male': '\u2642',
        'malt': '\u2720',
        'maltese': '\u2720',
        'map': '\u21A6',
        'Map': '\u2905',
        'mapsto': '\u21A6',
        'mapstodown': '\u21A7',
        'mapstoleft': '\u21A4',
        'mapstoup': '\u21A5',
        'marker': '\u25AE',
        'mcomma': '\u2A29',
        'mcy': '\u043C',
        'Mcy': '\u041C',
        'mdash': '\u2014',
        'mDDot': '\u223A',
        'measuredangle': '\u2221',
        'MediumSpace': '\u205F',
        'Mellintrf': '\u2133',
        'mfr': '\uD835\uDD2A',
        'Mfr': '\uD835\uDD10',
        'mho': '\u2127',
        'micro': '\xB5',
        'mid': '\u2223',
        'midast': '*',
        'midcir': '\u2AF0',
        'middot': '\xB7',
        'minus': '\u2212',
        'minusb': '\u229F',
        'minusd': '\u2238',
        'minusdu': '\u2A2A',
        'MinusPlus': '\u2213',
        'mlcp': '\u2ADB',
        'mldr': '\u2026',
        'mnplus': '\u2213',
        'models': '\u22A7',
        'mopf': '\uD835\uDD5E',
        'Mopf': '\uD835\uDD44',
        'mp': '\u2213',
        'mscr': '\uD835\uDCC2',
        'Mscr': '\u2133',
        'mstpos': '\u223E',
        'mu': '\u03BC',
        'Mu': '\u039C',
        'multimap': '\u22B8',
        'mumap': '\u22B8',
        'nabla': '\u2207',
        'nacute': '\u0144',
        'Nacute': '\u0143',
        'nang': '\u2220\u20D2',
        'nap': '\u2249',
        'napE': '\u2A70\u0338',
        'napid': '\u224B\u0338',
        'napos': '\u0149',
        'napprox': '\u2249',
        'natur': '\u266E',
        'natural': '\u266E',
        'naturals': '\u2115',
        'nbsp': '\xA0',
        'nbump': '\u224E\u0338',
        'nbumpe': '\u224F\u0338',
        'ncap': '\u2A43',
        'ncaron': '\u0148',
        'Ncaron': '\u0147',
        'ncedil': '\u0146',
        'Ncedil': '\u0145',
        'ncong': '\u2247',
        'ncongdot': '\u2A6D\u0338',
        'ncup': '\u2A42',
        'ncy': '\u043D',
        'Ncy': '\u041D',
        'ndash': '\u2013',
        'ne': '\u2260',
        'nearhk': '\u2924',
        'nearr': '\u2197',
        'neArr': '\u21D7',
        'nearrow': '\u2197',
        'nedot': '\u2250\u0338',
        'NegativeMediumSpace': '\u200B',
        'NegativeThickSpace': '\u200B',
        'NegativeThinSpace': '\u200B',
        'NegativeVeryThinSpace': '\u200B',
        'nequiv': '\u2262',
        'nesear': '\u2928',
        'nesim': '\u2242\u0338',
        'NestedGreaterGreater': '\u226B',
        'NestedLessLess': '\u226A',
        'NewLine': '\n',
        'nexist': '\u2204',
        'nexists': '\u2204',
        'nfr': '\uD835\uDD2B',
        'Nfr': '\uD835\uDD11',
        'nge': '\u2271',
        'ngE': '\u2267\u0338',
        'ngeq': '\u2271',
        'ngeqq': '\u2267\u0338',
        'ngeqslant': '\u2A7E\u0338',
        'nges': '\u2A7E\u0338',
        'nGg': '\u22D9\u0338',
        'ngsim': '\u2275',
        'ngt': '\u226F',
        'nGt': '\u226B\u20D2',
        'ngtr': '\u226F',
        'nGtv': '\u226B\u0338',
        'nharr': '\u21AE',
        'nhArr': '\u21CE',
        'nhpar': '\u2AF2',
        'ni': '\u220B',
        'nis': '\u22FC',
        'nisd': '\u22FA',
        'niv': '\u220B',
        'njcy': '\u045A',
        'NJcy': '\u040A',
        'nlarr': '\u219A',
        'nlArr': '\u21CD',
        'nldr': '\u2025',
        'nle': '\u2270',
        'nlE': '\u2266\u0338',
        'nleftarrow': '\u219A',
        'nLeftarrow': '\u21CD',
        'nleftrightarrow': '\u21AE',
        'nLeftrightarrow': '\u21CE',
        'nleq': '\u2270',
        'nleqq': '\u2266\u0338',
        'nleqslant': '\u2A7D\u0338',
        'nles': '\u2A7D\u0338',
        'nless': '\u226E',
        'nLl': '\u22D8\u0338',
        'nlsim': '\u2274',
        'nlt': '\u226E',
        'nLt': '\u226A\u20D2',
        'nltri': '\u22EA',
        'nltrie': '\u22EC',
        'nLtv': '\u226A\u0338',
        'nmid': '\u2224',
        'NoBreak': '\u2060',
        'NonBreakingSpace': '\xA0',
        'nopf': '\uD835\uDD5F',
        'Nopf': '\u2115',
        'not': '\xAC',
        'Not': '\u2AEC',
        'NotCongruent': '\u2262',
        'NotCupCap': '\u226D',
        'NotDoubleVerticalBar': '\u2226',
        'NotElement': '\u2209',
        'NotEqual': '\u2260',
        'NotEqualTilde': '\u2242\u0338',
        'NotExists': '\u2204',
        'NotGreater': '\u226F',
        'NotGreaterEqual': '\u2271',
        'NotGreaterFullEqual': '\u2267\u0338',
        'NotGreaterGreater': '\u226B\u0338',
        'NotGreaterLess': '\u2279',
        'NotGreaterSlantEqual': '\u2A7E\u0338',
        'NotGreaterTilde': '\u2275',
        'NotHumpDownHump': '\u224E\u0338',
        'NotHumpEqual': '\u224F\u0338',
        'notin': '\u2209',
        'notindot': '\u22F5\u0338',
        'notinE': '\u22F9\u0338',
        'notinva': '\u2209',
        'notinvb': '\u22F7',
        'notinvc': '\u22F6',
        'NotLeftTriangle': '\u22EA',
        'NotLeftTriangleBar': '\u29CF\u0338',
        'NotLeftTriangleEqual': '\u22EC',
        'NotLess': '\u226E',
        'NotLessEqual': '\u2270',
        'NotLessGreater': '\u2278',
        'NotLessLess': '\u226A\u0338',
        'NotLessSlantEqual': '\u2A7D\u0338',
        'NotLessTilde': '\u2274',
        'NotNestedGreaterGreater': '\u2AA2\u0338',
        'NotNestedLessLess': '\u2AA1\u0338',
        'notni': '\u220C',
        'notniva': '\u220C',
        'notnivb': '\u22FE',
        'notnivc': '\u22FD',
        'NotPrecedes': '\u2280',
        'NotPrecedesEqual': '\u2AAF\u0338',
        'NotPrecedesSlantEqual': '\u22E0',
        'NotReverseElement': '\u220C',
        'NotRightTriangle': '\u22EB',
        'NotRightTriangleBar': '\u29D0\u0338',
        'NotRightTriangleEqual': '\u22ED',
        'NotSquareSubset': '\u228F\u0338',
        'NotSquareSubsetEqual': '\u22E2',
        'NotSquareSuperset': '\u2290\u0338',
        'NotSquareSupersetEqual': '\u22E3',
        'NotSubset': '\u2282\u20D2',
        'NotSubsetEqual': '\u2288',
        'NotSucceeds': '\u2281',
        'NotSucceedsEqual': '\u2AB0\u0338',
        'NotSucceedsSlantEqual': '\u22E1',
        'NotSucceedsTilde': '\u227F\u0338',
        'NotSuperset': '\u2283\u20D2',
        'NotSupersetEqual': '\u2289',
        'NotTilde': '\u2241',
        'NotTildeEqual': '\u2244',
        'NotTildeFullEqual': '\u2247',
        'NotTildeTilde': '\u2249',
        'NotVerticalBar': '\u2224',
        'npar': '\u2226',
        'nparallel': '\u2226',
        'nparsl': '\u2AFD\u20E5',
        'npart': '\u2202\u0338',
        'npolint': '\u2A14',
        'npr': '\u2280',
        'nprcue': '\u22E0',
        'npre': '\u2AAF\u0338',
        'nprec': '\u2280',
        'npreceq': '\u2AAF\u0338',
        'nrarr': '\u219B',
        'nrArr': '\u21CF',
        'nrarrc': '\u2933\u0338',
        'nrarrw': '\u219D\u0338',
        'nrightarrow': '\u219B',
        'nRightarrow': '\u21CF',
        'nrtri': '\u22EB',
        'nrtrie': '\u22ED',
        'nsc': '\u2281',
        'nsccue': '\u22E1',
        'nsce': '\u2AB0\u0338',
        'nscr': '\uD835\uDCC3',
        'Nscr': '\uD835\uDCA9',
        'nshortmid': '\u2224',
        'nshortparallel': '\u2226',
        'nsim': '\u2241',
        'nsime': '\u2244',
        'nsimeq': '\u2244',
        'nsmid': '\u2224',
        'nspar': '\u2226',
        'nsqsube': '\u22E2',
        'nsqsupe': '\u22E3',
        'nsub': '\u2284',
        'nsube': '\u2288',
        'nsubE': '\u2AC5\u0338',
        'nsubset': '\u2282\u20D2',
        'nsubseteq': '\u2288',
        'nsubseteqq': '\u2AC5\u0338',
        'nsucc': '\u2281',
        'nsucceq': '\u2AB0\u0338',
        'nsup': '\u2285',
        'nsupe': '\u2289',
        'nsupE': '\u2AC6\u0338',
        'nsupset': '\u2283\u20D2',
        'nsupseteq': '\u2289',
        'nsupseteqq': '\u2AC6\u0338',
        'ntgl': '\u2279',
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'ntlg': '\u2278',
        'ntriangleleft': '\u22EA',
        'ntrianglelefteq': '\u22EC',
        'ntriangleright': '\u22EB',
        'ntrianglerighteq': '\u22ED',
        'nu': '\u03BD',
        'Nu': '\u039D',
        'num': '#',
        'numero': '\u2116',
        'numsp': '\u2007',
        'nvap': '\u224D\u20D2',
        'nvdash': '\u22AC',
        'nvDash': '\u22AD',
        'nVdash': '\u22AE',
        'nVDash': '\u22AF',
        'nvge': '\u2265\u20D2',
        'nvgt': '>\u20D2',
        'nvHarr': '\u2904',
        'nvinfin': '\u29DE',
        'nvlArr': '\u2902',
        'nvle': '\u2264\u20D2',
        'nvlt': '<\u20D2',
        'nvltrie': '\u22B4\u20D2',
        'nvrArr': '\u2903',
        'nvrtrie': '\u22B5\u20D2',
        'nvsim': '\u223C\u20D2',
        'nwarhk': '\u2923',
        'nwarr': '\u2196',
        'nwArr': '\u21D6',
        'nwarrow': '\u2196',
        'nwnear': '\u2927',
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'oast': '\u229B',
        'ocir': '\u229A',
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ocy': '\u043E',
        'Ocy': '\u041E',
        'odash': '\u229D',
        'odblac': '\u0151',
        'Odblac': '\u0150',
        'odiv': '\u2A38',
        'odot': '\u2299',
        'odsold': '\u29BC',
        'oelig': '\u0153',
        'OElig': '\u0152',
        'ofcir': '\u29BF',
        'ofr': '\uD835\uDD2C',
        'Ofr': '\uD835\uDD12',
        'ogon': '\u02DB',
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ogt': '\u29C1',
        'ohbar': '\u29B5',
        'ohm': '\u03A9',
        'oint': '\u222E',
        'olarr': '\u21BA',
        'olcir': '\u29BE',
        'olcross': '\u29BB',
        'oline': '\u203E',
        'olt': '\u29C0',
        'omacr': '\u014D',
        'Omacr': '\u014C',
        'omega': '\u03C9',
        'Omega': '\u03A9',
        'omicron': '\u03BF',
        'Omicron': '\u039F',
        'omid': '\u29B6',
        'ominus': '\u2296',
        'oopf': '\uD835\uDD60',
        'Oopf': '\uD835\uDD46',
        'opar': '\u29B7',
        'OpenCurlyDoubleQuote': '\u201C',
        'OpenCurlyQuote': '\u2018',
        'operp': '\u29B9',
        'oplus': '\u2295',
        'or': '\u2228',
        'Or': '\u2A54',
        'orarr': '\u21BB',
        'ord': '\u2A5D',
        'order': '\u2134',
        'orderof': '\u2134',
        'ordf': '\xAA',
        'ordm': '\xBA',
        'origof': '\u22B6',
        'oror': '\u2A56',
        'orslope': '\u2A57',
        'orv': '\u2A5B',
        'oS': '\u24C8',
        'oscr': '\u2134',
        'Oscr': '\uD835\uDCAA',
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'osol': '\u2298',
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'otimes': '\u2297',
        'Otimes': '\u2A37',
        'otimesas': '\u2A36',
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'ovbar': '\u233D',
        'OverBar': '\u203E',
        'OverBrace': '\u23DE',
        'OverBracket': '\u23B4',
        'OverParenthesis': '\u23DC',
        'par': '\u2225',
        'para': '\xB6',
        'parallel': '\u2225',
        'parsim': '\u2AF3',
        'parsl': '\u2AFD',
        'part': '\u2202',
        'PartialD': '\u2202',
        'pcy': '\u043F',
        'Pcy': '\u041F',
        'percnt': '%',
        'period': '.',
        'permil': '\u2030',
        'perp': '\u22A5',
        'pertenk': '\u2031',
        'pfr': '\uD835\uDD2D',
        'Pfr': '\uD835\uDD13',
        'phi': '\u03C6',
        'Phi': '\u03A6',
        'phiv': '\u03D5',
        'phmmat': '\u2133',
        'phone': '\u260E',
        'pi': '\u03C0',
        'Pi': '\u03A0',
        'pitchfork': '\u22D4',
        'piv': '\u03D6',
        'planck': '\u210F',
        'planckh': '\u210E',
        'plankv': '\u210F',
        'plus': '+',
        'plusacir': '\u2A23',
        'plusb': '\u229E',
        'pluscir': '\u2A22',
        'plusdo': '\u2214',
        'plusdu': '\u2A25',
        'pluse': '\u2A72',
        'PlusMinus': '\xB1',
        'plusmn': '\xB1',
        'plussim': '\u2A26',
        'plustwo': '\u2A27',
        'pm': '\xB1',
        'Poincareplane': '\u210C',
        'pointint': '\u2A15',
        'popf': '\uD835\uDD61',
        'Popf': '\u2119',
        'pound': '\xA3',
        'pr': '\u227A',
        'Pr': '\u2ABB',
        'prap': '\u2AB7',
        'prcue': '\u227C',
        'pre': '\u2AAF',
        'prE': '\u2AB3',
        'prec': '\u227A',
        'precapprox': '\u2AB7',
        'preccurlyeq': '\u227C',
        'Precedes': '\u227A',
        'PrecedesEqual': '\u2AAF',
        'PrecedesSlantEqual': '\u227C',
        'PrecedesTilde': '\u227E',
        'preceq': '\u2AAF',
        'precnapprox': '\u2AB9',
        'precneqq': '\u2AB5',
        'precnsim': '\u22E8',
        'precsim': '\u227E',
        'prime': '\u2032',
        'Prime': '\u2033',
        'primes': '\u2119',
        'prnap': '\u2AB9',
        'prnE': '\u2AB5',
        'prnsim': '\u22E8',
        'prod': '\u220F',
        'Product': '\u220F',
        'profalar': '\u232E',
        'profline': '\u2312',
        'profsurf': '\u2313',
        'prop': '\u221D',
        'Proportion': '\u2237',
        'Proportional': '\u221D',
        'propto': '\u221D',
        'prsim': '\u227E',
        'prurel': '\u22B0',
        'pscr': '\uD835\uDCC5',
        'Pscr': '\uD835\uDCAB',
        'psi': '\u03C8',
        'Psi': '\u03A8',
        'puncsp': '\u2008',
        'qfr': '\uD835\uDD2E',
        'Qfr': '\uD835\uDD14',
        'qint': '\u2A0C',
        'qopf': '\uD835\uDD62',
        'Qopf': '\u211A',
        'qprime': '\u2057',
        'qscr': '\uD835\uDCC6',
        'Qscr': '\uD835\uDCAC',
        'quaternions': '\u210D',
        'quatint': '\u2A16',
        'quest': '?',
        'questeq': '\u225F',
        'quot': '"',
        'QUOT': '"',
        'rAarr': '\u21DB',
        'race': '\u223D\u0331',
        'racute': '\u0155',
        'Racute': '\u0154',
        'radic': '\u221A',
        'raemptyv': '\u29B3',
        'rang': '\u27E9',
        'Rang': '\u27EB',
        'rangd': '\u2992',
        'range': '\u29A5',
        'rangle': '\u27E9',
        'raquo': '\xBB',
        'rarr': '\u2192',
        'rArr': '\u21D2',
        'Rarr': '\u21A0',
        'rarrap': '\u2975',
        'rarrb': '\u21E5',
        'rarrbfs': '\u2920',
        'rarrc': '\u2933',
        'rarrfs': '\u291E',
        'rarrhk': '\u21AA',
        'rarrlp': '\u21AC',
        'rarrpl': '\u2945',
        'rarrsim': '\u2974',
        'rarrtl': '\u21A3',
        'Rarrtl': '\u2916',
        'rarrw': '\u219D',
        'ratail': '\u291A',
        'rAtail': '\u291C',
        'ratio': '\u2236',
        'rationals': '\u211A',
        'rbarr': '\u290D',
        'rBarr': '\u290F',
        'RBarr': '\u2910',
        'rbbrk': '\u2773',
        'rbrace': '}',
        'rbrack': ']',
        'rbrke': '\u298C',
        'rbrksld': '\u298E',
        'rbrkslu': '\u2990',
        'rcaron': '\u0159',
        'Rcaron': '\u0158',
        'rcedil': '\u0157',
        'Rcedil': '\u0156',
        'rceil': '\u2309',
        'rcub': '}',
        'rcy': '\u0440',
        'Rcy': '\u0420',
        'rdca': '\u2937',
        'rdldhar': '\u2969',
        'rdquo': '\u201D',
        'rdquor': '\u201D',
        'rdsh': '\u21B3',
        'Re': '\u211C',
        'real': '\u211C',
        'realine': '\u211B',
        'realpart': '\u211C',
        'reals': '\u211D',
        'rect': '\u25AD',
        'reg': '\xAE',
        'REG': '\xAE',
        'ReverseElement': '\u220B',
        'ReverseEquilibrium': '\u21CB',
        'ReverseUpEquilibrium': '\u296F',
        'rfisht': '\u297D',
        'rfloor': '\u230B',
        'rfr': '\uD835\uDD2F',
        'Rfr': '\u211C',
        'rHar': '\u2964',
        'rhard': '\u21C1',
        'rharu': '\u21C0',
        'rharul': '\u296C',
        'rho': '\u03C1',
        'Rho': '\u03A1',
        'rhov': '\u03F1',
        'RightAngleBracket': '\u27E9',
        'rightarrow': '\u2192',
        'Rightarrow': '\u21D2',
        'RightArrow': '\u2192',
        'RightArrowBar': '\u21E5',
        'RightArrowLeftArrow': '\u21C4',
        'rightarrowtail': '\u21A3',
        'RightCeiling': '\u2309',
        'RightDoubleBracket': '\u27E7',
        'RightDownTeeVector': '\u295D',
        'RightDownVector': '\u21C2',
        'RightDownVectorBar': '\u2955',
        'RightFloor': '\u230B',
        'rightharpoondown': '\u21C1',
        'rightharpoonup': '\u21C0',
        'rightleftarrows': '\u21C4',
        'rightleftharpoons': '\u21CC',
        'rightrightarrows': '\u21C9',
        'rightsquigarrow': '\u219D',
        'RightTee': '\u22A2',
        'RightTeeArrow': '\u21A6',
        'RightTeeVector': '\u295B',
        'rightthreetimes': '\u22CC',
        'RightTriangle': '\u22B3',
        'RightTriangleBar': '\u29D0',
        'RightTriangleEqual': '\u22B5',
        'RightUpDownVector': '\u294F',
        'RightUpTeeVector': '\u295C',
        'RightUpVector': '\u21BE',
        'RightUpVectorBar': '\u2954',
        'RightVector': '\u21C0',
        'RightVectorBar': '\u2953',
        'ring': '\u02DA',
        'risingdotseq': '\u2253',
        'rlarr': '\u21C4',
        'rlhar': '\u21CC',
        'rlm': '\u200F',
        'rmoust': '\u23B1',
        'rmoustache': '\u23B1',
        'rnmid': '\u2AEE',
        'roang': '\u27ED',
        'roarr': '\u21FE',
        'robrk': '\u27E7',
        'ropar': '\u2986',
        'ropf': '\uD835\uDD63',
        'Ropf': '\u211D',
        'roplus': '\u2A2E',
        'rotimes': '\u2A35',
        'RoundImplies': '\u2970',
        'rpar': ')',
        'rpargt': '\u2994',
        'rppolint': '\u2A12',
        'rrarr': '\u21C9',
        'Rrightarrow': '\u21DB',
        'rsaquo': '\u203A',
        'rscr': '\uD835\uDCC7',
        'Rscr': '\u211B',
        'rsh': '\u21B1',
        'Rsh': '\u21B1',
        'rsqb': ']',
        'rsquo': '\u2019',
        'rsquor': '\u2019',
        'rthree': '\u22CC',
        'rtimes': '\u22CA',
        'rtri': '\u25B9',
        'rtrie': '\u22B5',
        'rtrif': '\u25B8',
        'rtriltri': '\u29CE',
        'RuleDelayed': '\u29F4',
        'ruluhar': '\u2968',
        'rx': '\u211E',
        'sacute': '\u015B',
        'Sacute': '\u015A',
        'sbquo': '\u201A',
        'sc': '\u227B',
        'Sc': '\u2ABC',
        'scap': '\u2AB8',
        'scaron': '\u0161',
        'Scaron': '\u0160',
        'sccue': '\u227D',
        'sce': '\u2AB0',
        'scE': '\u2AB4',
        'scedil': '\u015F',
        'Scedil': '\u015E',
        'scirc': '\u015D',
        'Scirc': '\u015C',
        'scnap': '\u2ABA',
        'scnE': '\u2AB6',
        'scnsim': '\u22E9',
        'scpolint': '\u2A13',
        'scsim': '\u227F',
        'scy': '\u0441',
        'Scy': '\u0421',
        'sdot': '\u22C5',
        'sdotb': '\u22A1',
        'sdote': '\u2A66',
        'searhk': '\u2925',
        'searr': '\u2198',
        'seArr': '\u21D8',
        'searrow': '\u2198',
        'sect': '\xA7',
        'semi': ';',
        'seswar': '\u2929',
        'setminus': '\u2216',
        'setmn': '\u2216',
        'sext': '\u2736',
        'sfr': '\uD835\uDD30',
        'Sfr': '\uD835\uDD16',
        'sfrown': '\u2322',
        'sharp': '\u266F',
        'shchcy': '\u0449',
        'SHCHcy': '\u0429',
        'shcy': '\u0448',
        'SHcy': '\u0428',
        'ShortDownArrow': '\u2193',
        'ShortLeftArrow': '\u2190',
        'shortmid': '\u2223',
        'shortparallel': '\u2225',
        'ShortRightArrow': '\u2192',
        'ShortUpArrow': '\u2191',
        'shy': '\xAD',
        'sigma': '\u03C3',
        'Sigma': '\u03A3',
        'sigmaf': '\u03C2',
        'sigmav': '\u03C2',
        'sim': '\u223C',
        'simdot': '\u2A6A',
        'sime': '\u2243',
        'simeq': '\u2243',
        'simg': '\u2A9E',
        'simgE': '\u2AA0',
        'siml': '\u2A9D',
        'simlE': '\u2A9F',
        'simne': '\u2246',
        'simplus': '\u2A24',
        'simrarr': '\u2972',
        'slarr': '\u2190',
        'SmallCircle': '\u2218',
        'smallsetminus': '\u2216',
        'smashp': '\u2A33',
        'smeparsl': '\u29E4',
        'smid': '\u2223',
        'smile': '\u2323',
        'smt': '\u2AAA',
        'smte': '\u2AAC',
        'smtes': '\u2AAC\uFE00',
        'softcy': '\u044C',
        'SOFTcy': '\u042C',
        'sol': '/',
        'solb': '\u29C4',
        'solbar': '\u233F',
        'sopf': '\uD835\uDD64',
        'Sopf': '\uD835\uDD4A',
        'spades': '\u2660',
        'spadesuit': '\u2660',
        'spar': '\u2225',
        'sqcap': '\u2293',
        'sqcaps': '\u2293\uFE00',
        'sqcup': '\u2294',
        'sqcups': '\u2294\uFE00',
        'Sqrt': '\u221A',
        'sqsub': '\u228F',
        'sqsube': '\u2291',
        'sqsubset': '\u228F',
        'sqsubseteq': '\u2291',
        'sqsup': '\u2290',
        'sqsupe': '\u2292',
        'sqsupset': '\u2290',
        'sqsupseteq': '\u2292',
        'squ': '\u25A1',
        'square': '\u25A1',
        'Square': '\u25A1',
        'SquareIntersection': '\u2293',
        'SquareSubset': '\u228F',
        'SquareSubsetEqual': '\u2291',
        'SquareSuperset': '\u2290',
        'SquareSupersetEqual': '\u2292',
        'SquareUnion': '\u2294',
        'squarf': '\u25AA',
        'squf': '\u25AA',
        'srarr': '\u2192',
        'sscr': '\uD835\uDCC8',
        'Sscr': '\uD835\uDCAE',
        'ssetmn': '\u2216',
        'ssmile': '\u2323',
        'sstarf': '\u22C6',
        'star': '\u2606',
        'Star': '\u22C6',
        'starf': '\u2605',
        'straightepsilon': '\u03F5',
        'straightphi': '\u03D5',
        'strns': '\xAF',
        'sub': '\u2282',
        'Sub': '\u22D0',
        'subdot': '\u2ABD',
        'sube': '\u2286',
        'subE': '\u2AC5',
        'subedot': '\u2AC3',
        'submult': '\u2AC1',
        'subne': '\u228A',
        'subnE': '\u2ACB',
        'subplus': '\u2ABF',
        'subrarr': '\u2979',
        'subset': '\u2282',
        'Subset': '\u22D0',
        'subseteq': '\u2286',
        'subseteqq': '\u2AC5',
        'SubsetEqual': '\u2286',
        'subsetneq': '\u228A',
        'subsetneqq': '\u2ACB',
        'subsim': '\u2AC7',
        'subsub': '\u2AD5',
        'subsup': '\u2AD3',
        'succ': '\u227B',
        'succapprox': '\u2AB8',
        'succcurlyeq': '\u227D',
        'Succeeds': '\u227B',
        'SucceedsEqual': '\u2AB0',
        'SucceedsSlantEqual': '\u227D',
        'SucceedsTilde': '\u227F',
        'succeq': '\u2AB0',
        'succnapprox': '\u2ABA',
        'succneqq': '\u2AB6',
        'succnsim': '\u22E9',
        'succsim': '\u227F',
        'SuchThat': '\u220B',
        'sum': '\u2211',
        'Sum': '\u2211',
        'sung': '\u266A',
        'sup': '\u2283',
        'Sup': '\u22D1',
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'supdot': '\u2ABE',
        'supdsub': '\u2AD8',
        'supe': '\u2287',
        'supE': '\u2AC6',
        'supedot': '\u2AC4',
        'Superset': '\u2283',
        'SupersetEqual': '\u2287',
        'suphsol': '\u27C9',
        'suphsub': '\u2AD7',
        'suplarr': '\u297B',
        'supmult': '\u2AC2',
        'supne': '\u228B',
        'supnE': '\u2ACC',
        'supplus': '\u2AC0',
        'supset': '\u2283',
        'Supset': '\u22D1',
        'supseteq': '\u2287',
        'supseteqq': '\u2AC6',
        'supsetneq': '\u228B',
        'supsetneqq': '\u2ACC',
        'supsim': '\u2AC8',
        'supsub': '\u2AD4',
        'supsup': '\u2AD6',
        'swarhk': '\u2926',
        'swarr': '\u2199',
        'swArr': '\u21D9',
        'swarrow': '\u2199',
        'swnwar': '\u292A',
        'szlig': '\xDF',
        'Tab': '\t',
        'target': '\u2316',
        'tau': '\u03C4',
        'Tau': '\u03A4',
        'tbrk': '\u23B4',
        'tcaron': '\u0165',
        'Tcaron': '\u0164',
        'tcedil': '\u0163',
        'Tcedil': '\u0162',
        'tcy': '\u0442',
        'Tcy': '\u0422',
        'tdot': '\u20DB',
        'telrec': '\u2315',
        'tfr': '\uD835\uDD31',
        'Tfr': '\uD835\uDD17',
        'there4': '\u2234',
        'therefore': '\u2234',
        'Therefore': '\u2234',
        'theta': '\u03B8',
        'Theta': '\u0398',
        'thetasym': '\u03D1',
        'thetav': '\u03D1',
        'thickapprox': '\u2248',
        'thicksim': '\u223C',
        'ThickSpace': '\u205F\u200A',
        'thinsp': '\u2009',
        'ThinSpace': '\u2009',
        'thkap': '\u2248',
        'thksim': '\u223C',
        'thorn': '\xFE',
        'THORN': '\xDE',
        'tilde': '\u02DC',
        'Tilde': '\u223C',
        'TildeEqual': '\u2243',
        'TildeFullEqual': '\u2245',
        'TildeTilde': '\u2248',
        'times': '\xD7',
        'timesb': '\u22A0',
        'timesbar': '\u2A31',
        'timesd': '\u2A30',
        'tint': '\u222D',
        'toea': '\u2928',
        'top': '\u22A4',
        'topbot': '\u2336',
        'topcir': '\u2AF1',
        'topf': '\uD835\uDD65',
        'Topf': '\uD835\uDD4B',
        'topfork': '\u2ADA',
        'tosa': '\u2929',
        'tprime': '\u2034',
        'trade': '\u2122',
        'TRADE': '\u2122',
        'triangle': '\u25B5',
        'triangledown': '\u25BF',
        'triangleleft': '\u25C3',
        'trianglelefteq': '\u22B4',
        'triangleq': '\u225C',
        'triangleright': '\u25B9',
        'trianglerighteq': '\u22B5',
        'tridot': '\u25EC',
        'trie': '\u225C',
        'triminus': '\u2A3A',
        'TripleDot': '\u20DB',
        'triplus': '\u2A39',
        'trisb': '\u29CD',
        'tritime': '\u2A3B',
        'trpezium': '\u23E2',
        'tscr': '\uD835\uDCC9',
        'Tscr': '\uD835\uDCAF',
        'tscy': '\u0446',
        'TScy': '\u0426',
        'tshcy': '\u045B',
        'TSHcy': '\u040B',
        'tstrok': '\u0167',
        'Tstrok': '\u0166',
        'twixt': '\u226C',
        'twoheadleftarrow': '\u219E',
        'twoheadrightarrow': '\u21A0',
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'uarr': '\u2191',
        'uArr': '\u21D1',
        'Uarr': '\u219F',
        'Uarrocir': '\u2949',
        'ubrcy': '\u045E',
        'Ubrcy': '\u040E',
        'ubreve': '\u016D',
        'Ubreve': '\u016C',
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ucy': '\u0443',
        'Ucy': '\u0423',
        'udarr': '\u21C5',
        'udblac': '\u0171',
        'Udblac': '\u0170',
        'udhar': '\u296E',
        'ufisht': '\u297E',
        'ufr': '\uD835\uDD32',
        'Ufr': '\uD835\uDD18',
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uHar': '\u2963',
        'uharl': '\u21BF',
        'uharr': '\u21BE',
        'uhblk': '\u2580',
        'ulcorn': '\u231C',
        'ulcorner': '\u231C',
        'ulcrop': '\u230F',
        'ultri': '\u25F8',
        'umacr': '\u016B',
        'Umacr': '\u016A',
        'uml': '\xA8',
        'UnderBar': '_',
        'UnderBrace': '\u23DF',
        'UnderBracket': '\u23B5',
        'UnderParenthesis': '\u23DD',
        'Union': '\u22C3',
        'UnionPlus': '\u228E',
        'uogon': '\u0173',
        'Uogon': '\u0172',
        'uopf': '\uD835\uDD66',
        'Uopf': '\uD835\uDD4C',
        'uparrow': '\u2191',
        'Uparrow': '\u21D1',
        'UpArrow': '\u2191',
        'UpArrowBar': '\u2912',
        'UpArrowDownArrow': '\u21C5',
        'updownarrow': '\u2195',
        'Updownarrow': '\u21D5',
        'UpDownArrow': '\u2195',
        'UpEquilibrium': '\u296E',
        'upharpoonleft': '\u21BF',
        'upharpoonright': '\u21BE',
        'uplus': '\u228E',
        'UpperLeftArrow': '\u2196',
        'UpperRightArrow': '\u2197',
        'upsi': '\u03C5',
        'Upsi': '\u03D2',
        'upsih': '\u03D2',
        'upsilon': '\u03C5',
        'Upsilon': '\u03A5',
        'UpTee': '\u22A5',
        'UpTeeArrow': '\u21A5',
        'upuparrows': '\u21C8',
        'urcorn': '\u231D',
        'urcorner': '\u231D',
        'urcrop': '\u230E',
        'uring': '\u016F',
        'Uring': '\u016E',
        'urtri': '\u25F9',
        'uscr': '\uD835\uDCCA',
        'Uscr': '\uD835\uDCB0',
        'utdot': '\u22F0',
        'utilde': '\u0169',
        'Utilde': '\u0168',
        'utri': '\u25B5',
        'utrif': '\u25B4',
        'uuarr': '\u21C8',
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'uwangle': '\u29A7',
        'vangrt': '\u299C',
        'varepsilon': '\u03F5',
        'varkappa': '\u03F0',
        'varnothing': '\u2205',
        'varphi': '\u03D5',
        'varpi': '\u03D6',
        'varpropto': '\u221D',
        'varr': '\u2195',
        'vArr': '\u21D5',
        'varrho': '\u03F1',
        'varsigma': '\u03C2',
        'varsubsetneq': '\u228A\uFE00',
        'varsubsetneqq': '\u2ACB\uFE00',
        'varsupsetneq': '\u228B\uFE00',
        'varsupsetneqq': '\u2ACC\uFE00',
        'vartheta': '\u03D1',
        'vartriangleleft': '\u22B2',
        'vartriangleright': '\u22B3',
        'vBar': '\u2AE8',
        'Vbar': '\u2AEB',
        'vBarv': '\u2AE9',
        'vcy': '\u0432',
        'Vcy': '\u0412',
        'vdash': '\u22A2',
        'vDash': '\u22A8',
        'Vdash': '\u22A9',
        'VDash': '\u22AB',
        'Vdashl': '\u2AE6',
        'vee': '\u2228',
        'Vee': '\u22C1',
        'veebar': '\u22BB',
        'veeeq': '\u225A',
        'vellip': '\u22EE',
        'verbar': '|',
        'Verbar': '\u2016',
        'vert': '|',
        'Vert': '\u2016',
        'VerticalBar': '\u2223',
        'VerticalLine': '|',
        'VerticalSeparator': '\u2758',
        'VerticalTilde': '\u2240',
        'VeryThinSpace': '\u200A',
        'vfr': '\uD835\uDD33',
        'Vfr': '\uD835\uDD19',
        'vltri': '\u22B2',
        'vnsub': '\u2282\u20D2',
        'vnsup': '\u2283\u20D2',
        'vopf': '\uD835\uDD67',
        'Vopf': '\uD835\uDD4D',
        'vprop': '\u221D',
        'vrtri': '\u22B3',
        'vscr': '\uD835\uDCCB',
        'Vscr': '\uD835\uDCB1',
        'vsubne': '\u228A\uFE00',
        'vsubnE': '\u2ACB\uFE00',
        'vsupne': '\u228B\uFE00',
        'vsupnE': '\u2ACC\uFE00',
        'Vvdash': '\u22AA',
        'vzigzag': '\u299A',
        'wcirc': '\u0175',
        'Wcirc': '\u0174',
        'wedbar': '\u2A5F',
        'wedge': '\u2227',
        'Wedge': '\u22C0',
        'wedgeq': '\u2259',
        'weierp': '\u2118',
        'wfr': '\uD835\uDD34',
        'Wfr': '\uD835\uDD1A',
        'wopf': '\uD835\uDD68',
        'Wopf': '\uD835\uDD4E',
        'wp': '\u2118',
        'wr': '\u2240',
        'wreath': '\u2240',
        'wscr': '\uD835\uDCCC',
        'Wscr': '\uD835\uDCB2',
        'xcap': '\u22C2',
        'xcirc': '\u25EF',
        'xcup': '\u22C3',
        'xdtri': '\u25BD',
        'xfr': '\uD835\uDD35',
        'Xfr': '\uD835\uDD1B',
        'xharr': '\u27F7',
        'xhArr': '\u27FA',
        'xi': '\u03BE',
        'Xi': '\u039E',
        'xlarr': '\u27F5',
        'xlArr': '\u27F8',
        'xmap': '\u27FC',
        'xnis': '\u22FB',
        'xodot': '\u2A00',
        'xopf': '\uD835\uDD69',
        'Xopf': '\uD835\uDD4F',
        'xoplus': '\u2A01',
        'xotime': '\u2A02',
        'xrarr': '\u27F6',
        'xrArr': '\u27F9',
        'xscr': '\uD835\uDCCD',
        'Xscr': '\uD835\uDCB3',
        'xsqcup': '\u2A06',
        'xuplus': '\u2A04',
        'xutri': '\u25B3',
        'xvee': '\u22C1',
        'xwedge': '\u22C0',
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yacy': '\u044F',
        'YAcy': '\u042F',
        'ycirc': '\u0177',
        'Ycirc': '\u0176',
        'ycy': '\u044B',
        'Ycy': '\u042B',
        'yen': '\xA5',
        'yfr': '\uD835\uDD36',
        'Yfr': '\uD835\uDD1C',
        'yicy': '\u0457',
        'YIcy': '\u0407',
        'yopf': '\uD835\uDD6A',
        'Yopf': '\uD835\uDD50',
        'yscr': '\uD835\uDCCE',
        'Yscr': '\uD835\uDCB4',
        'yucy': '\u044E',
        'YUcy': '\u042E',
        'yuml': '\xFF',
        'Yuml': '\u0178',
        'zacute': '\u017A',
        'Zacute': '\u0179',
        'zcaron': '\u017E',
        'Zcaron': '\u017D',
        'zcy': '\u0437',
        'Zcy': '\u0417',
        'zdot': '\u017C',
        'Zdot': '\u017B',
        'zeetrf': '\u2128',
        'ZeroWidthSpace': '\u200B',
        'zeta': '\u03B6',
        'Zeta': '\u0396',
        'zfr': '\uD835\uDD37',
        'Zfr': '\u2128',
        'zhcy': '\u0436',
        'ZHcy': '\u0416',
        'zigrarr': '\u21DD',
        'zopf': '\uD835\uDD6B',
        'Zopf': '\u2124',
        'zscr': '\uD835\uDCCF',
        'Zscr': '\uD835\uDCB5',
        'zwj': '\u200D',
        'zwnj': '\u200C'
    };
    var decodeMapLegacy = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'aelig': '\xE6',
        'AElig': '\xC6',
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'amp': '&',
        'AMP': '&',
        'aring': '\xE5',
        'Aring': '\xC5',
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'brvbar': '\xA6',
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'cedil': '\xB8',
        'cent': '\xA2',
        'copy': '\xA9',
        'COPY': '\xA9',
        'curren': '\xA4',
        'deg': '\xB0',
        'divide': '\xF7',
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'frac12': '\xBD',
        'frac14': '\xBC',
        'frac34': '\xBE',
        'gt': '>',
        'GT': '>',
        'iacute': '\xED',
        'Iacute': '\xCD',
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'iexcl': '\xA1',
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'iquest': '\xBF',
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'laquo': '\xAB',
        'lt': '<',
        'LT': '<',
        'macr': '\xAF',
        'micro': '\xB5',
        'middot': '\xB7',
        'nbsp': '\xA0',
        'not': '\xAC',
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ordf': '\xAA',
        'ordm': '\xBA',
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'para': '\xB6',
        'plusmn': '\xB1',
        'pound': '\xA3',
        'quot': '"',
        'QUOT': '"',
        'raquo': '\xBB',
        'reg': '\xAE',
        'REG': '\xAE',
        'sect': '\xA7',
        'shy': '\xAD',
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'szlig': '\xDF',
        'thorn': '\xFE',
        'THORN': '\xDE',
        'times': '\xD7',
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uml': '\xA8',
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yen': '\xA5',
        'yuml': '\xFF'
    };
    var decodeMapNumeric = {
        '0': '\uFFFD',
        '128': '\u20AC',
        '130': '\u201A',
        '131': '\u0192',
        '132': '\u201E',
        '133': '\u2026',
        '134': '\u2020',
        '135': '\u2021',
        '136': '\u02C6',
        '137': '\u2030',
        '138': '\u0160',
        '139': '\u2039',
        '140': '\u0152',
        '142': '\u017D',
        '145': '\u2018',
        '146': '\u2019',
        '147': '\u201C',
        '148': '\u201D',
        '149': '\u2022',
        '150': '\u2013',
        '151': '\u2014',
        '152': '\u02DC',
        '153': '\u2122',
        '154': '\u0161',
        '155': '\u203A',
        '156': '\u0153',
        '158': '\u017E',
        '159': '\u0178'
    };
    var invalidReferenceCodePoints = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        11,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        64976,
        64977,
        64978,
        64979,
        64980,
        64981,
        64982,
        64983,
        64984,
        64985,
        64986,
        64987,
        64988,
        64989,
        64990,
        64991,
        64992,
        64993,
        64994,
        64995,
        64996,
        64997,
        64998,
        64999,
        65000,
        65001,
        65002,
        65003,
        65004,
        65005,
        65006,
        65007,
        65534,
        65535,
        131070,
        131071,
        196606,
        196607,
        262142,
        262143,
        327678,
        327679,
        393214,
        393215,
        458750,
        458751,
        524286,
        524287,
        589822,
        589823,
        655358,
        655359,
        720894,
        720895,
        786430,
        786431,
        851966,
        851967,
        917502,
        917503,
        983038,
        983039,
        1048574,
        1048575,
        1114110,
        1114111
    ];
    /*--------------------------------------------------------------------------*/ var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
    };
    var contains = function(array, value) {
        var index = -1;
        var length = array.length;
        while(++index < length){
            if (array[index] == value) return true;
        }
        return false;
    };
    var merge = function(options, defaults) {
        if (!options) return defaults;
        var result = {};
        var key;
        for(key in defaults)// A `hasOwnProperty` check is not needed here, since only recognized
        // option names are used anyway. Any others are ignored.
        result[key] = has(options, key) ? options[key] : defaults[key];
        return result;
    };
    // Modified version of `ucs2encode`; see https://mths.be/punycode.
    var codePointToSymbol = function(codePoint, strict) {
        var output = '';
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) parseError('character reference outside the permissible Unicode range');
            return '\uFFFD';
        }
        if (has(decodeMapNumeric, codePoint)) {
            if (strict) parseError('disallowed character reference');
            return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError('disallowed character reference');
        if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
    };
    var hexEscape = function(codePoint) {
        return '&#x' + codePoint.toString(16).toUpperCase() + ';';
    };
    var decEscape = function(codePoint) {
        return '&#' + codePoint + ';';
    };
    var parseError = function(message) {
        throw Error('Parse error: ' + message);
    };
    /*--------------------------------------------------------------------------*/ var encode = function(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) parseError('forbidden code point');
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function(symbol) {
                // Use named references if requested & possible.
                if (useNamedReferences && has(encodeMap, symbol)) return '&' + encodeMap[symbol] + ';';
                return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;').replace(/&#x66;&#x6A;/g, '&fjlig;');
            // Encode non-ASCII symbols.
            if (useNamedReferences) // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return '&' + encodeMap[string] + ';';
            });
        // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) string = string.replace(regexEscape, function(string) {
                return '&' + encodeMap[string] + ';'; // no need to check `has()` here
            });
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;');
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return '&' + encodeMap[string] + ';';
            });
        } else if (!allowUnsafeSymbols) // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
        // using named character references.
        string = string.replace(regexEscape, escapeBmpSymbol);
        return string// Encode astral symbols.
        .replace(regexAstralSymbols, function($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
        })// Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    // Expose default options (so they can be overridden globally).
    encode.options = {
        'allowUnsafeSymbols': false,
        'encodeEverything': false,
        'strict': false,
        'useNamedReferences': false,
        'decimal': false
    };
    var decode = function(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) parseError('malformed character reference');
        return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
                reference = $1;
                // Note: there is no need to check `has(decodeMap, reference)`.
                return decodeMap[reference];
            }
            if ($2) {
                // Decode named character references without trailing `;`, e.g. `&amp`.
                // This is only a parse error if it gets converted to `&`, or if it is
                // followed by `=` in an attribute context.
                reference = $2;
                next = $3;
                if (next && options.isAttributeValue) {
                    if (strict && next == '=') parseError('`&` did not start a character reference');
                    return $0;
                } else {
                    if (strict) parseError('named character reference was not terminated by a semicolon');
                    // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                    return decodeMapLegacy[reference] + (next || '');
                }
            }
            if ($4) {
                // Decode decimal escapes, e.g. `&#119558;`.
                decDigits = $4;
                semicolon = $5;
                if (strict && !semicolon) parseError('character reference was not terminated by a semicolon');
                codePoint = parseInt(decDigits, 10);
                return codePointToSymbol(codePoint, strict);
            }
            if ($6) {
                // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                hexDigits = $6;
                semicolon = $7;
                if (strict && !semicolon) parseError('character reference was not terminated by a semicolon');
                codePoint = parseInt(hexDigits, 16);
                return codePointToSymbol(codePoint, strict);
            }
            // If we’re still here, `if ($7)` is implied; it’s an ambiguous
            // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
            if (strict) parseError('named character reference was not terminated by a semicolon');
            return $0;
        });
    };
    // Expose default options (so they can be overridden globally).
    decode.options = {
        'isAttributeValue': false,
        'strict': false
    };
    var escape = function(string) {
        return string.replace(regexEscape, function($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
        });
    };
    /*--------------------------------------------------------------------------*/ var he = {
        'version': '1.2.0',
        'encode': encode,
        'decode': decode,
        'escape': escape,
        'unescape': decode
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define(function() {
        return he;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = he;
        else for(var key in he)has(he, key) && (freeExports[key] = he[key]);
    } else root.he = he;
})(this);

});

parcelRegister("luckw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fa45f6c690cbe79c$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
})($fa45f6c690cbe79c$var$NodeType || ($fa45f6c690cbe79c$var$NodeType = {}));
module.exports.default = $fa45f6c690cbe79c$var$NodeType;

});

parcelRegister("hRZMB", function(module, exports) {
"use strict";
var $d0274fb26902e6e1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = module.exports.base_parse = void 0;

var $4pbUi = parcelRequire("4pbUi");


const $d0274fb26902e6e1$var$he_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("jopS9")));

const $d0274fb26902e6e1$var$back_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("22Uby")));

const $d0274fb26902e6e1$var$matcher_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("f2HSH")));

const $d0274fb26902e6e1$var$void_tag_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("4bNOP")));

const $d0274fb26902e6e1$var$comment_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("asvGx")));

const $d0274fb26902e6e1$var$node_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("1vK45")));

const $d0274fb26902e6e1$var$text_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("a5onE")));

const $d0274fb26902e6e1$var$type_1 = $d0274fb26902e6e1$var$__importDefault((parcelRequire("luckw")));
function $d0274fb26902e6e1$var$decode(val) {
    // clone string
    return JSON.parse(JSON.stringify($d0274fb26902e6e1$var$he_1.default.decode(val)));
}
// https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
const $d0274fb26902e6e1$var$Htags = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup'
];
const $d0274fb26902e6e1$var$Dtags = [
    'details',
    'dialog',
    'dd',
    'div',
    'dt'
];
const $d0274fb26902e6e1$var$Ftags = [
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form'
];
const $d0274fb26902e6e1$var$tableTags = [
    'table',
    'td',
    'tr'
];
const $d0274fb26902e6e1$var$htmlTags = [
    'address',
    'article',
    'aside',
    'blockquote',
    'br',
    'hr',
    'li',
    'main',
    'nav',
    'ol',
    'p',
    'pre',
    'section',
    'ul'
];
const $d0274fb26902e6e1$var$kBlockElements = new Set();
function $d0274fb26902e6e1$var$addToKBlockElement(...args) {
    const addToSet = (array)=>{
        for(let index = 0; index < array.length; index++){
            const element = array[index];
            $d0274fb26902e6e1$var$kBlockElements.add(element);
            $d0274fb26902e6e1$var$kBlockElements.add(element.toUpperCase());
        }
    };
    for (const arg of args)addToSet(arg);
}
$d0274fb26902e6e1$var$addToKBlockElement($d0274fb26902e6e1$var$Htags, $d0274fb26902e6e1$var$Dtags, $d0274fb26902e6e1$var$Ftags, $d0274fb26902e6e1$var$tableTags, $d0274fb26902e6e1$var$htmlTags);
class $d0274fb26902e6e1$var$DOMTokenList {
    _validate(c) {
        if (/\s/.test(c)) throw new Error(`DOMException in DOMTokenList.add: The token '${c}' contains HTML space characters, which are not valid in tokens.`);
    }
    add(c) {
        this._validate(c);
        this._set.add(c);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    }
    replace(c1, c2) {
        this._validate(c2);
        this._set.delete(c1);
        this._set.add(c2);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    }
    remove(c) {
        this._set.delete(c) && this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    }
    toggle(c) {
        this._validate(c);
        if (this._set.has(c)) this._set.delete(c);
        else this._set.add(c);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    }
    contains(c) {
        return this._set.has(c);
    }
    get length() {
        return this._set.size;
    }
    values() {
        return this._set.values();
    }
    get value() {
        return Array.from(this._set.values());
    }
    toString() {
        return Array.from(this._set.values()).join(' ');
    }
    constructor(valuesInit = [], afterUpdate = ()=>null){
        this._set = new Set(valuesInit);
        this._afterUpdate = afterUpdate;
    }
}
/**
 * HTMLElement, which contains a set of children.
 *
 * Note: this is a minimalist implementation, no complete tree
 *   structure provided (no parentNode, nextSibling,
 *   previousSibling etc).
 * @class HTMLElement
 * @extends {Node}
 */ class $d0274fb26902e6e1$var$HTMLElement extends $d0274fb26902e6e1$var$node_1.default {
    /**
     * Quote attribute values
     * @param attr attribute value
     * @returns {string} quoted value
     */ quoteAttribute(attr) {
        if (attr == null) return 'null';
        return JSON.stringify(attr.replace(/"/g, '&quot;')).replace(/\\t/g, '\t').replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\/g, '');
    }
    /**
     * Remove Child element from childNodes array
     * @param {HTMLElement} node     node to remove
     */ removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>{
            return child !== node;
        });
        return this;
    }
    /**
     * Exchanges given child with new child
     * @param {HTMLElement} oldNode     node to exchange
     * @param {HTMLElement} newNode     new node
     */ exchangeChild(oldNode, newNode) {
        const children = this.childNodes;
        this.childNodes = children.map((child)=>{
            if (child === oldNode) return newNode;
            return child;
        });
        return this;
    }
    get tagName() {
        return this.rawTagName ? this.rawTagName.toUpperCase() : this.rawTagName;
    }
    set tagName(newname) {
        this.rawTagName = newname.toLowerCase();
    }
    get localName() {
        return this.rawTagName.toLowerCase();
    }
    get isVoidElement() {
        return this.voidTag.isVoidElement(this.localName);
    }
    /**
     * Get escpaed (as-it) text value of current node and its children.
     * @return {string} text content
     */ get rawText() {
        // https://github.com/taoqf/node-html-parser/issues/249
        if (/^br$/i.test(this.rawTagName)) return '\n';
        return this.childNodes.reduce((pre, cur)=>{
            return pre += cur.rawText;
        }, '');
    }
    get textContent() {
        return $d0274fb26902e6e1$var$decode(this.rawText);
    }
    set textContent(val) {
        const content = [
            new $d0274fb26902e6e1$var$text_1.default(val, this)
        ];
        this.childNodes = content;
    }
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */ get text() {
        return $d0274fb26902e6e1$var$decode(this.rawText);
    }
    /**
     * Get structured Text (with '\n' etc.)
     * @return {string} structured text
     */ get structuredText() {
        let currentBlock = [];
        const blocks = [
            currentBlock
        ];
        function dfs(node) {
            if (node.nodeType === $d0274fb26902e6e1$var$type_1.default.ELEMENT_NODE) {
                if ($d0274fb26902e6e1$var$kBlockElements.has(node.rawTagName)) {
                    if (currentBlock.length > 0) blocks.push(currentBlock = []);
                    node.childNodes.forEach(dfs);
                    if (currentBlock.length > 0) blocks.push(currentBlock = []);
                } else node.childNodes.forEach(dfs);
            } else if (node.nodeType === $d0274fb26902e6e1$var$type_1.default.TEXT_NODE) {
                if (node.isWhitespace) // Whitespace node, postponed output
                currentBlock.prependWhitespace = true;
                else {
                    let text = node.trimmedText;
                    if (currentBlock.prependWhitespace) {
                        text = ` ${text}`;
                        currentBlock.prependWhitespace = false;
                    }
                    currentBlock.push(text);
                }
            }
        }
        dfs(this);
        return blocks.map((block)=>{
            return block.join('').replace(/\s{2,}/g, ' '); // Normalize each line's whitespace
        }).join('\n').replace(/\s+$/, ''); // trimRight;
    }
    toString() {
        const tag = this.rawTagName;
        if (tag) {
            const attrs = this.rawAttrs ? ` ${this.rawAttrs}` : '';
            return this.voidTag.formatNode(tag, attrs, this.innerHTML);
        }
        return this.innerHTML;
    }
    get innerHTML() {
        return this.childNodes.map((child)=>{
            return child.toString();
        }).join('');
    }
    set innerHTML(content) {
        const r = $d0274fb26902e6e1$var$parse(content, this._parseOptions);
        const nodes = r.childNodes.length ? r.childNodes : [
            new $d0274fb26902e6e1$var$text_1.default(content, this)
        ];
        $d0274fb26902e6e1$var$resetParent(nodes, this);
        $d0274fb26902e6e1$var$resetParent(this.childNodes, null);
        this.childNodes = nodes;
    }
    set_content(content, options = {}) {
        if (content instanceof $d0274fb26902e6e1$var$node_1.default) content = [
            content
        ];
        else if (typeof content == 'string') {
            options = Object.assign(Object.assign({}, this._parseOptions), options);
            const r = $d0274fb26902e6e1$var$parse(content, options);
            content = r.childNodes.length ? r.childNodes : [
                new $d0274fb26902e6e1$var$text_1.default(r.innerHTML, this)
            ];
        }
        $d0274fb26902e6e1$var$resetParent(this.childNodes, null);
        $d0274fb26902e6e1$var$resetParent(content, this);
        this.childNodes = content;
        return this;
    }
    replaceWith(...nodes) {
        const parent = this.parentNode;
        const content = nodes.map((node)=>{
            if (node instanceof $d0274fb26902e6e1$var$node_1.default) return [
                node
            ];
            else if (typeof node == 'string') {
                const r = $d0274fb26902e6e1$var$parse(node, this._parseOptions);
                return r.childNodes.length ? r.childNodes : [
                    new $d0274fb26902e6e1$var$text_1.default(node, this)
                ];
            }
            return [];
        }).flat();
        const idx = parent.childNodes.findIndex((child)=>{
            return child === this;
        });
        $d0274fb26902e6e1$var$resetParent([
            this
        ], null);
        parent.childNodes = [
            ...parent.childNodes.slice(0, idx),
            ...$d0274fb26902e6e1$var$resetParent(content, parent),
            ...parent.childNodes.slice(idx + 1)
        ];
        return this;
    }
    get outerHTML() {
        return this.toString();
    }
    /**
     * Trim element from right (in block) after seeing pattern in a TextNode.
     * @param  {RegExp} pattern pattern to find
     * @return {HTMLElement}    reference to current node
     */ trimRight(pattern) {
        for(let i = 0; i < this.childNodes.length; i++){
            const childNode = this.childNodes[i];
            if (childNode.nodeType === $d0274fb26902e6e1$var$type_1.default.ELEMENT_NODE) childNode.trimRight(pattern);
            else {
                const index = childNode.rawText.search(pattern);
                if (index > -1) {
                    childNode.rawText = childNode.rawText.substr(0, index);
                    // trim all following nodes.
                    this.childNodes.length = i + 1;
                }
            }
        }
        return this;
    }
    /**
     * Get DOM structure
     * @return {string} structure
     */ get structure() {
        const res = [];
        let indention = 0;
        function write(str) {
            res.push('  '.repeat(indention) + str);
        }
        function dfs(node) {
            const idStr = node.id ? `#${node.id}` : '';
            const classStr = node.classList.length ? `.${node.classList.value.join('.')}` : ''; // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-call
            write(`${node.rawTagName}${idStr}${classStr}`);
            indention++;
            node.childNodes.forEach((childNode)=>{
                if (childNode.nodeType === $d0274fb26902e6e1$var$type_1.default.ELEMENT_NODE) dfs(childNode);
                else if (childNode.nodeType === $d0274fb26902e6e1$var$type_1.default.TEXT_NODE) {
                    if (!childNode.isWhitespace) write('#text');
                }
            });
            indention--;
        }
        dfs(this);
        return res.join('\n');
    }
    /**
     * Remove whitespaces in this sub tree.
     * @return {HTMLElement} pointer to this
     */ removeWhitespace() {
        let o = 0;
        this.childNodes.forEach((node)=>{
            if (node.nodeType === $d0274fb26902e6e1$var$type_1.default.TEXT_NODE) {
                if (node.isWhitespace) return;
                node.rawText = node.trimmedRawText;
            } else if (node.nodeType === $d0274fb26902e6e1$var$type_1.default.ELEMENT_NODE) node.removeWhitespace();
            this.childNodes[o++] = node;
        });
        this.childNodes.length = o;
        // remove whitespace between attributes
        const attrs = Object.keys(this.rawAttributes).map((key)=>{
            const val = this.rawAttributes[key];
            return `${key}=${JSON.stringify(val)}`;
        }).join(' ');
        this.rawAttrs = attrs;
        delete this._rawAttrs;
        return this;
    }
    /**
     * Query CSS selector to find matching nodes.
     * @param  {string}         selector Simplified CSS selector
     * @return {HTMLElement[]}  matching elements
     */ querySelectorAll(selector) {
        return (0, $4pbUi.selectAll)(selector, this, {
            xmlMode: true,
            adapter: $d0274fb26902e6e1$var$matcher_1.default
        });
    }
    /**
     * Query CSS Selector to find matching node.
     * @param  {string}         selector Simplified CSS selector
     * @return {(HTMLElement|null)}    matching node
     */ querySelector(selector) {
        return (0, $4pbUi.selectOne)(selector, this, {
            xmlMode: true,
            adapter: $d0274fb26902e6e1$var$matcher_1.default
        });
    }
    /**
     * find elements by their tagName
     * @param {string} tagName the tagName of the elements to select
     */ getElementsByTagName(tagName) {
        const upperCasedTagName = tagName.toUpperCase();
        const re = [];
        const stack = [];
        let currentNodeReference = this;
        let index = 0;
        // index turns to undefined once the stack is empty and the first condition occurs
        // which happens once all relevant children are searched through
        while(index !== undefined){
            let child;
            // make it work with sparse arrays
            do child = currentNodeReference.childNodes[index++];
            while (index < currentNodeReference.childNodes.length && child === undefined);
            // if the child does not exist we move on with the last provided index (which belongs to the parentNode)
            if (child === undefined) {
                currentNodeReference = currentNodeReference.parentNode;
                index = stack.pop();
                continue;
            }
            if (child.nodeType === $d0274fb26902e6e1$var$type_1.default.ELEMENT_NODE) {
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/getElementsByTagName#syntax
                if (tagName === '*' || child.tagName === upperCasedTagName) re.push(child);
                // if children are existing push the current status to the stack and keep searching for elements in the level below
                if (child.childNodes.length > 0) {
                    stack.push(index);
                    currentNodeReference = child;
                    index = 0;
                }
            }
        }
        return re;
    }
    /**
     * find element by it's id
     * @param {string} id the id of the element to select
     * @returns {HTMLElement | null} the element with the given id or null if not found
     */ getElementById(id) {
        const stack = [];
        let currentNodeReference = this;
        let index = 0;
        // index turns to undefined once the stack is empty and the first condition occurs
        // which happens once all relevant children are searched through
        while(index !== undefined){
            let child;
            // make it work with sparse arrays
            do child = currentNodeReference.childNodes[index++];
            while (index < currentNodeReference.childNodes.length && child === undefined);
            // if the child does not exist we move on with the last provided index (which belongs to the parentNode)
            if (child === undefined) {
                currentNodeReference = currentNodeReference.parentNode;
                index = stack.pop();
                continue;
            }
            if (child.nodeType === $d0274fb26902e6e1$var$type_1.default.ELEMENT_NODE) {
                if (child.id === id) return child;
                // if children are existing push the current status to the stack and keep searching for elements in the level below
                if (child.childNodes.length > 0) {
                    stack.push(index);
                    currentNodeReference = child;
                    index = 0;
                }
            }
        }
        return null;
    }
    /**
     * traverses the Element and its parents (heading toward the document root) until it finds a node that matches the provided selector string. Will return itself or the matching ancestor. If no such element exists, it returns null.
     * @param selector a DOMString containing a selector list
     * @returns {HTMLElement | null} the element with the given id or null if not found
     */ closest(selector) {
        const mapChild = new Map();
        let el = this;
        let old = null;
        function findOne(test, elems) {
            let elem = null;
            for(let i = 0, l = elems.length; i < l && !elem; i++){
                const el = elems[i];
                if (test(el)) elem = el;
                else {
                    const child = mapChild.get(el);
                    if (child) elem = findOne(test, [
                        child
                    ]);
                }
            }
            return elem;
        }
        while(el){
            mapChild.set(el, old);
            old = el;
            el = el.parentNode;
        }
        el = this;
        while(el){
            const e = (0, $4pbUi.selectOne)(selector, el, {
                xmlMode: true,
                adapter: Object.assign(Object.assign({}, $d0274fb26902e6e1$var$matcher_1.default), {
                    getChildren (node) {
                        const child = mapChild.get(node);
                        return child && [
                            child
                        ];
                    },
                    getSiblings (node) {
                        return [
                            node
                        ];
                    },
                    findOne: findOne,
                    findAll () {
                        return [];
                    }
                })
            });
            if (e) return e;
            el = el.parentNode;
        }
        return null;
    }
    /**
     * Append a child node to childNodes
     * @param  {Node} node node to append
     * @return {Node}      node appended
     */ appendChild(node) {
        this.append(node);
        return node;
    }
    /**
     * Get attributes
     * @access private
     * @return {Object} parsed and unescaped attributes
     */ get attrs() {
        if (this._attrs) return this._attrs;
        this._attrs = {};
        const attrs = this.rawAttributes;
        for(const key in attrs){
            const val = attrs[key] || '';
            this._attrs[key.toLowerCase()] = $d0274fb26902e6e1$var$decode(val);
        }
        return this._attrs;
    }
    get attributes() {
        const ret_attrs = {};
        const attrs = this.rawAttributes;
        for(const key in attrs){
            const val = attrs[key] || '';
            ret_attrs[key] = $d0274fb26902e6e1$var$decode(val);
        }
        return ret_attrs;
    }
    /**
     * Get escaped (as-is) attributes
     * @return {Object} parsed attributes
     */ get rawAttributes() {
        if (this._rawAttrs) return this._rawAttrs;
        const attrs = {};
        if (this.rawAttrs) {
            const re = /([a-zA-Z()[\]#@$.?:][a-zA-Z0-9-._:()[\]#]*)(?:\s*=\s*((?:'[^']*')|(?:"[^"]*")|\S+))?/g;
            let match;
            while(match = re.exec(this.rawAttrs)){
                const key = match[1];
                let val = match[2] || null;
                if (val && (val[0] === `'` || val[0] === `"`)) val = val.slice(1, val.length - 1);
                attrs[key] = attrs[key] || val;
            }
        }
        this._rawAttrs = attrs;
        return attrs;
    }
    removeAttribute(key) {
        const attrs = this.rawAttributes;
        delete attrs[key];
        // Update this.attribute
        if (this._attrs) delete this._attrs[key];
        // Update rawString
        this.rawAttrs = Object.keys(attrs).map((name)=>{
            const val = this.quoteAttribute(attrs[name]);
            if (val === 'null' || val === '""') return name;
            return `${name}=${val}`;
        }).join(' ');
        // Update this.id
        if (key === 'id') this.id = '';
        return this;
    }
    hasAttribute(key) {
        return key.toLowerCase() in this.attrs;
    }
    /**
     * Get an attribute
     * @return {string | undefined} value of the attribute; or undefined if not exist
     */ getAttribute(key) {
        return this.attrs[key.toLowerCase()];
    }
    /**
     * Set an attribute value to the HTMLElement
     * @param {string} key The attribute name
     * @param {string} value The value to set, or null / undefined to remove an attribute
     */ setAttribute(key, value) {
        if (arguments.length < 2) throw new Error("Failed to execute 'setAttribute' on 'Element'");
        const k2 = key.toLowerCase();
        const attrs = this.rawAttributes;
        for(const k in attrs)if (k.toLowerCase() === k2) {
            key = k;
            break;
        }
        attrs[key] = String(value);
        // update this.attrs
        if (this._attrs) this._attrs[k2] = $d0274fb26902e6e1$var$decode(attrs[key]);
        // Update rawString
        this.rawAttrs = Object.keys(attrs).map((name)=>{
            const val = this.quoteAttribute(attrs[name]);
            if (val === 'null' || val === '""') return name;
            return `${name}=${val}`;
        }).join(' ');
        // Update this.id
        if (key === 'id') this.id = value;
        return this;
    }
    /**
     * Replace all the attributes of the HTMLElement by the provided attributes
     * @param {Attributes} attributes the new attribute set
     */ setAttributes(attributes) {
        // Invalidate current this.attributes
        if (this._attrs) delete this._attrs;
        // Invalidate current this.rawAttributes
        if (this._rawAttrs) delete this._rawAttrs;
        // Update rawString
        this.rawAttrs = Object.keys(attributes).map((name)=>{
            const val = attributes[name];
            if (val === 'null' || val === '""') return name;
            return `${name}=${this.quoteAttribute(String(val))}`;
        }).join(' ');
        return this;
    }
    insertAdjacentHTML(where, html) {
        if (arguments.length < 2) throw new Error('2 arguments required');
        const p = $d0274fb26902e6e1$var$parse(html, this._parseOptions);
        if (where === 'afterend') this.after(...p.childNodes);
        else if (where === 'afterbegin') this.prepend(...p.childNodes);
        else if (where === 'beforeend') this.append(...p.childNodes);
        else if (where === 'beforebegin') this.before(...p.childNodes);
        else throw new Error(`The value provided ('${where}') is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'`);
        return this;
    }
    /** Prepend nodes or strings to this node's children. */ prepend(...insertable) {
        const nodes = $d0274fb26902e6e1$var$resolveInsertable(insertable);
        $d0274fb26902e6e1$var$resetParent(nodes, this);
        this.childNodes.unshift(...nodes);
    }
    /** Append nodes or strings to this node's children. */ append(...insertable) {
        const nodes = $d0274fb26902e6e1$var$resolveInsertable(insertable);
        $d0274fb26902e6e1$var$resetParent(nodes, this);
        this.childNodes.push(...nodes);
    }
    /** Insert nodes or strings before this node. */ before(...insertable) {
        const nodes = $d0274fb26902e6e1$var$resolveInsertable(insertable);
        const siblings = this.parentNode.childNodes;
        $d0274fb26902e6e1$var$resetParent(nodes, this.parentNode);
        siblings.splice(siblings.indexOf(this), 0, ...nodes);
    }
    /** Insert nodes or strings after this node. */ after(...insertable) {
        const nodes = $d0274fb26902e6e1$var$resolveInsertable(insertable);
        const siblings = this.parentNode.childNodes;
        $d0274fb26902e6e1$var$resetParent(nodes, this.parentNode);
        siblings.splice(siblings.indexOf(this) + 1, 0, ...nodes);
    }
    get nextSibling() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            let i = 0;
            while(i < children.length){
                const child = children[i++];
                if (this === child) return children[i] || null;
            }
            return null;
        }
    }
    get nextElementSibling() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            let i = 0;
            let find = false;
            while(i < children.length){
                const child = children[i++];
                if (find) {
                    if (child instanceof $d0274fb26902e6e1$var$HTMLElement) return child || null;
                } else if (this === child) find = true;
            }
            return null;
        }
    }
    get previousSibling() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            let i = children.length;
            while(i > 0){
                const child = children[--i];
                if (this === child) return children[i - 1] || null;
            }
            return null;
        }
    }
    get previousElementSibling() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            let i = children.length;
            let find = false;
            while(i > 0){
                const child = children[--i];
                if (find) {
                    if (child instanceof $d0274fb26902e6e1$var$HTMLElement) return child || null;
                } else if (this === child) find = true;
            }
            return null;
        }
    }
    /** Get all childNodes of type {@link HTMLElement}. */ get children() {
        const children = [];
        for (const childNode of this.childNodes)if (childNode instanceof $d0274fb26902e6e1$var$HTMLElement) children.push(childNode);
        return children;
    }
    /**
     * Get the first child node.
     * @return The first child or undefined if none exists.
     */ get firstChild() {
        return this.childNodes[0];
    }
    /**
     * Get the first child node of type {@link HTMLElement}.
     * @return The first child element or undefined if none exists.
     */ get firstElementChild() {
        return this.children[0];
    }
    /**
     * Get the last child node.
     * @return The last child or undefined if none exists.
     */ get lastChild() {
        return (0, $d0274fb26902e6e1$var$back_1.default)(this.childNodes);
    }
    /**
     * Get the last child node of type {@link HTMLElement}.
     * @return The last child element or undefined if none exists.
     */ get lastElementChild() {
        return this.children[this.children.length - 1];
    }
    get childElementCount() {
        return this.children.length;
    }
    get classNames() {
        return this.classList.toString();
    }
    /** Clone this Node */ clone() {
        return $d0274fb26902e6e1$var$parse(this.toString(), this._parseOptions).firstChild;
    }
    /**
     * Creates an instance of HTMLElement.
     * @param keyAttrs	id and class attribute
     * @param [rawAttrs]	attributes in string
     *
     * @memberof HTMLElement
     */ constructor(tagName, keyAttrs, rawAttrs = '', parentNode = null, range, voidTag = new $d0274fb26902e6e1$var$void_tag_1.default(), _parseOptions = {}){
        super(parentNode, range);
        this.rawAttrs = rawAttrs;
        this.voidTag = voidTag;
        /**
         * Node Type declaration.
         */ this.nodeType = $d0274fb26902e6e1$var$type_1.default.ELEMENT_NODE;
        this.rawTagName = tagName;
        this.rawAttrs = rawAttrs || '';
        this.id = keyAttrs.id || '';
        this.childNodes = [];
        this._parseOptions = _parseOptions;
        this.classList = new $d0274fb26902e6e1$var$DOMTokenList(keyAttrs.class ? keyAttrs.class.split(/\s+/) : [], (classList)=>this.setAttribute('class', classList.toString()) // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        );
        if (keyAttrs.id) {
            if (!rawAttrs) this.rawAttrs = `id="${keyAttrs.id}"`;
        }
        if (keyAttrs.class) {
            if (!rawAttrs) {
                const cls = `class="${this.classList.toString()}"`;
                if (this.rawAttrs) this.rawAttrs += ` ${cls}`;
                else this.rawAttrs = cls;
            }
        }
    }
}
module.exports.default = $d0274fb26902e6e1$var$HTMLElement;
// #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
// https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
const $d0274fb26902e6e1$var$kMarkupPattern = /<!--[\s\S]*?-->|<(\/?)([a-zA-Z][-.:0-9_a-zA-Z@\xB7\xC0-\xD6\xD8-\xF6\u00F8-\u03A1\u03A3-\u03D9\u03DB-\u03EF\u03F7-\u03FF\u0400-\u04FF\u0500-\u052F\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E00-\u1E9B\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A-\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA78E\uA790-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64-\uAB65\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\x37F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]*)((?:\s+[^>]*?(?:(?:'[^']*')|(?:"[^"]*"))?)*)\s*(\/?)>/gu;
// const kMarkupPattern = /<!--[\s\S]*?-->|<(\/?)([a-zA-Z][-.:0-9_a-zA-Z]*)((?:\s+[^>]*?(?:(?:'[^']*')|(?:"[^"]*"))?)*)\s*(\/?)>/g;
const $d0274fb26902e6e1$var$kAttributePattern = /(?:^|\s)(id|class)\s*=\s*((?:'[^']*')|(?:"[^"]*")|\S+)/gi;
const $d0274fb26902e6e1$var$kElementsClosedByOpening = {
    li: {
        li: true,
        LI: true
    },
    LI: {
        li: true,
        LI: true
    },
    p: {
        p: true,
        div: true,
        P: true,
        DIV: true
    },
    P: {
        p: true,
        div: true,
        P: true,
        DIV: true
    },
    b: {
        div: true,
        DIV: true
    },
    B: {
        div: true,
        DIV: true
    },
    td: {
        td: true,
        th: true,
        TD: true,
        TH: true
    },
    TD: {
        td: true,
        th: true,
        TD: true,
        TH: true
    },
    th: {
        td: true,
        th: true,
        TD: true,
        TH: true
    },
    TH: {
        td: true,
        th: true,
        TD: true,
        TH: true
    },
    h1: {
        h1: true,
        H1: true
    },
    H1: {
        h1: true,
        H1: true
    },
    h2: {
        h2: true,
        H2: true
    },
    H2: {
        h2: true,
        H2: true
    },
    h3: {
        h3: true,
        H3: true
    },
    H3: {
        h3: true,
        H3: true
    },
    h4: {
        h4: true,
        H4: true
    },
    H4: {
        h4: true,
        H4: true
    },
    h5: {
        h5: true,
        H5: true
    },
    H5: {
        h5: true,
        H5: true
    },
    h6: {
        h6: true,
        H6: true
    },
    H6: {
        h6: true,
        H6: true
    }
};
const $d0274fb26902e6e1$var$kElementsClosedByClosing = {
    li: {
        ul: true,
        ol: true,
        UL: true,
        OL: true
    },
    LI: {
        ul: true,
        ol: true,
        UL: true,
        OL: true
    },
    a: {
        div: true,
        DIV: true
    },
    A: {
        div: true,
        DIV: true
    },
    b: {
        div: true,
        DIV: true
    },
    B: {
        div: true,
        DIV: true
    },
    i: {
        div: true,
        DIV: true
    },
    I: {
        div: true,
        DIV: true
    },
    p: {
        div: true,
        DIV: true
    },
    P: {
        div: true,
        DIV: true
    },
    td: {
        tr: true,
        table: true,
        TR: true,
        TABLE: true
    },
    TD: {
        tr: true,
        table: true,
        TR: true,
        TABLE: true
    },
    th: {
        tr: true,
        table: true,
        TR: true,
        TABLE: true
    },
    TH: {
        tr: true,
        table: true,
        TR: true,
        TABLE: true
    }
};
const $d0274fb26902e6e1$var$frameflag = 'documentfragmentcontainer';
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 * @param  {string} data      html
 * @return {HTMLElement}      root element
 */ function $d0274fb26902e6e1$var$base_parse(data, options = {}) {
    var _a, _b;
    const voidTag = new $d0274fb26902e6e1$var$void_tag_1.default((_a = options === null || options === void 0 ? void 0 : options.voidTag) === null || _a === void 0 ? void 0 : _a.closingSlash, (_b = options === null || options === void 0 ? void 0 : options.voidTag) === null || _b === void 0 ? void 0 : _b.tags);
    const elements = options.blockTextElements || {
        script: true,
        noscript: true,
        style: true,
        pre: true
    };
    const element_names = Object.keys(elements);
    const kBlockTextElements = element_names.map((it)=>new RegExp(`^${it}$`, 'i'));
    const kIgnoreElements = element_names.filter((it)=>Boolean(elements[it])).map((it)=>new RegExp(`^${it}$`, 'i'));
    function element_should_be_ignore(tag) {
        return kIgnoreElements.some((it)=>it.test(tag));
    }
    function is_block_text_element(tag) {
        return kBlockTextElements.some((it)=>it.test(tag));
    }
    const createRange = (startPos, endPos)=>[
            startPos - frameFlagOffset,
            endPos - frameFlagOffset
        ];
    const root = new $d0274fb26902e6e1$var$HTMLElement(null, {}, '', null, [
        0,
        data.length
    ], voidTag, options);
    let currentParent = root;
    const stack = [
        root
    ];
    let lastTextPos = -1;
    let noNestedTagIndex = undefined;
    let match;
    // https://github.com/taoqf/node-html-parser/issues/38
    data = `<${$d0274fb26902e6e1$var$frameflag}>${data}</${$d0274fb26902e6e1$var$frameflag}>`;
    const { lowerCaseTagName: lowerCaseTagName, fixNestedATags: fixNestedATags } = options;
    const dataEndPos = data.length - ($d0274fb26902e6e1$var$frameflag.length + 2);
    const frameFlagOffset = $d0274fb26902e6e1$var$frameflag.length + 2;
    while(match = $d0274fb26902e6e1$var$kMarkupPattern.exec(data)){
        // Note: Object destructuring here consistently tests as higher performance than array destructuring
        // eslint-disable-next-line prefer-const
        let { 0: matchText, 1: leadingSlash, 2: tagName, 3: attributes, 4: closingSlash } = match;
        const matchLength = matchText.length;
        const tagStartPos = $d0274fb26902e6e1$var$kMarkupPattern.lastIndex - matchLength;
        const tagEndPos = $d0274fb26902e6e1$var$kMarkupPattern.lastIndex;
        // Add TextNode if content
        if (lastTextPos > -1) {
            if (lastTextPos + matchLength < tagEndPos) {
                const text = data.substring(lastTextPos, tagStartPos);
                currentParent.appendChild(new $d0274fb26902e6e1$var$text_1.default(text, currentParent, createRange(lastTextPos, tagStartPos)));
            }
        }
        lastTextPos = $d0274fb26902e6e1$var$kMarkupPattern.lastIndex;
        // https://github.com/taoqf/node-html-parser/issues/38
        // Skip frameflag node
        if (tagName === $d0274fb26902e6e1$var$frameflag) continue;
        // Handle comments
        if (matchText[1] === '!') {
            if (options.comment) {
                // Only keep what is in between <!-- and -->
                const text = data.substring(tagStartPos + 4, tagEndPos - 3);
                currentParent.appendChild(new $d0274fb26902e6e1$var$comment_1.default(text, currentParent, createRange(tagStartPos, tagEndPos)));
            }
            continue;
        }
        /* -- Handle tag matching -- */ // Fix tag casing if necessary
        if (lowerCaseTagName) tagName = tagName.toLowerCase();
        // Handle opening tags (ie. <this> not </that>)
        if (!leadingSlash) {
            /* Populate attributes */ const attrs = {};
            for(let attMatch; attMatch = $d0274fb26902e6e1$var$kAttributePattern.exec(attributes);){
                const { 1: key, 2: val } = attMatch;
                const isQuoted = val[0] === `'` || val[0] === `"`;
                attrs[key.toLowerCase()] = isQuoted ? val.slice(1, val.length - 1) : val;
            }
            const parentTagName = currentParent.rawTagName;
            if (!closingSlash && $d0274fb26902e6e1$var$kElementsClosedByOpening[parentTagName]) {
                if ($d0274fb26902e6e1$var$kElementsClosedByOpening[parentTagName][tagName]) {
                    stack.pop();
                    currentParent = (0, $d0274fb26902e6e1$var$back_1.default)(stack);
                }
            }
            // Prevent nested A tags by terminating the last A and starting a new one : see issue #144
            if (fixNestedATags && (tagName === 'a' || tagName === 'A')) {
                if (noNestedTagIndex !== undefined) {
                    stack.splice(noNestedTagIndex);
                    currentParent = (0, $d0274fb26902e6e1$var$back_1.default)(stack);
                }
                noNestedTagIndex = stack.length;
            }
            const tagEndPos = $d0274fb26902e6e1$var$kMarkupPattern.lastIndex;
            const tagStartPos = tagEndPos - matchLength;
            currentParent = currentParent.appendChild(// Initialize range (end position updated later for closed tags)
            new $d0274fb26902e6e1$var$HTMLElement(tagName, attrs, attributes.slice(1), null, createRange(tagStartPos, tagEndPos), voidTag, options));
            stack.push(currentParent);
            if (is_block_text_element(tagName)) {
                // Find closing tag
                const closeMarkup = `</${tagName}>`;
                const closeIndex = lowerCaseTagName ? data.toLocaleLowerCase().indexOf(closeMarkup, $d0274fb26902e6e1$var$kMarkupPattern.lastIndex) : data.indexOf(closeMarkup, $d0274fb26902e6e1$var$kMarkupPattern.lastIndex);
                const textEndPos = closeIndex === -1 ? dataEndPos : closeIndex;
                if (element_should_be_ignore(tagName)) {
                    const text = data.substring(tagEndPos, textEndPos);
                    if (text.length > 0 && /\S/.test(text)) currentParent.appendChild(new $d0274fb26902e6e1$var$text_1.default(text, currentParent, createRange(tagEndPos, textEndPos)));
                }
                if (closeIndex === -1) lastTextPos = $d0274fb26902e6e1$var$kMarkupPattern.lastIndex = data.length + 1;
                else {
                    lastTextPos = $d0274fb26902e6e1$var$kMarkupPattern.lastIndex = closeIndex + closeMarkup.length;
                    // Cause to be treated as self-closing, because no close found
                    leadingSlash = '/';
                }
            }
        }
        // Handle closing tags or self-closed elements (ie </tag> or <br>)
        if (leadingSlash || closingSlash || voidTag.isVoidElement(tagName)) while(true){
            if (noNestedTagIndex != null && (tagName === 'a' || tagName === 'A')) noNestedTagIndex = undefined;
            if (currentParent.rawTagName === tagName) {
                // Update range end for closed tag
                currentParent.range[1] = createRange(-1, Math.max(lastTextPos, tagEndPos))[1];
                stack.pop();
                currentParent = (0, $d0274fb26902e6e1$var$back_1.default)(stack);
                break;
            } else {
                const parentTagName = currentParent.tagName;
                // Trying to close current tag, and move on
                if ($d0274fb26902e6e1$var$kElementsClosedByClosing[parentTagName]) {
                    if ($d0274fb26902e6e1$var$kElementsClosedByClosing[parentTagName][tagName]) {
                        stack.pop();
                        currentParent = (0, $d0274fb26902e6e1$var$back_1.default)(stack);
                        continue;
                    }
                }
                break;
            }
        }
    }
    return stack;
}
module.exports.base_parse = $d0274fb26902e6e1$var$base_parse;
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */ function $d0274fb26902e6e1$var$parse(data, options = {}) {
    const stack = $d0274fb26902e6e1$var$base_parse(data, options);
    const [root] = stack;
    while(stack.length > 1){
        // Handle each error elements.
        const last = stack.pop();
        const oneBefore = (0, $d0274fb26902e6e1$var$back_1.default)(stack);
        if (last.parentNode && last.parentNode.parentNode) {
            if (last.parentNode === oneBefore && last.tagName === oneBefore.tagName) // Pair error case <h3> <h3> handle : Fixes to <h3> </h3>
            // this is wrong, becouse this will put the H3 outside the current right position which should be inside the current Html Element, see issue 152 for more info
            {
                if (options.parseNoneClosedTags !== true) {
                    oneBefore.removeChild(last);
                    last.childNodes.forEach((child)=>{
                        oneBefore.parentNode.appendChild(child);
                    });
                    stack.pop();
                }
            } else // Single error  <div> <h3> </div> handle: Just removes <h3>
            // Why remove? this is already a HtmlElement and the missing <H3> is already added in this case. see issue 152 for more info
            // eslint-disable-next-line no-lonely-if
            if (options.parseNoneClosedTags !== true) {
                oneBefore.removeChild(last);
                last.childNodes.forEach((child)=>{
                    oneBefore.appendChild(child);
                });
            }
        }
    }
    // response.childNodes.forEach((node) => {
    // 	if (node instanceof HTMLElement) {
    // 		node.parentNode = null;
    // 	}
    // });
    return root;
}
module.exports.parse = $d0274fb26902e6e1$var$parse;
/**
 * Resolves a list of {@link NodeInsertable} to a list of nodes,
 * and removes nodes from any potential parent.
 */ function $d0274fb26902e6e1$var$resolveInsertable(insertable) {
    return insertable.map((val)=>{
        if (typeof val === 'string') return new $d0274fb26902e6e1$var$text_1.default(val);
        val.remove();
        return val;
    });
}
function $d0274fb26902e6e1$var$resetParent(nodes, parent) {
    return nodes.map((node)=>{
        node.parentNode = parent;
        return node;
    });
}

});

parcelRegister("81Stn", function(module, exports) {
"use strict";
var $5d88abe4ba1f05c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5d88abe4ba1f05c4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5d88abe4ba1f05c4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasChildren = module.exports.isDocument = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = void 0;

$5d88abe4ba1f05c4$var$__exportStar((parcelRequire("dAVSh")), module.exports);

$5d88abe4ba1f05c4$var$__exportStar((parcelRequire("eyr0Y")), module.exports);

$5d88abe4ba1f05c4$var$__exportStar((parcelRequire("5sWUf")), module.exports);

$5d88abe4ba1f05c4$var$__exportStar((parcelRequire("1qvmO")), module.exports);

$5d88abe4ba1f05c4$var$__exportStar((parcelRequire("7K46I")), module.exports);

$5d88abe4ba1f05c4$var$__exportStar((parcelRequire("cp1am")), module.exports);

$5d88abe4ba1f05c4$var$__exportStar((parcelRequire("7mRmG")), module.exports);

var $3jYfZ = parcelRequire("3jYfZ");

Object.defineProperty(module.exports, "isTag", {
    enumerable: true,
    get: function() {
        return $3jYfZ.isTag;
    }
});
Object.defineProperty(module.exports, "isCDATA", {
    enumerable: true,
    get: function() {
        return $3jYfZ.isCDATA;
    }
});
Object.defineProperty(module.exports, "isText", {
    enumerable: true,
    get: function() {
        return $3jYfZ.isText;
    }
});
Object.defineProperty(module.exports, "isComment", {
    enumerable: true,
    get: function() {
        return $3jYfZ.isComment;
    }
});
Object.defineProperty(module.exports, "isDocument", {
    enumerable: true,
    get: function() {
        return $3jYfZ.isDocument;
    }
});
Object.defineProperty(module.exports, "hasChildren", {
    enumerable: true,
    get: function() {
        return $3jYfZ.hasChildren;
    }
});

});

parcelRegister("dAVSh", function(module, exports) {
"use strict";
var $9e5b87cce4b4524e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOuterHTML = $9e5b87cce4b4524e$var$getOuterHTML;
module.exports.getInnerHTML = $9e5b87cce4b4524e$var$getInnerHTML;
module.exports.getText = $9e5b87cce4b4524e$var$getText;
module.exports.textContent = $9e5b87cce4b4524e$var$textContent;
module.exports.innerText = $9e5b87cce4b4524e$var$innerText;

var $3jYfZ = parcelRequire("3jYfZ");


var $9e5b87cce4b4524e$var$dom_serializer_1 = $9e5b87cce4b4524e$var$__importDefault((parcelRequire("f7XSU")));

var $6bRC8 = parcelRequire("6bRC8");

/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @returns `node`'s outer HTML.
 */ function $9e5b87cce4b4524e$var$getOuterHTML(node, options) {
    return (0, $9e5b87cce4b4524e$var$dom_serializer_1.default)(node, options);
}
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @returns `node`'s inner HTML.
 */ function $9e5b87cce4b4524e$var$getInnerHTML(node, options) {
    return (0, $3jYfZ.hasChildren)(node) ? node.children.map(function(node) {
        return $9e5b87cce4b4524e$var$getOuterHTML(node, options);
    }).join("") : "";
}
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
 *
 * @category Stringify
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */ function $9e5b87cce4b4524e$var$getText(node) {
    if (Array.isArray(node)) return node.map($9e5b87cce4b4524e$var$getText).join("");
    if ((0, $3jYfZ.isTag)(node)) return node.name === "br" ? "\n" : $9e5b87cce4b4524e$var$getText(node.children);
    if ((0, $3jYfZ.isCDATA)(node)) return $9e5b87cce4b4524e$var$getText(node.children);
    if ((0, $3jYfZ.isText)(node)) return node.data;
    return "";
}
/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */ function $9e5b87cce4b4524e$var$textContent(node) {
    if (Array.isArray(node)) return node.map($9e5b87cce4b4524e$var$textContent).join("");
    if ((0, $3jYfZ.hasChildren)(node) && !(0, $3jYfZ.isComment)(node)) return $9e5b87cce4b4524e$var$textContent(node.children);
    if ((0, $3jYfZ.isText)(node)) return node.data;
    return "";
}
/**
 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */ function $9e5b87cce4b4524e$var$innerText(node) {
    if (Array.isArray(node)) return node.map($9e5b87cce4b4524e$var$innerText).join("");
    if ((0, $3jYfZ.hasChildren)(node) && (node.type === $6bRC8.ElementType.Tag || (0, $3jYfZ.isCDATA)(node))) return $9e5b87cce4b4524e$var$innerText(node.children);
    if ((0, $3jYfZ.isText)(node)) return node.data;
    return "";
}

});

parcelRegister("3vfXm", function(module, exports) {
"use strict";
var $28d0a4f839bde568$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $28d0a4f839bde568$var$__assign = module.exports && module.exports.__assign || function() {
    $28d0a4f839bde568$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28d0a4f839bde568$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.CDATA = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $6bRC8 = parcelRequire("6bRC8");

/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $28d0a4f839bde568$var$Node = /** @class */ function() {
    function Node() {
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $28d0a4f839bde568$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $28d0a4f839bde568$var$Node;
/**
 * A node that contains some data.
 */ var $28d0a4f839bde568$var$DataNode = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */ function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($28d0a4f839bde568$var$Node);
module.exports.DataNode = $28d0a4f839bde568$var$DataNode;
/**
 * Text within the document.
 */ var $28d0a4f839bde568$var$Text = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $6bRC8.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function() {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}($28d0a4f839bde568$var$DataNode);
module.exports.Text = $28d0a4f839bde568$var$Text;
/**
 * Comments within the document.
 */ var $28d0a4f839bde568$var$Comment = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $6bRC8.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function() {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}($28d0a4f839bde568$var$DataNode);
module.exports.Comment = $28d0a4f839bde568$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $28d0a4f839bde568$var$ProcessingInstruction = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = $6bRC8.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}($28d0a4f839bde568$var$DataNode);
module.exports.ProcessingInstruction = $28d0a4f839bde568$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $28d0a4f839bde568$var$NodeWithChildren = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($28d0a4f839bde568$var$Node);
module.exports.NodeWithChildren = $28d0a4f839bde568$var$NodeWithChildren;
var $28d0a4f839bde568$var$CDATA = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $6bRC8.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function() {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}($28d0a4f839bde568$var$NodeWithChildren);
module.exports.CDATA = $28d0a4f839bde568$var$CDATA;
/**
 * The root node of the document.
 */ var $28d0a4f839bde568$var$Document = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $6bRC8.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function() {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}($28d0a4f839bde568$var$NodeWithChildren);
module.exports.Document = $28d0a4f839bde568$var$Document;
/**
 * An element within the DOM.
 */ var $28d0a4f839bde568$var$Element = /** @class */ function(_super) {
    $28d0a4f839bde568$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $6bRC8.ElementType.Script : name === "style" ? $6bRC8.ElementType.Style : $6bRC8.ElementType.Tag;
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($28d0a4f839bde568$var$NodeWithChildren);
module.exports.Element = $28d0a4f839bde568$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $28d0a4f839bde568$var$isTag(node) {
    return (0, $6bRC8.isTag)(node);
}
module.exports.isTag = $28d0a4f839bde568$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $28d0a4f839bde568$var$isCDATA(node) {
    return node.type === $6bRC8.ElementType.CDATA;
}
module.exports.isCDATA = $28d0a4f839bde568$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $28d0a4f839bde568$var$isText(node) {
    return node.type === $6bRC8.ElementType.Text;
}
module.exports.isText = $28d0a4f839bde568$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $28d0a4f839bde568$var$isComment(node) {
    return node.type === $6bRC8.ElementType.Comment;
}
module.exports.isComment = $28d0a4f839bde568$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $28d0a4f839bde568$var$isDirective(node) {
    return node.type === $6bRC8.ElementType.Directive;
}
module.exports.isDirective = $28d0a4f839bde568$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $28d0a4f839bde568$var$isDocument(node) {
    return node.type === $6bRC8.ElementType.Root;
}
module.exports.isDocument = $28d0a4f839bde568$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */ function $28d0a4f839bde568$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $28d0a4f839bde568$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $28d0a4f839bde568$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($28d0a4f839bde568$var$isText(node)) result = new $28d0a4f839bde568$var$Text(node.data);
    else if ($28d0a4f839bde568$var$isComment(node)) result = new $28d0a4f839bde568$var$Comment(node.data);
    else if ($28d0a4f839bde568$var$isTag(node)) {
        var children = recursive ? $28d0a4f839bde568$var$cloneChildren(node.children) : [];
        var clone_1 = new $28d0a4f839bde568$var$Element(node.name, $28d0a4f839bde568$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $28d0a4f839bde568$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $28d0a4f839bde568$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($28d0a4f839bde568$var$isCDATA(node)) {
        var children = recursive ? $28d0a4f839bde568$var$cloneChildren(node.children) : [];
        var clone_2 = new $28d0a4f839bde568$var$CDATA(children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($28d0a4f839bde568$var$isDocument(node)) {
        var children = recursive ? $28d0a4f839bde568$var$cloneChildren(node.children) : [];
        var clone_3 = new $28d0a4f839bde568$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($28d0a4f839bde568$var$isDirective(node)) {
        var instruction = new $28d0a4f839bde568$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $28d0a4f839bde568$var$cloneNode;
function $28d0a4f839bde568$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $28d0a4f839bde568$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});

parcelRegister("f7XSU", function(module, exports) {
"use strict";
var $b035f649bf94d454$var$__assign = module.exports && module.exports.__assign || function() {
    $b035f649bf94d454$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b035f649bf94d454$var$__assign.apply(this, arguments);
};
var $b035f649bf94d454$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b035f649bf94d454$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b035f649bf94d454$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b035f649bf94d454$var$__createBinding(result, mod, k);
    }
    $b035f649bf94d454$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.render = void 0;

/*
 * Module dependencies
 */ var $b035f649bf94d454$var$ElementType = $b035f649bf94d454$var$__importStar((parcelRequire("6bRC8")));

var $aEI1g = parcelRequire("aEI1g");


var $tyrPM = parcelRequire("tyrPM");

var $b035f649bf94d454$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $b035f649bf94d454$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $b035f649bf94d454$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $b035f649bf94d454$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? $aEI1g.encodeXML : $aEI1g.escapeAttribute;
    return Object.keys(attributes).map(function(key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = $tyrPM.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return "".concat(key, "=\"").concat(encode(value), "\"");
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ var $b035f649bf94d454$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */ function $b035f649bf94d454$var$render(node, options) {
    if (options === void 0) options = {};
    var nodes = "length" in node ? node : [
        node
    ];
    var output = "";
    for(var i = 0; i < nodes.length; i++)output += $b035f649bf94d454$var$renderNode(nodes[i], options);
    return output;
}
module.exports.render = $b035f649bf94d454$var$render;
module.exports.default = $b035f649bf94d454$var$render;
function $b035f649bf94d454$var$renderNode(node, options) {
    switch(node.type){
        case $b035f649bf94d454$var$ElementType.Root:
            return $b035f649bf94d454$var$render(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $b035f649bf94d454$var$ElementType.Doctype:
        case $b035f649bf94d454$var$ElementType.Directive:
            return $b035f649bf94d454$var$renderDirective(node);
        case $b035f649bf94d454$var$ElementType.Comment:
            return $b035f649bf94d454$var$renderComment(node);
        case $b035f649bf94d454$var$ElementType.CDATA:
            return $b035f649bf94d454$var$renderCdata(node);
        case $b035f649bf94d454$var$ElementType.Script:
        case $b035f649bf94d454$var$ElementType.Style:
        case $b035f649bf94d454$var$ElementType.Tag:
            return $b035f649bf94d454$var$renderTag(node, options);
        case $b035f649bf94d454$var$ElementType.Text:
            return $b035f649bf94d454$var$renderText(node, options);
    }
}
var $b035f649bf94d454$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var $b035f649bf94d454$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $b035f649bf94d454$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = $tyrPM.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $b035f649bf94d454$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = $b035f649bf94d454$var$__assign($b035f649bf94d454$var$__assign({}, opts), {
            xmlMode: false
        });
    }
    if (!opts.xmlMode && $b035f649bf94d454$var$foreignElements.has(elem.name)) opts = $b035f649bf94d454$var$__assign($b035f649bf94d454$var$__assign({}, opts), {
        xmlMode: "foreign"
    });
    var tag = "<".concat(elem.name);
    var attribs = $b035f649bf94d454$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += " ".concat(attribs);
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $b035f649bf94d454$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $b035f649bf94d454$var$render(elem.children, opts);
        if (opts.xmlMode || !$b035f649bf94d454$var$singleTag.has(elem.name)) tag += "</".concat(elem.name, ">");
    }
    return tag;
}
function $b035f649bf94d454$var$renderDirective(elem) {
    return "<".concat(elem.data, ">");
}
function $b035f649bf94d454$var$renderText(elem, opts) {
    var _a;
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $b035f649bf94d454$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $aEI1g.encodeXML)(data) : (0, $aEI1g.escapeText)(data);
    return data;
}
function $b035f649bf94d454$var$renderCdata(elem) {
    return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function $b035f649bf94d454$var$renderComment(elem) {
    return "<!--".concat(elem.data, "-->");
}

});

parcelRegister("eWl4h", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("3DyDZ", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("lm1Rc", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $f8bd17d5bbcab39a$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $f8bd17d5bbcab39a$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($f8bd17d5bbcab39a$var$_a = String.fromCodePoint) !== null && $f8bd17d5bbcab39a$var$_a !== void 0 ? $f8bd17d5bbcab39a$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $f8bd17d5bbcab39a$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $f8bd17d5bbcab39a$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $f8bd17d5bbcab39a$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $f8bd17d5bbcab39a$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($f8bd17d5bbcab39a$var$replaceCodePoint(codePoint));
}
module.exports.default = $f8bd17d5bbcab39a$var$decodeCodePoint;

});

parcelRegister("l2AEi", function(module, exports) {
"use strict";
// Generated using scripts/write-encode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $f516369c26d611ba$var$restoreDiff(arr) {
    for(var i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
// prettier-ignore
module.exports.default = new Map(/* #__PURE__ */ $f516369c26d611ba$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $f516369c26d611ba$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $f516369c26d611ba$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $f516369c26d611ba$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("eyr0Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getChildren = $a9893232e1f79944$var$getChildren;
module.exports.getParent = $a9893232e1f79944$var$getParent;
module.exports.getSiblings = $a9893232e1f79944$var$getSiblings;
module.exports.getAttributeValue = $a9893232e1f79944$var$getAttributeValue;
module.exports.hasAttrib = $a9893232e1f79944$var$hasAttrib;
module.exports.getName = $a9893232e1f79944$var$getName;
module.exports.nextElementSibling = $a9893232e1f79944$var$nextElementSibling;
module.exports.prevElementSibling = $a9893232e1f79944$var$prevElementSibling;

var $3jYfZ = parcelRequire("3jYfZ");

/**
 * Get a node's children.
 *
 * @category Traversal
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */ function $a9893232e1f79944$var$getChildren(elem) {
    return (0, $3jYfZ.hasChildren)(elem) ? elem.children : [];
}
/**
 * Get a node's parent.
 *
 * @category Traversal
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
 */ function $a9893232e1f79944$var$getParent(elem) {
    return elem.parent || null;
}
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first. If we don't
 * have a parent (the element is a root node), we walk the element's `prev` &
 * `next` to get all remaining nodes.
 *
 * @category Traversal
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings, including `elem`.
 */ function $a9893232e1f79944$var$getSiblings(elem) {
    var _a, _b;
    var parent = $a9893232e1f79944$var$getParent(elem);
    if (parent != null) return $a9893232e1f79944$var$getChildren(parent);
    var siblings = [
        elem
    ];
    var prev = elem.prev, next = elem.next;
    while(prev != null){
        siblings.unshift(prev);
        _a = prev, prev = _a.prev;
    }
    while(next != null){
        siblings.push(next);
        _b = next, next = _b.next;
    }
    return siblings;
}
/**
 * Gets an attribute from an element.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */ function $a9893232e1f79944$var$getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
/**
 * Checks whether an element has an attribute.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */ function $a9893232e1f79944$var$hasAttrib(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
/**
 * Get the tag name of an element.
 *
 * @category Traversal
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */ function $a9893232e1f79944$var$getName(elem) {
    return elem.name;
}
/**
 * Returns the next element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
 * sibling.
 */ function $a9893232e1f79944$var$nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while(next !== null && !(0, $3jYfZ.isTag)(next))_a = next, next = _a.next;
    return next;
}
/**
 * Returns the previous element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
 * previous sibling.
 */ function $a9893232e1f79944$var$prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while(prev !== null && !(0, $3jYfZ.isTag)(prev))_a = prev, prev = _a.prev;
    return prev;
}

});

parcelRegister("5sWUf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeElement = $3fad42d958aa3470$var$removeElement;
module.exports.replaceElement = $3fad42d958aa3470$var$replaceElement;
module.exports.appendChild = $3fad42d958aa3470$var$appendChild;
module.exports.append = $3fad42d958aa3470$var$append;
module.exports.prependChild = $3fad42d958aa3470$var$prependChild;
module.exports.prepend = $3fad42d958aa3470$var$prepend;
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $3fad42d958aa3470$var$removeElement(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        var childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
/**
 * Replace an element in the dom
 *
 * @category Manipulation
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */ function $3fad42d958aa3470$var$replaceElement(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    var next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    var parent = replacement.parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
/**
 * Append a child to an element.
 *
 * @category Manipulation
 * @param parent The element to append to.
 * @param child The element to be added as a child.
 */ function $3fad42d958aa3470$var$appendChild(parent, child) {
    $3fad42d958aa3470$var$removeElement(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        var sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
/**
 * Append an element after another.
 *
 * @category Manipulation
 * @param elem The element to append after.
 * @param next The element be added.
 */ function $3fad42d958aa3470$var$append(elem, next) {
    $3fad42d958aa3470$var$removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
/**
 * Prepend a child to an element.
 *
 * @category Manipulation
 * @param parent The element to prepend before.
 * @param child The element to be added as a child.
 */ function $3fad42d958aa3470$var$prependChild(parent, child) {
    $3fad42d958aa3470$var$removeElement(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        var sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
/**
 * Prepend an element before another.
 *
 * @category Manipulation
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */ function $3fad42d958aa3470$var$prepend(elem, prev) {
    $3fad42d958aa3470$var$removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("1qvmO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filter = $10a08cfbff275d4e$var$filter;
module.exports.find = $10a08cfbff275d4e$var$find;
module.exports.findOneChild = $10a08cfbff275d4e$var$findOneChild;
module.exports.findOne = $10a08cfbff275d4e$var$findOne;
module.exports.existsOne = $10a08cfbff275d4e$var$existsOne;
module.exports.findAll = $10a08cfbff275d4e$var$findAll;

var $3jYfZ = parcelRequire("3jYfZ");

/**
 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $10a08cfbff275d4e$var$filter(test, node, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return $10a08cfbff275d4e$var$find(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
/**
 * Search an array of nodes and their children for nodes passing a test function.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $10a08cfbff275d4e$var$find(test, nodes, recurse, limit) {
    var result = [];
    /** Stack of the arrays we are looking at. */ var nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ var indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $3jYfZ.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
/**
 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 * @deprecated Use `Array.prototype.find` directly.
 */ function $10a08cfbff275d4e$var$findOneChild(test, nodes) {
    return nodes.find(test);
}
/**
 * Finds one element in a tree that passes a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Node or array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first node that passes `test`.
 */ function $10a08cfbff275d4e$var$findOne(test, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    var searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for(var i = 0; i < searchedNodes.length; i++){
        var node = searchedNodes[i];
        if ((0, $3jYfZ.isTag)(node) && test(node)) return node;
        if (recurse && (0, $3jYfZ.hasChildren)(node) && node.children.length > 0) {
            var found = $10a08cfbff275d4e$var$findOne(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
/**
 * Checks if a tree of nodes contains at least one node passing a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing the test.
 */ function $10a08cfbff275d4e$var$existsOne(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some(function(node) {
        return (0, $3jYfZ.isTag)(node) && test(node) || (0, $3jYfZ.hasChildren)(node) && $10a08cfbff275d4e$var$existsOne(test, node.children);
    });
}
/**
 * Search an array of nodes and their children for elements passing a test function.
 *
 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */ function $10a08cfbff275d4e$var$findAll(test, nodes) {
    var result = [];
    var nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    var indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if ((0, $3jYfZ.isTag)(elem) && test(elem)) result.push(elem);
        if ((0, $3jYfZ.hasChildren)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("7K46I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.testElement = $5a3003e4616eee81$var$testElement;
module.exports.getElements = $5a3003e4616eee81$var$getElements;
module.exports.getElementById = $5a3003e4616eee81$var$getElementById;
module.exports.getElementsByTagName = $5a3003e4616eee81$var$getElementsByTagName;
module.exports.getElementsByClassName = $5a3003e4616eee81$var$getElementsByClassName;
module.exports.getElementsByTagType = $5a3003e4616eee81$var$getElementsByTagType;

var $3jYfZ = parcelRequire("3jYfZ");


var $1qvmO = parcelRequire("1qvmO");

/**
 * A map of functions to check nodes against.
 */ var $5a3003e4616eee81$var$Checks = {
    tag_name: function(name) {
        if (typeof name === "function") return function(elem) {
            return (0, $3jYfZ.isTag)(elem) && name(elem.name);
        };
        else if (name === "*") return $3jYfZ.isTag;
        return function(elem) {
            return (0, $3jYfZ.isTag)(elem) && elem.name === name;
        };
    },
    tag_type: function(type) {
        if (typeof type === "function") return function(elem) {
            return type(elem.type);
        };
        return function(elem) {
            return elem.type === type;
        };
    },
    tag_contains: function(data) {
        if (typeof data === "function") return function(elem) {
            return (0, $3jYfZ.isText)(elem) && data(elem.data);
        };
        return function(elem) {
            return (0, $3jYfZ.isText)(elem) && elem.data === data;
        };
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $5a3003e4616eee81$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return function(elem) {
        return (0, $3jYfZ.isTag)(elem) && value(elem.attribs[attrib]);
    };
    return function(elem) {
        return (0, $3jYfZ.isTag)(elem) && elem.attribs[attrib] === value;
    };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $5a3003e4616eee81$var$combineFuncs(a, b) {
    return function(elem) {
        return a(elem) || b(elem);
    };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $5a3003e4616eee81$var$compileTest(options) {
    var funcs = Object.keys(options).map(function(key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call($5a3003e4616eee81$var$Checks, key) ? $5a3003e4616eee81$var$Checks[key](value) : $5a3003e4616eee81$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($5a3003e4616eee81$var$combineFuncs);
}
/**
 * Checks whether a node matches the description in `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */ function $5a3003e4616eee81$var$testElement(options, node) {
    var test = $5a3003e4616eee81$var$compileTest(options);
    return test ? test(node) : true;
}
/**
 * Returns all nodes that match `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */ function $5a3003e4616eee81$var$getElements(options, nodes, recurse, limit) {
    if (limit === void 0) limit = Infinity;
    var test = $5a3003e4616eee81$var$compileTest(options);
    return test ? (0, $1qvmO.filter)(test, nodes, recurse, limit) : [];
}
/**
 * Returns the node with the supplied ID.
 *
 * @category Legacy Query Functions
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */ function $5a3003e4616eee81$var$getElementById(id, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $1qvmO.findOne)($5a3003e4616eee81$var$getAttribCheck("id", id), nodes, recurse);
}
/**
 * Returns all nodes with the supplied `tagName`.
 *
 * @category Legacy Query Functions
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */ function $5a3003e4616eee81$var$getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $1qvmO.filter)($5a3003e4616eee81$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
/**
 * Returns all nodes with the supplied `className`.
 *
 * @category Legacy Query Functions
 * @param className Class name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `className`.
 */ function $5a3003e4616eee81$var$getElementsByClassName(className, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $1qvmO.filter)($5a3003e4616eee81$var$getAttribCheck("class", className), nodes, recurse, limit);
}
/**
 * Returns all nodes with the supplied `type`.
 *
 * @category Legacy Query Functions
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */ function $5a3003e4616eee81$var$getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $1qvmO.filter)($5a3003e4616eee81$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("cp1am", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DocumentPosition = void 0;
module.exports.removeSubsets = $9078b962e727db05$var$removeSubsets;
module.exports.compareDocumentPosition = $9078b962e727db05$var$compareDocumentPosition;
module.exports.uniqueSort = $9078b962e727db05$var$uniqueSort;

var $3jYfZ = parcelRequire("3jYfZ");

/**
 * Given an array of nodes, remove any member that is contained by another
 * member.
 *
 * @category Helpers
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't contained by other nodes.
 */ function $9078b962e727db05$var$removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(var ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
/**
 * @category Helpers
 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
 */ var $9078b962e727db05$var$DocumentPosition;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($9078b962e727db05$var$DocumentPosition || (module.exports.DocumentPosition = $9078b962e727db05$var$DocumentPosition = {}));
/**
 * Compare the position of one node against another node in any other document,
 * returning a bitmask with the values from {@link DocumentPosition}.
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent.
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @category Helpers
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */ function $9078b962e727db05$var$compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) return 0;
    var current = (0, $3jYfZ.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $3jYfZ.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $9078b962e727db05$var$DocumentPosition.DISCONNECTED;
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $9078b962e727db05$var$DocumentPosition.FOLLOWING | $9078b962e727db05$var$DocumentPosition.CONTAINED_BY;
        return $9078b962e727db05$var$DocumentPosition.FOLLOWING;
    }
    if (sharedParent === nodeA) return $9078b962e727db05$var$DocumentPosition.PRECEDING | $9078b962e727db05$var$DocumentPosition.CONTAINS;
    return $9078b962e727db05$var$DocumentPosition.PRECEDING;
}
/**
 * Sort an array of nodes based on their relative position in the document,
 * removing any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @category Helpers
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */ function $9078b962e727db05$var$uniqueSort(nodes) {
    nodes = nodes.filter(function(node, i, arr) {
        return !arr.includes(node, i + 1);
    });
    nodes.sort(function(a, b) {
        var relative = $9078b962e727db05$var$compareDocumentPosition(a, b);
        if (relative & $9078b962e727db05$var$DocumentPosition.PRECEDING) return -1;
        else if (relative & $9078b962e727db05$var$DocumentPosition.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("7mRmG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeed = $55d3fba33b68cc98$var$getFeed;

var $dAVSh = parcelRequire("dAVSh");


var $7K46I = parcelRequire("7K46I");

/**
 * Get the feed object from the root of a DOM tree.
 *
 * @category Feeds
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */ function $55d3fba33b68cc98$var$getFeed(doc) {
    var feedRoot = $55d3fba33b68cc98$var$getOneElement($55d3fba33b68cc98$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $55d3fba33b68cc98$var$getAtomFeed(feedRoot) : $55d3fba33b68cc98$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $55d3fba33b68cc98$var$getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, $7K46I.getElementsByTagName)("entry", childs).map(function(item) {
            var _a;
            var children = item.children;
            var entry = {
                media: $55d3fba33b68cc98$var$getMediaElements(children)
            };
            $55d3fba33b68cc98$var$addConditionally(entry, "id", "id", children);
            $55d3fba33b68cc98$var$addConditionally(entry, "title", "title", children);
            var href = (_a = $55d3fba33b68cc98$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            var description = $55d3fba33b68cc98$var$fetch("summary", children) || $55d3fba33b68cc98$var$fetch("content", children);
            if (description) entry.description = description;
            var pubDate = $55d3fba33b68cc98$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $55d3fba33b68cc98$var$addConditionally(feed, "id", "id", childs);
    $55d3fba33b68cc98$var$addConditionally(feed, "title", "title", childs);
    var href = (_a = $55d3fba33b68cc98$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $55d3fba33b68cc98$var$addConditionally(feed, "description", "subtitle", childs);
    var updated = $55d3fba33b68cc98$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $55d3fba33b68cc98$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $55d3fba33b68cc98$var$getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = $55d3fba33b68cc98$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $7K46I.getElementsByTagName)("item", feedRoot.children).map(function(item) {
            var children = item.children;
            var entry = {
                media: $55d3fba33b68cc98$var$getMediaElements(children)
            };
            $55d3fba33b68cc98$var$addConditionally(entry, "id", "guid", children);
            $55d3fba33b68cc98$var$addConditionally(entry, "title", "title", children);
            $55d3fba33b68cc98$var$addConditionally(entry, "link", "link", children);
            $55d3fba33b68cc98$var$addConditionally(entry, "description", "description", children);
            var pubDate = $55d3fba33b68cc98$var$fetch("pubDate", children) || $55d3fba33b68cc98$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $55d3fba33b68cc98$var$addConditionally(feed, "title", "title", childs);
    $55d3fba33b68cc98$var$addConditionally(feed, "link", "link", childs);
    $55d3fba33b68cc98$var$addConditionally(feed, "description", "description", childs);
    var updated = $55d3fba33b68cc98$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $55d3fba33b68cc98$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var $55d3fba33b68cc98$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
var $55d3fba33b68cc98$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $55d3fba33b68cc98$var$getMediaElements(where) {
    return (0, $7K46I.getElementsByTagName)("media:content", where).map(function(elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for(var _i = 0, MEDIA_KEYS_STRING_1 = $55d3fba33b68cc98$var$MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++){
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) media[attrib] = attribs[attrib];
        }
        for(var _a = 0, MEDIA_KEYS_INT_1 = $55d3fba33b68cc98$var$MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++){
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        }
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $55d3fba33b68cc98$var$getOneElement(tagName, node) {
    return (0, $7K46I.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $55d3fba33b68cc98$var$fetch(tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    return (0, $dAVSh.textContent)((0, $7K46I.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $55d3fba33b68cc98$var$addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    var val = $55d3fba33b68cc98$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $55d3fba33b68cc98$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});

parcelRegister("3pXQ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isTraversal = void 0;

var $bGFyo = parcelRequire("bGFyo");

var $27d21fd98ac28004$var$procedure = new Map([
    [
        $bGFyo.SelectorType.Universal,
        50
    ],
    [
        $bGFyo.SelectorType.Tag,
        30
    ],
    [
        $bGFyo.SelectorType.Attribute,
        1
    ],
    [
        $bGFyo.SelectorType.Pseudo,
        0
    ]
]);
function $27d21fd98ac28004$var$isTraversal(token) {
    return !$27d21fd98ac28004$var$procedure.has(token.type);
}
module.exports.isTraversal = $27d21fd98ac28004$var$isTraversal;
var $27d21fd98ac28004$var$attributes = new Map([
    [
        $bGFyo.AttributeAction.Exists,
        10
    ],
    [
        $bGFyo.AttributeAction.Equals,
        8
    ],
    [
        $bGFyo.AttributeAction.Not,
        7
    ],
    [
        $bGFyo.AttributeAction.Start,
        6
    ],
    [
        $bGFyo.AttributeAction.End,
        6
    ],
    [
        $bGFyo.AttributeAction.Any,
        5
    ]
]);
/**
 * Sort the parts of the passed selector,
 * as there is potential for optimization
 * (some types of selectors are faster than others)
 *
 * @param arr Selector to sort
 */ function $27d21fd98ac28004$var$sortByProcedure(arr) {
    var procs = arr.map($27d21fd98ac28004$var$getProcedure);
    for(var i = 1; i < arr.length; i++){
        var procNew = procs[i];
        if (procNew < 0) continue;
        for(var j = i - 1; j >= 0 && procNew < procs[j]; j--){
            var token = arr[j + 1];
            arr[j + 1] = arr[j];
            arr[j] = token;
            procs[j + 1] = procs[j];
            procs[j] = procNew;
        }
    }
}
module.exports.default = $27d21fd98ac28004$var$sortByProcedure;
function $27d21fd98ac28004$var$getProcedure(token) {
    var _a, _b;
    var proc = (_a = $27d21fd98ac28004$var$procedure.get(token.type)) !== null && _a !== void 0 ? _a : -1;
    if (token.type === $bGFyo.SelectorType.Attribute) {
        proc = (_b = $27d21fd98ac28004$var$attributes.get(token.action)) !== null && _b !== void 0 ? _b : 4;
        if (token.action === $bGFyo.AttributeAction.Equals && token.name === "id") // Prefer ID selectors (eg. #ID)
        proc = 9;
        if (token.ignoreCase) /*
             * IgnoreCase adds some overhead, prefer "normal" token
             * this is a binary operation, to ensure it's still an int
             */ proc >>= 1;
    } else if (token.type === $bGFyo.SelectorType.Pseudo) {
        if (!token.data) proc = 3;
        else if (token.name === "has" || token.name === "contains") proc = 0; // Expensive in any case
        else if (Array.isArray(token.data)) {
            // Eg. :matches, :not
            proc = Math.min.apply(Math, token.data.map(function(d) {
                return Math.min.apply(Math, d.map($27d21fd98ac28004$var$getProcedure));
            }));
            // If we have traversals, try to avoid executing this selector
            if (proc < 0) proc = 0;
        } else proc = 2;
    }
    return proc;
}

});

parcelRegister("22Uby", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $17d759ec3ad775aa$var$arr_back(arr) {
    return arr[arr.length - 1];
}
module.exports.default = $17d759ec3ad775aa$var$arr_back;

});

parcelRegister("f2HSH", function(module, exports) {
"use strict";
var $af3914cbc8b1da32$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $af3914cbc8b1da32$var$type_1 = $af3914cbc8b1da32$var$__importDefault((parcelRequire("luckw")));
function $af3914cbc8b1da32$var$isTag(node) {
    return node && node.nodeType === $af3914cbc8b1da32$var$type_1.default.ELEMENT_NODE;
}
function $af3914cbc8b1da32$var$getAttributeValue(elem, name) {
    return $af3914cbc8b1da32$var$isTag(elem) ? elem.getAttribute(name) : undefined;
}
function $af3914cbc8b1da32$var$getName(elem) {
    return (elem && elem.rawTagName || '').toLowerCase();
}
function $af3914cbc8b1da32$var$getChildren(node) {
    return node && node.childNodes;
}
function $af3914cbc8b1da32$var$getParent(node) {
    return node ? node.parentNode : null;
}
function $af3914cbc8b1da32$var$getText(node) {
    return node.text;
}
function $af3914cbc8b1da32$var$removeSubsets(nodes) {
    let idx = nodes.length;
    let node;
    let ancestor;
    let replace;
    // Check if each node (or one of its ancestors) is already contained in the
    // array.
    while(--idx > -1){
        node = ancestor = nodes[idx];
        // Temporarily remove the node under consideration
        nodes[idx] = null;
        replace = true;
        while(ancestor){
            if (nodes.indexOf(ancestor) > -1) {
                replace = false;
                nodes.splice(idx, 1);
                break;
            }
            ancestor = $af3914cbc8b1da32$var$getParent(ancestor);
        }
        // If the node has been found to be unique, re-insert it.
        if (replace) nodes[idx] = node;
    }
    return nodes;
}
function $af3914cbc8b1da32$var$existsOne(test, elems) {
    return elems.some((elem)=>{
        return $af3914cbc8b1da32$var$isTag(elem) ? test(elem) || $af3914cbc8b1da32$var$existsOne(test, $af3914cbc8b1da32$var$getChildren(elem)) : false;
    });
}
function $af3914cbc8b1da32$var$getSiblings(node) {
    const parent = $af3914cbc8b1da32$var$getParent(node);
    return parent ? $af3914cbc8b1da32$var$getChildren(parent) : [];
}
function $af3914cbc8b1da32$var$hasAttrib(elem, name) {
    return $af3914cbc8b1da32$var$getAttributeValue(elem, name) !== undefined;
}
function $af3914cbc8b1da32$var$findOne(test, elems) {
    let elem = null;
    for(let i = 0, l = elems === null || elems === void 0 ? void 0 : elems.length; i < l && !elem; i++){
        const el = elems[i];
        if (test(el)) elem = el;
        else {
            const childs = $af3914cbc8b1da32$var$getChildren(el);
            if (childs && childs.length > 0) elem = $af3914cbc8b1da32$var$findOne(test, childs);
        }
    }
    return elem;
}
function $af3914cbc8b1da32$var$findAll(test, nodes) {
    let result = [];
    for(let i = 0, j = nodes.length; i < j; i++){
        if (!$af3914cbc8b1da32$var$isTag(nodes[i])) continue;
        if (test(nodes[i])) result.push(nodes[i]);
        const childs = $af3914cbc8b1da32$var$getChildren(nodes[i]);
        if (childs) result = result.concat($af3914cbc8b1da32$var$findAll(test, childs));
    }
    return result;
}
module.exports.default = {
    isTag: $af3914cbc8b1da32$var$isTag,
    getAttributeValue: $af3914cbc8b1da32$var$getAttributeValue,
    getName: $af3914cbc8b1da32$var$getName,
    getChildren: $af3914cbc8b1da32$var$getChildren,
    getParent: $af3914cbc8b1da32$var$getParent,
    getText: $af3914cbc8b1da32$var$getText,
    removeSubsets: $af3914cbc8b1da32$var$removeSubsets,
    existsOne: $af3914cbc8b1da32$var$existsOne,
    getSiblings: $af3914cbc8b1da32$var$getSiblings,
    hasAttrib: $af3914cbc8b1da32$var$hasAttrib,
    findOne: $af3914cbc8b1da32$var$findOne,
    findAll: $af3914cbc8b1da32$var$findAll
};

});

parcelRegister("4bNOP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $30ced579ceac8b82$var$VoidTag {
    formatNode(tag, attrs, innerHTML) {
        const addClosingSlash = this.addClosingSlash;
        const closingSpace = addClosingSlash && attrs && !attrs.endsWith(' ') ? ' ' : '';
        const closingSlash = addClosingSlash ? `${closingSpace}/` : '';
        return this.isVoidElement(tag.toLowerCase()) ? `<${tag}${attrs}${closingSlash}>` : `<${tag}${attrs}>${innerHTML}</${tag}>`;
    }
    isVoidElement(tag) {
        return this.voidTags.has(tag);
    }
    constructor(addClosingSlash = false, tags){
        this.addClosingSlash = addClosingSlash;
        if (Array.isArray(tags)) this.voidTags = tags.reduce((set, tag)=>{
            return set.add(tag.toLowerCase()).add(tag.toUpperCase()).add(tag);
        }, new Set());
        else this.voidTags = [
            'area',
            'base',
            'br',
            'col',
            'embed',
            'hr',
            'img',
            'input',
            'link',
            'meta',
            'param',
            'source',
            'track',
            'wbr'
        ].reduce((set, tag)=>{
            return set.add(tag.toLowerCase()).add(tag.toUpperCase()).add(tag);
        }, new Set());
    }
}
module.exports.default = $30ced579ceac8b82$var$VoidTag;

});

parcelRegister("a5onE", function(module, exports) {
"use strict";
var $757d487144c44b9f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jopS9 = parcelRequire("jopS9");


const $757d487144c44b9f$var$node_1 = $757d487144c44b9f$var$__importDefault((parcelRequire("1vK45")));

const $757d487144c44b9f$var$type_1 = $757d487144c44b9f$var$__importDefault((parcelRequire("luckw")));
/**
 * TextNode to contain a text element in DOM tree.
 * @param {string} value [description]
 */ class $757d487144c44b9f$var$TextNode extends $757d487144c44b9f$var$node_1.default {
    clone() {
        return new $757d487144c44b9f$var$TextNode(this._rawText, null);
    }
    get rawText() {
        return this._rawText;
    }
    /**
     * Set rawText and invalidate trimmed caches
     */ set rawText(text) {
        this._rawText = text;
        this._trimmedRawText = void 0;
        this._trimmedText = void 0;
    }
    /**
     * Returns raw text with all whitespace trimmed except single leading/trailing non-breaking space
     */ get trimmedRawText() {
        if (this._trimmedRawText !== undefined) return this._trimmedRawText;
        this._trimmedRawText = $757d487144c44b9f$var$trimText(this.rawText);
        return this._trimmedRawText;
    }
    /**
     * Returns text with all whitespace trimmed except single leading/trailing non-breaking space
     */ get trimmedText() {
        if (this._trimmedText !== undefined) return this._trimmedText;
        this._trimmedText = $757d487144c44b9f$var$trimText(this.text);
        return this._trimmedText;
    }
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */ get text() {
        return (0, $jopS9.decode)(this.rawText);
    }
    /**
     * Detect if the node contains only white space.
     * @return {boolean}
     */ get isWhitespace() {
        return /^(\s|&nbsp;)*$/.test(this.rawText);
    }
    toString() {
        return this.rawText;
    }
    constructor(rawText, parentNode = null, range){
        super(parentNode, range);
        /**
         * Node Type declaration.
         * @type {Number}
         */ this.nodeType = $757d487144c44b9f$var$type_1.default.TEXT_NODE;
        this.rawTagName = '';
        this._rawText = rawText;
    }
}
module.exports.default = $757d487144c44b9f$var$TextNode;
/**
 * Trim whitespace except single leading/trailing non-breaking space
 */ function $757d487144c44b9f$var$trimText(text) {
    let i = 0;
    let startPos;
    let endPos;
    while(i >= 0 && i < text.length){
        if (/\S/.test(text[i])) {
            if (startPos === undefined) {
                startPos = i;
                i = text.length;
            } else {
                endPos = i;
                i = void 0;
            }
        }
        if (startPos === undefined) i++;
        else i--;
    }
    if (startPos === undefined) startPos = 0;
    if (endPos === undefined) endPos = text.length - 1;
    const hasLeadingSpace = startPos > 0 && /[^\S\r\n]/.test(text[startPos - 1]);
    const hasTrailingSpace = endPos < text.length - 1 && /[^\S\r\n]/.test(text[endPos + 1]);
    return (hasLeadingSpace ? ' ' : '') + text.slice(startPos, endPos + 1) + (hasTrailingSpace ? ' ' : '');
}

});

parcelRegister("8DdXR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hRZMB = parcelRequire("hRZMB");

Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $hRZMB.parse;
    }
});

});

parcelRegister("fTd1w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hRZMB = parcelRequire("hRZMB");

/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */ function $b9161840ffb13ca8$var$valid(data, options = {}) {
    const stack = (0, $hRZMB.base_parse)(data, options);
    return Boolean(stack.length === 1);
}
module.exports.default = $b9161840ffb13ca8$var$valid;

});

parcelRegister("JBlXx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dwp40 = parcelRequire("dwp40");

async function $942404ecc89e44eb$var$fetchRestResponse({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
const $942404ecc89e44eb$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $942404ecc89e44eb$export$ce7efc011dbfc5b9 = ({ urls: urls })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [objectResolverData, setObjectResolverData] = (0, $42omo.useState)([]);
    const urlKeys = (0, $42omo.useMemo)(()=>urls.join('|'), [
        urls
    ]);
    (0, $42omo.useEffect)(()=>{
        const fetchObjectResolver = async ()=>{
            if (!urls.length) {
                setIsLoading(false);
                return;
            }
            try {
                setIsLoading(true);
                const objectResolver = await $942404ecc89e44eb$var$fetchRestResponse({
                    url: $942404ecc89e44eb$var$OBJECT_RESOLVER_ENDPOINT,
                    body: urls.map((url)=>({
                            resourceUrl: url
                        }))
                });
                if (!objectResolver) {
                    setIsLoading(false);
                    return;
                }
                const objectData = objectResolver.filter((obj)=>obj.status === 200);
                setObjectResolverData(objectData.map((objData)=>objData.body.data));
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
            }
        };
        fetchObjectResolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        urlKeys
    ]);
    return {
        isLoading: isLoading,
        objectResolverData: objectResolverData
    };
};
module.exports["useFetchSmartLinkData"] = $942404ecc89e44eb$export$ce7efc011dbfc5b9;

});

parcelRegister("dN2lk", function(module, exports) {
/* icon-stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $43e437b97106950f$var$styles = {
    list: "_1e0c1txw _19121cl4 _6rthze3t _1pfhze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
    item: "_6rthze3t _1pfhze3t _ahbqze3t"
};
const $43e437b97106950f$var$unboundStyles = {
    list: "_2mzuglyw _12l2t94y",
    item: "_2rko12b0 _bfhkvuon _16qsz8ju _1e0c116y _12l21n1a"
};
const $43e437b97106950f$var$DEFAULT_MAX_STACK_SIZE = 3;
function $43e437b97106950f$export$1483abeb36a40e41({ children: children, maxStackSize: maxStackSize, testId: testId }) {
    maxStackSize = maxStackSize ?? $43e437b97106950f$var$DEFAULT_MAX_STACK_SIZE;
    return /*#__PURE__*/ (0, $l998X.jsx)("ul", {
        "aria-hidden": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $43e437b97106950f$var$styles.list,
            $43e437b97106950f$var$unboundStyles.list
        ]),
        children: (0, $42omo.Children).map(children, (child, index)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                style: {
                    zIndex: maxStackSize - index
                },
                className: (0, $gMc0m.default)([
                    $43e437b97106950f$var$styles.item,
                    $43e437b97106950f$var$unboundStyles.item
                ]),
                children: child
            }))
    });
}
module.exports["IconStack"] = $43e437b97106950f$export$1483abeb36a40e41;

});

parcelRegister("bXlEj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jSpMW = parcelRequire("jSpMW");

var $03cc297dc81fea05$exports = {};
$03cc297dc81fea05$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":29.9700012207031,\"ip\":0,\"op\":95.0000038694293,\"w\":1920,\"h\":1080,\"nm\":\"Comp 1\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Shape Layer 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[502.345,0,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.4,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":2,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":50.479,\"s\":[1486.1,615.223],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":63,\"s\":[1486.1,400],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":72.74,\"s\":[1486.1,575.917],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":79,\"s\":[1486.1,528.917],\"to\":[0,0],\"ti\":[0,0]},{\"t\":82.0000033399285,\"s\":[1486.1,615.223]}],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0.594,0.384,0.713,0.461,0.777,0.645,0.66,1,0.961,0.906,0.607],\"ix\":9}},\"s\":{\"a\":0,\"k\":[1244.484,582.344],\"ix\":5},\"e\":{\"a\":0,\"k\":[1727.031,624.016],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"Shape Layer 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":20.479,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0.076},\"t\":21,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":33,\"s\":[1486.1,400,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":42.74,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":49,\"s\":[1486.1,528.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":52.0000021180034,\"s\":[1486.1,615.223,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.7,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.749019607843,0.388235294118,0.952941176471,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Shape Layer 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[2454.1,1191.14,0],\"ix\":2,\"l\":2},\"a\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":1,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":8,\"s\":[1486.1,784.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":15,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":21.441,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":24.00000097754,\"s\":[1486.1,575.917,0]}],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":46.3,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":50,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0,0.396,1,0.724,0.182,0.396,1,1,0.364,0.396,1],\"ix\":9}},\"s\":{\"a\":0,\"k\":[0,0],\"ix\":5},\"e\":{\"a\":0,\"k\":[100,0],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $04174aaad1427a0e$var$loadingAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: (0, (/*@__PURE__*/$parcel$interopDefault($03cc297dc81fea05$exports))),
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};
const $04174aaad1427a0e$var$loadingAnimationStyles = null;
const $04174aaad1427a0e$var$jiraOverrideStyles = null;
const $04174aaad1427a0e$export$1110722318fbbc6b = ({ onAnimationShown: onAnimationShown, source: source })=>{
    (0, $42omo.useEffect)(()=>{
        onAnimationShown?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSpMW)) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored because an external consumer needs to override the style with styled component. https://atlassian.slack.com/archives/C06K9T53N66/p1745962052140289?thread_ts=1745868665.350719&cid=C06K9T53N66
    ), {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154inicn _1ltv1q9q _1bsb12am _4t3i7vkz _t9ec2k2r",
            source === 'jira-highlight-actions' && "_154id439 _1ltv1vh9",
            "dot-animation-loader"
        ]),
        ...$04174aaad1427a0e$var$loadingAnimationOptions
    });
};
module.exports["DotAnimationLoader"] = $04174aaad1427a0e$export$1110722318fbbc6b;

});

parcelRegister("4dwEP", function(module, exports) {
"use strict";
var $3121b56ddf679195$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeType = module.exports.TextNode = module.exports.Node = module.exports.valid = module.exports.CommentNode = module.exports.HTMLElement = module.exports.parse = void 0;

const $3121b56ddf679195$var$comment_1 = $3121b56ddf679195$var$__importDefault((parcelRequire("asvGx")));
module.exports.CommentNode = $3121b56ddf679195$var$comment_1.default;

const $3121b56ddf679195$var$html_1 = $3121b56ddf679195$var$__importDefault((parcelRequire("hRZMB")));
module.exports.HTMLElement = $3121b56ddf679195$var$html_1.default;

const $3121b56ddf679195$var$node_1 = $3121b56ddf679195$var$__importDefault((parcelRequire("1vK45")));
module.exports.Node = $3121b56ddf679195$var$node_1.default;

const $3121b56ddf679195$var$text_1 = $3121b56ddf679195$var$__importDefault((parcelRequire("a5onE")));
module.exports.TextNode = $3121b56ddf679195$var$text_1.default;

const $3121b56ddf679195$var$type_1 = $3121b56ddf679195$var$__importDefault((parcelRequire("luckw")));
module.exports.NodeType = $3121b56ddf679195$var$type_1.default;

const $3121b56ddf679195$var$parse_1 = $3121b56ddf679195$var$__importDefault((parcelRequire("8DdXR")));

const $3121b56ddf679195$var$valid_1 = $3121b56ddf679195$var$__importDefault((parcelRequire("fTd1w")));
module.exports.valid = $3121b56ddf679195$var$valid_1.default;
function $3121b56ddf679195$var$parse(data, options = {}) {
    return (0, $3121b56ddf679195$var$parse_1.default)(data, options);
}
module.exports.default = $3121b56ddf679195$var$parse;
module.exports.parse = $3121b56ddf679195$var$parse;
$3121b56ddf679195$var$parse.parse = $3121b56ddf679195$var$parse_1.default;
$3121b56ddf679195$var$parse.HTMLElement = $3121b56ddf679195$var$html_1.default;
$3121b56ddf679195$var$parse.CommentNode = $3121b56ddf679195$var$comment_1.default;
$3121b56ddf679195$var$parse.valid = $3121b56ddf679195$var$valid_1.default;
$3121b56ddf679195$var$parse.Node = $3121b56ddf679195$var$node_1.default;
$3121b56ddf679195$var$parse.TextNode = $3121b56ddf679195$var$text_1.default;
$3121b56ddf679195$var$parse.NodeType = $3121b56ddf679195$var$type_1.default;

});

parcelRegister("jTYav", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $2ISy2 = parcelRequire("2ISy2");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $dh538 = parcelRequire("dh538");


var $4A7Gn = parcelRequire("4A7Gn");


var $eRXI0 = parcelRequire("eRXI0");


var $f7lNm = parcelRequire("f7lNm");


var $hAecz = parcelRequire("hAecz");


var $gszZj = parcelRequire("gszZj");


var $2ISOG = parcelRequire("2ISOG");


var $5CTTZ = parcelRequire("5CTTZ");


var $9EPrq = parcelRequire("9EPrq");


var $jhjPA = parcelRequire("jhjPA");


var $lKT4y = parcelRequire("lKT4y");


var $jKslv = parcelRequire("jKslv");


var $dILBZ = parcelRequire("dILBZ");


var $lcPZc = parcelRequire("lcPZc");

const $38c3206170f8162a$var$ColoredBugIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: ""
    });
const $38c3206170f8162a$export$6e6fdd8d215e1d59 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { commonAttributes: commonAttributes, smartAnswersRoute: smartAnswersRoute } = (0, $eRXI0.useAIAnswerContext)();
    const [isSAINDebuggerModalOpen, setIsSAINDebuggerModalOpen] = (0, $42omo.useState)(false);
    const isNaturalLanguageQuery = smartAnswersRoute === (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
    const openDebuggerModal = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        setIsSAINDebuggerModalOpen(true);
    }, []);
    const closeDebuggerModal = (0, $42omo.useCallback)(()=>setIsSAINDebuggerModalOpen(false), []);
    const { extraAttributes: extraAttributes } = commonAttributes;
    const debuggerData = (0, $42omo.useMemo)(()=>(0, $lcPZc.normalizeDebuggerData)(extraAttributes), [
        extraAttributes
    ]);
    const showPluginsPanels = isNaturalLanguageQuery && !debuggerData.minions.hasMinionOutputs && debuggerData.pluginInvocations.hasPluginInvocations;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: $38c3206170f8162a$var$ColoredBugIcon,
                label: formatMessage((0, $hAecz.messages).ai_debugger_icon_label),
                onClick: openDebuggerModal,
                appearance: "subtle",
                isTooltipDisabled: false,
                spacing: "compact",
                testId: "sain-online-debugger-button",
                color: "var(--ds-icon-subtlest, #6B6E76)",
                shape: (0, $dh538.fg)('kd_sain_feedback_collector_ux_uplift_rollout') ? 'circle' : 'default'
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isSAINDebuggerModalOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
                    onClose: closeDebuggerModal,
                    width: "x-large",
                    testId: "sain-online-debugger-modal",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_title)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4A7Gn.default), {
                                id: "sain-online-debugger-tabs",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gszZj.DebuggerTabList), {
                                        isNaturalLanguageQuery: isNaturalLanguageQuery,
                                        hasMinionOutputs: debuggerData.minions.hasMinionOutputs,
                                        hasPluginInvocations: debuggerData.pluginInvocations.hasPluginInvocations,
                                        roundCount: debuggerData.minions.roundCount
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dILBZ.RequestOverviewPanel), {
                                        ...debuggerData.requestOverview,
                                        smartAnswersRoute: smartAnswersRoute,
                                        isNaturalLanguageQuery: isNaturalLanguageQuery
                                    }),
                                    showPluginsPanels && /*#__PURE__*/ (0, $l998X.jsx)((0, $jKslv.RawSearchResultsPanel), {
                                        searchResults: debuggerData.rawSearch.searchResults
                                    }),
                                    showPluginsPanels && /*#__PURE__*/ (0, $l998X.jsx)((0, $jhjPA.RankedSearchResultsPanel), {
                                        rankedDocumentsWithChunks: debuggerData.rankedSearch.rankedDocumentsWithChunks
                                    }),
                                    showPluginsPanels && /*#__PURE__*/ (0, $l998X.jsx)((0, $9EPrq.PluginInvocationsPanel), {
                                        nonSearchPluginInvocations: debuggerData.pluginInvocations.nonSearchPluginInvocations
                                    }),
                                    isNaturalLanguageQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $5CTTZ.OrchestrationOverviewPanel), {
                                        orchestrationRounds: debuggerData.minions.orchestrationRounds
                                    }),
                                    isNaturalLanguageQuery && debuggerData.minions.hasMinionOutputs && debuggerData.minions.orchestrationRounds.map((round, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2ISOG.LoopPanel), {
                                            round: round,
                                            roundIndex: index
                                        }, `loop-panel-${index}`)),
                                    isNaturalLanguageQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $lKT4y.RawJsonPanel), {
                                        rawJson: debuggerData.rawJson.rawJson
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                    ]
                })
            })
        ]
    });
};
module.exports["OnlineDebuggerButton"] = $38c3206170f8162a$export$6e6fdd8d215e1d59;

});

parcelRegister("hAecz", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $7cef8d30dc0c5cbc$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    ai_debugger_icon_label: {
        id: "search_ai.ai_debugger_icon_label",
        defaultMessage: "Debugger"
    },
    ai_debugger_modal_title: {
        id: "search_ai.ai_debugger_modal_title",
        defaultMessage: "SAIN Debugging Panel"
    },
    ai_debugger_modal_original_query_subheading: {
        id: "search_ai.ai_debugger_modal_original_query_subheading",
        defaultMessage: "Original Query"
    },
    ai_debugger_modal_transformed_query_subheading: {
        id: "search_ai.ai_debugger_modal_transformed_query_subheading",
        defaultMessage: "Transformed Query"
    },
    ai_debugger_modal_detected_intent_subheading: {
        id: "search_ai.ai_debugger_modal_detected_intent_subheading",
        defaultMessage: "Detected Intent"
    },
    ai_debugger_modal_trace_id_subheading: {
        id: "search_ai.ai_debugger_modal_trace_id_subheading",
        defaultMessage: "Trace ID"
    },
    ai_debugger_modal_model_subheading: {
        id: "search_ai.ai_debugger_modal_model_subheading",
        defaultMessage: "Answer Generation Model"
    },
    ai_debugger_modal_sources_subheading: {
        id: "search_ai.ai_debugger_modal_sources_subheading",
        defaultMessage: "Sources"
    },
    ai_debugger_modal_cached_answer_subheading: {
        id: "search_ai.ai_debugger_modal_cached_answer_subheading",
        defaultMessage: "Cached answer"
    },
    ai_debugger_modal_copy_button_text: {
        id: "search_ai.ai_debugger_modal_copy_button_text",
        defaultMessage: "Copy JSON"
    },
    ai_debugger_modal_copy_button_copied_text: {
        id: "search_ai.ai_debugger_modal_copy_button_copied_text",
        defaultMessage: "JSON Copied"
    },
    ai_debugger_modal_tab_request_overview: {
        id: "search_ai.ai_debugger_modal_tab_request_overview",
        defaultMessage: "Request Overview"
    },
    ai_debugger_modal_tab_raw_search_results: {
        id: "search_ai.ai_debugger_modal_tab_raw_search_results",
        defaultMessage: "Raw Search Results"
    },
    ai_debugger_modal_tab_ranked_search_results: {
        id: "search_ai.ai_debugger_modal_tab_ranked_search_results",
        defaultMessage: "Ranked Search Results"
    },
    ai_debugger_modal_tab_plugin_invocations: {
        id: "search_ai.ai_debugger_modal_tab_plugin_invocations",
        defaultMessage: "Plugin Invocations"
    },
    ai_debugger_modal_tab_raw_json: {
        id: "search_ai.ai_debugger_modal_tab_raw_json",
        defaultMessage: "Raw JSON"
    },
    ai_debugger_modal_copy_trace_id_label: {
        id: "search_ai.ai_debugger_modal_copy_trace_id_label",
        defaultMessage: "Copy Trace ID"
    },
    ai_debugger_modal_trace_id_copied_text: {
        id: "search_ai.ai_debugger_modal_trace_id_copied_text",
        defaultMessage: "Trace ID copied"
    },
    ai_debugger_modal_expand_label: {
        id: "search_ai.ai_debugger_modal_expand_label",
        defaultMessage: "Expand"
    },
    ai_debugger_modal_collapse_label: {
        id: "search_ai.ai_debugger_modal_collapse_label",
        defaultMessage: "Collapse"
    },
    ai_debugger_modal_success_label: {
        id: "search_ai.ai_debugger_modal_success_label",
        defaultMessage: "Success"
    },
    ai_debugger_modal_failed_label: {
        id: "search_ai.ai_debugger_modal_failed_label",
        defaultMessage: "Failed"
    },
    ai_debugger_modal_search_results_heading: {
        id: "search_ai.ai_debugger_modal_search_results_heading",
        defaultMessage: "Search Results ({count})"
    },
    ai_debugger_modal_ranked_documents_heading: {
        id: "search_ai.ai_debugger_modal_ranked_documents_heading",
        defaultMessage: "Ranked Documents ({count})"
    },
    ai_debugger_modal_tab_orchestration_overview: {
        id: "search_ai.ai_debugger_modal_tab_orchestration_overview",
        defaultMessage: "Orchestration Overview"
    },
    ai_debugger_modal_tab_loop: {
        id: "search_ai.ai_debugger_modal_tab_loop",
        defaultMessage: "Loop {number}"
    },
    ai_debugger_modal_orchestration_loop_heading: {
        id: "search_ai.ai_debugger_modal_orchestration_loop_heading",
        defaultMessage: "Loop {number}"
    },
    ai_debugger_modal_orchestration_loop_with_count: {
        id: "search_ai.ai_debugger_modal_orchestration_loop_with_count",
        defaultMessage: "Loop {number} - {count} {count, plural, one {minion} other {minions}}"
    },
    ai_debugger_modal_orchestration_minions_count: {
        id: "search_ai.ai_debugger_modal_orchestration_minions_count",
        defaultMessage: "{count} {count, plural, one {minion} other {minions}}"
    },
    ai_debugger_modal_no_orchestration_data: {
        id: "search_ai.ai_debugger_modal_no_orchestration_data",
        defaultMessage: "No minion outputs to show."
    },
    ai_debugger_modal_minion_input_label: {
        id: "search_ai.ai_debugger_modal_minion_input_label",
        defaultMessage: "Input"
    },
    ai_debugger_modal_minion_output_label: {
        id: "search_ai.ai_debugger_modal_minion_output_label",
        defaultMessage: "Output"
    },
    ai_debugger_modal_execution_duration: {
        id: "search_ai.ai_debugger_modal_execution_duration",
        defaultMessage: "{duration}ms"
    },
    ai_debugger_modal_execution_duration_label: {
        id: "search_ai.ai_debugger_modal_execution_duration_label",
        defaultMessage: "Duration"
    },
    ai_debugger_modal_minion_name_label: {
        id: "search_ai.ai_debugger_modal_minion_name_label",
        defaultMessage: "Minion Name"
    },
    ai_debugger_modal_disabled: {
        id: "search_ai.ai_debugger_modal_disabled",
        defaultMessage: "disabled"
    },
    ai_debugger_modal_minion_extra_info_label: {
        id: "search_ai.ai_debugger_modal_plugin_output_label",
        defaultMessage: "Extra Info"
    },
    ai_debugger_modal_no_plugins_invoked: {
        id: "search_ai.ai_debugger_modal_no_plugins_invoked",
        defaultMessage: "No additional plugins invoked."
    },
    ai_debugger_modal_teamwork_unnamed_team: {
        id: "search_ai.ai_debugger_modal_teamwork_unnamed_team",
        defaultMessage: "Unnamed Team"
    },
    ai_debugger_modal_teamwork_members_count: {
        id: "search_ai.ai_debugger_modal_teamwork_members_count",
        defaultMessage: "Members: {count}"
    },
    ai_debugger_modal_teamwork_state: {
        id: "search_ai.ai_debugger_modal_teamwork_state",
        defaultMessage: "State: {state}"
    },
    ai_debugger_modal_teamwork_creator: {
        id: "search_ai.ai_debugger_modal_teamwork_creator",
        defaultMessage: "Creator: {creator}"
    },
    ai_debugger_modal_teamwork_show_count: {
        id: "search_ai.ai_debugger_modal_teamwork_show_count",
        defaultMessage: "Show {count} {count, plural, one {member} other {members}}"
    },
    ai_debugger_modal_teamwork_hide_count: {
        id: "search_ai.ai_debugger_modal_teamwork_hide_count",
        defaultMessage: "Hide {count} {count, plural, one {member} other {members}}"
    },
    ai_debugger_modal_author_label: {
        id: "search_ai.ai_debugger_modal_author_label",
        defaultMessage: "Author: {author}"
    },
    ai_debugger_modal_teamwork_document_updated: {
        id: "search_ai.ai_debugger_modal_teamwork_document_updated",
        defaultMessage: "Updated: {date}"
    },
    ai_debugger_modal_page_search_space: {
        id: "search_ai.ai_debugger_modal_page_search_space",
        defaultMessage: "Space: {space}"
    },
    ai_debugger_modal_page_search_count: {
        id: "search_ai.ai_debugger_modal_page_search_count",
        defaultMessage: "{count} {count, plural, one {page} other {pages}} found"
    },
    ai_debugger_modal_function_results_count: {
        id: "search_ai.ai_debugger_modal_function_results_count",
        defaultMessage: "Function Results ({count})"
    },
    ai_debugger_modal_raw_search_results_heading: {
        id: "search_ai.ai_debugger_modal_raw_search_results_heading",
        defaultMessage: "{count, plural, one {Raw Search Result ({count})} other {Raw Search Results ({count})}}"
    },
    ai_debugger_modal_table_url_header: {
        id: "search_ai.ai_debugger_modal_table_url_header",
        defaultMessage: "Document URL"
    },
    ai_debugger_modal_table_doc_index_header: {
        id: "search_ai.ai_debugger_modal_table_doc_index_header",
        defaultMessage: "#"
    },
    ai_debugger_modal_no_raw_search_results: {
        id: "search_ai.ai_debugger_modal_no_raw_search_results",
        defaultMessage: "No raw search results available."
    },
    ai_debugger_modal_ranked_search_results_heading: {
        id: "search_ai.ai_debugger_modal_ranked_search_results_heading",
        defaultMessage: "{count, plural, one {Ranked Document with Chunks ({count})} other {Ranked Documents with Chunks ({count})}}"
    },
    ai_debugger_modal_table_chunk_id_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_id_header",
        defaultMessage: "Chunk ID"
    },
    ai_debugger_modal_table_chunk_score_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_score_header",
        defaultMessage: "Score"
    },
    ai_debugger_modal_table_chunk_rank_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_rank_header",
        defaultMessage: "Rank"
    },
    ai_debugger_modal_no_ranked_search_results: {
        id: "search_ai.ai_debugger_modal_no_ranked_search_results",
        defaultMessage: "No ranked search results available."
    },
    ai_debugger_modal_unable_to_match_chunks: {
        id: "search_ai.ai_debugger_modal_unable_to_match_chunks",
        defaultMessage: "Unable to match chunks"
    },
    ai_debugger_modal_plugins_invoked_subheading: {
        id: "search_ai.ai_debugger_modal_plugins_invoked_subheading",
        defaultMessage: "Plugins Invoked"
    },
    prompt_override_button_label: {
        id: "search_ai.prompt_override_button_label",
        defaultMessage: "Prompt override"
    },
    prompt_override_modal_title: {
        id: "search_ai.prompt_override_modal_title",
        defaultMessage: "Custom System Prompt Override"
    },
    prompt_override_custom_prompt_label: {
        id: "search_ai.prompt_override_custom_prompt_label",
        defaultMessage: "Custom Prompt:"
    },
    prompt_override_textarea_placeholder: {
        id: "search_ai.prompt_override_textarea_placeholder",
        defaultMessage: "Enter your custom system prompt here..."
    },
    prompt_override_help_text: {
        id: "search_ai.prompt_override_help_text",
        defaultMessage: "This prompt will override the default system prompt for AI requests during this session."
    },
    prompt_override_cancel_button: {
        id: "search_ai.prompt_override_cancel_button",
        defaultMessage: "Cancel"
    },
    prompt_override_save_button: {
        id: "search_ai.prompt_override_save_button",
        defaultMessage: "Save"
    }
});
module.exports["messages"] = $7cef8d30dc0c5cbc$export$defe85febe8b728c;

});

parcelRegister("lqjTE", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $2b6cd569ab8ae716$export$f3f282f819d3a3cc = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "3",
                cy: "14",
                r: "1",
                fill: '#1F69DA',
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;1;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "7",
                cy: "14",
                r: "1",
                fill: '#C16CD4',
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11",
                cy: "14",
                r: "1",
                fill: '#F5A117',
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;0;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            })
        ]
    });
};
const $2b6cd569ab8ae716$export$62d54f79d0abe5c8 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "3",
                cy: "14",
                r: "1",
                fill: '#1F69DA'
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "7",
                cy: "14",
                r: "1",
                fill: '#C16CD4'
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11",
                cy: "14",
                r: "1",
                fill: '#F5A117'
            })
        ]
    });
};
module.exports["RovoGeneratingAnimation"] = $2b6cd569ab8ae716$export$f3f282f819d3a3cc;
module.exports["ReducedMotionRovoGeneratingAnimation"] = $2b6cd569ab8ae716$export$62d54f79d0abe5c8;

});

parcelRegister("8AwZ3", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $07cde24ec19968df$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    smart_answer_card_generating: {
        id: "search_ai.smart_answer_card_generating",
        defaultMessage: "Generating"
    },
    smart_answer_card_title: {
        id: "search_ai.smart_answer_card.title",
        defaultMessage: "Answer"
    },
    smart_answer_card_dynamic_layout_title: {
        id: "search_ai.smart_answer_card_dynamic_layout_title",
        defaultMessage: "Overview"
    },
    smart_answer_card_rovo_generating: {
        id: "search_ai.smart_answer_card_rovo_generating",
        defaultMessage: "Rovo is {queryReasoning}"
    },
    smart_answer_card_rovo_is_thinking: {
        id: "search_ai.smart_answer_card_rovo_is_thinking",
        defaultMessage: "Rovo is thinking"
    }
});
module.exports["messages"] = $07cde24ec19968df$export$defe85febe8b728c;

});

parcelRegister("iew5c", function(module, exports) {
module.exports = new URL("Rovo.e24f6f93.svg", import.meta.url).toString();

});

parcelRegister("gUXWz", function(module, exports) {
/* knowledge-cards-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $81TN7 = parcelRequire("81TN7");


var $ckCUa = parcelRequire("ckCUa");


var $d19et = parcelRequire("d19et");

const $b374fd03230d789b$var$i18n = (0, $cgtv4.defineMessages)({
    knowledgeRowTypeWork: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.work",
        defaultMessage: "Work Item"
    },
    knowledgeRowTypeAgent: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.agent",
        defaultMessage: "Agent"
    },
    knowledgeRowTypePerson: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.person",
        defaultMessage: "Person"
    }
});
const $b374fd03230d789b$var$styles = {
    root: "_2rko12b0 _12l2u2gc _irr319i6 _d0altlke"
};
const $b374fd03230d789b$export$96be17c41f7933d9 = ({ primaryText: primaryText, secondaryText: secondaryText, pictureUrl: pictureUrl, type: type, triggerProps: triggerProps, onClick: onClick, contentTypeName: contentTypeName })=>{
    const intl = (0, $8C5kA.default)();
    const altText = contentTypeName ? (0, $d19et.formatContentTypeName)(contentTypeName) : type === (0, $ckCUa.KnowledgeCardsRowType).PERSON ? intl.formatMessage($b374fd03230d789b$var$i18n.knowledgeRowTypePerson) : intl.formatMessage($b374fd03230d789b$var$i18n.knowledgeRowTypeWork);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b374fd03230d789b$var$styles.root,
        paddingInline: "space.200",
        paddingBlock: "space.100",
        ...triggerProps,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                type === (0, $ckCUa.KnowledgeCardsRowType).PERSON ? /*#__PURE__*/ (0, $l998X.jsx)((0, $81TN7.PersonStyles), {
                    src: pictureUrl,
                    alt: altText
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $81TN7.WorkStyles), {
                    src: pictureUrl,
                    alt: altText
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            maxLines: 1,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "xxsmall",
                                children: primaryText
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            maxLines: 1,
                            children: secondaryText
                        })
                    ]
                })
            ]
        })
    });
};
const $b374fd03230d789b$export$465f421106844c87 = ({ primaryText: primaryText, secondaryText: secondaryText, pictureUrl: pictureUrl, type: type, triggerProps: triggerProps, onClick: onClick, contentTypeName: contentTypeName })=>{
    const intl = (0, $8C5kA.default)();
    const altText = contentTypeName ? (0, $d19et.formatContentTypeName)(contentTypeName) : type === (0, $ckCUa.KnowledgeCardsRowType).WORK ? intl.formatMessage($b374fd03230d789b$var$i18n.knowledgeRowTypeWork) : type === (0, $ckCUa.KnowledgeCardsRowType).AGENT ? intl.formatMessage($b374fd03230d789b$var$i18n.knowledgeRowTypeAgent) : intl.formatMessage($b374fd03230d789b$var$i18n.knowledgeRowTypePerson);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b374fd03230d789b$var$styles.root,
        paddingInline: "space.200",
        paddingBlock: "space.075",
        ...triggerProps,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                type === (0, $ckCUa.KnowledgeCardsRowType).WORK ? /*#__PURE__*/ (0, $l998X.jsx)((0, $81TN7.WorkStyles), {
                    src: pictureUrl,
                    alt: altText
                }) : type === (0, $ckCUa.KnowledgeCardsRowType).AGENT ? /*#__PURE__*/ (0, $l998X.jsx)((0, $81TN7.AgentStyles), {
                    src: pictureUrl,
                    alt: altText
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $81TN7.PersonStyles), {
                    src: pictureUrl,
                    alt: altText
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            maxLines: 1,
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            maxLines: 1,
                            children: secondaryText
                        })
                    ]
                })
            ]
        })
    });
};
module.exports["KnowledgeCardsRow"] = $b374fd03230d789b$export$96be17c41f7933d9;
module.exports["KnowledgeCardsRowRefresh"] = $b374fd03230d789b$export$465f421106844c87;

});

parcelRegister("8HDcK", function(module, exports) {
/* knowledge-smart-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $7p4As = parcelRequire("7p4As");


var $lE8sM = parcelRequire("lE8sM");


var $buthI = parcelRequire("buthI");


var $8tdj3 = parcelRequire("8tdj3");


var $gj7hi = parcelRequire("gj7hi");


var $2Nwuj = parcelRequire("2Nwuj");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $5TXU5 = parcelRequire("5TXU5");

var $hpUsb = parcelRequire("hpUsb");

var $8NpDA = parcelRequire("8NpDA");

var $1lLfV = parcelRequire("1lLfV");

var $8zS2j = parcelRequire("8zS2j");

var $5znEc = parcelRequire("5znEc");


var $9CM6e = parcelRequire("9CM6e");


var $i7jPX = parcelRequire("i7jPX");


var $lytr3 = parcelRequire("lytr3");


var $bSZ63 = parcelRequire("bSZ63");

const $1635da8f2a597759$var$messages = (0, $cgtv4.defineMessages)({
    navigate_button: {
        id: "search_ai.action_card_navigate_button",
        defaultMessage: "Navigate"
    }
});
const $1635da8f2a597759$var$unboundStyles = {
    compactContainer: "_2rko1mok _19pkidpf _2hwx1wug _otyridpf _18u01wug _4bfu1r31 _1hmsglyw _ajmmnqa1 _1h6d1l7x _1dqonqa1 _189ee4h9 _bfhksm61 _80omtlke _1e0c1txw _4cvr1h6o _1bsb1osq _p12f1gwv _1tket9kd _5pue1osq _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _d0altlke",
    actionCardContainer: "_2rko1mok _4bfu1r31 _1hmsglyw _ajmmnqa1 _1h6d1l7x _1dqonqa1 _189ee4h9 _bfhksm61 _1e0c1txw _4cvr1h6o _p12f1gwv _1bsb1osq _ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi",
    actionCardButton: "_y3gnusic",
    fallbackContainer: "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi",
    embeddedCardContainer: "_1bsb1osq _umhnidpf _9xfsidpf _4d6gidpf _6tqjidpf _hmmtj0fz _1kbq1mok _172kusvi _9pbr1r31 _yeu2glyw _xne81o36 _ybkb1osq",
    richSourceCardContainer: "_1bsb1osq _12uwidpf _1ftqidpf _7wrtidpf _1gonidpf _1vzo1mok _jce3usvi _ybkb1osq _1chl1wug",
    titleBlockCss: "_zulpu2gc _13mh1pd9 _2yhz13af",
    compactTitleBlockCss: "_1hgg1qyo _137lv77o",
    footerBlockCss: "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb"
};
function $1635da8f2a597759$var$constructSourceUrl({ source: source, searchSessionId: searchSessionId }) {
    if (source.product === 'Confluence' && !!searchSessionId) {
        const url = new URL(source.url);
        url.searchParams.append('search_id', searchSessionId);
        return url.toString();
    }
    return source.url;
}
var $1635da8f2a597759$export$c32f46c9d34bc809 = /*#__PURE__*/ function(CardVariant) {
    CardVariant["COMPACT"] = "COMPACT";
    CardVariant["FULL"] = "FULL";
    CardVariant["DROPDOWN_SOURCE"] = "DROPDOWN_SOURCE";
    CardVariant["ACTION_CARD"] = "ACTION_CARD";
    return CardVariant;
}({});
const $1635da8f2a597759$var$createCardClickHandler = (source, index, searchSessionId, onClickHandler, sourceCardType)=>(e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $bSZ63.extractUrlHostname)(source.url),
            sourceCardType: sourceCardType
        });
        e.preventDefault();
        window.open($1635da8f2a597759$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
function $1635da8f2a597759$var$SimpleFallbackCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const handleClick = (e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $bSZ63.extractUrlHostname)(source.url),
            sourceCardType: 'compact'
        });
        e.preventDefault();
        window.open($1635da8f2a597759$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: source.url,
        xcss: $1635da8f2a597759$var$unboundStyles.compactContainer,
        onClick: handleClick,
        testId: "knowledge-smart-card-fallback",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $1635da8f2a597759$var$unboundStyles.fallbackContainer,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        weight: "bold",
                        maxLines: 1,
                        children: source.title || source.url
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            source.iconUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
                                isInset: false,
                                label: "",
                                size: "xxsmall",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                    src: source.iconUrl,
                                    alt: source.product || ''
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                maxLines: 1,
                                children: source.product || ''
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $1635da8f2a597759$var$ActionCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $1635da8f2a597759$var$unboundStyles.actionCardContainer,
        testId: "knowledge-smart-card-action-card",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.150",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                            label: "",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
                            appearance: "gray",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.025",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "bold",
                                    size: "medium",
                                    maxLines: 1,
                                    children: source.title
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: source.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        appearance: "subtle",
                                        children: source.url
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $1635da8f2a597759$var$unboundStyles.actionCardButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                        href: source.url,
                        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                        onClick: $1635da8f2a597759$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'action-card'),
                        children: formatMessage($1635da8f2a597759$var$messages.navigate_button)
                    })
                })
            ]
        })
    });
}
function $1635da8f2a597759$var$CompactKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler, onError: onError }) {
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    if (hasError) return /*#__PURE__*/ (0, $l998X.jsx)($1635da8f2a597759$var$SimpleFallbackCard, {
        source: source,
        index: index,
        searchSessionId: searchSessionId,
        onClickHandler: onClickHandler
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $1635da8f2a597759$var$unboundStyles.compactContainer,
        testId: "knowledge-smart-card-compact",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            appearance: "block",
            url: source.url,
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: true,
                hideBackground: true,
                hideElevation: true,
                size: (0, $5TXU5.SmartLinkSize).Medium,
                removeBlockRestriction: true
            },
            onClick: $1635da8f2a597759$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'compact'),
            onError: (err)=>{
                setHasError(true);
                onError?.(err);
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                maxLines: 1,
                size: (0, $5TXU5.SmartLinkSize).Small,
                subtitle: [
                    {
                        name: (0, $5TXU5.ElementName).Provider
                    }
                ],
                position: (0, $5TXU5.SmartLinkPosition).Center,
                hideIcon: true,
                className: (0, $gMc0m.default)([
                    $1635da8f2a597759$var$unboundStyles.compactTitleBlockCss
                ])
            })
        })
    });
}
function $1635da8f2a597759$var$StandardKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler, onError: onError }) {
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const footerActions = (0, $42omo.useMemo)(()=>[
            {
                name: (0, $5TXU5.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const topMetadata = [
        {
            name: (0, $5TXU5.ElementName).AuthorGroup
        },
        {
            name: (0, $5TXU5.ElementName).AssignedTo
        },
        {
            name: (0, $5TXU5.ElementName).CreatedBy
        },
        {
            name: (0, $5TXU5.ElementName).ModifiedOn
        }
    ];
    const titleMetadata = [
        {
            name: (0, $5TXU5.ElementName).State
        }
    ];
    if (hasError) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $1635da8f2a597759$var$unboundStyles.richSourceCardContainer,
        testId: "knowledge-smart-card-standard-error",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
            appearance: "block",
            url: source.url,
            ui: {
                removeBlockRestriction: true
            },
            onClick: $1635da8f2a597759$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'rich-flexible')
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $1635da8f2a597759$var$unboundStyles.richSourceCardContainer,
        testId: "knowledge-smart-card-standard",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hpUsb.Card), {
            appearance: "block",
            url: source.url,
            ui: {
                removeBlockRestriction: true
            },
            onClick: $1635da8f2a597759$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'rich-flexible'),
            onError: (err)=>{
                setHasError(true);
                onError?.(err);
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                    maxLines: 1,
                    metadata: titleMetadata,
                    className: (0, $gMc0m.default)([
                        $1635da8f2a597759$var$unboundStyles.titleBlockCss
                    ])
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1lLfV.default), {
                    primary: topMetadata,
                    maxLines: 1
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8NpDA.default), {
                    actions: footerActions,
                    className: (0, $gMc0m.default)([
                        $1635da8f2a597759$var$unboundStyles.footerBlockCss
                    ])
                })
            ]
        })
    });
}
function $1635da8f2a597759$var$EmbeddedKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler, onError: onError }) {
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    if (hasError) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $1635da8f2a597759$var$unboundStyles.embeddedCardContainer,
        testId: "knowledge-smart-card-embedded-error",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
            appearance: "block",
            url: source.url,
            ui: {
                removeBlockRestriction: true
            },
            onClick: $1635da8f2a597759$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'embedded')
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $1635da8f2a597759$var$unboundStyles.embeddedCardContainer,
        testId: "knowledge-smart-card-embedded",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
            appearance: "embed",
            inheritDimensions: true,
            frameStyle: "show",
            url: source.url,
            onClick: $1635da8f2a597759$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'embedded'),
            onError: (err)=>{
                setHasError(true);
                onError?.(err);
            }
        })
    });
}
function $1635da8f2a597759$var$DropdownSourceSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler, onError: onError }) {
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hpUsb.Card), {
        appearance: "block",
        ui: {
            theme: (0, $5TXU5.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $5TXU5.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        url: source.url,
        onClick: $1635da8f2a597759$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'dropdown-source'),
        onError: onError || (()=>{}),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                maxLines: 1,
                size: (0, $5TXU5.SmartLinkSize).Medium
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                maxLines: 2
            })
        ]
    });
}
const $1635da8f2a597759$export$dfe41ae7345cd34b = ({ source: source, variant: variant, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler, onError: onError })=>{
    // Apply defaults for internal components
    const internalProps = {
        onError: onError || (()=>{}),
        source: source,
        index: index || 0,
        searchSessionId: searchSessionId || '',
        onClickHandler: onClickHandler || (()=>{})
    };
    if (variant === "COMPACT") return /*#__PURE__*/ (0, $l998X.jsx)($1635da8f2a597759$var$CompactKnowledgeSmartCard, {
        ...internalProps
    });
    if (variant === "DROPDOWN_SOURCE") return /*#__PURE__*/ (0, $l998X.jsx)($1635da8f2a597759$var$DropdownSourceSmartCard, {
        ...internalProps
    });
    if (variant === "ACTION_CARD") return /*#__PURE__*/ (0, $l998X.jsx)($1635da8f2a597759$var$ActionCard, {
        ...internalProps
    });
    const shouldUseEmbedded = source.product && source.product in (0, $lytr3.EMBEDDED_SOURCE_PRODUCTS);
    if (shouldUseEmbedded) return /*#__PURE__*/ (0, $l998X.jsx)($1635da8f2a597759$var$EmbeddedKnowledgeSmartCard, {
        ...internalProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($1635da8f2a597759$var$StandardKnowledgeSmartCard, {
        ...internalProps
    });
};
module.exports["CardVariant"] = $1635da8f2a597759$export$c32f46c9d34bc809;
module.exports["KnowledgeSmartCard"] = $1635da8f2a597759$export$dfe41ae7345cd34b;

});

parcelRegister("4pbUi", function(module, exports) {
"use strict";
var $3352bbaf838ce317$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3352bbaf838ce317$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3352bbaf838ce317$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3352bbaf838ce317$var$__createBinding(result, mod, k);
    }
    $3352bbaf838ce317$var$__setModuleDefault(result, mod);
    return result;
};
var $3352bbaf838ce317$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aliases = module.exports.pseudos = module.exports.filters = module.exports.is = module.exports.selectOne = module.exports.selectAll = module.exports.prepareContext = module.exports._compileToken = module.exports._compileUnsafe = module.exports.compile = void 0;

var $3352bbaf838ce317$var$DomUtils = $3352bbaf838ce317$var$__importStar((parcelRequire("81Stn")));

var $3352bbaf838ce317$var$boolbase_1 = $3352bbaf838ce317$var$__importDefault((parcelRequire("7Rnqo")));

var $bRsJn = parcelRequire("bRsJn");


var $ekA3e = parcelRequire("ekA3e");

var $3352bbaf838ce317$var$defaultEquals = function(a, b) {
    return a === b;
};
var $3352bbaf838ce317$var$defaultOptions = {
    adapter: $3352bbaf838ce317$var$DomUtils,
    equals: $3352bbaf838ce317$var$defaultEquals
};
function $3352bbaf838ce317$var$convertOptionFormats(options) {
    var _a, _b, _c, _d;
    /*
     * We force one format of options to the other one.
     */ // @ts-expect-error Default options may have incompatible `Node` / `ElementNode`.
    var opts = options !== null && options !== void 0 ? options : $3352bbaf838ce317$var$defaultOptions;
    // @ts-expect-error Same as above.
    (_a = opts.adapter) !== null && _a !== void 0 ? _a : opts.adapter = $3352bbaf838ce317$var$DomUtils;
    // @ts-expect-error `equals` does not exist on `Options`
    (_b = opts.equals) !== null && _b !== void 0 ? _b : opts.equals = (_d = (_c = opts.adapter) === null || _c === void 0 ? void 0 : _c.equals) !== null && _d !== void 0 ? _d : $3352bbaf838ce317$var$defaultEquals;
    return opts;
}
function $3352bbaf838ce317$var$wrapCompile(func) {
    return function addAdapter(selector, options, context) {
        var opts = $3352bbaf838ce317$var$convertOptionFormats(options);
        return func(selector, opts, context);
    };
}
/**
 * Compiles the query, returns a function.
 */ module.exports.compile = $3352bbaf838ce317$var$wrapCompile($bRsJn.compile);
module.exports._compileUnsafe = $3352bbaf838ce317$var$wrapCompile($bRsJn.compileUnsafe);
module.exports._compileToken = $3352bbaf838ce317$var$wrapCompile($bRsJn.compileToken);
function $3352bbaf838ce317$var$getSelectorFunc(searchFunc) {
    return function select(query, elements, options) {
        var opts = $3352bbaf838ce317$var$convertOptionFormats(options);
        if (typeof query !== "function") query = (0, $bRsJn.compileUnsafe)(query, opts, elements);
        var filteredElements = $3352bbaf838ce317$var$prepareContext(elements, opts.adapter, query.shouldTestNextSiblings);
        return searchFunc(query, filteredElements, opts);
    };
}
function $3352bbaf838ce317$var$prepareContext(elems, adapter, shouldTestNextSiblings) {
    if (shouldTestNextSiblings === void 0) shouldTestNextSiblings = false;
    /*
     * Add siblings if the query requires them.
     * See https://github.com/fb55/css-select/pull/43#issuecomment-225414692
     */ if (shouldTestNextSiblings) elems = $3352bbaf838ce317$var$appendNextSiblings(elems, adapter);
    return Array.isArray(elems) ? adapter.removeSubsets(elems) : adapter.getChildren(elems);
}
module.exports.prepareContext = $3352bbaf838ce317$var$prepareContext;
function $3352bbaf838ce317$var$appendNextSiblings(elem, adapter) {
    // Order matters because jQuery seems to check the children before the siblings
    var elems = Array.isArray(elem) ? elem.slice(0) : [
        elem
    ];
    var elemsLength = elems.length;
    for(var i = 0; i < elemsLength; i++){
        var nextSiblings = (0, $ekA3e.getNextSiblings)(elems[i], adapter);
        elems.push.apply(elems, nextSiblings);
    }
    return elems;
}
/**
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elems Elements to query. If it is an element, its children will be queried..
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns All matching elements.
 *
 */ module.exports.selectAll = $3352bbaf838ce317$var$getSelectorFunc(function(query, elems, options) {
    return query === $3352bbaf838ce317$var$boolbase_1.default.falseFunc || !elems || elems.length === 0 ? [] : options.adapter.findAll(query, elems);
});
/**
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elems Elements to query. If it is an element, its children will be queried..
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns the first match, or null if there was no match.
 */ module.exports.selectOne = $3352bbaf838ce317$var$getSelectorFunc(function(query, elems, options) {
    return query === $3352bbaf838ce317$var$boolbase_1.default.falseFunc || !elems || elems.length === 0 ? null : options.adapter.findOne(query, elems);
});
/**
 * Tests whether or not an element is matched by query.
 *
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elem The element to test if it matches the query.
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns
 */ function $3352bbaf838ce317$var$is(elem, query, options) {
    var opts = $3352bbaf838ce317$var$convertOptionFormats(options);
    return (typeof query === "function" ? query : (0, $bRsJn.compile)(query, opts))(elem);
}
module.exports.is = $3352bbaf838ce317$var$is;
/**
 * Alias for selectAll(query, elems, options).
 * @see [compile] for supported selector queries.
 */ module.exports.default = module.exports.selectAll;

var $45FRP = parcelRequire("45FRP");

Object.defineProperty(module.exports, "filters", {
    enumerable: true,
    get: function() {
        return $45FRP.filters;
    }
});
Object.defineProperty(module.exports, "pseudos", {
    enumerable: true,
    get: function() {
        return $45FRP.pseudos;
    }
});
Object.defineProperty(module.exports, "aliases", {
    enumerable: true,
    get: function() {
        return $45FRP.aliases;
    }
});

});

parcelRegister("3jYfZ", function(module, exports) {
"use strict";
var $26b1e33b9992f4f8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $26b1e33b9992f4f8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $26b1e33b9992f4f8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomHandler = void 0;

var $6bRC8 = parcelRequire("6bRC8");



$26b1e33b9992f4f8$var$__exportStar((parcelRequire("3vfXm")), module.exports);
// Default options
var $26b1e33b9992f4f8$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $26b1e33b9992f4f8$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("3vfXm")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $26b1e33b9992f4f8$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $26b1e33b9992f4f8$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("3vfXm")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $6bRC8.ElementType.Tag : undefined;
        var element = new (parcelRequire("3vfXm")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $6bRC8.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            var node = new (parcelRequire("3vfXm")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $6bRC8.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("3vfXm")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("3vfXm")).Text("");
        var node = new (parcelRequire("3vfXm")).CDATA([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("3vfXm")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
module.exports.DomHandler = $26b1e33b9992f4f8$var$DomHandler;
module.exports.default = $26b1e33b9992f4f8$var$DomHandler;

});

parcelRegister("aEI1g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXMLStrict = module.exports.decodeHTML5Strict = module.exports.decodeHTML4Strict = module.exports.decodeHTML5 = module.exports.decodeHTML4 = module.exports.decodeHTMLAttribute = module.exports.decodeHTMLStrict = module.exports.decodeHTML = module.exports.decodeXML = module.exports.DecodingMode = module.exports.EntityDecoder = module.exports.encodeHTML5 = module.exports.encodeHTML4 = module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = module.exports.escapeText = module.exports.escapeAttribute = module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeXML = module.exports.encode = module.exports.decodeStrict = module.exports.decode = module.exports.EncodingMode = module.exports.EntityLevel = void 0;

var $dkUsN = parcelRequire("dkUsN");


var $lUNMs = parcelRequire("lUNMs");


var $Hny5k = parcelRequire("Hny5k");

/** The level of entities to support. */ var $7c1fc929e516d918$var$EntityLevel;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($7c1fc929e516d918$var$EntityLevel = module.exports.EntityLevel || (module.exports.EntityLevel = {}));
var $7c1fc929e516d918$var$EncodingMode;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($7c1fc929e516d918$var$EncodingMode = module.exports.EncodingMode || (module.exports.EncodingMode = {}));
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 */ function $7c1fc929e516d918$var$decode(data, options) {
    if (options === void 0) options = $7c1fc929e516d918$var$EntityLevel.XML;
    var level = typeof options === "number" ? options : options.level;
    if (level === $7c1fc929e516d918$var$EntityLevel.HTML) {
        var mode = typeof options === "object" ? options.mode : undefined;
        return (0, $dkUsN.decodeHTML)(data, mode);
    }
    return (0, $dkUsN.decodeXML)(data);
}
module.exports.decode = $7c1fc929e516d918$var$decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 * @deprecated Use `decode` with the `mode` set to `Strict`.
 */ function $7c1fc929e516d918$var$decodeStrict(data, options) {
    var _a;
    if (options === void 0) options = $7c1fc929e516d918$var$EntityLevel.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = $dkUsN.DecodingMode.Strict;
    return $7c1fc929e516d918$var$decode(data, opts);
}
module.exports.decodeStrict = $7c1fc929e516d918$var$decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param options Encoding options.
 */ function $7c1fc929e516d918$var$encode(data, options) {
    if (options === void 0) options = $7c1fc929e516d918$var$EntityLevel.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $7c1fc929e516d918$var$EncodingMode.UTF8) return (0, $Hny5k.escapeUTF8)(data);
    if (opts.mode === $7c1fc929e516d918$var$EncodingMode.Attribute) return (0, $Hny5k.escapeAttribute)(data);
    if (opts.mode === $7c1fc929e516d918$var$EncodingMode.Text) return (0, $Hny5k.escapeText)(data);
    if (opts.level === $7c1fc929e516d918$var$EntityLevel.HTML) {
        if (opts.mode === $7c1fc929e516d918$var$EncodingMode.ASCII) return (0, $lUNMs.encodeNonAsciiHTML)(data);
        return (0, $lUNMs.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $Hny5k.encodeXML)(data);
}
module.exports.encode = $7c1fc929e516d918$var$encode;



Object.defineProperty(module.exports, "encodeXML", {
    enumerable: true,
    get: function() {
        return $Hny5k.encodeXML;
    }
});
Object.defineProperty(module.exports, "escape", {
    enumerable: true,
    get: function() {
        return $Hny5k.escape;
    }
});
Object.defineProperty(module.exports, "escapeUTF8", {
    enumerable: true,
    get: function() {
        return $Hny5k.escapeUTF8;
    }
});
Object.defineProperty(module.exports, "escapeAttribute", {
    enumerable: true,
    get: function() {
        return $Hny5k.escapeAttribute;
    }
});
Object.defineProperty(module.exports, "escapeText", {
    enumerable: true,
    get: function() {
        return $Hny5k.escapeText;
    }
});



Object.defineProperty(module.exports, "encodeHTML", {
    enumerable: true,
    get: function() {
        return $lUNMs.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeNonAsciiHTML", {
    enumerable: true,
    get: function() {
        return $lUNMs.encodeNonAsciiHTML;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "encodeHTML4", {
    enumerable: true,
    get: function() {
        return $lUNMs.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeHTML5", {
    enumerable: true,
    get: function() {
        return $lUNMs.encodeHTML;
    }
});



Object.defineProperty(module.exports, "EntityDecoder", {
    enumerable: true,
    get: function() {
        return $dkUsN.EntityDecoder;
    }
});
Object.defineProperty(module.exports, "DecodingMode", {
    enumerable: true,
    get: function() {
        return $dkUsN.DecodingMode;
    }
});
Object.defineProperty(module.exports, "decodeXML", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeXML;
    }
});
Object.defineProperty(module.exports, "decodeHTML", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTMLStrict", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeHTMLAttribute", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeHTMLAttribute;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "decodeHTML4", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML5", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML4Strict", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeHTML5Strict", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeXMLStrict", {
    enumerable: true,
    get: function() {
        return $dkUsN.decodeXML;
    }
});

});

parcelRegister("tyrPM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attributeNames = module.exports.elementNames = void 0;
module.exports.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));
module.exports.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));

});

parcelRegister("gszZj", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $gCbPZ = parcelRequire("gCbPZ");

var $0DTaW = parcelRequire("0DTaW");


var $hAecz = parcelRequire("hAecz");

const $57c0aa1cdfee37c2$export$77c21587411d3943 = ({ isNaturalLanguageQuery: isNaturalLanguageQuery, hasMinionOutputs: hasMinionOutputs, hasPluginInvocations: hasPluginInvocations, roundCount: roundCount })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const showPluginsTabs = isNaturalLanguageQuery && !hasMinionOutputs && hasPluginInvocations;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_tab_request_overview)
            }),
            showPluginsTabs && /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_tab_raw_search_results)
            }),
            showPluginsTabs && /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_tab_ranked_search_results)
            }),
            showPluginsTabs && /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_tab_plugin_invocations)
            }),
            isNaturalLanguageQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_tab_orchestration_overview)
            }),
            isNaturalLanguageQuery && hasMinionOutputs && Array.from({
                length: roundCount
            }, (_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_tab_loop, {
                        number: index
                    })
                }, `loop-${index}`)),
            isNaturalLanguageQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_tab_raw_json)
            })
        ]
    });
};
module.exports["DebuggerTabList"] = $57c0aa1cdfee37c2$export$77c21587411d3943;

});

parcelRegister("2ISOG", function(module, exports) {
/* loop-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $d2kvf = parcelRequire("d2kvf");


var $14qs9 = parcelRequire("14qs9");


var $hAecz = parcelRequire("hAecz");


var $8a70H = parcelRequire("8a70H");


var $717Wk = parcelRequire("717Wk");


var $40Bg6 = parcelRequire("40Bg6");


var $lcPZc = parcelRequire("lcPZc");


var $b5vPf = parcelRequire("b5vPf");

const $282ccd0c2577234c$var$styles = {
    minionCard: "_2rko12b0 _1reo15vq _18m915vq _bfhksm61",
    pressable: "_ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi _80omtlke _1bsb1osq",
    expandedContent: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhki8nm _uwhke4h9 _15a5nqa1 _1i531l7x",
    borderedBox: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _bfhksm61",
    sectionPadding: "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi",
    codeBlock: "_2rko12b0 _1reo1wug _18m91wug _bfhk1j9a _ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp _o5721jtm _1nmz9jpi _c71luuw1",
    expandableHeader: "_ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _80omtlke _1bsb1osq",
    expandableContent: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _uwhke4h9 _15a5nqa1 _1i531l7x",
    searchResultsGrid: "_yv0ehkll",
    rankedDocsGrid: "_yv0e1weo",
    gridCell: "_ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp _1doce4h9 _1il9nqa1 _1o3i1l7x _1nmz9jpi",
    gridCellWithLeftBorder: "_t6vde4h9 _1p3lnqa1 _5wra1l7x",
    gridHeader: "_bfhki8nm"
};
const $282ccd0c2577234c$var$ExpandableSection = ({ title: title, children: children, defaultExpanded: defaultExpanded = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(defaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $282ccd0c2577234c$var$styles.borderedBox,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                onClick: ()=>setIsExpanded(!isExpanded),
                xcss: $282ccd0c2577234c$var$styles.expandableHeader,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "center",
                    children: [
                        isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: formatMessage((0, $hAecz.messages).ai_debugger_modal_collapse_label),
                            color: "currentColor"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                            label: formatMessage((0, $hAecz.messages).ai_debugger_modal_expand_label),
                            color: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            children: title
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $282ccd0c2577234c$var$styles.expandableContent,
                children: children
            })
        ]
    });
};
const $282ccd0c2577234c$var$MinionExpandableItem = ({ minion: minion, index: index })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const minionInfo = (0, $lcPZc.getMinionOutputItem)(minion);
    const isSearchMinion = minionInfo.minion_id?.toLowerCase().includes((0, $40Bg6.MinionName).SEARCH);
    const { extraInfo: extraInfo, parsedOutput: parsedOutput, functionResults: functionResults, searchExtraInfo: searchExtraInfo } = (0, $lcPZc.parseMinionExtraInfo)(minionInfo.minion_extra_info, minionInfo.minion_id, isSearchMinion ?? false);
    const rankedDocumentsWithChunks = (0, $lcPZc.getRankedDocumentsWithChunks)(searchExtraInfo);
    const rawSearchResults = searchExtraInfo?.searchResults ?? [];
    const executionDuration = minionInfo.minion_execution_duration;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $282ccd0c2577234c$var$styles.minionCard,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    onClick: ()=>setIsExpanded(!isExpanded),
                    xcss: $282ccd0c2577234c$var$styles.pressable,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.100",
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.100",
                                alignBlock: "center",
                                children: [
                                    isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                        label: formatMessage((0, $hAecz.messages).ai_debugger_modal_collapse_label),
                                        color: "currentColor"
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                        label: formatMessage((0, $hAecz.messages).ai_debugger_modal_expand_label),
                                        color: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        weight: "medium",
                                        children: minionInfo.minion_id || `Minion ${index + 1}`
                                    })
                                ]
                            }),
                            executionDuration !== undefined && /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: [
                                    formatMessage((0, $hAecz.messages).ai_debugger_modal_execution_duration_label),
                                    ":",
                                    ' ',
                                    formatMessage((0, $hAecz.messages).ai_debugger_modal_execution_duration, {
                                        duration: executionDuration
                                    })
                                ]
                            })
                        ]
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $282ccd0c2577234c$var$styles.expandedContent,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.200",
                        children: [
                            minionInfo.minion_input && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.borderedBox, $282ccd0c2577234c$var$styles.sectionPadding),
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            weight: "semibold",
                                            size: "small",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_minion_input_label)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $282ccd0c2577234c$var$styles.codeBlock,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                children: typeof minionInfo.minion_input === 'object' ? JSON.stringify(minionInfo.minion_input, null, 2) : minionInfo.minion_input
                                            })
                                        })
                                    ]
                                })
                            }),
                            minionInfo.minion_output && /*#__PURE__*/ (0, $l998X.jsx)($282ccd0c2577234c$var$ExpandableSection, {
                                title: formatMessage((0, $hAecz.messages).ai_debugger_modal_minion_output_label),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $282ccd0c2577234c$var$styles.codeBlock,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        children: typeof minionInfo.minion_output === 'object' ? JSON.stringify(minionInfo.minion_output, null, 2) : minionInfo.minion_output
                                    })
                                })
                            }),
                            functionResults && functionResults.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)($282ccd0c2577234c$var$ExpandableSection, {
                                title: formatMessage((0, $hAecz.messages).ai_debugger_modal_function_results_count, {
                                    count: functionResults.length
                                }),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                                    space: "space.100",
                                    children: functionResults.map((result, idx)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $8a70H.FunctionResult), {
                                            result: result,
                                            index: idx
                                        }, idx))
                                })
                            }),
                            (parsedOutput || extraInfo) && /*#__PURE__*/ (0, $l998X.jsx)($282ccd0c2577234c$var$ExpandableSection, {
                                title: formatMessage((0, $hAecz.messages).ai_debugger_modal_minion_extra_info_label),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $717Wk.PluginOutputRenderer), {
                                    parsedOutput: parsedOutput,
                                    extraInfo: extraInfo
                                })
                            }),
                            isSearchMinion && rawSearchResults.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)($282ccd0c2577234c$var$ExpandableSection, {
                                title: formatMessage((0, $hAecz.messages).ai_debugger_modal_raw_search_results_heading, {
                                    count: rawSearchResults.length
                                }),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $282ccd0c2577234c$var$styles.borderedBox,
                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                                        xcss: $282ccd0c2577234c$var$styles.searchResultsGrid,
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridHeader),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    weight: "semibold",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_url_header)
                                                })
                                            }),
                                            rawSearchResults.map((url)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: $282ccd0c2577234c$var$styles.gridCell,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                        href: url,
                                                        target: "_blank",
                                                        children: url
                                                    })
                                                }, url))
                                        ]
                                    })
                                })
                            }),
                            isSearchMinion && rankedDocumentsWithChunks.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)($282ccd0c2577234c$var$ExpandableSection, {
                                title: formatMessage((0, $hAecz.messages).ai_debugger_modal_ranked_search_results_heading, {
                                    count: rankedDocumentsWithChunks.length
                                }),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $282ccd0c2577234c$var$styles.borderedBox,
                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                                        xcss: $282ccd0c2577234c$var$styles.rankedDocsGrid,
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridHeader),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    weight: "semibold",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_doc_index_header)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder, $282ccd0c2577234c$var$styles.gridHeader),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    weight: "semibold",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_url_header)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder, $282ccd0c2577234c$var$styles.gridHeader),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    weight: "semibold",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_chunk_id_header)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder, $282ccd0c2577234c$var$styles.gridHeader),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    weight: "semibold",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_chunk_score_header)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder, $282ccd0c2577234c$var$styles.gridHeader),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    weight: "semibold",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_chunk_rank_header)
                                                })
                                            }),
                                            rankedDocumentsWithChunks.map((doc, docIndex)=>{
                                                const chunkCount = Math.max(doc.chunks.length, 1);
                                                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            xcss: $282ccd0c2577234c$var$styles.gridCell,
                                                            style: {
                                                                gridRow: `span ${chunkCount}`
                                                            },
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                weight: "semibold",
                                                                children: docIndex + 1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder),
                                                            style: {
                                                                gridRow: `span ${chunkCount}`
                                                            },
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                href: doc.url,
                                                                target: "_blank",
                                                                children: doc.url
                                                            })
                                                        }),
                                                        doc.chunks.length > 0 ? doc.chunks.map((chunk)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                                        xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder),
                                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                            children: chunk.chunk_id
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                                        xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder),
                                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                            children: chunk.score.toFixed(4)
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                                        xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder),
                                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                            children: chunk.rank
                                                                        })
                                                                    })
                                                                ]
                                                            }, chunk.chunk_id)) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                                    xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder),
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                        color: "color.text.subtlest",
                                                                        children: formatMessage((0, $hAecz.messages).ai_debugger_modal_unable_to_match_chunks)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                                    xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder),
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                        children: "-"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                                    xcss: (0, $1Whri.cx)($282ccd0c2577234c$var$styles.gridCell, $282ccd0c2577234c$var$styles.gridCellWithLeftBorder),
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                        children: "-"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, doc.url);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $282ccd0c2577234c$export$99187093ec4738cf = ({ round: round, roundIndex: roundIndex })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b5vPf.Panel), {
            testId: `sain-online-debugger-loop-${roundIndex}-panel`,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: formatMessage((0, $hAecz.messages).ai_debugger_modal_orchestration_loop_with_count, {
                            number: roundIndex,
                            count: round.length
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        space: "space.100",
                        children: round.map((minion, minionIndex)=>/*#__PURE__*/ (0, $l998X.jsx)($282ccd0c2577234c$var$MinionExpandableItem, {
                                minion: minion,
                                index: minionIndex
                            }, (0, $lcPZc.getMinionOutputItem)(minion).minion_id || minionIndex))
                    })
                ]
            })
        })
    });
};
module.exports["LoopPanel"] = $282ccd0c2577234c$export$99187093ec4738cf;

});

parcelRegister("5CTTZ", function(module, exports) {
/* orchestration-overview-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $5nBzc = parcelRequire("5nBzc");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $d2kvf = parcelRequire("d2kvf");


var $hAecz = parcelRequire("hAecz");


var $lcPZc = parcelRequire("lcPZc");


var $b5vPf = parcelRequire("b5vPf");

const $c1c59a71bf0e5c0b$var$styles = {
    minionGrid: "_yv0eux3o"
};
const $c1c59a71bf0e5c0b$export$fb4e2149d28f72b3 = ({ orchestrationRounds: orchestrationRounds })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (orchestrationRounds.length === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b5vPf.Panel), {
            testId: "sain-online-debugger-orchestration-overview-panel",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_no_orchestration_data)
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b5vPf.Panel), {
            testId: "sain-online-debugger-orchestration-overview-panel",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                space: "space.200",
                children: orchestrationRounds.map((round, roundIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    space: "space.100",
                                    alignBlock: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "small",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_orchestration_loop_heading, {
                                                number: roundIndex
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                            appearance: "default",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_orchestration_minions_count, {
                                                count: round.length
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                                    xcss: $c1c59a71bf0e5c0b$var$styles.minionGrid,
                                    gap: "space.100",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "xsmall",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_minion_name_label)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "xsmall",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_execution_duration_label)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "xsmall",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_minion_input_label)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    children: round.map((minion, minionIndex)=>{
                                        const minionInfo = (0, $lcPZc.getMinionOutputItem)(minion);
                                        const minionId = minionInfo.minion_id;
                                        const minionInput = minionInfo.minion_input;
                                        const executionDuration = minionInfo.minion_execution_duration;
                                        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                                            xcss: $c1c59a71bf0e5c0b$var$styles.minionGrid,
                                            gap: "space.100",
                                            alignItems: "center",
                                            children: [
                                                minionId ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtle",
                                                    children: minionId
                                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtlest",
                                                    testId: "disabled-minion-id",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_disabled)
                                                }),
                                                executionDuration !== undefined ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtle",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_execution_duration, {
                                                        duration: executionDuration
                                                    })
                                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtlest",
                                                    testId: "disabled-execution-duration",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_disabled)
                                                }),
                                                minionInput ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtle",
                                                    children: typeof minionInput === 'object' ? JSON.stringify(minionInput, null, 2) : minionInput
                                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtlest",
                                                    testId: "disabled-minion-input",
                                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_disabled)
                                                })
                                            ]
                                        }, `${minionId}-${minionIndex}`);
                                    })
                                })
                            ]
                        })
                    }, roundIndex))
            })
        })
    });
};
module.exports["OrchestrationOverviewPanel"] = $c1c59a71bf0e5c0b$export$fb4e2149d28f72b3;

});

parcelRegister("9EPrq", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $d2kvf = parcelRequire("d2kvf");


var $akGHV = parcelRequire("akGHV");


var $hAecz = parcelRequire("hAecz");


var $b5vPf = parcelRequire("b5vPf");

const $eb7e7fa9bc0e3cfe$export$8eddb41fbb2fcd3f = ({ nonSearchPluginInvocations: nonSearchPluginInvocations })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b5vPf.Panel), {
            testId: "sain-online-debugger-plugin-invocations-panel",
            children: nonSearchPluginInvocations.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                space: "space.0",
                children: nonSearchPluginInvocations.map((plugin, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $akGHV.PluginInvocationItem), {
                        plugin: plugin,
                        index: index
                    }, plugin.plugin_invocation_id || index))
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_no_plugins_invoked)
            })
        })
    });
};
module.exports["PluginInvocationsPanel"] = $eb7e7fa9bc0e3cfe$export$8eddb41fbb2fcd3f;

});

parcelRegister("jhjPA", function(module, exports) {
/* ranked-search-results-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $d2kvf = parcelRequire("d2kvf");


var $hAecz = parcelRequire("hAecz");


var $b5vPf = parcelRequire("b5vPf");

const $525850e229d1b6ab$var$styles = {
    rankedDocsGrid: "_yv0e1weo _uwhke4h9 _15a5nqa1 _1i531l7x _t6vde4h9 _1p3lnqa1 _5wra1l7x",
    gridHeader: "_bfhki8nm _ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp _1doce4h9 _1il9nqa1 _1o3i1l7x _hr4je4h9 _1apgnqa1 _mowc1l7x",
    gridCell: "_ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp _1doce4h9 _1il9nqa1 _1o3i1l7x _hr4je4h9 _1apgnqa1 _mowc1l7x",
    gridUrlCell: "_ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp _1doce4h9 _1il9nqa1 _1o3i1l7x _hr4je4h9 _1apgnqa1 _mowc1l7x _1nmz9jpi"
};
const $525850e229d1b6ab$export$39197e0ebf675eb2 = ({ rankedDocumentsWithChunks: rankedDocumentsWithChunks })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b5vPf.Panel), {
            testId: "sain-online-debugger-ranked-search-results-panel",
            children: rankedDocumentsWithChunks.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_no_ranked_search_results)
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: formatMessage((0, $hAecz.messages).ai_debugger_modal_ranked_search_results_heading, {
                            count: rankedDocumentsWithChunks.length
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                        xcss: $525850e229d1b6ab$var$styles.rankedDocsGrid,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $525850e229d1b6ab$var$styles.gridHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "semibold",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_doc_index_header)
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $525850e229d1b6ab$var$styles.gridHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "semibold",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_url_header)
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $525850e229d1b6ab$var$styles.gridHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "semibold",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_chunk_id_header)
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $525850e229d1b6ab$var$styles.gridHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "semibold",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_chunk_score_header)
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $525850e229d1b6ab$var$styles.gridHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "semibold",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_chunk_rank_header)
                                })
                            }),
                            rankedDocumentsWithChunks.map((doc, index)=>{
                                const chunkCount = Math.max(doc.chunks.length, 1);
                                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $525850e229d1b6ab$var$styles.gridCell,
                                            style: {
                                                gridRow: `span ${chunkCount}`
                                            },
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                weight: "semibold",
                                                children: index + 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $525850e229d1b6ab$var$styles.gridUrlCell,
                                            style: {
                                                gridRow: `span ${chunkCount}`
                                            },
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                href: doc.url,
                                                target: "_blank",
                                                children: doc.url
                                            })
                                        }),
                                        doc.chunks.length > 0 ? doc.chunks.map((chunk, chunkIndex)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                        xcss: $525850e229d1b6ab$var$styles.gridCell,
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                            children: chunk.chunk_id
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                        xcss: $525850e229d1b6ab$var$styles.gridCell,
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                            children: chunk.score.toFixed(4)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                        xcss: $525850e229d1b6ab$var$styles.gridCell,
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                            children: chunk.rank
                                                        })
                                                    })
                                                ]
                                            }, `${chunk.chunk_id}-${chunkIndex}`)) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: $525850e229d1b6ab$var$styles.gridCell,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                        color: "color.text.subtlest",
                                                        children: formatMessage((0, $hAecz.messages).ai_debugger_modal_unable_to_match_chunks)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: $525850e229d1b6ab$var$styles.gridCell,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                        children: "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: $525850e229d1b6ab$var$styles.gridCell,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                        children: "-"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, `${doc.url}-${index}`);
                            })
                        ]
                    })
                ]
            })
        })
    });
};
module.exports["RankedSearchResultsPanel"] = $525850e229d1b6ab$export$39197e0ebf675eb2;

});

parcelRegister("lKT4y", function(module, exports) {
/* raw-json-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $9QfXi = parcelRequire("9QfXi");


var $2MuFw = parcelRequire("2MuFw");


var $3sFtD = parcelRequire("3sFtD");


var $gdv5Z = parcelRequire("gdv5Z");


var $d2kvf = parcelRequire("d2kvf");


var $hAecz = parcelRequire("hAecz");


var $b5vPf = parcelRequire("b5vPf");

const $68e066b2ccdac326$var$styles = {
    copyJsonButton: "_18u01wug"
};
const $68e066b2ccdac326$var$formatJson = (data)=>{
    return JSON.stringify(data, null, 2);
};
const $68e066b2ccdac326$export$c1727a1710dac2d1 = ({ rawJson: rawJson })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [jsonCopied, setJsonCopied] = (0, $42omo.useState)(false);
    const copyFinalResponseJson = (0, $42omo.useCallback)(async ()=>{
        try {
            if (!rawJson) return;
            const jsonString = $68e066b2ccdac326$var$formatJson(rawJson);
            if (!jsonString) return;
            await navigator.clipboard.writeText(jsonString);
            setJsonCopied(true);
            setTimeout(()=>{
                setJsonCopied(false);
            }, 2500);
        } catch  {
            return;
        }
    }, [
        rawJson
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $b5vPf.Panel), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $68e066b2ccdac326$var$styles.copyJsonButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "primary",
                        onClick: copyFinalResponseJson,
                        iconBefore: jsonCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))) : (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
                        children: jsonCopied ? formatMessage((0, $hAecz.messages).ai_debugger_modal_copy_button_copied_text) : formatMessage((0, $hAecz.messages).ai_debugger_modal_copy_button_text)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9QfXi.default), {
                    language: "json",
                    text: $68e066b2ccdac326$var$formatJson(rawJson ?? null),
                    shouldWrapLongLines: true
                })
            ]
        })
    });
};
module.exports["RawJsonPanel"] = $68e066b2ccdac326$export$c1727a1710dac2d1;

});

parcelRegister("jKslv", function(module, exports) {
/* raw-search-results-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $d2kvf = parcelRequire("d2kvf");


var $hAecz = parcelRequire("hAecz");


var $b5vPf = parcelRequire("b5vPf");

const $c8975f4713c30273$var$styles = {
    singleColumnGrid: "_yv0ehkll _uwhke4h9 _15a5nqa1 _1i531l7x _t6vde4h9 _1p3lnqa1 _5wra1l7x",
    gridHeader: "_bfhki8nm _ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp _1doce4h9 _1il9nqa1 _1o3i1l7x _hr4je4h9 _1apgnqa1 _mowc1l7x",
    gridUrlCell: "_ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp _1doce4h9 _1il9nqa1 _1o3i1l7x _hr4je4h9 _1apgnqa1 _mowc1l7x _1nmz9jpi"
};
const $c8975f4713c30273$export$4809e441463be887 = ({ searchResults: searchResults })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b5vPf.Panel), {
            testId: "sain-online-debugger-raw-search-results-panel",
            children: searchResults.length > 0 ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: formatMessage((0, $hAecz.messages).ai_debugger_modal_raw_search_results_heading, {
                            count: searchResults.length
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                        xcss: $c8975f4713c30273$var$styles.singleColumnGrid,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $c8975f4713c30273$var$styles.gridHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "semibold",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_table_url_header)
                                })
                            }),
                            searchResults.map((url, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $c8975f4713c30273$var$styles.gridUrlCell,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: url,
                                        target: "_blank",
                                        children: url
                                    })
                                }, `${url}-${index}`))
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_no_raw_search_results)
            })
        })
    });
};
module.exports["RawSearchResultsPanel"] = $c8975f4713c30273$export$4809e441463be887;

});

parcelRegister("dILBZ", function(module, exports) {
/* request-overview-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $5nBzc = parcelRequire("5nBzc");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $d2kvf = parcelRequire("d2kvf");


var $eALDe = parcelRequire("eALDe");


var $hAecz = parcelRequire("hAecz");


var $lcPZc = parcelRequire("lcPZc");


var $b5vPf = parcelRequire("b5vPf");

const $6d8a861804bf5227$var$styles = {
    twoColumnGrid: "_yv0ewxkt"
};
const $6d8a861804bf5227$export$fff5f67a3c73a716 = ({ originalQuery: originalQuery, transformedQuery: transformedQuery, smartAnswersRoute: smartAnswersRoute, traceId: traceId, modelName: modelName, cacheHit: cacheHit, sources: sources, isNaturalLanguageQuery: isNaturalLanguageQuery, invokedPluginNames: invokedPluginNames })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const displayCacheHit = cacheHit === null ? 'disabled' : cacheHit.toString();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $b5vPf.Panel), {
            testId: "sain-online-debugger-request-overview-panel",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_original_query_subheading)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: originalQuery ?? 'null'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_transformed_query_subheading)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: transformedQuery ?? 'null'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                    xcss: $6d8a861804bf5227$var$styles.twoColumnGrid,
                    gap: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "xsmall",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_detected_intent_subheading)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    children: smartAnswersRoute
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "xsmall",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_trace_id_subheading)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    space: "space.100",
                                    alignBlock: "start",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            children: traceId ?? 'null'
                                        }),
                                        traceId && /*#__PURE__*/ (0, $l998X.jsx)((0, $eALDe.CopyButton), {
                                            copyText: traceId,
                                            copyLabel: formatMessage((0, $hAecz.messages).ai_debugger_modal_copy_trace_id_label),
                                            copiedLabel: formatMessage((0, $hAecz.messages).ai_debugger_modal_trace_id_copied_text),
                                            testId: "sain-online-debugger-copy-trace-id-button"
                                        })
                                    ]
                                })
                            ]
                        }),
                        isNaturalLanguageQuery && /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "xsmall",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_model_subheading)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            children: modelName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "xsmall",
                                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_cached_answer_subheading)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            children: displayCacheHit
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isNaturalLanguageQuery && invokedPluginNames.length > 0 && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_plugins_invoked_subheading)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            space: "space.100",
                            alignBlock: "center",
                            children: invokedPluginNames.map((pluginName)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                    appearance: (0, $lcPZc.getPluginLozengeAppearance)(pluginName),
                                    isBold: true,
                                    children: pluginName
                                }, pluginName))
                        })
                    ]
                }),
                isNaturalLanguageQuery && sources.length > 0 && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_sources_subheading)
                        }),
                        sources.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                        children: [
                                            index + 1,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: source.url,
                                        target: "_blank",
                                        children: source.title
                                    })
                                ]
                            }, source.ari))
                    ]
                })
            ]
        })
    });
};
module.exports["RequestOverviewPanel"] = $6d8a861804bf5227$export$fff5f67a3c73a716;

});

parcelRegister("lcPZc", function(module, exports) {

var $GzZ6c = parcelRequire("GzZ6c");


var $40Bg6 = parcelRequire("40Bg6");

const $9403c882ad03874d$export$9007e115c1a30684 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return null;
    const searchPlugin = pluginInvocations.find((plugin)=>plugin.plugin_name === (0, $40Bg6.PluginName).SEARCH);
    if (!searchPlugin?.plugin_extra_info) return null;
    try {
        return JSON.parse(searchPlugin.plugin_extra_info);
    } catch  {
        return null;
    }
};
const $9403c882ad03874d$export$bf63c148d8c5608b = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs)) return null;
    // Find search minion - check if minion_id contains 'search' (case insensitive)
    const searchMinion = minionOutputs.find((minion)=>{
        const minionInfo = Array.isArray(minion) ? minion[0] : minion;
        return minionInfo.minion_id?.toLowerCase().includes((0, $40Bg6.MinionName).SEARCH);
    });
    if (!searchMinion) return null;
    const minionInfo = Array.isArray(searchMinion) ? searchMinion[0] : searchMinion;
    if (!minionInfo.minion_extra_info) return null;
    try {
        const parsedExtraInfo = JSON.parse(minionInfo.minion_extra_info);
        // Extract from functionMessage.pluginInvocationInfo.extraInfo
        if (parsedExtraInfo.functionMessage?.pluginInvocationInfo?.extraInfo) try {
            return JSON.parse(parsedExtraInfo.functionMessage.pluginInvocationInfo.extraInfo);
        } catch  {
            return null;
        }
        return null;
    } catch  {
        return null;
    }
};
const $9403c882ad03874d$export$15d9e451202b41ba = (pluginSearchInfo, minionSearchInfo)=>{
    // If we have plugin search info, use it (it has more complete data like rawRankedDocumentsInfoMap)
    if (pluginSearchInfo) return pluginSearchInfo;
    // Otherwise, use minion search info
    return minionSearchInfo;
};
const $9403c882ad03874d$export$1f23ec3fd5426403 = (searchExtraInfo)=>{
    if (!searchExtraInfo?.rankedDocuments || !searchExtraInfo?.rawRankedDocumentsInfoMap) return [];
    const { rankedDocuments: rankedDocuments, rawRankedDocumentsInfoMap: rawRankedDocumentsInfoMap } = searchExtraInfo;
    const chunkArrays = Object.values(rawRankedDocumentsInfoMap);
    return rankedDocuments.map((url, index)=>({
            url: url,
            chunks: chunkArrays[index]?.sort((a, b)=>a.chunk_id - b.chunk_id) ?? []
        }));
};
const $9403c882ad03874d$export$702a9b90e43f0129 = (text)=>{
    const match = text.match(/\[([^\]]+)\]\(([^)]+)\)/);
    if (!match) return null;
    const [, name, url] = match;
    const accountIdMatch = url.match(/\/people\/([^/]+)/);
    const accountId = accountIdMatch ? accountIdMatch[1] : null;
    return {
        name: name,
        url: url,
        accountId: accountId
    };
};
const $9403c882ad03874d$export$c064dfbb0e9baaa8 = (text)=>{
    const parsed = $9403c882ad03874d$export$702a9b90e43f0129(text);
    if (!parsed) return text;
    return parsed.accountId ? `${parsed.name} (${parsed.accountId})` : parsed.name;
};
const $9403c882ad03874d$export$21986be684877eaa = (output)=>{
    const lines = output.split('\n');
    const result = {
        sections: []
    };
    let currentTeam = null;
    let currentDocument = null;
    let inMembersSection = false;
    let headerLines = [];
    let currentSection = {};
    lines.forEach((line)=>{
        const trimmedLine = line.trim();
        // Capture main header
        if (trimmedLine.startsWith('Here are') && !result.header && !currentTeam && !currentDocument) {
            headerLines.push(trimmedLine);
            return;
        }
        // Section headers (like "Here are the Confluence documents:")
        if (trimmedLine.startsWith('Here are the') && trimmedLine.endsWith(':') && !currentTeam && !currentDocument) {
            // Save previous section if exists
            if (currentSection.teams || currentSection.documents) result.sections.push(currentSection);
            currentSection = {
                sectionHeader: trimmedLine.slice(0, -1)
            }; // Remove trailing colon
            return;
        }
        // Start of a new team
        if (trimmedLine.startsWith('- type: Team')) {
            // Save previous item
            if (currentTeam) {
                if (!currentSection.teams) currentSection.teams = [];
                currentSection.teams.push(currentTeam);
            }
            if (currentDocument) {
                if (!currentSection.documents) currentSection.documents = [];
                currentSection.documents.push(currentDocument);
            }
            currentTeam = {
                type: 'Team',
                members: []
            };
            currentDocument = null;
            inMembersSection = false;
            return;
        }
        // Start of a new document (Confluence Page, Confluence Blog Post, etc.)
        if (trimmedLine.startsWith('- type: Confluence') || trimmedLine.startsWith('- type: Jira')) {
            // Save previous item
            if (currentTeam) {
                if (!currentSection.teams) currentSection.teams = [];
                currentSection.teams.push(currentTeam);
            }
            if (currentDocument) {
                if (!currentSection.documents) currentSection.documents = [];
                currentSection.documents.push(currentDocument);
            }
            currentDocument = {
                type: trimmedLine.substring(8).trim()
            };
            currentTeam = null;
            inMembersSection = false;
            return;
        }
        // Parse fields
        if (currentTeam) {
            // Team parsing
            if (inMembersSection && trimmedLine.startsWith('- [')) currentTeam.members.push(trimmedLine.substring(2).trim());
            else if (trimmedLine.startsWith('- ')) {
                const colonIndex = trimmedLine.indexOf(':');
                if (colonIndex !== -1) {
                    const fieldName = trimmedLine.substring(2, colonIndex).toLowerCase();
                    const fieldValue = trimmedLine.substring(colonIndex + 1).trim();
                    switch(fieldName){
                        case 'ari':
                            currentTeam.ari = fieldValue;
                            break;
                        case 'name':
                            currentTeam.name = fieldValue;
                            break;
                        case 'description':
                            currentTeam.description = fieldValue;
                            break;
                        case 'creator':
                            currentTeam.creator = fieldValue;
                            break;
                        case 'member count':
                            currentTeam.memberCount = parseInt(fieldValue, 10);
                            break;
                        case 'teamstate':
                            currentTeam.teamState = fieldValue;
                            inMembersSection = false;
                            break;
                        case 'members':
                            inMembersSection = true;
                            currentTeam.members = [];
                            break;
                    }
                }
            }
        } else if (currentDocument && trimmedLine.startsWith('- ')) {
            // Document parsing
            const colonIndex = trimmedLine.indexOf(':');
            if (colonIndex !== -1) {
                const fieldName = trimmedLine.substring(2, colonIndex).toLowerCase();
                const fieldValue = trimmedLine.substring(colonIndex + 1).trim();
                switch(fieldName){
                    case 'ari':
                        currentDocument.ari = fieldValue;
                        break;
                    case 'title':
                        currentDocument.title = fieldValue;
                        break;
                    case 'url':
                        currentDocument.url = fieldValue;
                        break;
                    case 'author':
                        currentDocument.author = fieldValue;
                        break;
                    case 'updated':
                        currentDocument.updated = fieldValue;
                        break;
                }
            }
        }
    });
    // Save last item
    if (currentTeam) {
        if (!currentSection.teams) currentSection.teams = [];
        currentSection.teams.push(currentTeam);
    }
    if (currentDocument) {
        if (!currentSection.documents) currentSection.documents = [];
        currentSection.documents.push(currentDocument);
    }
    // Save last section
    if (currentSection.teams || currentSection.documents) result.sections.push(currentSection);
    if (headerLines.length > 0) result.header = headerLines.join(' ');
    return result.sections.length > 0 ? result : null;
};
const $9403c882ad03874d$export$8639a620a71ba97 = (output)=>{
    const lines = output.split('\n');
    const result = {
        people: []
    };
    let currentPerson = null;
    let inProfileSection = false;
    const savePerson = ()=>{
        if (currentPerson && currentPerson.profile.name) result.people.push(currentPerson);
    };
    for (const line of lines){
        const trimmedLine = line.trim();
        // Parse header line to extract account ID - this starts a new person
        if (trimmedLine.startsWith('Retrieved the following information for user')) {
            // Save previous person if exists
            savePerson();
            // Start new person
            currentPerson = {
                profile: {}
            };
            currentPerson.header = trimmedLine;
            const accountIdMatch = trimmedLine.match(/account\/user id \(([^)]+)\)/);
            if (accountIdMatch) currentPerson.accountId = accountIdMatch[1];
            inProfileSection = false;
            continue;
        }
        // Check for profile section start
        if (trimmedLine === '# Profile:') {
            inProfileSection = true;
            continue;
        }
        // Parse profile fields (format: - **Key**: Value)
        if (inProfileSection && currentPerson && trimmedLine.startsWith('- **')) {
            const fieldMatch = trimmedLine.match(/^- \*\*([^*]+)\*\*:\s*(.*)$/);
            if (fieldMatch) {
                const [, fieldName, fieldValue] = fieldMatch;
                const profile = currentPerson.profile;
                switch(fieldName.toLowerCase()){
                    case 'name':
                        profile.name = fieldValue;
                        break;
                    case 'picture':
                        profile.picture = fieldValue;
                        break;
                    case 'email':
                        profile.email = fieldValue;
                        break;
                    case 'timezone':
                        profile.timezone = fieldValue;
                        break;
                    case 'locale':
                        profile.locale = fieldValue;
                        break;
                    case 'nickname':
                        profile.nickname = fieldValue;
                        break;
                    case 'job title':
                        profile.jobTitle = fieldValue;
                        break;
                    case 'location':
                        profile.location = fieldValue;
                        break;
                    case 'department':
                        profile.department = fieldValue;
                        break;
                    case 'organization':
                        profile.organization = fieldValue;
                        break;
                }
            }
        }
    }
    // Save the last person
    savePerson();
    return result.people.length > 0 ? result : null;
};
const $9403c882ad03874d$export$97b80a86e0bee15d = (output)=>{
    const lines = output.split('\n');
    const result = {
        pages: []
    };
    let currentPage = null;
    let headerCaptured = false;
    const savePage = ()=>{
        if (currentPage && currentPage.title) result.pages.push(currentPage);
    };
    for (const line of lines){
        const trimmedLine = line.trim();
        // Capture header
        if (!headerCaptured && trimmedLine.startsWith('Here are')) {
            result.header = trimmedLine;
            headerCaptured = true;
            continue;
        }
        // Start of a new page entry (title line)
        if (trimmedLine.startsWith('- title:')) {
            // Save previous page if exists
            savePage();
            currentPage = {
                title: trimmedLine.substring(9).trim()
            };
            continue;
        }
        // Parse page fields
        if (currentPage) {
            if (trimmedLine.startsWith('url:')) currentPage.url = trimmedLine.substring(4).trim();
            else if (trimmedLine.startsWith('space:')) currentPage.space = trimmedLine.substring(6).trim();
            else if (trimmedLine.startsWith('date:')) currentPage.date = trimmedLine.substring(5).trim();
            else if (trimmedLine.startsWith('author:')) currentPage.author = trimmedLine.substring(7).trim();
            else if (trimmedLine.startsWith('snippet:')) currentPage.snippet = trimmedLine.substring(8).trim();
        }
    }
    // Save the last page
    savePage();
    return result.pages.length > 0 ? result : null;
};
const $9403c882ad03874d$export$cc2e1f911cfb137c = (pluginName, output)=>{
    switch(pluginName){
        case (0, $40Bg6.PluginName).TEAMWORK:
            {
                const teamworkData = $9403c882ad03874d$export$21986be684877eaa(output);
                if (teamworkData) return {
                    type: 'teamwork',
                    data: teamworkData
                };
                break;
            }
        case (0, $40Bg6.PluginName).PAGE_SEARCH_PLUGIN:
            {
                const pageSearchData = $9403c882ad03874d$export$97b80a86e0bee15d(output);
                if (pageSearchData) return {
                    type: 'pageSearch',
                    data: pageSearchData
                };
                break;
            }
    }
    return null;
};
const $9403c882ad03874d$export$167366d10321aef5 = (minionExtraInfo, minionId, isSearchMinion)=>{
    let extraInfo = null;
    let parsedOutput = null;
    let functionResults = null;
    let searchExtraInfo = null;
    if (!minionExtraInfo) return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput,
        functionResults: functionResults,
        searchExtraInfo: searchExtraInfo
    };
    try {
        const parsedExtraInfo = JSON.parse(minionExtraInfo);
        // Case 1 & 2: Has functionMessage (single function call result)
        if (parsedExtraInfo.functionMessage) {
            const { pluginInvocationInfo: pluginInvocationInfo, output: output } = parsedExtraInfo.functionMessage;
            if (isSearchMinion && pluginInvocationInfo?.extraInfo) // Search minion: extract nested search results from extraInfo
            try {
                searchExtraInfo = JSON.parse(pluginInvocationInfo.extraInfo);
            } catch  {
                extraInfo = pluginInvocationInfo.extraInfo;
            }
            else {
                // Non-search minion: parse the output for structured display
                const rawOutput = pluginInvocationInfo?.output || output;
                if (typeof rawOutput === 'string') {
                    parsedOutput = $9403c882ad03874d$export$cc2e1f911cfb137c(minionId, rawOutput);
                    if (!parsedOutput) extraInfo = rawOutput;
                }
            }
        } else if (Array.isArray(parsedExtraInfo.results) && parsedExtraInfo.results.length > 0) functionResults = parsedExtraInfo.results;
        else if (parsedExtraInfo.content) extraInfo = parsedExtraInfo.content;
    } catch  {
        // Case 5: JSON parsing failed, use raw string
        extraInfo = minionExtraInfo;
    }
    return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput,
        functionResults: functionResults,
        searchExtraInfo: searchExtraInfo
    };
};
const $9403c882ad03874d$export$419c88009f8631e2 = (pluginName)=>{
    if (!pluginName) return 0, $GzZ6c.DEFAULT_PLUGIN_LOZENGE_APPEARANCE;
    if (pluginName in (0, $GzZ6c.PLUGIN_LOZENGE_APPEARANCE)) return (0, $GzZ6c.PLUGIN_LOZENGE_APPEARANCE)[pluginName];
    return 0, $GzZ6c.DEFAULT_PLUGIN_LOZENGE_APPEARANCE;
};
const $9403c882ad03874d$export$fda8ebbceae980b6 = (answerGenerationModel)=>{
    if (answerGenerationModel?.model_usage && typeof answerGenerationModel.model_usage === 'object') {
        const keys = Object.keys(answerGenerationModel.model_usage);
        return keys[0] ?? 'null';
    }
    return 'null';
};
const $9403c882ad03874d$export$25fa9bb580a33ec7 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return [];
    return [
        ...new Set(pluginInvocations.map((p)=>p.plugin_name).filter((name)=>Boolean(name)))
    ];
};
const $9403c882ad03874d$export$b79df509190735d5 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return [];
    return pluginInvocations.filter((plugin)=>plugin.plugin_name !== (0, $40Bg6.PluginName).SEARCH);
};
const $9403c882ad03874d$export$fabd92b0068ace48 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs)) return [];
    return minionOutputs.filter((minion)=>{
        const minionInfo = Array.isArray(minion) ? minion[0] : minion;
        return !minionInfo.minion_id?.toLowerCase().includes((0, $40Bg6.MinionName).SEARCH);
    });
};
const $9403c882ad03874d$export$60b013a10d8ce23 = (cacheInfo)=>{
    if (!cacheInfo) return null;
    return cacheInfo.cache_hit ?? null;
};
const $9403c882ad03874d$export$be4d3e7f2d62c728 = (minion)=>{
    return Array.isArray(minion) ? minion[0] : minion;
};
const $9403c882ad03874d$export$a5ce513682ddb349 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs) || minionOutputs.length === 0) return false;
    // Check if first element is an array (indicating rounds structure)
    return Array.isArray(minionOutputs[0]);
};
const $9403c882ad03874d$export$f14fe30fd1a0b725 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs) || minionOutputs.length === 0) return [];
    // Check if it's already a rounds structure (array of arrays)
    if ($9403c882ad03874d$export$a5ce513682ddb349(minionOutputs)) return minionOutputs;
    // Wrap flat array in a single round
    return [
        minionOutputs
    ];
};
const $9403c882ad03874d$export$c30dc1f014540aa = (minion)=>{
    const minionInfo = $9403c882ad03874d$export$be4d3e7f2d62c728(minion);
    return {
        minion_id: minionInfo.minion_id,
        minion_input: minionInfo.minion_input,
        minion_extra_info: minionInfo.minion_extra_info
    };
};
const $9403c882ad03874d$export$6f0a258f64ff7a99 = (extraAttributes)=>{
    const { originalQuery: originalQuery, transformedQuery: transformedQuery, traceId: traceId, answerGenerationModel: answerGenerationModel, cacheInfo: cacheInfo, sources: sources = [], pluginInvocations: pluginInvocations = [], minion_outputs: minion_outputs = [], rawJson: rawJson } = extraAttributes ?? {};
    // Extract search data from both plugins and minions, then merge
    const pluginSearchInfo = $9403c882ad03874d$export$9007e115c1a30684(pluginInvocations);
    const minionSearchInfo = $9403c882ad03874d$export$bf63c148d8c5608b(minion_outputs);
    const searchExtraInfo = $9403c882ad03874d$export$15d9e451202b41ba(pluginSearchInfo, minionSearchInfo);
    const rankedDocumentsWithChunks = $9403c882ad03874d$export$1f23ec3fd5426403(searchExtraInfo);
    const orchestrationRounds = $9403c882ad03874d$export$f14fe30fd1a0b725(minion_outputs);
    return {
        requestOverview: {
            originalQuery: originalQuery ?? null,
            transformedQuery: transformedQuery ?? null,
            traceId: traceId ?? null,
            modelName: $9403c882ad03874d$export$fda8ebbceae980b6(answerGenerationModel),
            cacheHit: $9403c882ad03874d$export$60b013a10d8ce23(cacheInfo),
            sources: sources,
            invokedPluginNames: $9403c882ad03874d$export$25fa9bb580a33ec7(pluginInvocations)
        },
        rankedSearch: {
            searchExtraInfo: searchExtraInfo,
            rankedDocumentsWithChunks: rankedDocumentsWithChunks
        },
        rawSearch: {
            searchResults: searchExtraInfo?.searchResults ?? []
        },
        pluginInvocations: {
            allPluginInvocations: pluginInvocations,
            nonSearchPluginInvocations: $9403c882ad03874d$export$b79df509190735d5(pluginInvocations),
            hasPluginInvocations: pluginInvocations ? pluginInvocations.length > 0 : false
        },
        minions: {
            allMinionOutputs: minion_outputs,
            nonSearchMinionOutputs: $9403c882ad03874d$export$fabd92b0068ace48(minion_outputs),
            hasMinionOutputs: minion_outputs ? minion_outputs.length > 0 : false,
            orchestrationRounds: orchestrationRounds,
            roundCount: orchestrationRounds.length
        },
        rawJson: {
            rawJson: rawJson
        }
    };
};
module.exports["getRankedDocumentsWithChunks"] = $9403c882ad03874d$export$1f23ec3fd5426403;
module.exports["formatMarkdownLinkAsText"] = $9403c882ad03874d$export$c064dfbb0e9baaa8;
module.exports["parsePluginOutput"] = $9403c882ad03874d$export$cc2e1f911cfb137c;
module.exports["parseMinionExtraInfo"] = $9403c882ad03874d$export$167366d10321aef5;
module.exports["getPluginLozengeAppearance"] = $9403c882ad03874d$export$419c88009f8631e2;
module.exports["getMinionOutputItem"] = $9403c882ad03874d$export$be4d3e7f2d62c728;
module.exports["normalizeDebuggerData"] = $9403c882ad03874d$export$6f0a258f64ff7a99;

});

parcelRegister("81TN7", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0370817e1cefddd5$export$7f0e56320ea6e6ee = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _1bsb16xz _4t3i16xz",
            __cmplp.className
        ])
    });
});
const $0370817e1cefddd5$export$bf503936295d1d98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _1bsbzwfg _4t3izwfg",
            __cmplp.className
        ])
    });
});
const $0370817e1cefddd5$export$b32bf078e8b397e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkoidpf _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $0370817e1cefddd5$export$f23caa50568db2b0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1qi0 _1bsbzwfg _4t3izwfg",
            __cmplp.className
        ])
    });
});
module.exports["KnowledgeCardsPicture"] = $0370817e1cefddd5$export$7f0e56320ea6e6ee;
module.exports["PersonStyles"] = $0370817e1cefddd5$export$bf503936295d1d98;
module.exports["WorkStyles"] = $0370817e1cefddd5$export$b32bf078e8b397e9;
module.exports["AgentStyles"] = $0370817e1cefddd5$export$f23caa50568db2b0;

});

parcelRegister("d19et", function(module, exports) {
/**
 * Converts a GraphQL __typename (PascalCase) to a human-readable format for alt text.
 * 
 * Examples:
 * - "ConfluencePage" → "Confluence Page"
 * - "JiraIssue" → "Jira Issue"
 * - "BitbucketPullRequest" → "Bitbucket Pull Request"
 * - "TownsquareGoal" → "Townsquare Goal"
 * 
 * @param typeName - The GraphQL __typename value
 * @returns Human-readable formatted string
 */ function $2dd5d56935fdefe5$export$aeeed0811af42dc5(typeName) {
    if (!typeName) return '';
    let result = '';
    for(let i = 0; i < typeName.length; i++){
        const char = typeName[i];
        // Add space before uppercase letters (except the first character)
        if (i > 0 && char === char.toUpperCase() && char !== char.toLowerCase()) result += ' ';
        result += char;
    }
    return result;
}
module.exports["formatContentTypeName"] = $2dd5d56935fdefe5$export$aeeed0811af42dc5;

});

parcelRegister("lytr3", function(module, exports) {
const $743747c9abf98373$export$61d53a7e0f2f3df1 = {
    'Google Drive': 'Google Drive',
    Loom: 'Loom',
    Google: 'Google',
    GoogleDrive: 'GoogleDrive'
};
module.exports["EMBEDDED_SOURCE_PRODUCTS"] = $743747c9abf98373$export$61d53a7e0f2f3df1;

});

parcelRegister("bSZ63", function(module, exports) {
/**
 * Extracts the hostname from a URL string.
 * Returns undefined if the URL is invalid.
 */ const $0fdcf7e593c60f1d$export$a3b7216c107a7a1 = (sourceUrl)=>{
    let url;
    try {
        url = new URL(sourceUrl);
    } catch  {
        return undefined;
    }
    return url.hostname;
};
module.exports["extractUrlHostname"] = $0fdcf7e593c60f1d$export$a3b7216c107a7a1;

});

parcelRegister("bRsJn", function(module, exports) {
"use strict";
var $8a2aee491c62da41$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a2aee491c62da41$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8a2aee491c62da41$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8a2aee491c62da41$var$__createBinding(result, mod, k);
    }
    $8a2aee491c62da41$var$__setModuleDefault(result, mod);
    return result;
};
var $8a2aee491c62da41$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compileToken = module.exports.compileUnsafe = module.exports.compile = void 0;

var $fftKo = parcelRequire("fftKo");

var $bGFyo = parcelRequire("bGFyo");


var $8a2aee491c62da41$var$boolbase_1 = $8a2aee491c62da41$var$__importDefault((parcelRequire("7Rnqo")));

var $8a2aee491c62da41$var$sort_js_1 = $8a2aee491c62da41$var$__importStar((parcelRequire("3pXQ8")));

var $l9NKi = parcelRequire("l9NKi");


var $ekA3e = parcelRequire("ekA3e");

/**
 * Compiles a selector to an executable function.
 *
 * @param selector Selector to compile.
 * @param options Compilation options.
 * @param context Optional context for the selector.
 */ function $8a2aee491c62da41$var$compile(selector, options, context) {
    var next = $8a2aee491c62da41$var$compileUnsafe(selector, options, context);
    return (0, $ekA3e.ensureIsTag)(next, options.adapter);
}
module.exports.compile = $8a2aee491c62da41$var$compile;
function $8a2aee491c62da41$var$compileUnsafe(selector, options, context) {
    var token = typeof selector === "string" ? (0, $fftKo.parse)(selector) : selector;
    return $8a2aee491c62da41$var$compileToken(token, options, context);
}
module.exports.compileUnsafe = $8a2aee491c62da41$var$compileUnsafe;
function $8a2aee491c62da41$var$includesScopePseudo(t) {
    return t.type === $bGFyo.SelectorType.Pseudo && (t.name === "scope" || Array.isArray(t.data) && t.data.some(function(data) {
        return data.some($8a2aee491c62da41$var$includesScopePseudo);
    }));
}
var $8a2aee491c62da41$var$DESCENDANT_TOKEN = {
    type: $bGFyo.SelectorType.Descendant
};
var $8a2aee491c62da41$var$FLEXIBLE_DESCENDANT_TOKEN = {
    type: "_flexibleDescendant"
};
var $8a2aee491c62da41$var$SCOPE_TOKEN = {
    type: $bGFyo.SelectorType.Pseudo,
    name: "scope",
    data: null
};
/*
 * CSS 4 Spec (Draft): 3.4.1. Absolutizing a Relative Selector
 * http://www.w3.org/TR/selectors4/#absolutizing
 */ function $8a2aee491c62da41$var$absolutize(token, _a, context) {
    var adapter = _a.adapter;
    // TODO Use better check if the context is a document
    var hasContext = !!(context === null || context === void 0 ? void 0 : context.every(function(e) {
        var parent = adapter.isTag(e) && adapter.getParent(e);
        return e === $ekA3e.PLACEHOLDER_ELEMENT || parent && adapter.isTag(parent);
    }));
    for(var _i = 0, token_1 = token; _i < token_1.length; _i++){
        var t = token_1[_i];
        if (t.length > 0 && (0, $8a2aee491c62da41$var$sort_js_1.isTraversal)(t[0]) && t[0].type !== $bGFyo.SelectorType.Descendant) ;
        else if (hasContext && !t.some($8a2aee491c62da41$var$includesScopePseudo)) t.unshift($8a2aee491c62da41$var$DESCENDANT_TOKEN);
        else continue;
        t.unshift($8a2aee491c62da41$var$SCOPE_TOKEN);
    }
}
function $8a2aee491c62da41$var$compileToken(token, options, context) {
    var _a;
    token.forEach($8a2aee491c62da41$var$sort_js_1.default);
    context = (_a = options.context) !== null && _a !== void 0 ? _a : context;
    var isArrayContext = Array.isArray(context);
    var finalContext = context && (Array.isArray(context) ? context : [
        context
    ]);
    // Check if the selector is relative
    if (options.relativeSelector !== false) $8a2aee491c62da41$var$absolutize(token, options, finalContext);
    else if (token.some(function(t) {
        return t.length > 0 && (0, $8a2aee491c62da41$var$sort_js_1.isTraversal)(t[0]);
    })) throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
    var shouldTestNextSiblings = false;
    var query = token.map(function(rules) {
        if (rules.length >= 2) {
            var first = rules[0], second = rules[1];
            if (first.type !== $bGFyo.SelectorType.Pseudo || first.name !== "scope") ;
            else if (isArrayContext && second.type === $bGFyo.SelectorType.Descendant) rules[1] = $8a2aee491c62da41$var$FLEXIBLE_DESCENDANT_TOKEN;
            else if (second.type === $bGFyo.SelectorType.Adjacent || second.type === $bGFyo.SelectorType.Sibling) shouldTestNextSiblings = true;
        }
        return $8a2aee491c62da41$var$compileRules(rules, options, finalContext);
    }).reduce($8a2aee491c62da41$var$reduceRules, $8a2aee491c62da41$var$boolbase_1.default.falseFunc);
    query.shouldTestNextSiblings = shouldTestNextSiblings;
    return query;
}
module.exports.compileToken = $8a2aee491c62da41$var$compileToken;
function $8a2aee491c62da41$var$compileRules(rules, options, context) {
    var _a;
    return rules.reduce(function(previous, rule) {
        return previous === $8a2aee491c62da41$var$boolbase_1.default.falseFunc ? $8a2aee491c62da41$var$boolbase_1.default.falseFunc : (0, $l9NKi.compileGeneralSelector)(previous, rule, options, context, $8a2aee491c62da41$var$compileToken);
    }, (_a = options.rootFunc) !== null && _a !== void 0 ? _a : $8a2aee491c62da41$var$boolbase_1.default.trueFunc);
}
function $8a2aee491c62da41$var$reduceRules(a, b) {
    if (b === $8a2aee491c62da41$var$boolbase_1.default.falseFunc || a === $8a2aee491c62da41$var$boolbase_1.default.trueFunc) return a;
    if (a === $8a2aee491c62da41$var$boolbase_1.default.falseFunc || b === $8a2aee491c62da41$var$boolbase_1.default.trueFunc) return b;
    return function combine(elem) {
        return a(elem) || b(elem);
    };
}

});

parcelRegister("ekA3e", function(module, exports) {
"use strict";
var $a6eee5f030165959$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a6eee5f030165959$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.subselects = module.exports.getNextSiblings = module.exports.ensureIsTag = module.exports.PLACEHOLDER_ELEMENT = void 0;

var $a6eee5f030165959$var$boolbase_1 = $a6eee5f030165959$var$__importDefault((parcelRequire("7Rnqo")));

var $3pXQ8 = parcelRequire("3pXQ8");

/** Used as a placeholder for :has. Will be replaced with the actual element. */ module.exports.PLACEHOLDER_ELEMENT = {};
function $a6eee5f030165959$var$ensureIsTag(next, adapter) {
    if (next === $a6eee5f030165959$var$boolbase_1.default.falseFunc) return $a6eee5f030165959$var$boolbase_1.default.falseFunc;
    return function(elem) {
        return adapter.isTag(elem) && next(elem);
    };
}
module.exports.ensureIsTag = $a6eee5f030165959$var$ensureIsTag;
function $a6eee5f030165959$var$getNextSiblings(elem, adapter) {
    var siblings = adapter.getSiblings(elem);
    if (siblings.length <= 1) return [];
    var elemIndex = siblings.indexOf(elem);
    if (elemIndex < 0 || elemIndex === siblings.length - 1) return [];
    return siblings.slice(elemIndex + 1).filter(adapter.isTag);
}
module.exports.getNextSiblings = $a6eee5f030165959$var$getNextSiblings;
function $a6eee5f030165959$var$copyOptions(options) {
    // Not copied: context, rootFunc
    return {
        xmlMode: !!options.xmlMode,
        lowerCaseAttributeNames: !!options.lowerCaseAttributeNames,
        lowerCaseTags: !!options.lowerCaseTags,
        quirksMode: !!options.quirksMode,
        cacheResults: !!options.cacheResults,
        pseudos: options.pseudos,
        adapter: options.adapter,
        equals: options.equals
    };
}
var $a6eee5f030165959$var$is = function(next, token, options, context, compileToken) {
    var func = compileToken(token, $a6eee5f030165959$var$copyOptions(options), context);
    return func === $a6eee5f030165959$var$boolbase_1.default.trueFunc ? next : func === $a6eee5f030165959$var$boolbase_1.default.falseFunc ? $a6eee5f030165959$var$boolbase_1.default.falseFunc : function(elem) {
        return func(elem) && next(elem);
    };
};
/*
 * :not, :has, :is, :matches and :where have to compile selectors
 * doing this in src/pseudos.ts would lead to circular dependencies,
 * so we add them here
 */ module.exports.subselects = {
    is: $a6eee5f030165959$var$is,
    /**
     * `:matches` and `:where` are aliases for `:is`.
     */ matches: $a6eee5f030165959$var$is,
    where: $a6eee5f030165959$var$is,
    not: function(next, token, options, context, compileToken) {
        var func = compileToken(token, $a6eee5f030165959$var$copyOptions(options), context);
        return func === $a6eee5f030165959$var$boolbase_1.default.falseFunc ? next : func === $a6eee5f030165959$var$boolbase_1.default.trueFunc ? $a6eee5f030165959$var$boolbase_1.default.falseFunc : function(elem) {
            return !func(elem) && next(elem);
        };
    },
    has: function(next, subselect, options, _context, compileToken) {
        var adapter = options.adapter;
        var opts = $a6eee5f030165959$var$copyOptions(options);
        opts.relativeSelector = true;
        var context = subselect.some(function(s) {
            return s.some($3pXQ8.isTraversal);
        }) ? [
            module.exports.PLACEHOLDER_ELEMENT
        ] : undefined;
        var compiled = compileToken(subselect, opts, context);
        if (compiled === $a6eee5f030165959$var$boolbase_1.default.falseFunc) return $a6eee5f030165959$var$boolbase_1.default.falseFunc;
        var hasElement = $a6eee5f030165959$var$ensureIsTag(compiled, adapter);
        // If `compiled` is `trueFunc`, we can skip this.
        if (context && compiled !== $a6eee5f030165959$var$boolbase_1.default.trueFunc) {
            /*
             * `shouldTestNextSiblings` will only be true if the query starts with
             * a traversal (sibling or adjacent). That means we will always have a context.
             */ var _a = compiled.shouldTestNextSiblings, shouldTestNextSiblings_1 = _a === void 0 ? false : _a;
            return function(elem) {
                if (!next(elem)) return false;
                context[0] = elem;
                var childs = adapter.getChildren(elem);
                var nextElements = shouldTestNextSiblings_1 ? $a6eee5f030165959$var$__spreadArray($a6eee5f030165959$var$__spreadArray([], childs, true), $a6eee5f030165959$var$getNextSiblings(elem, adapter), true) : childs;
                return adapter.existsOne(hasElement, nextElements);
            };
        }
        return function(elem) {
            return next(elem) && adapter.existsOne(hasElement, adapter.getChildren(elem));
        };
    }
};

});

parcelRegister("45FRP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compilePseudoSelector = module.exports.aliases = module.exports.pseudos = module.exports.filters = void 0;

var $fftKo = parcelRequire("fftKo");


var $02rhb = parcelRequire("02rhb");

Object.defineProperty(module.exports, "filters", {
    enumerable: true,
    get: function() {
        return $02rhb.filters;
    }
});

var $3U4aF = parcelRequire("3U4aF");

Object.defineProperty(module.exports, "pseudos", {
    enumerable: true,
    get: function() {
        return $3U4aF.pseudos;
    }
});

var $1NM7l = parcelRequire("1NM7l");

Object.defineProperty(module.exports, "aliases", {
    enumerable: true,
    get: function() {
        return $1NM7l.aliases;
    }
});

var $ekA3e = parcelRequire("ekA3e");

function $2fa81b04f397fa15$var$compilePseudoSelector(next, selector, options, context, compileToken) {
    var _a;
    var name = selector.name, data = selector.data;
    if (Array.isArray(data)) {
        if (!(name in $ekA3e.subselects)) throw new Error("Unknown pseudo-class :".concat(name, "(").concat(data, ")"));
        return $ekA3e.subselects[name](next, data, options, context, compileToken);
    }
    var userPseudo = (_a = options.pseudos) === null || _a === void 0 ? void 0 : _a[name];
    var stringPseudo = typeof userPseudo === "string" ? userPseudo : $1NM7l.aliases[name];
    if (typeof stringPseudo === "string") {
        if (data != null) throw new Error("Pseudo ".concat(name, " doesn't have any arguments"));
        // The alias has to be parsed here, to make sure options are respected.
        var alias = (0, $fftKo.parse)(stringPseudo);
        return $ekA3e.subselects["is"](next, alias, options, context, compileToken);
    }
    if (typeof userPseudo === "function") {
        (0, $3U4aF.verifyPseudoArgs)(userPseudo, name, data, 1);
        return function(elem) {
            return userPseudo(elem, data) && next(elem);
        };
    }
    if (name in $02rhb.filters) return $02rhb.filters[name](next, data, options, context);
    if (name in $3U4aF.pseudos) {
        var pseudo_1 = $3U4aF.pseudos[name];
        (0, $3U4aF.verifyPseudoArgs)(pseudo_1, name, data, 2);
        return function(elem) {
            return pseudo_1(elem, options, data) && next(elem);
        };
    }
    throw new Error("Unknown pseudo-class :".concat(name));
}
module.exports.compilePseudoSelector = $2fa81b04f397fa15$var$compilePseudoSelector;

});

parcelRegister("dkUsN", function(module, exports) {
"use strict";
var $9b58f1180f04994d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9b58f1180f04994d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9b58f1180f04994d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9b58f1180f04994d$var$__createBinding(result, mod, k);
    }
    $9b58f1180f04994d$var$__setModuleDefault(result, mod);
    return result;
};
var $9b58f1180f04994d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $9b58f1180f04994d$var$decode_data_html_js_1 = $9b58f1180f04994d$var$__importDefault((parcelRequire("eWl4h")));
module.exports.htmlDecodeTree = $9b58f1180f04994d$var$decode_data_html_js_1.default;

var $9b58f1180f04994d$var$decode_data_xml_js_1 = $9b58f1180f04994d$var$__importDefault((parcelRequire("3DyDZ")));
module.exports.xmlDecodeTree = $9b58f1180f04994d$var$decode_data_xml_js_1.default;

var $9b58f1180f04994d$var$decode_codepoint_js_1 = $9b58f1180f04994d$var$__importStar((parcelRequire("lm1Rc")));
module.exports.decodeCodePoint = $9b58f1180f04994d$var$decode_codepoint_js_1.default;

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lm1Rc")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lm1Rc")).fromCodePoint;
    }
});
var $9b58f1180f04994d$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($9b58f1180f04994d$var$CharCodes || ($9b58f1180f04994d$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $9b58f1180f04994d$var$TO_LOWER_BIT = 32;
var $9b58f1180f04994d$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($9b58f1180f04994d$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $9b58f1180f04994d$var$isNumber(code) {
    return code >= $9b58f1180f04994d$var$CharCodes.ZERO && code <= $9b58f1180f04994d$var$CharCodes.NINE;
}
function $9b58f1180f04994d$var$isHexadecimalCharacter(code) {
    return code >= $9b58f1180f04994d$var$CharCodes.UPPER_A && code <= $9b58f1180f04994d$var$CharCodes.UPPER_F || code >= $9b58f1180f04994d$var$CharCodes.LOWER_A && code <= $9b58f1180f04994d$var$CharCodes.LOWER_F;
}
function $9b58f1180f04994d$var$isAsciiAlphaNumeric(code) {
    return code >= $9b58f1180f04994d$var$CharCodes.UPPER_A && code <= $9b58f1180f04994d$var$CharCodes.UPPER_Z || code >= $9b58f1180f04994d$var$CharCodes.LOWER_A && code <= $9b58f1180f04994d$var$CharCodes.LOWER_Z || $9b58f1180f04994d$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $9b58f1180f04994d$var$isEntityInAttributeInvalidEnd(code) {
    return code === $9b58f1180f04994d$var$CharCodes.EQUALS || $9b58f1180f04994d$var$isAsciiAlphaNumeric(code);
}
var $9b58f1180f04994d$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($9b58f1180f04994d$var$EntityDecoderState || ($9b58f1180f04994d$var$EntityDecoderState = {}));
var $9b58f1180f04994d$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($9b58f1180f04994d$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $9b58f1180f04994d$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $9b58f1180f04994d$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $9b58f1180f04994d$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $9b58f1180f04994d$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $9b58f1180f04994d$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $9b58f1180f04994d$var$CharCodes.NUM) {
                    this.state = $9b58f1180f04994d$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $9b58f1180f04994d$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $9b58f1180f04994d$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $9b58f1180f04994d$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $9b58f1180f04994d$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $9b58f1180f04994d$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $9b58f1180f04994d$var$TO_LOWER_BIT) === $9b58f1180f04994d$var$CharCodes.LOWER_X) {
            this.state = $9b58f1180f04994d$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $9b58f1180f04994d$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($9b58f1180f04994d$var$isNumber(char) || $9b58f1180f04994d$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($9b58f1180f04994d$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $9b58f1180f04994d$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $9b58f1180f04994d$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $9b58f1180f04994d$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $9b58f1180f04994d$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $9b58f1180f04994d$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $9b58f1180f04994d$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $9b58f1180f04994d$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $9b58f1180f04994d$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $9b58f1180f04994d$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $9b58f1180f04994d$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $9b58f1180f04994d$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $9b58f1180f04994d$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$9b58f1180f04994d$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $9b58f1180f04994d$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $9b58f1180f04994d$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $9b58f1180f04994d$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $9b58f1180f04994d$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $9b58f1180f04994d$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $9b58f1180f04994d$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $9b58f1180f04994d$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $9b58f1180f04994d$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $9b58f1180f04994d$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $9b58f1180f04994d$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $9b58f1180f04994d$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $9b58f1180f04994d$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $9b58f1180f04994d$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $9b58f1180f04994d$var$determineBranch;
var $9b58f1180f04994d$var$htmlDecoder = $9b58f1180f04994d$var$getDecoder($9b58f1180f04994d$var$decode_data_html_js_1.default);
var $9b58f1180f04994d$var$xmlDecoder = $9b58f1180f04994d$var$getDecoder($9b58f1180f04994d$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $9b58f1180f04994d$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $9b58f1180f04994d$var$DecodingMode.Legacy;
    return $9b58f1180f04994d$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $9b58f1180f04994d$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $9b58f1180f04994d$var$decodeHTMLAttribute(str) {
    return $9b58f1180f04994d$var$htmlDecoder(str, $9b58f1180f04994d$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $9b58f1180f04994d$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $9b58f1180f04994d$var$decodeHTMLStrict(str) {
    return $9b58f1180f04994d$var$htmlDecoder(str, $9b58f1180f04994d$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $9b58f1180f04994d$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $9b58f1180f04994d$var$decodeXML(str) {
    return $9b58f1180f04994d$var$xmlDecoder(str, $9b58f1180f04994d$var$DecodingMode.Strict);
}
module.exports.decodeXML = $9b58f1180f04994d$var$decodeXML;

});

parcelRegister("lUNMs", function(module, exports) {
"use strict";
var $ff4571512b40d097$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = void 0;

var $ff4571512b40d097$var$encode_html_js_1 = $ff4571512b40d097$var$__importDefault((parcelRequire("l2AEi")));

var $Hny5k = parcelRequire("Hny5k");

var $ff4571512b40d097$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
/**
 * Encodes all characters in the input using HTML entities. This includes
 * characters that are valid ASCII characters in HTML documents, such as `#`.
 *
 * To get a more compact output, consider using the `encodeNonAsciiHTML`
 * function, which will only encode characters that are not valid in HTML
 * documents, as well as non-ASCII characters.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ function $ff4571512b40d097$var$encodeHTML(data) {
    return $ff4571512b40d097$var$encodeHTMLTrieRe($ff4571512b40d097$var$htmlReplacer, data);
}
module.exports.encodeHTML = $ff4571512b40d097$var$encodeHTML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities. This function will not encode characters that
 * are valid in HTML documents, such as `#`.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ function $ff4571512b40d097$var$encodeNonAsciiHTML(data) {
    return $ff4571512b40d097$var$encodeHTMLTrieRe($Hny5k.xmlReplacer, data);
}
module.exports.encodeNonAsciiHTML = $ff4571512b40d097$var$encodeNonAsciiHTML;
function $ff4571512b40d097$var$encodeHTMLTrieRe(regExp, str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = regExp.exec(str)) !== null){
        var i = match.index;
        ret += str.substring(lastIdx, i);
        var char = str.charCodeAt(i);
        var next = $ff4571512b40d097$var$encode_html_js_1.default.get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                var nextChar = str.charCodeAt(i + 1);
                var value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            var cp = (0, $Hny5k.getCodePoint)(str, i);
            ret += "&#x".concat(cp.toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});

parcelRegister("Hny5k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escapeText = module.exports.escapeAttribute = module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeXML = module.exports.getCodePoint = module.exports.xmlReplacer = void 0;
module.exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
var $0826488f42da2b9c$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
// For compatibility with node < 4, we wrap `codePointAt`
module.exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str, index) {
    return str.codePointAt(index);
} : function(c, index) {
    return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ function $0826488f42da2b9c$var$encodeXML(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = module.exports.xmlReplacer.exec(str)) !== null){
        var i = match.index;
        var char = str.charCodeAt(i);
        var next = $0826488f42da2b9c$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, module.exports.getCodePoint)(str, i).toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = module.exports.xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
module.exports.encodeXML = $0826488f42da2b9c$var$encodeXML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */ module.exports.escape = $0826488f42da2b9c$var$encodeXML;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $0826488f42da2b9c$var$getEscaper(regex, map) {
    return function escape(data) {
        var match;
        var lastIdx = 0;
        var result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
/**
 * Encodes all characters not valid in XML documents using XML entities.
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */ module.exports.escapeUTF8 = $0826488f42da2b9c$var$getEscaper(/[&<>'"]/g, $0826488f42da2b9c$var$xmlCodeMap);
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeAttribute = $0826488f42da2b9c$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeText = $0826488f42da2b9c$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});

parcelRegister("8a70H", function(module, exports) {
/* function-result.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $7yDmn = parcelRequire("7yDmn");


var $3sFtD = parcelRequire("3sFtD");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $hAecz = parcelRequire("hAecz");


var $40Bg6 = parcelRequire("40Bg6");

const $b0a25d0a64ad8aab$var$functionResultStyles = {
    functionCard: "_2rko12b0 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _bfhki8nm",
    outputContent: "_2rko12b0 _1reo1wug _18m91wug _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _bfhksm61 _c71l1mjv",
    preformatted: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721jtm _ect4zzfg"
};
const $b0a25d0a64ad8aab$export$c460f77fbe5ab0de = ({ result: result, index: index })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const info = result.pluginInvocationInfo;
    if (!info) return null;
    const isSuccess = info.status === (0, $40Bg6.FunctionResultStatus).SUCCESS;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b0a25d0a64ad8aab$var$functionResultStyles.functionCard,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    onClick: ()=>setIsExpanded(!isExpanded),
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.100",
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.100",
                                alignBlock: "center",
                                children: [
                                    isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                        label: formatMessage((0, $hAecz.messages).ai_debugger_modal_collapse_label),
                                        color: "currentColor"
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                        label: formatMessage((0, $hAecz.messages).ai_debugger_modal_expand_label),
                                        color: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                        weight: "medium",
                                        size: "small",
                                        children: [
                                            index + 1,
                                            ". ",
                                            info.name || 'Unknown Function'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    isSuccess ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                        label: info.status || 'Unknown',
                                        color: "var(--ds-icon-success, #6A9A23)"
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                                        label: info.status || 'Unknown',
                                        color: "var(--ds-icon-danger, #C9372C)"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        color: isSuccess ? 'color.text.success' : 'color.text.danger',
                                        children: info.status || 'Unknown'
                                    })
                                ]
                            })
                        ]
                    })
                }),
                isExpanded && info.output && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b0a25d0a64ad8aab$var$functionResultStyles.outputContent,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "pre",
                        xcss: $b0a25d0a64ad8aab$var$functionResultStyles.preformatted,
                        children: info.output
                    })
                })
            ]
        })
    });
};
module.exports["FunctionResult"] = $b0a25d0a64ad8aab$export$c460f77fbe5ab0de;

});

parcelRegister("717Wk", function(module, exports) {
/* plugin-output-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $hAecz = parcelRequire("hAecz");


var $7Tpwp = parcelRequire("7Tpwp");


var $1XZcC = parcelRequire("1XZcC");


var $9ymzq = parcelRequire("9ymzq");

const $e2da04121422c51c$var$styles = {
    numberBox: "_1ul91tcg _1o9zidpf",
    linkBox: "_1reo15vq _18m915vq _1nmz1hna _16jlkb7n",
    divider: "_4t3it94y _bfhki8nm _19pkutpp _otyrutpp"
};
const $e2da04121422c51c$var$TeamworkRenderer = ({ data: data })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.200",
        children: [
            data.data.header && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "medium",
                children: data.data.header
            }),
            data.data.sections.map((section, sectionIdx)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        section.sectionHeader && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "medium",
                            size: "small",
                            children: section.sectionHeader
                        }),
                        section.teams && section.teams.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            space: "space.100",
                            children: section.teams.map((team, idx)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9ymzq.TeamworkTeamCard), {
                                    team: team,
                                    index: idx
                                }, idx))
                        }),
                        section.documents && section.documents.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            space: "space.100",
                            children: section.documents.map((doc, idx)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1XZcC.TeamworkDocumentCard), {
                                    doc: doc,
                                    index: idx
                                }, idx))
                        })
                    ]
                }, sectionIdx))
        ]
    });
};
const $e2da04121422c51c$var$SearchPluginRenderer = ({ extraInfo: extraInfo })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            extraInfo.searchResults && extraInfo.searchResults.length > 0 && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: formatMessage((0, $hAecz.messages).ai_debugger_modal_search_results_heading, {
                            count: extraInfo.searchResults.length
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        space: "space.050",
                        children: extraInfo.searchResults.map((url, idx)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "start",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $e2da04121422c51c$var$styles.numberBox,
                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                            children: [
                                                idx + 1,
                                                "."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $e2da04121422c51c$var$styles.linkBox,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                            href: url,
                                            target: "_blank",
                                            children: url
                                        })
                                    })
                                ]
                            }, idx))
                    })
                ]
            }),
            extraInfo.searchResults && extraInfo.searchResults.length > 0 && extraInfo.rankedDocuments && extraInfo.rankedDocuments.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $e2da04121422c51c$var$styles.divider
            }),
            extraInfo.rankedDocuments && extraInfo.rankedDocuments.length > 0 && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: formatMessage((0, $hAecz.messages).ai_debugger_modal_ranked_documents_heading, {
                            count: extraInfo.rankedDocuments.length
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        space: "space.050",
                        children: extraInfo.rankedDocuments.map((url, idx)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "start",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $e2da04121422c51c$var$styles.numberBox,
                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                            children: [
                                                idx + 1,
                                                "."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $e2da04121422c51c$var$styles.linkBox,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                            href: url,
                                            target: "_blank",
                                            children: url
                                        })
                                    })
                                ]
                            }, idx))
                    })
                ]
            })
        ]
    });
};
const $e2da04121422c51c$export$50ae64692e52fc4f = ({ parsedOutput: parsedOutput, extraInfo: extraInfo })=>{
    // Render based on parsed output type
    if (parsedOutput) switch(parsedOutput.type){
        case 'teamwork':
            return /*#__PURE__*/ (0, $l998X.jsx)($e2da04121422c51c$var$TeamworkRenderer, {
                data: parsedOutput
            });
        case 'pageSearch':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $7Tpwp.PageSearchCard), {
                data: parsedOutput.data
            });
    }
     // Fallback to string display
    if (typeof extraInfo === 'string') return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        children: extraInfo
    });
     // Render search plugin extra info
    if (extraInfo && (extraInfo.searchResults || extraInfo.rankedDocuments)) return /*#__PURE__*/ (0, $l998X.jsx)($e2da04121422c51c$var$SearchPluginRenderer, {
        extraInfo: extraInfo
    });
    return null;
};
module.exports["PluginOutputRenderer"] = $e2da04121422c51c$export$50ae64692e52fc4f;

});

parcelRegister("40Bg6", function(module, exports) {
var $cde704655f4528f9$export$a80387b071fd4173 = /*#__PURE__*/ function(PluginName) {
    PluginName["TEAMWORK"] = "teamwork";
    PluginName["PAGE_SEARCH_PLUGIN"] = "Page-Search-Plugin";
    PluginName["SEARCH"] = "search";
    PluginName["PEOPLE"] = "people";
    return PluginName;
}({});
var $cde704655f4528f9$export$7088950d16b52135 = /*#__PURE__*/ function(PluginInvocationStatus) {
    PluginInvocationStatus["PLUGIN_FINISHED"] = "PLUGIN_FINISHED";
    PluginInvocationStatus["PLUGIN_ERRORED"] = "PLUGIN_ERRORED";
    return PluginInvocationStatus;
}({});
var $cde704655f4528f9$export$ea22648b9de9e52c = /*#__PURE__*/ function(MinionName) {
    MinionName["TEAMWORK_AGENT"] = "TeamworkAgent";
    MinionName["SEARCH"] = "search";
    return MinionName;
}({});
var $cde704655f4528f9$export$5731613326371a4a = /*#__PURE__*/ function(FunctionResultStatus) {
    FunctionResultStatus["SUCCESS"] = "SUCCESS";
    FunctionResultStatus["ERROR"] = "ERROR";
    return FunctionResultStatus;
}({});
module.exports["PluginName"] = $cde704655f4528f9$export$a80387b071fd4173;
module.exports["PluginInvocationStatus"] = $cde704655f4528f9$export$7088950d16b52135;
module.exports["MinionName"] = $cde704655f4528f9$export$ea22648b9de9e52c;
module.exports["FunctionResultStatus"] = $cde704655f4528f9$export$5731613326371a4a;

});

parcelRegister("b5vPf", function(module, exports) {
/* panel-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $095942d2819591dc$var$styles = {
    root: "_1bsb1osq _ca0qu2gc _n3tdu2gc"
};
const $095942d2819591dc$export$2ddb90ad54e5f587 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        space: "space.100",
        xcss: $095942d2819591dc$var$styles.root,
        testId: testId,
        children: children
    });
module.exports["Panel"] = $095942d2819591dc$export$2ddb90ad54e5f587;

});

parcelRegister("akGHV", function(module, exports) {
/* plugin-invocation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $7yDmn = parcelRequire("7yDmn");


var $3sFtD = parcelRequire("3sFtD");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $14qs9 = parcelRequire("14qs9");


var $hAecz = parcelRequire("hAecz");


var $717Wk = parcelRequire("717Wk");


var $40Bg6 = parcelRequire("40Bg6");


var $lcPZc = parcelRequire("lcPZc");

const $7b1d951f190cfe29$var$parsePluginExtraInfo = ({ pluginName: pluginName, pluginExtraInfo: pluginExtraInfo, pluginOutput: pluginOutput })=>{
    let extraInfo;
    let parsedOutput = null; // Search plugin: parse plugin_extra_info for search results
    if (pluginName === (0, $40Bg6.PluginName).SEARCH) try {
        if (pluginExtraInfo) extraInfo = JSON.parse(pluginExtraInfo);
    } catch  {
        extraInfo = pluginExtraInfo;
    }
    else {
        extraInfo = pluginOutput;
        if (typeof extraInfo === 'string') parsedOutput = (0, $lcPZc.parsePluginOutput)(pluginName, extraInfo);
    }
    return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput
    };
};
const $7b1d951f190cfe29$var$pluginInvocationStyles = {
    pressable: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _80omtlke _1bsb1osq",
    content: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhksm61"
};
const $7b1d951f190cfe29$export$213f6c57639a4547 = ({ plugin: plugin, index: index })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const isSuccess = plugin.plugin_invocation_status === (0, $40Bg6.PluginInvocationStatus).PLUGIN_FINISHED;
    const StatusIcon = isSuccess ? (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))) : (0, (/*@__PURE__*/$parcel$interopDefault($7yDmn)));
    const statusColor = isSuccess ? "var(--ds-icon-success, #6A9A23)" : "var(--ds-icon-danger, #C9372C)";
    const statusText = isSuccess ? formatMessage((0, $hAecz.messages).ai_debugger_modal_success_label) : formatMessage((0, $hAecz.messages).ai_debugger_modal_failed_label);
    const expandLabel = formatMessage((0, $hAecz.messages).ai_debugger_modal_expand_label);
    const collapseLabel = formatMessage((0, $hAecz.messages).ai_debugger_modal_collapse_label);
    const { extraInfo: extraInfo, parsedOutput: parsedOutput } = $7b1d951f190cfe29$var$parsePluginExtraInfo({
        pluginName: plugin.plugin_name,
        pluginExtraInfo: plugin.plugin_extra_info,
        pluginOutput: plugin.plugin_output
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    onClick: ()=>setIsExpanded(!isExpanded),
                    xcss: $7b1d951f190cfe29$var$pluginInvocationStyles.pressable,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.100",
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.100",
                                alignBlock: "center",
                                children: [
                                    isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                        label: collapseLabel,
                                        color: "currentColor"
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                        label: expandLabel,
                                        color: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        weight: "medium",
                                        children: plugin.plugin_name || `Plugin ${index + 1}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)(StatusIcon, {
                                        label: statusText,
                                        color: statusColor
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: isSuccess ? 'color.text.success' : 'color.text.danger',
                                        children: statusText
                                    })
                                ]
                            })
                        ]
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $7b1d951f190cfe29$var$pluginInvocationStyles.content,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        space: "space.200",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $717Wk.PluginOutputRenderer), {
                            parsedOutput: parsedOutput,
                            extraInfo: extraInfo
                        })
                    })
                })
            ]
        })
    });
};
module.exports["PluginInvocationItem"] = $7b1d951f190cfe29$export$213f6c57639a4547;

});

parcelRegister("eALDe", function(module, exports) {
/* copy-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $2MuFw = parcelRequire("2MuFw");


var $3sFtD = parcelRequire("3sFtD");


var $fVUfS = parcelRequire("fVUfS");


var $3gadb = parcelRequire("3gadb");

const $ca7af0d6bb89bc7a$var$TIMEOUT_DELAY = 2500;
const $ca7af0d6bb89bc7a$var$buttonStyles = {
    root: "_2rko12b0 _4t3i7vkz _1bsb7vkz _y4tize3t _bozgze3t",
    cursorDisabledStyles: "_19itglyw _80om73ad"
};
const $ca7af0d6bb89bc7a$export$4f2558dd25106ae2 = ({ copyText: copyText, copyLabel: copyLabel, copiedLabel: copiedLabel, testId: testId })=>{
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [currentTooltipLabel, setCurrentTooltipLabel] = (0, $42omo.useState)(copyLabel);
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        currentTooltipLabel
    ]);
    const copyTextToClipboard = async ()=>{
        try {
            if (!copyText) return;
            await navigator.clipboard.writeText(copyText);
            setIsCopied(true);
            setCurrentTooltipLabel(copiedLabel);
            setTimeout(()=>{
                setIsCopied(false);
                setCurrentTooltipLabel(copyLabel);
            }, $ca7af0d6bb89bc7a$var$TIMEOUT_DELAY);
        } catch (_e) {
            // Failed to copy
            throw new Error('Failed to copy');
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return currentTooltipLabel;
        },
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            xcss: (0, $1Whri.cx)($ca7af0d6bb89bc7a$var$buttonStyles.root, isCopied ? $ca7af0d6bb89bc7a$var$buttonStyles.cursorDisabledStyles : undefined),
            isDisabled: isCopied,
            onClick: copyTextToClipboard,
            "aria-label": copyLabel,
            testId: testId,
            children: isCopied ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: copiedLabel,
                color: "var(--ds-icon-accent-green, #22A06B)"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                label: copyLabel,
                color: "var(--ds-icon-subtle, #505258)"
            })
        })
    });
};
module.exports["CopyButton"] = $ca7af0d6bb89bc7a$export$4f2558dd25106ae2;

});

parcelRegister("GzZ6c", function(module, exports) {

var $40Bg6 = parcelRequire("40Bg6");

const $d199036a7f0502c6$export$aec1a4983c19c033 = {
    [(0, $40Bg6.PluginName).SEARCH]: 'success',
    [(0, $40Bg6.PluginName).PEOPLE]: 'inprogress',
    [(0, $40Bg6.PluginName).TEAMWORK]: 'new',
    [(0, $40Bg6.PluginName).PAGE_SEARCH_PLUGIN]: 'moved'
};
const $d199036a7f0502c6$export$c9fed45cd50ca9c7 = 'default';
module.exports["PLUGIN_LOZENGE_APPEARANCE"] = $d199036a7f0502c6$export$aec1a4983c19c033;
module.exports["DEFAULT_PLUGIN_LOZENGE_APPEARANCE"] = $d199036a7f0502c6$export$c9fed45cd50ca9c7;

});

parcelRegister("l9NKi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compileGeneralSelector = void 0;

var $5AySZ = parcelRequire("5AySZ");


var $45FRP = parcelRequire("45FRP");


var $bGFyo = parcelRequire("bGFyo");

function $f67106afbf2abf7f$var$getElementParent(node, adapter) {
    var parent = adapter.getParent(node);
    if (parent && adapter.isTag(parent)) return parent;
    return null;
}
/*
 * All available rules
 */ function $f67106afbf2abf7f$var$compileGeneralSelector(next, selector, options, context, compileToken) {
    var adapter = options.adapter, equals = options.equals;
    switch(selector.type){
        case $bGFyo.SelectorType.PseudoElement:
            throw new Error("Pseudo-elements are not supported by css-select");
        case $bGFyo.SelectorType.ColumnCombinator:
            throw new Error("Column combinators are not yet supported by css-select");
        case $bGFyo.SelectorType.Attribute:
            if (selector.namespace != null) throw new Error("Namespaced attributes are not yet supported by css-select");
            if (!options.xmlMode || options.lowerCaseAttributeNames) selector.name = selector.name.toLowerCase();
            return $5AySZ.attributeRules[selector.action](next, selector, options);
        case $bGFyo.SelectorType.Pseudo:
            return (0, $45FRP.compilePseudoSelector)(next, selector, options, context, compileToken);
        // Tags
        case $bGFyo.SelectorType.Tag:
            if (selector.namespace != null) throw new Error("Namespaced tag names are not yet supported by css-select");
            var name_1 = selector.name;
            if (!options.xmlMode || options.lowerCaseTags) name_1 = name_1.toLowerCase();
            return function tag(elem) {
                return adapter.getName(elem) === name_1 && next(elem);
            };
        // Traversal
        case $bGFyo.SelectorType.Descendant:
            if (options.cacheResults === false || typeof WeakSet === "undefined") return function descendant(elem) {
                var current = elem;
                while(current = $f67106afbf2abf7f$var$getElementParent(current, adapter)){
                    if (next(current)) return true;
                }
                return false;
            };
            // @ts-expect-error `ElementNode` is not extending object
            var isFalseCache_1 = new WeakSet();
            return function cachedDescendant(elem) {
                var current = elem;
                while(current = $f67106afbf2abf7f$var$getElementParent(current, adapter))if (!isFalseCache_1.has(current)) {
                    if (adapter.isTag(current) && next(current)) return true;
                    isFalseCache_1.add(current);
                }
                return false;
            };
        case "_flexibleDescendant":
            // Include element itself, only used while querying an array
            return function flexibleDescendant(elem) {
                var current = elem;
                do {
                    if (next(current)) return true;
                }while (current = $f67106afbf2abf7f$var$getElementParent(current, adapter));
                return false;
            };
        case $bGFyo.SelectorType.Parent:
            return function parent(elem) {
                return adapter.getChildren(elem).some(function(elem) {
                    return adapter.isTag(elem) && next(elem);
                });
            };
        case $bGFyo.SelectorType.Child:
            return function child(elem) {
                var parent = adapter.getParent(elem);
                return parent != null && adapter.isTag(parent) && next(parent);
            };
        case $bGFyo.SelectorType.Sibling:
            return function sibling(elem) {
                var siblings = adapter.getSiblings(elem);
                for(var i = 0; i < siblings.length; i++){
                    var currentSibling = siblings[i];
                    if (equals(elem, currentSibling)) break;
                    if (adapter.isTag(currentSibling) && next(currentSibling)) return true;
                }
                return false;
            };
        case $bGFyo.SelectorType.Adjacent:
            if (adapter.prevElementSibling) return function adjacent(elem) {
                var previous = adapter.prevElementSibling(elem);
                return previous != null && next(previous);
            };
            return function adjacent(elem) {
                var siblings = adapter.getSiblings(elem);
                var lastElement;
                for(var i = 0; i < siblings.length; i++){
                    var currentSibling = siblings[i];
                    if (equals(elem, currentSibling)) break;
                    if (adapter.isTag(currentSibling)) lastElement = currentSibling;
                }
                return !!lastElement && next(lastElement);
            };
        case $bGFyo.SelectorType.Universal:
            if (selector.namespace != null && selector.namespace !== "*") throw new Error("Namespaced universal selectors are not yet supported by css-select");
            return next;
    }
}
module.exports.compileGeneralSelector = $f67106afbf2abf7f$var$compileGeneralSelector;

});

parcelRegister("02rhb", function(module, exports) {
"use strict";
var $0075587a696d22fb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filters = void 0;

var $0075587a696d22fb$var$nth_check_1 = $0075587a696d22fb$var$__importDefault((parcelRequire("2aBVB")));

var $0075587a696d22fb$var$boolbase_1 = $0075587a696d22fb$var$__importDefault((parcelRequire("7Rnqo")));
function $0075587a696d22fb$var$getChildFunc(next, adapter) {
    return function(elem) {
        var parent = adapter.getParent(elem);
        return parent != null && adapter.isTag(parent) && next(elem);
    };
}
module.exports.filters = {
    contains: function(next, text, _a) {
        var adapter = _a.adapter;
        return function contains(elem) {
            return next(elem) && adapter.getText(elem).includes(text);
        };
    },
    icontains: function(next, text, _a) {
        var adapter = _a.adapter;
        var itext = text.toLowerCase();
        return function icontains(elem) {
            return next(elem) && adapter.getText(elem).toLowerCase().includes(itext);
        };
    },
    // Location specific methods
    "nth-child": function(next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, $0075587a696d22fb$var$nth_check_1.default)(rule);
        if (func === $0075587a696d22fb$var$boolbase_1.default.falseFunc) return $0075587a696d22fb$var$boolbase_1.default.falseFunc;
        if (func === $0075587a696d22fb$var$boolbase_1.default.trueFunc) return $0075587a696d22fb$var$getChildFunc(next, adapter);
        return function nthChild(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for(var i = 0; i < siblings.length; i++){
                if (equals(elem, siblings[i])) break;
                if (adapter.isTag(siblings[i])) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-child": function(next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, $0075587a696d22fb$var$nth_check_1.default)(rule);
        if (func === $0075587a696d22fb$var$boolbase_1.default.falseFunc) return $0075587a696d22fb$var$boolbase_1.default.falseFunc;
        if (func === $0075587a696d22fb$var$boolbase_1.default.trueFunc) return $0075587a696d22fb$var$getChildFunc(next, adapter);
        return function nthLastChild(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for(var i = siblings.length - 1; i >= 0; i--){
                if (equals(elem, siblings[i])) break;
                if (adapter.isTag(siblings[i])) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-of-type": function(next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, $0075587a696d22fb$var$nth_check_1.default)(rule);
        if (func === $0075587a696d22fb$var$boolbase_1.default.falseFunc) return $0075587a696d22fb$var$boolbase_1.default.falseFunc;
        if (func === $0075587a696d22fb$var$boolbase_1.default.trueFunc) return $0075587a696d22fb$var$getChildFunc(next, adapter);
        return function nthOfType(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for(var i = 0; i < siblings.length; i++){
                var currentSibling = siblings[i];
                if (equals(elem, currentSibling)) break;
                if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-of-type": function(next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, $0075587a696d22fb$var$nth_check_1.default)(rule);
        if (func === $0075587a696d22fb$var$boolbase_1.default.falseFunc) return $0075587a696d22fb$var$boolbase_1.default.falseFunc;
        if (func === $0075587a696d22fb$var$boolbase_1.default.trueFunc) return $0075587a696d22fb$var$getChildFunc(next, adapter);
        return function nthLastOfType(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for(var i = siblings.length - 1; i >= 0; i--){
                var currentSibling = siblings[i];
                if (equals(elem, currentSibling)) break;
                if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    // TODO determine the actual root element
    root: function(next, _rule, _a) {
        var adapter = _a.adapter;
        return function(elem) {
            var parent = adapter.getParent(elem);
            return (parent == null || !adapter.isTag(parent)) && next(elem);
        };
    },
    scope: function(next, rule, options, context) {
        var equals = options.equals;
        if (!context || context.length === 0) // Equivalent to :root
        return module.exports.filters["root"](next, rule, options);
        if (context.length === 1) // NOTE: can't be unpacked, as :has uses this for side-effects
        return function(elem) {
            return equals(context[0], elem) && next(elem);
        };
        return function(elem) {
            return context.includes(elem) && next(elem);
        };
    },
    hover: $0075587a696d22fb$var$dynamicStatePseudo("isHovered"),
    visited: $0075587a696d22fb$var$dynamicStatePseudo("isVisited"),
    active: $0075587a696d22fb$var$dynamicStatePseudo("isActive")
};
/**
 * Dynamic state pseudos. These depend on optional Adapter methods.
 *
 * @param name The name of the adapter method to call.
 * @returns Pseudo for the `filters` object.
 */ function $0075587a696d22fb$var$dynamicStatePseudo(name) {
    return function dynamicPseudo(next, _rule, _a) {
        var adapter = _a.adapter;
        var func = adapter[name];
        if (typeof func !== "function") return $0075587a696d22fb$var$boolbase_1.default.falseFunc;
        return function active(elem) {
            return func(elem) && next(elem);
        };
    };
}

});

parcelRegister("3U4aF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifyPseudoArgs = module.exports.pseudos = void 0;
// While filters are precompiled, pseudos get called when they are needed
module.exports.pseudos = {
    empty: function(elem, _a) {
        var adapter = _a.adapter;
        return !adapter.getChildren(elem).some(function(elem) {
            // FIXME: `getText` call is potentially expensive.
            return adapter.isTag(elem) || adapter.getText(elem) !== "";
        });
    },
    "first-child": function(elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        if (adapter.prevElementSibling) return adapter.prevElementSibling(elem) == null;
        var firstChild = adapter.getSiblings(elem).find(function(elem) {
            return adapter.isTag(elem);
        });
        return firstChild != null && equals(elem, firstChild);
    },
    "last-child": function(elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        for(var i = siblings.length - 1; i >= 0; i--){
            if (equals(elem, siblings[i])) return true;
            if (adapter.isTag(siblings[i])) break;
        }
        return false;
    },
    "first-of-type": function(elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        var elemName = adapter.getName(elem);
        for(var i = 0; i < siblings.length; i++){
            var currentSibling = siblings[i];
            if (equals(elem, currentSibling)) return true;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) break;
        }
        return false;
    },
    "last-of-type": function(elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        var elemName = adapter.getName(elem);
        for(var i = siblings.length - 1; i >= 0; i--){
            var currentSibling = siblings[i];
            if (equals(elem, currentSibling)) return true;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) break;
        }
        return false;
    },
    "only-of-type": function(elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var elemName = adapter.getName(elem);
        return adapter.getSiblings(elem).every(function(sibling) {
            return equals(elem, sibling) || !adapter.isTag(sibling) || adapter.getName(sibling) !== elemName;
        });
    },
    "only-child": function(elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        return adapter.getSiblings(elem).every(function(sibling) {
            return equals(elem, sibling) || !adapter.isTag(sibling);
        });
    }
};
function $2d79d657be524dd4$var$verifyPseudoArgs(func, name, subselect, argIndex) {
    if (subselect === null) {
        if (func.length > argIndex) throw new Error("Pseudo-class :".concat(name, " requires an argument"));
    } else if (func.length === argIndex) throw new Error("Pseudo-class :".concat(name, " doesn't have any arguments"));
}
module.exports.verifyPseudoArgs = $2d79d657be524dd4$var$verifyPseudoArgs;

});

parcelRegister("1NM7l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aliases = void 0;
/**
 * Aliases are pseudos that are expressed as selectors.
 */ module.exports.aliases = {
    // Links
    "any-link": ":is(a, area, link)[href]",
    link: ":any-link:not(:visited)",
    // Forms
    // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
    disabled: ":is(\n        :is(button, input, select, textarea, optgroup, option)[disabled],\n        optgroup[disabled] > option,\n        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)\n    )",
    enabled: ":not(:disabled)",
    checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
    required: ":is(input, select, textarea)[required]",
    optional: ":is(input, select, textarea):not([required])",
    // JQuery extensions
    // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
    selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
    checkbox: "[type=checkbox]",
    file: "[type=file]",
    password: "[type=password]",
    radio: "[type=radio]",
    reset: "[type=reset]",
    image: "[type=image]",
    submit: "[type=submit]",
    parent: ":not(:empty)",
    header: ":is(h1, h2, h3, h4, h5, h6)",
    button: ":is(button, input[type=button])",
    input: ":is(input, textarea, select, button)",
    text: "input:is(:not([type!='']), [type=text])"
};

});

parcelRegister("7Tpwp", function(module, exports) {
/* page-search-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $hAecz = parcelRequire("hAecz");


const $d312b26be7c1ab24$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hPQo9")).then(({ Card: Card })=>({
            default: Card
        })));
const $d312b26be7c1ab24$var$styles = {
    card: "_2rko12b0 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhki8nm _otyru2gc",
    itemNumber: "_1ul91tcg _1o9zidpf _o5721q9c",
    snippet: "_1reo15vq _18m915vq _1nmz1hna"
};
const $d312b26be7c1ab24$var$PageCard = ({ page: page, index: index })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d312b26be7c1ab24$var$styles.card,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $d312b26be7c1ab24$var$styles.itemNumber,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                weight: "bold",
                                color: "color.text",
                                children: [
                                    index + 1,
                                    "."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.050",
                            children: [
                                page.url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: page.url,
                                        target: "_blank",
                                        children: page.title
                                    }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)($d312b26be7c1ab24$var$Card, {
                                        appearance: "inline",
                                        url: page.url
                                    })
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "bold",
                                    children: page.title
                                }),
                                page.space && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_page_search_space, {
                                        space: page.space
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.200",
                    children: [
                        page.author && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_author_label, {
                                author: page.author
                            })
                        }),
                        page.date && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: page.date
                        })
                    ]
                }),
                page.snippet && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $d312b26be7c1ab24$var$styles.snippet,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: page.snippet
                    })
                })
            ]
        })
    });
};
const $d312b26be7c1ab24$export$fbdb7e4b907b475b = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.150",
        children: [
            data.header && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "medium",
                children: data.header
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest",
                children: formatMessage((0, $hAecz.messages).ai_debugger_modal_page_search_count, {
                    count: data.pages.length
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                space: "space.100",
                children: data.pages.map((page, idx)=>/*#__PURE__*/ (0, $l998X.jsx)($d312b26be7c1ab24$var$PageCard, {
                        page: page,
                        index: idx
                    }, idx))
            })
        ]
    });
};
module.exports["PageSearchCard"] = $d312b26be7c1ab24$export$fbdb7e4b907b475b;

});

parcelRegister("1XZcC", function(module, exports) {
/* teamwork-document-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $hAecz = parcelRequire("hAecz");


var $lcPZc = parcelRequire("lcPZc");

const $af956e7ddcb2cad5$var$pluginInvocationStyles = {
    teamworkCard: "_2rko12b0 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhki8nm _otyru2gc",
    teamworkItemNumber: "_1ul91tcg _1o9zidpf _o5721q9c"
};
const $af956e7ddcb2cad5$export$4bdcb2db328c0713 = ({ doc: doc, index: index })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $af956e7ddcb2cad5$var$pluginInvocationStyles.teamworkCard,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $af956e7ddcb2cad5$var$pluginInvocationStyles.teamworkItemNumber,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                weight: "medium",
                                children: [
                                    index + 1,
                                    "."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.050",
                            children: [
                                doc.url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: doc.url,
                                    target: "_blank",
                                    children: doc.title || doc.url
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "medium",
                                    children: doc.title
                                }),
                                doc.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: doc.type
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.200",
                    alignBlock: "center",
                    children: [
                        doc.author && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_author_label, {
                                author: (0, $lcPZc.formatMarkdownLinkAsText)(doc.author)
                            })
                        }),
                        doc.updated && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_teamwork_document_updated, {
                                date: new Date(doc.updated).toLocaleDateString()
                            })
                        })
                    ]
                }),
                doc.ari && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: doc.ari
                })
            ]
        })
    });
};
module.exports["TeamworkDocumentCard"] = $af956e7ddcb2cad5$export$4bdcb2db328c0713;

});

parcelRegister("9ymzq", function(module, exports) {
/* teamwork-team-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $hAecz = parcelRequire("hAecz");


var $lcPZc = parcelRequire("lcPZc");

const $f72604edbf01a53a$var$pluginInvocationStyles = {
    teamworkCard: "_2rko12b0 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhki8nm _otyru2gc",
    teamworkMembersList: "_1reo1wug _18m91wug _19pku2gc _18u01ejb _c71luuw1",
    teamworkItemNumber: "_1ul91tcg _1o9zidpf _o5721q9c"
};
const $f72604edbf01a53a$export$f27472f36b5cad7b = ({ team: team, index: index })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [showMembers, setShowMembers] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $f72604edbf01a53a$var$pluginInvocationStyles.teamworkCard,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f72604edbf01a53a$var$pluginInvocationStyles.teamworkItemNumber,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                weight: "bold",
                                color: "color.text",
                                children: [
                                    index + 1,
                                    "."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "bold",
                            color: "color.text",
                            children: team.name || formatMessage((0, $hAecz.messages).ai_debugger_modal_teamwork_unnamed_team)
                        })
                    ]
                }),
                team.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: team.description
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.200",
                    alignBlock: "center",
                    children: [
                        team.memberCount !== undefined && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_teamwork_members_count, {
                                count: team.memberCount
                            })
                        }),
                        team.teamState && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            children: formatMessage((0, $hAecz.messages).ai_debugger_modal_teamwork_state, {
                                state: team.teamState
                            })
                        })
                    ]
                }),
                team.creator && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    children: formatMessage((0, $hAecz.messages).ai_debugger_modal_teamwork_creator, {
                        creator: team.creator
                    })
                }),
                team.ari && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: team.ari
                }),
                team.members.length > 0 && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            iconBefore: showMembers ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))),
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: ()=>setShowMembers(!showMembers),
                            children: showMembers ? formatMessage((0, $hAecz.messages).ai_debugger_modal_teamwork_hide_count, {
                                count: team.members.length
                            }) : formatMessage((0, $hAecz.messages).ai_debugger_modal_teamwork_show_count, {
                                count: team.members.length
                            })
                        }),
                        showMembers && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f72604edbf01a53a$var$pluginInvocationStyles.teamworkMembersList,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                                space: "space.050",
                                children: team.members.map((member, idx)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: (0, $lcPZc.formatMarkdownLinkAsText)(member)
                                    }, idx))
                            })
                        })
                    ]
                })
            ]
        })
    });
};
module.exports["TeamworkTeamCard"] = $f72604edbf01a53a$export$f27472f36b5cad7b;

});

parcelRegister("5AySZ", function(module, exports) {
"use strict";
var $411b60259b6bf8e3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attributeRules = void 0;

var $411b60259b6bf8e3$var$boolbase_1 = $411b60259b6bf8e3$var$__importDefault((parcelRequire("7Rnqo")));
/**
 * All reserved characters in a regex, used for escaping.
 *
 * Taken from XRegExp, (c) 2007-2020 Steven Levithan under the MIT license
 * https://github.com/slevithan/xregexp/blob/95eeebeb8fac8754d54eafe2b4743661ac1cf028/src/xregexp.js#L794
 */ var $411b60259b6bf8e3$var$reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
function $411b60259b6bf8e3$var$escapeRegex(value) {
    return value.replace($411b60259b6bf8e3$var$reChars, "\\$&");
}
/**
 * Attributes that are case-insensitive in HTML.
 *
 * @private
 * @see https://html.spec.whatwg.org/multipage/semantics-other.html#case-sensitivity-of-selectors
 */ var $411b60259b6bf8e3$var$caseInsensitiveAttributes = new Set([
    "accept",
    "accept-charset",
    "align",
    "alink",
    "axis",
    "bgcolor",
    "charset",
    "checked",
    "clear",
    "codetype",
    "color",
    "compact",
    "declare",
    "defer",
    "dir",
    "direction",
    "disabled",
    "enctype",
    "face",
    "frame",
    "hreflang",
    "http-equiv",
    "lang",
    "language",
    "link",
    "media",
    "method",
    "multiple",
    "nohref",
    "noresize",
    "noshade",
    "nowrap",
    "readonly",
    "rel",
    "rev",
    "rules",
    "scope",
    "scrolling",
    "selected",
    "shape",
    "target",
    "text",
    "type",
    "valign",
    "valuetype",
    "vlink"
]);
function $411b60259b6bf8e3$var$shouldIgnoreCase(selector, options) {
    return typeof selector.ignoreCase === "boolean" ? selector.ignoreCase : selector.ignoreCase === "quirks" ? !!options.quirksMode : !options.xmlMode && $411b60259b6bf8e3$var$caseInsensitiveAttributes.has(selector.name);
}
/**
 * Attribute selectors
 */ module.exports.attributeRules = {
    equals: function(next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        if ($411b60259b6bf8e3$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length === value.length && attr.toLowerCase() === value && next(elem);
            };
        }
        return function(elem) {
            return adapter.getAttributeValue(elem, name) === value && next(elem);
        };
    },
    hyphen: function(next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = value.length;
        if ($411b60259b6bf8e3$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function hyphenIC(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len).toLowerCase() === value && next(elem);
            };
        }
        return function hyphen(elem) {
            var attr = adapter.getAttributeValue(elem, name);
            return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len) === value && next(elem);
        };
    },
    element: function(next, data, options) {
        var adapter = options.adapter;
        var name = data.name, value = data.value;
        if (/\s/.test(value)) return $411b60259b6bf8e3$var$boolbase_1.default.falseFunc;
        var regex = new RegExp("(?:^|\\s)".concat($411b60259b6bf8e3$var$escapeRegex(value), "(?:$|\\s)"), $411b60259b6bf8e3$var$shouldIgnoreCase(data, options) ? "i" : "");
        return function element(elem) {
            var attr = adapter.getAttributeValue(elem, name);
            return attr != null && attr.length >= value.length && regex.test(attr) && next(elem);
        };
    },
    exists: function(next, _a, _b) {
        var name = _a.name;
        var adapter = _b.adapter;
        return function(elem) {
            return adapter.hasAttrib(elem, name) && next(elem);
        };
    },
    start: function(next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = value.length;
        if (len === 0) return $411b60259b6bf8e3$var$boolbase_1.default.falseFunc;
        if ($411b60259b6bf8e3$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length >= len && attr.substr(0, len).toLowerCase() === value && next(elem);
            };
        }
        return function(elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.startsWith(value)) && next(elem);
        };
    },
    end: function(next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = -value.length;
        if (len === 0) return $411b60259b6bf8e3$var$boolbase_1.default.falseFunc;
        if ($411b60259b6bf8e3$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function(elem) {
                var _a;
                return ((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.substr(len).toLowerCase()) === value && next(elem);
            };
        }
        return function(elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.endsWith(value)) && next(elem);
        };
    },
    any: function(next, data, options) {
        var adapter = options.adapter;
        var name = data.name, value = data.value;
        if (value === "") return $411b60259b6bf8e3$var$boolbase_1.default.falseFunc;
        if ($411b60259b6bf8e3$var$shouldIgnoreCase(data, options)) {
            var regex_1 = new RegExp($411b60259b6bf8e3$var$escapeRegex(value), "i");
            return function anyIC(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length >= value.length && regex_1.test(attr) && next(elem);
            };
        }
        return function(elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.includes(value)) && next(elem);
        };
    },
    not: function(next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        if (value === "") return function(elem) {
            return !!adapter.getAttributeValue(elem, name) && next(elem);
        };
        else if ($411b60259b6bf8e3$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr == null || attr.length !== value.length || attr.toLowerCase() !== value) && next(elem);
            };
        }
        return function(elem) {
            return adapter.getAttributeValue(elem, name) !== value && next(elem);
        };
    }
};

});


//# sourceMappingURL=definition-popup-content.9b049b48.js.map
